export interface Person {
  firstName: string;
  lastName: string;
  title: string;
  slug: string;
  dei: boolean;
  category: string;
}

export const people: Person[] = [
  {
    firstName: "Harold L",
    lastName: "Aaron",
    title: "Manager, Int Contrls & Compl",
    slug: "harold-l-aaron",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacob",
    lastName: "Aaronson",
    title: "Analytics Developer",
    slug: "jacob-aaronson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jose E.",
    lastName: "Abad",
    title: "Senior Input Control Specialist",
    slug: "jose-e-abad",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Denise",
    lastName: "Abad",
    title: "Associate Director, Events Management",
    slug: "denise-abad",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Solomon F",
    lastName: "Abate",
    title:
      " Senior Staff Associates I in the International Center for AIDS Care and Treatment Programs",
    slug: "solomon-f-abate",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David R.",
    lastName: "Abbott",
    title: "Chief Mate",
    slug: "david-r-abbott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barbara J",
    lastName: "Abbott-McGhee",
    title: "Manager, Technical Specialists",
    slug: "barbara-j-abbott-mcghee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Deema Ahmed Sherif",
    lastName: "Abdel Meguid",
    title: "Industry Outreach and Relationships Manager",
    slug: "deema-ahmed-sherif-abdel-meguid",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Husni",
    lastName: "Abdelqader",
    title: "Financial Aid Officer",
    slug: "husni-abdelqader",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julia",
    lastName: "Abdurahman",
    title: "Editor",
    slug: "julia-abdurahman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Zainab",
    lastName: "Abedin",
    title: "Assistant Director, Evaluation",
    slug: "zainab-abedin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Claire Marie",
    lastName: "Abell",
    title: "Asst Director-Donor Relations",
    slug: "claire-marie-abell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Abhiva",
    title: "Purchasing Officer",
    slug: "laura-abhiva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rami",
    lastName: "Abi Jomaa",
    title: "Deputy Vice President for Data Strategy & Information Management",
    slug: "rami-abi-jomaa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ediba",
    lastName: "Abiose",
    title: "Assistant Manager - Banquet",
    slug: "ediba-abiose",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia",
    lastName: "Ables",
    title: "Administrative Assistant",
    slug: "patricia-ables",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Virginia Thuy Lam",
    lastName: "Abrams",
    title: "Vice President-Communications",
    slug: "virginia-thuy-lam-abrams",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ryan T.",
    lastName: "Abrecea",
    title: "Hardware Specialist",
    slug: "ryan-t-abrecea",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Viviana",
    lastName: "Abreu",
    title: "Credentialing Coordinator",
    slug: "viviana-abreu",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rainelly A",
    lastName: "Abreu",
    title: "Manager, HR/FA",
    slug: "rainelly-a-abreu",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rafael E.",
    lastName: "Abreu",
    title: "Associate Director, Finance",
    slug: "rafael-e-abreu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Noelia M",
    lastName: "Abreu",
    title: "Administrative Aide",
    slug: "noelia-m-abreu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Judith",
    lastName: "Abreu",
    title: "Billing Manager",
    slug: "judith-abreu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Francina",
    lastName: "Abreu",
    title: "Finance Manager",
    slug: "francina-abreu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cynthia",
    lastName: "Abreu",
    title: "Administrative Coordinator",
    slug: "cynthia-abreu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna R.",
    lastName: "Abreu",
    title: "Administrative Assistant",
    slug: "anna-r-abreu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tara F",
    lastName: "Abularrage",
    title: "Senior Project Officer",
    slug: "tara-f-abularrage",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carmen",
    lastName: "Abuzid",
    title: "Admissions Specialist",
    slug: "carmen-abuzid",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Yvette",
    lastName: "Acevedo",
    title: "Sr Coord Radiation Safety Comm",
    slug: "yvette-acevedo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lien",
    lastName: "Acevedo",
    title: "Admissions Operations Assistant",
    slug: "lien-acevedo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jonathan",
    lastName: "Acevedo",
    title: "Porter",
    slug: "jonathan-acevedo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dale Alexander",
    lastName: "Acevedo",
    title: "Financial Assistant",
    slug: "dale-alexander-acevedo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexander",
    lastName: "Acevedo",
    title: "Associate Service Specialist",
    slug: "alexander-acevedo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kay E.",
    lastName: "Achar",
    title: "Dir, Academic Admin & Finance",
    slug: "kay-e-achar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary",
    lastName: "Acheampong",
    title: "I",
    slug: "mary-acheampong",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew",
    lastName: "Ackerman",
    title: "Development Officer",
    slug: "matthew-ackerman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angela Nicole",
    lastName: "Acorita",
    title: "Rounds Person",
    slug: "angela-nicole-acorita",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rafael L.",
    lastName: "Acosta",
    title: "Porter",
    slug: "rafael-l-acosta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miguel Eduardo",
    lastName: "Acosta",
    title: "Education Support Specialist I",
    slug: "miguel-eduardo-acosta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dianelly",
    lastName: "Acosta",
    title: "CMA",
    slug: "dianelly-acosta",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carolina",
    lastName: "Acosta Gutierrez",
    title: "Associate Director, Academic Advising and Student Success",
    slug: "carolina-acosta-gutierrez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dianisbeth Michelle",
    lastName: "Acquie",
    title: "Director of Judicial Careers",
    slug: "dianisbeth-michelle-acquie",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Atsuko",
    lastName: "Adachi",
    title: "Courtesy UNI Extension",
    slug: "atsuko-adachi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christian Nicholas",
    lastName: "Adames",
    title: "Research Project Manager",
    slug: "christian-nicholas-adames",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jesse Q.",
    lastName: "Adamo Grimes",
    title: "Associate Vice President, Administration & Operations",
    slug: "jesse-q-adamo-grimes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lyndsey N.",
    lastName: "Adams",
    title: "Senior Integration Coordinator",
    slug: "lyndsey-n-adams",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer Elizabeth",
    lastName: "Adams",
    title: "Executive Director of Administrative Services",
    slug: "jennifer-elizabeth-adams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Adams",
    title: "Scientific Systems, HPC Engr",
    slug: "john-adams",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jodi",
    lastName: "Adams",
    title: "People/Culture Manager",
    slug: "jodi-adams",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alexa",
    lastName: "Adams",
    title: "Undergraduate Coordinator",
    slug: "alexa-adams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole S",
    lastName: "Adams-Vanwhervin",
    title: "Assistant Director, Retirement",
    slug: "nicole-s-adams-vanwhervin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael M",
    lastName: "Adan",
    title: "Undergraduate Coordinator",
    slug: "michael-m-adan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christine Carpio",
    lastName: "Adapon",
    title: "Administrator of Student Academic Appointments",
    slug: "christine-carpio-adapon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adeola Anike",
    lastName: "Adegbola-White",
    title: "Assistant Director, Graduate Student Wellness and Support Services",
    slug: "adeola-anike-adegbola-white",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Caroline A.",
    lastName: "Adelman",
    title: "Associate Director, Strategic Communications and Media Relations",
    slug: "caroline-a-adelman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Taiwo",
    lastName: "Adenekan",
    title: "Executive Director, Administration & Operations",
    slug: "taiwo-adenekan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ken",
    lastName: "Adenekan",
    title: "Operations Manager for Student Support",
    slug: "ken-adenekan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Adebambo",
    lastName: "Adesanya",
    title: "Coordinator",
    slug: "adebambo-adesanya",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Adefisayo",
    lastName: "Adetayo",
    title: "Coordinator",
    slug: "adefisayo-adetayo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kwabena",
    lastName: "Adjei",
    title: "Neurophysiology Coordinator",
    slug: "kwabena-adjei",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha S.",
    lastName: "Adkins",
    title: "Senior Financial Services Officer",
    slug: "samantha-s-adkins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vera A",
    lastName: "Adler",
    title: "Executive Director, Operations",
    slug: "vera-a-adler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha Peikoff",
    lastName: "Adler",
    title: "Admissions Contract Worker",
    slug: "samantha-peikoff-adler",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nikki",
    lastName: "Adler",
    title: "Manager, Leave Management",
    slug: "nikki-adler",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Isabel Haya Weidman",
    lastName: "Adler",
    title: "Communications Coordinator",
    slug: "isabel-haya-weidman-adler",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elaine",
    lastName: "Adorno",
    title: "Licensed Master Social Worker",
    slug: "elaine-adorno",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah J.",
    lastName: "Adriance",
    title: "Assistant Director of Academic Administration",
    slug: "sarah-j-adriance",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sandra",
    lastName: "Afflick",
    title: "Assistant Registrar for Operations and Records",
    slug: "sandra-afflick",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mayya",
    lastName: "Agapova",
    title: "Junior Designer",
    slug: "mayya-agapova",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maneesha",
    lastName: "Aggarwal",
    title: "AVP, Academic, Emerging Technologies & Research Services",
    slug: "maneesha-aggarwal",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karthik",
    lastName: "Aggarwal",
    title: "Assistant Director, Alumni Marketing and Communications",
    slug: "karthik-aggarwal",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maureen F",
    lastName: "Agostini",
    title: "Sr Exec Director, Development",
    slug: "maureen-f-agostini",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Milagros M",
    lastName: "Agostini",
    title: "Associate Director, Financial Aid Operations and Processing",
    slug: "milagros-m-agostini",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mariangela",
    lastName: "Agovino",
    title: "Research Manager, QA & Safety",
    slug: "mariangela-agovino",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Teresa E.",
    lastName: "Aguayo",
    title: "Director of Academic Administration and Finance",
    slug: "teresa-e-aguayo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leonia M.",
    lastName: "Aguiar",
    title: "Executive Director of Human Resources",
    slug: "leonia-m-aguiar",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joseph",
    lastName: "Aguiar",
    title: "Administrative Assistant",
    slug: "joseph-aguiar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan A.",
    lastName: "Aguilar",
    title: "Student Affairs Administrator",
    slug: "susan-a-aguilar",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nina",
    lastName: "Aguilar",
    title: "Senior Manager, Sponsored Projects Finance",
    slug: "nina-aguilar",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joy",
    lastName: "Aguiyi",
    title: "Monitor for Hire",
    slug: "joy-aguiyi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maame Y",
    lastName: "Agyeiwaah",
    title: "Associate General Counsel",
    slug: "maame-y-agyeiwaah",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Nicole",
    lastName: "Agyeman",
    title: "SYEP",
    slug: "nicole-agyeman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Akosua S",
    lastName: "Agyemang",
    title: "Student Academic Support Worker",
    slug: "akosua-s-agyemang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samar Hasna",
    lastName: "Ahmad",
    title: "Project Coordinator II",
    slug: "samar-hasna-ahmad",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Naveed A",
    lastName: "Ahmad",
    title: "Director,Enrollment/Operations",
    slug: "naveed-a-ahmad",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tasmina Sultana",
    lastName: "Ahmed",
    title: "Senior Director of Finance",
    slug: "tasmina-sultana-ahmed",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Salwa M",
    lastName: "Ahmed",
    title: "Project Coordinator I",
    slug: "salwa-m-ahmed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sayeed",
    lastName: "Ahmed",
    title: "Assistant Manager-Catering",
    slug: "sayeed-ahmed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shaziya",
    lastName: "Ahmed",
    title: "Sr Regulatory Res Coord",
    slug: "shaziya-ahmed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shahid",
    lastName: "Ahmed",
    title: "Director, Application Architecture & Software Services",
    slug: "shahid-ahmed",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Saleha",
    lastName: "Ahmed",
    title: "Senior Director, HR/FA",
    slug: "saleha-ahmed",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mufrad M",
    lastName: "Ahmed",
    title: "Residence Hall Director",
    slug: "mufrad-m-ahmed",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Catherine E",
    lastName: "Ahmed",
    title: "Deputy Director Of Operations",
    slug: "catherine-e-ahmed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly J.",
    lastName: "Ahn",
    title: "Associate Dean, Career Design Lab",
    slug: "kelly-j-ahn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eunice",
    lastName: "Ahonor-Edwards",
    title: "Sr Act Rep",
    slug: "eunice-ahonor-edwards",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shourav",
    lastName: "Ahsan",
    title: "Academic Appointment Officer",
    slug: "shourav-ahsan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily Anne",
    lastName: "Ailts",
    title: "Assistant General Manager - Conference Services",
    slug: "emily-anne-ailts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kara M",
    lastName: "Ainsworth",
    title: "Manager",
    slug: "kara-m-ainsworth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul Kehinde",
    lastName: "Ajayi",
    title: "Residence Hall Director",
    slug: "paul-kehinde-ajayi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Adnan",
    lastName: "Akram",
    title: "System Administrator",
    slug: "adnan-akram",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Beauty",
    lastName: "Akter",
    title: "Administrative Assistant",
    slug: "beauty-akter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Agatha A.",
    lastName: "Akyere",
    title: "Senior Student Service Rep",
    slug: "agatha-a-akyere",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Johan",
    lastName: "Alarcon",
    title: "Associate Director, Construction Sourcing",
    slug: "johan-alarcon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leslie Marleny",
    lastName: "Alas Quijada",
    title: "Communications Coordinator",
    slug: "leslie-marleny-alas-quijada",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Pilar",
    lastName: "Alayo",
    title: "Senior Manager, HR Reporting",
    slug: "pilar-alayo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Carla",
    lastName: "Alba",
    title: "Administrative Coordinator",
    slug: "carla-alba",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Denice F",
    lastName: "Alba Batista",
    title: "Manager, HR/FA",
    slug: "denice-f-alba-batista",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jun Gonzales",
    lastName: "Alban Jr.",
    title: "System Administrator & DBA-Lead",
    slug: "jun-gonzales-alban-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aruna",
    lastName: "Albert",
    title: "SYEP",
    slug: "aruna-albert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth G",
    lastName: "Albes",
    title: "Advising Dean",
    slug: "elizabeth-g-albes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Naomi",
    lastName: "Alcantara",
    title: "Project Coordinator",
    slug: "naomi-alcantara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lineyda",
    lastName: "Alcantara",
    title: "Billing Manager",
    slug: "lineyda-alcantara",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Genesis",
    lastName: "Alcantara",
    title: "Administrative Assistant",
    slug: "genesis-alcantara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edirka",
    lastName: "Alcantara Abreu",
    title: "Senior Education Coordinator",
    slug: "edirka-alcantara-abreu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Renato M",
    lastName: "Alcaraz",
    title: "Administrative Aide",
    slug: "renato-m-alcaraz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marr Luis Titus",
    lastName: "Aldea",
    title: "Technical Support Specialist",
    slug: "marr-luis-titus-aldea",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mercy M",
    lastName: "Alejo",
    title: "Administrative Coordinator",
    slug: "mercy-m-alejo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maceda",
    lastName: "Alemu",
    title: "Operations Officer",
    slug: "maceda-alemu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sherene",
    lastName: "Alexander",
    title: "Director of Academic Administration",
    slug: "sherene-alexander",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Taylor Keith",
    lastName: "Alexander",
    title: "Media Specialist",
    slug: "taylor-keith-alexander",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Phillip Kirk",
    lastName: "Alexander",
    title: "Jazz Studies Staff Associate 1",
    slug: "phillip-kirk-alexander",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madeline Grace",
    lastName: "Alexander",
    title: "Project Director",
    slug: "madeline-grace-alexander",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josh",
    lastName: "Alexander",
    title: "Associate Dean of Students",
    slug: "josh-alexander",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aschnelle Syndel",
    lastName: "Alexander",
    title: "Purchasing Coordinator",
    slug: "aschnelle-syndel-alexander",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cecile E.",
    lastName: "Alexis",
    title: "Production Editor",
    slug: "cecile-e-alexis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lina Maria",
    lastName: "Alfonso",
    title: "Asst Dir, Business Process Ops",
    slug: "lina-maria-alfonso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meredith A",
    lastName: "Alfred",
    title: "Scheduling Coordinator",
    slug: "meredith-a-alfred",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Molly A",
    lastName: "Algermissen",
    title: "Program Manager I",
    slug: "molly-a-algermissen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ana",
    lastName: "Alguera",
    title: "Account Representative",
    slug: "ana-alguera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Waleed",
    lastName: "Alhariri",
    title: "Managing Director",
    slug: "waleed-alhariri",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yasmeen",
    lastName: "Ali",
    title: "Finance and Compliance Manager, Sponsored Projects Finance",
    slug: "yasmeen-ali",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shazia",
    lastName: "Ali",
    title: "Finance Manager",
    slug: "shazia-ali",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heba A.",
    lastName: "Ali",
    title: "Senior Grants Manager",
    slug: "heba-a-ali",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tyana",
    lastName: "Ali-Pearson",
    title: "Senior Associate Director, Online and Digital Programs",
    slug: "tyana-ali-pearson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Azin",
    lastName: "Aliabadi",
    title: "Associate Director & Program Director for Partnerships, AC4",
    slug: "azin-aliabadi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vincent A.",
    lastName: "Aliberto",
    title: "Media and Production Lead",
    slug: "vincent-a-aliberto",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth",
    lastName: "Alicea",
    title: "Director",
    slug: "elizabeth-alicea",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Daniel P.",
    lastName: "Alicea",
    title: "Director of Post-Award Finance",
    slug: "daniel-p-alicea",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Blerta",
    lastName: "Alikaj",
    title: "Marketing/Outreach Coordinator",
    slug: "blerta-alikaj",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elmira",
    lastName: "Alimova",
    title: "Senior Director, Web & Mobile Application Services",
    slug: "elmira-alimova",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Salvatore",
    lastName: "Alioto",
    title: "Executive Director, Accounts Payable",
    slug: "salvatore-alioto",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lana G",
    lastName: "Alkhatib",
    title: "Assistant Director for Data Systems",
    slug: "lana-g-alkhatib",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Viola",
    lastName: "Alku",
    title: "Operations Associate-IMC",
    slug: "viola-alku",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Allalemdjian",
    title: "Director-Sustainability & Transportation",
    slug: "daniel-allalemdjian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francis F",
    lastName: "Allarey",
    title: "Manager, Fin/Business Dev",
    slug: "francis-f-allarey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tyson Heks",
    lastName: "Allen",
    title: "Manager-Research Operations",
    slug: "tyson-heks-allen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sheanine",
    lastName: "Allen",
    title: "Director of Affirmative Action and Recruitment",
    slug: "sheanine-allen",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Paige E",
    lastName: "Allen",
    title: "Assistant Director of Communications and Event Management",
    slug: "paige-e-allen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mea E",
    lastName: "Allen",
    title: "Senior Trainer",
    slug: "mea-e-allen",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Geoffrey",
    lastName: "Allen",
    title: "Creative Strategist",
    slug: "geoffrey-allen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Corey Cedric",
    lastName: "Allen",
    title: "Department Secretary",
    slug: "corey-cedric-allen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Antija Modessa",
    lastName: "Allen",
    title: "Staff",
    slug: "antija-modessa-allen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth",
    lastName: "Allende",
    title: "Academic Affairs Manager",
    slug: "elizabeth-allende",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Owen A.",
    lastName: "Allert",
    title: "Associate Director",
    slug: "owen-a-allert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ameena",
    lastName: "Allie",
    title: "Senior Generalist, HR/FA",
    slug: "ameena-allie",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Karen Justina",
    lastName: "Allis",
    title: "Administrative Manager",
    slug: "karen-justina-allis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Colin",
    lastName: "Allison",
    title:
      " Director of Recreation Operations, Associate Director of Physical Education & Recreation",
    slug: "colin-allison",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Najada",
    lastName: "Alliu",
    title: "MPA",
    slug: "najada-alliu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tarin M.",
    lastName: "Almanzar",
    title: "Associate Dean, Admissions and Financial Aid",
    slug: "tarin-m-almanzar",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Betsy B",
    lastName: "Almanzar",
    title: "Grants Manager",
    slug: "betsy-b-almanzar",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah A.",
    lastName: "Almeida",
    title: "Residence Hall Director",
    slug: "sarah-a-almeida",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yudelky",
    lastName: "Almonte",
    title: "Divisional Administrator",
    slug: "yudelky-almonte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "ROBERT",
    lastName: "ALMONTE",
    title: "Receptionist",
    slug: "robert-almonte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Phyllis",
    lastName: "Almonte",
    title: "Project Coordinator",
    slug: "phyllis-almonte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah Ann",
    lastName: "Aloe",
    title: "Senior Hazardous Materials Specialist",
    slug: "sarah-ann-aloe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James R",
    lastName: "Aloise",
    title: "Assistant Vice President & Director, Climate Initiatives Group",
    slug: "james-r-aloise",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zvika",
    lastName: "Aloni",
    title: "Regulatory Coordinator II",
    slug: "zvika-aloni",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Brandon M",
    lastName: "Alonso",
    title: "Compliance Specialist",
    slug: "brandon-m-alonso",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Carolyn F.",
    lastName: "Alonzo",
    title: "Manager of Database and Financial Administration",
    slug: "carolyn-f-alonzo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole F",
    lastName: "Alston",
    title: "Senior Trainer",
    slug: "nicole-f-alston",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Linda",
    lastName: "Alston",
    title: "Executive Assistant to Director Emeritus",
    slug: "linda-alston",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittany Renee",
    lastName: "Alston",
    title: "Administrative Coordinator",
    slug: "brittany-renee-alston",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth A",
    lastName: "Alt",
    title: "Senior Assistant Director",
    slug: "elizabeth-a-alt",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Josue",
    lastName: "Altamirano",
    title: "Technical Lead",
    slug: "josue-altamirano",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ian G.",
    lastName: "Althouse",
    title: "Associate Director, Graduate Student Programs and Services",
    slug: "ian-g-althouse",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Suzanne",
    lastName: "Altshuler",
    title: "Assistant Vice President for Development and Chief of Staff",
    slug: "suzanne-altshuler",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gina",
    lastName: "Alvarado",
    title: "Director, Monitoring, Evaluation and Learning",
    slug: "gina-alvarado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ahmed A.",
    lastName: "Alvares",
    title: "Office Assistant",
    slug: "ahmed-a-alvares",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Alvarez",
    title: "System Coordinator",
    slug: "mary-alvarez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Monica",
    lastName: "Alvarez",
    title: "Reception Coordinator",
    slug: "monica-alvarez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miriam",
    lastName: "Alvarez",
    title: "Front Desk Receptionist",
    slug: "miriam-alvarez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda",
    lastName: "Alvarez",
    title: "Asst Mgr Accounts Receivable",
    slug: "linda-alvarez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bienvenida",
    lastName: "Alvarez",
    title: "Associate HR Manager",
    slug: "bienvenida-alvarez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ana Julia",
    lastName: "Alvarez",
    title: "Senior Project Officer",
    slug: "ana-julia-alvarez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea",
    lastName: "Alvarez",
    title: "Patholgists' Assistant - Gross Room Manager",
    slug: "andrea-alvarez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gesenia J.",
    lastName: "Alvarez-Lazauskas",
    title: "Associate Director of Financial Operations",
    slug: "gesenia-j-alvarez-lazauskas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gilmari",
    lastName: "Alvelo",
    title: "Administrative Assistant",
    slug: "gilmari-alvelo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amelia J",
    lastName: "Alverson",
    title:
      " Executive Vice President for University Development and Alumni Relations",
    slug: "amelia-j-alverson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Basem",
    lastName: "Aly",
    title: "Assistant Director of Instructional Technology",
    slug: "basem-aly",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wanda",
    lastName: "Amancio",
    title: "Billing Compliance Assistant",
    slug: "wanda-amancio",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Camille",
    lastName: "Amantine",
    title: "Sr Financial Aid Coordinator",
    slug: "camille-amantine",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Zenaye",
    lastName: "Amare Negatou",
    title: "Billing Manager",
    slug: "zenaye-amare-negatou",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emmanuel",
    lastName: "Amarh",
    title: "Sr Service Desk Specialist",
    slug: "emmanuel-amarh",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Arabia",
    lastName: "Amari",
    title: "Assistant Manager-Dining Services",
    slug: "arabia-amari",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Monica",
    lastName: "Amaro",
    title: "Director of Enrollment",
    slug: "monica-amaro",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Anastassia R.",
    lastName: "Amato-La Hoz",
    title: "Assistant to the Chair",
    slug: "anastassia-r-amato-la-hoz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Muriel Geneva",
    lastName: "Ambrus",
    title: "Coordinator,Student Engagement",
    slug: "muriel-geneva-ambrus",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aaron",
    lastName: "Amezaga",
    title: "Technical Support Specialist",
    slug: "aaron-amezaga",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nishat",
    lastName: "Amin",
    title: "Grants Coordintor",
    slug: "nishat-amin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dina E.",
    lastName: "Amin",
    title: "Senior Project Officer",
    slug: "dina-e-amin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christian Johannes",
    lastName: "Amlang",
    title: "Collaborator",
    slug: "christian-johannes-amlang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan Rupa",
    lastName: "Amlani",
    title: "Dir, Exec Mgmt/Master in MHA",
    slug: "susan-rupa-amlani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tyffanie Rae-Anne",
    lastName: "Ammeter",
    title: "Interim Hourly",
    slug: "tyffanie-rae-anne-ammeter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yvonne",
    lastName: "Amparo",
    title: "Procurement Manager",
    slug: "yvonne-amparo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Malika",
    lastName: "Amraoui",
    title: "Academic Secretary",
    slug: "malika-amraoui",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mizpa Martine Akofa",
    lastName: "Anani Zoglo",
    title: "Accounting Coordinator",
    slug: "mizpa-martine-akofa-anani-zoglo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauren",
    lastName: "Anazagasti",
    title: "Finance & Admin Coordinator",
    slug: "lauren-anazagasti",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Abraham",
    lastName: "Ancrum",
    title: "Stockroom Coordinator",
    slug: "abraham-ancrum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca A.",
    lastName: "Andersen Polimeda",
    title:
      " Associate Director of Professional Development and Student Engagement",
    slug: "rebecca-a-andersen-polimeda",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yaryna",
    lastName: "Anderson",
    title: "Digital Comm & Tech Manager",
    slug: "yaryna-anderson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Victoria",
    lastName: "Anderson",
    title: "Manager-Audio Visual",
    slug: "victoria-anderson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Megan Nicole",
    lastName: "Anderson",
    title: "Project Assistant",
    slug: "megan-nicole-anderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin E.",
    lastName: "Anderson",
    title: "AV Specialist, The Forum",
    slug: "justin-e-anderson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ivan A.",
    lastName: "Anderson",
    title: "Senior Associate Director, Custom Programs",
    slug: "ivan-a-anderson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eugene",
    lastName: "Anderson",
    title: "Assistant Vice President, Community and Philanthropic Engagement",
    slug: "eugene-anderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sonnia",
    lastName: "Andrade",
    title: "Manager-Finance/Compliance",
    slug: "sonnia-andrade",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Georgia A",
    lastName: "Andre",
    title: "Admin Coordinator / Finance",
    slug: "georgia-a-andre",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Astrid",
    lastName: "Andre",
    title: "Academic Program Support in Professional Studies",
    slug: "astrid-andre",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gabrielle",
    lastName: "Andrion",
    title: "Assistant Director, Operations and Student Services",
    slug: "gabrielle-andrion",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Daisy M.",
    lastName: "Andujar",
    title: "Administrative Aide",
    slug: "daisy-m-andujar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Andujar-Ray",
    title: "Director, Research Administration",
    slug: "lisa-andujar-ray",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ilene S",
    lastName: "Anesini",
    title: "Assoc VP, Finance,Ops&Alum Rel",
    slug: "ilene-s-anesini",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Francisco",
    lastName: "Angeles",
    title: "Project Manager",
    slug: "francisco-angeles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ana",
    lastName: "Angeles",
    title: "Associate Director Student Leadership and Engagement",
    slug: "ana-angeles",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christopher",
    lastName: "Angelosanto",
    title: "Senior Grants Manager",
    slug: "christopher-angelosanto",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David",
    lastName: "Angileri",
    title: "Service Management Office Director",
    slug: "david-angileri",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Farha",
    lastName: "Anjum",
    title: "Digital Production Manager",
    slug: "farha-anjum",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marisa Lynn",
    lastName: "Annunziato",
    title: "Education and Outreach Coordinator",
    slug: "marisa-lynn-annunziato",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amoy Felisa",
    lastName: "Ansell-Poirier",
    title: "Manager-External Rel/Events",
    slug: "amoy-felisa-ansell-poirier",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan",
    lastName: "Anthony",
    title: "Administrative Assistant in the Weatherhead East Asian Institute",
    slug: "susan-anthony",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elaine",
    lastName: "Antigua",
    title: "Instructional Support Assistant",
    slug: "elaine-antigua",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Martin James",
    lastName: "Antone",
    title: "Senior Trainer",
    slug: "martin-james-antone",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Frances",
    lastName: "Antonetty",
    title: "Senior Grants/Contract Manager",
    slug: "frances-antonetty",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vincent",
    lastName: "Antwi",
    title: "Events Coordinator",
    slug: "vincent-antwi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leanette",
    lastName: "Anzules",
    title: "Associate Director, University Ceremonies",
    slug: "leanette-anzules",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ken",
    lastName: "Aoki",
    title: "Assistant Director",
    slug: "ken-aoki",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leora Jennifer",
    lastName: "Apfelbaum",
    title: "Adult Diabetes Educator",
    slug: "leora-jennifer-apfelbaum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Aponte",
    title: "Lab Aide",
    slug: "ashley-aponte",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Roberto A.",
    lastName: "Aquino",
    title: "Mail Room Supervisor",
    slug: "roberto-a-aquino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Orlando",
    lastName: "Aquino",
    title: "System Administrator",
    slug: "orlando-aquino",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melinda A",
    lastName: "Aquino",
    title: "Associate Dean of Multicultural Affairs",
    slug: "melinda-a-aquino",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Juan Evangelista",
    lastName: "Aquino",
    title: "Head Porter",
    slug: "juan-evangelista-aquino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Aquino",
    title: "Associate  Manager",
    slug: "david-aquino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bilkis",
    lastName: "Ara",
    title: "Senior Database Developer",
    slug: "bilkis-ara",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yancy",
    lastName: "Aracena",
    title:
      " Senior Associate Director, Office of Academic Record and Registration",
    slug: "yancy-aracena",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rebeca",
    lastName: "Aragon Garcia",
    title: "Project Manager",
    slug: "rebeca-aragon-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elina",
    lastName: "Aranchuk",
    title: "Associate Director, HR & FA",
    slug: "elina-aranchuk",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Henry",
    lastName: "Arango",
    title: "Administrative Assistant I",
    slug: "henry-arango",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas",
    lastName: "Arbuckle",
    title: "Staff",
    slug: "thomas-arbuckle",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maria Fatima",
    lastName: "Arcadio",
    title: "Admissions Coordinator",
    slug: "maria-fatima-arcadio",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Maya",
    lastName: "Ardon",
    title: "Sr Director, Student Affairs",
    slug: "maya-ardon",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Farouk",
    lastName: "Aregbe",
    title: "Senior Developer Data Insights & Visualization",
    slug: "farouk-aregbe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shaye E.",
    lastName: "Areheart",
    title: "Director, Columbia Publishing Course",
    slug: "shaye-e-areheart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rodolfo F",
    lastName: "Arevalo",
    title: "Project Coordinator",
    slug: "rodolfo-f-arevalo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin",
    lastName: "Argent",
    title: "MPA",
    slug: "caitlin-argent",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sally Elizabeth",
    lastName: "Arias",
    title: "Investigations Assistant",
    slug: "sally-elizabeth-arias",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Karina Winn",
    lastName: "Arias",
    title: "Assistant Director of Student Employment",
    slug: "karina-winn-arias",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christian J",
    lastName: "Arias",
    title: "Education Assistant",
    slug: "christian-j-arias",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Besaida",
    lastName: "Arias",
    title: "Senior Grants Specialist",
    slug: "besaida-arias",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Natalia",
    lastName: "Arias-Abreu",
    title: "Director, Administrative/Ops",
    slug: "natalia-arias-abreu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amber",
    lastName: "Arif",
    title: "Project Assistant",
    slug: "amber-arif",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Avanish",
    lastName: "Arjune",
    title: "IRB Specialist",
    slug: "avanish-arjune",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Noah",
    lastName: "Arlow",
    title: "Senior Designer",
    slug: "noah-arlow",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michelle",
    lastName: "Arminio",
    title: "CCW - Eastchester",
    slug: "michelle-arminio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannon Aline",
    lastName: "Armstrong",
    title: "Associate Director, Tax",
    slug: "shannon-aline-armstrong",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carolyn Mae",
    lastName: "Armstrong",
    title: "Associate Director of Data and Analytics",
    slug: "carolyn-mae-armstrong",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cassandra",
    lastName: "Armstrong",
    title: "Administrative Assistant",
    slug: "cassandra-armstrong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaele Amir William",
    lastName: "Armwood",
    title: "Instructional Technology Specialist",
    slug: "jaele-amir-william-armwood",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John S.",
    lastName: "Arn",
    title: "Program Manager",
    slug: "john-s-arn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole R",
    lastName: "Arndt",
    title: "Associate Director, Career Design Lab",
    slug: "nicole-r-arndt",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Phoebe-Sade",
    lastName: "Arnold",
    title: "Director,Community Affairs",
    slug: "phoebe-sade-arnold",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alexis",
    lastName: "Arnold",
    title: "Manager, Communications and Creative Services",
    slug: "alexis-arnold",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Edward A.",
    lastName: "Arnold-Berkovits",
    title: "Director, Servers & Applicatio",
    slug: "edward-a-arnold-berkovits",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Delana N",
    lastName: "Aromi",
    title: "Assistant Director, PFS",
    slug: "delana-n-aromi",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Corey S",
    lastName: "Aronstam",
    title:
      " Deputy Vice President of Development, Columbia College and Arts and Sciences / Senior Associate Dean for CC Dev and Alumni Relations",
    slug: "corey-s-aronstam",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abraham",
    lastName: "Arriaga",
    title: "Administrative Coordinator",
    slug: "abraham-arriaga",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas",
    lastName: "Arroyo",
    title: "Assistant Director, Admissions",
    slug: "nicholas-arroyo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kimberly",
    lastName: "Arroyo",
    title: "Executive Assistant and Administrative Officer",
    slug: "kimberly-arroyo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sadie Ellen",
    lastName: "Arsenault",
    title: "Graphic Designer",
    slug: "sadie-ellen-arsenault",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Samantha S.",
    lastName: "Arthur",
    title: "Live Support Specialist",
    slug: "samantha-s-arthur",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Paige",
    lastName: "Arthur",
    title: "Director - Global Programming",
    slug: "paige-arthur",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ian C.",
    lastName: "Arthur",
    title: "Application Specialist (ePro, PO, AP)",
    slug: "ian-c-arthur",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brenda",
    lastName: "Arthur",
    title: "Director, HR Operations",
    slug: "brenda-arthur",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alisha M",
    lastName: "Arthur",
    title: "Director of Academic Administration",
    slug: "alisha-m-arthur",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacqueline",
    lastName: "Artis-Abreu",
    title: "MPA",
    slug: "jacqueline-artis-abreu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marina",
    lastName: "Arzumanyan",
    title: "Associate Director, System Development & Administration",
    slug: "marina-arzumanyan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kofi Amoako",
    lastName: "Asare",
    title: "Media Services Administrator Lead",
    slug: "kofi-amoako-asare",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Abigail",
    lastName: "Asgaralli",
    title: "Registrar",
    slug: "abigail-asgaralli",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle Elizabeth",
    lastName: "Ashcroft",
    title: "Associate Director, Investifations",
    slug: "michelle-elizabeth-ashcroft",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Abigail",
    lastName: "Asher",
    title: "Manager - Events and Communication",
    slug: "abigail-asher",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rumana",
    lastName: "Ashraf",
    title: "Director of Center-Scale Pre-award Services",
    slug: "rumana-ashraf",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristen Lee",
    lastName: "Asp",
    title: "Digital Content Producer",
    slug: "kristen-lee-asp",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rick J",
    lastName: "Ast",
    title: "Manager Technical Services",
    slug: "rick-j-ast",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert S.",
    lastName: "Ast",
    title: "Senior Director, Data and Analytics",
    slug: "robert-s-ast",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher",
    lastName: "Aston",
    title:
      " Director, Biological Safety Programs and Chief Biological Safety Officer",
    slug: "christopher-aston",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheila",
    lastName: "Astudillo Amato",
    title: "Executive Director, HRIS",
    slug: "sheila-astudillo-amato",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marilyn",
    lastName: "Astwood",
    title: "Administrative Assistant",
    slug: "marilyn-astwood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Minne Genevieve",
    lastName: "Atairu",
    title: "Digital Content and Events Manager",
    slug: "minne-genevieve-atairu",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Irene T",
    lastName: "Atamian",
    title: "Business Manager",
    slug: "irene-t-atamian",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacqueline D",
    lastName: "Atkins",
    title: "Residence Hall Director",
    slug: "jacqueline-d-atkins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Carlotta A",
    lastName: "Atkins",
    title: "Talent Acquisition Manager",
    slug: "carlotta-a-atkins",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gillian Gayle Elouise",
    lastName: "Atkinson",
    title: "Director-DEIB",
    slug: "gillian-gayle-elouise-atkinson",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Claudia R.",
    lastName: "Atkinson",
    title: "Program Manager",
    slug: "claudia-r-atkinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Atsalis",
    title: "Managing Director, Investments",
    slug: "john-atsalis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dionna Nicole",
    lastName: "Attinson",
    title: "Consultant",
    slug: "dionna-nicole-attinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Byron",
    lastName: "Aucapina",
    title: "PET/CT Tech",
    slug: "byron-aucapina",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Renissa C.",
    lastName: "Audain",
    title: "Procurement Coordinator",
    slug: "renissa-c-audain",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marilyn P",
    lastName: "Audain",
    title: "Secretary",
    slug: "marilyn-p-audain",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brascia M",
    lastName: "Audain",
    title: "Business Manager",
    slug: "brascia-m-audain",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jasmina",
    lastName: "Auguste",
    title: "Senior Student Service Representative, Collections and Loans",
    slug: "jasmina-auguste",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jahsulynn",
    lastName: "Ault",
    title: "Director of Communications Operations",
    slug: "jahsulynn-ault",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nina L.",
    lastName: "Auslander-Padgham",
    title: "Assistant Director, Alumni & Development Events",
    slug: "nina-l-auslander-padgham",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David",
    lastName: "Austell",
    title: "Associate Provost/Executive Director, ISSO",
    slug: "david-austell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Olivia",
    lastName: "Austin",
    title: "Manager-Admissions",
    slug: "olivia-austin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Dianna",
    lastName: "Austin",
    title: "Executive Assistant",
    slug: "dianna-austin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adrian R.",
    lastName: "Austin",
    title: "Assoc Dir-Res Admin Train Dev",
    slug: "adrian-r-austin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bria-Nicole",
    lastName: "Austin-Gonzalez",
    title: "Administrative Assistant",
    slug: "bria-nicole-austin-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Valerie",
    lastName: "Austyn",
    title: "Sr Grants Compliance Coord",
    slug: "valerie-austyn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexander",
    lastName: "Autar",
    title: "Senior Service Specialist",
    slug: "alexander-autar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maribel",
    lastName: "Autie",
    title: "Financial Assistant",
    slug: "maribel-autie",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emilia L.",
    lastName: "Autin-Hefner",
    title: "Live Support Specialist",
    slug: "emilia-l-autin-hefner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah",
    lastName: "AuYeung",
    title: "HR Specialist II",
    slug: "sarah-auyeung",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle L.",
    lastName: "Avallone",
    title: "Director of Export Controls and International Engagement",
    slug: "michelle-l-avallone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kara Danielle V",
    lastName: "Avancena",
    title: "Director of Public Affairs",
    slug: "kara-danielle-v-avancena",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alexis",
    lastName: "Avedisian",
    title: "Director of Events and Marketing",
    slug: "alexis-avedisian",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dianne M.",
    lastName: "Avellino",
    title: "Assistant Project Manager",
    slug: "dianne-m-avellino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victor",
    lastName: "Aviles",
    title: "MPA",
    slug: "victor-aviles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexandra J.",
    lastName: "Aviles",
    title: "Administrative Assistant",
    slug: "alexandra-j-aviles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlin",
    lastName: "Aviles-Castillo",
    title: "Associate Director, Product Marketing",
    slug: "kaitlin-aviles-castillo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maya",
    lastName: "Aviram",
    title: "Research Administrator",
    slug: "maya-aviram",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Monica E.",
    lastName: "Avitsur",
    title: "Deputy Registrar",
    slug: "monica-e-avitsur",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Saleha",
    lastName: "Awal",
    title: "Program Manager",
    slug: "saleha-awal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Curtis K",
    lastName: "Awong",
    title: "Assoc Director, CUIMC Payroll",
    slug: "curtis-k-awong",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ericka",
    lastName: "Ayala",
    title: "Manager-Education Admin",
    slug: "ericka-ayala",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eduardo Andres",
    lastName: "Ayala Fuentes",
    title: "Major Gift Officer, School of International and Public Affairs",
    slug: "eduardo-andres-ayala-fuentes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nurys",
    lastName: "Aybar-Leavey",
    title: "Administrative Support Supervisor",
    slug: "nurys-aybar-leavey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "George A.",
    lastName: "Ayisi",
    title: "Guest Service Representative",
    slug: "george-a-ayisi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alfred Anthony",
    lastName: "Ayoub",
    title: "Director of Admissions and Marketing",
    slug: "alfred-anthony-ayoub",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Namita",
    lastName: "Azad",
    title: "Sr Dir,OrgDev-Transformation",
    slug: "namita-azad",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Roberto",
    lastName: "Azevedo",
    title: "Consultant",
    slug: "roberto-azevedo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Froogh",
    lastName: "Aziz",
    title: "Statistical Anlst/Data Manager",
    slug: "froogh-aziz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nyasha Terri-Anna",
    lastName: "Babb",
    title: "Business Services Officer",
    slug: "nyasha-terri-anna-babb",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "M.K.",
    lastName: "Babcock",
    title: "Associate Director of Finance",
    slug: "m-k-babcock",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Asha A.",
    lastName: "Bacchus",
    title: "Director, Network Operations",
    slug: "asha-a-bacchus",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jesse M",
    lastName: "Bachan",
    title: "Administrative Assistant",
    slug: "jesse-m-bachan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason Michael",
    lastName: "Bachan",
    title: "Program Affairs Coordinator",
    slug: "jason-michael-bachan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle",
    lastName: "Badillo",
    title: "Associate Director of Accounts Payable and Procurement",
    slug: "michelle-badillo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Diana Kyung",
    lastName: "Bae",
    title: "IRB Specialist",
    slug: "diana-kyung-bae",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vidal",
    lastName: "Baez",
    title: "Manager - Finance and Grants",
    slug: "vidal-baez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Berenis",
    lastName: "Baez",
    title: "Program Manager",
    slug: "berenis-baez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Asheena Aleana",
    lastName: "Baez",
    title: "Staff",
    slug: "asheena-aleana-baez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Massiel",
    lastName: "Baez Belen",
    title: "Project Coordinator II",
    slug: "massiel-baez-belen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey",
    lastName: "Bagares",
    title: "Director of Operations",
    slug: "jeffrey-bagares",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Baggan-Bacchus",
    title: "Executive Director of Finance and Budget",
    slug: "michelle-baggan-bacchus",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vera",
    lastName: "Bagnyuk",
    title: "Senior Admissions Manager",
    slug: "vera-bagnyuk",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Algassimou",
    lastName: "Bah",
    title: "Accounting Coordinator",
    slug: "algassimou-bah",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cody William",
    lastName: "Bahlau",
    title: "Science Officer",
    slug: "cody-william-bahlau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dione",
    lastName: "Bailey",
    title: "Staff",
    slug: "dione-bailey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Bailey Cognetti",
    title: "Director of Marketing and Engagement",
    slug: "lauren-bailey-cognetti",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tricia M",
    lastName: "Baione",
    title: "Assistant Dean of Admissions",
    slug: "tricia-m-baione",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Justus",
    lastName: "Baird",
    title: "Dean",
    slug: "justus-baird",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Akeem R",
    lastName: "Baird",
    title: "Administrator Assistant",
    slug: "akeem-r-baird",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Reetu R",
    lastName: "Bajaj",
    title: "Live Support Specialist",
    slug: "reetu-r-bajaj",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christina Kathryn",
    lastName: "Bak-Coleman",
    title: "Communications Manager",
    slug: "christina-kathryn-bak-coleman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Siri Linnea Peterson",
    lastName: "Baker",
    title: "Director of Gift Strategy",
    slug: "siri-linnea-peterson-baker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Malcolm",
    lastName: "Baker",
    title: "Oiler",
    slug: "malcolm-baker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James Edward",
    lastName: "Baker",
    title: "Lead Applications Systems Developer",
    slug: "james-edward-baker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ashly R.",
    lastName: "Baker",
    title: "Generalist, HR/FA",
    slug: "ashly-r-baker",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Audrey Helene",
    lastName: "Baker",
    title: "Director, International Programs",
    slug: "audrey-helene-baker",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carlton D.",
    lastName: "Baker II",
    title: "Graphic Artist II",
    slug: "carlton-d-baker-ii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marion",
    lastName: "Bakhoya",
    title: "NYSPI Volunteer",
    slug: "marion-bakhoya",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eola",
    lastName: "Bakhru",
    title: "Assoc Director-Grants &Finance",
    slug: "eola-bakhru",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katherine",
    lastName: "Balaguer",
    title:
      " Staff Assistant II in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "katherine-balaguer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arben",
    lastName: "Balazhi",
    title: "Application Specialist, Procurement Application Support",
    slug: "arben-balazhi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shelinna K.",
    lastName: "Balbuena",
    title: "Event Coordinator",
    slug: "shelinna-k-balbuena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David J.",
    lastName: "Balducci",
    title: "Sr. Director, Applications Quality Assurance",
    slug: "david-j-balducci",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carmela",
    lastName: "Balistreri",
    title: "Account Manager",
    slug: "carmela-balistreri",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rebecca",
    lastName: "Balkin",
    title: "Associate Director",
    slug: "rebecca-balkin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Phoebe",
    lastName: "Ballard",
    title: "Assistant Dean, Academic Services and Innovation",
    slug: "phoebe-ballard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carolyn",
    lastName: "Ballen",
    title: "Administrative Assistant",
    slug: "carolyn-ballen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelsie",
    lastName: "Bancroft",
    title: "Senior Associate Director, Communications",
    slug: "kelsie-bancroft",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kelly Fabiola",
    lastName: "Banegas",
    title: "Administrative Assistant",
    slug: "kelly-fabiola-banegas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Milee",
    lastName: "Bang",
    title: "Enrollment Services Specialist",
    slug: "milee-bang",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jae Joon",
    lastName: "Bang",
    title: "Assistant Director of Career Advising",
    slug: "jae-joon-bang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Abie Murray",
    lastName: "Bangura",
    title: "Senior Grants Manager",
    slug: "abie-murray-bangura",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David C.",
    lastName: "Banker",
    title: "Associate Director of Operations",
    slug: "david-c-banker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charmaine",
    lastName: "Banks",
    title: "Ultrasound Supervisor",
    slug: "charmaine-banks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noelle",
    lastName: "Bannister",
    title: "Executive Director of Development",
    slug: "noelle-bannister",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wakasha",
    lastName: "Bantawa-Rai",
    title: "Grants Finance Manager",
    slug: "wakasha-bantawa-rai",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Benjamin James",
    lastName: "Baraga",
    title: "Program Associate",
    slug: "benjamin-james-baraga",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabriella",
    lastName: "Barajas",
    title: "Associate Director of Student Affairs",
    slug: "gabriella-barajas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Irina Y.",
    lastName: "Baramidze",
    title: "Divisional Administrator",
    slug: "irina-y-baramidze",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nichole M.",
    lastName: "Barbe",
    title: "Graduate Admission Director",
    slug: "nichole-m-barbe",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Shawn Niles",
    lastName: "Barber",
    title: "Assistant Manager, Technical Support",
    slug: "shawn-niles-barber",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joshua Rene",
    lastName: "Barber",
    title: "Asst Director, Aquatic&RepLife",
    slug: "joshua-rene-barber",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dawn",
    lastName: "Barber",
    title: "Industry Liaison (Technology Management)",
    slug: "dawn-barber",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrew Campbell",
    lastName: "Barber",
    title: "Manager of High School Placement",
    slug: "andrew-campbell-barber",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maria C.",
    lastName: "Barcellos-Raible",
    title: "Senior Associate Director, Executive Education and Training",
    slug: "maria-c-barcellos-raible",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elmer",
    lastName: "Barcenes",
    title: "Administrative Manager",
    slug: "elmer-barcenes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie A",
    lastName: "Barimah",
    title: "Manager, HR/FA",
    slug: "stephanie-a-barimah",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Amirreza",
    lastName: "Barin",
    title: "Director of IT and Data Analytics",
    slug: "amirreza-barin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cody",
    lastName: "Barker",
    title: "Technical Assistant",
    slug: "cody-barker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ryan",
    lastName: "Barlow",
    title: "Assistant Director, Employer Relations",
    slug: "ryan-barlow",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jasmine",
    lastName: "Barlow",
    title: "Business Manager",
    slug: "jasmine-barlow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neil",
    lastName: "Barman",
    title: "Academic Program Support in Professional Studies",
    slug: "neil-barman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melissa",
    lastName: "Barnes",
    title: "Associate Director, Media and Advertising",
    slug: "melissa-barnes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Adam Michael",
    lastName: "Barnes",
    title: "Staff",
    slug: "adam-michael-barnes",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nicoletta",
    lastName: "Barolini",
    title: "Art Director",
    slug: "nicoletta-barolini",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jussara C.",
    lastName: "Barone",
    title: "Research Inf Proj Manager",
    slug: "jussara-c-barone",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kiersten A.",
    lastName: "Barr",
    title: "Senior Director of Data Analytics",
    slug: "kiersten-a-barr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ruth B",
    lastName: "Barragan",
    title: "Residency Coordinator",
    slug: "ruth-b-barragan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Wendy",
    lastName: "Barrales",
    title: "Induction Mentor",
    slug: "wendy-barrales",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anna F.",
    lastName: "Barranca-Burke",
    title: "Senior Director for Strategic Communications",
    slug: "anna-f-barranca-burke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laura",
    lastName: "Barrantes",
    title: "Consultant",
    slug: "laura-barrantes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karoline",
    lastName: "Barrera-Bogedale",
    title: "Development Coordinator",
    slug: "karoline-barrera-bogedale",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter",
    lastName: "Barrett",
    title: "Senior Publicist",
    slug: "peter-barrett",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joseph Samuel",
    lastName: "Barrette",
    title: "Residence Hall Director",
    slug: "joseph-samuel-barrette",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Steven",
    lastName: "Barroga",
    title: "Graduate Coordinator",
    slug: "steven-barroga",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maria",
    lastName: "Barros De La Hoz",
    title: "Administrative Coordinator",
    slug: "maria-barros-de-la-hoz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eileen M.",
    lastName: "Barroso",
    title: "University Photographer",
    slug: "eileen-m-barroso",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Zacha",
    lastName: "Barrow",
    title: "Med Asst/Sec",
    slug: "zacha-barrow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret",
    lastName: "Barrows",
    title: "Associate Director of Communications and Marketing",
    slug: "margaret-barrows",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Leta Margaret",
    lastName: "Barry",
    title: "Environmental Law Writer",
    slug: "leta-margaret-barry",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Annie",
    lastName: "Barry",
    title: "Sr IRB Specialist-Manager",
    slug: "annie-barry",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jill J",
    lastName: "Barshay",
    title: "Senior Reporter and Columnist",
    slug: "jill-j-barshay",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jason",
    lastName: "Bartlett",
    title: "Associate Director, Tax",
    slug: "jason-bartlett",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bridget Elizabeth",
    lastName: "Bartolini",
    title: "Department Secretary",
    slug: "bridget-elizabeth-bartolini",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eddie Jose",
    lastName: "Bartolomei",
    title: "Exhibitions Manager",
    slug: "eddie-jose-bartolomei",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vonetta T.",
    lastName: "Barton",
    title: "Financial Services Assistant 8",
    slug: "vonetta-t-barton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Renato",
    lastName: "Barucco",
    title: "Project Coordinator",
    slug: "renato-barucco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosiam",
    lastName: "Barzey-Caro",
    title: "Program Support Manager",
    slug: "rosiam-barzey-caro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laurie",
    lastName: "Bashford",
    title: "Graduate Assistant (Hourly)",
    slug: "laurie-bashford",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jackie",
    lastName: "Basile",
    title: "Program Manager",
    slug: "jackie-basile",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Whitney Mokuau",
    lastName: "Basmajian",
    title: "Matching Gifts Coordinator",
    slug: "whitney-mokuau-basmajian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nada",
    lastName: "Basouny",
    title: "Talent Aquisition Coordinator",
    slug: "nada-basouny",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Noah",
    lastName: "Batease",
    title: "Assistant Director, Admissions",
    slug: "noah-batease",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Alfredo B",
    lastName: "Batenga IV",
    title: "Instutional Bill Coordinator",
    slug: "alfredo-b-batenga-iv",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Thomson",
    lastName: "Batidzirai",
    title: "Senior Manager Proposal Development",
    slug: "thomson-batidzirai",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Faith",
    lastName: "Batidzirai",
    title: "Associate Director, Finance and Grants",
    slug: "faith-batidzirai",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth A.",
    lastName: "Batis",
    title: "Title IX Administrative Manager",
    slug: "elizabeth-a-batis",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jinauris Carmen",
    lastName: "Batista",
    title: "Generalist, HR/FA",
    slug: "jinauris-carmen-batista",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jeimy J.",
    lastName: "Batista",
    title: "Administrative Manager",
    slug: "jeimy-j-batista",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alleen R",
    lastName: "Batista",
    title: "Manager, Financial Operations",
    slug: "alleen-r-batista",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maria",
    lastName: "Batori",
    title: "Exec Asst/Academic Coordinator",
    slug: "maria-batori",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leuanna",
    lastName: "Batson",
    title: "MPA",
    slug: "leuanna-batson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kara K.",
    lastName: "Bauer",
    title: "Assoc Dir of Research Admin",
    slug: "kara-k-bauer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Drew J",
    lastName: "Baughman",
    title: "Senior Center Administrator",
    slug: "drew-j-baughman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric",
    lastName: "Baumgart",
    title: "Director, Cybersecurity",
    slug: "eric-baumgart",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Linnette",
    lastName: "Bautista",
    title: "Front Desk Coordinator",
    slug: "linnette-bautista",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hannah M",
    lastName: "Bayer",
    title:
      " Project Director in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "hannah-m-bayer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jaletza",
    lastName: "Bayley",
    title: "Senior Associate Director, Marketing & Participation",
    slug: "jaletza-bayley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kimberly Tricia-Ann",
    lastName: "Baylis",
    title: "Assistant Manager - Lerner Hall",
    slug: "kimberly-tricia-ann-baylis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nicole Alese",
    lastName: "Bayne",
    title: "Project Manager",
    slug: "nicole-alese-bayne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carlito",
    lastName: "Bayne",
    title: "Assistant Director",
    slug: "carlito-bayne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica",
    lastName: "Bayron",
    title: "Auditor",
    slug: "erica-bayron",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Erica",
    lastName: "Bayron",
    title: "Staff",
    slug: "erica-bayron-1",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristi Lynn",
    lastName: "Bazata",
    title: "Assistant Controller, Audit and Compliance",
    slug: "kristi-lynn-bazata",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christine",
    lastName: "Beachak",
    title: "Associate Director, Contracts, Services and Technology",
    slug: "christine-beachak",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dana",
    lastName: "Bean",
    title: "Four Points",
    slug: "dana-bean",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Beasley",
    title: "Payroll Specialist",
    slug: "anthony-beasley",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sandy",
    lastName: "Beato Matos",
    title: "Administrative Aide",
    slug: "sandy-beato-matos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Debbie Ann",
    lastName: "Beaudry",
    title: "Director of Academic Technical Support",
    slug: "debbie-ann-beaudry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ashley Jeanne",
    lastName: "Beccia",
    title: "Academic Coordinator",
    slug: "ashley-jeanne-beccia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eden",
    lastName: "Bechard",
    title: "Senior Program Manager",
    slug: "eden-bechard",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amy L",
    lastName: "Bechelli",
    title: "Manager-Data Management",
    slug: "amy-l-bechelli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam Charles",
    lastName: "Becker",
    title: "Assistant Director, Loan Services",
    slug: "adam-charles-becker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jaimee",
    lastName: "Beckett",
    title: "Bioinfo Software Developer",
    slug: "jaimee-beckett",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cynthia",
    lastName: "Beckman",
    title: "Administrative Director",
    slug: "cynthia-beckman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samuel Michael",
    lastName: "Bednar",
    title: "Coordinator",
    slug: "samuel-michael-bednar",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Betty Audrey",
    lastName: "Beecham",
    title: "Administrative Coordinator",
    slug: "betty-audrey-beecham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ben",
    lastName: "Beecher",
    title: "Sr Application Systems Develop",
    slug: "ben-beecher",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth J.",
    lastName: "Beerman",
    title: "AVP & Senior Director, Contracts & Compliance",
    slug: "elizabeth-j-beerman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Carol Margaret",
    lastName: "Begg",
    title: "Director-Acad Student Affairs",
    slug: "carol-margaret-begg",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrea",
    lastName: "Beharry",
    title: "Associate Director, Finance and Administration",
    slug: "andrea-beharry",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David",
    lastName: "Behringer",
    title: "Program Manager",
    slug: "david-behringer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joyce",
    lastName: "Bei",
    title: "Senior Application Administrator",
    slug: "joyce-bei",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Beirne",
    title: "Sr Director, Org Dev-Res/Ed",
    slug: "jennifer-beirne",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Desmond J.",
    lastName: "Beirne",
    title: "Director, Student Affairs",
    slug: "desmond-j-beirne",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kristin M.",
    lastName: "Beiswenger",
    title: "Exec Director-Scientific Ops",
    slug: "kristin-m-beiswenger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Denisse",
    lastName: "Bejaran",
    title: "Administrative Manager",
    slug: "denisse-bejaran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diana U",
    lastName: "Belizario",
    title: "Executive Assistant to CFO",
    slug: "diana-u-belizario",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Raquel",
    lastName: "Belkin",
    title: "Staff",
    slug: "raquel-belkin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Janarda",
    lastName: "Bell",
    title: "Development Assistant, Data Management",
    slug: "janarda-bell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eviana",
    lastName: "Bell",
    title: "Associate Director",
    slug: "eviana-bell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Bell",
    title:
      " Professor of Pediatrics and Population and Family Health at the Columbia University Medical Center; Associate Dean for Student Diversity, Inclusion and Belonging",
    slug: "david-bell",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Cassandra",
    lastName: "Bell",
    title: "Digital Image Specialist",
    slug: "cassandra-bell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "William",
    lastName: "Bell Jr",
    title: "Porter",
    slug: "william-bell-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zachary",
    lastName: "Bellacero",
    title: "Service Specialist",
    slug: "zachary-bellacero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacey",
    lastName: "Bellamy",
    title: "Administrative Manager",
    slug: "stacey-bellamy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua A.",
    lastName: "Bellis",
    title: "Lectuter in Professional Studies",
    slug: "joshua-a-bellis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Luis",
    lastName: "Bello",
    title: "Deputy Chief Information Officer",
    slug: "luis-bello",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kendra",
    lastName: "Bellonio",
    title: "Associate Director, Generalist",
    slug: "kendra-bellonio",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tatiana",
    lastName: "Beloborodov",
    title: "Administrative Coordinator",
    slug: "tatiana-beloborodov",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shawn",
    lastName: "Belpanno",
    title: "Administrative Assistant",
    slug: "shawn-belpanno",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Beltran",
    title:
      " Social and Multimedia Specialist; Interim Associate Director of Communications and Marketing",
    slug: "david-beltran",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nataly M",
    lastName: "Beltre",
    title: "Project Coordinator II",
    slug: "nataly-m-beltre",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lichinia N.",
    lastName: "Beltre",
    title: "Executive Director of Compliance",
    slug: "lichinia-n-beltre",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Darlene M",
    lastName: "Beltre",
    title: "Administrative Aide",
    slug: "darlene-m-beltre",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ronald Steven",
    lastName: "Bembry",
    title: "Assistant Director of Annual Giving, SIPA",
    slug: "ronald-steven-bembry",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gideon",
    lastName: "Ben-David",
    title: "Sr Accounting Officer, Indirect Cost",
    slug: "gideon-ben-david",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrea",
    lastName: "Benavides",
    title: "Project Coordinator II",
    slug: "andrea-benavides",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Humberto F",
    lastName: "Benavides Jr",
    title: "Credentialing Coordinator",
    slug: "humberto-f-benavides-jr",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Julia S",
    lastName: "Bender",
    title: "Program Manager - MA Progams",
    slug: "julia-s-bender",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Astrid M.",
    lastName: "Benedek",
    title: "Associate Director",
    slug: "astrid-m-benedek",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen I.",
    lastName: "Benedetto",
    title: "Administrative Assistant",
    slug: "karen-i-benedetto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brooke A.",
    lastName: "Benedetto",
    title: "Assistant Director, Strat Init",
    slug: "brooke-a-benedetto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anne Marie S",
    lastName: "Benedicto",
    title: "Chief of Staff",
    slug: "anne-marie-s-benedicto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard E",
    lastName: "Benitez",
    title: "Project Manager",
    slug: "richard-e-benitez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nathalie",
    lastName: "Benitez",
    title: "Manager - Operations",
    slug: "nathalie-benitez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Junior M.",
    lastName: "Benjamin",
    title: "Director, Community Outreach and Human Resources Manager",
    slug: "junior-m-benjamin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Emily Jane",
    lastName: "Benjamin",
    title: "Administrative Assistant",
    slug: "emily-jane-benjamin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Spencer C.",
    lastName: "Bennett",
    title: "Director, Compliance/Training",
    slug: "spencer-c-bennett",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Laura",
    lastName: "Bennett",
    title: "Senior Director, Instruction and Curriculum for Pre-College",
    slug: "laura-bennett",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zoe",
    lastName: "Bentley",
    title: "Assistant Director, Donor Relations and Stewardship",
    slug: "zoe-bentley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward",
    lastName: "Bentlyewski",
    title: "Asst Dir, Clin Res Nur & Qual",
    slug: "edward-bentlyewski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine Day",
    lastName: "Benvenuto",
    title:
      " Associate Dean for Development and Alumni Relations, School of International and Public Affairs (SIPA)",
    slug: "katherine-day-benvenuto",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel",
    lastName: "Benvenuto",
    title: "Director, Marketing Optimization and Integration",
    slug: "daniel-benvenuto",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristin L.",
    lastName: "Benzinger",
    title: "Executive Director, The President's House and Operations",
    slug: "kristin-l-benzinger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lex",
    lastName: "Berezhny",
    title: "Consultant",
    slug: "lex-berezhny",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alicia",
    lastName: "Bergdolt-Batista",
    title: "Senior Project Officer",
    slug: "alicia-bergdolt-batista",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William J",
    lastName: "Berger",
    title: "Assistant Vice President, Sponsored Projects Administration",
    slug: "william-j-berger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephanie R.",
    lastName: "Berger",
    title: "Sr Director - Media Relations",
    slug: "stephanie-r-berger",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer H",
    lastName: "Berger",
    title: "Office Manager",
    slug: "jennifer-h-berger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie",
    lastName: "Berger",
    title: "Assistant Director",
    slug: "julie-berger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Howard",
    lastName: "Berger",
    title: "Director, Benefits Systems",
    slug: "howard-berger",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Eyal",
    lastName: "Bergmann Harari",
    title: "Research Collaborator",
    slug: "eyal-bergmann-harari",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Bergren",
    title: "Sr Manager,IHN Edu Initiatives",
    slug: "sarah-bergren",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanuela",
    lastName: "Berhane",
    title: "Human Resources Generalist",
    slug: "amanuela-berhane",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Monique",
    lastName: "Berkley",
    title: "Director of Content Strategy",
    slug: "monique-berkley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Evgenia",
    lastName: "Berkovich",
    title: "Divisional Admin",
    slug: "evgenia-berkovich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yvette",
    lastName: "Berland",
    title: "Executive Assistant",
    slug: "yvette-berland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mikhail",
    lastName: "Berlyant",
    title: "Grants Administrator",
    slug: "mikhail-berlyant",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elyse",
    lastName: "Berman",
    title: "Division Administrator",
    slug: "elyse-berman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sherry",
    lastName: "Bermeo",
    title: "Senior Associate, Business Development",
    slug: "sherry-bermeo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vladimir P.",
    lastName: "Bermudez",
    title: "Assoc Dir, Program Management",
    slug: "vladimir-p-bermudez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sandra",
    lastName: "Bernal Garcia",
    title: "Associate Dean for Student Affairs",
    slug: "sandra-bernal-garcia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Justin V",
    lastName: "Bernardo",
    title: "Director of Ops and Rev Cycle",
    slug: "justin-v-bernardo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charlene A.",
    lastName: "Bernasko-Acquaye",
    title: "Director of Graduate Student Wellness and Support Services",
    slug: "charlene-a-bernasko-acquaye",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tania Lee",
    lastName: "Bernhardt",
    title: "Family Navigator",
    slug: "tania-lee-bernhardt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Berenis",
    lastName: "Berrido",
    title: "Manager, HR & FA",
    slug: "berenis-berrido",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nathaly",
    lastName: "Berrio-Diaz",
    title: "Exhibition Coordinator and Registrar",
    slug: "nathaly-berrio-diaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Berrios",
    title: "Financial Aid Officer",
    slug: "andrew-berrios",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Irma",
    lastName: "Berrios-Rosario",
    title: "Sr. Administrative Coordinator",
    slug: "irma-berrios-rosario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robbie",
    lastName: "Berry",
    title:
      " Associate Director of Digital Accessibility and Deaf & Hard of Hearing Services",
    slug: "robbie-berry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joseph William",
    lastName: "Bersson",
    title: "NROTC Officer",
    slug: "joseph-william-bersson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin D",
    lastName: "Bertin-Mahieux",
    title: "Business Manager",
    slug: "caitlin-d-bertin-mahieux",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexis G",
    lastName: "Bertsch",
    title: "Administrative Assistant",
    slug: "alexis-g-bertsch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abigail S",
    lastName: "Beshkin",
    title: "Senior Associate Director, Communications and Programs",
    slug: "abigail-s-beshkin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jeanine",
    lastName: "Bess",
    title: "Referral and Authorization Specialist II",
    slug: "jeanine-bess",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hattie Nelle",
    lastName: "Bestul",
    title: "Assistant Director",
    slug: "hattie-nelle-bestul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miriam K",
    lastName: "Beyer",
    title: "Director of Communications",
    slug: "miriam-k-beyer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Medha R.",
    lastName: "Bhalodkar",
    title: "CISO and Associate VP Enterprise Risk Management",
    slug: "medha-r-bhalodkar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Archana",
    lastName: "Bharathan",
    title: "Director of Outcomes",
    slug: "archana-bharathan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Manisha",
    lastName: "Bhardwaj",
    title: "Generalist, HR/FA",
    slug: "manisha-bhardwaj",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sujata",
    lastName: "Bhat",
    title: "CPRL Contractor",
    slug: "sujata-bhat",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Annette",
    lastName: "Bhatia",
    title: "Associate Dean, Continuing Education",
    slug: "annette-bhatia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Krish J.",
    lastName: "Bhatt",
    title: "Research Project Coordinator",
    slug: "krish-j-bhatt",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Diya",
    lastName: "Bhattacharya",
    title: "Senior Executive Director",
    slug: "diya-bhattacharya",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sukhada",
    lastName: "Bhave",
    title: "Alliance Manager",
    slug: "sukhada-bhave",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lutfur R.",
    lastName: "Bhuiya",
    title: "Senior Systems Manager",
    slug: "lutfur-r-bhuiya",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tania",
    lastName: "Bhuiyan",
    title: "Division Administrator",
    slug: "tania-bhuiyan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kiran J.",
    lastName: "Bhujle",
    title: "Academic Program Support in Professional Studies",
    slug: "kiran-j-bhujle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Aidi",
    lastName: "Bian",
    title: "Service Provider",
    slug: "aidi-bian",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jamie",
    lastName: "Bie",
    title: "Senior MSK Ultrasound Specialist",
    slug: "jamie-bie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Helen L.",
    lastName: "Bielak",
    title: "Operations Manager",
    slug: "helen-l-bielak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mairin T.",
    lastName: "Bierer",
    title:
      " Associate Director, Development Programs for the Arts and Sciences/Columbia College",
    slug: "mairin-t-bierer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy Lynn",
    lastName: "Biggi",
    title: "Senior Data Manager",
    slug: "amy-lynn-biggi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stacy M",
    lastName: "Bile",
    title: "Assistant Director-Intl Student Engagement",
    slug: "stacy-m-bile",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kalif",
    lastName: "Billet",
    title: "Administrative Clerk",
    slug: "kalif-billet",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Genia B.",
    lastName: "Billote",
    title: "Executive Director, GMO",
    slug: "genia-b-billote",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua Rene Plamo",
    lastName: "Binag",
    title: "Live Support Specialist",
    slug: "joshua-rene-plamo-binag",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rezarta",
    lastName: "Binaj",
    title: "Assoc Director-Academic Admin",
    slug: "rezarta-binaj",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marva",
    lastName: "Binns",
    title: "Assistant Director, Columbia College Finance",
    slug: "marva-binns",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lucas M",
    lastName: "Bird",
    title: "Associate Director",
    slug: "lucas-m-bird",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erik J.",
    lastName: "Bird",
    title: "Assistant Director of Data Management & Reporting",
    slug: "erik-j-bird",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Beth",
    lastName: "Bird",
    title: "Director - Professional Educ",
    slug: "beth-bird",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "Birmingham",
    title: "Senior Executive Director, Communications and Creative Services",
    slug: "jennifer-birmingham",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Zachary",
    lastName: "Biron",
    title: "Administrative Coordinator",
    slug: "zachary-biron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chantal",
    lastName: "Bisono",
    title: "Admissions Assistant",
    slug: "chantal-bisono",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Veronica",
    lastName: "Bjorkman",
    title: "Director of Family Outreach and Support",
    slug: "veronica-bjorkman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Reed",
    lastName: "Black",
    title: "Manager, Research Administration",
    slug: "reed-black",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kate",
    lastName: "Black",
    title: "Director, Programs and Partners, Dart Center",
    slug: "kate-black",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gennet",
    lastName: "Black",
    title: "Senior Assistant Dean of Academic Programs",
    slug: "gennet-black",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christina",
    lastName: "Black",
    title: "Budget Director",
    slug: "christina-black",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrew C.",
    lastName: "Black",
    title: "Manager, Finance/Research Ops",
    slug: "andrew-c-black",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hasani",
    lastName: "Blackwell",
    title: "Director, Technology",
    slug: "hasani-blackwell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeremy Feiner",
    lastName: "Blair",
    title: "Associate Service Specialist",
    slug: "jeremy-feiner-blair",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joyce R.",
    lastName: "Blair",
    title: "Administrative Assistant",
    slug: "joyce-r-blair",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew C",
    lastName: "Blair",
    title: "Finance and Compliance Manager, Sponsored Projects Finance",
    slug: "andrew-c-blair",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Philip",
    lastName: "Blake",
    title: "Senior Director, End User Computing and Email Systems",
    slug: "philip-blake",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elyse",
    lastName: "Blake",
    title: "Department Secretary",
    slug: "elyse-blake",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Debbie E",
    lastName: "Blake",
    title: "Assistant Director, Finance and Compliance SPF",
    slug: "debbie-e-blake",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Luis V",
    lastName: "Blanco",
    title: "Project Coordinator II",
    slug: "luis-v-blanco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Blanco",
    title: "Contractor",
    slug: "kyle-blanco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elvira Eloisa",
    lastName: "Blanco",
    title: "Managing Editor",
    slug: "elvira-eloisa-blanco",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Caroline Grace",
    lastName: "Blank",
    title: "Major Gifts Officer, General Studies and Arts & Sciences",
    slug: "caroline-grace-blank",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley Lindsay",
    lastName: "Blasland",
    title: "Senior Associate Director of Admissions",
    slug: "ashley-lindsay-blasland",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Corrie Lynn",
    lastName: "Blatt",
    title: "Senior Director, Operations",
    slug: "corrie-lynn-blatt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley E",
    lastName: "Bleam",
    title: "Director, Alumni Events and Programs",
    slug: "ashley-e-bleam",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jordan R",
    lastName: "Blitzer",
    title: "Director, Admissions Strategic Projects",
    slug: "jordan-r-blitzer",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Hana O.",
    lastName: "Bloch",
    title: "Director, Leave Management",
    slug: "hana-o-bloch",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Laura M",
    lastName: "Block",
    title: "Deputy Director,Ops&Mgmt,CQUIN",
    slug: "laura-m-block",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine R.",
    lastName: "Block",
    title: "Director, Rsch Prosp. Mgmt",
    slug: "catherine-r-block",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Steven H.",
    lastName: "Blomgren",
    title: "Senior Director of Business Development and Corporate Partnerships",
    slug: "steven-h-blomgren",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael J.",
    lastName: "Bloom",
    title: "Assoc Vice President -Benefits",
    slug: "michael-j-bloom",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Katherine Kim",
    lastName: "Bloom",
    title: "Director, East Coast Gifting",
    slug: "katherine-kim-bloom",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colleen Erin",
    lastName: "Bloom",
    title: "Program Manager, Center for Prolonged Grief",
    slug: "colleen-erin-bloom",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Darrell P.",
    lastName: "Blount",
    title: "Administrative Assistant",
    slug: "darrell-p-blount",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adrienne D.",
    lastName: "Blount",
    title: "Director of Case Management",
    slug: "adrienne-d-blount",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cedric Kim",
    lastName: "Blue II",
    title: "Associate Director, CAA Arts Access",
    slug: "cedric-kim-blue-ii",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessica Carroll",
    lastName: "Blum-Destefano",
    title: "Interim Hourly",
    slug: "jessica-carroll-blum-destefano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sonia",
    lastName: "Blunte",
    title: "Associate-Engage & Enrichment",
    slug: "sonia-blunte",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Benjamin",
    lastName: "Boafo",
    title: "RN - IR 51st Street",
    slug: "benjamin-boafo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas H",
    lastName: "Boag",
    title: "Director of Decanal Affairs",
    slug: "thomas-h-boag",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marie",
    lastName: "Bobadilla",
    title: "Surgical Scheduler",
    slug: "marie-bobadilla",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peninnah",
    lastName: "Bobrow-Simms",
    title: "Assistant Category Manager",
    slug: "peninnah-bobrow-simms",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ramon",
    lastName: "Bocarro",
    title: "Director, Travel and Expense Management",
    slug: "ramon-bocarro",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hans C. Tobias",
    lastName: "Bock",
    title: "Siegelbaum PDRS Alum",
    slug: "hans-c-tobias-bock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steffen A",
    lastName: "Boddeker",
    title: "Associate Dean of Admissions and Outreach",
    slug: "steffen-a-boddeker",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Melanie",
    lastName: "Boellinger",
    title: "Financial Assistant",
    slug: "melanie-boellinger",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amber",
    lastName: "Bogdewiecz",
    title: "Assistant Director, Division Administration - Academic Affairs",
    slug: "amber-bogdewiecz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ashley A",
    lastName: "Bogosian",
    title: "Director, Research Admin",
    slug: "ashley-a-bogosian",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alla",
    lastName: "Bogoslavskaya",
    title: "Accountant",
    slug: "alla-bogoslavskaya",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patrick F.",
    lastName: "Bohan",
    title: "Senior Associate Dean",
    slug: "patrick-f-bohan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erikka",
    lastName: "Bohm",
    title: "Quality Improvement Coord",
    slug: "erikka-bohm",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John G",
    lastName: "Bohn",
    title: "Assistant Director, Communication and Marketing",
    slug: "john-g-bohn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Antony",
    lastName: "Bolante",
    title: "Marketing Production Traffic Manager",
    slug: "antony-bolante",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Luz M.",
    lastName: "Bolivar",
    title: "Research Administrator I",
    slug: "luz-m-bolivar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ursula A.",
    lastName: "Bollini",
    title: "Senior Director, HR Compliance",
    slug: "ursula-a-bollini",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Inna",
    lastName: "Boluk",
    title: "Administrative Assistant",
    slug: "inna-boluk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamie M.",
    lastName: "Bonadonna-Van Beverhoudt",
    title: "Deputy Director, Procurement",
    slug: "jamie-m-bonadonna-van-beverhoudt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sylvia",
    lastName: "Bonaparte",
    title: "Asst Director, Ger Pnt Outrch",
    slug: "sylvia-bonaparte",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brandi Danielle",
    lastName: "Bonaparte",
    title: "Director of Human Resources",
    slug: "brandi-danielle-bonaparte",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alexis L.",
    lastName: "Boncy",
    title:
      " Director of Editorial Strategy and Content, and Editor-in-Chief; CCT",
    slug: "alexis-l-boncy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ashley Renee",
    lastName: "Bonds",
    title: "Asst Director, Enrollment/Ops",
    slug: "ashley-renee-bonds",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Emi",
    lastName: "Bonet",
    title: "Temp Financial Aid Coordinator",
    slug: "emi-bonet",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Denise Marie",
    lastName: "Boneta",
    title: "Senior Executive Director, Student Affairs",
    slug: "denise-marie-boneta",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Humberto",
    lastName: "Bonfante",
    title: "Senior Director",
    slug: "humberto-bonfante",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria Andrea",
    lastName: "Boniao Kern",
    title: "Data Entry and Billing Clerk",
    slug: "maria-andrea-boniao-kern",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maura",
    lastName: "Bonini",
    title: "Assistant Director, Admissions and Recruitment",
    slug: "maura-bonini",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jamie Grace",
    lastName: "Bonito",
    title: "Coding Specialist",
    slug: "jamie-grace-bonito",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bonnie J.",
    lastName: "Bonkowski",
    title: "Division Administrator",
    slug: "bonnie-j-bonkowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laurie M.",
    lastName: "Boockvar",
    title: "Senior Associate Director, MBA Career Education and Advising",
    slug: "laurie-m-boockvar",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brittany M.",
    lastName: "Booker",
    title: "Coordinator",
    slug: "brittany-m-booker",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer",
    lastName: "Boone-Waldron",
    title: "Assistant Director, Student Accounts Refunds & Operations",
    slug: "jennifer-boone-waldron",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gabriel",
    lastName: "Boratgis",
    title: "Project Coordinator II",
    slug: "gabriel-boratgis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julissa Georgina",
    lastName: "Borbon-Marcelin",
    title: "IRB Specialist",
    slug: "julissa-georgina-borbon-marcelin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joanna",
    lastName: "Borchert-Kopczuk",
    title: "Administrative Manager",
    slug: "joanna-borchert-kopczuk",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cindy Gabriela",
    lastName: "Borgen",
    title: "Coordinator-Acad/Student Affs",
    slug: "cindy-gabriela-borgen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maryann",
    lastName: "Borgognone",
    title: "Assistant Director for Registration and Billing",
    slug: "maryann-borgognone",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Honeira",
    lastName: "Borjas",
    title: "Billing Manager",
    slug: "honeira-borjas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nina Marcia",
    lastName: "Borland",
    title: "Creative and Instructional Designer",
    slug: "nina-marcia-borland",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dmitriy",
    lastName: "Borovtsov",
    title: "System Administrator",
    slug: "dmitriy-borovtsov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Angelica",
    lastName: "Borrero",
    title:
      " Assistant Registrar, Classroom Management and Digital Communication",
    slug: "angelica-borrero",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stanislav",
    lastName: "Borukhovich",
    title: "Senior Application Systems Developer (Mainframe)",
    slug: "stanislav-borukhovich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pilar",
    lastName: "Borvice",
    title: "Sr IRB Specialist/Sr Manager",
    slug: "pilar-borvice",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren",
    lastName: "Bos",
    title: "Orthopedic PT Resident",
    slug: "lauren-bos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amilcar Andres",
    lastName: "Boscan Bello",
    title: "Audio Visual Coordinator",
    slug: "amilcar-andres-boscan-bello",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Greta",
    lastName: "Bosello",
    title: "Program Manager",
    slug: "greta-bosello",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carlos",
    lastName: "Bosque",
    title: "Bayview",
    slug: "carlos-bosque",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Bossio",
    title: "Chief Information Officer, CUIMC",
    slug: "james-bossio",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Idelsi Y.",
    lastName: "Botex",
    title: "Director, Administration",
    slug: "idelsi-y-botex",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marilena",
    lastName: "Botoulas",
    title: "Associate Dean for Curriculum and Programs",
    slug: "marilena-botoulas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gaelle",
    lastName: "Bottex",
    title: "Program Assistant",
    slug: "gaelle-bottex",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martina",
    lastName: "Botti",
    title: "Editorial Coordinator",
    slug: "martina-botti",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gina M",
    lastName: "Boubion-Ryan",
    title: "Director, Career Services",
    slug: "gina-m-boubion-ryan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tessa Heyliger",
    lastName: "Bouche",
    title: "Executive Assistant",
    slug: "tessa-heyliger-bouche",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Albert G.",
    lastName: "Boulanger",
    title: "Senior Data Architect",
    slug: "albert-g-boulanger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rattana",
    lastName: "Bounsouaysana",
    title: "Administrative Coordinator",
    slug: "rattana-bounsouaysana",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mercy",
    lastName: "Bourdet",
    title: "Senior Admissions Specialist",
    slug: "mercy-bourdet",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kristine Magdalene",
    lastName: "Bourdier",
    title: "Project Coordinator II",
    slug: "kristine-magdalene-bourdier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daysi J",
    lastName: "Bourekas",
    title: "Administrative Associate",
    slug: "daysi-j-bourekas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ann K.",
    lastName: "Bourns",
    title: "Director, Project Management",
    slug: "ann-k-bourns",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andres",
    lastName: "Boutin",
    title: "Bayview Tech",
    slug: "andres-boutin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joanne",
    lastName: "Boutsikos",
    title: "Lead Accounts Clerk",
    slug: "joanne-boutsikos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joediann K",
    lastName: "Bowen",
    title: "Admin Supv&Pain Ctr Bll Spclst",
    slug: "joediann-k-bowen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shellianne",
    lastName: "Bowens-Ells",
    title: "Assoc Dir, Service Management",
    slug: "shellianne-bowens-ells",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Megan M",
    lastName: "Bowes",
    title: "Assoc Director, Clin Proj Mgmt",
    slug: "megan-m-bowes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie M",
    lastName: "Bowman",
    title: "Executive Assistant",
    slug: "stephanie-m-bowman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Satrina Willeth White",
    lastName: "Boyce",
    title: "Assistant Director of Development",
    slug: "satrina-willeth-white-boyce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley A",
    lastName: "Boyce",
    title: "Manager, Staff Engagement",
    slug: "ashley-a-boyce",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dennis",
    lastName: "Boyd Jr",
    title: "Live Support Specialist",
    slug: "dennis-boyd-jr",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "James R.",
    lastName: "Braddock",
    title: "Mitchell Giurgola Architects",
    slug: "james-r-braddock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam M",
    lastName: "Bradford",
    title: "Director, Prospect Development",
    slug: "adam-m-bradford",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jason",
    lastName: "Bradley",
    title: "Financial Services Assistant",
    slug: "jason-bradley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Courtney L.",
    lastName: "Bradley",
    title: "Audio Visual Specialist",
    slug: "courtney-l-bradley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chanda",
    lastName: "Bradshaw",
    title: "Administrative Aide",
    slug: "chanda-bradshaw",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew P",
    lastName: "Brady",
    title: "Director, Financial Aid Operations and Loan Services",
    slug: "matthew-p-brady",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Deirdre",
    lastName: "Brady",
    title: "Senior Assistant Dean for Academic Affairs",
    slug: "deirdre-brady",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lucia",
    lastName: "Bragg",
    title: "Project Manager",
    slug: "lucia-bragg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Saarah",
    lastName: "Braithwaite",
    title: "Development Assistant, Columbia College and Arts & Sciences",
    slug: "saarah-braithwaite",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisette M",
    lastName: "Braman",
    title: "Program Manager",
    slug: "lisette-m-braman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Branch",
    title: "Executive Director Digital, Video Services",
    slug: "robert-branch",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Brandoff",
    title: "Assoc Director-Contracts",
    slug: "sarah-brandoff",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jeanne",
    lastName: "Brandt",
    title: "Administrative Coordinator",
    slug: "jeanne-brandt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Russell A",
    lastName: "Brandwein",
    title: "Director",
    slug: "russell-a-brandwein",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Anna",
    lastName: "Braude",
    title: "Executive Assistant",
    slug: "anna-braude",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca Marie",
    lastName: "Braun-Slife",
    title: "Assoc Director-Stud Advising",
    slug: "rebecca-marie-braun-slife",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "James Eric",
    lastName: "Bravo",
    title: "Admissions Asociate, Admissions",
    slug: "james-eric-bravo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Melanie I.",
    lastName: "Brazil",
    title: "Chief of Staff, Precision Medicine Initiative",
    slug: "melanie-i-brazil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander M.",
    lastName: "Breck",
    title: "Assistant Technical Director",
    slug: "alexander-m-breck",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jason A",
    lastName: "Breiterman",
    title: "Accountant",
    slug: "jason-a-breiterman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matthew W",
    lastName: "Brennan",
    title: "Assistant ICM Facility Manager",
    slug: "matthew-w-brennan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace Kathryn",
    lastName: "Brennan",
    title: "Program Associate",
    slug: "grace-kathryn-brennan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan L",
    lastName: "Brenner-Morton",
    title: "Senior Science Officer",
    slug: "susan-l-brenner-morton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jill Elizabeth",
    lastName: "Brennick",
    title: "Administrative Assistant",
    slug: "jill-elizabeth-brennick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shani Shalev",
    lastName: "Bretas",
    title: "CPRE Deputy Director",
    slug: "shani-shalev-bretas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mariela",
    lastName: "Breton",
    title: "Assistant Director",
    slug: "mariela-breton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristian",
    lastName: "Breton",
    title: "Executive Director of Outreach and Community Engagement",
    slug: "kristian-breton",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marianna",
    lastName: "Breytman",
    title: "Sr Education Tech Specialist",
    slug: "marianna-breytman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Devorah",
    lastName: "Brickman",
    title: "Adult Diabetes Educator",
    slug: "devorah-brickman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer M",
    lastName: "Bridie",
    title: "Assistant Manager, L&D Design and Marketing",
    slug: "jennifer-m-bridie",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Chloe Swain",
    lastName: "Brighton",
    title: "Director of Investigation, Student Discrimination/Harassment",
    slug: "chloe-swain-brighton",
    dei: true,
    category: "Legal",
  },
  {
    firstName: "Maeve",
    lastName: "Brin",
    title: "Assistant Manager",
    slug: "maeve-brin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cheyenne",
    lastName: "Brisman",
    title: "SYEP",
    slug: "cheyenne-brisman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin",
    lastName: "Bristow",
    title: "Asst Dean, External Relations",
    slug: "caitlin-bristow",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andys M",
    lastName: "Brito",
    title: "Director of Human Resources",
    slug: "andys-m-brito",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mary Eliana",
    lastName: "Brito Espejo",
    title: "Case Manager, Social Services",
    slug: "mary-eliana-brito-espejo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Debra S.",
    lastName: "Britt",
    title: "Business Services Coordinator",
    slug: "debra-s-britt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Davima",
    lastName: "Broadbelt Clarke",
    title: "Director of Human Resources",
    slug: "davima-broadbelt-clarke",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Thomas Wayne",
    lastName: "Brock",
    title: "Director, Community College Research Center",
    slug: "thomas-wayne-brock",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tracy",
    lastName: "Brockman-Diaz",
    title: "Associate Director, Finance Human Resources",
    slug: "tracy-brockman-diaz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tina M.",
    lastName: "Broco",
    title: "Administrative Clerk",
    slug: "tina-m-broco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yamaris Gabriela",
    lastName: "Brodsky",
    title: "Deputy Chief Operating Officer",
    slug: "yamaris-gabriela-brodsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bess",
    lastName: "Brodsky",
    title: "Career Industry Alumni Consultant, Sports Management",
    slug: "bess-brodsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sivan Shaltiel",
    lastName: "Bromberg",
    title: "Program Evaluations Manager",
    slug: "sivan-shaltiel-bromberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barry N.",
    lastName: "Broner",
    title: "Associate Director, Billing and Student Accounts",
    slug: "barry-n-broner",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Taylor S.",
    lastName: "Bronson",
    title: "Paralegal",
    slug: "taylor-s-bronson",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Marsha A",
    lastName: "Brooks",
    title: "Administrative Assistant",
    slug: "marsha-a-brooks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Esther JT",
    lastName: "Brot",
    title: "Grant & Research Dev Associate",
    slug: "esther-jt-brot",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Conor",
    lastName: "Broughan",
    title: "Eastern Sales Representative",
    slug: "conor-broughan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tricia Ann",
    lastName: "Brown",
    title: "Program Manager - Academic Affairs",
    slug: "tricia-ann-brown",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Thomas",
    lastName: "Brown",
    title: "Senior Category Manager, Events and Contracts",
    slug: "thomas-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy Dwyer",
    lastName: "Brown",
    title: "Administrative Coordinator",
    slug: "nancy-dwyer-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maurquise L.",
    lastName: "Brown",
    title: "Ordinary Seaperson",
    slug: "maurquise-l-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael Lamar",
    lastName: "Brown",
    title: "Media Producer",
    slug: "michael-lamar-brown",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Matthew B",
    lastName: "Brown",
    title: "AVP, Financial Planning",
    slug: "matthew-b-brown",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leigh E.",
    lastName: "Brown",
    title: "Administrative Assistant",
    slug: "leigh-e-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katima",
    lastName: "Brown",
    title: "Registration Services Manager, Exams",
    slug: "katima-brown",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jasmine T.",
    lastName: "Brown",
    title: "Senior Director of Strategic Initiatives",
    slug: "jasmine-t-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan",
    lastName: "Brown",
    title: "Senior Service Specialist",
    slug: "jonathan-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dane",
    lastName: "Brown",
    title: "Multi-Ctr Clin Res Coor II",
    slug: "dane-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Brown",
    title: "Lead Application Systems Developer",
    slug: "david-brown",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chevette J",
    lastName: "Brown",
    title: "Secretary B",
    slug: "chevette-j-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam S.",
    lastName: "Brown",
    title: "Associate Director, Soler",
    slug: "adam-s-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adrian Stefan",
    lastName: "Brown",
    title: "Senior Assistant Dean",
    slug: "adrian-stefan-brown",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Audrey Lynne",
    lastName: "Brown",
    title: "Associate Vice President, Student Financial Services",
    slug: "audrey-lynne-brown",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ashlee",
    lastName: "Brown",
    title: "Asst Director, Social Media",
    slug: "ashlee-brown",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emily F",
    lastName: "Brown-Baker",
    title: "Administrative Coordinator",
    slug: "emily-f-brown-baker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gavin",
    lastName: "Browning",
    title: "Director of Public Programs and Engagement",
    slug: "gavin-browning",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mariella A",
    lastName: "Broyles",
    title: "Program Manager",
    slug: "mariella-a-broyles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Brucas",
    title: "Associate Director",
    slug: "jessica-brucas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matt A.",
    lastName: "Bruderle",
    title: "Senior Program Manager",
    slug: "matt-a-bruderle",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melody",
    lastName: "Brumfield",
    title: "Chief of Staff",
    slug: "melody-brumfield",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Will",
    lastName: "Brumley",
    title: "Executive Assistant, University Development",
    slug: "will-brumley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea Stephanie",
    lastName: "Brunetti",
    title: "Service Provider",
    slug: "andrea-stephanie-brunetti",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Benjamin A",
    lastName: "Brusilovsky",
    title: "ServiceNow Administrator",
    slug: "benjamin-a-brusilovsky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Clive",
    lastName: "Bryan",
    title: "Echo Tech Manager II",
    slug: "clive-bryan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alma",
    lastName: "Bryan",
    title: "Customer Service Representative",
    slug: "alma-bryan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rob",
    lastName: "Bryant",
    title: "Brickman Miller UI",
    slug: "rob-bryant",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bianca J",
    lastName: "Bryson",
    title: "Assistant Director, Employer and Alumni Relations",
    slug: "bianca-j-bryson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Arun",
    lastName: "Bryson",
    title: "Manager, Admin",
    slug: "arun-bryson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carmen Luisa",
    lastName: "Bu",
    title: "Sr Community Outreach Coord",
    slug: "carmen-luisa-bu",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Allison V",
    lastName: "Buba",
    title: "Deputy Director, Research",
    slug: "allison-v-buba",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephen",
    lastName: "Buchman",
    title: "Associate Director of Career Advising",
    slug: "stephen-buchman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erik",
    lastName: "Buckholz",
    title: "Senior Director of Administration and HR",
    slug: "erik-buckholz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nicole Lauren",
    lastName: "Buckley",
    title: "Associate Director, Student Life and Engagement",
    slug: "nicole-lauren-buckley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Janae A",
    lastName: "Buege-McClain",
    title:
      " Senior Associate Director of Residential Life & The First Year Area",
    slug: "janae-a-buege-mcclain",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gerard I.",
    lastName: "Bueno",
    title: "Senior Associate Dean for Administration, Finance and Planning",
    slug: "gerard-i-bueno",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gladys I.",
    lastName: "Bueso",
    title: "Program Administrator",
    slug: "gladys-i-bueso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Bukhari",
    title: "Director of Academic Adminstration and Finance",
    slug: "kyle-bukhari",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kara",
    lastName: "Buller",
    title: "Administrative Assistant",
    slug: "kara-buller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Bullis",
    title: "Asst Dir, Enrollment Programs",
    slug: "jennifer-bullis",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Johnathan",
    lastName: "Bun",
    title: "Dea Mama Employee",
    slug: "johnathan-bun",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lorna",
    lastName: "Buntin",
    title: "Revenue Cycle Lead",
    slug: "lorna-buntin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Debbie",
    lastName: "Buonamano",
    title: "Assistant Manager",
    slug: "debbie-buonamano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Buonomo",
    title: "General Manager",
    slug: "scott-buonomo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie B.",
    lastName: "Buraczewski",
    title: "Coordinator-Fieldwork & Admiss",
    slug: "stephanie-b-buraczewski",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Megan M",
    lastName: "Burak",
    title: "Director of Internal Content",
    slug: "megan-m-burak",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Reina Y",
    lastName: "Burdie",
    title: "Department Administrator",
    slug: "reina-y-burdie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia",
    lastName: "Burgdorff",
    title: "Program Assistant",
    slug: "julia-burgdorff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Burger",
    title: "Senior Director of Development",
    slug: "sarah-burger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanna J",
    lastName: "Burghardt",
    title: "Variable Hour Officer",
    slug: "joanna-j-burghardt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandra",
    lastName: "Burgos",
    title: "Secretary/Biller",
    slug: "sandra-burgos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Priscilla",
    lastName: "Burgos",
    title: "Administrative Coordinator",
    slug: "priscilla-burgos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juan Orlando",
    lastName: "Burgos",
    title: "Service Specialist",
    slug: "juan-orlando-burgos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aisha Liz",
    lastName: "Burgos",
    title: "Administrative Clerk",
    slug: "aisha-liz-burgos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "Burgos Santana",
    title: "Assistant Director of Internal Events",
    slug: "karen-burgos-santana",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Thomas",
    lastName: "Burke",
    title: "Assistant Manager of Shipping & Receiving",
    slug: "thomas-burke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly R",
    lastName: "Burke",
    title: "Assistant Director, Operations",
    slug: "kimberly-r-burke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathryn Mae",
    lastName: "Burke",
    title: "Project Officer",
    slug: "kathryn-mae-burke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen A.",
    lastName: "Burke",
    title: "Director-Human Resources/Ops",
    slug: "karen-a-burke",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "John",
    lastName: "Burke",
    title: "Manager, FFE Applications",
    slug: "john-burke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Burke",
    title: "Authorization and Referrals Specialist II",
    slug: "emily-burke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexandra G.",
    lastName: "Burkhart",
    title: "Administrative Manager",
    slug: "alexandra-g-burkhart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kira Jayne N",
    lastName: "Burkhauser",
    title: "Manager of Operations and Administrative Services",
    slug: "kira-jayne-n-burkhauser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha",
    lastName: "Burnham",
    title: "Assistant Director, Student Life",
    slug: "samantha-burnham",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aspasia M.",
    lastName: "Burnworth",
    title: "Manager, Financial Administration",
    slug: "aspasia-m-burnworth",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kendra",
    lastName: "Burpee",
    title: "Senior Associate Director, Learning Solutions",
    slug: "kendra-burpee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brianna E",
    lastName: "Bursey",
    title: "Executive Assistant and Special Projects Manager",
    slug: "brianna-e-bursey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda V",
    lastName: "Busacca",
    title: "Senior Program Manager",
    slug: "linda-v-busacca",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephanie",
    lastName: "Busch",
    title: "Associate Director, Student Life",
    slug: "stephanie-busch",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Erin C.",
    lastName: "Bush",
    title: "Director, Single Cell Core",
    slug: "erin-c-bush",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Debbie Rosenberg",
    lastName: "Bush",
    title: "Director-Corp/Found Relations",
    slug: "debbie-rosenberg-bush",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander Daniel",
    lastName: "Bush",
    title: "Operations Manager",
    slug: "alexander-daniel-bush",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brady",
    lastName: "Bushover",
    title: "Project Coordinator I",
    slug: "brady-bushover",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laurence",
    lastName: "Butaud-Rebbaa",
    title: "Director, Triage/Outreach",
    slug: "laurence-butaud-rebbaa",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christine D.",
    lastName: "Butcher",
    title: "Associate Director, Center for the Core Curriculum",
    slug: "christine-d-butcher",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shante",
    lastName: "Butler",
    title: "Medix employee",
    slug: "shante-butler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Butler",
    title: "Assistant Director of Instructional Technology",
    slug: "david-butler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sherry",
    lastName: "Buxo",
    title: "Assistant Director, Gift Planning Operations",
    slug: "sherry-buxo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Addi",
    lastName: "Byas",
    title: "Sous Chef",
    slug: "addi-byas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John E",
    lastName: "Bylander",
    title: "Production Editor/ Electronic Publishing Specialst",
    slug: "john-e-bylander",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Colleen R",
    lastName: "Bynum",
    title: "Director, Neurodiagnostics",
    slug: "colleen-r-bynum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tijana",
    lastName: "Bzenic",
    title: "Assistant Director, Pre-Award Grant Management",
    slug: "tijana-bzenic",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rudy A",
    lastName: "Caba Jr.",
    title: "Event and Classroom Technology Specialist Lead",
    slug: "rudy-a-caba-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Diego F",
    lastName: "Cabaleiro",
    title: "Coordinator",
    slug: "diego-f-cabaleiro",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Steph",
    lastName: "Caballero",
    title: "Senior Associate Director of Alumni Relations",
    slug: "steph-caballero",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sara",
    lastName: "Caban",
    title: "CUIMC Assistant Director",
    slug: "sara-caban",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joyce Marie",
    lastName: "Cabel",
    title: "Support Staff",
    slug: "joyce-marie-cabel",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Maria Elena",
    lastName: "Cabral",
    title: "Assistant Dean, Student, and International Programs",
    slug: "maria-elena-cabral",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessi",
    lastName: "Cabreja",
    title: "Referral and Authorization Specialist II",
    slug: "jessi-cabreja",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nathan W.",
    lastName: "Cabrera",
    title: "Accounting Coordinator",
    slug: "nathan-w-cabrera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laura Patricia",
    lastName: "Cabrera",
    title: "Director, Financial Aid",
    slug: "laura-patricia-cabrera",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Juana L.",
    lastName: "Cabrera",
    title: "Business Manager",
    slug: "juana-l-cabrera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julissa",
    lastName: "Cabrera",
    title: "Executive Assistant",
    slug: "julissa-cabrera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward J.",
    lastName: "Cabrera",
    title: "Associate Director, EDM",
    slug: "edward-j-cabrera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Estephany",
    lastName: "Cabrera",
    title: "Senior Secretary",
    slug: "estephany-cabrera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amelia",
    lastName: "Cabrera",
    title: "Billing Specialist",
    slug: "amelia-cabrera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melissa",
    lastName: "Cabrero",
    title: "Assistant Director of Communications and Program Administration",
    slug: "melissa-cabrero",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephen Aniello",
    lastName: "Cacace",
    title: "Associate Director, Student Accounts",
    slug: "stephen-aniello-cacace",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andre",
    lastName: "Cadogan",
    title: "Senior Technical Specialist",
    slug: "andre-cadogan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Iuliana Cristina",
    lastName: "Caescu",
    title: "Exec Director, Research Ops",
    slug: "iuliana-cristina-caescu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joseph",
    lastName: "Caffentzis",
    title: "Associate Director, Marketing Production",
    slug: "joseph-caffentzis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathleen",
    lastName: "Cagnina",
    title: "Coordinator Administration and Events",
    slug: "kathleen-cagnina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carolyn",
    lastName: "Cai",
    title: "Research Lab Manager",
    slug: "carolyn-cai",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Juan C",
    lastName: "Caicedo",
    title: "Director, Infrastructure and Cloud Native Operations",
    slug: "juan-c-caicedo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ryan",
    lastName: "Cairns",
    title: "Associate Dean for Alumni and Development",
    slug: "ryan-cairns",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elliott Scott",
    lastName: "Cairns",
    title: "Designer",
    slug: "elliott-scott-cairns",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "George",
    lastName: "Calderaro",
    title: "Senior Associate Director, Auditing and Community Programs",
    slug: "george-calderaro",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shakira",
    lastName: "Calderon",
    title: "Senior Secretary",
    slug: "shakira-calderon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven",
    lastName: "Caldwell",
    title: "Simulation Assistant",
    slug: "steven-caldwell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Natiya M.",
    lastName: "Caldwell",
    title: "Human Resources, Project Specialist",
    slug: "natiya-m-caldwell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Claudia",
    lastName: "Cali",
    title: "Adjunct Assistant (MUSC)",
    slug: "claudia-cali",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marcela",
    lastName: "Calidonio",
    title: "Advising Dean",
    slug: "marcela-calidonio",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Molly Britt",
    lastName: "Calkins",
    title: "Director",
    slug: "molly-britt-calkins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicholas D.",
    lastName: "Call",
    title: "Coordinator of Marine Recruitment & Staffing",
    slug: "nicholas-d-call",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Carla Maria",
    lastName: "Call",
    title: "Assistant Director",
    slug: "carla-maria-call",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luis",
    lastName: "Calle",
    title: "Maintenance Manager",
    slug: "luis-calle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan M.",
    lastName: "Callo",
    title: "Assistant Director, University Programs and Events",
    slug: "susan-m-callo",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maria Angelina",
    lastName: "Calungcagin",
    title: "Accountant",
    slug: "maria-angelina-calungcagin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacqueline",
    lastName: "Camacho",
    title: "Associate Director of Operations and Outreach",
    slug: "jacqueline-camacho",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristina",
    lastName: "Camaj",
    title: "Director of Administration",
    slug: "kristina-camaj",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren",
    lastName: "Camara",
    title: "Creative Director",
    slug: "lauren-camara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cheiku",
    lastName: "Camara",
    title: "Associate Dean for Student Affairs and Enrollment",
    slug: "cheiku-camara",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Giuseppina",
    lastName: "Cambareri",
    title: "Administrative Assistant",
    slug: "giuseppina-cambareri",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keshia Danelle",
    lastName: "Cameron",
    title: "Social Worker, Achievement Institute",
    slug: "keshia-danelle-cameron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Camille J",
    lastName: "Cameron",
    title: "Administrative Coordinator",
    slug: "camille-j-cameron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cody",
    lastName: "Cameron",
    title: "Senior Biological Safety Officer",
    slug: "cody-cameron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christian",
    lastName: "Camilo",
    title: "Senior Manager, HR/ Payroll",
    slug: "christian-camilo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Enyi",
    lastName: "Camilo Caceres",
    title: "Revenue Cycle Manager",
    slug: "enyi-camilo-caceres",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Angela Fay Malaguino",
    lastName: "Cammayo",
    title: "IT Project Manager",
    slug: "angela-fay-malaguino-cammayo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew",
    lastName: "Camp",
    title: "Director of Government Relations",
    slug: "matthew-camp",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Starr",
    lastName: "Campbell",
    title: "Investigations Assistant",
    slug: "starr-campbell",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sarah N",
    lastName: "Campbell",
    title: "Senior Assistant Director",
    slug: "sarah-n-campbell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven William",
    lastName: "Campbell",
    title: "Sr. Application Systems Developer",
    slug: "steven-william-campbell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ken",
    lastName: "Campbell",
    title: "Director, Services, Software and Consultant Agreements",
    slug: "ken-campbell",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Delroy",
    lastName: "Campbell",
    title: "CMA",
    slug: "delroy-campbell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Scott L",
    lastName: "Campi",
    title: "Asst Director-Print Services",
    slug: "scott-l-campi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "TIffany",
    lastName: "Campiz-Challe",
    title: "Communications Associate",
    slug: "tiffany-campiz-challe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rosalina",
    lastName: "Campos",
    title: "MPA",
    slug: "rosalina-campos",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Betty",
    lastName: "Campos",
    title: "EEG/EMU Coordinator",
    slug: "betty-campos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ana Cristina",
    lastName: "Campoverde",
    title: "Director, Inclusive Engagement",
    slug: "ana-cristina-campoverde",
    dei: true,
    category: "Communications",
  },
  {
    firstName: "Niurka",
    lastName: "Campusano",
    title: "Assoc Dir Acad Appts",
    slug: "niurka-campusano",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karen",
    lastName: "Canaan",
    title: "Contract Coordinator",
    slug: "karen-canaan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley R",
    lastName: "Canaan",
    title: "Paralegal",
    slug: "ashley-r-canaan",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Theodore P.",
    lastName: "Canaras",
    title: "Deputy Director, Strategic Relations and Stewardship",
    slug: "theodore-p-canaras",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Norberto",
    lastName: "Cancel",
    title: "Technical Support Specialist",
    slug: "norberto-cancel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Berlady",
    lastName: "Cancel",
    title: "Accessioning Supervisor",
    slug: "berlady-cancel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily Kern",
    lastName: "Candaux",
    title: "Digital Media Manager",
    slug: "emily-kern-candaux",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "Candelario",
    title: "Procurement Manager",
    slug: "jennifer-candelario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabriela Alondra",
    lastName: "Candelario",
    title: "Administrative Assistant",
    slug: "gabriela-alondra-candelario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amberley",
    lastName: "Canegitta",
    title: "Benefits Admin. Asst.",
    slug: "amberley-canegitta",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Melany Romona",
    lastName: "Canela",
    title: "Coordinator",
    slug: "melany-romona-canela",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Oscar",
    lastName: "Canepa",
    title: "IT Business Relationship Mgr",
    slug: "oscar-canepa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ed",
    lastName: "Cangialosi",
    title: "Gift Planning Officer",
    slug: "ed-cangialosi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Manuela",
    lastName: "Cangiamila",
    title: "Administrator",
    slug: "manuela-cangiamila",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maia",
    lastName: "Canlas",
    title: "Assoc Director-Dig Strat/Mktg",
    slug: "maia-canlas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amber E",
    lastName: "Cannady Weatherup",
    title: "Assistant Director, Volunteer Management",
    slug: "amber-e-cannady-weatherup",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Benjamin",
    lastName: "Canning-Pereira",
    title: "Senior Assistant Director for Communications",
    slug: "benjamin-canning-pereira",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Diane Elizabeth",
    lastName: "Cannone",
    title: "Regulatory Manager",
    slug: "diane-elizabeth-cannone",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Michael",
    lastName: "Canny",
    title: "Senior Project Director",
    slug: "michael-canny",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lizelle Joy Alog",
    lastName: "Canque",
    title: "On-Site Director",
    slug: "lizelle-joy-alog-canque",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sean Shengan",
    lastName: "Cao",
    title: "Software Developer",
    slug: "sean-shengan-cao",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yesenia",
    lastName: "Capellan",
    title: "Senior Manager of Financial Operations",
    slug: "yesenia-capellan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jeana Hillary",
    lastName: "Caporelli",
    title: "Manager - HR and Operations",
    slug: "jeana-hillary-caporelli",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bobbie",
    lastName: "Cappiello",
    title: "Assistant Director, Columbia Alumni Center",
    slug: "bobbie-cappiello",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sophia Moxi T",
    lastName: "Capri",
    title: "Records Assistant",
    slug: "sophia-moxi-t-capri",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lissette",
    lastName: "Capri",
    title: "Administrator",
    slug: "lissette-capri",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle Ashley Edejer",
    lastName: "Capuno",
    title: "Officer-Grants Contracts",
    slug: "michelle-ashley-edejer-capuno",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle",
    lastName: "Caraballo",
    title: "Associate Director, Events",
    slug: "michelle-caraballo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristine",
    lastName: "Carballo",
    title: "Associate Director, Procurement Policy Training and Communications",
    slug: "kristine-carballo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma M",
    lastName: "Carberry",
    title: "Assistant Director, of Alumni Relations and Development",
    slug: "emma-m-carberry",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Javier",
    lastName: "Cardona",
    title: "Porter",
    slug: "javier-cardona",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eddie N",
    lastName: "Cardona",
    title: "Service Specialist",
    slug: "eddie-n-cardona",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hayara C.",
    lastName: "Cardoso",
    title: "Operations Officer",
    slug: "hayara-c-cardoso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rollie P",
    lastName: "Carencia",
    title: "Executive Director, Student Life",
    slug: "rollie-p-carencia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "James D.",
    lastName: "Carey",
    title: "Administrative Aide",
    slug: "james-d-carey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanne M.",
    lastName: "Carey",
    title: "Assistant Director, Human Resources",
    slug: "joanne-m-carey",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Christopher J",
    lastName: "Cariello",
    title: "Asst Dir,Internal Cntrl&Compl",
    slug: "christopher-j-cariello",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rodolphe",
    lastName: "Carilus",
    title: "Administrative Manager",
    slug: "rodolphe-carilus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fermin F.",
    lastName: "Carino-Ortega",
    title: "Wait Staff",
    slug: "fermin-f-carino-ortega",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary Ann",
    lastName: "Carlese",
    title: "Executive Director, Labor Relations",
    slug: "mary-ann-carlese",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Larry Michael",
    lastName: "Carlson",
    title: "Director of Space and Related Projects",
    slug: "larry-michael-carlson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda B.",
    lastName: "Carlson",
    title: "Associate Dean, Admissions",
    slug: "amanda-b-carlson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ryan H",
    lastName: "Carmichael",
    title: "Vice President for University Development",
    slug: "ryan-h-carmichael",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vanina",
    lastName: "Carmona",
    title: "Associate Director, Financial & Endowment Accounting",
    slug: "vanina-carmona",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Genesis",
    lastName: "Carmona",
    title: "MPA",
    slug: "genesis-carmona",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristin",
    lastName: "Carnahan",
    title: "Program Manager",
    slug: "kristin-carnahan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lesley",
    lastName: "Caron",
    title: "Residence Hall Director, Fraternity & Sorority Life",
    slug: "lesley-caron",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Scott W",
    lastName: "Carpenter",
    title: "Associate Dean",
    slug: "scott-w-carpenter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jordan",
    lastName: "Carr",
    title: "Associate Director for Academic Counseling",
    slug: "jordan-carr",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dasaundra M",
    lastName: "Carr",
    title: "Systems Administrator",
    slug: "dasaundra-m-carr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John T.",
    lastName: "Carr III",
    title: "Administrative Assistant",
    slug: "john-t-carr-iii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine L",
    lastName: "Carraway",
    title: "Admissions Officer",
    slug: "katherine-l-carraway",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Francois",
    lastName: "Carrel-Billiard",
    title: "Associate Director",
    slug: "francois-carrel-billiard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monica",
    lastName: "Carrera",
    title: "Business Manager",
    slug: "monica-carrera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julian",
    lastName: "Carreras",
    title: "Administrative Coordinator",
    slug: "julian-carreras",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ingrid",
    lastName: "Carretero",
    title: "Administrative Coordinator",
    slug: "ingrid-carretero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victor",
    lastName: "Carreto",
    title: "Assistant Registrar, Academic Programs",
    slug: "victor-carreto",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "William A.",
    lastName: "Carrick",
    title: "Assistant Director",
    slug: "william-a-carrick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel J.",
    lastName: "Carrier",
    title: "Assistant Director of Finance",
    slug: "daniel-j-carrier",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joanne",
    lastName: "Carrillo",
    title: "Asst Director-External Program",
    slug: "joanne-carrillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angie D.",
    lastName: "Carrillo",
    title: "Associate Dean",
    slug: "angie-d-carrillo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ian Scott",
    lastName: "Carroll",
    title: "Associate Director, Student Affairs",
    slug: "ian-scott-carroll",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Cheryl",
    lastName: "Carruthers",
    title: "Senior Major Gifts Officer",
    slug: "cheryl-carruthers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leslie F.",
    lastName: "Carson",
    title: "Associate Director, Administration",
    slug: "leslie-f-carson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Haley A.",
    lastName: "Carson",
    title:
      " Associate Director of Residential Life and Special Interest Communities",
    slug: "haley-a-carson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sarah V.",
    lastName: "Carswell",
    title: "Executive Assistant",
    slug: "sarah-v-carswell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Austin T.",
    lastName: "Cartagena",
    title: "Assistant Director, Graduate Career Placement",
    slug: "austin-t-cartagena",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sharon Anita",
    lastName: "Carter",
    title: "Administrative Aide",
    slug: "sharon-anita-carter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard John",
    lastName: "Carthew",
    title: "Senior Associate Director, Web Development and Technology",
    slug: "richard-john-carthew",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nikia",
    lastName: "Cartwright",
    title: "Associate Director of Strategy and Board Operations",
    slug: "nikia-cartwright",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Fabrizio",
    lastName: "Carucci",
    title: "Associate Vice President, Research Policy & Indirect Cost",
    slug: "fabrizio-carucci",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristen",
    lastName: "Caruso",
    title: "Associate Director, Investigations",
    slug: "kristen-caruso",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Cynthia",
    lastName: "Caruso",
    title: "Associate Director - Contracts, Services and Technology",
    slug: "cynthia-caruso",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jill M",
    lastName: "Casal",
    title: "Director of Admissions",
    slug: "jill-m-casal",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kristen",
    lastName: "Casano",
    title: "Associate Director, Advising and Academic Success",
    slug: "kristen-casano",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Felicia",
    lastName: "Cascone",
    title: "Generalist, HR/FA",
    slug: "felicia-cascone",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Pamela F.",
    lastName: "Casey",
    title: "Manager-Events & Outreach",
    slug: "pamela-f-casey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Meghan A",
    lastName: "Casey",
    title: "Senior Associate Director of Annual Giving",
    slug: "meghan-a-casey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rene",
    lastName: "Casiano",
    title: "Office Assistant",
    slug: "rene-casiano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Milean",
    lastName: "Casiano",
    title: "Financial Coordinator",
    slug: "milean-casiano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ethan B.",
    lastName: "Caso",
    title: "Audience Services Manager",
    slug: "ethan-b-caso",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Krystina",
    lastName: "Casolino",
    title: "Director, Service Integration and Management",
    slug: "krystina-casolino",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle T",
    lastName: "Cass",
    title: "Assistant Vice President of Gift Strategy",
    slug: "michelle-t-cass",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cheryl L.",
    lastName: "Cassidy",
    title: "Coordinator, QualityManagement",
    slug: "cheryl-l-cassidy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Cassidy",
    title: "Director of Academic Administration",
    slug: "andrew-cassidy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeremy",
    lastName: "Casso Garcia",
    title: "Human Resources Coordinator",
    slug: "jeremy-casso-garcia",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Eva",
    lastName: "Castagna",
    title: "Tech in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "eva-castagna",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Candace D.",
    lastName: "Castagna",
    title: "Senior Manager, QA & Biosafety",
    slug: "candace-d-castagna",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marisol",
    lastName: "Castellano",
    title: "Project Manager",
    slug: "marisol-castellano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Castillo",
    title: "Associate Director, Columbia Scholastic Press Association",
    slug: "rebecca-castillo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maribel",
    lastName: "Castillo",
    title: "Executive Assistant",
    slug: "maribel-castillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura M",
    lastName: "Castillo",
    title: "Operations Manager",
    slug: "laura-m-castillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erickson R.",
    lastName: "Castillo",
    title: "Mail Clerk",
    slug: "erickson-r-castillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Castillo",
    title: "Program Assistant",
    slug: "andrew-castillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cecily",
    lastName: "Castle",
    title: "Senior Major Gifts Officer",
    slug: "cecily-castle",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Giorgio",
    lastName: "Castoldi",
    title: "Senior Associate Director, Corporate Relations and Major Gifts",
    slug: "giorgio-castoldi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sari",
    lastName: "Castro",
    title: "Programming and Communications Assistant",
    slug: "sari-castro",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marlene",
    lastName: "Castro",
    title: "Administrative Coordinator I",
    slug: "marlene-castro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jasmine",
    lastName: "Castro",
    title: "MPA",
    slug: "jasmine-castro",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Johnny",
    lastName: "Castro",
    title: "Administrative Clerk",
    slug: "johnny-castro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isabella",
    lastName: "Castro",
    title: "SYEP",
    slug: "isabella-castro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Giovani M.",
    lastName: "Castro",
    title: "Operations Specialist",
    slug: "giovani-m-castro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barbara M",
    lastName: "Catalano",
    title: "Executive Director, Staffing CEIC",
    slug: "barbara-m-catalano",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kenneth M.",
    lastName: "Catandella",
    title: "Senior Executive Director, CAA and University Relations",
    slug: "kenneth-m-catandella",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mark Edward",
    lastName: "Catt",
    title: "Sr. Applications Systems Developer",
    slug: "mark-edward-catt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David M.",
    lastName: "Caughlin",
    title:
      " Project Director, Center for Political Economy at Columbia World Projects",
    slug: "david-m-caughlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia",
    lastName: "Caunday Ep Rigot",
    title: "Assoc Director, QA",
    slug: "olivia-caunday-ep-rigot",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "DAWN L",
    lastName: "CAUSSADE",
    title: "Sevice Corp",
    slug: "dawn-l-caussade",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Cazzola",
    title: "Assistant Director, Events Management",
    slug: "lisa-cazzola",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan",
    lastName: "Ceballo",
    title: "HR Generalist",
    slug: "susan-ceballo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Giran Rafael",
    lastName: "Ceballos",
    title: "Administrative Assistant",
    slug: "giran-rafael-ceballos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher R.",
    lastName: "Cecilio",
    title: "Stockroom Coordinator",
    slug: "christopher-r-cecilio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Cedano",
    title: "Generalist, HR/FA",
    slug: "katherine-cedano",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Maria",
    lastName: "Cedeno",
    title: "Director of Administration and Finance, SIG",
    slug: "maria-cedeno",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Immacula",
    lastName: "Celestin",
    title: "Assistant Director of Special Events and Programs",
    slug: "immacula-celestin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Helen Kailun",
    lastName: "Cen",
    title: "Associate Director of Graduate Student Affairs",
    slug: "helen-kailun-cen",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Diana",
    lastName: "Cena",
    title: "Manager, Catering Sales",
    slug: "diana-cena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael John",
    lastName: "Cennamo",
    title: "Associate Director of Educational Technology",
    slug: "michael-john-cennamo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maria Mercedes",
    lastName: "Cepeda",
    title: "Project Manager",
    slug: "maria-mercedes-cepeda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Esteban D",
    lastName: "Cepeda Roman",
    title: "Financial Coordinator",
    slug: "esteban-d-cepeda-roman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Iyidenia J",
    lastName: "Cerda",
    title: "Administrative Coordinator",
    slug: "iyidenia-j-cerda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "George G.",
    lastName: "Cereno",
    title: "Bosun",
    slug: "george-g-cereno",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Austin Blake",
    lastName: "Cernosek",
    title: "Service Specialist",
    slug: "austin-blake-cernosek",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Cerone",
    title: "Assistant VP and Senior Director of Finance and Administration",
    slug: "anthony-cerone",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Miriam",
    lastName: "Cespedes",
    title: "University Affiliate - STEAM",
    slug: "miriam-cespedes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julia E.",
    lastName: "Cespedes",
    title: "Generalist, HR/FA",
    slug: "julia-e-cespedes",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Anna",
    lastName: "Cetnerowski",
    title: "Chief Admin Research Officer",
    slug: "anna-cetnerowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David S.",
    lastName: "Cha",
    title: "Systems Coordinator",
    slug: "david-s-cha",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chun",
    lastName: "Cha",
    title: "Senior Application Systems Developer (Java/Oracle)",
    slug: "chun-cha",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Catherine",
    lastName: "Cha",
    title: "Senior Manager of Communications & Knowledge Transfer",
    slug: "catherine-cha",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth Mary",
    lastName: "Chadbourne",
    title: "Project Manager",
    slug: "elizabeth-mary-chadbourne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joel",
    lastName: "Chaffee",
    title: "Assistant Director, ALP Advising",
    slug: "joel-chaffee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Susree",
    lastName: "Chakraborty",
    title: "Director, Operations",
    slug: "susree-chakraborty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jose",
    lastName: "Chalas",
    title: "Grants Manager",
    slug: "jose-chalas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Arwa Zoher",
    lastName: "Chalisa",
    title: "Programs Manager",
    slug: "arwa-zoher-chalisa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole Lynn",
    lastName: "Chamberlin",
    title: "Deputy Director, Strategic Events",
    slug: "nicole-lynn-chamberlin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Zauditu",
    lastName: "Chambers",
    title: "Associate Director of User Support & Training",
    slug: "zauditu-chambers",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kayla Michelle",
    lastName: "Champion",
    title: "Assistant Manager - Banquet",
    slug: "kayla-michelle-champion",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luisa G",
    lastName: "Chan",
    title: "Senior Project Officer",
    slug: "luisa-g-chan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "King-Tung",
    lastName: "Chan",
    title: "Sr Administrator-Linux Systems",
    slug: "king-tung-chan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ken Mee",
    lastName: "Chan",
    title: "Senior Application Developer, Financial Information Systems",
    slug: "ken-mee-chan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jasper",
    lastName: "Chan",
    title: "Payroll Manager",
    slug: "jasper-chan",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Evan",
    lastName: "Chan",
    title: "Associate Director, American Language Program",
    slug: "evan-chan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Chan",
    title: "Senior Application Systems Developer",
    slug: "david-chan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Danny H.",
    lastName: "Chan",
    title: "Associate Director, Software Development and Project Management",
    slug: "danny-h-chan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hei Ton",
    lastName: "Chan",
    title: "BMT,Cell&Gene Ther Res Nrs Mgr",
    slug: "hei-ton-chan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Chan",
    title: "Sr Assoc Director-Acad Stud",
    slug: "christine-chan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher A.",
    lastName: "Chan",
    title: "Senior Director, Application Services",
    slug: "christopher-a-chan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bryan",
    lastName: "Chan",
    title: "Director, Classroom & Lab Technologies",
    slug: "bryan-chan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Edward",
    lastName: "Chan-Lizardo",
    title: "Executive Director, University Development",
    slug: "edward-chan-lizardo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Srikanth",
    lastName: "Chandar",
    title: "Shadlen Lab HHMI Employee",
    slug: "srikanth-chandar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamie E",
    lastName: "Chandler",
    title: "Program Manager",
    slug: "jamie-e-chandler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Narine",
    lastName: "Chandrapaul",
    title: "Handyperson",
    slug: "narine-chandrapaul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandra",
    lastName: "Chang",
    title: "Operations Coordinator",
    slug: "sandra-chang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul S.",
    lastName: "Chang",
    title: "Production Manager",
    slug: "paul-s-chang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer Y.",
    lastName: "Chang",
    title: "Manager",
    slug: "jennifer-y-chang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gregory A.",
    lastName: "Chang",
    title: "New Media Coordinator",
    slug: "gregory-a-chang",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eugene",
    lastName: "Chang",
    title: "Program Manager",
    slug: "eugene-chang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina H.",
    lastName: "Chann",
    title: "Mysak Clinic Supervisor",
    slug: "christina-h-chann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peggy",
    lastName: "Chao",
    title: "Director of Operations",
    slug: "peggy-chao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vera",
    lastName: "Chaplin",
    title: "Lead Systems Administrator",
    slug: "vera-chaplin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brian",
    lastName: "Chapman",
    title: "Chief of Staff",
    slug: "brian-chapman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tricia Veronica",
    lastName: "Charles",
    title: "Admissions Specialist",
    slug: "tricia-veronica-charles",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Natasha",
    lastName: "Charles",
    title: "LPN",
    slug: "natasha-charles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "LaToya Demetra",
    lastName: "Charles",
    title: "Tech Customer Support Specialist",
    slug: "latoya-demetra-charles",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tara",
    lastName: "Charlton",
    title: "Sr Clin Coord / Clin Serv Mgr",
    slug: "tara-charlton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley M",
    lastName: "Chastain",
    title: "Senior Project Director",
    slug: "ashley-m-chastain",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sophia N.",
    lastName: "Chaudry",
    title: "Research Project Manager",
    slug: "sophia-n-chaudry",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lenia",
    lastName: "Chaves",
    title: "Deputy Director, Gift Strategy",
    slug: "lenia-chaves",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John L",
    lastName: "Chavez",
    title: "Director of Admissions Operations and Technology",
    slug: "john-l-chavez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jenny",
    lastName: "Chavez",
    title: "Project Manager",
    slug: "jenny-chavez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ciela Sophia",
    lastName: "Chavez-Gilbride",
    title: "Lab Coordinator",
    slug: "ciela-sophia-chavez-gilbride",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Luisa",
    lastName: "Chea",
    title: "Financial Assistant",
    slug: "luisa-chea",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Albert",
    lastName: "Chee",
    title: "Wait Staff",
    slug: "albert-chee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janique T",
    lastName: "Cheesman",
    title: "Associate Director of Research Compliance",
    slug: "janique-t-cheesman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Teresa",
    lastName: "Chen",
    title: "Associate General Counsel",
    slug: "teresa-chen",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Yuan Mei",
    lastName: "Chen",
    title: "Financial Coordinator",
    slug: "yuan-mei-chen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yan",
    lastName: "Chen",
    title:
      " Executive Assistant to the Senior Vice President for University Development",
    slug: "yan-chen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yu-Kang",
    lastName: "Chen",
    title: "Doctoral Supervisor",
    slug: "yu-kang-chen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Wen",
    lastName: "Chen",
    title: "Executive Assistant",
    slug: "wen-chen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shuyi",
    lastName: "Chen",
    title: "Instructional Designer",
    slug: "shuyi-chen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ru",
    lastName: "Chen",
    title: "Executive Assistant",
    slug: "ru-chen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Qin",
    lastName: "Chen",
    title: "Executive Director of Space Planning and Design",
    slug: "qin-chen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kong",
    lastName: "Chen",
    title: "Director, Data Operations",
    slug: "kong-chen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kenny",
    lastName: "Chen",
    title: "Senior Associate Director, Marketing Technology",
    slug: "kenny-chen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jacqueline",
    lastName: "Chen",
    title: "Program Manager, CP Center",
    slug: "jacqueline-chen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jimmy",
    lastName: "Chen",
    title: "Systems Administrator",
    slug: "jimmy-chen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Haoyu",
    lastName: "Chen",
    title: "Research Technical Support Assistant II",
    slug: "haoyu-chen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karen",
    lastName: "Chen",
    title: "Director, Financial Reporting and Accounting",
    slug: "karen-chen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eric Evan",
    lastName: "Chen",
    title: "Director, Creative Research",
    slug: "eric-evan-chen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Collin",
    lastName: "Chen",
    title: "Application Systems Developer (Python)",
    slug: "collin-chen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cristina C.",
    lastName: "Chen",
    title: "Grants Finance Manager",
    slug: "cristina-c-chen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Angela",
    lastName: "Chen",
    title: "Assistant Director, Benefits",
    slug: "angela-chen",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sophia",
    lastName: "Cheng",
    title: "Assistant Director of Student Affairs: Academic Records",
    slug: "sophia-cheng",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Henan",
    lastName: "Cheng",
    title: "Executive Director of the Center for Chinese Education",
    slug: "henan-cheng",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yixue",
    lastName: "Cheng",
    title: "Associate Director of Annual Fund",
    slug: "yixue-cheng",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Constantine",
    lastName: "Chernyavsky",
    title: "Associate Director of Finance",
    slug: "constantine-chernyavsky",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Angel",
    lastName: "Cherpanath",
    title: "Director of Finance and Administration",
    slug: "angel-cherpanath",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alaina",
    lastName: "Chester",
    title: "Administrative Coordinator",
    slug: "alaina-chester",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vivian",
    lastName: "Cheung",
    title: "Senior Associate Director, Budget and Operations",
    slug: "vivian-cheung",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lik Hang",
    lastName: "Cheung",
    title: "Senior Service Specialist",
    slug: "lik-hang-cheung",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria I",
    lastName: "Chevere",
    title: "Grants Manager",
    slug: "maria-i-chevere",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jeremiah",
    lastName: "Chevry",
    title: "Consultant",
    slug: "jeremiah-chevry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ethan",
    lastName: "Chiampas",
    title: "Associate Director, Delegate Management",
    slug: "ethan-chiampas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kane H.",
    lastName: "Chiang",
    title: "Asst Director-Multimedia Svcs",
    slug: "kane-h-chiang",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kin",
    lastName: "Chiang",
    title: "Administrator-Concur Expense",
    slug: "kin-chiang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Josephine",
    lastName: "Chiappetta",
    title: "Administrative Coordinator",
    slug: "josephine-chiappetta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suzanne T",
    lastName: "Chiaramonte",
    title: "Senior Regulatory Manager",
    slug: "suzanne-t-chiaramonte",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Loren",
    lastName: "Childress",
    title: "Director, Marketing/Comms",
    slug: "loren-childress",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karen",
    lastName: "Chin",
    title:
      " Research Manager, Center for Cerebral Palsy Research and Sensorimotor Neuroscience Lab",
    slug: "karen-chin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kimone K.S.",
    lastName: "Chin",
    title: "Asst Director, Admin & Finance",
    slug: "kimone-k-s-chin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wei Mun",
    lastName: "Ching",
    title: "Supervisor, Financial Mon&Plan",
    slug: "wei-mun-ching",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gregory John",
    lastName: "Chingas",
    title: "Student & Academic Affairs Specialist",
    slug: "gregory-john-chingas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephanie",
    lastName: "Chino",
    title: "Division Administrator",
    slug: "stephanie-chino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hanna Diamond",
    lastName: "Chipman",
    title: "Program Manager, Academy Affairs",
    slug: "hanna-diamond-chipman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer Y",
    lastName: "Chiu",
    title: "Business Manager",
    slug: "jennifer-y-chiu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexis",
    lastName: "Cho",
    title: "Learning Designer II",
    slug: "alexis-cho",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Richard",
    lastName: "Cho",
    title: "Financial&Procurement Manager",
    slug: "richard-cho",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica Yeonju",
    lastName: "Cho",
    title: "Digital Marketing Coordinator",
    slug: "jessica-yeonju-cho",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Allan B.",
    lastName: "Chochinov",
    title: "Academic Program Support",
    slug: "allan-b-chochinov",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Inji",
    lastName: "Choi",
    title: "Associate Director, Bond Issuance and Compliance",
    slug: "inji-choi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chien-Wen Jean",
    lastName: "Choi",
    title: "Biostatistian",
    slug: "chien-wen-jean-choi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charles",
    lastName: "Choi",
    title: "Writer",
    slug: "charles-choi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Madiha Zahrah",
    lastName: "Choksi",
    title: "Digital Learning and Emerging Technologies Specialist",
    slug: "madiha-zahrah-choksi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric",
    lastName: "Choo",
    title: "Assistant Director, Liquidity Management",
    slug: "eric-choo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Supriya",
    lastName: "Choudhary",
    title: "Generalist, HR/FA",
    slug: "supriya-choudhary",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Stephanie",
    lastName: "Chouloute",
    title: "Human Resources Generalist",
    slug: "stephanie-chouloute",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Summayah",
    lastName: "Chowdhury",
    title: "SYEP",
    slug: "summayah-chowdhury",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Prithak",
    lastName: "Chowdhury",
    title: "Director, Education and Training",
    slug: "prithak-chowdhury",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nazifa Maliyat",
    lastName: "Chowdhury",
    title: "Admissions Officer (High School Programs)",
    slug: "nazifa-maliyat-chowdhury",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ji Men Jenny",
    lastName: "Choy",
    title: "Graduate Admissions Officer",
    slug: "ji-men-jenny-choy",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kimberly",
    lastName: "Christel",
    title: "Financial Aid Officer",
    slug: "kimberly-christel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Luke",
    lastName: "Christie",
    title: "Assistant Director of Student Life",
    slug: "luke-christie",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jennifer",
    lastName: "Christner",
    title: "Consultant",
    slug: "jennifer-christner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eftihia",
    lastName: "Christoforatos",
    title: "Executive Assistant",
    slug: "eftihia-christoforatos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Chu",
    title: "Authorization and Referrals Specialist level II",
    slug: "stephanie-chu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Chu",
    title: "Program Manager",
    slug: "michelle-chu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaclyn Allison",
    lastName: "Chu",
    title: "Senior Director, Development and Strategic Initiatives",
    slug: "jaclyn-allison-chu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca Yae-Eun",
    lastName: "Chung",
    title: "Program Manager, Online campus",
    slug: "rebecca-yae-eun-chung",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katherine Y",
    lastName: "Chung",
    title: "Program Manager",
    slug: "katherine-y-chung",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Helen",
    lastName: "Chung",
    title: "Director, Finance & Administration",
    slug: "helen-chung",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hyun-Ha",
    lastName: "Chung",
    title: "Executive Director of Strategic Budget Planning and Analysis",
    slug: "hyun-ha-chung",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hwan",
    lastName: "Chung",
    title: "IT Assistant",
    slug: "hwan-chung",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Claudette V",
    lastName: "Chung",
    title: "Secretary",
    slug: "claudette-v-chung",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Anna",
    lastName: "Chung",
    title: "Student Casual",
    slug: "anna-chung",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ghipsel Consuelo",
    lastName: "Cibrian Lopez",
    title: "CPRE Researcher - Interim",
    slug: "ghipsel-consuelo-cibrian-lopez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chelsea N",
    lastName: "Cicero-Franco",
    title: "Associate Director, Visitors Center",
    slug: "chelsea-n-cicero-franco",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Miguel Eduardo",
    lastName: "Cid",
    title: "Project Coordinator",
    slug: "miguel-eduardo-cid",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ariana Noelle",
    lastName: "Cid",
    title: "Administrative Assistant",
    slug: "ariana-noelle-cid",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy J.",
    lastName: "Cieri",
    title: "Senior Executive Assistant to the Dean",
    slug: "nancy-j-cieri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Orquidea",
    lastName: "Cifre",
    title: "Administrative Assistant II",
    slug: "orquidea-cifre",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miriam I.",
    lastName: "Cinquegrana",
    title: "Administrative and Special Projects Coordinator",
    slug: "miriam-i-cinquegrana",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly",
    lastName: "Cionca-Sebesanu",
    title: "Course Operations Manager",
    slug: "kimberly-cionca-sebesanu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brett Robert",
    lastName: "Cione",
    title: "Director, Admissions and Financial Aid",
    slug: "brett-robert-cione",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jawad",
    lastName: "Cipriani",
    title: "Associate Director of Student Engagement and Transition",
    slug: "jawad-cipriani",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anthony M.",
    lastName: "Cirillo",
    title: "AVP Data Center & Operations Support Services",
    slug: "anthony-m-cirillo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John",
    lastName: "Cissel",
    title: "Associate Director, Learning Solutions",
    slug: "john-cissel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ria Elisa",
    lastName: "Citrin",
    title: "Assistant Director, Academic Advising and Student Success",
    slug: "ria-elisa-citrin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stanley",
    lastName: "Clark",
    title: "Coordinator, Alumni Engagement",
    slug: "stanley-clark",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Payton N",
    lastName: "Clark",
    title: "Communications Coordinator",
    slug: "payton-n-clark",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mckynzie N",
    lastName: "Clark",
    title: "Operations Officer",
    slug: "mckynzie-n-clark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meier",
    lastName: "Clark",
    title: "Media Support Associate",
    slug: "meier-clark",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Grace Teresa",
    lastName: "Clark",
    title: "Service Provider",
    slug: "grace-teresa-clark",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Shantel",
    lastName: "Clarke",
    title: "Coordinator-Alumni Relations",
    slug: "shantel-clarke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Latoya",
    lastName: "Clarke",
    title: "Assistant Director, Digital Content",
    slug: "latoya-clarke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Khalil Rossi",
    lastName: "Clarke",
    title: "Assistant Director, Payroll Accounting",
    slug: "khalil-rossi-clarke",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Khrystina N.",
    lastName: "Clarke",
    title: "Senior Director, HRPC",
    slug: "khrystina-n-clarke",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jermaine C.",
    lastName: "Clarke",
    title: "Sr Manager, Info Technology",
    slug: "jermaine-c-clarke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adrian",
    lastName: "Clarke",
    title: "Director, Development&Planning",
    slug: "adrian-clarke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annmarie",
    lastName: "Clarke",
    title: "Grants Administrator",
    slug: "annmarie-clarke",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eric",
    lastName: "Clausen",
    title: "Associate Director, Learning Management Solutions",
    slug: "eric-clausen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andrea",
    lastName: "Clay",
    title: "Director of Legal Strategy and Policy",
    slug: "andrea-clay",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Samantha Farr",
    lastName: "Clay Reagan",
    title: "Professional Staff (Art Education Program Manager)",
    slug: "samantha-farr-clay-reagan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary Elizabeth",
    lastName: "Cleary",
    title: "Senior Project Officer",
    slug: "mary-elizabeth-cleary",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dawn E.",
    lastName: "Clements",
    title: "Audience Services Manager",
    slug: "dawn-e-clements",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Walker",
    lastName: "Clermont",
    title: "Administrative Assistant",
    slug: "walker-clermont",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lucie",
    lastName: "Clifford",
    title: "Manager",
    slug: "lucie-clifford",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Haley M",
    lastName: "Clint",
    title: "Manager of Administration and Outreach",
    slug: "haley-m-clint",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evan T.",
    lastName: "Clinton",
    title: "Gallery Attendant",
    slug: "evan-t-clinton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren G",
    lastName: "Close",
    title: "Operations and Communications Manager - Northeast Big Data Hub",
    slug: "lauren-g-close",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alvaro",
    lastName: "Coarite-Velasquez",
    title: "Financial Services Assistant 8",
    slug: "alvaro-coarite-velasquez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Caelyn",
    lastName: "Cobb",
    title: "Editor, Global History and Politics",
    slug: "caelyn-cobb",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eve A",
    lastName: "Coben",
    title: "Genetic Counseling Assistant",
    slug: "eve-a-coben",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melanie",
    lastName: "Cobos",
    title: "Financial Coordinator",
    slug: "melanie-cobos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicholas",
    lastName: "Cocciadiferro",
    title: "Asst Service Desk Tech-Tier I",
    slug: "nicholas-cocciadiferro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Cocco",
    title: "Recruitment Administrative Assistant",
    slug: "jessica-cocco",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gabriela",
    lastName: "Cocco",
    title: "Assistant Director, Programs and Events",
    slug: "gabriela-cocco",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Cochran",
    title: "Assistant Director, Operations & Finance",
    slug: "jessica-cochran",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laura S",
    lastName: "Cocke",
    title: "Associate Manager-Housing Systems Operations",
    slug: "laura-s-cocke",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jacqueline",
    lastName: "Codrington",
    title: "Administrative Assistant",
    slug: "jacqueline-codrington",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nathan W",
    lastName: "Cody",
    title: "Associate Director, Undergraduate Career Development",
    slug: "nathan-w-cody",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Cynthia F.",
    lastName: "Cogdill",
    title: "Advising Dean",
    slug: "cynthia-f-cogdill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alison",
    lastName: "Coggins",
    title: "Student Affairs Officer",
    slug: "alison-coggins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Melissa P",
    lastName: "Cohen",
    title: "Associate General Counsel",
    slug: "melissa-p-cohen",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Lisa R",
    lastName: "Cohen",
    title: "Director, Dupont/Professional Prizes",
    slug: "lisa-r-cohen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leah A",
    lastName: "Cohen",
    title: "Associate Dean for Development & Alumni Relations, GSAPP",
    slug: "leah-a-cohen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth",
    lastName: "Cohen",
    title: "Associate Director, Online Meeting Solutions",
    slug: "elizabeth-cohen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adina C.",
    lastName: "Cojoc",
    title: "Assistant Director of Finance and Administration",
    slug: "adina-c-cojoc",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alessia",
    lastName: "Colarossi",
    title: "Program Specialist, University Senate",
    slug: "alessia-colarossi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ingrid",
    lastName: "Cole",
    title: "Senior Manager, Project Engagement and Client Relations",
    slug: "ingrid-cole",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annakaye K.",
    lastName: "Cole-Riggan",
    title: "Administrative Assistant",
    slug: "annakaye-k-cole-riggan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura Marie",
    lastName: "Coleman",
    title: "Senior Associate Director",
    slug: "laura-marie-coleman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandy C",
    lastName: "Coleman",
    title: "Academic Coord/PrIMER Assist",
    slug: "brandy-c-coleman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Angel A.",
    lastName: "Colina Perez",
    title: "Director, Technical Operations",
    slug: "angel-a-colina-perez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Whitney",
    lastName: "Collado",
    title: "Project Coordinator II",
    slug: "whitney-collado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thelma M.",
    lastName: "Collado",
    title: "Assistant Director",
    slug: "thelma-m-collado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Roberto",
    lastName: "Collado",
    title: "Manager, Benefits Systems",
    slug: "roberto-collado",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nashaly",
    lastName: "Collado",
    title: "Recess Enrichment Facilitator in The School",
    slug: "nashaly-collado",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Luis",
    lastName: "Collado",
    title: "Coordinator",
    slug: "luis-collado",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Johanny A.",
    lastName: "Collado",
    title: "Director, HR/FA",
    slug: "johanny-a-collado",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jatnna",
    lastName: "Collado",
    title: "Project Coordinator",
    slug: "jatnna-collado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Johanna",
    lastName: "Collado",
    title: "Administrative Aide",
    slug: "johanna-collado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason",
    lastName: "Collado",
    title: "Assistant Dean",
    slug: "jason-collado",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Denise",
    lastName: "Collado",
    title: "University Affiliate - STEAM",
    slug: "denise-collado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Collado",
    title: "Assistant Director",
    slug: "david-collado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yaritza",
    lastName: "Collazo",
    title: "Assistant Director, IRB Management",
    slug: "yaritza-collazo",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Anthony Joseph",
    lastName: "Colletti",
    title: "Assistant Vice President of Advancement Operations",
    slug: "anthony-joseph-colletti",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cameron",
    lastName: "Collichio",
    title:
      " Associate Director, Student Affairs (High School and Non-Degree Programs)",
    slug: "cameron-collichio",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ilka E.",
    lastName: "Collier",
    title: "Assistant Director, Office for Billing Compliance",
    slug: "ilka-e-collier",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "William K",
    lastName: "Collins",
    title: "Head Store Room Checker",
    slug: "william-k-collins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Debbie",
    lastName: "Collins",
    title: "Jr Act Rep",
    slug: "debbie-collins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephanie Ortiz",
    lastName: "Colon",
    title: "Finance and Compliance Manager, Sponsored Projects Finance",
    slug: "stephanie-ortiz-colon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Natasha",
    lastName: "Colon",
    title: "Grants Administrator",
    slug: "natasha-colon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melba",
    lastName: "Colon",
    title: "HR and Academic Affairs Generalist",
    slug: "melba-colon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Migdalia",
    lastName: "Colon",
    title: "Division Administrator",
    slug: "migdalia-colon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emely",
    lastName: "Colon",
    title: "5030 Broadway, 3rd Floor New York NY 10034",
    slug: "emely-colon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dawn",
    lastName: "Colon",
    title: "Secretary B",
    slug: "dawn-colon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ernesto Ernie",
    lastName: "Colorado Jr",
    title: "Director of Capital Project Management",
    slug: "ernesto-ernie-colorado-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer C",
    lastName: "Colozzi",
    title: "Chief of Staff",
    slug: "jennifer-c-colozzi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda B",
    lastName: "Colquhoun",
    title: "Senior Director of Stewardship & Donor Relations",
    slug: "linda-b-colquhoun",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric R",
    lastName: "Columbus",
    title: "Special Project Attorney",
    slug: "eric-r-columbus",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Matthew A",
    lastName: "Colunga",
    title: "Administrative Assistant",
    slug: "matthew-a-colunga",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cynthia",
    lastName: "Colurciello",
    title: "Revenue Cycle Manager",
    slug: "cynthia-colurciello",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Desirae",
    lastName: "Colvin",
    title: "Director, Special Projects",
    slug: "desirae-colvin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan D",
    lastName: "Comack",
    title: "Asst Dir, Budget/Fin Anlys",
    slug: "jonathan-d-comack",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Courtney",
    lastName: "Comart",
    title: "Associate Director, Advancement Services",
    slug: "courtney-comart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cynthia D.",
    lastName: "Combs",
    title: "Administrative Assistant",
    slug: "cynthia-d-combs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karyn C.",
    lastName: "Comeau",
    title: "Associate Director",
    slug: "karyn-c-comeau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cristina DArco",
    lastName: "Compton",
    title: "Director of Program Development",
    slug: "cristina-darco-compton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David Jeffrey",
    lastName: "Comroe",
    title: "Chief Information Officer",
    slug: "david-jeffrey-comroe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily Lynn",
    lastName: "Conan",
    title: "Certification Workshop Developer and Presenter (Interim Employee)",
    slug: "emily-lynn-conan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marin E.",
    lastName: "Conaughty",
    title: "Assistant Dean of Registration Services",
    slug: "marin-e-conaughty",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lourdes Antonia",
    lastName: "Conce",
    title: "Administrative Coordinator",
    slug: "lourdes-antonia-conce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lemuel",
    lastName: "Concepcion",
    title: "Sr Service Desk Specialist",
    slug: "lemuel-concepcion",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marion",
    lastName: "Concilio",
    title: "Associate Director. Financial Aid Client Services",
    slug: "marion-concilio",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patricia",
    lastName: "Conde",
    title: "Senior Director, HR/FA",
    slug: "patricia-conde",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Myriam C",
    lastName: "Congote Celis",
    title: "Health Indicator Coordinator",
    slug: "myriam-c-congote-celis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Quinn Alexandra",
    lastName: "Conklin",
    title: "Contractor",
    slug: "quinn-alexandra-conklin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bre Christinejones",
    lastName: "Conley",
    title: "Associate Director for Admission and Enrollment Management",
    slug: "bre-christinejones-conley",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Robert",
    lastName: "Conlon",
    title: "Asst Dir,Space Plan/Spec  Proj",
    slug: "robert-conlon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia",
    lastName: "Connelly",
    title: "Senior Writer, Development",
    slug: "patricia-connelly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maura",
    lastName: "Connelly",
    title: "Associate Director",
    slug: "maura-connelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth Lindsay",
    lastName: "Connelly",
    title: "Legal Project Manager",
    slug: "elizabeth-lindsay-connelly",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Christopher E",
    lastName: "Connelly",
    title: "Assistant Director",
    slug: "christopher-e-connelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan S.",
    lastName: "Conova",
    title: "Editorial Director",
    slug: "susan-s-conova",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cathy",
    lastName: "Conroy",
    title: "Administrative Coordinator",
    slug: "cathy-conroy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Antonio",
    lastName: "Consing",
    title: "Lab Aide",
    slug: "antonio-consing",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Manoushka L.",
    lastName: "Constant",
    title: "Senior Advising Dean",
    slug: "manoushka-l-constant",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erin Nicole",
    lastName: "Conti",
    title: "Senior Publicist",
    slug: "erin-nicole-conti",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Patricia",
    lastName: "Contino",
    title: "Administrative Assistant",
    slug: "patricia-contino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Contoveros",
    title: "Sr. Tax Accountant",
    slug: "maria-contoveros",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica Denise",
    lastName: "Contreras",
    title: "Program Manager",
    slug: "jessica-denise-contreras",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katharine Griffin Meehan",
    lastName: "Conway",
    title: "Vice Dean of Administration and Chief Operating Officer",
    slug: "katharine-griffin-meehan-conway",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jemima M.",
    lastName: "Conway",
    title: "Customer Srvc Representative",
    slug: "jemima-m-conway",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paige M",
    lastName: "Conwell",
    title: "Assistant Director of Human Resources",
    slug: "paige-m-conwell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Clarence K.",
    lastName: "Coo",
    title: "Interim Director of Academic Administration",
    slug: "clarence-k-coo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Taylor Grace",
    lastName: "Cook",
    title: "Associate Director for International Programs",
    slug: "taylor-grace-cook",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Paige Carmen",
    lastName: "Cook",
    title: "Assistant Director",
    slug: "paige-carmen-cook",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allyson C",
    lastName: "Cook",
    title: "Assistant Director - Columbia College Fund",
    slug: "allyson-c-cook",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Teresa Rita",
    lastName: "Coon",
    title: "Senior Executive Assistant",
    slug: "teresa-rita-coon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sharon Katz",
    lastName: "Cooper",
    title: "Education Officer",
    slug: "sharon-katz-cooper",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel",
    lastName: "Cooper",
    title: "Director of Curricular Innovation",
    slug: "daniel-cooper",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nina",
    lastName: "Cooper Beers",
    title: "Admissions Operations Specialist",
    slug: "nina-cooper-beers",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jermaine",
    lastName: "Coore",
    title: "Staff",
    slug: "jermaine-coore",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Willie V",
    lastName: "Copeland",
    title: "Senior Supervisor, ICM",
    slug: "willie-v-copeland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Copland",
    title: "Coordinator",
    slug: "jessica-copland",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Francesca",
    lastName: "Copperi",
    title: "Grant & Research Dev Associate",
    slug: "francesca-copperi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle",
    lastName: "Corbeaux",
    title: "Grants Manager, Center on Poverty and Social Policy (CPSP)",
    slug: "michelle-corbeaux",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sylvia Isabel",
    lastName: "Cordero",
    title: "Polar Field Assistant",
    slug: "sylvia-isabel-cordero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Genaro A",
    lastName: "Cordero",
    title: "User Services Manager",
    slug: "genaro-a-cordero",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeannette C",
    lastName: "Cordero-Rotger",
    title: "Director, Org Development-Ppl",
    slug: "jeannette-c-cordero-rotger",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Zury",
    lastName: "Cordova",
    title: "SYEP",
    slug: "zury-cordova",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sean J",
    lastName: "Corlett",
    title: "Chief of Organizational Development & Strategy",
    slug: "sean-j-corlett",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Maria Jimena",
    lastName: "Corley",
    title: "Assistant Director",
    slug: "maria-jimena-corley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kim Y",
    lastName: "Corley",
    title: "Senior Secretary",
    slug: "kim-y-corley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ardelys",
    lastName: "Corniel",
    title: "Administrative Assistant I",
    slug: "ardelys-corniel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cassandra M",
    lastName: "Cornier",
    title: "Front Desk Specialist",
    slug: "cassandra-m-cornier",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "David L.",
    lastName: "Cornwell",
    title: "Business Manager",
    slug: "david-l-cornwell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charles",
    lastName: "Corona",
    title: "Senior Cloud Architect",
    slug: "charles-corona",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patricia",
    lastName: "Coronado",
    title: "Administrative Assistant",
    slug: "patricia-coronado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Toni",
    lastName: "Correa",
    title: "Investigations Assistant",
    slug: "toni-correa",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Carlos",
    lastName: "Correa",
    title: "Dir, Student Enrollment Srvcs",
    slug: "carlos-correa",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Laura",
    lastName: "Corredor",
    title: "Asst. Vet Tech Supervisor",
    slug: "laura-corredor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francisco Jose",
    lastName: "Correia Graca Almeida",
    title: "VSI",
    slug: "francisco-jose-correia-graca-almeida",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natacha",
    lastName: "Cortes",
    title: "Administrative Coordinator",
    slug: "natacha-cortes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brianne",
    lastName: "Cortese",
    title: "Program Manager",
    slug: "brianne-cortese",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey V",
    lastName: "Cortez",
    title: "Technology Specialist, Database",
    slug: "jeffrey-v-cortez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anel",
    lastName: "Cortez",
    title: "Senior Grant and Research Development Specialist",
    slug: "anel-cortez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Danielle M.",
    lastName: "Corvacchioli",
    title: "Program Manager",
    slug: "danielle-m-corvacchioli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Cosentino",
    title: "Interim Hourly",
    slug: "joseph-cosentino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claudia",
    lastName: "Cosentino",
    title: "Program Manager",
    slug: "claudia-cosentino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicolas",
    lastName: "Cosme Jr",
    title: "Systems Coordinator",
    slug: "nicolas-cosme-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cristiane",
    lastName: "Costa",
    title: "Chief Operating Officer",
    slug: "cristiane-costa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isadora",
    lastName: "Costa Caldas",
    title: "Associate Director, MD-ICCCR",
    slug: "isadora-costa-caldas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather A",
    lastName: "Costello",
    title: "Senior Director, Systems Development",
    slug: "heather-a-costello",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Claire Stephanie",
    lastName: "Costello",
    title: "Executive Director, Administrative Affairs and Operations",
    slug: "claire-stephanie-costello",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janice E.",
    lastName: "Coston",
    title: "Administrative Assistant",
    slug: "janice-e-coston",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin Wade",
    lastName: "Cottrell",
    title: "Assistant Director - Housing Systems",
    slug: "justin-wade-cottrell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Samuel",
    lastName: "Coughlin",
    title: "Leadership Gift Officer I",
    slug: "samuel-coughlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maureen G.",
    lastName: "Coughlin",
    title: "Executive Director of Information Security",
    slug: "maureen-g-coughlin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joni Payne",
    lastName: "Coughlin",
    title: "Senior Associate Director, International",
    slug: "joni-payne-coughlin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ashley N.",
    lastName: "Courney",
    title: "Asst Director-Intl Travel",
    slug: "ashley-n-courney",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Olivier",
    lastName: "Couronne",
    title: "Executive Director/Nextgen Sequencing Core",
    slug: "olivier-couronne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mercedes Dominique",
    lastName: "Courter",
    title: "Health and Safety Specialist II",
    slug: "mercedes-dominique-courter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey",
    lastName: "Cousino",
    title: "Director, Administration",
    slug: "jeffrey-cousino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Candice",
    lastName: "Coutinho",
    title: "Finance and Compliance Manager, Sponsored Projects Finance",
    slug: "candice-coutinho",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Benjamin",
    lastName: "Covell",
    title: "LD. Application Systems Developer - EDM",
    slug: "benjamin-covell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karen R.",
    lastName: "Cover",
    title: "Associate Director-Career Svcs",
    slug: "karen-r-cover",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christopher Brandon",
    lastName: "Cox",
    title: "Assistant Director of Athletics Annual Funds",
    slug: "christopher-brandon-cox",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meaghan Elizabeth",
    lastName: "Crabill",
    title: "Associate, Investments",
    slug: "meaghan-elizabeth-crabill",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marshall Allister",
    lastName: "Craig",
    title: "Procurement Coordinator",
    slug: "marshall-allister-craig",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David J",
    lastName: "Craig",
    title: "Sr. Editor",
    slug: "david-j-craig",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Julie Bellware",
    lastName: "Crampton",
    title: "Deputy Director, Strategy and Operations",
    slug: "julie-bellware-crampton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua",
    lastName: "Crane",
    title: "Lab Manager - Renal",
    slug: "joshua-crane",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zelon E.",
    lastName: "Crawford",
    title: "Senior Associate Dean, Student Affairs",
    slug: "zelon-e-crawford",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tahirah D.",
    lastName: "Crawford",
    title: "Director of Multicultural Recruitment",
    slug: "tahirah-d-crawford",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nikolas Robert",
    lastName: "Crawford",
    title: "First Year Experience Coordinator",
    slug: "nikolas-robert-crawford",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dana",
    lastName: "Crawford",
    title: "Consultant",
    slug: "dana-crawford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lacarnly A.",
    lastName: "Creech",
    title: "Senior Service Specialist",
    slug: "lacarnly-a-creech",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deborah",
    lastName: "Creque",
    title: "Senior Business Manager",
    slug: "deborah-creque",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Helen",
    lastName: "Crescentini",
    title: "Associate, Academic Programs",
    slug: "helen-crescentini",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Letitia",
    lastName: "Crespo",
    title: "Administrative Manager",
    slug: "letitia-crespo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Crewe",
    title: "Associate Provost and Director of Columbia University Press",
    slug: "jennifer-crewe",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Taylor",
    lastName: "Crichton",
    title: "Associate Director of Special Events",
    slug: "taylor-crichton",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mignolia",
    lastName: "Crisostomo",
    title: "Referral and Authorization Specialist II",
    slug: "mignolia-crisostomo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan P",
    lastName: "Crisp",
    title: "Admissions CRM Administrator",
    slug: "ryan-p-crisp",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Alexandra",
    lastName: "Cristea-Platon",
    title: "Administrative Assistant",
    slug: "alexandra-cristea-platon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Clarissa G",
    lastName: "Cristian",
    title: "Admin Coordinator II,Audiology",
    slug: "clarissa-g-cristian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nikki",
    lastName: "Crocker",
    title: "Senior Category Manager, Contracts, Service & Technology",
    slug: "nikki-crocker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "April",
    lastName: "Croft",
    title: "Associate Director, SRI and Finance Communications",
    slug: "april-croft",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Caitlin",
    lastName: "Cronin",
    title: "Program Development Specialist",
    slug: "caitlin-cronin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chloe Colbert Coco",
    lastName: "Crookall",
    title: "Assistant Studio Manager",
    slug: "chloe-colbert-coco-crookall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alana Kathleen",
    lastName: "Crosby",
    title: "Senior Associate Director, Graduate Student Life & Development",
    slug: "alana-kathleen-crosby",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Timothy",
    lastName: "Cross",
    title: "Staff",
    slug: "timothy-cross",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cherylann",
    lastName: "Cross",
    title: "Guest Service Representative",
    slug: "cherylann-cross",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martin Charles",
    lastName: "Cross II",
    title: "Operations Coordinator",
    slug: "martin-charles-cross-ii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alan",
    lastName: "Crosswell",
    title: "AVP, Chief Tech Officer",
    slug: "alan-crosswell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leanne",
    lastName: "Crowder",
    title: "Coordinator",
    slug: "leanne-crowder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "McKenzie",
    lastName: "Crowe",
    title: "Generalist, HR/FA",
    slug: "mckenzie-crowe",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rose Y",
    lastName: "Crowley",
    title: "Interim Administrative Assistant",
    slug: "rose-y-crowley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Breckenridge",
    lastName: "Crum",
    title: "Master",
    slug: "breckenridge-crum",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brad O.",
    lastName: "Crutchfield",
    title: "Business Manager, Budget & Accounts Payable",
    slug: "brad-o-crutchfield",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yasmin",
    lastName: "Cruz",
    title: "Financial Coordinator",
    slug: "yasmin-cruz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Miguel",
    lastName: "Cruz",
    title: "Assistant Director of IT Projects",
    slug: "miguel-cruz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karen",
    lastName: "Cruz",
    title: "Finance Manager, Ed Programs",
    slug: "karen-cruz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gaspar J",
    lastName: "Cruz",
    title: "Project Coordinator II",
    slug: "gaspar-j-cruz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arnaldo L",
    lastName: "Cruz",
    title: "Coordinator-Safety/Security",
    slug: "arnaldo-l-cruz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alejandro",
    lastName: "Cruz",
    title: "Coord, Phleb Tring/Outpat Rsch",
    slug: "alejandro-cruz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Cruz",
    title: "Financial Assistant",
    slug: "anthony-cruz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carlos Ivan",
    lastName: "Cruz Rijos",
    title: "Systems Administrator",
    slug: "carlos-ivan-cruz-rijos",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lydia",
    lastName: "Cseh Dahling",
    title: "Assistant Director, Events Management",
    slug: "lydia-cseh-dahling",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey",
    lastName: "Csoka",
    title: "Director, Construction Sourcing",
    slug: "jeffrey-csoka",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lili C",
    lastName: "Csorba",
    title: "Program Manager, External Affairs and Communications",
    slug: "lili-c-csorba",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gabriella",
    lastName: "Cudjoe-Wilkes",
    title: "Staff",
    slug: "gabriella-cudjoe-wilkes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marena",
    lastName: "Cuevas",
    title: "Referrals and Authorization Specialist II",
    slug: "marena-cuevas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jadira",
    lastName: "Cuevas",
    title: "Administrative Assistant",
    slug: "jadira-cuevas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Cuevas",
    title: "Executive Assistant",
    slug: "elizabeth-cuevas",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Aracelis",
    lastName: "Cuevas",
    title: "Financial Aide Officer",
    slug: "aracelis-cuevas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nancy B",
    lastName: "Cuffy",
    title: "Business Manager",
    slug: "nancy-b-cuffy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey Marc",
    lastName: "Culang",
    title: "Editor",
    slug: "jeffrey-marc-culang",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Regina M.",
    lastName: "Cullen",
    title: "Integration Project Manager",
    slug: "regina-m-cullen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gregory C.",
    lastName: "Culler",
    title: "Executive Director of Research Partnerships/Initiatives",
    slug: "gregory-c-culler",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robin M",
    lastName: "Cumella",
    title: "Project Coordinator II",
    slug: "robin-m-cumella",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert Reed",
    lastName: "Cummings",
    title: "Associate Director, Administration - Political Analytics",
    slug: "robert-reed-cummings",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason",
    lastName: "Cummings",
    title: "Director-Budget/Administration",
    slug: "jason-cummings",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Megan M",
    lastName: "Cummins",
    title: "Associate Director - Communications",
    slug: "megan-m-cummins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Paulo M.",
    lastName: "Cunha",
    title:
      " Associate Director of Operations, Columbia Center on Sustainable Investment",
    slug: "paulo-m-cunha",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandon Thomas",
    lastName: "Cunnane",
    title: "Analytics Developer",
    slug: "brandon-thomas-cunnane",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Trudy-Ann",
    lastName: "Cunningham",
    title: "MPA",
    slug: "trudy-ann-cunningham",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maura S.",
    lastName: "Curran",
    title: "Administrative Manager",
    slug: "maura-s-curran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emerald",
    lastName: "Currie",
    title: "Director-Catering Sales",
    slug: "emerald-currie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grant P.",
    lastName: "Currin",
    title: "Writer, Editor",
    slug: "grant-p-currin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher",
    lastName: "Curry",
    title: "Manager, Financial Reporting",
    slug: "christopher-curry",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shawn I",
    lastName: "Curtis",
    title:
      " Associate Director for Development, Office of the Executive Vice President for University Development and Alumni Relations",
    slug: "shawn-i-curtis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ilana",
    lastName: "Curtis",
    title: "Assistant Director-Communications",
    slug: "ilana-curtis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andrea",
    lastName: "Curtis",
    title: "Audit Manager",
    slug: "andrea-curtis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth A",
    lastName: "Cusack",
    title: "Contracts Manager in the Department of Chemistry",
    slug: "elizabeth-a-cusack",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Theo",
    lastName: "Cutler",
    title: "Coordinator",
    slug: "theo-cutler",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Scott Nicholas",
    lastName: "Cutrone",
    title: "Executive Director of Admissions",
    slug: "scott-nicholas-cutrone",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kenneth Lloyd",
    lastName: "Cutts Jr",
    title: "Director of Marketing, Degree Programs",
    slug: "kenneth-lloyd-cutts-jr",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter H.",
    lastName: "Cymrot",
    title: "Associate General Counsel",
    slug: "peter-h-cymrot",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sheldon V",
    lastName: "Cyrus",
    title: "Senior Service Desk Specialist",
    slug: "sheldon-v-cyrus",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nancy",
    lastName: "D'Ambrosio",
    title: "Director of Principal Gifts",
    slug: "nancy-d-ambrosio",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melina",
    lastName: "D'Arduini",
    title: "Administrative Manager",
    slug: "melina-d-arduini",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Daniela",
    lastName: "D'Armetta",
    title: "Associate Director, EH&S HR",
    slug: "daniela-d-armetta",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Naima",
    lastName: "D'Ennery Dejoie",
    title: "Assistant Director, Admissions",
    slug: "naima-d-ennery-dejoie",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kimberly A.",
    lastName: "D'Eustachio",
    title: "Senior Director of Events",
    slug: "kimberly-a-d-eustachio",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rachel",
    lastName: "D'Orazio",
    title: "Patent Paralegal",
    slug: "rachel-d-orazio",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Marie",
    lastName: "D'Origny",
    title: "Administrative Director",
    slug: "marie-d-origny",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richeal S",
    lastName: "D'Rozario",
    title: "Program Manager",
    slug: "richeal-s-d-rozario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aline Sterk",
    lastName: "da Fonseca",
    title: "Technical Support Specialist",
    slug: "aline-sterk-da-fonseca",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Benita Y.",
    lastName: "Dace",
    title: "Administrative Assistant",
    slug: "benita-y-dace",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yijun",
    lastName: "Dai",
    title: "Instructional Designer",
    slug: "yijun-dai",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Odetta A.",
    lastName: "Daisley",
    title: "Human Resources Generalist",
    slug: "odetta-a-daisley",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Florence Emmanuela",
    lastName: "Dallas",
    title: "Assistant Director, Operations",
    slug: "florence-emmanuela-dallas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Timothy A",
    lastName: "Dalton",
    title: "Administration and Planning Coordinator",
    slug: "timothy-a-dalton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Dalton",
    title: "Assistant Director - Student Affairs",
    slug: "rebecca-dalton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kate E.",
    lastName: "Dalton",
    title: "Director of Research",
    slug: "kate-e-dalton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ashley Summers",
    lastName: "Dalton",
    title: "Associate Director of Research Strategy and Policy",
    slug: "ashley-summers-dalton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Latasha",
    lastName: "Daly",
    title: "Assistant Director of Administration, Enterprise Risk Management",
    slug: "latasha-daly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Venkat",
    lastName: "Damaraju",
    title: "Sr Director, People Soft & EDM Application",
    slug: "venkat-damaraju",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hannah M",
    lastName: "Dancy",
    title: "Project Coordinator",
    slug: "hannah-m-dancy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarina",
    lastName: "Dane",
    title: "Sr Project Portfolio Manager",
    slug: "sarina-dane",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nhi",
    lastName: "Dang",
    title: "Technical Project Manager",
    slug: "nhi-dang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ideta L.",
    lastName: "Daniel",
    title: "Director",
    slug: "ideta-l-daniel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth",
    lastName: "Daniel",
    title: "Director of Legal Strategy and Policy",
    slug: "elizabeth-daniel",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Alicha A",
    lastName: "Daniel",
    title: "Regulatory Manager",
    slug: "alicha-a-daniel",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jasmine Marie",
    lastName: "Daniels",
    title: "Live Support Specialist",
    slug: "jasmine-marie-daniels",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jarrell E.",
    lastName: "Daniels",
    title: "Project Director",
    slug: "jarrell-e-daniels",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josette",
    lastName: "Daniels",
    title: "Porter",
    slug: "josette-daniels",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura Marie",
    lastName: "Dankowski",
    title: "Specializations Coordinator",
    slug: "laura-marie-dankowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura P.",
    lastName: "Dannels",
    title: "Academic Program Support in Professional Studies",
    slug: "laura-p-dannels",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ian A.",
    lastName: "Danquah",
    title: "Instructional Technology Specialist",
    slug: "ian-a-danquah",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Fatma",
    lastName: "Dansoko",
    title: "Administrative Manager",
    slug: "fatma-dansoko",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jonathan",
    lastName: "Danziger",
    title: "Senior Writer",
    slug: "jonathan-danziger",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sharrol M.",
    lastName: "Dargan",
    title: "Assistant Secretary of the University",
    slug: "sharrol-m-dargan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John E",
    lastName: "Darlington",
    title: "Assoc Dir, Corp&Foundation Rel",
    slug: "john-e-darlington",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pallavi",
    lastName: "Das",
    title: "Academic Program Support in Professional Studies",
    slug: "pallavi-das",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephen M.",
    lastName: "Dashnaw",
    title: "Director of Research",
    slug: "stephen-m-dashnaw",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laura Queiroz",
    lastName: "Dasilva",
    title: "Accommodations Assistant",
    slug: "laura-queiroz-dasilva",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Parimal Kumar",
    lastName: "Datta",
    title: "Associate Director for Budget, Operations, and Reporting",
    slug: "parimal-kumar-datta",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shannon",
    lastName: "Daugherty",
    title: "Administrative Lab Manager",
    slug: "shannon-daugherty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Parixit",
    lastName: "Dave",
    title: "Senior Director, Emerging Technologies",
    slug: "parixit-dave",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mitali",
    lastName: "Dave",
    title: "Assistant Dean of Advising",
    slug: "mitali-dave",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Atul",
    lastName: "Dave",
    title: "Associate Director, Cash Accounting SPF",
    slug: "atul-dave",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julie K.",
    lastName: "Davenport",
    title: "Director, Admissions",
    slug: "julie-k-davenport",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Olamide",
    lastName: "David",
    title: "Project Coordinator",
    slug: "olamide-david",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natakii Theressa Ann",
    lastName: "David",
    title: "Associate Director, Strategy and Operations",
    slug: "natakii-theressa-ann-david",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle L",
    lastName: "David",
    title: "Project Coordinator II",
    slug: "michelle-l-david",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James L.",
    lastName: "David",
    title: "Sr. Project Director, HEALing Communities Study",
    slug: "james-l-david",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chezyrome Agcaoili",
    lastName: "David",
    title: "Coordinator",
    slug: "chezyrome-agcaoili-david",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Verlene",
    lastName: "Davidson",
    title: "Associate Director for Centers and Programs",
    slug: "verlene-davidson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Linara",
    lastName: "Davidson Greenidge",
    title:
      " Senior Associate Dean for Communications Strategy, Development and Alumni Affairs",
    slug: "linara-davidson-greenidge",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brian P.",
    lastName: "Davie",
    title: "Technical Specialist",
    slug: "brian-p-davie",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicolas A.",
    lastName: "Davila",
    title: "Director, Human Resources",
    slug: "nicolas-a-davila",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Shannon L",
    lastName: "Davis",
    title: "Director, Strategic Events",
    slug: "shannon-l-davis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rakesha L",
    lastName: "Davis",
    title: "Sr Dir,IT Serv Dlvry User  Svc",
    slug: "rakesha-l-davis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rhonda",
    lastName: "Davis",
    title: "MPA",
    slug: "rhonda-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ruth",
    lastName: "Davis",
    title: "Charge / Clims Edit Spec.",
    slug: "ruth-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mel",
    lastName: "Davis",
    title: "Associate Director of Space Management",
    slug: "mel-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Davis",
    title: "Onboarding Specialist II",
    slug: "maria-davis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Leondra",
    lastName: "Davis",
    title: "MPA",
    slug: "leondra-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kieshia R.",
    lastName: "Davis",
    title: "Deputy Director, Accounts Payable",
    slug: "kieshia-r-davis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jewelnel",
    lastName: "Davis",
    title: "University Chaplain",
    slug: "jewelnel-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jordan",
    lastName: "Davis",
    title: "Associate Director",
    slug: "jordan-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isoke",
    lastName: "Davis",
    title: "Assistant Director Operations",
    slug: "isoke-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace",
    lastName: "Davis",
    title: "Assistant Director of Graduate Student Life and Development",
    slug: "grace-davis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emily Anne Abbott",
    lastName: "Davis",
    title: "Director, Advancement Services",
    slug: "emily-anne-abbott-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elijah Jelani",
    lastName: "Davis",
    title: "Associate Director of Web and UX Development",
    slug: "elijah-jelani-davis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Enrika D.",
    lastName: "Davis",
    title: "Director of Academic Administration",
    slug: "enrika-d-davis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Camille",
    lastName: "Davis",
    title: "SYEP",
    slug: "camille-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James E.",
    lastName: "Davis III",
    title: "Steward",
    slug: "james-e-davis-iii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marri",
    lastName: "Davis Moffly",
    title: "Department Administrator",
    slug: "marri-davis-moffly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristin",
    lastName: "Davitt",
    title: "Sr Vice President, Development",
    slug: "kristin-davitt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anahita",
    lastName: "Davoudi",
    title: "Guest",
    slug: "anahita-davoudi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zoya",
    lastName: "Davydov",
    title: "Referrals and Authorization Specialist III",
    slug: "zoya-davydov",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David L",
    lastName: "Dawson",
    title: "Director, Fin Analys Planning",
    slug: "david-l-dawson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Traci",
    lastName: "Day",
    title: "Brickman Miller UI",
    slug: "traci-day",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan M.",
    lastName: "Day",
    title:
      " Director of Professional Development and Leadership and Graduate Career Placement",
    slug: "ryan-m-day",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Christopher A.",
    lastName: "Day",
    title: "Assistant Director-AV",
    slug: "christopher-a-day",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adrienne V.",
    lastName: "Day",
    title: "Content Manager",
    slug: "adrienne-v-day",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sanjay",
    lastName: "De",
    title: "Senior Grants Manager",
    slug: "sanjay-de",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Saskia D.",
    lastName: "De Caires",
    title: "Senior Director for Development and Deputy Chief of Staff",
    slug: "saskia-d-de-caires",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paulette",
    lastName: "De Jesus",
    title: "Admissions Specialist I",
    slug: "paulette-de-jesus",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Luis Claudio",
    lastName: "de Jesus",
    title: "Associate Director, Executive Education",
    slug: "luis-claudio-de-jesus",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Johaira",
    lastName: "De Jesus",
    title: "Administrative Coordinator",
    slug: "johaira-de-jesus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charlene",
    lastName: "De Jesus",
    title: "Administrative Coordinator",
    slug: "charlene-de-jesus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Johana",
    lastName: "de Jesus Pagan",
    title: "Human Resources Generalist",
    slug: "johana-de-jesus-pagan",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Shayna K",
    lastName: "De la Cruz",
    title: "Secretary B",
    slug: "shayna-k-de-la-cruz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maggie",
    lastName: "De La Cuesta",
    title: "Senior Manager, Academic Appointment and Payroll",
    slug: "maggie-de-la-cuesta",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Suzann D",
    lastName: "De La Pena",
    title: "Associate Director of Finance",
    slug: "suzann-d-de-la-pena",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alejandro",
    lastName: "De la Rosa",
    title: "Junior User Support Specialist (Client Services)",
    slug: "alejandro-de-la-rosa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "De Lannoy",
    title: "Senior Director, Development Operations and Alumni Engagement",
    slug: "jennifer-de-lannoy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Val",
    lastName: "De Leon",
    title: "Academic Secretary, Programs in Education Leadership",
    slug: "val-de-leon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Thomas",
    lastName: "De Leon",
    title: "Dir, HR Systems and Operations",
    slug: "thomas-de-leon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Erwin S.",
    lastName: "de Leon",
    title:
      " Lecturer in the Discipline of Nonprofit Management in the Faculty of Professional Studies; Chief Diversity Officer, School of Professional Studies",
    slug: "erwin-s-de-leon",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Michael A.",
    lastName: "De Lucia",
    title: "Executive Director, International and MS Career Management",
    slug: "michael-a-de-lucia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Caroline Ross",
    lastName: "de Marneffe",
    title:
      " Development Assistant, Donor Relations and Marketing Strategy and Enablement",
    slug: "caroline-ross-de-marneffe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cheryl L",
    lastName: "de Moose",
    title: "Director of Administration",
    slug: "cheryl-l-de-moose",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Danielly",
    lastName: "De Paiva Magalhaes",
    title: "Senior Project Manager",
    slug: "danielly-de-paiva-magalhaes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nikolai A",
    lastName: "De Vera",
    title: "Administrative Coordinator",
    slug: "nikolai-a-de-vera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tanner Rick",
    lastName: "Dean",
    title: "Dear Mama Employee",
    slug: "tanner-rick-dean",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stuart Ramsay",
    lastName: "Deans",
    title: "Compliance & Training Coord",
    slug: "stuart-ramsay-deans",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Merci M.",
    lastName: "Decker",
    title: "Academic Program Support in Professional Studies",
    slug: "merci-m-decker",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David J.",
    lastName: "DeClercq",
    title: "Sr Assc Dean, Strat Fin & Bus",
    slug: "david-j-declercq",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Caitlin Price",
    lastName: "DeClercq",
    title: "Senior Assistant Director, Graduate Student Programs and Services",
    slug: "caitlin-price-declercq",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Venkat",
    lastName: "Deenamsetty",
    title: "Sr. Application Systems Administrator",
    slug: "venkat-deenamsetty",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leyri",
    lastName: "Defrank-Paulino",
    title: "Manager, Grants and Finance",
    slug: "leyri-defrank-paulino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elaine Marie",
    lastName: "Defuria",
    title: "Coding Specialist",
    slug: "elaine-marie-defuria",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Miles Q",
    lastName: "DeGrazia",
    title: "Research Program Director",
    slug: "miles-q-degrazia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Aimee",
    lastName: "DeGrazia",
    title: "Exec Asst & Admissions Coord",
    slug: "aimee-degrazia",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Amy Jill",
    lastName: "Deiner",
    title: "Director of Academic Program Planning",
    slug: "amy-jill-deiner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "George",
    lastName: "DeJesus",
    title: "Call Center Coordinator",
    slug: "george-dejesus",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sebastian Jerome",
    lastName: "Deken",
    title: "Dir,Development Communications",
    slug: "sebastian-jerome-deken",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rene M",
    lastName: "Deknatel",
    title: "Procurement Supervisor",
    slug: "rene-m-deknatel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandra",
    lastName: "Del Guercio",
    title: "Academic Program Support in Professional Studies",
    slug: "sandra-del-guercio",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pamela",
    lastName: "Del Rosario",
    title: "Project Coordinator II",
    slug: "pamela-del-rosario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carlos",
    lastName: "del Rosario",
    title: "Broadcast and Multimedia Specialist",
    slug: "carlos-del-rosario",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eugene",
    lastName: "Dela Cruz",
    title: "OnBase Administrator",
    slug: "eugene-dela-cruz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Synyah L.",
    lastName: "Delancey Jordan",
    title: "MPA",
    slug: "synyah-l-delancey-jordan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Whitney R.",
    lastName: "Delaney",
    title: "Marketing Director",
    slug: "whitney-r-delaney",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rebecca Rose",
    lastName: "Delaney",
    title: "Senior Manager of HR & Academic Appointments",
    slug: "rebecca-rose-delaney",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sandy",
    lastName: "Deleon",
    title: "Technical Product Manager, SIS Operations & Support",
    slug: "sandy-deleon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sanny",
    lastName: "Deleon",
    title: "Executive Assistant",
    slug: "sanny-deleon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole Marie",
    lastName: "DeLeon",
    title: "Asst Director-Career Dev/Emp R",
    slug: "nicole-marie-deleon",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jenilees",
    lastName: "Deleon",
    title: "SubAward Administrator",
    slug: "jenilees-deleon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gisselle C",
    lastName: "Deleon",
    title: "Onboarding Specialist II",
    slug: "gisselle-c-deleon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Emmanuel",
    lastName: "Deleon",
    title: "Service Specialist",
    slug: "emmanuel-deleon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dawn Joy",
    lastName: "DeLeon",
    title: "Senior Executive Director of Development",
    slug: "dawn-joy-deleon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carmen",
    lastName: "DeLeon",
    title: "Associate Provost for Academic Appointments",
    slug: "carmen-deleon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joanne Marie",
    lastName: "Delgadillo",
    title: "Interim Title IX Coordinator",
    slug: "joanne-marie-delgadillo",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Vanessa",
    lastName: "Delgado",
    title: "Customer Service Representative",
    slug: "vanessa-delgado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Theresa S.",
    lastName: "Delgado",
    title: "Associate Director of Operations",
    slug: "theresa-s-delgado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria J.",
    lastName: "Delgado",
    title: "Executive Dir of SpacePlanning",
    slug: "maria-j-delgado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Iris Vanessa",
    lastName: "Delgado-Negron",
    title: "Administrative Coordinator",
    slug: "iris-vanessa-delgado-negron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Deliard",
    title: "Billing Coordinator",
    slug: "jennifer-deliard",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elisabeth A.",
    lastName: "Delle Chiaie",
    title: "Executive Assistant",
    slug: "elisabeth-a-delle-chiaie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley L",
    lastName: "Delphia",
    title: "Director of Academic Administration",
    slug: "ashley-l-delphia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mirtha",
    lastName: "Delvalle",
    title: "Assoc Dir, Grants & Finance",
    slug: "mirtha-delvalle",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sheyla",
    lastName: "Delvecchio",
    title: "Project Coordinator",
    slug: "sheyla-delvecchio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey L.",
    lastName: "DeMars",
    title: "Director of Outreach, MRSEC",
    slug: "jeffrey-l-demars",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth W.",
    lastName: "Demissie",
    title: "Grants and Contracts Manager",
    slug: "elizabeth-w-demissie",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "CloEve J",
    lastName: "Demmer",
    title: "Deputy Vice President for OAD Programs",
    slug: "cloeve-j-demmer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kiara I",
    lastName: "Demorla Ozuna",
    title: "Genetic Counselor Assistant",
    slug: "kiara-i-demorla-ozuna",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason K.",
    lastName: "Dempsey",
    title:
      " Interim Executive Director for the Central for Veterans Transition and Integration",
    slug: "jason-k-dempsey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melina",
    lastName: "Denebeim",
    title: "Program Director",
    slug: "melina-denebeim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yuhan",
    lastName: "Deng",
    title: "Program Photograph: A&H Department",
    slug: "yuhan-deng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colleen",
    lastName: "Deng",
    title: "Creative Director",
    slug: "colleen-deng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Romina",
    lastName: "DeNicola",
    title: "Contractor",
    slug: "romina-denicola",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anthony J",
    lastName: "Denis",
    title: "Assoc Director, Financial Mgmt",
    slug: "anthony-j-denis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David F.",
    lastName: "Denman",
    title: "Manager, Capital Asset Accounting",
    slug: "david-f-denman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Princess G.",
    lastName: "Dennis",
    title: "Department Administrator, Practicum Learning",
    slug: "princess-g-dennis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily",
    lastName: "Dennis",
    title: "Assistant Director-Student Affairs",
    slug: "emily-dennis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hameer",
    lastName: "Deo",
    title:
      " Assistant Director of Administration & Planning, Travel Coordinator",
    slug: "hameer-deo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edison",
    lastName: "Deossa",
    title: "Wait Staff",
    slug: "edison-deossa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carmen Rita",
    lastName: "Depasquale",
    title: "Sr. Payroll Tax Accountant",
    slug: "carmen-rita-depasquale",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Grace M.",
    lastName: "Derks",
    title: "Assoc Director, Development",
    slug: "grace-m-derks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Dermakardijian",
    title: "Administrative Assistant",
    slug: "christine-dermakardijian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole Marie",
    lastName: "deRoberts",
    title: "Assistant Director of Academic Affairs for LDEO",
    slug: "nicole-marie-deroberts",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Charles D.",
    lastName: "DeRubeis",
    title: "Assistant Dean of Financial Aid",
    slug: "charles-d-derubeis",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Anjani",
    lastName: "Desai",
    title: "Senior Web Developer (.Net)",
    slug: "anjani-desai",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melissa",
    lastName: "DeSimone",
    title: "Development Associate",
    slug: "melissa-desimone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "DesMarais",
    title: "Associate Director, Payroll Operations",
    slug: "melissa-desmarais",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Daphne",
    lastName: "Desrouleaux",
    title: "Associate Director for Development and Campaign Operations",
    slug: "daphne-desrouleaux",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Frank Joseph",
    lastName: "DeStefano",
    title: "Media Producer",
    slug: "frank-joseph-destefano",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brittney Mae",
    lastName: "Destin",
    title: "Assoc Director-Alliance Mgmt",
    slug: "brittney-mae-destin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sherley",
    lastName: "Desulme Willis",
    title: "Senior HR Business Partner",
    slug: "sherley-desulme-willis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Amy E",
    lastName: "Devine-Keum",
    title: "Program Manager-Graduates",
    slug: "amy-e-devine-keum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angela",
    lastName: "Dewey",
    title: "Adjunct Assistant",
    slug: "angela-dewey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Barbara L.",
    lastName: "Diamond",
    title: "Director of Institutional Giving",
    slug: "barbara-l-diamond",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Damaris Villafana",
    lastName: "Dias",
    title: "Assistant Director of Academic Enrollment",
    slug: "damaris-villafana-dias",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marta",
    lastName: "Dias Pinheiro Cabral",
    title: "Early Childhood Teaching Artist",
    slug: "marta-dias-pinheiro-cabral",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Walter",
    lastName: "Diaz",
    title: "Software Developer",
    slug: "walter-diaz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rudy A.",
    lastName: "Diaz",
    title: "Video Producer",
    slug: "rudy-a-diaz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michelle",
    lastName: "Diaz",
    title: "Authorization and Referral Specialist II",
    slug: "michelle-diaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kiana",
    lastName: "Diaz",
    title: "CUMC Payroll Admin Assistant",
    slug: "kiana-diaz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katherine",
    lastName: "Diaz",
    title: "Administrative Aide",
    slug: "katherine-diaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Krystal Ashley",
    lastName: "Diaz",
    title: "Live Support Specialist",
    slug: "krystal-ashley-diaz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erica",
    lastName: "Diaz",
    title: "Manager, Executive Support and Events",
    slug: "erica-diaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bismark",
    lastName: "Diaz",
    title: "Administrative Assistant",
    slug: "bismark-diaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony G.",
    lastName: "Diaz",
    title: "Administrative Aide",
    slug: "anthony-g-diaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Diaz",
    title:
      " Associate Director, Student Affairs (High School & Non-Degree Programs)",
    slug: "amanda-diaz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Daniela",
    lastName: "Diaz Caro",
    title: "Research Genetic Counselor",
    slug: "daniela-diaz-caro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zamaly",
    lastName: "Diaz Lebron",
    title: "Manager - Department Admin",
    slug: "zamaly-diaz-lebron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yissel",
    lastName: "Diaz Ruiz",
    title: "Accountant Student Financial Services",
    slug: "yissel-diaz-ruiz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Abel M.",
    lastName: "Diaz Valladares",
    title: "Assoc Dir, Financial Planning",
    slug: "abel-m-diaz-valladares",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Adela",
    lastName: "Diaz-Clase",
    title: "Transaction Coordinator",
    slug: "adela-diaz-clase",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Diaz-Gil",
    title: "Department Administrator",
    slug: "maria-diaz-gil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Delilah",
    lastName: "DiCioccio",
    title: "Administrative Assistant",
    slug: "delilah-dicioccio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Calinda Javonne",
    lastName: "Dickerson",
    title: "Associate Director, Donor Relations and Stewardship",
    slug: "calinda-javonne-dickerson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paulina Jennifer",
    lastName: "Diefenbach",
    title: "Officer-Contract Negotiations",
    slug: "paulina-jennifer-diefenbach",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Robert James",
    lastName: "DiGangi",
    title: "Associate Director, Student Conduct",
    slug: "robert-james-digangi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jude Bagasala",
    lastName: "Digao",
    title: "Instructional Support Associate-Technology Team",
    slug: "jude-bagasala-digao",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Edward R.",
    lastName: "Dijoseph",
    title: "Deputy Secretary",
    slug: "edward-r-dijoseph",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard A",
    lastName: "Dikeman",
    title: "Director of Institutional Research and Summer Programs",
    slug: "richard-a-dikeman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lacey",
    lastName: "Dikkers",
    title: "Senior Admissions Officer",
    slug: "lacey-dikkers",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Maria D.",
    lastName: "Dilbert",
    title: "Director, Acad Admin & Finance",
    slug: "maria-d-dilbert",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eric A",
    lastName: "Dillalogue",
    title: "Director of Administration",
    slug: "eric-a-dillalogue",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eunice",
    lastName: "Dilone",
    title: "Administrative Assistant",
    slug: "eunice-dilone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angeline J",
    lastName: "Dimambro",
    title: "Communications Manager, Media",
    slug: "angeline-j-dimambro",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elisabeth Swift",
    lastName: "DiMaria",
    title: "AsocDir,CL/Trans Rsch Init/Ops",
    slug: "elisabeth-swift-dimaria",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie A",
    lastName: "DiMattia",
    title: "Administrative Coordinator",
    slug: "natalie-a-dimattia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Veselin",
    lastName: "Dimitrov",
    title: "Senior Systems Administrator",
    slug: "veselin-dimitrov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leah K",
    lastName: "Dimond",
    title: "Director, HR/FA",
    slug: "leah-k-dimond",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Guixiao",
    lastName: "Ding",
    title: "Data Coordinator",
    slug: "guixiao-ding",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dannie Belle",
    lastName: "Dinh",
    title: "Program Officer",
    slug: "dannie-belle-dinh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley Marie",
    lastName: "Diodonet",
    title: "Education Coordinator",
    slug: "ashley-marie-diodonet",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bassirou",
    lastName: "Diop",
    title: "Media Support Specialist",
    slug: "bassirou-diop",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nandranie",
    lastName: "Dioquino",
    title: "Systems Specialist, Financial Aid Operations",
    slug: "nandranie-dioquino",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cheikh",
    lastName: "Dioum",
    title: "Manager, Data Maintenance and Integrity",
    slug: "cheikh-dioum",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elliot",
    lastName: "Diringer",
    title: "Consultant",
    slug: "elliot-diringer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ian David",
    lastName: "DiSalvo",
    title: "Videographer",
    slug: "ian-david-disalvo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael",
    lastName: "DiSarno",
    title: "Senior Executive Director for Alumni Relations",
    slug: "michael-disarno",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ernest",
    lastName: "Dix",
    title: "Senior Student Services Rep",
    slug: "ernest-dix",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Isabella D.",
    lastName: "Dixon",
    title: "Grants Coordinator",
    slug: "isabella-d-dixon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chanel",
    lastName: "Dixon",
    title: "Surgical Scheduler",
    slug: "chanel-dixon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alicia M",
    lastName: "Dixon",
    title: "Supervisor, Call Center",
    slug: "alicia-m-dixon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tam Ngoc",
    lastName: "Do",
    title: "Associate Director of Grants & Finance",
    slug: "tam-ngoc-do",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julie M",
    lastName: "Dobrow",
    title: "Dean of Admissions and Financial Aid",
    slug: "julie-m-dobrow",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jamaine",
    lastName: "Dobson",
    title: "Input Control Specialist",
    slug: "jamaine-dobson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katrina L.",
    lastName: "Dock",
    title: "Administrative Assistant",
    slug: "katrina-l-dock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas K",
    lastName: "Dodd",
    title: "Assistant Director, Development Marketing",
    slug: "nicholas-k-dodd",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathleen",
    lastName: "Dodd",
    title: "Director, Financial Management",
    slug: "kathleen-dodd",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Erin",
    lastName: "Dodd",
    title: "Vice Dean for Development and Alumni Relations",
    slug: "erin-dodd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosemary",
    lastName: "Dodemaide",
    title: "Associate Director for Budget and Finance",
    slug: "rosemary-dodemaide",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Goutham",
    lastName: "Dodla",
    title: "Sr Application Systems Developer",
    slug: "goutham-dodla",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Meave",
    lastName: "Doherty",
    title: "Associate Director Major Gifts",
    slug: "meave-doherty",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meaghan",
    lastName: "Doherty",
    title: "Project Manager",
    slug: "meaghan-doherty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward J",
    lastName: "Doherty Jr",
    title: "Exec Director, Web Services",
    slug: "edward-j-doherty-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa M.",
    lastName: "Dolberry Hancock",
    title: "Director of Learning and Innovation",
    slug: "lisa-m-dolberry-hancock",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Wildelinda",
    lastName: "Dominguez",
    title: "MRI Manager",
    slug: "wildelinda-dominguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mariela",
    lastName: "Dominguez",
    title: "Administrative Coordinator",
    slug: "mariela-dominguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Genovee V.",
    lastName: "Dominguez",
    title: "Residence Hall Director",
    slug: "genovee-v-dominguez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Delgi",
    lastName: "Dominguez",
    title: "Coding Charge Edits Spc III",
    slug: "delgi-dominguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christian",
    lastName: "Dominguez",
    title: "Asst Service Desk Tech-Tier I",
    slug: "christian-dominguez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andry",
    lastName: "Dominguez",
    title: "Executive Assistant",
    slug: "andry-dominguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter A.",
    lastName: "Donatich",
    title: "Executive Assistant",
    slug: "peter-a-donatich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yueming",
    lastName: "Dong",
    title: "Employer Relations Specialist",
    slug: "yueming-dong",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Andrew",
    lastName: "Donini",
    title: "Concentration Manager",
    slug: "andrew-donini",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Flor A.",
    lastName: "Donoso",
    title: "Guest Service Representative",
    slug: "flor-a-donoso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathy",
    lastName: "Donovan",
    title: "Administrative Coordinator",
    slug: "kathy-donovan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jack B.",
    lastName: "Donovan",
    title: "Lead Applications Developer",
    slug: "jack-b-donovan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Haley M.",
    lastName: "Donovan",
    title: "Academic Programs Coordinator",
    slug: "haley-m-donovan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Caroline Isabel",
    lastName: "Donovan",
    title: "Assistant Director, Institute of Global Politics",
    slug: "caroline-isabel-donovan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julia B.",
    lastName: "Dooley",
    title: "Assistant Director of Student Engagement",
    slug: "julia-b-dooley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Daniella",
    lastName: "Dorancy",
    title: "Evaluation Specialist",
    slug: "daniella-dorancy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christelle Elle",
    lastName: "Dorce",
    title: "Manager, HR Processing Center Initiatives",
    slug: "christelle-elle-dorce",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Benjamin Warner",
    lastName: "Dorr",
    title: "Associate Director, Marketing Optimization and Integration",
    slug: "benjamin-warner-dorr",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Travis W",
    lastName: "Dorville",
    title: "Generalist, HR/FA",
    slug: "travis-w-dorville",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Silas",
    lastName: "Dottor",
    title: "Project Coordinator, DEI",
    slug: "silas-dottor",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Chris Michael",
    lastName: "Doucet",
    title: "Manager, Systems Administration",
    slug: "chris-michael-doucet",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew J",
    lastName: "Dougherty",
    title: "Director",
    slug: "matthew-j-dougherty",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alison",
    lastName: "Dougherty",
    title: "Grants Administrator",
    slug: "alison-dougherty",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Renee A.",
    lastName: "Douglas",
    title: "Director of Administration and Finance",
    slug: "renee-a-douglas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Myles",
    lastName: "Douglas",
    title: "Assistant Director, Academic Advising and Student Success",
    slug: "myles-douglas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer C.",
    lastName: "Douglas",
    title: "Assistant Director International Student Services",
    slug: "jennifer-c-douglas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elisa",
    lastName: "Douglas",
    title: "Director, Alumni Engagement and Programs",
    slug: "elisa-douglas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Crystal",
    lastName: "Dow",
    title: "Associate Director of Curriculum",
    slug: "crystal-dow",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chris",
    lastName: "Dowden",
    title: "Senior Director, Identity and Access Management",
    slug: "chris-dowden",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Keeley Cormac",
    lastName: "Dower",
    title: "Senior Development Associate",
    slug: "keeley-cormac-dower",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sophia Genevieve",
    lastName: "Dowling",
    title: "Project Coordinator",
    slug: "sophia-genevieve-dowling",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colin Michael",
    lastName: "Downes",
    title: "Manager-Catering Ops",
    slug: "colin-michael-downes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine",
    lastName: "Downey",
    title: "Associate Director, Social Media",
    slug: "catherine-downey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christina",
    lastName: "Doyle",
    title: "Department Administrator",
    slug: "christina-doyle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly Alison",
    lastName: "Doyle",
    title: "Director-Academic Admin",
    slug: "kelly-alison-doyle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rachel M.",
    lastName: "Dozier-Ezell",
    title: "Costume Supervisor",
    slug: "rachel-m-dozier-ezell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jody Lee",
    lastName: "Drafta",
    title: "Manager-Title IX",
    slug: "jody-lee-drafta",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Mara",
    lastName: "Draica",
    title: "Assistant Director, Engagement Content",
    slug: "mara-draica",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Douglas O.",
    lastName: "Drake",
    title: "Administrative Assistant",
    slug: "douglas-o-drake",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adiza",
    lastName: "Dramani",
    title: "SYEP",
    slug: "adiza-dramani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Dreher",
    title: "Application Developer Team Lead",
    slug: "susan-dreher",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Breanna",
    lastName: "Drew",
    title: "Assistant Director, Admissions",
    slug: "breanna-drew",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Alfred H.",
    lastName: "Drewes",
    title: "Exec in Residence",
    slug: "alfred-h-drewes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily M",
    lastName: "Driehaus",
    title: "Assistant Editor",
    slug: "emily-m-driehaus",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Juliana",
    lastName: "Driever",
    title: "Dir, Academic Admin & Finance",
    slug: "juliana-driever",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel L.",
    lastName: "Driscoll",
    title: "Vice President and Chief Human Resources Officer",
    slug: "daniel-l-driscoll",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Betty Ann",
    lastName: "Driver",
    title: "Department Secretary",
    slug: "betty-ann-driver",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danna",
    lastName: "Drori",
    title: "Associate General Counsel",
    slug: "danna-drori",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Lucy",
    lastName: "Drotning",
    title: "Associate Provost for Institutional Effectiveness",
    slug: "lucy-drotning",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Greg S",
    lastName: "Drozdek",
    title: "Enrichment Facilitator in The School",
    slug: "greg-s-drozdek",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Iurii S",
    lastName: "Druchuk",
    title: "Systems Administrator",
    slug: "iurii-s-druchuk",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Donna",
    lastName: "Drucker",
    title: "Asst Dir,Off of Schshp&Res Dev",
    slug: "donna-drucker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wanglei",
    lastName: "Du",
    title: "Administrative Coordinator",
    slug: "wanglei-du",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea Carolina",
    lastName: "Duarte Ojeda",
    title: "Assistant Director of Financial Aid",
    slug: "andrea-carolina-duarte-ojeda",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ines L.",
    lastName: "Dubbels",
    title: "Business Manager",
    slug: "ines-l-dubbels",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Latisha Rahemia",
    lastName: "DuBose",
    title: "Administrative Coordinator",
    slug: "latisha-rahemia-dubose",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica Lee",
    lastName: "Dudek",
    title: "Director of the Transdisciplinary Behavior Analytic Program",
    slug: "jessica-lee-dudek",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah Elizabeth",
    lastName: "Duer",
    title: "Director, Hollingworth Preschool",
    slug: "sarah-elizabeth-duer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pamela L",
    lastName: "Duffy",
    title: "Executive Director, HR/FA",
    slug: "pamela-l-duffy",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Megan Margaret",
    lastName: "Duffy",
    title: "Assistant Director of Alumni Relations",
    slug: "megan-margaret-duffy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Doreen E.",
    lastName: "Duffy",
    title: "Director of Alumni Relations",
    slug: "doreen-e-duffy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dorian",
    lastName: "Dufore",
    title: "Administrative Aide",
    slug: "dorian-dufore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carol E.",
    lastName: "Duigou",
    title: "Administrative Coordinator",
    slug: "carol-e-duigou",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abaigael",
    lastName: "Duke",
    title: "Recovery Specialist and Trainer Supervisor",
    slug: "abaigael-duke",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elise",
    lastName: "Dunaway",
    title: "Communications Associate",
    slug: "elise-dunaway",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christine",
    lastName: "Dunbar",
    title: "Editorial Director",
    slug: "christine-dunbar",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lauryn Joseph",
    lastName: "Duncan",
    title: "Community Engagement Officer",
    slug: "lauryn-joseph-duncan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alanna C.",
    lastName: "Duncan",
    title: "Development Director",
    slug: "alanna-c-duncan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tanisha",
    lastName: "Duncan-Brown",
    title: "Scheduling Coordinator",
    slug: "tanisha-duncan-brown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean Lee",
    lastName: "Dundas",
    title: "Senior Media Producer",
    slug: "sean-lee-dundas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kareen K.",
    lastName: "Dunkley-Richards",
    title: "Administrative Manager",
    slug: "kareen-k-dunkley-richards",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tyler J",
    lastName: "Dunn",
    title: "Divisional Administrator",
    slug: "tyler-j-dunn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evan",
    lastName: "Dunn",
    title: "Associate Director, Web Operations",
    slug: "evan-dunn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Renson A.",
    lastName: "Duran",
    title: "Print Services Clerk",
    slug: "renson-a-duran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicolas Rico",
    lastName: "Duran",
    title: "Assistant Director, Events",
    slug: "nicolas-rico-duran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keyra A",
    lastName: "Duran",
    title: "Billing Coordinator",
    slug: "keyra-a-duran",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joselin",
    lastName: "Duran",
    title: "Administrative Clerk",
    slug: "joselin-duran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dalila R.",
    lastName: "Duran",
    title: "Executive Assistant",
    slug: "dalila-r-duran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yolanda",
    lastName: "Durant",
    title: "Sr Administrative Coordinator",
    slug: "yolanda-durant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria T",
    lastName: "Durden",
    title: "Director, Learning and Development",
    slug: "victoria-t-durden",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Celina M",
    lastName: "Durgin",
    title: "Program Manager",
    slug: "celina-m-durgin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Durham",
    title: "Communications Officer",
    slug: "sarah-durham",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathleen J.",
    lastName: "Durkin",
    title: "Director, MR Research Administration",
    slug: "kathleen-j-durkin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Misti M.",
    lastName: "Duvall",
    title: "Writing Specialist",
    slug: "misti-m-duvall",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Miriam",
    lastName: "Duverge",
    title: "User Services Consultant Temp",
    slug: "miriam-duverge",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yaa A",
    lastName: "Dwamena",
    title: "Director of Financial Aid",
    slug: "yaa-a-dwamena",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Calan",
    lastName: "Dwyer",
    title: "Assistant Director of Business Operations",
    slug: "calan-dwyer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Daniel L.",
    lastName: "Dykema",
    title: "Manager, Network Field Services",
    slug: "daniel-l-dykema",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pamela A",
    lastName: "Dykes",
    title: "Senior Generalist, HR/FA",
    slug: "pamela-a-dykes",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jessica C.",
    lastName: "Dzaman",
    title: "Advising Dean",
    slug: "jessica-c-dzaman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Colin Stewart",
    lastName: "Eagens",
    title: "Assistant Registrar, Course Management",
    slug: "colin-stewart-eagens",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hussein",
    lastName: "Ebied",
    title: "Marketing Manager",
    slug: "hussein-ebied",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amanda S.",
    lastName: "Eckler",
    title: "Executive Director",
    slug: "amanda-s-eckler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara E.",
    lastName: "Ede",
    title: "Senior Assistant Dean of Advising, Director of Dual BA Advising",
    slug: "sara-e-ede",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rachel",
    lastName: "Edelman",
    title: "Sr Director of Development",
    slug: "rachel-edelman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael E.",
    lastName: "Eder",
    title: "Senior Director, Media Production",
    slug: "michael-e-eder",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Chantal",
    lastName: "Edghill",
    title: "Telephone Operator",
    slug: "chantal-edghill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gizzel B",
    lastName: "Edmund",
    title: "Associate Director of On-Campus College Access Programs",
    slug: "gizzel-b-edmund",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Twinkle M.",
    lastName: "Edwards",
    title: "Financial Assistant",
    slug: "twinkle-m-edwards",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shakir Crystal",
    lastName: "Edwards",
    title: "Regulatory Coordinator",
    slug: "shakir-crystal-edwards",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Joshua D.",
    lastName: "Edwin",
    title: "Associate Dean of Students and Director of Advising",
    slug: "joshua-d-edwin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Beth",
    lastName: "Efran",
    title: "Content Manager",
    slug: "beth-efran",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Benjamin",
    lastName: "Eggleston",
    title: "Sr. Act Rep",
    slug: "benjamin-eggleston",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matthew J",
    lastName: "Ehrlich",
    title: "Senior Director of Development",
    slug: "matthew-j-ehrlich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa A",
    lastName: "Eicher",
    title: "Senior Director-Commnications",
    slug: "lisa-a-eicher",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Chuck",
    lastName: "Eigen",
    title: "Project Director",
    slug: "chuck-eigen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alan",
    lastName: "Eiland",
    title: "AVP, Portfolio Management",
    slug: "alan-eiland",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph P",
    lastName: "Eimicke",
    title: "Statistical Anlst/Data Manager",
    slug: "joseph-p-eimicke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachel A.",
    lastName: "Eisner",
    title: "Senior Associate Director, Financial Aid.",
    slug: "rachel-a-eisner",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Julia Mae",
    lastName: "Eizenstat",
    title: "Consultant",
    slug: "julia-mae-eizenstat",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ikenna",
    lastName: "Ekelem",
    title: "Business Development Associate",
    slug: "ikenna-ekelem",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Itewari Doubara",
    lastName: "Ekpebu",
    title: "Course Developer",
    slug: "itewari-doubara-ekpebu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth",
    lastName: "Elam",
    title: "Director",
    slug: "elizabeth-elam",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Daniela",
    lastName: "Elazari",
    title: "Director of Well-being",
    slug: "daniela-elazari",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeffrey T.",
    lastName: "Eldredge",
    title: "Associate Director, Identity & Access Management",
    slug: "jeffrey-t-eldredge",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katherine Alexandria",
    lastName: "Elia",
    title: "Sr Director-Education Admin",
    slug: "katherine-alexandria-elia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Paul",
    lastName: "Elias",
    title: "Asst Manager-Finance",
    slug: "paul-elias",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Safa",
    lastName: "Elkefi",
    title: "Project Manager",
    slug: "safa-elkefi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter James",
    lastName: "Elkind",
    title: "Clerk 2",
    slug: "peter-james-elkind",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Ellentuck",
    title: "Manager, Application Systems Development",
    slug: "daniel-ellentuck",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brian H.",
    lastName: "Ellerbeck",
    title: "Editorial Director",
    slug: "brian-h-ellerbeck",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan",
    lastName: "Ellingwood",
    title: "Associate Vice President for Public Affairs",
    slug: "susan-ellingwood",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emily",
    lastName: "Elliott",
    title: "Assistant Director of Development and Engagement",
    slug: "emily-elliott",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Daniela K",
    lastName: "Elliott",
    title: "Director, Licensing and Contract Services",
    slug: "daniela-k-elliott",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Chloe Lee",
    lastName: "Elliott",
    title: "Director, Recruitment and Special Projects",
    slug: "chloe-lee-elliott",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Allison",
    lastName: "Elliott",
    title: "Director of Executive Communications",
    slug: "allison-elliott",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rodbert D",
    lastName: "Ellis",
    title: "Chief of Staff and Senior Director of Strategic Planning",
    slug: "rodbert-d-ellis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle L",
    lastName: "Ellis",
    title: "Executive Assistant and Office Manager",
    slug: "michelle-l-ellis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisette N.",
    lastName: "Ellis",
    title: "Sr Administrative Coordinator",
    slug: "lisette-n-ellis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justine Esta",
    lastName: "Ellis",
    title: "Associate Director",
    slug: "justine-esta-ellis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gregory",
    lastName: "Ellner",
    title: "Human Resources and Payroll Reporting Coordinator",
    slug: "gregory-ellner",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nader",
    lastName: "Elmehdawi",
    title: "Project Coordinator II",
    slug: "nader-elmehdawi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yonah",
    lastName: "Elorza",
    title: "Assistant Director of Making Studio & Operations",
    slug: "yonah-elorza",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ramaz H.",
    lastName: "Elsadig",
    title: "Project Coordinator II",
    slug: "ramaz-h-elsadig",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy",
    lastName: "Elsamanoudi",
    title:
      " Administrative Coordinator, International and Comparative Law Programs",
    slug: "nancy-elsamanoudi",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Lisa",
    lastName: "Elwin",
    title: "Manager-Fin Compliance",
    slug: "lisa-elwin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Erich D.",
    lastName: "Ely",
    title: "Director of Development,Athletics",
    slug: "erich-d-ely",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christa C",
    lastName: "Emanuel",
    title: "Research Admin Coordinator",
    slug: "christa-c-emanuel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katie Mary",
    lastName: "Embree",
    title:
      " Vice President for Planning and Strategy, Chief of Staff to the President and Secretary of the College",
    slug: "katie-mary-embree",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tania",
    lastName: "Emilian",
    title: "Administrative Assistant",
    slug: "tania-emilian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Emrich",
    title: "Compliance - Training Coord",
    slug: "jennifer-emrich",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nkemjika C",
    lastName: "Emuchay",
    title: "Service Specialist",
    slug: "nkemjika-c-emuchay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexis",
    lastName: "Encarnacion",
    title: "Finance and Compliance Manager, Sponsored Projects Finance",
    slug: "alexis-encarnacion",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrysailys",
    lastName: "Encarnacion",
    title: "Service Specialist",
    slug: "andrysailys-encarnacion",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stanley",
    lastName: "Eng",
    title: "Salesforce Administrator",
    slug: "stanley-eng",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Darwin",
    lastName: "Eng",
    title: "Assistant Director",
    slug: "darwin-eng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shartiss",
    lastName: "England",
    title: "Associate Director",
    slug: "shartiss-england",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dameione",
    lastName: "Ennis",
    title: "Alan Joel",
    slug: "dameione-ennis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian D.",
    lastName: "Enright",
    title: "Associate Director, Production and Technology",
    slug: "brian-d-enright",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maria",
    lastName: "Enriquez",
    title: "Executive Assistant",
    slug: "maria-enriquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Markeisha J",
    lastName: "Ensley",
    title: "Senior Service Specialist",
    slug: "markeisha-j-ensley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lida",
    lastName: "Entezami",
    title: "Billing Compliance Coord",
    slug: "lida-entezami",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katherine",
    lastName: "Entress",
    title: "RN, FNP",
    slug: "katherine-entress",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabrielle O",
    lastName: "Epemolu",
    title: "Regulatory Coordinator",
    slug: "gabrielle-o-epemolu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pamela A",
    lastName: "Epps",
    title: "Finance Administrator",
    slug: "pamela-a-epps",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shannon M.",
    lastName: "Epstein",
    title: "Manager - AV Events",
    slug: "shannon-m-epstein",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Veronica E",
    lastName: "Erdman",
    title: "Manager-Operations",
    slug: "veronica-e-erdman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mariia",
    lastName: "Ergasheva",
    title: "Administrative Assistant, Strategic Events",
    slug: "mariia-ergasheva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Erickson",
    title: "Clin Coord, Mental Hlth Prvdr",
    slug: "jessica-erickson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacqueline A.",
    lastName: "Erickson",
    title: "Sr. Director, Endowment Compliance & Financial System Security",
    slug: "jacqueline-a-erickson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kevin",
    lastName: "Erixson",
    title: "Senior Associate Director, The Hub",
    slug: "kevin-erixson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Janice",
    lastName: "Erskine",
    title: "Office Manager",
    slug: "janice-erskine",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Pamela",
    lastName: "Escano",
    title: "Continuing Legal and Executive Education Officer",
    slug: "pamela-escano",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Rafael",
    lastName: "Escobar",
    title: "Health Information Specialist",
    slug: "rafael-escobar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mery Elizabeth",
    lastName: "Escobar",
    title: "Authorization and Referrals Specialist I",
    slug: "mery-elizabeth-escobar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lovette",
    lastName: "Esliker",
    title: "Stud Affrs Office Coordinator",
    slug: "lovette-esliker",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Manuel E",
    lastName: "Espaillat",
    title: "Manager, Finance/Budget",
    slug: "manuel-e-espaillat",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gabriel M.",
    lastName: "Espaillat",
    title: "Financial Assistant",
    slug: "gabriel-m-espaillat",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexander",
    lastName: "Espana",
    title: "Associate Dean",
    slug: "alexander-espana",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zenny",
    lastName: "Espinal",
    title: "Secretary B",
    slug: "zenny-espinal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wanda",
    lastName: "Espinal",
    title: "Administrative Assistant",
    slug: "wanda-espinal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sujeiry",
    lastName: "Espinal",
    title: "Financial Coordinator",
    slug: "sujeiry-espinal",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Luisa",
    lastName: "Espinal",
    title: "Project Manager",
    slug: "luisa-espinal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jose",
    lastName: "Espinal",
    title: "Accounting Manager, Fringe Benefits Operations & Forecasting",
    slug: "jose-espinal",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jeny P",
    lastName: "Espinal",
    title: "Associate Director, Finance",
    slug: "jeny-p-espinal",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Issac",
    lastName: "Espinal",
    title: "Ricoh Tech",
    slug: "issac-espinal",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gerardo",
    lastName: "Espinal",
    title: "Administrative Coordinator",
    slug: "gerardo-espinal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alba Z.",
    lastName: "Espinal",
    title: "BRIDGE Imp&Trn Specialist",
    slug: "alba-z-espinal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lucia Isabelle Holmes",
    lastName: "Espineira",
    title: "Student Affairs Officer: Student Life and Well-being",
    slug: "lucia-isabelle-holmes-espineira",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Romelinda",
    lastName: "Espinosa",
    title: "HR Associate",
    slug: "romelinda-espinosa",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cindy",
    lastName: "Espinosa",
    title: "Associate Director, Investigations",
    slug: "cindy-espinosa",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jorge Arturo",
    lastName: "Espinoza",
    title: "Systems Administrator",
    slug: "jorge-arturo-espinoza",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carla",
    lastName: "Espinoza",
    title: "Associate Director of Career Services",
    slug: "carla-espinoza",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aileen K",
    lastName: "Espinoza",
    title: "Financial Coordinator",
    slug: "aileen-k-espinoza",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessie",
    lastName: "Esposito",
    title: "Senior Associate Director of Financial Aid",
    slug: "jessie-esposito",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Vicki",
    lastName: "Esposito",
    title: "Senior Director Client Relations and Service Fulfillment",
    slug: "vicki-esposito",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren D",
    lastName: "Esposito",
    title: "Senior Project Manager, Knowledge Management",
    slug: "lauren-d-esposito",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica M.",
    lastName: "Esposito",
    title: "Live Support Specialist",
    slug: "jessica-m-esposito",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brett E",
    lastName: "Essler",
    title: "Senior Director of Communications",
    slug: "brett-e-essler",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Johan",
    lastName: "Esteban",
    title: "Senior Education Coordinator",
    slug: "johan-esteban",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alycia",
    lastName: "Esteban",
    title: "Administrative Coordinator",
    slug: "alycia-esteban",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ramon",
    lastName: "Estevez",
    title: "Audio Visual Aide",
    slug: "ramon-estevez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marisol",
    lastName: "Estevez",
    title: "Advertising Manager and Creative Service Manager",
    slug: "marisol-estevez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Larry",
    lastName: "Estevez",
    title: "Dir,  Operations Management",
    slug: "larry-estevez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katia",
    lastName: "Estevez",
    title: "Prog Mgr for UME & GME",
    slug: "katia-estevez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carlos",
    lastName: "Estevez",
    title: "Manager of Operations",
    slug: "carlos-estevez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wilbur I.",
    lastName: "Estrada",
    title: "Financial Coordinator",
    slug: "wilbur-i-estrada",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michale Anthony",
    lastName: "Estrada",
    title: "Director of Learning and Development Programs",
    slug: "michale-anthony-estrada",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "John",
    lastName: "Estrella",
    title: "Senior Service Specialist",
    slug: "john-estrella",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David Pierre",
    lastName: "Estrella",
    title: "Senior Assistant Director of Admission",
    slug: "david-pierre-estrella",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Latisha",
    lastName: "Etheridge",
    title: "Surgical Coordinator",
    slug: "latisha-etheridge",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shonda",
    lastName: "Eury",
    title: "Development Assistant, Marketing Strategy and Enablement",
    slug: "shonda-eury",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Veronica A.",
    lastName: "Evans",
    title: "Coordinator-Admin/Education",
    slug: "veronica-a-evans",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justine",
    lastName: "Evans",
    title: "Director of Rights and Contracts",
    slug: "justine-evans",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Elizabeth A",
    lastName: "Evans",
    title: "Associate Director of Alumni Relations",
    slug: "elizabeth-a-evans",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ace",
    lastName: "Evans",
    title: "Senior Admissions Officer",
    slug: "ace-evans",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Anabel",
    lastName: "Evans",
    title: "Research Specialist",
    slug: "anabel-evans",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Evelyn",
    lastName: "Evans-Guarnieri",
    title: "Radiology Program Associate",
    slug: "evelyn-evans-guarnieri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alice",
    lastName: "Ewald",
    title: "Deputy Program Director, Applied Analytics",
    slug: "alice-ewald",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bryson Robert",
    lastName: "Ezell",
    title: "Assistant Director-Audio Visual",
    slug: "bryson-robert-ezell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erin",
    lastName: "Fae",
    title: "Associate Director for Communications and Special Projects",
    slug: "erin-fae",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dorsa Ivana",
    lastName: "Fahami",
    title:
      " Program Manager (Professional Certification and Curriculum and Teaching Programs)",
    slug: "dorsa-ivana-fahami",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Khadija Fatima",
    lastName: "Faheem",
    title: "Senior Data Coordinator",
    slug: "khadija-fatima-faheem",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Denise",
    lastName: "Fairman",
    title: "Associate Director",
    slug: "denise-fairman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fahim",
    lastName: "Faisal",
    title: "SYEP Clerical Aide",
    slug: "fahim-faisal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosanna",
    lastName: "Fajar",
    title: "IRB Specialist",
    slug: "rosanna-fajar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erika Aliza Enzer",
    lastName: "Fajerman",
    title: "Associate Director of Annual Giving",
    slug: "erika-aliza-enzer-fajerman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie M",
    lastName: "Falato",
    title: "Assoc Director-Events/Programs",
    slug: "natalie-m-falato",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Judith",
    lastName: "Falconi",
    title: "Administrative Aide",
    slug: "judith-falconi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Falconieri",
    title: "Associate Director, Admissions and Recruitment",
    slug: "michael-falconieri",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ismaila",
    lastName: "Fall",
    title: "Director, Information Technology",
    slug: "ismaila-fall",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lebab",
    lastName: "Fallin",
    title: "Administrative Assistant",
    slug: "lebab-fallin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Felicite",
    lastName: "Fallon",
    title: "Assoc Director, Internal Comm",
    slug: "felicite-fallon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Katherine A.",
    lastName: "Fallow",
    title: "Deputy Litigation Director, Knight First Amendment Institute",
    slug: "katherine-a-fallow",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Paul",
    lastName: "Falvo",
    title: "Senior Program Manager",
    slug: "paul-falvo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alyssa Nicole",
    lastName: "Famolari",
    title: "Learning Designer II",
    slug: "alyssa-nicole-famolari",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Valecia",
    lastName: "Fane",
    title: "Associate Director, Student Accounts Refunds & Operations",
    slug: "valecia-fane",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cameron M",
    lastName: "Fane",
    title: "Financial Aid Officer",
    slug: "cameron-m-fane",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Francesca P.",
    lastName: "Fanelli",
    title: "Senior Associate Director of Graduate Career Development",
    slug: "francesca-p-fanelli",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chloe L",
    lastName: "Fang",
    title: "Data Coordinator II",
    slug: "chloe-l-fang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ching",
    lastName: "Fang",
    title: "PDRS Alum",
    slug: "ching-fang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tony Abaunza",
    lastName: "Fangel",
    title: "Associate Director for Housing and Card Services",
    slug: "tony-abaunza-fangel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Timothy John",
    lastName: "Fann",
    title: "Director-Student Engagement",
    slug: "timothy-john-fann",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alexander Scott",
    lastName: "Fanning",
    title: "Program Manager",
    slug: "alexander-scott-fanning",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alyssa",
    lastName: "Fantauzzi",
    title: "Temp Administrative Assistant",
    slug: "alyssa-fantauzzi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cecile",
    lastName: "Fanton d'Andon",
    title: "Consultant",
    slug: "cecile-fanton-d-andon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Farber",
    title: "Title IX Investigator",
    slug: "emily-farber",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Faye A.",
    lastName: "Farese",
    title: "Director of Dev,Almni&Mjr Gfts",
    slug: "faye-a-farese",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashkan",
    lastName: "Farhoodfar",
    title: "Director, Application Development",
    slug: "ashkan-farhoodfar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mauricio",
    lastName: "Farigua",
    title: "Client Services Manager",
    slug: "mauricio-farigua",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matteo",
    lastName: "Farinella",
    title:
      " Scientific Multimedia Producer in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "matteo-farinella",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hector M.",
    lastName: "Faris",
    title: "Safety Specialist",
    slug: "hector-m-faris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary Elizabeth",
    lastName: "Farkouh",
    title: "Pediatric Diabetes Educator",
    slug: "mary-elizabeth-farkouh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liz M",
    lastName: "Farley",
    title: "Director of Academic Administration",
    slug: "liz-m-farley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Genna",
    lastName: "Farley",
    title: "Director, Alumni Engagement",
    slug: "genna-farley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lorena R",
    lastName: "Farmand",
    title: "Project Coordinator",
    slug: "lorena-r-farmand",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melanie A.",
    lastName: "Farmer",
    title: "Director-ENG Communications",
    slug: "melanie-a-farmer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Catherine Alexandra",
    lastName: "Farquharson",
    title: "Project Coordinator",
    slug: "catherine-alexandra-farquharson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adan Y. J.",
    lastName: "Farrah",
    title: "Financial Aid Officer",
    slug: "adan-y-j-farrah",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Timothy J.",
    lastName: "Farrell",
    title: "Major Gifts Officer, Columbia Climate School",
    slug: "timothy-j-farrell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer L",
    lastName: "Farris",
    title:
      " Chief Operating Officer in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "jennifer-l-farris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mikita",
    lastName: "Farrow-Glover",
    title: "Events Consultant",
    slug: "mikita-farrow-glover",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Fasel",
    title: "Bioinformatics Director",
    slug: "david-fasel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nausheen",
    lastName: "Fathima",
    title: "Administrative Assistant",
    slug: "nausheen-fathima",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kern B",
    lastName: "Faubion",
    title: "Legal Sec/Asst Paralegal",
    slug: "kern-b-faubion",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Michael S",
    lastName: "Faucher",
    title: "Director, Rsch IT & Computing",
    slug: "michael-s-faucher",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amanda E.",
    lastName: "Faulkner",
    title: "Student Acad Support Worker",
    slug: "amanda-e-faulkner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lorenza",
    lastName: "Favrot",
    title: "Assistant Director, Outreach and Communication",
    slug: "lorenza-favrot",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Meghan Jean",
    lastName: "Fawcett",
    title: "Assistant Director, Marketing Initiatives",
    slug: "meghan-jean-fawcett",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Katherine",
    lastName: "Fayn",
    title: "Associate Director, Human Resources",
    slug: "katherine-fayn",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kyle Gramer",
    lastName: "Featherston",
    title: "Research Program Director",
    slug: "kyle-gramer-featherston",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gerardo J",
    lastName: "Febres",
    title: "Program Manager",
    slug: "gerardo-j-febres",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caroline Olivia",
    lastName: "Feehan",
    title: "Executive Assistant",
    slug: "caroline-olivia-feehan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah Rita",
    lastName: "Feeney",
    title: "Associate Director of Advising",
    slug: "sarah-rita-feeney",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brendan I.",
    lastName: "Feifer",
    title: "Director, Talent Operations and Human Resources",
    slug: "brendan-i-feifer",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sarah Kim",
    lastName: "Fein",
    title: "Program Manager",
    slug: "sarah-kim-fein",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vera",
    lastName: "Felder",
    title: "Program Manager",
    slug: "vera-felder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Feldman",
    title: "Sr. User Experience Specialist",
    slug: "susan-feldman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julie M.",
    lastName: "Feldman",
    title: "Associate Director",
    slug: "julie-m-feldman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trisha Lynnette",
    lastName: "Feliciano",
    title: "Asst Director-Communications",
    slug: "trisha-lynnette-feliciano",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael",
    lastName: "Feliciano",
    title: "Assistant Dean of Budget & Analytics",
    slug: "michael-feliciano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jose R.",
    lastName: "Feliciano",
    title: "Benefits Manager",
    slug: "jose-r-feliciano",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle",
    lastName: "Felipe",
    title: "Auth Referrals Spc II",
    slug: "michelle-felipe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa A",
    lastName: "Feliz",
    title: "Secretary B",
    slug: "melissa-a-feliz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Feliz",
    title: "Manager of Academic Appointments",
    slug: "jennifer-feliz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samantha K.",
    lastName: "Felmus",
    title: "Administrative Assistant",
    slug: "samantha-k-felmus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wendy M",
    lastName: "Felton",
    title: "Executive Director, Social Media",
    slug: "wendy-m-felton",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Samantha",
    lastName: "Feng",
    title: "Financial Coordinator",
    slug: "samantha-feng",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ping",
    lastName: "Feng",
    title: "Webmaster",
    slug: "ping-feng",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ming",
    lastName: "Feng",
    title: "Senior Data Manager",
    slug: "ming-feng",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica M.",
    lastName: "Fenton",
    title: "Associate General Counsel",
    slug: "jessica-m-fenton",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Keisha",
    lastName: "Fequiere",
    title: "Call Center Agent",
    slug: "keisha-fequiere",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maria Ashley",
    lastName: "Fera",
    title: "Associate Director, Alumni, Community and Industry Engagement",
    slug: "maria-ashley-fera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel M.",
    lastName: "Ferat",
    title: "Program Manager",
    slug: "rachel-m-ferat",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jannatul",
    lastName: "Ferdous-Hypolite",
    title: "Budget Manager",
    slug: "jannatul-ferdous-hypolite",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amanda Huckabee",
    lastName: "Ferlazzo",
    title: "Director of Energy Training and Partnerships",
    slug: "amanda-huckabee-ferlazzo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carmen A.",
    lastName: "Fermaintt",
    title: "Human Resources Manager",
    slug: "carmen-a-fermaintt",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Maria E.",
    lastName: "Fernandez",
    title: "Senior Generalist, HR/FA",
    slug: "maria-e-fernandez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kenneth",
    lastName: "Fernandez",
    title: "System Administrator",
    slug: "kenneth-fernandez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jaime J.",
    lastName: "Fernandez",
    title: "Catering Delivery",
    slug: "jaime-j-fernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angel Jose.",
    lastName: "Fernandez",
    title: "Pantry Worker",
    slug: "angel-jose-fernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danilo",
    lastName: "Fernandez",
    title: "Financial Assistant",
    slug: "danilo-fernandez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Montserrat",
    lastName: "Fernandez-Pinkley",
    title: "Student Services Coordinator for Student and Academic Affairs",
    slug: "montserrat-fernandez-pinkley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Danushi S.",
    lastName: "Fernando",
    title: "Assistant Dean of Engagement and Strategic Programs",
    slug: "danushi-s-fernando",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yu-Hui",
    lastName: "Ferng",
    title: "Director, Global Health",
    slug: "yu-hui-ferng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Derek",
    lastName: "Ferranti",
    title: "RN",
    slug: "derek-ferranti",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Ferrara",
    title: "Deputy Vice President for Strategic Communications",
    slug: "christine-ferrara",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rachel Andrea",
    lastName: "Ferrari",
    title: "Executive Director Protection of Minors Programs",
    slug: "rachel-andrea-ferrari",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth A.",
    lastName: "Ferrari",
    title: "Director, Academic Programs",
    slug: "elizabeth-a-ferrari",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yarline",
    lastName: "Ferreira",
    title: "Asst Manager, Revenue Cycle",
    slug: "yarline-ferreira",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisle N.",
    lastName: "Ferreira",
    title: "Executive Director, Strategic Programs and Presidential Events",
    slug: "lisle-n-ferreira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane M",
    lastName: "Ferrone",
    title: "Ex Dir Develop, Annual Giving",
    slug: "jane-m-ferrone",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charles",
    lastName: "Ferrusi",
    title: "Project Manager",
    slug: "charles-ferrusi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob",
    lastName: "Fertig",
    title: "Associate Director, Marketing Initiatives",
    slug: "jacob-fertig",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stewart F.",
    lastName: "Feuerstein",
    title: "Director of Storage, Backup, Disaster Recovery and Main Frame Supp",
    slug: "stewart-f-feuerstein",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Orlando",
    lastName: "Fiallo",
    title: "Contractor",
    slug: "orlando-fiallo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa Taryn",
    lastName: "Fielding",
    title: "Head & Neck Adult Surg Coord",
    slug: "melissa-taryn-fielding",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "Fife",
    title: "Director, HERC",
    slug: "karen-fife",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chanis",
    lastName: "Figuereo",
    title: "Junior ServiceNow Developer",
    slug: "chanis-figuereo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yessica O.",
    lastName: "Figueroa",
    title: "Administrative Aide",
    slug: "yessica-o-figueroa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Figueroa",
    title: "Administrative Assistant",
    slug: "melissa-figueroa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary Beth",
    lastName: "Figueroa",
    title: "Human Resources Assistant",
    slug: "mary-beth-figueroa",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "GEFFIE L",
    lastName: "FIGUEROA",
    title: "Transcriptionist",
    slug: "geffie-l-figueroa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Beatrice C",
    lastName: "Figueroa",
    title: "Director of Revenue Cycle",
    slug: "beatrice-c-figueroa",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Audrey",
    lastName: "Figueroa",
    title: "Billing Compliance Manager",
    slug: "audrey-figueroa",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Juan David",
    lastName: "Figueroa-Salazar",
    title: "Applications Developer",
    slug: "juan-david-figueroa-salazar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric John",
    lastName: "Fillinger",
    title: "Program Director",
    slug: "eric-john-fillinger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma J",
    lastName: "Finder",
    title: "Assistant Director of Undergraduate Career Development",
    slug: "emma-j-finder",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joel E.",
    lastName: "Fine",
    title: "Director of Finance & Payroll",
    slug: "joel-e-fine",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Allison H.",
    lastName: "Finkel",
    title: "Associate Director, Marketing",
    slug: "allison-h-finkel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Aaron M",
    lastName: "Finkelstein",
    title: "Director of Talent Management",
    slug: "aaron-m-finkelstein",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Manoah A",
    lastName: "Finston",
    title: "Associate Registrar, Academic Programs",
    slug: "manoah-a-finston",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Matthew C.",
    lastName: "Finuoli",
    title: "Assistant Director of IT Projects",
    slug: "matthew-c-finuoli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Francesco",
    lastName: "Fiondella",
    title: "Associate Director, Communications and Special Projects",
    slug: "francesco-fiondella",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mary",
    lastName: "Fiore",
    title: "Sr Dir, Const Engmnt & Events",
    slug: "mary-fiore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alston M",
    lastName: "Fishburne",
    title: "Executive Assistant",
    slug: "alston-m-fishburne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samuel L.",
    lastName: "Fisher",
    title: "Education Assistant",
    slug: "samuel-l-fisher",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nickle N.",
    lastName: "Fisher",
    title: "Administrative Assistant",
    slug: "nickle-n-fisher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marjory D.",
    lastName: "Fisher",
    title: "Associate Vice President & Title IX Coordinator",
    slug: "marjory-d-fisher",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Julie A.",
    lastName: "Fisher",
    title: "Administrator",
    slug: "julie-a-fisher",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Etolia Brooke",
    lastName: "Fisher",
    title: "Director of Finance and Budget",
    slug: "etolia-brooke-fisher",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Honey S.",
    lastName: "Fishman",
    title: "Assistant Vice President, Housing Services & Student Center Ops",
    slug: "honey-s-fishman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Angelica N.",
    lastName: "Fisichella",
    title: "Associate Director",
    slug: "angelica-n-fisichella",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claire McNicholas",
    lastName: "Fissinger",
    title: "Senior Grants Manager",
    slug: "claire-mcnicholas-fissinger",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Natazia M",
    lastName: "Fistrovic",
    title: "Sr Mgr, Program & Award Mgmt",
    slug: "natazia-m-fistrovic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin A.",
    lastName: "Fittinghoff",
    title: "Chief Operating Officer",
    slug: "kevin-a-fittinghoff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David P.",
    lastName: "Fitzgerald",
    title: "Asst Director -Career Placemen",
    slug: "david-p-fitzgerald",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kevin Joseph",
    lastName: "Fitzmaurice",
    title: "Director of Public Affairs",
    slug: "kevin-joseph-fitzmaurice",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "William J",
    lastName: "Fitzpatrick",
    title: "Associate Director, Campus Communications",
    slug: "william-j-fitzpatrick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Philip J",
    lastName: "Fitzpatrick",
    title: "IntermSys/Network Anyst/Progr",
    slug: "philip-j-fitzpatrick",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Meghan",
    lastName: "Flaherty",
    title: "Advising Dean",
    slug: "meghan-flaherty",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathleen R",
    lastName: "Flandrick",
    title: "Sr Research Program Director",
    slug: "kathleen-r-flandrick",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ellen",
    lastName: "Flax",
    title: "Director, Corp/Foundation Rel",
    slug: "ellen-flax",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Deirdre",
    lastName: "Flaxman",
    title: "Monitor for Hire",
    slug: "deirdre-flaxman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marjorie Lynn",
    lastName: "Fleck",
    title: "Supervisor, ICM",
    slug: "marjorie-lynn-fleck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael P",
    lastName: "Fleming",
    title: "Senior Director, Online Support and Academic Technology",
    slug: "michael-p-fleming",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yvonne M.",
    lastName: "Flesche",
    title: "Director of Financial Mgmt",
    slug: "yvonne-m-flesche",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ariel",
    lastName: "Fleurimond",
    title: "Senior Director, Instructional Design and Curriculum Support",
    slug: "ariel-fleurimond",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jada Rene",
    lastName: "Flint",
    title: "MA Program Assistant",
    slug: "jada-rene-flint",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Denise",
    lastName: "Flood",
    title: "Sr Administrative Coordinator",
    slug: "denise-flood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Myron Krys",
    lastName: "Florence",
    title: "Staff",
    slug: "myron-krys-florence",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Rodolfo",
    lastName: "Florendo",
    title: "Oiler",
    slug: "rodolfo-florendo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ruben",
    lastName: "Flores",
    title: "Asst Director, PhD Program",
    slug: "ruben-flores",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maritza",
    lastName: "Flores",
    title: "Senior HR Business Partner",
    slug: "maritza-flores",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Luis",
    lastName: "Flores",
    title: "SYEP Clerical Aide",
    slug: "luis-flores",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Itzaes",
    lastName: "Flores",
    title: "FY25 One Time Payments (Grant)",
    slug: "itzaes-flores",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Humberto A",
    lastName: "Flores",
    title: "Wait Staff",
    slug: "humberto-a-flores",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Flores",
    title: "Manager, Office of Budget and Planning",
    slug: "christine-flores",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Antoine U.",
    lastName: "Florestal",
    title: "Director, Animal Facility Ops",
    slug: "antoine-u-florestal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emilay N",
    lastName: "Florez",
    title: "Project Coordinator II",
    slug: "emilay-n-florez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Florian-Gonzalez",
    title: "Administrative Assistant I",
    slug: "jennifer-florian-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noah O",
    lastName: "Florimon",
    title: "Financial Coordinator",
    slug: "noah-o-florimon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mavis A",
    lastName: "Flowers",
    title: "Project Manager",
    slug: "mavis-a-flowers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lawrence Loftin",
    lastName: "Flowers",
    title: "Vice President, Government and Community Affairs",
    slug: "lawrence-loftin-flowers",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Deidre Bennett",
    lastName: "Flowers",
    title: "Assistant Adjunct",
    slug: "deidre-bennett-flowers",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rachael M",
    lastName: "Flynn",
    title: "Assistant Director Analysis and Reporting",
    slug: "rachael-m-flynn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Neal Michael",
    lastName: "Flynn",
    title: "Printmaking Studio Assistant",
    slug: "neal-michael-flynn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth J.",
    lastName: "Flynn",
    title: "Live Support Specialist",
    slug: "elizabeth-j-flynn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melanie P.",
    lastName: "Foley",
    title: "Administrative Manager",
    slug: "melanie-p-foley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justine",
    lastName: "Foley",
    title: "Associate Director",
    slug: "justine-foley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cat A.",
    lastName: "Foley",
    title: "Lighting and Production Associate",
    slug: "cat-a-foley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bridget W",
    lastName: "Foley",
    title: "Executive Director,Development",
    slug: "bridget-w-foley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meika",
    lastName: "Folkerts",
    title: "Research Manager",
    slug: "meika-folkerts",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeanelle A.",
    lastName: "Folkes",
    title: "Admissions CRM Administrator",
    slug: "jeanelle-a-folkes",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mykaella",
    lastName: "Fonacier",
    title: "Manager, Employee Experience & Digital Content",
    slug: "mykaella-fonacier",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Karen",
    lastName: "Foncette",
    title: "Lead Benefits Representative",
    slug: "karen-foncette",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jenny",
    lastName: "Fondren",
    title: "Student Acad Support Worker",
    slug: "jenny-fondren",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Teri",
    lastName: "Fongyit",
    title: "Research Finance Manager",
    slug: "teri-fongyit",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Monica P",
    lastName: "Fonseca",
    title: "Wait Staff",
    slug: "monica-p-fonseca",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley P.",
    lastName: "Fonville",
    title: "Sr Coordinator, PhD Program",
    slug: "ashley-p-fonville",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John C",
    lastName: "Foo",
    title: "Senior Assistant Director",
    slug: "john-c-foo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Dustin Lake",
    lastName: "Foote",
    title: "Senior Media Producer",
    slug: "dustin-lake-foote",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tosha",
    lastName: "Ford",
    title: "Development Assistant (Lockbox Coordinator)",
    slug: "tosha-ford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gregory L.",
    lastName: "Ford",
    title: "Prospect Intelligence Specialist",
    slug: "gregory-l-ford",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Khayri",
    lastName: "Forde",
    title: "Event Coordinator",
    slug: "khayri-forde",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Imogen H",
    lastName: "Fordyce",
    title: "Senior Admissions Officer",
    slug: "imogen-h-fordyce",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ronald",
    lastName: "Foreman",
    title: "Talon - CDIS",
    slug: "ronald-foreman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Doris",
    lastName: "Foreman",
    title: "Administrative Coordinator",
    slug: "doris-foreman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Foresman",
    title: "Communications Officer",
    slug: "elizabeth-foresman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Antonia",
    lastName: "Forika",
    title: "Assistant Director of Event Planning and Logistics",
    slug: "antonia-forika",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin Bridget",
    lastName: "Forrest",
    title: "Administrative Coordinator in the Harriman Institute",
    slug: "erin-bridget-forrest",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew J",
    lastName: "Forsberg",
    title: "Senior Financial Manager",
    slug: "matthew-j-forsberg",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katherine de Rosset",
    lastName: "Forshay",
    title: "Assistant Director",
    slug: "katherine-de-rosset-forshay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cardene",
    lastName: "Forsyrthe",
    title: "Recruitment Admin. Asst.",
    slug: "cardene-forsyrthe",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "James E.",
    lastName: "Forteza",
    title: "Duplicating Machine Operator",
    slug: "james-e-forteza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nyoka S",
    lastName: "Foster",
    title: "HR Representative",
    slug: "nyoka-s-foster",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Entela",
    lastName: "Foto",
    title: "Senior Accountant-Pension and Benefits Accounting and Reporting",
    slug: "entela-foto",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anne F",
    lastName: "Foulke",
    title: "Sr Assoc Dir, Digital Strategy",
    slug: "anne-f-foulke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan Helen",
    lastName: "Fountain",
    title: "Workshop Developer and Presenter",
    slug: "susan-helen-fountain",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert",
    lastName: "Fowler",
    title: "Dear Mama Employee",
    slug: "robert-fowler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel Clinton",
    lastName: "Fox",
    title: "Director, Content Strat & Prod",
    slug: "daniel-clinton-fox",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Janet M.",
    lastName: "Franceschi",
    title: "Administrative Aide",
    slug: "janet-m-franceschi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephen L",
    lastName: "Francis",
    title: "Director, Technical Services",
    slug: "stephen-l-francis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Natalie",
    lastName: "Francis",
    title: "Referral and Authorization Specialist III",
    slug: "natalie-francis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melbourne E.",
    lastName: "Francis",
    title: "Assistant Director of Student Services",
    slug: "melbourne-e-francis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Keverl Ariana",
    lastName: "Francis",
    title: "Administrative Coordinator",
    slug: "keverl-ariana-francis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Faybian",
    lastName: "Francis",
    title: "Administrative Clerk",
    slug: "faybian-francis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Darius N.",
    lastName: "Francis",
    title: "Senior Service Specialist",
    slug: "darius-n-francis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miguel A",
    lastName: "Francisco",
    title: "Clerk B",
    slug: "miguel-a-francisco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karina",
    lastName: "Francisco",
    title: "Secretary B",
    slug: "karina-francisco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Windsor M",
    lastName: "Franco",
    title: "Chemical Barcoder II",
    slug: "windsor-m-franco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sakine",
    lastName: "Franke",
    title: "Executive Assistant to the Provost",
    slug: "sakine-franke",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanda D.",
    lastName: "Franklin",
    title: "Asst Dir, Budget & Analytics",
    slug: "amanda-d-franklin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Monique A.",
    lastName: "Fraser",
    title: "Live Support Specialist",
    slug: "monique-a-fraser",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gina R",
    lastName: "Frassetto",
    title: "Director of Finance and Admin",
    slug: "gina-r-frassetto",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nakesha S",
    lastName: "Fray",
    title: "Data Coordinator",
    slug: "nakesha-s-fray",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rob-Sterling",
    lastName: "Frazier",
    title: "Payroll Administrator",
    slug: "rob-sterling-frazier",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kathleen M.",
    lastName: "Frazier",
    title: "Executive Assistant",
    slug: "kathleen-m-frazier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charise",
    lastName: "Frazier",
    title: "Communications Manager",
    slug: "charise-frazier",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Asia",
    lastName: "Frazier",
    title: "MPA",
    slug: "asia-frazier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dianne C",
    lastName: "Frederick",
    title: "Senior Program Manager",
    slug: "dianne-c-frederick",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Milan J.",
    lastName: "Fredricks",
    title: "Strategic Communications Mngr",
    slug: "milan-j-fredricks",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicholas Troy",
    lastName: "Freeman",
    title: "Financial Assistant",
    slug: "nicholas-troy-freeman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Evelina",
    lastName: "Freeman",
    title: "Assistant Dean, Graduate Programs",
    slug: "evelina-freeman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher Edward",
    lastName: "Freeman",
    title: "Divisional Administrator",
    slug: "christopher-edward-freeman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isaac R",
    lastName: "Freeman Sr",
    title: "Lead Postal Clerk",
    slug: "isaac-r-freeman-sr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Riley",
    lastName: "French",
    title: "Manager-Ticket/Info Center",
    slug: "riley-french",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anke",
    lastName: "Freude",
    title: "Administrative Manager",
    slug: "anke-freude",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily B.D.",
    lastName: "Frey",
    title: "Asst Director,Academic Affairs",
    slug: "emily-b-d-frey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Megan L.",
    lastName: "Friar",
    title: "Executive Assistant, Academic Affairs",
    slug: "megan-l-friar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Irma Onelis",
    lastName: "Frias",
    title: "Assistant Director, Prospect Research",
    slug: "irma-onelis-frias",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brendan",
    lastName: "Fridhandler",
    title: "Assistant Manager-Safety/Security",
    slug: "brendan-fridhandler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yevgenia",
    lastName: "Fridman",
    title: "Associate Director, Student Applications Systems Development",
    slug: "yevgenia-fridman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Fried",
    title: "Associate Director, Admissions and Recruitment",
    slug: "jennifer-fried",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Catherine",
    lastName: "Friedl",
    title: "Senior Administrator Coordinator",
    slug: "catherine-friedl",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zachary",
    lastName: "Friedman",
    title: "Copywriter and Catalog Manager",
    slug: "zachary-friedman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elisabeth",
    lastName: "Friedman",
    title: "Administrative Assistant",
    slug: "elisabeth-friedman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Friedman",
    title: "Cardio Sonographer",
    slug: "danielle-friedman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Iris",
    lastName: "Friedrich",
    title: "Financial Counselor",
    slug: "iris-friedrich",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Akosua Serwaa",
    lastName: "Frimpong",
    title: "Manager, Probation & Parole Reform Project",
    slug: "akosua-serwaa-frimpong",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Katherine",
    lastName: "Fritz",
    title: "Associate Biological Safety Officer",
    slug: "katherine-fritz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eileen",
    lastName: "Frommer",
    title: "Ophthalmic Photographer",
    slug: "eileen-frommer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lowell",
    lastName: "Frye",
    title: "Communications Administrator",
    slug: "lowell-frye",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "En",
    lastName: "Fu",
    title: "Research Program Manager",
    slug: "en-fu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julian",
    lastName: "Fuchsberg",
    title: "Assistant Director, Development and Strategic Initiatives",
    slug: "julian-fuchsberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria Guadalupe",
    lastName: "Fuentes",
    title: "MPA",
    slug: "maria-guadalupe-fuentes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leticia",
    lastName: "Fuentes",
    title: "Benefits Administrator",
    slug: "leticia-fuentes",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joseph N",
    lastName: "Fuentes",
    title: "Associate Director, Post Award and Finance",
    slug: "joseph-n-fuentes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jeanette",
    lastName: "Fuentes",
    title: "Call Center Scheduling Representative",
    slug: "jeanette-fuentes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eileen Z.",
    lastName: "Fuentes",
    title: "Director, HR/FA",
    slug: "eileen-z-fuentes",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Carolyn",
    lastName: "Fuentes- Castano",
    title: "Bus Svcs Coord, Cred",
    slug: "carolyn-fuentes-castano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mitchell Layton",
    lastName: "Fullerton",
    title: "Business Development Manager",
    slug: "mitchell-layton-fullerton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven Gerald",
    lastName: "Fullwood",
    title: "Project Coordinator",
    slug: "steven-gerald-fullwood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John Russell",
    lastName: "Furbush",
    title: "Data Manager",
    slug: "john-russell-furbush",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marquis L.",
    lastName: "Fuse",
    title: "Manager, Education Programs",
    slug: "marquis-l-fuse",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eugenie V",
    lastName: "Fyodorova",
    title: "Coordinator",
    slug: "eugenie-v-fyodorova",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emily A.",
    lastName: "Gabor",
    title: "Dir, Academic Admin & Finance",
    slug: "emily-a-gabor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Terrance Thomas",
    lastName: "Gabriel",
    title: "Director of Academic Administration",
    slug: "terrance-thomas-gabriel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yanni",
    lastName: "Gacopoulos",
    title: "Director, HR & Talent Management",
    slug: "yanni-gacopoulos",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sara M",
    lastName: "Gadasi",
    title:
      " Director of Fitness and Wellness, Assistant Director of Physical Education",
    slug: "sara-m-gadasi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jonathan Wade",
    lastName: "Gaddy",
    title: "Senior Trainer",
    slug: "jonathan-wade-gaddy",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lynette",
    lastName: "Gagedeen",
    title: "Senior HR Specialist",
    slug: "lynette-gagedeen",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Barbara",
    lastName: "Galati",
    title: "Diagnostic Imaging Specialist IV",
    slug: "barbara-galati",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabriel",
    lastName: "Galindez",
    title: "Financial Assistant",
    slug: "gabriel-galindez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marlene I.",
    lastName: "Galindo",
    title: "Assistant Director (Development Services)",
    slug: "marlene-i-galindo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "George Daniel",
    lastName: "Galindo",
    title: "Internship Coach for SPA NOLA students",
    slug: "george-daniel-galindo",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Monserrat",
    lastName: "Galindo Cruz",
    title: "Admissions Officer, High School Programs",
    slug: "monserrat-galindo-cruz",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Adam D",
    lastName: "Galinsky",
    title:
      " Paul Calello Professor of Leadership and Ethics; Vice Dean for Diversity Equity and Inclusion",
    slug: "adam-d-galinsky",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Jean C",
    lastName: "Gallagher",
    title: "Chief Financial and Administrative Officer",
    slug: "jean-c-gallagher",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jonathan J",
    lastName: "Gallagher",
    title: "Aide",
    slug: "jonathan-j-gallagher",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Arianna Christine",
    lastName: "Gallanes",
    title: "Associate Director of Annual Giving",
    slug: "arianna-christine-gallanes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jamison R",
    lastName: "Galloway",
    title: "Associate Director",
    slug: "jamison-r-galloway",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Raldy Rafael",
    lastName: "Galvez",
    title: "Coordinator",
    slug: "raldy-rafael-galvez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Patricia",
    lastName: "Galvin",
    title: "Education Coordinator",
    slug: "patricia-galvin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Veronica",
    lastName: "Gamboa",
    title: "Financial Assistant",
    slug: "veronica-gamboa",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alvaro",
    lastName: "Gamboa",
    title: "Asst Director-Info Tech Ops",
    slug: "alvaro-gamboa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joshua D",
    lastName: "Gamse",
    title: "Director, Fraternity and Sorority Life",
    slug: "joshua-d-gamse",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Vanessa R",
    lastName: "Gandara",
    title: "Financial Aid Customer Service Representative",
    slug: "vanessa-r-gandara",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jawahar",
    lastName: "Ganesh",
    title: "Consultant",
    slug: "jawahar-ganesh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabrielle G",
    lastName: "Gannon",
    title: "Associate Dean of Graduate Admissions",
    slug: "gabrielle-g-gannon",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Yuan Christina",
    lastName: "Gao",
    title: "Senior Project Officer",
    slug: "yuan-christina-gao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ping",
    lastName: "Gao",
    title: "Assistant Director of Financial Aid Systems and Data",
    slug: "ping-gao",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hong Lan",
    lastName: "Gao",
    title: "Senior Accountant",
    slug: "hong-lan-gao",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sandra",
    lastName: "Gaona",
    title: "Senior Associate Director",
    slug: "sandra-gaona",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Frankie",
    lastName: "Garabito",
    title: "ServiceNow Administrator",
    slug: "frankie-garabito",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christian",
    lastName: "Garbutt",
    title: "Administrative Services Manager",
    slug: "christian-garbutt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ricardo Diamondte",
    lastName: "Garces",
    title: "Service Desk AV Support Tech",
    slug: "ricardo-diamondte-garces",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wanda E.",
    lastName: "Garcia",
    title: "Director, Community Engagement",
    slug: "wanda-e-garcia",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Wendy",
    lastName: "Garcia",
    title: "Wait Staff",
    slug: "wendy-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Veronica A",
    lastName: "Garcia",
    title: "Vascular Supervisor",
    slug: "veronica-a-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosemary",
    lastName: "Garcia",
    title: "Admin Coordinator, Education",
    slug: "rosemary-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patty",
    lastName: "Garcia",
    title: "Senior Finance Coordinator",
    slug: "patty-garcia",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Miguel",
    lastName: "Garcia",
    title: "Procurement Associate",
    slug: "miguel-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mikaela",
    lastName: "Garcia",
    title: "SYEP",
    slug: "mikaela-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "MIGUEL",
    lastName: "GARCIA",
    title: "Biller",
    slug: "miguel-garcia-1",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laura I",
    lastName: "Garcia",
    title: "Lab Operations Coordinator",
    slug: "laura-i-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lejani D",
    lastName: "Garcia",
    title: "Neurophysiology Coordinator",
    slug: "lejani-d-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kiara",
    lastName: "Garcia",
    title: "Grants Financial Coordinator",
    slug: "kiara-garcia",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karla P.",
    lastName: "Garcia",
    title: "Operations Manager",
    slug: "karla-p-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jose A.",
    lastName: "Garcia",
    title: "Sr. Director, EBIS",
    slug: "jose-a-garcia",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Garcia",
    title: "Administrative Coordinator",
    slug: "jessica-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "JoAnn Gorre",
    lastName: "Garcia",
    title: "Director, Finance",
    slug: "joann-gorre-garcia",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Helen E",
    lastName: "Garcia",
    title: "Secretary B",
    slug: "helen-e-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Guillermo",
    lastName: "Garcia",
    title: "Recess Enrichment Facilitator in The School",
    slug: "guillermo-garcia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Florante T",
    lastName: "Garcia",
    title: "Director, Data Management",
    slug: "florante-t-garcia",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth Anne",
    lastName: "Garcia",
    title: "Assistant Director for Financial Reconciliation, Gift Systems",
    slug: "elizabeth-anne-garcia",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Enoe",
    lastName: "Garcia",
    title: "Financial Coordinator / Proc",
    slug: "enoe-garcia",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Evelyn",
    lastName: "Garcia",
    title: "Administrative Assistant",
    slug: "evelyn-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Delia",
    lastName: "Garcia",
    title: "Executive Assistant",
    slug: "delia-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony Raymond",
    lastName: "Garcia",
    title: "Project Coordinator",
    slug: "anthony-raymond-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander I",
    lastName: "Garcia",
    title: "Assistant Director of Research and Technology",
    slug: "alexander-i-garcia",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adlar",
    lastName: "Garcia",
    title:
      " Associate Dean for Columbia College Alumni Relations and Engagement",
    slug: "adlar-garcia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alina",
    lastName: "Garcia",
    title: "HHMI/Lab Administrator",
    slug: "alina-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angela",
    lastName: "Garcia",
    title: "Front Desk Secretary",
    slug: "angela-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ana J.",
    lastName: "Garcia",
    title: "Program Manager",
    slug: "ana-j-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alia V.",
    lastName: "Garcia",
    title: "Data Coordinator II",
    slug: "alia-v-garcia",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Allison",
    lastName: "Garcia",
    title: "HR Coordinator",
    slug: "allison-garcia",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Angela",
    lastName: "Garcia",
    title: "Administration and Operations Manager",
    slug: "angela-garcia-1",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alicia",
    lastName: "Garcia",
    title: "Program Support Coordinator",
    slug: "alicia-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Krystal",
    lastName: "Garcia Geraldo",
    title: "Community Engagement Associate",
    slug: "krystal-garcia-geraldo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marina Elizabeth",
    lastName: "Garcia Santos",
    title: "Research Project Coordinator",
    slug: "marina-elizabeth-garcia-santos",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carmen Elena",
    lastName: "Garcia-Quiroz",
    title: "Project Coordinator",
    slug: "carmen-elena-garcia-quiroz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lamar Orlando Odane",
    lastName: "Gardner",
    title: "Associate Manager - Operations",
    slug: "lamar-orlando-odane-gardner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonelle Janna",
    lastName: "Gardner",
    title: "Senior Secretary",
    slug: "jonelle-janna-gardner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ava P.",
    lastName: "Gardner",
    title: "Coordinator",
    slug: "ava-p-gardner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Helen B.",
    lastName: "Garey",
    title: "Associate Director, SCMR",
    slug: "helen-b-garey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ruth",
    lastName: "Garibaldi",
    title: "Associate Director for Academic Appointments",
    slug: "ruth-garibaldi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Noemi",
    lastName: "Garibay",
    title: "Assistant Registrar",
    slug: "noemi-garibay",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Muhammed L",
    lastName: "Garland",
    title: "Live Support Specialist",
    slug: "muhammed-l-garland",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kendral L.",
    lastName: "Garlick",
    title: "Administrative Assistant I",
    slug: "kendral-l-garlick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily F",
    lastName: "Garner",
    title: "Grants Coordinator",
    slug: "emily-f-garner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shaquoia D",
    lastName: "Garo",
    title: "Alumni Relations Associate",
    slug: "shaquoia-d-garo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "George S.",
    lastName: "Garrett",
    title: "Director, Technology and Infrastructure and Support",
    slug: "george-s-garrett",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ernesto",
    lastName: "Garrido",
    title: "Service Desk Tech Tier II",
    slug: "ernesto-garrido",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Will",
    lastName: "Garvey",
    title: "Consultant",
    slug: "will-garvey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shaquille",
    lastName: "Garvey",
    title: "Mail Clerk",
    slug: "shaquille-garvey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Garwood",
    title: "Director of Finance and Administration",
    slug: "amy-garwood",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andres",
    lastName: "Garza",
    title: "Development Associate",
    slug: "andres-garza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer A",
    lastName: "Gass",
    title: "Senior HR Business Partner",
    slug: "jennifer-a-gass",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "David",
    lastName: "Gastwirth",
    title: "Staff",
    slug: "david-gastwirth",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "Gately",
    title: "Assistant Director, Center for American Studies",
    slug: "michael-gately",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jamilette M.",
    lastName: "Gaton",
    title: "Promotions Specialist",
    slug: "jamilette-m-gaton",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tommy",
    lastName: "Gavaris",
    title: "Divisional Administrator",
    slug: "tommy-gavaris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacqueline",
    lastName: "Gavin",
    title: "Orthoptist",
    slug: "jacqueline-gavin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "Gawronski",
    title: "Western Sales Representative",
    slug: "william-gawronski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Krista N.",
    lastName: "Gay",
    title: "Program Assistant",
    slug: "krista-n-gay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carri-Ann",
    lastName: "Gay",
    title: "Research Compliance Specialist",
    slug: "carri-ann-gay",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anna Cristina",
    lastName: "Gayla",
    title: "Director of Donor Relations and Gift Administration",
    slug: "anna-cristina-gayla",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joshua William",
    lastName: "Gaynor",
    title: "Advising Dean",
    slug: "joshua-william-gaynor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William Oxley",
    lastName: "Gaythwaite",
    title: "Assistant Director of Registration Services, Special Populations",
    slug: "william-oxley-gaythwaite",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Matthew Daniel",
    lastName: "Gazda",
    title: "Director, Data Management",
    slug: "matthew-daniel-gazda",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Huaizhi",
    lastName: "Ge",
    title: "Data Coordinator",
    slug: "huaizhi-ge",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nardos",
    lastName: "Gebremicheal",
    title: "Specialist, Finance and Operations",
    slug: "nardos-gebremicheal",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Betty Y.",
    lastName: "Gee",
    title: "File Room Coordinator",
    slug: "betty-y-gee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Makella-Ann",
    lastName: "Geffrard",
    title: "Military and Veteran Affairs/Financial Aid Officer",
    slug: "makella-ann-geffrard",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marie P",
    lastName: "Gelin",
    title: "Variable Hours Office",
    slug: "marie-p-gelin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalia",
    lastName: "Gell",
    title: "Senior Secretary",
    slug: "natalia-gell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brooke",
    lastName: "Geller",
    title: "Interim Employee",
    slug: "brooke-geller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina R.",
    lastName: "Gellhorn",
    title: "Executive Assistant",
    slug: "christina-r-gellhorn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Denise",
    lastName: "Gelpi",
    title: "Administrative Coordinator",
    slug: "denise-gelpi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maggie",
    lastName: "Gelwix",
    title: "Digital Strategist",
    slug: "maggie-gelwix",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lorena",
    lastName: "Genao",
    title: "Associate Director of Human Resources",
    slug: "lorena-genao",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tania",
    lastName: "Genel",
    title: "Contractor",
    slug: "tania-genel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Genrich",
    title: "Director of Communications",
    slug: "jennifer-genrich",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kimberly Y",
    lastName: "Geoffrey",
    title: "Project Coordinator",
    slug: "kimberly-y-geoffrey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessy",
    lastName: "George",
    title: "Senior Project Officer",
    slug: "jessy-george",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jino J",
    lastName: "George",
    title: "Director, Financial Operations",
    slug: "jino-j-george",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bryan Wilson",
    lastName: "George",
    title: "IT Configurations Manager",
    slug: "bryan-wilson-george",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michele",
    lastName: "George-Peters",
    title: "Payroll Specialist",
    slug: "michele-george-peters",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bailey",
    lastName: "Georges",
    title: "Variable Hour Officer",
    slug: "bailey-georges",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Misael",
    lastName: "Gerena",
    title: "Senior Financial Manager",
    slug: "misael-gerena",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maria E.",
    lastName: "Gerena",
    title: "Senior Human Resources Business Partner",
    slug: "maria-e-gerena",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Margaret",
    lastName: "German",
    title: "Finance & Admin Coordinator",
    slug: "margaret-german",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Raphael Thomas",
    lastName: "Gerraty",
    title: "Managing Director, MRI Platform",
    slug: "raphael-thomas-gerraty",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eugene",
    lastName: "Gershteyn",
    title: "BRIDGE Info Tech Director",
    slug: "eugene-gershteyn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ingrid E.",
    lastName: "Gerstmann",
    title: "Assistant Director",
    slug: "ingrid-e-gerstmann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria Ricaida R",
    lastName: "Gervacio",
    title: "Senior Grants Accountant",
    slug: "maria-ricaida-r-gervacio",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nigel Philip",
    lastName: "Ghany",
    title: "Financial Manager",
    slug: "nigel-philip-ghany",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laudan E.",
    lastName: "Ghayebi",
    title: "Project Manager",
    slug: "laudan-e-ghayebi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vanessa Christine",
    lastName: "Giardino",
    title: "Project Coordinator",
    slug: "vanessa-christine-giardino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adriana",
    lastName: "Gibbons",
    title: "Budget and Finance Manager",
    slug: "adriana-gibbons",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Clarence H.",
    lastName: "Gifford",
    title: "Assistant Dean",
    slug: "clarence-h-gifford",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth",
    lastName: "Gil Guadalupe",
    title: "Operations Mgmt Coordinator",
    slug: "elizabeth-gil-guadalupe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Morgan Frances",
    lastName: "Gilbard",
    title: "Senior Associate Director of Communications",
    slug: "morgan-frances-gilbard",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Siobhan Marielle",
    lastName: "Gilbert",
    title: "Digital Mrkting & Comm Manager",
    slug: "siobhan-marielle-gilbert",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laura L.",
    lastName: "Gilbert",
    title: "Assistant Director",
    slug: "laura-l-gilbert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gracie Yanna",
    lastName: "Gilbert",
    title: "Audit Manager - Data Analytics",
    slug: "gracie-yanna-gilbert",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jatinder",
    lastName: "Gill",
    title: "Junior Accountant",
    slug: "jatinder-gill",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Daljeet Kaur",
    lastName: "Gill",
    title: "Assistant Director PMO",
    slug: "daljeet-kaur-gill",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alison Carr",
    lastName: "Gillespie",
    title: "Staff",
    slug: "alison-carr-gillespie",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Clarissa B.",
    lastName: "Gilliam",
    title: "Director of Human Resources",
    slug: "clarissa-b-gilliam",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rachel",
    lastName: "Gilliar",
    title: "Associate Director, Investigations",
    slug: "rachel-gilliar",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Eileen",
    lastName: "Gillooly",
    title: "Executive Director, Heyman Ctr",
    slug: "eileen-gillooly",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephanie J",
    lastName: "Gilman",
    title: "Associate Director - Practicum Learning",
    slug: "stephanie-j-gilman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Thomas R.",
    lastName: "Gilmore",
    title: "Production & Facility Manager",
    slug: "thomas-r-gilmore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nathan E.",
    lastName: "Gilmore",
    title: "Administrative Coordinator I",
    slug: "nathan-e-gilmore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ayanna",
    lastName: "Gilmore",
    title: "Program Manager",
    slug: "ayanna-gilmore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Macy",
    lastName: "Gimbel",
    title: "Generalist, HR/FA",
    slug: "macy-gimbel",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sylvia",
    lastName: "Gindick",
    title: "Program Manager",
    slug: "sylvia-gindick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kenesha F",
    lastName: "Giocastro",
    title: "Assistant Director, Leave Management",
    slug: "kenesha-f-giocastro",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Brendan D.",
    lastName: "Gioello",
    title: "Technical Support Specialist",
    slug: "brendan-d-gioello",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sandra",
    lastName: "Giordano",
    title: "Senior Finance and Compliance Manager",
    slug: "sandra-giordano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anthony R",
    lastName: "Glad",
    title: "Dir, Stud Fin Aid & Planning",
    slug: "anthony-r-glad",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Harvey",
    lastName: "Gladden",
    title: "Officer-Digital Communications",
    slug: "harvey-gladden",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan K.",
    lastName: "Glancy",
    title: "Secretary of the University",
    slug: "susan-k-glancy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eve",
    lastName: "Glasberg",
    title: "Director, Arts & Culture Communications",
    slug: "eve-glasberg",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Charlene",
    lastName: "Glascock",
    title: "Consultant",
    slug: "charlene-glascock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evan Alexander",
    lastName: "Glassberg",
    title: "VP&S COI Coordinator",
    slug: "evan-alexander-glassberg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mitchell",
    lastName: "Glazier",
    title: "Creative Writing Pre-College & Undergraduate Program Administrator",
    slug: "mitchell-glazier",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joshua",
    lastName: "Gleich",
    title: "Associate Director of Administration, Enterprise Risk Management",
    slug: "joshua-gleich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Glenn Bass",
    title: "Research Director",
    slug: "katherine-glenn-bass",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dylan Thomas",
    lastName: "Glickel",
    title: "Director, ZI Events and Administrative Services",
    slug: "dylan-thomas-glickel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Garret",
    lastName: "Glinka",
    title: "HHMI/Lab Administrator",
    slug: "garret-glinka",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth",
    lastName: "Gloder",
    title: "Administrative Assistant",
    slug: "elizabeth-gloder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle K.",
    lastName: "Glorioso",
    title: "Trainer",
    slug: "danielle-k-glorioso",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Matthew",
    lastName: "Glose",
    title: "Operations Manager and Executive Assistant to the COO",
    slug: "matthew-glose",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jim W",
    lastName: "Glover",
    title: "Senior Associate Dean for Academic Administration",
    slug: "jim-w-glover",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anastasiya",
    lastName: "Glubokovskikh",
    title: "Assistant Director of Admission Operations",
    slug: "anastasiya-glubokovskikh",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lisa",
    lastName: "Glynn",
    title: "Executive Director of Alumni Relations and Special Events",
    slug: "lisa-glynn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter L.",
    lastName: "Gmelch",
    title: "Grant and Research Development Specialist",
    slug: "peter-l-gmelch",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katharine D.",
    lastName: "Godfrey",
    title: "Senior Program Manager",
    slug: "katharine-d-godfrey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julie Novacek",
    lastName: "Godsoe",
    title:
      " Executive Director of Communications, Marketing, and Public Affairs",
    slug: "julie-novacek-godsoe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarahgrace",
    lastName: "Godwin",
    title: "Assistant Director - HP",
    slug: "sarahgrace-godwin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chad",
    lastName: "Goeden",
    title: "Associate Director for International Students Programs",
    slug: "chad-goeden",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sarah Elizabeth",
    lastName: "Goez",
    title: "Coordinator, Student Life",
    slug: "sarah-elizabeth-goez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Megan Ann Forbes",
    lastName: "Goger",
    title: "Associate Director, Investigations",
    slug: "megan-ann-forbes-goger",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Laura Elizabeth",
    lastName: "Gold",
    title: "Coordinator for the Protection of Minors",
    slug: "laura-elizabeth-gold",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Wendy",
    lastName: "Goldberg",
    title: "Associate Director, Pre-Award",
    slug: "wendy-goldberg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emma Kate",
    lastName: "Goldberg",
    title: "Graphic Designer",
    slug: "emma-kate-goldberg",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Deborah",
    lastName: "Goldberg",
    title: "Executive Director, Sponsored Projects Finance",
    slug: "deborah-goldberg",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aileen P",
    lastName: "Goldberg",
    title: "Talent Manager",
    slug: "aileen-p-goldberg",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jo",
    lastName: "Golden",
    title: "Associate Director for Administration and Planning",
    slug: "jo-golden",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Svetlana",
    lastName: "Goldenberg",
    title: "Special Visitor",
    slug: "svetlana-goldenberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamie Michelle",
    lastName: "Goldenberg",
    title: "Assistant Director, Admissions",
    slug: "jamie-michelle-goldenberg",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Olga",
    lastName: "Goldengorn",
    title: "Administrative Coordinator",
    slug: "olga-goldengorn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura A.",
    lastName: "Goldenkranz",
    title: "Administrative Coordinator I",
    slug: "laura-a-goldenkranz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Benjamin M.",
    lastName: "Goldie",
    title: "Director of Information Tech",
    slug: "benjamin-m-goldie",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kian M.",
    lastName: "Goldman",
    title: "Assistant Director - Urban Planning",
    slug: "kian-m-goldman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandra",
    lastName: "Goldmark",
    title:
      " Senior Assistant Dean of Interdisciplinary Engagement, Climate School",
    slug: "sandra-goldmark",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kimberly Ann",
    lastName: "Goldner",
    title: "Affiliate",
    slug: "kimberly-ann-goldner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David A.",
    lastName: "Goldsheft",
    title: "Senior Contracts Officer",
    slug: "david-a-goldsheft",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ann Marie",
    lastName: "Goldsman",
    title:
      " Assistant Director, Human Resources in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "ann-marie-goldsman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jill Tracy",
    lastName: "Goldstein",
    title: "Associate Director-Budget Information Systems",
    slug: "jill-tracy-goldstein",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carrie V.",
    lastName: "Golston",
    title: "Director, Financial Compliance",
    slug: "carrie-v-golston",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Desmar Antonio",
    lastName: "Gomes",
    title: "Major Gifts Officer, Columbia College, Arts & Sciences",
    slug: "desmar-antonio-gomes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher",
    lastName: "Gomes",
    title: "CHEF MANAGER",
    slug: "christopher-gomes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Audree",
    lastName: "Gomes",
    title: "Technical Specialist",
    slug: "audree-gomes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aaron T",
    lastName: "Gomes",
    title: "Executive Director of Student Engagement",
    slug: "aaron-t-gomes",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Samantha",
    lastName: "Gomez",
    title: "Administrative Assistant",
    slug: "samantha-gomez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olga Marlene",
    lastName: "Gomez",
    title: "Administrative Coordinator",
    slug: "olga-marlene-gomez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicauly",
    lastName: "Gomez",
    title: "Executive Assistant",
    slug: "nicauly-gomez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Gomez",
    title: "General Accounting Specialist",
    slug: "michelle-gomez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karolin Yoana",
    lastName: "Gomez",
    title: "Associate Service Specialist",
    slug: "karolin-yoana-gomez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Gomez",
    title: "Regulatory Coordinator II",
    slug: "katherine-gomez",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kenia A",
    lastName: "Gomez",
    title: "Grants Manager",
    slug: "kenia-a-gomez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Juan",
    lastName: "Gomez",
    title: "Rounds Person",
    slug: "juan-gomez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Gomez",
    title: "Business Services Coordinator",
    slug: "jessica-gomez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gleniza A",
    lastName: "Gomez",
    title: "Administrative Assistant",
    slug: "gleniza-a-gomez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Astrith Gabriela",
    lastName: "Gomez",
    title: "Instructional Support Supervisor",
    slug: "astrith-gabriela-gomez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maria Lorena",
    lastName: "Gomez Blum",
    title: "Project Coordinator II",
    slug: "maria-lorena-gomez-blum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rafael Yamir",
    lastName: "Gomez Carrasco",
    title: "Senior Program Manager",
    slug: "rafael-yamir-gomez-carrasco",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Urszula",
    lastName: "Gonera",
    title: "Assistant Director, Research Policy & Indirect Cost",
    slug: "urszula-gonera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dorota",
    lastName: "Gonera",
    title: "Manager, Gifts Receivables",
    slug: "dorota-gonera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Teresa",
    lastName: "Gong",
    title: "Outreach Program Manager",
    slug: "teresa-gong",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Taehee",
    lastName: "Gong",
    title: "Grants Manager",
    slug: "taehee-gong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Verona",
    lastName: "Gonzalez",
    title: "Administrative Aide",
    slug: "verona-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stanley",
    lastName: "Gonzalez",
    title: "Comparative Medicine Asst",
    slug: "stanley-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Gonzalez",
    title: "Administrative Assistant",
    slug: "stephanie-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Roselen",
    lastName: "Gonzalez",
    title: "Senior Student Services Rep",
    slug: "roselen-gonzalez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nereyda",
    lastName: "Gonzalez",
    title: "Administrative Director",
    slug: "nereyda-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nikky",
    lastName: "Gonzalez",
    title: "Senior Development Associate",
    slug: "nikky-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Gonzalez",
    title: "CT Tech",
    slug: "michelle-gonzalez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mayra",
    lastName: "Gonzalez",
    title: "Recruitment Coordinator",
    slug: "mayra-gonzalez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Leroy",
    lastName: "Gonzalez",
    title: "Database Administrator",
    slug: "leroy-gonzalez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Janet",
    lastName: "Gonzalez",
    title: "Executive Assistant",
    slug: "janet-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacquelina",
    lastName: "Gonzalez",
    title: "Compliance & Training Coord",
    slug: "jacquelina-gonzalez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joeandy",
    lastName: "Gonzalez",
    title: "Alan Joel",
    slug: "joeandy-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juan",
    lastName: "Gonzalez",
    title: "Simulation Technology Manager",
    slug: "juan-gonzalez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Johanna",
    lastName: "Gonzalez",
    title: "Assistant Director of Multimedia Operations",
    slug: "johanna-gonzalez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jose F.",
    lastName: "Gonzalez",
    title: "Senior Service Specialist",
    slug: "jose-f-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer D",
    lastName: "Gonzalez",
    title: "Administrator Coordinator",
    slug: "jennifer-d-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacqueline M",
    lastName: "Gonzalez",
    title: "Senior Secretary",
    slug: "jacqueline-m-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hector Luis",
    lastName: "Gonzalez",
    title: "Security Coordinator",
    slug: "hector-luis-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Frances C",
    lastName: "Gonzalez",
    title: "Manager-Assignments",
    slug: "frances-c-gonzalez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elizet",
    lastName: "Gonzalez",
    title: "Information Processing Assistant",
    slug: "elizet-gonzalez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Akira Akara",
    lastName: "Gonzalez",
    title: "Generalist, HR/FA",
    slug: "akira-akara-gonzalez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alfha Cristarlin",
    lastName: "Gonzalez",
    title: "Assistant to the Director",
    slug: "alfha-cristarlin-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex",
    lastName: "Gonzalez",
    title: "Staff",
    slug: "alex-gonzalez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anna R.",
    lastName: "Gonzalez",
    title: "Senior Student Services Rep",
    slug: "anna-r-gonzalez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Auxiliadora",
    lastName: "Gonzalez",
    title: "Assistant Director, Operations",
    slug: "auxiliadora-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ardenys P.",
    lastName: "Gonzalez",
    title: "Building Manager",
    slug: "ardenys-p-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Efrain",
    lastName: "Gonzalez Gomez",
    title: "Director of Pre-Award Operations",
    slug: "efrain-gonzalez-gomez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew William",
    lastName: "Good",
    title: "Director, Partnership Initiatives",
    slug: "andrew-william-good",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "Goodall",
    title: "Assistant Director, Career Design Lab",
    slug: "william-goodall",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Felicia C",
    lastName: "Goodman",
    title: "Chief of Staff",
    slug: "felicia-c-goodman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew M",
    lastName: "Goodwillie",
    title: "Data Systems Manager",
    slug: "andrew-m-goodwillie",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katharine",
    lastName: "Goodwin",
    title: "Senior Associate Director for Case Management and Student Support",
    slug: "katharine-goodwin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tajus V",
    lastName: "Gopal",
    title: "Digital Edu/Training Creator",
    slug: "tajus-v-gopal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Manasa",
    lastName: "Gopal",
    title: "Associate General Counsel",
    slug: "manasa-gopal",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Steve",
    lastName: "Gordon",
    title: "Manager-Print Services",
    slug: "steve-gordon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin",
    lastName: "Gordon",
    title: "Director of Administration, Applied Analytics",
    slug: "kevin-gordon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Annalise",
    lastName: "Gordon",
    title: "Administrative Assistant",
    slug: "annalise-gordon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Winston",
    lastName: "Gordon III",
    title: "Administrative Assistant",
    slug: "winston-gordon-iii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cynthia D.",
    lastName: "Gorey",
    title: "Director of Development",
    slug: "cynthia-d-gorey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eladia M",
    lastName: "Goris",
    title: "Administrative Assistant",
    slug: "eladia-m-goris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle E.",
    lastName: "Gorman",
    title:
      " Assistant to the Chief of Staff and Associate Director, Executive Support",
    slug: "kyle-e-gorman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Idina M.",
    lastName: "Gorman",
    title: "Executive Director, Labor Relations",
    slug: "idina-m-gorman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Eugene",
    lastName: "Gorodetsky",
    title: "Senior Web Developer, Web Initiatives",
    slug: "eugene-gorodetsky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ann",
    lastName: "Gorski-Lobue",
    title: "Executive Director of Strategy and Operations",
    slug: "ann-gorski-lobue",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Antervedi Bhargava",
    lastName: "Gorty",
    title: "Senior Director, Data Protection and Application Security",
    slug: "antervedi-bhargava-gorty",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tracy R.",
    lastName: "Gorveatte",
    title: "Executive Assistant and Projects Coordinator",
    slug: "tracy-r-gorveatte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joel Andrew",
    lastName: "Gorveatte",
    title: "Assistant Director, Recruitment",
    slug: "joel-andrew-gorveatte",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Hannah E.",
    lastName: "Gosney",
    title: "Assistant Director, Alumni Events and Programs",
    slug: "hannah-e-gosney",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lisa",
    lastName: "Gottardo",
    title: "Executive Director, Employer Relations",
    slug: "lisa-gottardo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dafna",
    lastName: "Gottesman",
    title: "Associate Dean for Admissions, International Programs",
    slug: "dafna-gottesman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Denise A.",
    lastName: "Gottwald",
    title: "Director, HR / FA",
    slug: "denise-a-gottwald",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Maryalice",
    lastName: "Goulet",
    title: "Legal Sec/Asst Paralegal",
    slug: "maryalice-goulet",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Shawna",
    lastName: "Gourgue",
    title: "Senior Finance and Compliance Manager, Sponsored Projects Finance",
    slug: "shawna-gourgue",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tatyana",
    lastName: "Gourov",
    title: "Senior Associate Director, Admissions",
    slug: "tatyana-gourov",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Dorret Ann",
    lastName: "Gouveia",
    title: "Sr Ops Officer-Reporting/Sys",
    slug: "dorret-ann-gouveia",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gerald Anthony",
    lastName: "Govia",
    title: "Project Coordinator II",
    slug: "gerald-anthony-govia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vanita R",
    lastName: "Gowda",
    title: "Chief Communications Officer",
    slug: "vanita-r-gowda",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicholas",
    lastName: "Gowens",
    title: "Director of Marketing and Participation",
    slug: "nicholas-gowens",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Megan",
    lastName: "Gowland",
    title: "Assistant Director, Admissions",
    slug: "megan-gowland",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sally Moskowitz",
    lastName: "Goyette",
    title: "Interim Literacy Practicum Supervsiors - Spring 2025",
    slug: "sally-moskowitz-goyette",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nick",
    lastName: "GradowskiSanchez",
    title: "Assistant Director, Human Resources",
    slug: "nick-gradowskisanchez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Janice Rafferty",
    lastName: "Grady",
    title: "Assoc Dean, Dev & Alumni Rel",
    slug: "janice-rafferty-grady",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Warren",
    lastName: "Graham",
    title: "Associate Dean of Practicum Learning",
    slug: "warren-graham",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kareem",
    lastName: "Graham",
    title: "Mail Clerk",
    slug: "kareem-graham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arah C",
    lastName: "Graham",
    title: "Business Operations Specialist",
    slug: "arah-c-graham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bruno D",
    lastName: "Granados Fosados",
    title: "Sr. Application Systems Developer",
    slug: "bruno-d-granados-fosados",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cecilia",
    lastName: "Granda",
    title: "Assistant Dean of Financial Aid",
    slug: "cecilia-granda",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sankara",
    lastName: "Grandhi",
    title: "Manager, Application Security",
    slug: "sankara-grandhi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ulysses L.",
    lastName: "Grant",
    title: "Production Assistant",
    slug: "ulysses-l-grant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Omeika N.",
    lastName: "Grant",
    title: "Administrative Clerk",
    slug: "omeika-n-grant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nekadda",
    lastName: "Grant",
    title: "Technican Assistant",
    slug: "nekadda-grant",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Deena Charise",
    lastName: "Grant",
    title: "Clerk",
    slug: "deena-charise-grant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charrekett",
    lastName: "Grant",
    title: "SYEP",
    slug: "charrekett-grant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aseeya",
    lastName: "Grant",
    title: "Administrative Assistant",
    slug: "aseeya-grant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanna Casey",
    lastName: "Granton",
    title: "Assistant Director, Academic Appointments & Payroll",
    slug: "joanna-casey-granton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael J",
    lastName: "Gratale",
    title:
      " Senior Associate Dean of Enrollment Management and Chief Technology Officer",
    slug: "michael-j-gratale",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sheree L",
    lastName: "Grate",
    title: "Digital Marketing Producer",
    slug: "sheree-l-grate",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amber Elizabeth",
    lastName: "Gratereaux",
    title: "Counselor - Career Services",
    slug: "amber-elizabeth-gratereaux",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kyle",
    lastName: "Gray",
    title:
      " Major Gift Officer, University Development (Domestic and International)",
    slug: "kyle-gray",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Devin L",
    lastName: "Gray",
    title: "Executive Director",
    slug: "devin-l-gray",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abigail Mary",
    lastName: "Gray",
    title: "Senior Associate Director, Content Development",
    slug: "abigail-mary-gray",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vanessa Y",
    lastName: "Grayman",
    title: "Executive Assistant and Procurement Operations Coordinator",
    slug: "vanessa-y-grayman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martyna",
    lastName: "Grazda",
    title: "Coordinator",
    slug: "martyna-grazda",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marina",
    lastName: "Grdzelishvili",
    title: "Revenue Cycle, Coding and Compliance Manager",
    slug: "marina-grdzelishvili",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patrick D",
    lastName: "Greaney",
    title: "Assistant Director, Admissions",
    slug: "patrick-d-greaney",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marissa",
    lastName: "Green",
    title: "Associate Director, Employer & Alumni Relations",
    slug: "marissa-green",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joanne Elizabeth",
    lastName: "Green",
    title: "Content Officer",
    slug: "joanne-elizabeth-green",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Isis",
    lastName: "Green",
    title: "Technical Support Specialist",
    slug: "isis-green",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Valerie",
    lastName: "Green Thomas",
    title: "University Affiliate - STEAM",
    slug: "valerie-green-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marina",
    lastName: "Greenberg",
    title: "Finance Manager",
    slug: "marina-greenberg",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lily E.",
    lastName: "Greenberg",
    title: "Research Administrator I",
    slug: "lily-e-greenberg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine Carole",
    lastName: "Greenberg",
    title: "IRB Specialist",
    slug: "katherine-carole-greenberg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Trey H.",
    lastName: "Greene III",
    title: "Manager-Outreach Programs",
    slug: "trey-h-greene-iii",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jacqueline E.",
    lastName: "Greene-Austin",
    title: "Assistant Director, Finance",
    slug: "jacqueline-e-greene-austin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph Defraine",
    lastName: "Greenwell",
    title: "Senior Vice President, Student Affairs",
    slug: "joseph-defraine-greenwell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Paige N.",
    lastName: "Greer",
    title: "Associate Dir of Annual Giving",
    slug: "paige-n-greer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sherette",
    lastName: "Gregg",
    title: "Executive Assistant, Dean's Office",
    slug: "sherette-gregg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Deanna Ghozati",
    lastName: "Gregory",
    title: "Director of Recruitment-Admissions",
    slug: "deanna-ghozati-gregory",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ian",
    lastName: "Gregory-Davis",
    title: "Senior Assistant Director",
    slug: "ian-gregory-davis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie V",
    lastName: "Grepo",
    title: "Associate Director, Capacity Building",
    slug: "stephanie-v-grepo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexandra A.",
    lastName: "Gribovskaya",
    title: "Director of Accreditation and Assessment",
    slug: "alexandra-a-gribovskaya",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jai",
    lastName: "Griem",
    title: "Director, Strategy and Operations",
    slug: "jai-griem",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah J",
    lastName: "Griffen",
    title: "Genetic Counseling Assistant",
    slug: "sarah-j-griffen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laverne A",
    lastName: "Griffith",
    title: "Executive Director, Benefit  & Pension Accounting & Reporting",
    slug: "laverne-a-griffith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amber E",
    lastName: "Griffiths",
    title: "Associate Dean of Student Wellness",
    slug: "amber-e-griffiths",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dennis J.",
    lastName: "Griggs",
    title: "Senior Media Technology Specialist",
    slug: "dennis-j-griggs",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Olivia J",
    lastName: "Grinberg-Phillips",
    title: "Coordinator, Saltzman Institute of War and Peace Studies",
    slug: "olivia-j-grinberg-phillips",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert Raymond",
    lastName: "Grinnell Jr",
    title: "Assistant Manager, HRPC",
    slug: "robert-raymond-grinnell-jr",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ryan",
    lastName: "Groendyk",
    title: "Academic Marketing Manager",
    slug: "ryan-groendyk",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Damien",
    lastName: "Grose",
    title: "Associate Director, Cost Analysis",
    slug: "damien-grose",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Steven J",
    lastName: "Gross",
    title: "Systems Administrator",
    slug: "steven-j-gross",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeffrey David",
    lastName: "Grossman",
    title: "Assistant Director, Integrated Communications",
    slug: "jeffrey-david-grossman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jill Ellen",
    lastName: "Grossman",
    title: "Director of Communications and Marketing",
    slug: "jill-ellen-grossman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Krystal",
    lastName: "Grow",
    title: "Program Manager-Dart Center",
    slug: "krystal-grow",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ryan",
    lastName: "Grubbs",
    title: "Director of Administration",
    slug: "ryan-grubbs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jody L.",
    lastName: "Grunfeld",
    title: "Asst Dean, Budget and Analysis",
    slug: "jody-l-grunfeld",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Adina",
    lastName: "Grunn",
    title: "Lab Manager/Technical Support",
    slug: "adina-grunn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julia",
    lastName: "Grushko",
    title: "Auditor",
    slug: "julia-grushko",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dawn E.",
    lastName: "Gruss",
    title: "Community Engagement Facilitator",
    slug: "dawn-e-gruss",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alejandra Marien",
    lastName: "Guadalupe",
    title: "Program Manager-SRC",
    slug: "alejandra-marien-guadalupe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natasha Soriano",
    lastName: "Guadalupe-Torres",
    title: "Director, Office of Sponsored Programs",
    slug: "natasha-soriano-guadalupe-torres",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steve",
    lastName: "Guaman",
    title: "HR Assistant",
    slug: "steve-guaman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle",
    lastName: "Guaman",
    title: "Senior Admissions Specialist, Pre-College Programs",
    slug: "michelle-guaman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Luke",
    lastName: "Guan",
    title: "Senior Technical Support Specialist",
    slug: "luke-guan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rosa",
    lastName: "Guante",
    title: "Benefits Associate",
    slug: "rosa-guante",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lydia",
    lastName: "Guardado",
    title: "Assistant Manager Billing Operations",
    slug: "lydia-guardado",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jazmin Paola",
    lastName: "Guardado",
    title: "International Projects and Partnerships Manager",
    slug: "jazmin-paola-guardado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pamela F",
    lastName: "Guardia",
    title: "Director of Administration and Planning",
    slug: "pamela-f-guardia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Guerra",
    title: "CDHV Staff",
    slug: "david-guerra",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rafael E.",
    lastName: "Guerrero",
    title: "Business Office Manager",
    slug: "rafael-e-guerrero",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicomedes",
    lastName: "Guerrero",
    title: "Senior Service Specialist",
    slug: "nicomedes-guerrero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Guerrero",
    title: "Systems Specialist",
    slug: "melissa-guerrero",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Heather K",
    lastName: "Guerrero",
    title: "Development Assistant",
    slug: "heather-k-guerrero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noemi",
    lastName: "Guerrero",
    title: "Accounts Payable Specialist",
    slug: "noemi-guerrero",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Guarionex",
    lastName: "Guerrero",
    title: "Senior Grants Administrator",
    slug: "guarionex-guerrero",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Erica",
    lastName: "Guevara",
    title: "Coding and Charge Edits Specialist III",
    slug: "erica-guevara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fanny N.",
    lastName: "Guex",
    title: "Associate Director",
    slug: "fanny-n-guex",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Issa",
    lastName: "Gueye",
    title: "Associate Director and Technical Lead, Information Technology",
    slug: "issa-gueye",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sonia",
    lastName: "Gugga",
    title: "Assistant Provost for Planning and Institutional Research",
    slug: "sonia-gugga",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marie Alex",
    lastName: "Gugnishev",
    title: "Associate Director of Administration, Bioethics",
    slug: "marie-alex-gugnishev",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamilah",
    lastName: "Guindo",
    title: "Administrative Assistant",
    slug: "jamilah-guindo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristi Lee",
    lastName: "Guinness",
    title: "Staff Developer",
    slug: "kristi-lee-guinness",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Siria",
    lastName: "Guity",
    title: "Coding Specialist",
    slug: "siria-guity",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Irina F.",
    lastName: "Guletsky",
    title: "Sr Application Sytstems Dev",
    slug: "irina-f-guletsky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael C.",
    lastName: "Gulino",
    title: "Admissions Officer",
    slug: "michael-c-gulino",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Russ Mark",
    lastName: "Gulizia",
    title: "Associate Registrar",
    slug: "russ-mark-gulizia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adria S.",
    lastName: "Gulizia",
    title: "Director of Training & Educ",
    slug: "adria-s-gulizia",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Adelia M",
    lastName: "Gulliver-Niles",
    title: "Purchasing Assistant",
    slug: "adelia-m-gulliver-niles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Timur",
    lastName: "Gulyamov",
    title: "Associate Director of Academic Planning and Reporting",
    slug: "timur-gulyamov",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew Joseph",
    lastName: "Gumbiner",
    title: "Chief External Affairs and Public Policy Officer",
    slug: "andrew-joseph-gumbiner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maia Grace",
    lastName: "Gumnit",
    title: "Public Programs Manager",
    slug: "maia-grace-gumnit",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Priya A",
    lastName: "Gunaseharan",
    title: "Senior AP and Procurement Manager",
    slug: "priya-a-gunaseharan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rita D.",
    lastName: "Gunther-McGrath",
    title: "Academic Director in Executive Education",
    slug: "rita-d-gunther-mcgrath",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anthony C.",
    lastName: "Gunthrope",
    title: "Clerical Asst",
    slug: "anthony-c-gunthrope",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Toni",
    lastName: "Gunthrope-Hardee",
    title: "Executive Assistant",
    slug: "toni-gunthrope-hardee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Xiu Yun",
    lastName: "Guo",
    title: "Accounts Payable Coordinator",
    slug: "xiu-yun-guo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Qiongfen",
    lastName: "Guo",
    title: "Research Admin Coordinator",
    slug: "qiongfen-guo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Helen Ruth",
    lastName: "Guo",
    title: "Business Manager",
    slug: "helen-ruth-guo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle",
    lastName: "Guo",
    title: "Academic Secretary",
    slug: "michelle-guo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vinod K.",
    lastName: "Gupta",
    title: "Director of IT Services",
    slug: "vinod-k-gupta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sunaina",
    lastName: "Gupta",
    title: "Sr. Application Systems Developer",
    slug: "sunaina-gupta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rupal",
    lastName: "Gupta",
    title: "Associate",
    slug: "rupal-gupta",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pankaj",
    lastName: "Gupta",
    title: "Director, Business Intelligence Application Systems",
    slug: "pankaj-gupta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexandra",
    lastName: "Gupta",
    title: "Assistant Editor",
    slug: "alexandra-gupta",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Irina",
    lastName: "Gurevich",
    title: "Administrative Coordinator",
    slug: "irina-gurevich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Molly Greer",
    lastName: "Gurny",
    title: "Senior Director of Legal Strategy and Policy",
    slug: "molly-greer-gurny",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Tianna Claire",
    lastName: "Gurwich",
    title: "Administrative Coordinator",
    slug: "tianna-claire-gurwich",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea F",
    lastName: "Gurwitt",
    title: "Editor and Communications Director",
    slug: "andrea-f-gurwitt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sara A.",
    lastName: "Gusik",
    title: "Sr.TechnologyLicensing Officer",
    slug: "sara-a-gusik",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tatiana V.",
    lastName: "Gussaki",
    title: "Grants Financial Manager",
    slug: "tatiana-v-gussaki",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy Marie Letitia",
    lastName: "Gustavsson",
    title: "Sr Dir, Strategic Initiatives",
    slug: "amy-marie-letitia-gustavsson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sydney Katelynn",
    lastName: "Guthrie",
    title: "Staffing Specialist",
    slug: "sydney-katelynn-guthrie",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Miriam",
    lastName: "Gutierrez",
    title:
      " HHMI Tech in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "miriam-gutierrez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cristina",
    lastName: "Gutierrez",
    title: "Administrative Clerk",
    slug: "cristina-gutierrez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brianna Prudencia",
    lastName: "Gutierrez",
    title: "Associate Director of Experiential Education",
    slug: "brianna-prudencia-gutierrez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maritza",
    lastName: "Gutierrez",
    title: "Executive Director, Recruitment and HR Compliance",
    slug: "maritza-gutierrez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Brianna",
    lastName: "Gutierrez",
    title:
      " Assistant Director of Development, Center for Global Energy Policy, SIPA",
    slug: "brianna-gutierrez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ariel",
    lastName: "Gutierrez",
    title: "Associate - Contracts",
    slug: "ariel-gutierrez",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jennifer",
    lastName: "Gutierrez Marquez",
    title: "Assistant Director, Admissions",
    slug: "jennifer-gutierrez-marquez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Analia",
    lastName: "Gutierrez Martinez",
    title: "Administrative Assistant",
    slug: "analia-gutierrez-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlyn Anne",
    lastName: "Guy",
    title:
      " Managing Director, Geopolitics of Climate Change and Energy Transition",
    slug: "kaitlyn-anne-guy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samuel E",
    lastName: "Guyer",
    title: "Administrative Assistant",
    slug: "samuel-e-guyer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yanel",
    lastName: "Guzman",
    title: "Administrative Coordinator",
    slug: "yanel-guzman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robyn",
    lastName: "Guzman",
    title: "Director, Marketing Analytics and Performance",
    slug: "robyn-guzman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Keila",
    lastName: "Guzman",
    title: "Executive Assistant",
    slug: "keila-guzman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason T.",
    lastName: "Guzman",
    title: "Senior Media Producer",
    slug: "jason-t-guzman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessica",
    lastName: "Guzman",
    title: "Human Resources Generalist",
    slug: "jessica-guzman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gregory A",
    lastName: "Guzman",
    title: "Coordinator, Research Edu Ops",
    slug: "gregory-a-guzman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Desiree",
    lastName: "Guzman",
    title: "Input Control Specialist",
    slug: "desiree-guzman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Ha",
    title: "Director, Columbia Scholastic Press Association",
    slug: "jennifer-ha",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alyssa J.",
    lastName: "Ha",
    title: "Sr Manager Budget and Finance",
    slug: "alyssa-j-ha",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Olivia Leigh",
    lastName: "Haag",
    title: "Compliance and Training Coord",
    slug: "olivia-leigh-haag",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer",
    lastName: "Haastrup",
    title: "Program Manager, Student Life",
    slug: "jennifer-haastrup",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mark",
    lastName: "Habana",
    title: "Director of Research and Grants Development",
    slug: "mark-habana",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mona",
    lastName: "Habbal",
    title: "Program Manager",
    slug: "mona-habbal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason H.",
    lastName: "Habbal",
    title: "Cloud Architect",
    slug: "jason-h-habbal",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicole A.",
    lastName: "Haberland",
    title: "Director,Strategic Initiatives",
    slug: "nicole-a-haberland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rezina Tsehai",
    lastName: "Habtemariam",
    title: "Managing Editor of Logics",
    slug: "rezina-tsehai-habtemariam",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Katja",
    lastName: "Hafendoerfer",
    title: "Director of Development, Graduate School of Journalism",
    slug: "katja-hafendoerfer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kelly A",
    lastName: "Hafermann",
    title: "Administrative Manager",
    slug: "kelly-a-hafermann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard",
    lastName: "Hagen",
    title: "Director, Bridge to PhD Program",
    slug: "richard-hagen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily Suzanne",
    lastName: "Hagen",
    title: "Administrative Assistant",
    slug: "emily-suzanne-hagen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher P.",
    lastName: "Hagen",
    title: "Academic Program Support in Professional Studies",
    slug: "christopher-p-hagen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julia",
    lastName: "Hahn",
    title: "Production Manager",
    slug: "julia-hahn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zeina M",
    lastName: "Haidar",
    title: "Instructional Support Associate",
    slug: "zeina-m-haidar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael D",
    lastName: "Hailstock",
    title: "Senior Mail Operations Clerk",
    slug: "michael-d-hailstock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kenia Danelle",
    lastName: "Hale",
    title: "Administrative Coordinator",
    slug: "kenia-danelle-hale",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittany",
    lastName: "Halinka",
    title: "Director, Programs and Events",
    slug: "brittany-halinka",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley L",
    lastName: "Halinski",
    title: "Asst Director, IRB Management",
    slug: "ashley-l-halinski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tia-Tenarge",
    lastName: "Hall",
    title: "Associate Manager-Lerner Hall",
    slug: "tia-tenarge-hall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacy A.",
    lastName: "Hall",
    title: "Billing Manager",
    slug: "stacy-a-hall",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Richard D.",
    lastName: "Hall",
    title: "AVP, Business School Information Technology",
    slug: "richard-d-hall",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle V",
    lastName: "Hall",
    title: "Managing Director",
    slug: "michelle-v-hall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary J",
    lastName: "Hall",
    title: "Administrative Aide",
    slug: "mary-j-hall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael Patrick",
    lastName: "Hall",
    title: "Executive Director of Financial Aid",
    slug: "michael-patrick-hall",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Camille R",
    lastName: "Hall",
    title: "Director of Events and Career Programming",
    slug: "camille-r-hall",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Takeisha",
    lastName: "Hall-Ruff",
    title: "Ex Dir Dev,Corp&Foundation Rel",
    slug: "takeisha-hall-ruff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric A",
    lastName: "Halperin",
    title: "Student Affairs Generalist",
    slug: "eric-a-halperin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gergana",
    lastName: "Halpern",
    title: "Deputy Director",
    slug: "gergana-halpern",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicola Ponzi",
    lastName: "Hamacher",
    title: "Consultant",
    slug: "nicola-ponzi-hamacher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leora",
    lastName: "Hamberger",
    title: "Assistant Lab. Coord",
    slug: "leora-hamberger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Xavier A.",
    lastName: "Hamilton",
    title: "Assistant Director, Advising",
    slug: "xavier-a-hamilton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Scot G.",
    lastName: "Hamilton",
    title: "Senior Director, Agreement Review and Execution",
    slug: "scot-g-hamilton",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Racquel",
    lastName: "Hamilton-Langdon",
    title: "Senior Accountant",
    slug: "racquel-hamilton-langdon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexa",
    lastName: "Hammel",
    title: "Senior Associate Director of Programs and Operations",
    slug: "alexa-hammel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael A.",
    lastName: "Hammer",
    title: "Human Resources Manager",
    slug: "michael-a-hammer",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "William",
    lastName: "Hammond",
    title: "Director, Internal Audit",
    slug: "william-hammond",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Robert D.",
    lastName: "Hammond",
    title: "Able-Bodied Seaperson",
    slug: "robert-d-hammond",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Xinwei",
    lastName: "Han",
    title: "Research Support Assistant",
    slug: "xinwei-han",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shelley",
    lastName: "Han",
    title: "Associate Director",
    slug: "shelley-han",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Han",
    title: "Associate Director",
    slug: "michelle-han",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie",
    lastName: "Han",
    title: "Associate Director of Graduate Admissions Operations",
    slug: "julie-han",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Grace H.",
    lastName: "Han",
    title: "Executive Director of Admissions and Financial Aid",
    slug: "grace-h-han",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Barbara A.",
    lastName: "Han",
    title: "Executive Director of Operations",
    slug: "barbara-a-han",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John",
    lastName: "Handal",
    title: "Senior Program Manager",
    slug: "john-handal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janine",
    lastName: "Handfus",
    title: "Associate Dir, Annual Fund",
    slug: "janine-handfus",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephen T.",
    lastName: "Hands",
    title: "Executive Finance and Compensation Officer",
    slug: "stephen-t-hands",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Felicia",
    lastName: "Haney",
    title: "Sr Act Rep-Team Leader",
    slug: "felicia-haney",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tara",
    lastName: "Hanna",
    title:
      " Associate Dean, Undergraduate Student Life; Executive Director, Residential Life",
    slug: "tara-hanna",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Domenica",
    lastName: "Hanna",
    title: "Administrative Assistant",
    slug: "domenica-hanna",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Randy A",
    lastName: "Hannig Jr",
    title: "Assistant Director, Office of Management & Budget",
    slug: "randy-a-hannig-jr",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John J.",
    lastName: "Hannon",
    title: "Director, Finance and Human Resources Service Center",
    slug: "john-j-hannon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leah",
    lastName: "Hannum",
    title: "Senior Coordinator, Executive Support",
    slug: "leah-hannum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael P",
    lastName: "Hanrahan",
    title: "Procurement Specialist",
    slug: "michael-p-hanrahan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina E.",
    lastName: "Hansen",
    title: "Senior Director",
    slug: "christina-e-hansen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Derek D",
    lastName: "Hanson",
    title: "Assistant Director, HR Strategic Initiatives",
    slug: "derek-d-hanson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Zixun",
    lastName: "Hao",
    title: "Assoc Director, Data&Analytics",
    slug: "zixun-hao",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John Christopher",
    lastName: "Harbison",
    title: "Manager of Executive Education",
    slug: "john-christopher-harbison",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristine E",
    lastName: "Harding",
    title: "Administrative Aide",
    slug: "kristine-e-harding",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth Rhiannon",
    lastName: "Harding",
    title: "Research Physical Therapist",
    slug: "elizabeth-rhiannon-harding",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anne",
    lastName: "Harding",
    title: "Senior Editorial Manager",
    slug: "anne-harding",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Arielle",
    lastName: "Harding II",
    title: "Comm & Mrktg Coordinator",
    slug: "arielle-harding-ii",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sean L.",
    lastName: "Hardwick",
    title: "Associate Director",
    slug: "sean-l-hardwick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katy E.",
    lastName: "Hardy",
    title: "Department Administrator",
    slug: "katy-e-hardy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sonovia",
    lastName: "Harmon",
    title: "Associate Director of Programing",
    slug: "sonovia-harmon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin E",
    lastName: "Harned",
    title: "Project Manager",
    slug: "erin-e-harned",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Reginald Steven",
    lastName: "Harriett",
    title: "Accounting Coordinator",
    slug: "reginald-steven-harriett",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Richard Caldwell",
    lastName: "Harrill",
    title: "Executive Director, Community Impact",
    slug: "richard-caldwell-harrill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandra",
    lastName: "Harris",
    title: "VP, Comm Affairs/Partnshp Eng",
    slug: "sandra-harris",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sharon N.",
    lastName: "Harris",
    title: "Administrative Assistant",
    slug: "sharon-n-harris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lorna",
    lastName: "Harris",
    title: "Assistant Compliance Officer",
    slug: "lorna-harris",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Joy O",
    lastName: "Harris",
    title: "Guest Service Representative",
    slug: "joy-o-harris",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason",
    lastName: "Harris",
    title: "Human Resources and Recruitment Manager",
    slug: "jason-harris",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Emily Michael",
    lastName: "Harris",
    title: "Director of Public Interest Lawyering and Strategic Initiatives",
    slug: "emily-michael-harris",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Day L.",
    lastName: "Harris-Drake",
    title: "Associate Director, Healthy Minds and Bodies",
    slug: "day-l-harris-drake",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kareem",
    lastName: "Harrison",
    title: "Senior Project Officer",
    slug: "kareem-harrison",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Summer",
    lastName: "Hart",
    title: "Chief Creative Officer",
    slug: "summer-hart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan",
    lastName: "Hart",
    title: "Executive Director of Planned Giving",
    slug: "ryan-hart",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jerry Brian",
    lastName: "Hart",
    title: "Guest Service Representative",
    slug: "jerry-brian-hart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caroline",
    lastName: "Harting",
    title: "Senior Director, Communications and Creative Services",
    slug: "caroline-harting",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tanya",
    lastName: "Harvey",
    title: "Technical Support Specialist",
    slug: "tanya-harvey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pamela J",
    lastName: "Harvey-Brown",
    title: "Director, Career Education Initiatives",
    slug: "pamela-j-harvey-brown",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ali",
    lastName: "Hasanaj",
    title: "Assistant Director, Employer Relations",
    slug: "ali-hasanaj",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Karen",
    lastName: "Hasher",
    title: "Program Manager",
    slug: "karen-hasher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Masako",
    lastName: "Hashimoto",
    title: "Asst Director, Career Services",
    slug: "masako-hashimoto",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael",
    lastName: "Haskell",
    title: "Publishing Systems Manager/Manuscript Ed",
    slug: "michael-haskell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John A.",
    lastName: "Haskins",
    title: "Dean of Student Affairs, Professional Prizes and Programs",
    slug: "john-a-haskins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrew Warren",
    lastName: "Hass",
    title: "Associate Dean of Finance",
    slug: "andrew-warren-hass",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John F.",
    lastName: "Hasson",
    title: "Steward",
    slug: "john-f-hasson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan",
    lastName: "Hastie",
    title: "Grants Manager in the Department of Chemistry",
    slug: "ryan-hastie",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ryan K",
    lastName: "Hata",
    title: "Assistant Director",
    slug: "ryan-k-hata",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria Rose",
    lastName: "Hataier",
    title: "PT Administrator",
    slug: "maria-rose-hataier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alicia Christine",
    lastName: "Hatfield",
    title: "Administrative Assistant",
    slug: "alicia-christine-hatfield",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ivy T.",
    lastName: "Hatsengate",
    title: "Director, Advising and Strategic Projects",
    slug: "ivy-t-hatsengate",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Xiaoming",
    lastName: "Haugh",
    title: "Administrative Director",
    slug: "xiaoming-haugh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine E",
    lastName: "Haupert",
    title: "Chief of Staff",
    slug: "katherine-e-haupert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ing",
    lastName: "Haviland",
    title: "Comm Writer-Scientific Grant",
    slug: "ing-haviland",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alice M.",
    lastName: "Haviland",
    title: "Academic Program Support in Professional Studies",
    slug: "alice-m-haviland",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Haw",
    title: "Manager, Procurement and Reconciliation",
    slug: "sarah-haw",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mark",
    lastName: "Hawkins",
    title: "Vice President, Finance and Controller",
    slug: "mark-hawkins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eileen Patricia",
    lastName: "Hawley Nigro",
    title: "Assistant Director, OSP",
    slug: "eileen-patricia-hawley-nigro",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tomi",
    lastName: "Haxhi",
    title: "Business Manager",
    slug: "tomi-haxhi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Erald",
    lastName: "Haxhillari",
    title: "Senior Accountant, Sponsored Projects Finance Cash Team",
    slug: "erald-haxhillari",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kymani",
    lastName: "Hayden",
    title: "Asst Director-Social Media",
    slug: "kymani-hayden",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michelle Ann",
    lastName: "Hayden-Marsan",
    title: "Senior Development Associate",
    slug: "michelle-ann-hayden-marsan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shawn S.",
    lastName: "Hayes",
    title: "Benefits Specialist",
    slug: "shawn-s-hayes",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alison L.",
    lastName: "Hayes",
    title: "Director, West Coast Funding",
    slug: "alison-l-hayes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Olivia H.",
    lastName: "Haynes",
    title: "Managing Director",
    slug: "olivia-h-haynes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aletha",
    lastName: "Haynes",
    title: "Primary Division Director in The School",
    slug: "aletha-haynes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Keron Kevin",
    lastName: "Haywood",
    title: "Analytics Developer",
    slug: "keron-kevin-haywood",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Felicia R.",
    lastName: "Hazell",
    title: "Administrative Manager to the Co-Dean and Senior Associate Dean",
    slug: "felicia-r-hazell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Arielle Kaminer",
    lastName: "Hazi",
    title: "Data Manager",
    slug: "arielle-kaminer-hazi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yupeng",
    lastName: "He",
    title: "Student Acad Support Worker",
    slug: "yupeng-he",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brittany",
    lastName: "He",
    title: "Associate Director, Development Research",
    slug: "brittany-he",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert K",
    lastName: "Headd",
    title: "Utility",
    slug: "robert-k-headd",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Hannah L",
    lastName: "Healy",
    title: "Senior Assistant Director",
    slug: "hannah-l-healy",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Allison C.",
    lastName: "Heaps",
    title: "Project Manager",
    slug: "allison-c-heaps",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ra",
    lastName: "Hearne",
    title: "Digital Content Strategist, Strategic Communications",
    slug: "ra-hearne",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ryan F",
    lastName: "Heath",
    title: "Senior Director, Insights and Analytics",
    slug: "ryan-f-heath",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John Brad",
    lastName: "Hebel",
    title: "Director Sales Operating Officer",
    slug: "john-brad-hebel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Doreen M.",
    lastName: "Hebert",
    title: "Divisional Administrator-APLab",
    slug: "doreen-m-hebert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott M",
    lastName: "Hecht",
    title: "Director, Financial Aid Client Services",
    slug: "scott-m-hecht",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mindy Kalya Feldman",
    lastName: "Hecht",
    title: "Program Manager",
    slug: "mindy-kalya-feldman-hecht",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonah Ben",
    lastName: "Heckelman",
    title: "Director, Major Gifts and Planned Giving",
    slug: "jonah-ben-heckelman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Whitney Elizabeth Ann",
    lastName: "Hedgepeth",
    title: "Associate Director for Strategic Initiatives & Communication",
    slug: "whitney-elizabeth-ann-hedgepeth",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nina",
    lastName: "Heebink",
    title: "People/Culture Manager",
    slug: "nina-heebink",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sherri Lyn",
    lastName: "Heerapersaud",
    title: "Manager II",
    slug: "sherri-lyn-heerapersaud",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Britt A.",
    lastName: "Hefelfinger",
    title: "Associate Director, Strategic Projects",
    slug: "britt-a-hefelfinger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane E.",
    lastName: "Heffner",
    title: "Executive Director of Development",
    slug: "jane-e-heffner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bonnie M",
    lastName: "Heigl",
    title: "Project Coordinator I",
    slug: "bonnie-m-heigl",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elisa",
    lastName: "Heikkila",
    title: "Director for Development, Arts & Sciences",
    slug: "elisa-heikkila",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jack T.",
    lastName: "Hein",
    title: "Senior Manager of Visitor Relations",
    slug: "jack-t-hein",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Paola Carolina",
    lastName: "Heincke",
    title: "Senior Manager, Strategy & Operations",
    slug: "paola-carolina-heincke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lara S",
    lastName: "Hejtmanek",
    title: "Managing Director",
    slug: "lara-s-hejtmanek",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Molly R.",
    lastName: "Hellauer",
    title: "Associate Director, Correspondence and Briefings",
    slug: "molly-r-hellauer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephen",
    lastName: "Helmke",
    title: "Program Manager",
    slug: "stephen-helmke",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Molly",
    lastName: "Hemnauth",
    title: "Senior Generalist, HR/FA",
    slug: "molly-hemnauth",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dawn",
    lastName: "Hemphill",
    title: "Senior Advising Dean",
    slug: "dawn-hemphill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mara",
    lastName: "Henckler",
    title: "Executive Director, Columbia College Fund",
    slug: "mara-henckler",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy L.",
    lastName: "Hendershot",
    title: "Live Support Specialist",
    slug: "amy-l-hendershot",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vanessa N",
    lastName: "Henderson",
    title: "Assoc Director-EO/AA",
    slug: "vanessa-n-henderson",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Timothy P",
    lastName: "Henderson",
    title: "Executive Assistant",
    slug: "timothy-p-henderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachaele A",
    lastName: "Henderson",
    title: "Associate Director of Major Gifts",
    slug: "rachaele-a-henderson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Keely D.",
    lastName: "Henderson",
    title: "Vice Dean of Development and Alumni Relations",
    slug: "keely-d-henderson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara Elizabeth",
    lastName: "Hendery",
    title: "Communications Officer",
    slug: "sara-elizabeth-hendery",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Holland L.",
    lastName: "Hendrix",
    title: "President Emeritus",
    slug: "holland-l-hendrix",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tal T.",
    lastName: "Henig-Hadar",
    title: "Program Manager",
    slug: "tal-t-henig-hadar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christian F",
    lastName: "Henkel",
    title: "Lead Front-End & User Exp Engr",
    slug: "christian-f-henkel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kristen Ann",
    lastName: "Henlin",
    title: "Assistant Director of Student Support",
    slug: "kristen-ann-henlin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lina",
    lastName: "Henn",
    title: "Compliance & Inst Bill Coord",
    slug: "lina-henn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lindsey",
    lastName: "Hennawi",
    title: "NYSPI DEI Specialist",
    slug: "lindsey-hennawi",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Rafael",
    lastName: "Henriquez",
    title: "IT Systems Administrator",
    slug: "rafael-henriquez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Charo",
    lastName: "Henriquez",
    title: "Knight Bagehot Selector",
    slug: "charo-henriquez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeri L",
    lastName: "Henry",
    title:
      " Associate General Counsel and Director, Compliance and Special Projects",
    slug: "jeri-l-henry",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Alfonso D.",
    lastName: "Henry",
    title: "Porter",
    slug: "alfonso-d-henry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Denise",
    lastName: "Henry",
    title: "Coding and Charge Edits Specialist II",
    slug: "denise-henry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey",
    lastName: "Hensley",
    title: "Associate Vice President Finance",
    slug: "jeffrey-hensley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole B.",
    lastName: "Hentrich",
    title: "Senior Learning Designer",
    slug: "nicole-b-hentrich",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Narre",
    lastName: "Heon",
    title: "Project Manager and Evaluator",
    slug: "narre-heon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Herb",
    title: "Administrative Coordinator",
    slug: "danielle-herb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Heredia",
    title: "Dir, Ops&Strategic Initiatives",
    slug: "jennifer-heredia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carmen",
    lastName: "Heredia",
    title: "Secretary",
    slug: "carmen-heredia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John M.",
    lastName: "Herin",
    title: "Director of Development Services",
    slug: "john-m-herin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Huimin",
    lastName: "Herling",
    title: "Concentration Manager",
    slug: "huimin-herling",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah Elizabeth",
    lastName: "Herman",
    title: "Assistant Director, Digital Marketing",
    slug: "sarah-elizabeth-herman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mathieu",
    lastName: "Herman",
    title: "Project Manager",
    slug: "mathieu-herman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bernadette L",
    lastName: "Hernaiz",
    title: "Front Desk Coordinator",
    slug: "bernadette-l-hernaiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vilma",
    lastName: "Hernandez",
    title: "Accounts Payable Specialist",
    slug: "vilma-hernandez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Steven",
    lastName: "Hernandez",
    title: "Senior Admissions Specialist",
    slug: "steven-hernandez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Stephanie",
    lastName: "Hernandez",
    title: "Administrative Coordinator",
    slug: "stephanie-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ranjana",
    lastName: "Hernandez",
    title: "Administrative Coordinator",
    slug: "ranjana-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marilyn",
    lastName: "Hernandez",
    title: "SrDirector, Billing Compliance",
    slug: "marilyn-hernandez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meena",
    lastName: "Hernandez",
    title: "Front Desk Receptionist",
    slug: "meena-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mariella G",
    lastName: "Hernandez",
    title: "IRB Specialist",
    slug: "mariella-g-hernandez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lorraine",
    lastName: "Hernandez",
    title: "Asst Director for Gift Systems",
    slug: "lorraine-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John L.",
    lastName: "Hernandez",
    title: "Director of Grants and Contract Accounting",
    slug: "john-l-hernandez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Hernandez",
    title: "University Affiliate - STEAM",
    slug: "jennifer-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Hernandez",
    title: "Administrative Aide",
    slug: "jessica-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth M.",
    lastName: "Hernandez",
    title: "Assistant Director of Academic and Learning Initiatives",
    slug: "elizabeth-m-hernandez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher",
    lastName: "Hernandez",
    title: "Senior Grants Manager",
    slug: "christopher-hernandez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alicia",
    lastName: "Hernandez Concepcion",
    title: "Coordinator",
    slug: "alicia-hernandez-concepcion",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nestor",
    lastName: "Hernandez Jr",
    title: "Assistant Director of Student Engagement",
    slug: "nestor-hernandez-jr",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christian David",
    lastName: "Hernandez Melo",
    title: "Graduate Student Life Manager",
    slug: "christian-david-hernandez-melo",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gabriela M",
    lastName: "Hernandez Santiago",
    title: "Program Manager",
    slug: "gabriela-m-hernandez-santiago",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Myrna",
    lastName: "Hernandez-Jimenez",
    title: "Director, Financial Operations",
    slug: "myrna-hernandez-jimenez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wendy M.",
    lastName: "Hernandez-Quinones",
    title: "Senior Director, Admissions",
    slug: "wendy-m-hernandez-quinones",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jerome",
    lastName: "Hernando",
    title: "Manager, Revenue Cycle",
    slug: "jerome-hernando",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer J",
    lastName: "Herniman",
    title: "Digital Marketing Initiatives Contractor",
    slug: "jennifer-j-herniman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Saby",
    lastName: "Herrera",
    title: "Per Diem Surgical RN",
    slug: "saby-herrera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Omar",
    lastName: "Herrera",
    title: "Senior Manager, Events and Outreach",
    slug: "omar-herrera",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melissa C",
    lastName: "Herrera",
    title: "Assistant Director, Financial Planning and Analysis",
    slug: "melissa-c-herrera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Justine",
    lastName: "Herrera",
    title: "Sr Director Graduate Programs",
    slug: "justine-herrera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cileyn",
    lastName: "Herrera",
    title: "Program Manager",
    slug: "cileyn-herrera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arelis",
    lastName: "Herrera",
    title: "Administrative Assistant",
    slug: "arelis-herrera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alice",
    lastName: "Herrera",
    title: "Administrator, Research Edu Op",
    slug: "alice-herrera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maritza I",
    lastName: "Herrera-Diaz",
    title: "Metadata & Social Media Mgr.",
    slug: "maritza-i-herrera-diaz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gary L.",
    lastName: "Herrmann",
    title: "Department Administrator",
    slug: "gary-l-herrmann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kay Leanne",
    lastName: "Hershberger",
    title: "Advising Dean",
    slug: "kay-leanne-hershberger",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica",
    lastName: "Herstein",
    title: "Assistant Director, Finance",
    slug: "jessica-herstein",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Betti-Sue",
    lastName: "Hertz",
    title: "Director and Chief Curator",
    slug: "betti-sue-hertz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Herzig",
    title: "Senior Graphic Artist",
    slug: "brian-herzig",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Halayn J.",
    lastName: "Hescock",
    title: "Sr. Director, Research Services",
    slug: "halayn-j-hescock",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tianna",
    lastName: "Hewitt",
    title: "Financial Assistant",
    slug: "tianna-hewitt",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nina",
    lastName: "Heyman",
    title: "Director, Office of Well-Being",
    slug: "nina-heyman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Matthew E.",
    lastName: "Hicinbothem",
    title: "Service Specialist",
    slug: "matthew-e-hicinbothem",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia E",
    lastName: "Hickey",
    title: "Assoc Director, Alumni Comms",
    slug: "julia-e-hickey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jill Marie Galas",
    lastName: "Hickey",
    title: "Associate Dean for Development and Alumni Relations",
    slug: "jill-marie-galas-hickey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicole",
    lastName: "Hicks",
    title: "Administrative Assistant II",
    slug: "nicole-hicks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jon D.",
    lastName: "Hicks",
    title: "Senior Associate Director, MBA Career Education and Advising",
    slug: "jon-d-hicks",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brandon",
    lastName: "Hicks",
    title: "Development Coordinator, Annual Giving, SEAS",
    slug: "brandon-hicks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie",
    lastName: "Hidalgo",
    title: "Chief Technology Officer",
    slug: "natalie-hidalgo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebekka",
    lastName: "Higgins",
    title: "Grants Administrator",
    slug: "rebekka-higgins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda",
    lastName: "Higgins",
    title: "Senior Executive Assistant",
    slug: "linda-higgins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina",
    lastName: "Higgins",
    title: "Development Associate",
    slug: "christina-higgins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda Jane",
    lastName: "Higgins",
    title: "Associate Director, Financial Aid Loan Services",
    slug: "amanda-jane-higgins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matthew",
    lastName: "Higgs",
    title: "Consultant",
    slug: "matthew-higgs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lucas",
    lastName: "Higuera-Hidalgo",
    title: "Associate Director, Instructional Support",
    slug: "lucas-higuera-hidalgo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ellen Callahan",
    lastName: "Hilgendorf",
    title: "Project Coordinator",
    slug: "ellen-callahan-hilgendorf",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan",
    lastName: "Hill",
    title: "Program Manager- RFMH",
    slug: "ryan-hill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Hill",
    title: "Academic Secretary",
    slug: "michelle-hill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Hill",
    title: "Ricoh Tech",
    slug: "david-hill",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Clifford A",
    lastName: "Hill",
    title: "Prof. of Language and Education",
    slug: "clifford-a-hill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily A.",
    lastName: "Hillebrand",
    title: "Executive Assistant",
    slug: "emily-a-hillebrand",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah G.",
    lastName: "Hindman",
    title: "Assoc Director-Development",
    slug: "sarah-g-hindman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Oneil",
    lastName: "Hinds",
    title: "IT Audit Manager",
    slug: "oneil-hinds",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily M.",
    lastName: "Hines",
    title: "Events Specialist",
    slug: "emily-m-hines",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monica",
    lastName: "Hinojosa",
    title: "Administrative Assistant",
    slug: "monica-hinojosa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeremy P.",
    lastName: "Hinsdale",
    title: "Senior Web Producer",
    slug: "jeremy-p-hinsdale",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erin E.",
    lastName: "Hinz",
    title: "Communications Manager, Student Recruitment",
    slug: "erin-e-hinz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rebecca S",
    lastName: "Hirade",
    title: "Dean of Finance and Operations",
    slug: "rebecca-s-hirade",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jay",
    lastName: "Hirsch",
    title: "Dir. of Admin., ERM",
    slug: "jay-hirsch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly J",
    lastName: "Hiss",
    title: "Senior Editorial Director",
    slug: "kimberly-j-hiss",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David T",
    lastName: "Hiti",
    title: "Grants Manager",
    slug: "david-t-hiti",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Donna M",
    lastName: "Hitscherich",
    title:
      " Senior Lecturer in the Discipline of Business in the Finance and Economics Division in the Faculty of Business; Director of the Private Equity Program, Graduate School of Business",
    slug: "donna-m-hitscherich",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Waichi",
    lastName: "Ho",
    title: "Director of Finance and Administration",
    slug: "waichi-ho",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Randy",
    lastName: "Ho",
    title: "Referral Specialist III",
    slug: "randy-ho",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vanessa Hoi Wan",
    lastName: "Ho",
    title: "Assistant Director, Undergraduate Travel Safety",
    slug: "vanessa-hoi-wan-ho",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace M",
    lastName: "Ho",
    title: "Business Officer",
    slug: "grace-m-ho",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chung H.",
    lastName: "Ho",
    title: "Coordinator",
    slug: "chung-h-ho",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Catherine",
    lastName: "Hobbs",
    title: "Sales  Manager",
    slug: "catherine-hobbs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shelby Rachel",
    lastName: "Hochberg",
    title: "Manager, Research Admin",
    slug: "shelby-rachel-hochberg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Isaiah",
    lastName: "Hodges",
    title: "Administrative Coordinator",
    slug: "isaiah-hodges",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley Nichole",
    lastName: "Hoefly",
    title: "Associate Director of Financial Operations",
    slug: "ashley-nichole-hoefly",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carmen G.",
    lastName: "Hoepelman",
    title: "Sr Manager for EH&S Admin & HR",
    slug: "carmen-g-hoepelman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Karen",
    lastName: "Hoffer",
    title: "Director of Procurement",
    slug: "karen-hoffer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Timothy L",
    lastName: "Hoffman",
    title: "Director, NY State Cleantech Venture Exchange",
    slug: "timothy-l-hoffman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Troy",
    lastName: "Hoffman",
    title: "Dir, Educational Initiatives",
    slug: "troy-hoffman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dawn Michele",
    lastName: "Hoffman",
    title: "Assistant Director for Compliance",
    slug: "dawn-michele-hoffman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Christian",
    lastName: "Hoffman",
    title: "Registration Services Manager, Operations",
    slug: "christian-hoffman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Emily S",
    lastName: "Hoffmann",
    title: "Executive Assistant",
    slug: "emily-s-hoffmann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Hoffmeister",
    title: "Director of Finance and Planning",
    slug: "robert-hoffmeister",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Noreen M.",
    lastName: "Hoffmeister",
    title: "Senior Writer",
    slug: "noreen-m-hoffmeister",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kerstin",
    lastName: "Hofmann",
    title: "Director - Academic Administration/Finance",
    slug: "kerstin-hofmann",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexander James",
    lastName: "Hogan",
    title: "Director for Government Programs",
    slug: "alexander-james-hogan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey J.",
    lastName: "Hoinacki",
    title: "Asst. Dir. Rsch Fin Plan & Ana",
    slug: "jeffrey-j-hoinacki",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tina",
    lastName: "Holder",
    title: "Academic Affairs Coordinator",
    slug: "tina-holder",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kim J",
    lastName: "Holder",
    title: "Coordinator",
    slug: "kim-j-holder",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Eric H.",
    lastName: "Holder",
    title: "University Trustee",
    slug: "eric-h-holder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna S.",
    lastName: "Holder",
    title: "Recruitment Specialist",
    slug: "donna-s-holder",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dian",
    lastName: "Holder",
    title: "Exec Director,Academic Affairs",
    slug: "dian-holder",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Susan",
    lastName: "Holgate",
    title: "Senior Director of Corporate Engagement",
    slug: "susan-holgate",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sophie",
    lastName: "Holin",
    title: "Concentration Coordinator",
    slug: "sophie-holin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sophie",
    lastName: "Holland",
    title: "Associate Director, Admissions Operations",
    slug: "sophie-holland",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "M Roger",
    lastName: "Holland II",
    title: "Artist-in-Residence",
    slug: "m-roger-holland-ii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine A",
    lastName: "Holley",
    title: "Lead Staff Developer",
    slug: "christine-a-holley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Hollibaugh",
    title: "Dean of Academic Affairs",
    slug: "lisa-hollibaugh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Merona A",
    lastName: "Hollingsworth",
    title: "Asst Director, Simulation Ctr",
    slug: "merona-a-hollingsworth",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole",
    lastName: "Hollis",
    title: "Administrative Assistant",
    slug: "nicole-hollis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deirdre Lynn",
    lastName: "Hollman",
    title: "Senior Curriculum Specialist",
    slug: "deirdre-lynn-hollman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yoshiko",
    lastName: "Hollstein",
    title: "KCJS Financial Officer",
    slug: "yoshiko-hollstein",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matthew",
    lastName: "Holman",
    title: "Administrative Assistant",
    slug: "matthew-holman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brianna",
    lastName: "Holt",
    title: "Associate Director",
    slug: "brianna-holt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paul",
    lastName: "Hond",
    title: "Senior Features Editor",
    slug: "paul-hond",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eunjin",
    lastName: "Hong",
    title: "Benefits Sepcialist II",
    slug: "eunjin-hong",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Leigh R",
    lastName: "Honigman",
    title: "Benefits Coordinator",
    slug: "leigh-r-honigman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Regina H.",
    lastName: "Honorat",
    title: "Live Support Specialist",
    slug: "regina-h-honorat",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lara-May",
    lastName: "Honrado",
    title: "Special Assistant",
    slug: "lara-may-honrado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Veronica",
    lastName: "Hood",
    title: "Executive Director, Human Resources and Talent Management",
    slug: "veronica-hood",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "David",
    lastName: "Hooker",
    title: "Assistant Director, Financial Aid & Admissions",
    slug: "david-hooker",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michele Faye",
    lastName: "Hoos",
    title: "Executive Director of Communications",
    slug: "michele-faye-hoos",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Benjamin N",
    lastName: "Hoover",
    title: "Sr Manager-Translational Rsch",
    slug: "benjamin-n-hoover",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Riley",
    lastName: "Hopkins",
    title: "Associate Director, Systems and Slate",
    slug: "riley-hopkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mohammad",
    lastName: "Hoque",
    title: "Stockroom Coordinator",
    slug: "mohammad-hoque",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather T.",
    lastName: "Horgan",
    title: "Sr Project  Officer",
    slug: "heather-t-horgan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Therese",
    lastName: "Horn",
    title: "Associate Director Grants Administration",
    slug: "therese-horn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ava",
    lastName: "Hornblass",
    title: "Research Support Assistant II",
    slug: "ava-hornblass",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexander K.",
    lastName: "Horne",
    title: "Development Assistant",
    slug: "alexander-k-horne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Naomi",
    lastName: "Hornedo",
    title: "Senior Executive Assistant to the Director",
    slug: "naomi-hornedo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicolas Dagoberto",
    lastName: "Hornedo",
    title: "Senior Associate Director of Social Media Engagement",
    slug: "nicolas-dagoberto-hornedo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andrew",
    lastName: "Horner",
    title: "Assistant Director, Events Management",
    slug: "andrew-horner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark A.",
    lastName: "Horney",
    title: "Assistant Dean",
    slug: "mark-a-horney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle Jane",
    lastName: "Horowitz",
    title: "Research Project Manager",
    slug: "michelle-jane-horowitz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hugh A.",
    lastName: "Horowitz",
    title: "AVP, Procurement Services",
    slug: "hugh-a-horowitz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rachel A",
    lastName: "Horton",
    title: "Director of Strategic Projects, Curriculum and Programs",
    slug: "rachel-a-horton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sam",
    lastName: "Horton III",
    title: "Porter",
    slug: "sam-horton-iii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rakhi",
    lastName: "Hossain",
    title: "Assistant Director of Budget Planning and Finance",
    slug: "rakhi-hossain",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Weilu",
    lastName: "Hou",
    title: "Human Resources Coordinator",
    slug: "weilu-hou",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ivory",
    lastName: "Houck",
    title: "Administrative Coordinator II",
    slug: "ivory-houck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph C",
    lastName: "Hough",
    title: "President Emeritus",
    slug: "joseph-c-hough",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shewanna M.",
    lastName: "House",
    title: "Senior Student Services Rep",
    slug: "shewanna-m-house",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Terry Lynn",
    lastName: "Houston",
    title: "Coordinator",
    slug: "terry-lynn-houston",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chantel M",
    lastName: "Hover",
    title: "PER Program Manager",
    slug: "chantel-m-hover",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah C",
    lastName: "Howard",
    title: "Operations Manager, Senior Vice Dean's Office",
    slug: "sarah-c-howard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meredith",
    lastName: "Howard",
    title: "Promotions Director",
    slug: "meredith-howard",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kevin G.",
    lastName: "Howard",
    title: "Director (Operations)",
    slug: "kevin-g-howard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth S",
    lastName: "Howe",
    title: "Administrative Assistant",
    slug: "elizabeth-s-howe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nora Ray",
    lastName: "Howell",
    title: "Community Educator",
    slug: "nora-ray-howell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle L",
    lastName: "Howell",
    title: "Senior Assistant Director of Financial Aid",
    slug: "michelle-l-howell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Katherine Maria",
    lastName: "Howell",
    title: "Asst Director-Finance",
    slug: "katherine-maria-howell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Frances M",
    lastName: "Howell",
    title: "Research Project Coordinator",
    slug: "frances-m-howell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kiana Chanel",
    lastName: "Howerton",
    title: "Program Secretary",
    slug: "kiana-chanel-howerton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer Ruth Ruth",
    lastName: "Hoyden",
    title: "Macy Gallery Coordinator",
    slug: "jennifer-ruth-ruth-hoyden",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew",
    lastName: "Hrycyk",
    title: "Executive Director, Analytics",
    slug: "andrew-hrycyk",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Hsieh",
    title: "Associate Director of Admissions Operations and Technology",
    slug: "jennifer-hsieh",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Shu-Yi",
    lastName: "Hsu",
    title: "Senior Instructural Designer",
    slug: "shu-yi-hsu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leina",
    lastName: "Hsu",
    title: "Development Assistant",
    slug: "leina-hsu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hua Lin",
    lastName: "Hsu",
    title: "Administrative Assistant",
    slug: "hua-lin-hsu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allison",
    lastName: "Hsu",
    title: "Project Officer",
    slug: "allison-hsu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert Yin",
    lastName: "Hsueh",
    title: "Recess and Enrichment Facilitator in The School",
    slug: "robert-yin-hsueh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bianca",
    lastName: "Hsueh",
    title: "Senior Grants Manager",
    slug: "bianca-hsueh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jalie",
    lastName: "Hu",
    title: "Dir, Budget&Financial Analysis",
    slug: "jalie-hu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy",
    lastName: "Hu",
    title: "Sr. Associate, Operations",
    slug: "amy-hu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin",
    lastName: "Hua",
    title: "Service Desk Tech (Tier II)",
    slug: "justin-hua",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jian",
    lastName: "Hua",
    title: "Senior Application Systems Developer",
    slug: "jian-hua",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "James",
    lastName: "Hua",
    title: "Director of System Services and Cloud Based Projects",
    slug: "james-hua",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yue",
    lastName: "Huang",
    title: "Senior Finance Manager",
    slug: "yue-huang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicky",
    lastName: "Huang",
    title: "Financial Operations Manager",
    slug: "nicky-huang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Libing",
    lastName: "Huang",
    title: "Sr Manager, Budget & Analytics",
    slug: "libing-huang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacqueline Megan",
    lastName: "Huang",
    title: "Project Coordinator",
    slug: "jacqueline-megan-huang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward",
    lastName: "Huang",
    title: "Sr. Dir, Financial Info Sys",
    slug: "edward-huang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Darvin T",
    lastName: "Huang",
    title: "Contractor-RFMH",
    slug: "darvin-t-huang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chien Jung",
    lastName: "Huang",
    title: "Business Officer",
    slug: "chien-jung-huang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrea C",
    lastName: "Hubbard",
    title: "Assoc Director, Veterinary Ops",
    slug: "andrea-c-hubbard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren N.",
    lastName: "Hudak",
    title: "Director of Institutional Reporting and Analytics",
    slug: "lauren-n-hudak",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Steven J.",
    lastName: "Hudock",
    title: "Associate Director of Events",
    slug: "steven-j-hudock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joanne",
    lastName: "Hudson",
    title: "Director, Student Financial Accounting and Services",
    slug: "joanne-hudson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Florence D",
    lastName: "Hudson",
    title: "Executive Director of the Northeast Big Data Innovation Hub",
    slug: "florence-d-hudson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "James",
    lastName: "Huerta",
    title: "Associate Director of Admissions",
    slug: "james-huerta",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "JoAnn",
    lastName: "Huether",
    title: "Deputy Director for Gift Planning Operations",
    slug: "joann-huether",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nichole",
    lastName: "Huff",
    title: "Associate Director, Internal Communications",
    slug: "nichole-huff",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melanie Greer",
    lastName: "Huff",
    title: "Senior Associate Dean of Student Life",
    slug: "melanie-greer-huff",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "LaKeysia",
    lastName: "Huger",
    title: "Administrator",
    slug: "lakeysia-huger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David Andre",
    lastName: "Huggins",
    title: "Major Gifts Officer",
    slug: "david-andre-huggins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Herbert",
    lastName: "Hugh",
    title: "Assistant Dean of Student Support",
    slug: "herbert-hugh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dwayne Stephen",
    lastName: "Hugh",
    title: "Assistant Director",
    slug: "dwayne-stephen-hugh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Milo",
    lastName: "Hughes",
    title:
      " Lab Administrator in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "milo-hughes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin",
    lastName: "Hughes",
    title: "Assistant Director, Community Impact",
    slug: "caitlin-hughes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eileen P",
    lastName: "Huhn",
    title: "Program Manager",
    slug: "eileen-p-huhn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cindy",
    lastName: "Huitzil",
    title: "Interim Coder: Baby's First Years",
    slug: "cindy-huitzil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grazyna Ewa",
    lastName: "Hulacka",
    title: "Senior Grants and Contracts Manager",
    slug: "grazyna-ewa-hulacka",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ismael Ibrahim",
    lastName: "Hulchafo",
    title: "Data Manager",
    slug: "ismael-ibrahim-hulchafo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ella C",
    lastName: "Hungeling",
    title: "Alumni Programs Coordinator",
    slug: "ella-c-hungeling",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Matthew",
    lastName: "Hunt",
    title: "User Support and Training Coordinator",
    slug: "matthew-hunt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "London S",
    lastName: "Hunt",
    title: "Simulation Coordinator",
    slug: "london-s-hunt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine T",
    lastName: "Hunt",
    title: "Associate Director for Strategic Initiatives",
    slug: "christine-t-hunt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather J",
    lastName: "Hunte",
    title: "Major Gift Officer, University Development",
    slug: "heather-j-hunte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert",
    lastName: "Hunter",
    title: "Chief Financial Officer",
    slug: "robert-hunter",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Colista Marcia",
    lastName: "Hunter",
    title: "Senior Student Services Representative",
    slug: "colista-marcia-hunter",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Meredith",
    lastName: "Hunter-Mason",
    title: "Projects Assistant",
    slug: "meredith-hunter-mason",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wan Wendy",
    lastName: "Huo",
    title: "Director, Global Treasury Operations and Liquidity Management",
    slug: "wan-wendy-huo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sonia",
    lastName: "Huq",
    title: "Communications Associate",
    slug: "sonia-huq",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David",
    lastName: "Hurst",
    title: "Administrator",
    slug: "david-hurst",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hani",
    lastName: "Hussein",
    title: "Technical Support Specialist",
    slug: "hani-hussein",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erin Z.",
    lastName: "Hussein",
    title: "Director of Alumni Relations and Development",
    slug: "erin-z-hussein",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vanessa",
    lastName: "Hutchinson",
    title: "Staff",
    slug: "vanessa-hutchinson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jane M.",
    lastName: "Hutchinson",
    title: "Customer Service Representative",
    slug: "jane-m-hutchinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandon",
    lastName: "Hutchinson",
    title: "University Affiliate - STEAM",
    slug: "brandon-hutchinson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ji Young",
    lastName: "Hwang",
    title: "Senior Associate Director, MS Career Management",
    slug: "ji-young-hwang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chelsey",
    lastName: "Hyatt",
    title: "Admissions Counselor",
    slug: "chelsey-hyatt",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "John M.",
    lastName: "Hyde",
    title: "Asst Director-Car Dev Alumni",
    slug: "john-m-hyde",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hannah",
    lastName: "Hyland",
    title: "Lab Manager",
    slug: "hannah-hyland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elena",
    lastName: "Iaffa-Coln",
    title: "Advertising Manager",
    slug: "elena-iaffa-coln",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yasmin M.",
    lastName: "Ibrahim",
    title: "External Relations Coordinator",
    slug: "yasmin-m-ibrahim",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Idrija",
    lastName: "Ibrahimagic",
    title: "Director, Post-Award Finance",
    slug: "idrija-ibrahimagic",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sidney",
    lastName: "Idumonyi",
    title: "Production Coordinator",
    slug: "sidney-idumonyi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Veronica V.",
    lastName: "Ifill",
    title: "Assistant ICM Facility Manager",
    slug: "veronica-v-ifill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ebi Morris Laurene",
    lastName: "Igbodo",
    title: "Junior Instructional Designer",
    slug: "ebi-morris-laurene-igbodo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karina",
    lastName: "Ikeda",
    title: "Officer-Career Placement",
    slug: "karina-ikeda",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Farida",
    lastName: "Ilboudo",
    title: "Assistant Director, Prospect Management",
    slug: "farida-ilboudo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Alexandre P.",
    lastName: "Ilic",
    title: "Director of Film Program Events",
    slug: "alexandre-p-ilic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rilwan",
    lastName: "Ilumoka",
    title: "Associate Director, Student Conduct",
    slug: "rilwan-ilumoka",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Yeo Jean",
    lastName: "Im",
    title: "Assistant Director of Exhibitions and Public Programs",
    slug: "yeo-jean-im",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Im",
    title: "Manager-Audience Srvs",
    slug: "daniel-im",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Afrim",
    lastName: "Imami",
    title: "System Administration",
    slug: "afrim-imami",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sanjana Naidu",
    lastName: "Inala",
    title: "Research Manager",
    slug: "sanjana-naidu-inala",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Natasha",
    lastName: "Infante",
    title: "Assistant Manager - Guest Services",
    slug: "natasha-infante",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miguel A.",
    lastName: "Ingles",
    title: "Office Assistant VI",
    slug: "miguel-a-ingles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Larisha",
    lastName: "Ingles",
    title: "Administrative Coordinator",
    slug: "larisha-ingles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nathanael L",
    lastName: "Inglis",
    title: "Associate Director for Domestic Programs and Partnerships",
    slug: "nathanael-l-inglis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shannon",
    lastName: "Ingraham",
    title: "Administrative Director",
    slug: "shannon-ingraham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noble",
    lastName: "Ingram",
    title: "Audience Engagement Editor",
    slug: "noble-ingram",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emmett",
    lastName: "Ingram",
    title: "Assistant Director of Admissions",
    slug: "emmett-ingram",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Deirdre",
    lastName: "Ingram",
    title: "Senior Program Manager",
    slug: "deirdre-ingram",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tonya V.",
    lastName: "Insani",
    title: "Director, Human Resources",
    slug: "tonya-v-insani",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Catherine Shanley",
    lastName: "Insel",
    title: "Shohamy Lab Alum - 2nd courtesy extension",
    slug: "catherine-shanley-insel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shanta",
    lastName: "Inshiqaq",
    title: "Senior Director, Custom Programs",
    slug: "shanta-inshiqaq",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael Bryan",
    lastName: "Introini",
    title: "Developer, Systems Administrator",
    slug: "michael-bryan-introini",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Oliver",
    lastName: "Inzerillo",
    title: "Technical Support Assistant Level II",
    slug: "oliver-inzerillo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chris",
    lastName: "Ioannides",
    title: "Lead, Database Administrator",
    slug: "chris-ioannides",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Monica",
    lastName: "Ionescu-Albu",
    title: "Division Administrator",
    slug: "monica-ionescu-albu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cindy",
    lastName: "Ip",
    title:
      " Assistant Director, Student Affairs, Sustainability Management & Science",
    slug: "cindy-ip",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rifat",
    lastName: "Iqbal",
    title: "Research Project Manager",
    slug: "rifat-iqbal",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Krysal-lou",
    lastName: "Irani",
    title: "Officer Manager",
    slug: "krysal-lou-irani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly Theresa",
    lastName: "Irizarri-Douglas",
    title: "Associate Director of Advancement Services",
    slug: "kimberly-theresa-irizarri-douglas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristine",
    lastName: "Irizarry",
    title: "Associate Director of Human Resources and Finance",
    slug: "kristine-irizarry",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Camilo",
    lastName: "Irizarry",
    title: "Senior Instructional Designer",
    slug: "camilo-irizarry",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jesse",
    lastName: "Irmler",
    title: "Director, Talent Acquisition & Office Services",
    slug: "jesse-irmler",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Freddricka L",
    lastName: "Irvin",
    title: "Administrative Assistant",
    slug: "freddricka-l-irvin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda L.",
    lastName: "Irvin",
    title: "Executive Director, Center for Teaching and Learning",
    slug: "amanda-l-irvin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Edwin",
    lastName: "Isaac",
    title: "Director, Financial Aid and Admissions",
    slug: "edwin-isaac",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Daniela",
    lastName: "Isakov",
    title: "Senior Human Resources Generalist",
    slug: "daniela-isakov",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Liam",
    lastName: "Itgen",
    title: "Leadership Gift Officer",
    slug: "liam-itgen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jason S.",
    lastName: "Itzkowitz",
    title: "Director of Grants and Finance Services",
    slug: "jason-s-itzkowitz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Olga D.",
    lastName: "Ivakh",
    title: "Executive Assistant",
    slug: "olga-d-ivakh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yulia",
    lastName: "Ivanova",
    title: "Staff",
    slug: "yulia-ivanova",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Beverly",
    lastName: "Ivens",
    title: "Senior Executive Director, Finance and Strategic Planning",
    slug: "beverly-ivens",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "E Nkonye",
    lastName: "Iwerebon",
    title: "Associate Dean of Admissions",
    slug: "e-nkonye-iwerebon",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christina R.",
    lastName: "Izzo",
    title: "Administrative Assistant",
    slug: "christina-r-izzo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Myron B",
    lastName: "Jabido",
    title: "Associate Director",
    slug: "myron-b-jabido",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kenneth",
    lastName: "Jackson",
    title: "Oiler",
    slug: "kenneth-jackson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julian",
    lastName: "Jackson",
    title: "Senior Staff Technical Support Specialist",
    slug: "julian-jackson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gabriela Lynda",
    lastName: "Jackson",
    title: "Project Coordinator II",
    slug: "gabriela-lynda-jackson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diamond",
    lastName: "Jackson",
    title: "Project Coordinator, ODCI",
    slug: "diamond-jackson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Debra A.",
    lastName: "Jackson",
    title: "Executive Assistant, Academic Affairs",
    slug: "debra-a-jackson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Agnetha",
    lastName: "Jacob-Chen",
    title: "Associate General Counsel",
    slug: "agnetha-jacob-chen",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Zachary",
    lastName: "Jacobs",
    title: "SYEP",
    slug: "zachary-jacobs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samuel S.",
    lastName: "Jacobs",
    title: "Third Mate",
    slug: "samuel-s-jacobs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Halle",
    lastName: "Jacobs",
    title: "Graduate Assistant (Hourly)",
    slug: "halle-jacobs",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sean",
    lastName: "Jacobsen",
    title: "IT Manager",
    slug: "sean-jacobsen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle",
    lastName: "Jacoby",
    title: "Administrative Assistant",
    slug: "michelle-jacoby",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samuel",
    lastName: "Jaffe Goldstein",
    title: "Client Press Coordinator",
    slug: "samuel-jaffe-goldstein",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Fahmina",
    lastName: "Jafri",
    title: "Chief Financial Officer",
    slug: "fahmina-jafri",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jasmine",
    lastName: "Jaghab",
    title: "Coordinator",
    slug: "jasmine-jaghab",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tanvi",
    lastName: "Jain",
    title: "Senior Program Officer",
    slug: "tanvi-jain",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deepika",
    lastName: "Jain",
    title: "Sr. Business Objects Administrator",
    slug: "deepika-jain",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bharti",
    lastName: "Jain",
    title: "Sr. Director, Service Administration and Support",
    slug: "bharti-jain",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anil A.",
    lastName: "Jaisinghani",
    title: "Director (Operations)",
    slug: "anil-a-jaisinghani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marian J.",
    lastName: "Jakubiak",
    title: "Dir,Admin&Strat Initiatives",
    slug: "marian-j-jakubiak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maisem",
    lastName: "Jaloudi",
    title: "Assistant Director, Executive Operations",
    slug: "maisem-jaloudi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seandell N.",
    lastName: "James",
    title: "Director, Loan Repayment Assistance Program",
    slug: "seandell-n-james",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rahel B",
    lastName: "James",
    title: "Finance Manager",
    slug: "rahel-b-james",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Raven A.",
    lastName: "James",
    title: "Assoc Director - Financial Ops",
    slug: "raven-a-james",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lenwood Earl",
    lastName: "James",
    title: "Manager -  Guest Services",
    slug: "lenwood-earl-james",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica L.",
    lastName: "James",
    title: "Director of Financial Aid Systems and Data",
    slug: "erica-l-james",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Darryl Lamar",
    lastName: "James",
    title: "Porter",
    slug: "darryl-lamar-james",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Desiree Allison",
    lastName: "James",
    title: "Dept Admin",
    slug: "desiree-allison-james",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meahgan",
    lastName: "Jameyson",
    title: "Associate Director of Graduate Admissions",
    slug: "meahgan-jameyson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Rubaa",
    lastName: "Jamil",
    title: "Senior Designer",
    slug: "rubaa-jamil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arish",
    lastName: "Jamil",
    title: "Project Manager",
    slug: "arish-jamil",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rajvi",
    lastName: "Jani",
    title: "Consultant",
    slug: "rajvi-jani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie L",
    lastName: "Jankowski",
    title: "Associate Director of Communications",
    slug: "natalie-l-jankowski",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter Frederick",
    lastName: "Janus",
    title: "Graduate Admissions Coordinator",
    slug: "peter-frederick-janus",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Janine",
    lastName: "Jaquet",
    title: "Senior Principal Gifts Officer",
    slug: "janine-jaquet",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Idarmis C",
    lastName: "Jaquez",
    title: "Generalist, HR/FA",
    slug: "idarmis-c-jaquez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nadia",
    lastName: "Jaquez-Fristensky",
    title: "Associate Director for Development",
    slug: "nadia-jaquez-fristensky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joel",
    lastName: "Jares",
    title: "Production Assistant",
    slug: "joel-jares",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sami Kamal",
    lastName: "Jarrah",
    title:
      " Vice Dean, Finance and Administration; Executive Director for Public Partnerships",
    slug: "sami-kamal-jarrah",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Xaelah Dionne",
    lastName: "Jarrett",
    title:
      " Associate Director of Multicultural Affairs/Program Director for Students of Color at Columbia",
    slug: "xaelah-dionne-jarrett",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Keith",
    lastName: "Jarrett",
    title: "Financial Aid Officer",
    slug: "keith-jarrett",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Thandiwe L.",
    lastName: "Jarrett Abdulali",
    title: "Director, College Alumni Relations",
    slug: "thandiwe-l-jarrett-abdulali",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Austin",
    lastName: "Jasienski",
    title: "Assistant Director, Pre-College Programs",
    slug: "austin-jasienski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kayla-Rose Letizia",
    lastName: "Jason",
    title: "Service Provider",
    slug: "kayla-rose-letizia-jason",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Claire E.",
    lastName: "Jasper",
    title: "Administrator",
    slug: "claire-e-jasper",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew P",
    lastName: "Jass",
    title: "Director, Financial Reporting",
    slug: "andrew-p-jass",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Raquel",
    lastName: "Javier",
    title: "Administrative Coordinator",
    slug: "raquel-javier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Moises",
    lastName: "Javier",
    title: "Procurement Associate",
    slug: "moises-javier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luis M",
    lastName: "Javier",
    title: "Technology Support Specialist",
    slug: "luis-m-javier",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Greeshma",
    lastName: "Jayanth",
    title: "Assistant Software Developer",
    slug: "greeshma-jayanth",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ramona G.",
    lastName: "Jayasena",
    title: "Quality Research Manager",
    slug: "ramona-g-jayasena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Phaimy",
    lastName: "Jean",
    title: "Grants and Contracts Manager",
    slug: "phaimy-jean",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julian",
    lastName: "Jean",
    title: "Ricoh Tech",
    slug: "julian-jean",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Samantha",
    lastName: "Jean-Baptiste",
    title: "Associate Director",
    slug: "samantha-jean-baptiste",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angelie N.",
    lastName: "Jean-Brice",
    title: "Special Projects Manager",
    slug: "angelie-n-jean-brice",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sony",
    lastName: "Jean-Michel Thornton",
    title: "Senior HR Business Partner",
    slug: "sony-jean-michel-thornton",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jenissia M.",
    lastName: "Jeanty",
    title: "Coordinator-Center SIG",
    slug: "jenissia-m-jeanty",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Jefferson",
    title: "HR Manager",
    slug: "nicole-jefferson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jordan Maverick",
    lastName: "Jeffries",
    title: "Coordinator",
    slug: "jordan-maverick-jeffries",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gerald C",
    lastName: "Jeglinski",
    title: "Senior Director of Budget and Financial Reporting.",
    slug: "gerald-c-jeglinski",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patricia Anne",
    lastName: "Jendraszek",
    title: "Associate General Counsel",
    slug: "patricia-anne-jendraszek",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Shayleah Jenkins",
    lastName: "Jenkins",
    title: "Communications Assistant",
    slug: "shayleah-jenkins-jenkins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Robert J.",
    lastName: "Jenkins",
    title:
      " Director of Curriculum and Instruction for Columbia University Cent for Veteran Transition and Integration",
    slug: "robert-j-jenkins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa M.",
    lastName: "Jenkins",
    title: "Financial Assistant",
    slug: "lisa-m-jenkins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kate A.",
    lastName: "Jenkins",
    title: "Senior Associate Director, Financial Aid",
    slug: "kate-a-jenkins",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jacqueline Andrea",
    lastName: "Jenkins",
    title: "Associate Director of Finance and HR Operations",
    slug: "jacqueline-andrea-jenkins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julie",
    lastName: "Jenkins",
    title: "Associate Director, Business Analysis & Project Management",
    slug: "julie-jenkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ike",
    lastName: "Jenkins",
    title: "Executive Director, Risk Management",
    slug: "ike-jenkins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Fabian A",
    lastName: "Jenkins",
    title: "ET Bus Int&Analytics Developer",
    slug: "fabian-a-jenkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Denee",
    lastName: "Jenkins",
    title: "Senior Associate Director, Operations",
    slug: "denee-jenkins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olena M.",
    lastName: "Jennings",
    title: "Administrative Assistant",
    slug: "olena-m-jennings",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jack P",
    lastName: "Jennings",
    title: "Senior Video Editor and Cinematographer",
    slug: "jack-p-jennings",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Todd",
    lastName: "Jensvold",
    title: "Science Officer",
    slug: "todd-jensvold",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Minhyeok",
    lastName: "Jeong",
    title: "Visiting Studetn Intern",
    slug: "minhyeok-jeong",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Seung Hoon",
    lastName: "Jeong",
    title:
      " HHMI Tech in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "seung-hoon-jeong",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patricka",
    lastName: "Jeremie",
    title: "Manager, AP Office Operations",
    slug: "patricka-jeremie",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leticia V.",
    lastName: "Jerman",
    title: "Administrative Assistant",
    slug: "leticia-v-jerman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Jerome",
    title: "Director, Design and Production",
    slug: "jennifer-jerome",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Krystina Michelle",
    lastName: "Jeron",
    title: "Mgr, Professional Education",
    slug: "krystina-michelle-jeron",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Salowa Jashim",
    lastName: "Jessica",
    title: "Corporate Partners Coordinator",
    slug: "salowa-jashim-jessica",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah Huntington",
    lastName: "Jessup",
    title: "Associate Director for Partnerships and Outreach",
    slug: "sarah-huntington-jessup",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Charles Peterson",
    lastName: "Jester",
    title: "Administrative Assistant",
    slug: "charles-peterson-jester",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jungsoo",
    lastName: "Ji",
    title: "Asst Manager,Finance/Res Admin",
    slug: "jungsoo-ji",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Renny",
    lastName: "Jiang",
    title: "Pro Bono and Summer Programs Officer",
    slug: "renny-jiang",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Quan",
    lastName: "Jiang",
    title: "Associate Director, Admissions",
    slug: "quan-jiang",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Chen",
    lastName: "Jiang",
    title: "Assistant Director of International Graduate Student Services",
    slug: "chen-jiang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tiffany",
    lastName: "Jimenez",
    title: "Secretary B",
    slug: "tiffany-jimenez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laila",
    lastName: "Jimenez",
    title: "Ophthalmic Aide",
    slug: "laila-jimenez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James R",
    lastName: "Jimenez",
    title: "Lead Person Painter",
    slug: "james-r-jimenez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica Liliana",
    lastName: "Jimenez",
    title: "Executive Director of Student Services",
    slug: "jessica-liliana-jimenez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jean",
    lastName: "Jimenez",
    title: "Data Manager",
    slug: "jean-jimenez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Jimenez",
    title: "Director of Administration",
    slug: "jessica-jimenez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeser",
    lastName: "Jimenez",
    title: "Business Manager in the Department of Chemistry",
    slug: "jeser-jimenez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jasmine A",
    lastName: "Jimenez",
    title: "Secretary B",
    slug: "jasmine-a-jimenez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Genesis",
    lastName: "Jimenez",
    title: "Front Desk Representative",
    slug: "genesis-jimenez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica",
    lastName: "Jimenez",
    title: "Senior Student Service Rep",
    slug: "erica-jimenez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Beth Mixel",
    lastName: "Jimenez",
    title: "Assistant Manager - Housing",
    slug: "beth-mixel-jimenez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ashley M",
    lastName: "Jimenez",
    title: "Senior Financial Coordinator",
    slug: "ashley-m-jimenez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Annkitza M.",
    lastName: "Jimenez",
    title: "Grants Finance Coordinator I",
    slug: "annkitza-m-jimenez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Zhenia Y.",
    lastName: "Jimenez Munoz",
    title: "Accountant, Financial Report & Operations",
    slug: "zhenia-y-jimenez-munoz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Talia",
    lastName: "Jimenez Ramirez",
    title: "Sr. Projects Officer",
    slug: "talia-jimenez-ramirez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ana",
    lastName: "Jimenez-Bautista",
    title: "Ex Dir, Comm Hlth Eqty Collab",
    slug: "ana-jimenez-bautista",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yuis J",
    lastName: "Jimenez-Cortez",
    title: "Manager, IHC",
    slug: "yuis-j-jimenez-cortez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yiqun",
    lastName: "Jin",
    title: "Statistical Anlst/Data Manager",
    slug: "yiqun-jin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hui",
    lastName: "Jin",
    title: "Sr Applications System Developer",
    slug: "hui-jin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brian M",
    lastName: "Jines",
    title:
      " Director of Intramurals and Club Sport, Assistant Director of Physical Education",
    slug: "brian-m-jines",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Adela Elena",
    lastName: "Joanta-Gomez",
    title: "Sr Research Project Specialist",
    slug: "adela-elena-joanta-gomez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark deVille",
    lastName: "Jobson",
    title: "Administrative Assistant",
    slug: "mark-deville-jobson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jada Kanika",
    lastName: "John-Ali",
    title: "Service Provider",
    slug: "jada-kanika-john-ali",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Wendy R",
    lastName: "Johnson",
    title: "Director - Contracts, Services and Technology",
    slug: "wendy-r-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vonzelle",
    lastName: "Johnson",
    title: "Major Gifts Officer, Columbia College and Arts & Sciences",
    slug: "vonzelle-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tariq",
    lastName: "Johnson",
    title: "Tech Customer Support Specialist",
    slug: "tariq-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shaina Raquel",
    lastName: "Johnson",
    title: "Coordinator",
    slug: "shaina-raquel-johnson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sven",
    lastName: "Johnson",
    title: "Lead Applications Systems Developer",
    slug: "sven-johnson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rory C.",
    lastName: "Johnson",
    title: "Associate Director of Experiential Education",
    slug: "rory-c-johnson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pauline",
    lastName: "Johnson",
    title: "Audit Manager",
    slug: "pauline-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Niquette S.",
    lastName: "Johnson",
    title: "Officer, Admissions and Financial Aid",
    slug: "niquette-s-johnson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nancy K",
    lastName: "Johnson",
    title: "Vice President, Budget and Financial Planning",
    slug: "nancy-k-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maya S",
    lastName: "Johnson",
    title: "Senior Admissions Officer",
    slug: "maya-s-johnson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Leroy",
    lastName: "Johnson",
    title: "Staff Accountant",
    slug: "leroy-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lorianna H",
    lastName: "Johnson",
    title: "Program Administrator, Multiple Programs",
    slug: "lorianna-h-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda",
    lastName: "Johnson",
    title: "Administrative Assistant",
    slug: "linda-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kim",
    lastName: "Johnson",
    title: "Administrative Aide",
    slug: "kim-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathleen A.",
    lastName: "Johnson",
    title: "Director, Communications and Administrative Management",
    slug: "kathleen-a-johnson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer M.",
    lastName: "Johnson",
    title:
      " Senior Associate Director, Instructional Design and Special Projects",
    slug: "jennifer-m-johnson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Irene",
    lastName: "Johnson",
    title: "Financial Coordinator",
    slug: "irene-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hawley M.",
    lastName: "Johnson",
    title: "Associate Director, Columbia Global Freedom of Expression",
    slug: "hawley-m-johnson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Edward T.",
    lastName: "Johnson",
    title: "Director, Procurement and Accounts Payable",
    slug: "edward-t-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily Sarah",
    lastName: "Johnson",
    title: "Assistant Director of Annual Giving, SEAS",
    slug: "emily-sarah-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evan",
    lastName: "Johnson",
    title: "Executive Director of Major Gifts, Arts & Sciences",
    slug: "evan-johnson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emma DeGray",
    lastName: "Johnson",
    title: "Senior Assistant Dean of Student Life and Well-Being",
    slug: "emma-degray-johnson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Chavon Michele",
    lastName: "Johnson",
    title: "Coordinator, Communications and Research",
    slug: "chavon-michele-johnson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christine A",
    lastName: "Johnson",
    title: "Senior Contracts Officer",
    slug: "christine-a-johnson",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Christina Rose",
    lastName: "Johnson",
    title: "Subrights and Permissions Manager/Special Sales Coordinator",
    slug: "christina-rose-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew",
    lastName: "Johnson",
    title: "Senior Assistant Dean",
    slug: "andrew-johnson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Akil M.",
    lastName: "Johnson",
    title: "Sr Director, Operations",
    slug: "akil-m-johnson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert J.",
    lastName: "Johnston",
    title: "Senior Director of Research",
    slug: "robert-j-johnston",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kathleen",
    lastName: "Johnston",
    title: "Program Director, Tow Center",
    slug: "kathleen-johnston",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Spencer Paul",
    lastName: "Jones",
    title: "Specialist -Digital Content",
    slug: "spencer-paul-jones",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sonya L.",
    lastName: "Jones",
    title: "IT Organizational Change Management Lead",
    slug: "sonya-l-jones",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sophia",
    lastName: "Jones",
    title: "Administrative Coordinator",
    slug: "sophia-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark",
    lastName: "Jones",
    title: "Associate",
    slug: "mark-jones",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lakeisha C.",
    lastName: "Jones",
    title: "Strategic Planning Project Mgr",
    slug: "lakeisha-c-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lindsey Frances",
    lastName: "Jones",
    title: "Director of Web and UX",
    slug: "lindsey-frances-jones",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jasmin",
    lastName: "Jones",
    title: "Application Support Specialist",
    slug: "jasmin-jones",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer Coreen",
    lastName: "Jones",
    title: "Staff Attorney",
    slug: "jennifer-coreen-jones",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jennifer",
    lastName: "Jones",
    title: "Executive Assistant",
    slug: "jennifer-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gregory Scott",
    lastName: "Jones",
    title: "Director - Development",
    slug: "gregory-scott-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gregory Adam",
    lastName: "Jones",
    title: "Associate Director of Admissions Operations",
    slug: "gregory-adam-jones",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Elizabeth E",
    lastName: "Jones",
    title: "Director, Community Employment Programs and Services",
    slug: "elizabeth-e-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ebony",
    lastName: "Jones",
    title: "Coordinator",
    slug: "ebony-jones",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Devin J.",
    lastName: "Jones",
    title: "Business Development Manager",
    slug: "devin-j-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlyn E",
    lastName: "Jones",
    title: "Administrative Assistant",
    slug: "caitlyn-e-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin B.",
    lastName: "Jones",
    title: "Technical Support Specialist",
    slug: "caitlin-b-jones",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brianna Janae",
    lastName: "Jones",
    title: "Director of College Events",
    slug: "brianna-janae-jones",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrew S.",
    lastName: "Jones",
    title: "Associate Secretary of the University",
    slug: "andrew-s-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Jones",
    title: "Senior Associate Director, Administrative Management",
    slug: "amy-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony L",
    lastName: "Jones",
    title: "Lead Benefits Specialist",
    slug: "anthony-l-jones",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Aria",
    lastName: "Jones",
    title: "Executive Assistant, Principal Gifts",
    slug: "aria-jones",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Errold D.",
    lastName: "Jones Jr",
    title: "Associate Director, Diversity, Equity, Inclusion and Accessibility",
    slug: "errold-d-jones-jr",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Eun Y.",
    lastName: "Joo",
    title: "Senior Director, Finance & Budget",
    slug: "eun-y-joo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Benjamin",
    lastName: "Jooste",
    title: "Consultant",
    slug: "benjamin-jooste",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ammaris D.",
    lastName: "Jordan",
    title: "Administrative Coordinator",
    slug: "ammaris-d-jordan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alyssa",
    lastName: "Jordan",
    title: "Editorial Assistant",
    slug: "alyssa-jordan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andrea Maria",
    lastName: "Jordan",
    title: "Coordinator-Finance & Administration",
    slug: "andrea-maria-jordan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kathryn",
    lastName: "Jorge",
    title: "Production Editor",
    slug: "kathryn-jorge",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Janiris",
    lastName: "Jorge",
    title: "Dir,Projects&Strat Initiatives",
    slug: "janiris-jorge",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan A",
    lastName: "Joseph",
    title: "Admissions Officer",
    slug: "ryan-a-joseph",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Pearlyn",
    lastName: "Joseph",
    title: "Accounts Receivable Follow-Up and Claims Edits Specialist II",
    slug: "pearlyn-joseph",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Molly-Ann",
    lastName: "Joseph-Wade",
    title: "Administrative Assistant",
    slug: "molly-ann-joseph-wade",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abhishek",
    lastName: "Joshi",
    title: "Executive Director of Infrastructure, Technology and Support",
    slug: "abhishek-joshi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Donovan",
    lastName: "Joshua",
    title: "Information Service Intern",
    slug: "donovan-joshua",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Donald",
    lastName: "Joshua",
    title: "Chief Information Officer",
    slug: "donald-joshua",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Beverley",
    lastName: "Josiah-Walker",
    title: "Associate Director, Finance Operations",
    slug: "beverley-josiah-walker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samira",
    lastName: "Joussef Pina",
    title: "Biological Safety Officer II",
    slug: "samira-joussef-pina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia",
    lastName: "Joy",
    title: "Senior Digital Editor",
    slug: "julia-joy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "James",
    lastName: "Joy",
    title: "Assistant Director-Operations and Customer Service",
    slug: "james-joy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hana",
    lastName: "Joy",
    title: "Associate Director, Events & Publishing (Tow Center)",
    slug: "hana-joy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jillian L",
    lastName: "Joyce",
    title: "Collaborator",
    slug: "jillian-l-joyce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony",
    lastName: "Joyles",
    title: "Senior Service Specialist",
    slug: "anthony-joyles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jared",
    lastName: "Jozsa",
    title: "Consultant",
    slug: "jared-jozsa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Haiying",
    lastName: "Ju",
    title: "Coordinator of Academic Operations",
    slug: "haiying-ju",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Fay J.",
    lastName: "Ju",
    title: "Associate Dean",
    slug: "fay-j-ju",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kassandra",
    lastName: "Juarez",
    title: "Academic Secretary - Humanities",
    slug: "kassandra-juarez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Jubar",
    title: "Senior Acquisitions Editor",
    slug: "sarah-jubar",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah M",
    lastName: "Jubinski",
    title: "Associate Provost for Academic Initiatives",
    slug: "sarah-m-jubinski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian C",
    lastName: "Juergens",
    title: "Director of Operations and Planning Innovation",
    slug: "brian-c-juergens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vanessa",
    lastName: "Jung",
    title: "Program Coord, Elec&Vis Stdnts",
    slug: "vanessa-jung",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jamie",
    lastName: "Jung",
    title: "Operations Manager",
    slug: "jamie-jung",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dawoom",
    lastName: "Jung",
    title: "Project Coordinator for Student Life",
    slug: "dawoom-jung",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dominika I.",
    lastName: "Juniewicz",
    title: "Neurophysiology Coordinator",
    slug: "dominika-i-juniewicz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex",
    lastName: "Jurado",
    title: "Residence Hall Director",
    slug: "alex-jurado",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Agata E.",
    lastName: "Jurewicz",
    title: "Quality Assurance Specialist",
    slug: "agata-e-jurewicz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Connolly",
    lastName: "Jurkiewicz",
    title: "Assistant Director, Marketing & Communications",
    slug: "connolly-jurkiewicz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bernice",
    lastName: "Jusino",
    title: "Assistant Director of Student Services, Office Management",
    slug: "bernice-jusino",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rebecca W.",
    lastName: "Kabat",
    title: "Senior Director of Development",
    slug: "rebecca-w-kabat",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Osman",
    lastName: "Kabir",
    title: "Sr. Application Systems Administrator",
    slug: "osman-kabir",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Abigail Mary",
    lastName: "Kaczmarek",
    title: "Manager-Admissions Intl Prog",
    slug: "abigail-mary-kaczmarek",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Rajwanth",
    lastName: "Kadari",
    title: "Ld. Application Systems Administrator",
    slug: "rajwanth-kadari",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sridhar",
    lastName: "Kadempally",
    title: "Associate Director, Information, Security and Risk Management",
    slug: "sridhar-kadempally",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chantal",
    lastName: "Kadhi-Smith",
    title: "Business Manager",
    slug: "chantal-kadhi-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ameenat",
    lastName: "Kadree",
    title: "Instructional Designer",
    slug: "ameenat-kadree",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Madeleine B.",
    lastName: "Kagan",
    title: "Administrative Clerk",
    slug: "madeleine-b-kagan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna S.",
    lastName: "Kagaruki Mhando",
    title: "Admissions Operations Specialist",
    slug: "anna-s-kagaruki-mhando",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Brianne Mary",
    lastName: "Kain",
    title: "Associate Director of Admissions",
    slug: "brianne-mary-kain",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christopher Matthew",
    lastName: "Kaiser",
    title: "Associate Director",
    slug: "christopher-matthew-kaiser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma",
    lastName: "Kaishian",
    title: "Program Administrator",
    slug: "emma-kaishian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danna",
    lastName: "Kalap",
    title: "Manager, Sub Awards CUIMC",
    slug: "danna-kalap",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tessa",
    lastName: "Kale",
    title: "Senior Editor",
    slug: "tessa-kale",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sheetal",
    lastName: "Kale",
    title: "Officer-Chief Equity & Inclusi",
    slug: "sheetal-kale",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Doodmatie",
    lastName: "Kalicharan",
    title: "Dir, Academic Admin & Finance",
    slug: "doodmatie-kalicharan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Max Alexander",
    lastName: "Kaliner",
    title: "Development Assistant, Office of Gift Planning",
    slug: "max-alexander-kaliner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas",
    lastName: "Kalogeropoulos",
    title: "Senior Associate Director, Employer Relations",
    slug: "nicholas-kalogeropoulos",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Praveen Reddy",
    lastName: "Kalwakollu",
    title: "Ld. Application Systems Administrator",
    slug: "praveen-reddy-kalwakollu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tracy E.",
    lastName: "Kamens",
    title: "Associate Director, Administration & Planning",
    slug: "tracy-e-kamens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel",
    lastName: "Kamerman",
    title: "Business Manager, Distributions",
    slug: "rachel-kamerman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kristine Nana",
    lastName: "Kamimura",
    title: "Internal Communications Manager",
    slug: "kristine-nana-kamimura",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Benjamin Haber",
    lastName: "Kamine",
    title: "Program Associate, Multifaith, VHO",
    slug: "benjamin-haber-kamine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aine Isabel",
    lastName: "Kaminski",
    title: "Undergraduate Volunteer",
    slug: "aine-isabel-kaminski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kai-Joachim",
    lastName: "Kamrath",
    title: "Executive Director",
    slug: "kai-joachim-kamrath",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Simbarashe Tawanda",
    lastName: "Kamuriwo",
    title: "Asst Dean-Advising",
    slug: "simbarashe-tawanda-kamuriwo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Panagiotis V",
    lastName: "Kamvosoulis",
    title: "MRI Manager",
    slug: "panagiotis-v-kamvosoulis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erva",
    lastName: "Kan",
    title: "Coordinator, SIPA Cyber Program",
    slug: "erva-kan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Diana T.",
    lastName: "Kandefer",
    title: "Associate Director, Operations",
    slug: "diana-t-kandefer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret",
    lastName: "Kane",
    title: "Administrative Assistant",
    slug: "margaret-kane",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barry S.",
    lastName: "Kane",
    title: "Associate Vice President and Registrar",
    slug: "barry-s-kane",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren",
    lastName: "Kane-Sample",
    title: "Director, Digital Learning",
    slug: "lauren-kane-sample",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maria",
    lastName: "Kang",
    title: "Student Services Coordinator",
    slug: "maria-kang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Priyanshi",
    lastName: "Kanoria",
    title: "Digital Content Coordinator",
    slug: "priyanshi-kanoria",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vedant B",
    lastName: "Kansara",
    title: "Data Coordinator",
    slug: "vedant-b-kansara",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yen-Hong",
    lastName: "Kao",
    title: "Scientific Computing Spec",
    slug: "yen-hong-kao",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kyle J.",
    lastName: "Kapfer",
    title:
      " Assistant Director, Student Philanthropy and Young Alumni Engagement",
    slug: "kyle-j-kapfer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Virginia M.",
    lastName: "Kaplan",
    title: "Chief of Staff to the Chief Operating Officer",
    slug: "virginia-m-kaplan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca Nicole",
    lastName: "Kaplan",
    title: "Social Media Officer",
    slug: "rebecca-nicole-kaplan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ruth",
    lastName: "Kaplan",
    title: "Interim Associate Dean, School of the Arts",
    slug: "ruth-kaplan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Aaron Nathan",
    lastName: "Kaplan",
    title: "Lead Software Developer",
    slug: "aaron-nathan-kaplan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shana",
    lastName: "Kaplanov",
    title: "Staff",
    slug: "shana-kaplanov",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Celia S.",
    lastName: "Kapsomera",
    title: "Academic Program Support in Professional Studies",
    slug: "celia-s-kapsomera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Denys",
    lastName: "Kapush",
    title: "Senior Associate Director, Digital Marketing",
    slug: "denys-kapush",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vasiliki",
    lastName: "Karahalios",
    title: "Associate Dean of Records and Standards",
    slug: "vasiliki-karahalios",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ashot A.",
    lastName: "Karamian",
    title: "Senior Service Specialist",
    slug: "ashot-a-karamian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ayana",
    lastName: "Kareem",
    title: "Talent Services Operations Associate",
    slug: "ayana-kareem",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Azeez",
    lastName: "Karim",
    title: "Manager, Information Systems",
    slug: "azeez-karim",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nathasha",
    lastName: "Kariyakarawana",
    title: "Finance and Compliance Manager, Sponsored Projects Finance",
    slug: "nathasha-kariyakarawana",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shreya Sachin",
    lastName: "Karnik",
    title: "PT Interim RA: S-BYE Lab",
    slug: "shreya-sachin-karnik",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anita Grace",
    lastName: "Karr",
    title: "Project Coordinator",
    slug: "anita-grace-karr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea A.",
    lastName: "Kassiano",
    title: "Specialist, Organization & Dev",
    slug: "andrea-a-kassiano",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Danielle Zoe",
    lastName: "Kassow",
    title: "Director - Program",
    slug: "danielle-zoe-kassow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seth",
    lastName: "Kasten",
    title: "Head, Reference and Research",
    slug: "seth-kasten",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Raja",
    lastName: "Kasukurthi",
    title: "Director, Financial Applications",
    slug: "raja-kasukurthi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zachary A.",
    lastName: "Katagiri",
    title: "Director, Alumni Relations, Design and Web Development",
    slug: "zachary-a-katagiri",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Raissa",
    lastName: "Katerskaia",
    title: "Senior Director, Finance Application Support",
    slug: "raissa-katerskaia",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kent",
    lastName: "Katner",
    title: "Program Manager",
    slug: "kent-katner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer Hannah",
    lastName: "Katz",
    title: "Admissions Assistant",
    slug: "jennifer-hannah-katz",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Alan J",
    lastName: "Katz",
    title: "Accounting Coordinator",
    slug: "alan-j-katz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dan",
    lastName: "Kauffman",
    title: "Adjunct",
    slug: "dan-kauffman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sharan",
    lastName: "Kaur",
    title: "Senior Contracts Officer",
    slug: "sharan-kaur",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Manpreet",
    lastName: "Kaur",
    title: "MA",
    slug: "manpreet-kaur",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jyoti",
    lastName: "Kaushal",
    title: "Director-Office of IACUC",
    slug: "jyoti-kaushal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pragati",
    lastName: "Kaushik",
    title: "Interim Employee",
    slug: "pragati-kaushik",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Emily",
    lastName: "Kautz",
    title: "Program Manager",
    slug: "emily-kautz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristine",
    lastName: "Kavanaugh",
    title: "Associate Vice President",
    slug: "kristine-kavanaugh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane M.",
    lastName: "Kawaoka",
    title: "Senior Lab Director",
    slug: "jane-m-kawaoka",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hazal",
    lastName: "Kayalioglu",
    title: "Research Administrator I",
    slug: "hazal-kayalioglu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tristia",
    lastName: "Kayser",
    title: "Manager, Financial Aid Operations and Training",
    slug: "tristia-kayser",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maire K.",
    lastName: "Keane",
    title: "Program and Communications Manager",
    slug: "maire-k-keane",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jon Steven",
    lastName: "Kearney",
    title: "Director, Vendor Management",
    slug: "jon-steven-kearney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie E",
    lastName: "Kearney",
    title: "Coordinator, Curriculum and Instruction",
    slug: "julie-e-kearney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rosa A.",
    lastName: "Kedir",
    title: "Sr Application Systems Develop",
    slug: "rosa-a-kedir",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David Luke",
    lastName: "Keefe",
    title: "Director of Military and Veteran Community Engagement",
    slug: "david-luke-keefe",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrew",
    lastName: "Keen",
    title: "Associate Director, Finance",
    slug: "andrew-keen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paul",
    lastName: "Keenan",
    title: "Senior Vice President for University Development",
    slug: "paul-keenan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly I.",
    lastName: "Kefgen",
    title: "Associate Director of Business Development",
    slug: "kimberly-i-kefgen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Owen Craggs",
    lastName: "Keith",
    title: "Systems Administrator",
    slug: "owen-craggs-keith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tyliah A.",
    lastName: "Kekele",
    title: "Comm and Marketing Coordinator",
    slug: "tyliah-a-kekele",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karina",
    lastName: "Kelleher",
    title: "Executive Assistant",
    slug: "karina-kelleher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel Marie",
    lastName: "Keller",
    title: "Associate Director, Reunion Class Giving",
    slug: "rachel-marie-keller",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Debra A.",
    lastName: "Keller",
    title: "Senior Director, HR/FA",
    slug: "debra-a-keller",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Christian",
    lastName: "Keller",
    title: "Data Manager",
    slug: "christian-keller",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aaron L.",
    lastName: "Keller",
    title: "Thesis Production Manager",
    slug: "aaron-l-keller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Caroline",
    lastName: "Kelley",
    title: "Assistant Director, Career Design Lab",
    slug: "caroline-kelley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Frances",
    lastName: "Kellner",
    title: "Assistant Director of Career Advising",
    slug: "frances-kellner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Scott T",
    lastName: "Kelly",
    title: "Manager of Graduate Admissions and Student Affairs",
    slug: "scott-t-kelly",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sheila Denise",
    lastName: "Kelly",
    title: "Senior Student Services Rep",
    slug: "sheila-denise-kelly",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Meaghan Kennedy",
    lastName: "Kelly",
    title: "Communications Editor",
    slug: "meaghan-kennedy-kelly",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lauren M",
    lastName: "Kelly",
    title: "Senior Project Manager Safety & Regulatory Affairs",
    slug: "lauren-m-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen Yvette",
    lastName: "Kelly",
    title: "Manager of Administrative Services",
    slug: "karen-yvette-kelly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandon Michael",
    lastName: "Kelly",
    title: "Senior Associate Director, Business Applications & Data Operations",
    slug: "brandon-michael-kelly",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Moshe A",
    lastName: "Kelsen",
    title: "Chief Financial Officer",
    slug: "moshe-a-kelsen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amir",
    lastName: "Kenan",
    title: "Associate Director, Communications",
    slug: "amir-kenan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gulnar Torebekgyzy",
    lastName: "Kendirbai",
    title: "Researcher",
    slug: "gulnar-torebekgyzy-kendirbai",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Barry Lee",
    lastName: "Kendrick Jr",
    title: "Manager, Finance & Operations",
    slug: "barry-lee-kendrick-jr",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer L",
    lastName: "Kenneally",
    title: "Administrative Manager, Climate",
    slug: "jennifer-l-kenneally",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathryn R.",
    lastName: "Kennedy",
    title: "Director, Professional Programs",
    slug: "kathryn-r-kennedy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marquett",
    lastName: "Kennely",
    title: "Executive Assistant",
    slug: "marquett-kennely",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica Marie",
    lastName: "Kenney",
    title: "Org Dev Specialist, Res/Edu",
    slug: "jessica-marie-kenney",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Margarita M.",
    lastName: "Kenny",
    title: "Finance Coordinator",
    slug: "margarita-m-kenny",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lorraine",
    lastName: "Kenny",
    title: "Communications Director",
    slug: "lorraine-kenny",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Griffin George",
    lastName: "Kent",
    title: "Coordinator-Student Srvs Event",
    slug: "griffin-george-kent",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Catherine",
    lastName: "Kentros",
    title: "Genetics Counselor",
    slug: "catherine-kentros",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Simeon",
    lastName: "Kenward",
    title: "Student Mail Clerk",
    slug: "simeon-kenward",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrew W.",
    lastName: "Keough",
    title: "Grant and Research Development Specialist",
    slug: "andrew-w-keough",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Merideth H.",
    lastName: "Kerby",
    title: "Associate Dean, HR and Administration",
    slug: "merideth-h-kerby",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael Edward",
    lastName: "Kerman",
    title: "Director of Career Counseling",
    slug: "michael-edward-kerman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bamini",
    lastName: "Ketheesan",
    title: "Grants Manager",
    slug: "bamini-ketheesan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Regina R.",
    lastName: "Ketting",
    title: "Director of Gift Planning",
    slug: "regina-r-ketting",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sehar",
    lastName: "Khan",
    title: "Regulatory Coordinator",
    slug: "sehar-khan",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Rana",
    lastName: "Khan",
    title: "Assistant Vice President, Student Affairs",
    slug: "rana-khan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "MD W",
    lastName: "Khan",
    title: "Associate Director, Operations",
    slug: "md-w-khan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mohammed",
    lastName: "Khan",
    title: "Assistant Director, Finance",
    slug: "mohammed-khan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Muin",
    lastName: "Khan",
    title: "Director, Acad Admin & Finance",
    slug: "muin-khan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lara E.",
    lastName: "Khan",
    title: "Vice President, Budget and Planning",
    slug: "lara-e-khan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tanvir",
    lastName: "Khan",
    title: "Anltcs Clin Data Nav - Surgery",
    slug: "tanvir-khan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Issa",
    lastName: "Khan",
    title: "Project Coordinator II",
    slug: "issa-khan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ankit Shrikantbhai",
    lastName: "Khatri",
    title: "Sr Dir, Fin Analysis/Reporting",
    slug: "ankit-shrikantbhai-khatri",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Diana",
    lastName: "Kherdaji",
    title: "Director, CUIT Service Desk",
    slug: "diana-kherdaji",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aarti",
    lastName: "Kheskani",
    title: "Student Acad Support Worker",
    slug: "aarti-kheskani",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sherien",
    lastName: "Khonsari",
    title: "Student Digital and Communications Strategy Lead",
    slug: "sherien-khonsari",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Renee M",
    lastName: "Khouri",
    title: "Data Coordinator",
    slug: "renee-m-khouri",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rafia",
    lastName: "Khursheed",
    title: "Research Program Manager",
    slug: "rafia-khursheed",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rodesia",
    lastName: "Kibler",
    title: "University Affiliate - STEAM",
    slug: "rodesia-kibler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathryn Jane Bartram",
    lastName: "Kiddell",
    title: "Neuroscience and Education Interim Employee",
    slug: "kathryn-jane-bartram-kiddell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leeora L",
    lastName: "Kidron",
    title: "Project Administrator",
    slug: "leeora-l-kidron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason M",
    lastName: "Kiebzak",
    title: "Storage Area Network Admin",
    slug: "jason-m-kiebzak",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katherine Maureen Smith",
    lastName: "Kijinski",
    title: "Sr Project Portfolio Manager",
    slug: "katherine-maureen-smith-kijinski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Adam Sean",
    lastName: "Kilduff",
    title: "Associate Director of Communication and Public Affairs",
    slug: "adam-sean-kilduff",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hannah H",
    lastName: "Kilgore",
    title: "Assistant Dean of Strategic Initiatives",
    slug: "hannah-h-kilgore",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Teresa M.",
    lastName: "Kilzi",
    title: "Assistant Director for Alumni Relations",
    slug: "teresa-m-kilzi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yoon Jin",
    lastName: "Kim",
    title: "Coordinator, University Programs and Events",
    slug: "yoon-jin-kim",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Young Seo",
    lastName: "Kim",
    title: "Interim Classroom Technology Specialist Assistant",
    slug: "young-seo-kim",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "So Yeun",
    lastName: "Kim",
    title: "Marketing Specialist",
    slug: "so-yeun-kim",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sunghee",
    lastName: "Kim",
    title: "Creative Director",
    slug: "sunghee-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susie",
    lastName: "Kim",
    title: "Exec Dir & Assoc Priv Officer",
    slug: "susie-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sue B.",
    lastName: "Kim",
    title: "Admissions Coordinator",
    slug: "sue-b-kim",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Naeun",
    lastName: "Kim",
    title: "Sr Manager, Finance/Res Admin",
    slug: "naeun-kim",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Norman Hwan",
    lastName: "Kim",
    title: "Diversity, Equity and Inclusion Officer",
    slug: "norman-hwan-kim",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Sharon",
    lastName: "Kim",
    title:
      " Associate Director of Administration, Negotiation and Conflict Resolution",
    slug: "sharon-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaime Y",
    lastName: "Kim",
    title: "Sr Manager, Lab & Operations",
    slug: "jaime-y-kim",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jihoo",
    lastName: "Kim",
    title: "Collaborator, Non-Hebbian project",
    slug: "jihoo-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janet",
    lastName: "Kim",
    title: "Project Officer",
    slug: "janet-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ji Eun Kaela",
    lastName: "Kim",
    title: "Officer-Contract Negotiations",
    slug: "ji-eun-kaela-kim",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Hyunsoo",
    lastName: "Kim",
    title: "One Time Payment - Art Ed",
    slug: "hyunsoo-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Helen",
    lastName: "Kim",
    title: "Vice President for Research Operations and Policy (VPROP)",
    slug: "helen-kim",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Grace",
    lastName: "Kim",
    title: "Director of Compliance",
    slug: "grace-kim",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Calvin S.",
    lastName: "Kim",
    title: "Manager of Academic Administration",
    slug: "calvin-s-kim",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Clayton Joonhan",
    lastName: "Kim",
    title: "Digital Image Specialist",
    slug: "clayton-joonhan-kim",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chace",
    lastName: "Kim",
    title: "Assistant Director, Digital Marketing",
    slug: "chace-kim",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andy",
    lastName: "Kim",
    title: "Senior Grant Coordinator",
    slug: "andy-kim",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aaron",
    lastName: "Kim",
    title: "Lab Coordinator, CSSW Action Lab for Social Justice",
    slug: "aaron-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia",
    lastName: "Kimyagarov",
    title: "Director",
    slug: "julia-kimyagarov",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kayla",
    lastName: "Kindred",
    title: "Admissions Officer, High School Programs",
    slug: "kayla-kindred",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Stephanie N.",
    lastName: "King",
    title: "Associate Dean of Student and Family Support",
    slug: "stephanie-n-king",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Marlon S",
    lastName: "King",
    title: "Bursar Representative for Loans and Collections",
    slug: "marlon-s-king",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marquis L.",
    lastName: "King",
    title: "Able-Bodied Seaperson",
    slug: "marquis-l-king",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret Anne",
    lastName: "King",
    title: "Sr Dir of Individual Giving",
    slug: "margaret-anne-king",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ebony L.",
    lastName: "King",
    title: "Administrative Manager",
    slug: "ebony-l-king",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bridget T.",
    lastName: "King",
    title: "Generalist, HR/FA",
    slug: "bridget-t-king",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Allie Hope",
    lastName: "King",
    title:
      " Program Manager, Community Language Program and International Researchers Language Program",
    slug: "allie-hope-king",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Kingon",
    title: "Associate Director, CUMC Programs and Services",
    slug: "ashley-kingon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karla Sue",
    lastName: "Kingsbury",
    title: "Director, Revenue Cycle",
    slug: "karla-sue-kingsbury",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauren N",
    lastName: "Kinsley",
    title: "Assistant Director, Donor and Prospect Relations",
    slug: "lauren-n-kinsley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jenna N.",
    lastName: "Kirant",
    title: "Manager, Technology Projects and Production",
    slug: "jenna-n-kirant",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vladimir",
    lastName: "Kirilko",
    title: "Sr. Application Systems Developer",
    slug: "vladimir-kirilko",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shane M",
    lastName: "Kirk",
    title: "User Services Consultant",
    slug: "shane-m-kirk",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gwyneth M.",
    lastName: "Kirkbride",
    title: "Program Director, Workplace Center",
    slug: "gwyneth-m-kirkbride",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isabelle C",
    lastName: "Kirkham-Lewitt",
    title: "Director-Print Publications",
    slug: "isabelle-c-kirkham-lewitt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sonnie Jo",
    lastName: "Kirschbaum",
    title: "Coordinator",
    slug: "sonnie-jo-kirschbaum",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Laura B",
    lastName: "Kirschstein",
    title: "Vice Provost for Equal Opportunity and Affirmative Action",
    slug: "laura-b-kirschstein",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Nina K",
    lastName: "Kisanga",
    title: "Admissions Officer",
    slug: "nina-k-kisanga",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sergey",
    lastName: "Kisselev",
    title: "Data Manager",
    slug: "sergey-kisselev",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Kissner",
    title: "Sr Dir ofOps,Flow Cytmtry Core",
    slug: "michael-kissner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan Carole",
    lastName: "Kistler",
    title: "Director Information Technology",
    slug: "susan-carole-kistler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carolyn",
    lastName: "Klaasen",
    title: "Staff",
    slug: "carolyn-klaasen",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Suzanna",
    lastName: "Klaf",
    title: "Associate Director",
    slug: "suzanna-klaf",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dana R",
    lastName: "Klainberg",
    title: "Assistant Manager for Ed. D. Students. Office of Doctoral Studies",
    slug: "dana-r-klainberg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jamie Lynn",
    lastName: "Kleidman",
    title: "Associate Director, Investigations",
    slug: "jamie-lynn-kleidman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Martin J",
    lastName: "Klein",
    title: "Asst Marine Operations Manager",
    slug: "martin-j-klein",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael A.",
    lastName: "Klein",
    title: "Director, Research Compliance",
    slug: "michael-a-klein",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erica Lee",
    lastName: "Klein",
    title: "Executive Director",
    slug: "erica-lee-klein",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Althea",
    lastName: "Klein",
    title: "Director, HR Benefits Vendor Relations",
    slug: "althea-klein",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rachel Marie",
    lastName: "Klem",
    title: "Division Director",
    slug: "rachel-marie-klem",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria",
    lastName: "Klesseck",
    title: "Assistant Director of Administration, Non-Profit Management",
    slug: "victoria-klesseck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward M.",
    lastName: "Kliment",
    title: "Deputy Administrator for Operations and Prize Process",
    slug: "edward-m-kliment",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allison",
    lastName: "Kline",
    title: "Senior Associate Director, Network Engagement",
    slug: "allison-kline",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah",
    lastName: "Kling",
    title: "New Business Development & Sales Manager",
    slug: "sarah-kling",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Valentina",
    lastName: "Kloosterman",
    title: "Implementation Specialist",
    slug: "valentina-kloosterman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lydia H.",
    lastName: "Knapp",
    title: "Assistant Director - Events & Outreach",
    slug: "lydia-h-knapp",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Courtney",
    lastName: "Knights",
    title: "Major Gift Officer for University Initiatives",
    slug: "courtney-knights",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Knipe",
    title: "Lead Network Operations Technican",
    slug: "david-knipe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert G.",
    lastName: "Knott",
    title: "Senior Director, Marketing Content and Creative",
    slug: "robert-g-knott",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Corrie B",
    lastName: "Knott",
    title: "Director of Production",
    slug: "corrie-b-knott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carrie",
    lastName: "Knowlton",
    title: "Application Systems Developer",
    slug: "carrie-knowlton",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bronwyn G.",
    lastName: "Knox",
    title: "Associate Director, Marketing Content and Creative",
    slug: "bronwyn-g-knox",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andrew Timothy",
    lastName: "Knutson",
    title: "Executive Director, Employer and Alumni Relations",
    slug: "andrew-timothy-knutson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hsiang-Jou",
    lastName: "Ko",
    title: "Production Manager - Lighting & Theatrical Systems",
    slug: "hsiang-jou-ko",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ana Maria",
    lastName: "Kobori",
    title: "Administrative Coordinator",
    slug: "ana-maria-kobori",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elena",
    lastName: "Kocheleva",
    title: "Housekeeping Attendant",
    slug: "elena-kocheleva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gina K",
    lastName: "Koh-Campbell",
    title: "Administrative Coordinator",
    slug: "gina-k-koh-campbell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Purti",
    lastName: "Kohli",
    title: "Grants Manager-Post Award",
    slug: "purti-kohli",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amy",
    lastName: "Kohn",
    title:
      " Senior Associate Director of Academic Affairs, Curriculum Management",
    slug: "amy-kohn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jerry",
    lastName: "Kokkinos",
    title: "Director of Human Resources",
    slug: "jerry-kokkinos",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cassandra",
    lastName: "Kokofu",
    title: "Student Affairs Manager",
    slug: "cassandra-kokofu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jerry",
    lastName: "Kokoshka",
    title: "Sr Technology Licensing Officer",
    slug: "jerry-kokoshka",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elymar Redor",
    lastName: "Kolev",
    title: "Assistant Director, Advancement Service",
    slug: "elymar-redor-kolev",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chelsea A",
    lastName: "Kolff",
    title: "Director, Academic Programs",
    slug: "chelsea-a-kolff",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adam",
    lastName: "Kolker",
    title:
      " Assistant Dean and Executive Director for International and Comparative Law Programs",
    slug: "adam-kolker",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ella Catherine",
    lastName: "Kolosek",
    title: "Senior Admissions Officer",
    slug: "ella-catherine-kolosek",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mustafa C",
    lastName: "Kolukisa",
    title: "Director, Technology & Innovation",
    slug: "mustafa-c-kolukisa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Victoria",
    lastName: "Kolupaeva",
    title: "Research Administrator",
    slug: "victoria-kolupaeva",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jannebu",
    lastName: "Komah",
    title: "SYEP",
    slug: "jannebu-komah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ibrahim M.",
    lastName: "Kombarji",
    title: "Director of Communications",
    slug: "ibrahim-m-kombarji",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elena V.",
    lastName: "Komissarova",
    title: "Project Manager",
    slug: "elena-v-komissarova",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madhusudhanrao",
    lastName: "Kommineni",
    title: "Manager, Procurement Application Support",
    slug: "madhusudhanrao-kommineni",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sourikhunh",
    lastName: "Konekeo",
    title: "Director of Admissions",
    slug: "sourikhunh-konekeo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Soke Kwai",
    lastName: "Kong",
    title: "Assistant Director for Academic Affairs",
    slug: "soke-kwai-kong",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cynthia C.",
    lastName: "Kong",
    title: "Chief of Staff to the Dean for Columbia College",
    slug: "cynthia-c-kong",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher R",
    lastName: "Konowal",
    title: "Lab Manager",
    slug: "christopher-r-konowal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine J",
    lastName: "Konradt",
    title: "Project Manager",
    slug: "catherine-j-konradt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph M.",
    lastName: "Kopriva",
    title: "Director of Residential Life",
    slug: "joseph-m-kopriva",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brunilda",
    lastName: "Kore",
    title: "Manager-Catering Sales",
    slug: "brunilda-kore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa A",
    lastName: "Korek",
    title: "Grants Manager",
    slug: "melissa-a-korek",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vasiliki M.",
    lastName: "Korikis",
    title: "Director",
    slug: "vasiliki-m-korikis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "Korinek",
    title: "Assistant Controller, Financial Reporting",
    slug: "jennifer-korinek",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jonathan M",
    lastName: "Kornberg",
    title: "Director, Instructional Technology",
    slug: "jonathan-m-kornberg",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tatsiana",
    lastName: "Korsakava",
    title: "Billing Compliance Assistant",
    slug: "tatsiana-korsakava",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle",
    lastName: "Kosiorek",
    title: "Four Points Tech",
    slug: "michelle-kosiorek",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David",
    lastName: "Kossey",
    title: "IRB Member",
    slug: "david-kossey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dhanasri",
    lastName: "Kota",
    title: "Consultant",
    slug: "dhanasri-kota",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ken",
    lastName: "Kotala",
    title: "Director, Network Field Svcs",
    slug: "ken-kotala",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Romina",
    lastName: "Kotsamanidis",
    title: "Program and Outreach Manager",
    slug: "romina-kotsamanidis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michelle Alicia",
    lastName: "Kouassi",
    title: "Associate Director, Admissions",
    slug: "michelle-alicia-kouassi",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Maria N",
    lastName: "Kouimanis",
    title: "Finance Manager",
    slug: "maria-n-kouimanis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dimitra",
    lastName: "Koutsantoni",
    title: "Executive Director, Corporate Foundation Relations",
    slug: "dimitra-koutsantoni",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yasmin",
    lastName: "Kovacic",
    title: "Associate Director, Operations",
    slug: "yasmin-kovacic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Kozikott",
    title: "Senior Project Officer",
    slug: "jessica-kozikott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie",
    lastName: "Kozikova",
    title: "Senior Certification Manager",
    slug: "julie-kozikova",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kevin",
    lastName: "Krajick",
    title: "Senior Editor, Science News",
    slug: "kevin-krajick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Robert W.",
    lastName: "Kramer",
    title: "Associate Director of Admissions and Academic Affairs",
    slug: "robert-w-kramer",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jared A.",
    lastName: "Kramer",
    title: "Mgr, Institutional Technology",
    slug: "jared-a-kramer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mildred",
    lastName: "Kramer-Garcia",
    title: "Dir, Academic Admin & Finance",
    slug: "mildred-kramer-garcia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samuel",
    lastName: "Krasnoff",
    title: "Software Developer",
    slug: "samuel-krasnoff",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ann S",
    lastName: "Kraus",
    title: "Associate Vice President, Total Compensation",
    slug: "ann-s-kraus",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ryan",
    lastName: "Kreider",
    title: "Associate Director, Harriman Institute",
    slug: "ryan-kreider",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karlene N",
    lastName: "Kreutzer",
    title: "Senior Director, Donor Rel",
    slug: "karlene-n-kreutzer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Leslie Ruth",
    lastName: "Kriesel",
    title: "Production Editing Manager",
    slug: "leslie-ruth-kriesel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael R",
    lastName: "Krisch",
    title: "Program Director, Brown Institute",
    slug: "michael-r-krisch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarath Babu",
    lastName: "Krishna Murthy",
    title: "Dir,Genomic Health&Informatics",
    slug: "sarath-babu-krishna-murthy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Edward L",
    lastName: "Kritchevski",
    title: "Division Administrator-Finance",
    slug: "edward-l-kritchevski",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David",
    lastName: "Kritchevski",
    title: "Non-Student STC",
    slug: "david-kritchevski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Arlene",
    lastName: "Kriv",
    title: "Marketing & Comms Manager",
    slug: "arlene-kriv",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shea K",
    lastName: "Kroez",
    title: "Administrative Manager",
    slug: "shea-k-kroez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Anne Marie",
    lastName: "Kromidas",
    title: "Associate Director, Military and Veteran Affairs",
    slug: "anne-marie-kromidas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Shawna",
    lastName: "Kroning",
    title: "Assistant Director, Events Management",
    slug: "shawna-kroning",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel J",
    lastName: "Krug",
    title: "Sr Manager, Finance/Res Admin",
    slug: "daniel-j-krug",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anamaria",
    lastName: "Krull",
    title: "Quality Assurance Manager",
    slug: "anamaria-krull",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cui Xia",
    lastName: "Kuan",
    title: "Technical Assistant",
    slug: "cui-xia-kuan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rebecca",
    lastName: "Kubey",
    title: "Assistant Director, Human Resources",
    slug: "rebecca-kubey",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Erika S.",
    lastName: "Kuciw",
    title: "Project/Admin Coordinator",
    slug: "erika-s-kuciw",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katharine Roberts",
    lastName: "Kuhl",
    title: "Associate Director, Investigation",
    slug: "katharine-roberts-kuhl",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Maggie",
    lastName: "Kuhn",
    title: "Assistant Director, Student and Alumni Connections",
    slug: "maggie-kuhn",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brittany R.",
    lastName: "Kuhn",
    title: "Production Resources and Nash Operations Manager",
    slug: "brittany-r-kuhn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Saarthak Padma",
    lastName: "Kumar",
    title: "Operations Officer",
    slug: "saarthak-padma-kumar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ramya",
    lastName: "Kumar",
    title: "Associate Director",
    slug: "ramya-kumar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kavya S.",
    lastName: "Kumar",
    title: "Director, Recent Alumni",
    slug: "kavya-s-kumar",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gabriela",
    lastName: "Kumar",
    title: "Administrative Assistant",
    slug: "gabriela-kumar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tenzin",
    lastName: "Kunphel",
    title: "Director Budget and Finance",
    slug: "tenzin-kunphel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jiny",
    lastName: "Kurian",
    title: "Associate Director of Human Resources",
    slug: "jiny-kurian",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rebecca Ida",
    lastName: "Kurk",
    title: "Executive Assistant, Principal Gifts",
    slug: "rebecca-ida-kurk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin M.",
    lastName: "Kurtz",
    title: "Midwest Sales Representative",
    slug: "kevin-m-kurtz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Priya",
    lastName: "Kurup",
    title: "Project Officer",
    slug: "priya-kurup",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward S",
    lastName: "Kurzum Jr",
    title: "Manager - Environmental Health & Safety",
    slug: "edward-s-kurzum-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia",
    lastName: "Kushnirsky",
    title: "Design Director",
    slug: "julia-kushnirsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "George Berthold",
    lastName: "Kusserow",
    title: "Assistant Director for Operations and Communications",
    slug: "george-berthold-kusserow",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Victoria",
    lastName: "Kutepova",
    title: "Grants Financial Manager",
    slug: "victoria-kutepova",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Noah",
    lastName: "Kutzy",
    title: "Director of Communications",
    slug: "noah-kutzy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jae Eun",
    lastName: "Kwak",
    title: "Manager-Title IX",
    slug: "jae-eun-kwak",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Eliza K.",
    lastName: "Kwon",
    title: "Sr Manager-Busi/Stud Affairs",
    slug: "eliza-k-kwon",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elizabeth",
    lastName: "Kwon",
    title: "Embedded Research Computing Specialist",
    slug: "elizabeth-kwon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Charlotte",
    lastName: "Kwon",
    title: "Associate Director, Finance",
    slug: "charlotte-kwon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jason",
    lastName: "Kwong",
    title: "Webmaster/LAMP Sys Admin",
    slug: "jason-kwong",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Esther B",
    lastName: "Kyeremah",
    title: "Project Coordinator",
    slug: "esther-b-kyeremah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leonora B.",
    lastName: "La Pierre",
    title: "Assistant Manager",
    slug: "leonora-b-la-pierre",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniella",
    lastName: "LaBella",
    title: "Director of Finance Operations and Budget Management",
    slug: "daniella-labella",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennyville Lois Y.",
    lastName: "Labuga Rumenik",
    title: "Coordinator",
    slug: "jennyville-lois-y-labuga-rumenik",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Irene M",
    lastName: "Lacis",
    title: "Associate Director",
    slug: "irene-m-lacis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason J.",
    lastName: "Lacks",
    title: "Financial Coordinator",
    slug: "jason-j-lacks",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John F.",
    lastName: "Lacqua",
    title: "Director, Academic Administration & Finance",
    slug: "john-f-lacqua",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kip David",
    lastName: "Lacy",
    title: "Contractor",
    slug: "kip-david-lacy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Funmi",
    lastName: "Ladigbolu",
    title: "Assoc Director, Service Mgmt",
    slug: "funmi-ladigbolu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John J",
    lastName: "LaDuca",
    title: "Sr Dir, Digital Strategy",
    slug: "john-j-laduca",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marian L",
    lastName: "LaForest",
    title: "Senior Program Manager",
    slug: "marian-l-laforest",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica Nicole",
    lastName: "LaHote",
    title: "Senior Program Officer",
    slug: "jessica-nicole-lahote",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yecenia",
    lastName: "Lahoz",
    title: "Financial Assistant",
    slug: "yecenia-lahoz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hana",
    lastName: "Lahr",
    title: "Assistant Director of Research & Director of Applied Learning",
    slug: "hana-lahr",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Phoebe",
    lastName: "Lai",
    title: "Administrative Clerk",
    slug: "phoebe-lai",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen H",
    lastName: "Lai",
    title: "Assistant Director of Budget and Financial Analysis",
    slug: "karen-h-lai",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yu Chun",
    lastName: "Lai",
    title: "Director, Budget Management Reporting",
    slug: "yu-chun-lai",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sherece S",
    lastName: "Laine",
    title: "Research Project Coordinator",
    slug: "sherece-s-laine",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yelena",
    lastName: "Lakhter",
    title: "Lead App Systems Developer",
    slug: "yelena-lakhter",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah Marguerite",
    lastName: "Lally",
    title: "Manager-Communications",
    slug: "sarah-marguerite-lally",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nina A",
    lastName: "Lam",
    title: "Associate Director of Student Engagement",
    slug: "nina-a-lam",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Michael",
    lastName: "Lam",
    title: "Reporting Specialist, Registrar's Office",
    slug: "michael-lam",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elliot H.",
    lastName: "Lam",
    title: "Admissions Coordinator",
    slug: "elliot-h-lam",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Chut",
    lastName: "Lam",
    title: "Director, Financial Reporting & Business Intelligence",
    slug: "chut-lam",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maria Elisa",
    lastName: "Lamadrid",
    title: "Director of Academic Administration",
    slug: "maria-elisa-lamadrid",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ryan",
    lastName: "LaMantia",
    title: "Assistant Director, Admissions",
    slug: "ryan-lamantia",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Latisha",
    lastName: "Lambert",
    title: "Director, Talent Services",
    slug: "latisha-lambert",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Debra V.",
    lastName: "Lambert",
    title: "Executive Director, Media and Advertising",
    slug: "debra-v-lambert",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cyrenus Tristen",
    lastName: "Lambert",
    title: "Summer Intern",
    slug: "cyrenus-tristen-lambert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Lamela",
    title: "Senior Program Support Coord",
    slug: "elizabeth-lamela",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adriana Leila",
    lastName: "Lamirande",
    title: "Media & Social Media Manager",
    slug: "adriana-leila-lamirande",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alexandra",
    lastName: "Lamoree",
    title: "Auditor",
    slug: "alexandra-lamoree",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah",
    lastName: "Lamparski",
    title: "Associate Director",
    slug: "sarah-lamparski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin R.",
    lastName: "Lampert",
    title: "Project Manager",
    slug: "robin-r-lampert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cara",
    lastName: "Lampron",
    title: "Creative Arts Therapist",
    slug: "cara-lampron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mu-Lin",
    lastName: "Lan",
    title: "Assistant Director",
    slug: "mu-lin-lan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chingfu",
    lastName: "Lan",
    title: "Interim Hourly",
    slug: "chingfu-lan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dean M.",
    lastName: "Lance",
    title: "Production Coordinator",
    slug: "dean-m-lance",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason",
    lastName: "Land",
    title: "Financial Assistant",
    slug: "jason-land",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Josie",
    lastName: "Landers",
    title: "Assistant Director, Admissions",
    slug: "josie-landers",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Olivia",
    lastName: "Landes",
    title: "Project Coordinator",
    slug: "olivia-landes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark C.",
    lastName: "Landow",
    title: "Master",
    slug: "mark-c-landow",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mackey",
    lastName: "Landy",
    title: "Digital Content Producer",
    slug: "mackey-landy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Robert R.",
    lastName: "Lane",
    title: "Executive Director of IT",
    slug: "robert-r-lane",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Lane",
    title: "Executive Assistant and Operations Manager",
    slug: "michael-lane",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keaton",
    lastName: "Lane",
    title: "Assistant Director",
    slug: "keaton-lane",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ann",
    lastName: "Lane",
    title: "Executive Assistant",
    slug: "ann-lane",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meghan",
    lastName: "Lane-Fall",
    title: "Chair, Department of Anesthesiology",
    slug: "meghan-lane-fall",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Charles",
    lastName: "Lang",
    title: "Sr Exec Dir & Coterminous Prof",
    slug: "charles-lang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cynthia",
    lastName: "Lang",
    title: "Sr.TechnologyLicensing Officer",
    slug: "cynthia-lang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Barbara",
    lastName: "Lang",
    title: "Research Administrative Director",
    slug: "barbara-lang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tammy",
    lastName: "Langan",
    title: "Graduate Program Manager",
    slug: "tammy-langan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cynthia P.",
    lastName: "Langin",
    title: "Senior Associate Provost for Institutional Research",
    slug: "cynthia-p-langin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cheyenne Marie",
    lastName: "Langrin-Delgado",
    title: "Org Dev Specialist, Bus Proc",
    slug: "cheyenne-marie-langrin-delgado",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alesi Gabrielle",
    lastName: "Lanham",
    title: "Admissions Coordinator",
    slug: "alesi-gabrielle-lanham",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tara A.",
    lastName: "Lanigan",
    title: "Senior Director Strategic Partnerships",
    slug: "tara-a-lanigan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William A.",
    lastName: "Lannon",
    title: "Director",
    slug: "william-a-lannon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Arianna",
    lastName: "Lantigua",
    title: "Secretary B",
    slug: "arianna-lantigua",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Quinn",
    lastName: "Lanza",
    title: "Dr. Golub - EARLHI Public Projec",
    slug: "quinn-lanza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Lapin",
    title: "Department Administrator",
    slug: "james-lapin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Iris W.",
    lastName: "Lara",
    title: "Manager, HR & FA",
    slug: "iris-w-lara",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gregory",
    lastName: "Lara",
    title: "Director of Information Technology",
    slug: "gregory-lara",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nini",
    lastName: "Larkin",
    title:
      " Assistant Director, Operations and Administration - Student Affairs",
    slug: "nini-larkin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jonathan",
    lastName: "Larkin",
    title: "Managing Director, Risk & Data Analytics",
    slug: "jonathan-larkin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Grace C",
    lastName: "Larkin",
    title: "Writer, Editor, and Content Manager",
    slug: "grace-c-larkin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicole M.",
    lastName: "Larkins",
    title: "Manager of Development Operations",
    slug: "nicole-m-larkins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kelly",
    lastName: "Larnach",
    title: "Associate Director, Career Education and Advising",
    slug: "kelly-larnach",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Greta E",
    lastName: "Larson",
    title: "Administrative Director",
    slug: "greta-e-larson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Davin",
    lastName: "Larson",
    title: "Associate Director of Digital Content Strategy",
    slug: "davin-larson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dawn F.",
    lastName: "LaSalle",
    title: "Admin Assistant",
    slug: "dawn-f-lasalle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda J",
    lastName: "Lasker",
    title:
      " Senior Executive Director for Development, Columbia College and Arts & Sciences",
    slug: "amanda-j-lasker",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David John",
    lastName: "Lasko",
    title: "Respiratory Therapist",
    slug: "david-john-lasko",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marisa",
    lastName: "Lastres",
    title: "Production Editor",
    slug: "marisa-lastres",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lorraine",
    lastName: "Latouche",
    title: "Administrative Assistant",
    slug: "lorraine-latouche",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Asia",
    lastName: "Latt",
    title: "Business Officer",
    slug: "asia-latt",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kathryn",
    lastName: "Lattimer",
    title: "Chief Operating Officer",
    slug: "kathryn-lattimer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jackson",
    lastName: "Lau",
    title: "Systems Administrator",
    slug: "jackson-lau",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachel",
    lastName: "Laufer",
    title: "Development Associate",
    slug: "rachel-laufer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica Emiko",
    lastName: "Laufer",
    title: "Concentration Coordinator",
    slug: "jessica-emiko-laufer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizah M.",
    lastName: "Laurenceau",
    title: "Assistant Director-Alumni Relations",
    slug: "elizah-m-laurenceau",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alyssa Ann",
    lastName: "Laurencio",
    title: "Associate Director of Events & Special Programs",
    slug: "alyssa-ann-laurencio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lunes",
    lastName: "Laurore",
    title: "Porter",
    slug: "lunes-laurore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheldon D.",
    lastName: "Laury",
    title: "Senior Web Systems Manager",
    slug: "sheldon-d-laury",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicole Ann",
    lastName: "Lavacchia",
    title: "Coordinator",
    slug: "nicole-ann-lavacchia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew Luke",
    lastName: "LaVenia",
    title: "Senior Associate Director, Admissions Operations",
    slug: "andrew-luke-lavenia",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Benjamin Frederick",
    lastName: "Laviana",
    title: "Assistant Director, Graduate Admissions",
    slug: "benjamin-frederick-laviana",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marui",
    lastName: "Lavinder",
    title: "Administrative Assistant, Alumni Engagement",
    slug: "marui-lavinder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael G.",
    lastName: "Law",
    title: "Sr. Application Systems Developer",
    slug: "michael-g-law",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher L",
    lastName: "Law",
    title: "Financial and Operations Coordinator",
    slug: "christopher-l-law",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cynthia W",
    lastName: "Law",
    title: "Project Manager",
    slug: "cynthia-w-law",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Suesan",
    lastName: "Law-Faison",
    title: "Manager, Procurement",
    slug: "suesan-law-faison",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine M",
    lastName: "Lawin",
    title: "Project Manager",
    slug: "katherine-m-lawin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia Corbeau",
    lastName: "Lawrence",
    title: "LCDS Lab Manager",
    slug: "olivia-corbeau-lawrence",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lindsay",
    lastName: "Lawrence",
    title: "Academic Affairs Coordinator",
    slug: "lindsay-lawrence",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanda Asaro",
    lastName: "Lawrence",
    title: "Grants Administrator",
    slug: "amanda-asaro-lawrence",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Graziella",
    lastName: "Layouss",
    title: "Director, Applications Architecture",
    slug: "graziella-layouss",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Phuc Hoang",
    lastName: "Le",
    title: "Digital Architect",
    slug: "phuc-hoang-le",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Minh Dac",
    lastName: "Le",
    title: "Principal Instructional Design",
    slug: "minh-dac-le",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hien T",
    lastName: "Le",
    title:
      " Program Manager for the Vietnam Executive Leadership Program (VELP)",
    slug: "hien-t-le",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patrice M",
    lastName: "Le Melle",
    title: "Associate General Counsel",
    slug: "patrice-m-le-melle",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Rebecca",
    lastName: "Leaman",
    title: "Project Officer, Global Programming",
    slug: "rebecca-leaman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Quinn D",
    lastName: "Lebowitz",
    title: "Program Manager",
    slug: "quinn-d-lebowitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie R.",
    lastName: "LeBrecht",
    title: "Residency Services Coordinator",
    slug: "natalie-r-lebrecht",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Crisne",
    lastName: "Lebron",
    title: "Leadership Gift Officer I",
    slug: "crisne-lebron",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paul",
    lastName: "LeClerc",
    title: "Director, Global Centers Paris",
    slug: "paul-leclerc",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katie Rachel",
    lastName: "Ledwell",
    title: "Director of Academic Affairs Compliance",
    slug: "katie-rachel-ledwell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Susan G.",
    lastName: "Lee",
    title: "Senior Director of Event Management",
    slug: "susan-g-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sophie",
    lastName: "Lee",
    title: "Assistant Director, International Financial Operations",
    slug: "sophie-lee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah",
    lastName: "Lee",
    title: "Audit Manager",
    slug: "sarah-lee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sean",
    lastName: "Lee",
    title: "Chief Technology Officer, IMC",
    slug: "sean-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sharon",
    lastName: "Lee",
    title: "Associate Director; Benefits Accounting",
    slug: "sharon-lee",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Shurin",
    lastName: "Lee",
    title: "Associate Director of Strategy and Operations",
    slug: "shurin-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sally",
    lastName: "Lee",
    title: "Editor-in-Chief, Columbia Magazine",
    slug: "sally-lee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shi Yee",
    lastName: "Lee",
    title: "Director of Finance and Administration",
    slug: "shi-yee-lee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle",
    lastName: "Lee",
    title: "Lab-to-Market (L2M) Alliance Associate",
    slug: "michelle-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Milenda",
    lastName: "Lee",
    title: "Senior Designer",
    slug: "milenda-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chae Rin",
    lastName: "Lee",
    title: "Instructional Designer",
    slug: "chae-rin-lee",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Larry",
    lastName: "Lee",
    title: "Director, Information Technology Risk Management",
    slug: "larry-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kara Ting Ting",
    lastName: "Lee",
    title: "Grants Manager",
    slug: "kara-ting-ting-lee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katie",
    lastName: "Lee",
    title: "Director of Human Resources",
    slug: "katie-lee",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kyu",
    lastName: "Lee",
    title: "Director of Communications and Digital Media",
    slug: "kyu-lee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Junie",
    lastName: "Lee",
    title: "Director of Creative Services",
    slug: "junie-lee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jenny Elizabeth",
    lastName: "Lee",
    title: "Division Administrator",
    slug: "jenny-elizabeth-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Lee",
    title:
      " Assistant Director, International Student Professional Development Programming",
    slug: "james-lee",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Lee",
    title: "Absence Management Manager, HRPC Data Integrity",
    slug: "jessica-lee",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer",
    lastName: "Lee",
    title: "Director, Career Placement, Events & External Relations",
    slug: "jennifer-lee",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jeong",
    lastName: "Lee",
    title: "Associate General Counsel",
    slug: "jeong-lee",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jessica L",
    lastName: "Lee",
    title: "Director of Selection & Outreach",
    slug: "jessica-l-lee",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Heather Anne",
    lastName: "Lee",
    title: "Associate Director, Events & Sales",
    slug: "heather-anne-lee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Henry K.",
    lastName: "Lee",
    title: "Exec Director - Fin & Altycs",
    slug: "henry-k-lee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Grace",
    lastName: "Lee",
    title: "Director, Strategic Financial Planning and Analysis",
    slug: "grace-lee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Fuk Keung",
    lastName: "Lee",
    title: "Senior Service Specialist",
    slug: "fuk-keung-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fen",
    lastName: "Lee",
    title: "Exec Director, Clin Bus Dev",
    slug: "fen-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eun Ja",
    lastName: "Lee",
    title: "Circulation, Reserves",
    slug: "eun-ja-lee",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dalton James",
    lastName: "Lee",
    title: "Manager, CRM Systems & AI",
    slug: "dalton-james-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher P.",
    lastName: "Lee",
    title: "Senior HR Business Partner",
    slug: "christopher-p-lee",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Chang Jae",
    lastName: "Lee",
    title: "Senior Designer",
    slug: "chang-jae-lee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Benjamin",
    lastName: "Lee",
    title: "Assistant Director",
    slug: "benjamin-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angie N.",
    lastName: "Lee",
    title: "Director of Learning Platforms and Innovation",
    slug: "angie-n-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Arleen Maritza",
    lastName: "Lee",
    title: "Grants Manager",
    slug: "arleen-maritza-lee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Audrey",
    lastName: "Lee",
    title: "Online Student Services Coordinator",
    slug: "audrey-lee",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ae Ri",
    lastName: "Lee",
    title: "Anltcs Bus Intel&Anltcs Anlst",
    slug: "ae-ri-lee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Angie",
    lastName: "Lee",
    title: "Administrative Coordinator",
    slug: "angie-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angela E.",
    lastName: "Lee",
    title: "Senior Associate Director",
    slug: "angela-e-lee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jenna",
    lastName: "Lefkowitz",
    title: "Admissions Specialist",
    slug: "jenna-lefkowitz",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Roger",
    lastName: "Lefort",
    title: "Assistant Director for Research Integrity and Compliance",
    slug: "roger-lefort",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Erica",
    lastName: "Legagneur",
    title: "Financial Coordinator",
    slug: "erica-legagneur",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph O.",
    lastName: "Legaspi",
    title: "Administrative Assistant",
    slug: "joseph-o-legaspi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalie N",
    lastName: "Legerton",
    title: "Revenue Cycle Rep 1",
    slug: "natalie-n-legerton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Arielle B",
    lastName: "Lehman",
    title: "Collaborator",
    slug: "arielle-b-lehman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexandra J.",
    lastName: "Lehoczki",
    title: "Financial Coordinator",
    slug: "alexandra-j-lehoczki",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ivy",
    lastName: "Lei",
    title: "Administrative Coordinator",
    slug: "ivy-lei",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaime Celina",
    lastName: "Leifer",
    title: "Publisher",
    slug: "jaime-celina-leifer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alyson Marie",
    lastName: "Lelina",
    title: "Assistant Director, Alumni Clubs",
    slug: "alyson-marie-lelina",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anthony",
    lastName: "Lella",
    title: "Manager, Building Operations",
    slug: "anthony-lella",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Taisha E",
    lastName: "Lembert",
    title: "Admin Mngr, R&T Programs",
    slug: "taisha-e-lembert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patrick C",
    lastName: "Lembo",
    title: "Director, Finance/Operations",
    slug: "patrick-c-lembo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Seble",
    lastName: "Lemma",
    title: "Sr Assoc Director - Donor Rel",
    slug: "seble-lemma",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kharis Shekinah",
    lastName: "Lena",
    title: "Assistant Director, Admissions",
    slug: "kharis-shekinah-lena",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mark T.",
    lastName: "Leneker",
    title: "Operations Specialist",
    slug: "mark-t-leneker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David Kent",
    lastName: "Lennington",
    title: "Post Certificate Teaching Associate",
    slug: "david-kent-lennington",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren E",
    lastName: "Lentz",
    title: "Lab Manager, Cytogenic/FISH",
    slug: "lauren-e-lentz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas R",
    lastName: "Leo",
    title: "Advising Dean",
    slug: "thomas-r-leo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lucia",
    lastName: "Leon",
    title: "Benefits Manager",
    slug: "lucia-leon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Katherine",
    lastName: "Leon",
    title: "Administrative Coordinator",
    slug: "katherine-leon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine A.",
    lastName: "Leon",
    title: "Senior Project Officer",
    slug: "katherine-a-leon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Clara N.",
    lastName: "Leon",
    title: "Dir, OSDIB Office/Programs",
    slug: "clara-n-leon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ines",
    lastName: "Leon Mora",
    title: "CMA",
    slug: "ines-leon-mora",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samantha Ann",
    lastName: "Leonard",
    title: "Study Coordinator",
    slug: "samantha-ann-leonard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacqueline",
    lastName: "Lerescu",
    title: "Associate Director of Stewardship",
    slug: "jacqueline-lerescu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yovanka",
    lastName: "Leroux",
    title: "Education Support Specialist I",
    slug: "yovanka-leroux",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jazmin Patrice",
    lastName: "Lesane",
    title: "Associate Director, Employer and Alumni Relations",
    slug: "jazmin-patrice-lesane",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nancy Louise",
    lastName: "Lesko",
    title: "Executive Editor for the TC Record",
    slug: "nancy-louise-lesko",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jamie L.",
    lastName: "Leskowitz",
    title: "Health Educator",
    slug: "jamie-l-leskowitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cynthia K.",
    lastName: "Leslie",
    title: "Executive Assistant",
    slug: "cynthia-k-leslie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alice M",
    lastName: "Lesman",
    title: "Dir, Information & Referral",
    slug: "alice-m-lesman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alison Kathleen",
    lastName: "Lester",
    title: "Development Associate",
    slug: "alison-kathleen-lester",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Winnie",
    lastName: "Leung",
    title: "Coordinator",
    slug: "winnie-leung",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sara Michelle",
    lastName: "Leupp",
    title: "Executive Director, Benefits",
    slug: "sara-michelle-leupp",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Claire S",
    lastName: "Levenson",
    title: "Director, Executive Communications",
    slug: "claire-s-levenson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Philip",
    lastName: "Leventhal",
    title: "Executive Editor",
    slug: "philip-leventhal",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Langley Victoria",
    lastName: "Leverett",
    title: "Editorial & Content Strategist",
    slug: "langley-victoria-leverett",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Johanna",
    lastName: "Levey",
    title: "Assistant Director, Student Engagement",
    slug: "johanna-levey",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mark",
    lastName: "Levine",
    title: "Drama Therapist",
    slug: "mark-levine",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diana A.",
    lastName: "Levine",
    title: "Director, Alumni Career Management",
    slug: "diana-a-levine",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mindi Erin",
    lastName: "Levinson",
    title: "Director of Career Management",
    slug: "mindi-erin-levinson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Genise M.",
    lastName: "Levius",
    title: "Tech A",
    slug: "genise-m-levius",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Thierry S",
    lastName: "Levy",
    title: "Senior Service Specialist",
    slug: "thierry-s-levy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maryann",
    lastName: "Levy",
    title: "Administrative Assistant",
    slug: "maryann-levy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren Dana",
    lastName: "Levy",
    title: "Associate Director for Academic Counseling & Student Support",
    slug: "lauren-dana-levy",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dror",
    lastName: "Levy",
    title: "Associate Director of Finance and Operations",
    slug: "dror-levy",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kim Y.",
    lastName: "Lew",
    title:
      " President and Chief Executive Officer of the Investment Management Company and Vice President for Investments of the University",
    slug: "kim-y-lew",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sophia Samantha",
    lastName: "Lewis",
    title: "Director of Development",
    slug: "sophia-samantha-lewis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shazel",
    lastName: "Lewis",
    title: "Social Worker",
    slug: "shazel-lewis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannel",
    lastName: "Lewis",
    title: "Senior Project Officer",
    slug: "shannel-lewis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter",
    lastName: "Lewis",
    title: "Digital Media Developer",
    slug: "peter-lewis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Phillip A",
    lastName: "Lewis",
    title: "Revenue Cycle Rep I",
    slug: "phillip-a-lewis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marva",
    lastName: "Lewis",
    title: "Associate Director Human Resources",
    slug: "marva-lewis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lauren S.",
    lastName: "Lewis",
    title: "Senior Associate Director, Data Management",
    slug: "lauren-s-lewis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katherine K.",
    lastName: "Lewis",
    title: "Director, Human Resources Operations",
    slug: "katherine-k-lewis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kathryn M.",
    lastName: "Lewis",
    title: "Executive Director, Columbia College Human Resources",
    slug: "kathryn-m-lewis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jasmine N.",
    lastName: "Lewis",
    title: "Business Operations Officer",
    slug: "jasmine-n-lewis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charlene L",
    lastName: "Lewis",
    title: "Assistant Director, Student Engagement",
    slug: "charlene-l-lewis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Annabelle",
    lastName: "Lewis",
    title: "Admissions Specialist",
    slug: "annabelle-lewis",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Arthur E.",
    lastName: "Lewis",
    title: "Associate Director, Admissions Operations & Technology",
    slug: "arthur-e-lewis",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tenzin",
    lastName: "Lhakhang",
    title: "Computational Research Lab Mgr",
    slug: "tenzin-lhakhang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jiaqi",
    lastName: "Li",
    title: "Academic and Student Affairs Coordinator",
    slug: "jiaqi-li",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sina Hui",
    lastName: "Li",
    title: "Department Administrator",
    slug: "sina-hui-li",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter",
    lastName: "Li",
    title: "Service Specialist",
    slug: "peter-li",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lexie",
    lastName: "Li",
    title: "Interim Employee",
    slug: "lexie-li",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lucia P",
    lastName: "Li",
    title: "Asst Dir, Academic Programs",
    slug: "lucia-p-li",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joann G.",
    lastName: "Li",
    title: "Department Administrator/CFO",
    slug: "joann-g-li",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jie",
    lastName: "Li",
    title: "Senior Assistant Dean of Academic Affairs",
    slug: "jie-li",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jing",
    lastName: "Li",
    title: "Grants Officer",
    slug: "jing-li",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hongying",
    lastName: "Li",
    title: "Senior Program Manager, Interdisciplinary Engagement",
    slug: "hongying-li",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diana Hsiaohong",
    lastName: "Li",
    title: "Associate Director of Education and Training Initiatives",
    slug: "diana-hsiaohong-li",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chenchen",
    lastName: "Li",
    title: "PT Interim RA: Econ Program",
    slug: "chenchen-li",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Suet",
    lastName: "Liang",
    title: "Financial Assistant",
    slug: "suet-liang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kurtis",
    lastName: "Liang",
    title: "Associate Director, Information Systems",
    slug: "kurtis-liang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John Yingbin",
    lastName: "Liang",
    title: "Director, Operational Risk-Investment Management Company",
    slug: "john-yingbin-liang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Douglas",
    lastName: "Liang",
    title: "Center Financial Administrator",
    slug: "douglas-liang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Steven",
    lastName: "Liao",
    title: "Lead Application Systems Develop",
    slug: "steven-liao",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yira",
    lastName: "Liberata",
    title: "Payroll Coordinator",
    slug: "yira-liberata",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Madeline K.",
    lastName: "Liberato",
    title: "Financial Aid Coordinator",
    slug: "madeline-k-liberato",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David P",
    lastName: "Licata",
    title: "Multimedia Specialist",
    slug: "david-p-licata",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laura A.",
    lastName: "Lichtblau",
    title: "Finance and Grants Manager",
    slug: "laura-a-lichtblau",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ryan D",
    lastName: "Lichtcsien",
    title: "Department Administrator/CAO",
    slug: "ryan-d-lichtcsien",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kendra",
    lastName: "Lider-Johnson",
    title: "Director, Marketing and Communications",
    slug: "kendra-lider-johnson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rebecca Flynn",
    lastName: "Liebendorfer",
    title: "IRB Specialist",
    slug: "rebecca-flynn-liebendorfer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer S",
    lastName: "Lieberman",
    title: "Grants Administrator",
    slug: "jennifer-s-lieberman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brandon P",
    lastName: "Lieff",
    title: "Manager of Operations",
    slug: "brandon-p-lieff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hannah",
    lastName: "Lienert",
    title: "Strategic Events Assistant",
    slug: "hannah-lienert",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David",
    lastName: "Lieu",
    title: "Associate Director, Financial Operations Compliance",
    slug: "david-lieu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vy Tuong Vy",
    lastName: "Lieu",
    title: "Senior Field Experience Logistics Manager",
    slug: "vy-tuong-vy-lieu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Lilien",
    title: "Director of Decanal Affairs",
    slug: "jessica-lilien",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pat",
    lastName: "Lilly",
    title: "Assistant Director",
    slug: "pat-lilly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Soo Sing",
    lastName: "Lim",
    title: "Deputy Director, Gift Systems",
    slug: "soo-sing-lim",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Narae",
    lastName: "Lim",
    title: "Associate Director of Undergraduate Career Development",
    slug: "narae-lim",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maribel",
    lastName: "Lim",
    title: "Chief of Staff",
    slug: "maribel-lim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rafael Mesquita De Souza",
    lastName: "Lima",
    title: "Seminar Associate",
    slug: "rafael-mesquita-de-souza-lima",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nina Rosa",
    lastName: "Limongelli",
    title:
      " Special Assistant, Associate Dean for Communications Strategy, Development and Alumni Affairs",
    slug: "nina-rosa-limongelli",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Xuan",
    lastName: "Lin",
    title: "Asst Director - Marketing,Tech",
    slug: "xuan-lin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mandy",
    lastName: "Lin",
    title: "Sr Mgr, Ops&Strat Initiatives",
    slug: "mandy-lin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lan",
    lastName: "Lin",
    title: "Snr Qual Assurance Specialist",
    slug: "lan-lin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kathryn Maria",
    lastName: "Lin",
    title: "Admissions Coordinator",
    slug: "kathryn-maria-lin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kevin",
    lastName: "Lin",
    title: "Director, HR Operations & Data",
    slug: "kevin-lin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bryan Julius",
    lastName: "Lin",
    title: "Artistic Administrator",
    slug: "bryan-julius-lin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bee-ca",
    lastName: "Lin",
    title: "Business Officer",
    slug: "bee-ca-lin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alan",
    lastName: "Lin",
    title: "Assistant Director of Budget and Finance",
    slug: "alan-lin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Antony",
    lastName: "Lin",
    title: "Admissions Operations Assistant (Document Management)",
    slug: "antony-lin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Anthony",
    lastName: "Lin",
    title: "Director, Operations",
    slug: "anthony-lin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isabel Rosie",
    lastName: "Linacre",
    title: "CPRE Associate Researcher",
    slug: "isabel-rosie-linacre",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Janean",
    lastName: "Linares",
    title: "Senior Operations Manager",
    slug: "janean-linares",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric",
    lastName: "Linares",
    title: "Revenue Cycle Rep II",
    slug: "eric-linares",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laura E",
    lastName: "Lincks",
    title: "Database Developer",
    slug: "laura-e-lincks",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chloe Isabella",
    lastName: "Lincoln",
    title: "Research Consultant",
    slug: "chloe-isabella-lincoln",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lorrie A.",
    lastName: "Lind",
    title: "Coordinator",
    slug: "lorrie-a-lind",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "James C.",
    lastName: "Lindner",
    title: "Associate Vice President-HRIS",
    slug: "james-c-lindner",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Isabella S",
    lastName: "Lindsay",
    title: "Special Project Assistant",
    slug: "isabella-s-lindsay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Errol F",
    lastName: "Lindsay",
    title: "Sr Application Systems Develop",
    slug: "errol-f-lindsay",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laurel F",
    lastName: "Linekin",
    title: "Administrative Coordinator",
    slug: "laurel-f-linekin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neil T",
    lastName: "Link",
    title: "Sr Product and Support Manager",
    slug: "neil-t-link",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amelie",
    lastName: "Lipman",
    title: "Assistant Director, Development Research",
    slug: "amelie-lipman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rachel M.",
    lastName: "Lippolis",
    title: "Event Manager",
    slug: "rachel-m-lippolis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan J.",
    lastName: "Lipschitz",
    title: "Director, Satellite Operations",
    slug: "susan-j-lipschitz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maya P.",
    lastName: "Lipsman",
    title: "Senior Project Coordinator",
    slug: "maya-p-lipsman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan E",
    lastName: "Liquori",
    title: "Director, Accounting",
    slug: "susan-e-liquori",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Carlos I.",
    lastName: "Lira-Coppo",
    title: "Assistant Director, NRA Processing",
    slug: "carlos-i-lira-coppo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Katherine A",
    lastName: "Liranzo",
    title: "Data Coordinator II",
    slug: "katherine-a-liranzo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Luis",
    lastName: "Liriano",
    title: "SYEP",
    slug: "luis-liriano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathleen",
    lastName: "Liriano",
    title: "Recruitment Admin. Asst.",
    slug: "kathleen-liriano",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jesenia M",
    lastName: "Liriano",
    title: "Asst Director, Portfolio Mgmt",
    slug: "jesenia-m-liriano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charles",
    lastName: "Liriano",
    title: "Director, Financial Aid",
    slug: "charles-liriano",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sarah Caroline",
    lastName: "Lis",
    title: "Director of Academic Human Resources",
    slug: "sarah-caroline-lis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alyssa Rose",
    lastName: "LiSanti",
    title: "Associate Director, University Programs and Events",
    slug: "alyssa-rose-lisanti",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jackie Noel",
    lastName: "Lisch",
    title: "Finance and Compliance Manager, Sponsored Projects Finance",
    slug: "jackie-noel-lisch",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sabine",
    lastName: "Lissain",
    title: "Program Manager",
    slug: "sabine-lissain",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Litchfield",
    title: "Gallery Attendant",
    slug: "stephanie-litchfield",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shantelle M",
    lastName: "Little",
    title: "Enrollment&Operations Manager",
    slug: "shantelle-m-little",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Faith",
    lastName: "Little",
    title: "Initiative Director, 21st Century Learning",
    slug: "faith-little",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael Tarrell",
    lastName: "Littlejohn",
    title: "Assistant Dean for Student Life",
    slug: "michael-tarrell-littlejohn",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Audrey M. F.",
    lastName: "Litvak",
    title: "Asst Director-Government Affrs",
    slug: "audrey-m-f-litvak",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yuliya",
    lastName: "Litvinova",
    title: "Billing Compliance Asst",
    slug: "yuliya-litvinova",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yu-Lin",
    lastName: "Liu",
    title: "Junior IT Consultant (Physics)",
    slug: "yu-lin-liu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ying",
    lastName: "Liu",
    title: "Director of Software Development and Analytics",
    slug: "ying-liu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yue",
    lastName: "Liu",
    title: "Assistant Director",
    slug: "yue-liu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tianyi",
    lastName: "Liu",
    title: "Collaborator",
    slug: "tianyi-liu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shirley",
    lastName: "Liu",
    title: "Associate Drupal Developer",
    slug: "shirley-liu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Qi Fen",
    lastName: "Liu",
    title: "Associate Director, Audit & Review",
    slug: "qi-fen-liu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Qiaolian",
    lastName: "Liu",
    title: "Officer-Science",
    slug: "qiaolian-liu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessie",
    lastName: "Liu",
    title: "Administrative Coordinator",
    slug: "jessie-liu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace Ge",
    lastName: "Liu",
    title: "Data Manager",
    slug: "grace-ge-liu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ang",
    lastName: "Liu",
    title: "High School Assistant",
    slug: "ang-liu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Luisanne",
    lastName: "Liz",
    title: "Associate Director",
    slug: "luisanne-liz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley Michelle",
    lastName: "Liz",
    title: "Financial Assistant",
    slug: "ashley-michelle-liz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dior DeVaughn",
    lastName: "Llewellyn",
    title: "User Support Specialist",
    slug: "dior-devaughn-llewellyn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Susan E",
    lastName: "Lloyd",
    title: "Research Director",
    slug: "susan-e-lloyd",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eileen",
    lastName: "Lloyd",
    title: "Mgr, Admissions & Admin Svcs",
    slug: "eileen-lloyd",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Vivian",
    lastName: "Lo",
    title: "Billing Compliance Assistant",
    slug: "vivian-lo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dominique",
    lastName: "Lochard",
    title: "Senior Client Manager",
    slug: "dominique-lochard",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wendy K.",
    lastName: "Lochner",
    title: "Publisher, Philosophy and Religion",
    slug: "wendy-k-lochner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rebecca Jane",
    lastName: "Lock",
    title: "Director, Special Projects",
    slug: "rebecca-jane-lock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sallie",
    lastName: "Locke",
    title: "Development Assistant",
    slug: "sallie-locke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica",
    lastName: "Lockhart",
    title: "Director of Academic Administration and Finance",
    slug: "erica-lockhart",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anna M.",
    lastName: "Lockman",
    title: "Director, Finance & Res Admin",
    slug: "anna-m-lockman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole",
    lastName: "Lockwood",
    title: "Administrative Aide",
    slug: "nicole-lockwood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria",
    lastName: "Lodi",
    title: "University Affiliate - STEAM",
    slug: "victoria-lodi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gaspare S",
    lastName: "LoDuca",
    title:
      " Chief Information Officer and Vice President for Information Technology",
    slug: "gaspare-s-loduca",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julia",
    lastName: "Loewer",
    title: "Assistant Director, Admissions",
    slug: "julia-loewer",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Helena T.",
    lastName: "Logan",
    title: "Administrative Coordinator",
    slug: "helena-t-logan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janet Jun Siew",
    lastName: "Loh",
    title:
      " Associate Director of Multicultural Affairs / Program Director for International at Columbia",
    slug: "janet-jun-siew-loh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sunita",
    lastName: "Lokuge",
    title: "Sr Assoc Director-Career Edu",
    slug: "sunita-lokuge",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Frank J.",
    lastName: "Lombardo",
    title: "Budget Director",
    slug: "frank-j-lombardo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ricardo Orlando",
    lastName: "Lombera",
    title: "Coordinator",
    slug: "ricardo-orlando-lombera",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mathilda Albano",
    lastName: "Lombos",
    title: "Grants and Contracts Manager",
    slug: "mathilda-albano-lombos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sherri Denise",
    lastName: "Long",
    title: "Administrative Clerk",
    slug: "sherri-denise-long",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janna",
    lastName: "Long",
    title: "Senior Business Manager",
    slug: "janna-long",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie Elizabeth",
    lastName: "Loos",
    title: "Communications and Outreach Associate",
    slug: "katie-elizabeth-loos",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yeraldin A",
    lastName: "Lopez",
    title: "HR & FA Generalist",
    slug: "yeraldin-a-lopez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rosalina",
    lastName: "Lopez",
    title: "Org Dev Specialist, Res/Edu",
    slug: "rosalina-lopez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Priscilla S",
    lastName: "Lopez",
    title: "Program Manager",
    slug: "priscilla-s-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Narelle",
    lastName: "Lopez",
    title: "University Affiliate - STEAM",
    slug: "narelle-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noelia",
    lastName: "Lopez",
    title: "Administrative Aide",
    slug: "noelia-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michele Christine",
    lastName: "Lopez",
    title: "HR Manager, Strategic Operations & Employee Experience",
    slug: "michele-christine-lopez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Molly K",
    lastName: "Lopez",
    title:
      " Managing Director, Center for Learning the Earth with Artificial Intelligence & Physics",
    slug: "molly-k-lopez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melissa",
    lastName: "Lopez",
    title: "Assistant Director of Registration Services, Scheduling, and Data",
    slug: "melissa-lopez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lizette L.",
    lastName: "Lopez",
    title: "Senior Student Services Rep",
    slug: "lizette-l-lopez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Johanna E",
    lastName: "Lopez",
    title: "Financial Assistant",
    slug: "johanna-e-lopez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Judelly T",
    lastName: "Lopez",
    title: "Administrative Clerk",
    slug: "judelly-t-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Johana J",
    lastName: "Lopez",
    title: "Scheduler",
    slug: "johana-j-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jordan Georgemanuel",
    lastName: "Lopez",
    title: "Financial Assistant",
    slug: "jordan-georgemanuel-lopez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Graciela",
    lastName: "Lopez",
    title: "MA",
    slug: "graciela-lopez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Edgardo",
    lastName: "Lopez",
    title: "Administrative Assistant",
    slug: "edgardo-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edwin H",
    lastName: "Lopez",
    title: "Director, IT Client Services",
    slug: "edwin-h-lopez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniel Austin",
    lastName: "Lopez",
    title: "Gallery Attendant",
    slug: "daniel-austin-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diana Yvette",
    lastName: "Lopez",
    title: "Assistant Director of Financial Aid",
    slug: "diana-yvette-lopez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Davys",
    lastName: "Lopez",
    title: "Courtesy Extension",
    slug: "davys-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ariana D",
    lastName: "Lopez",
    title: "Research Project Coordinator",
    slug: "ariana-d-lopez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cindy Maite",
    lastName: "Lopez Cedano",
    title: "Financial Assistant",
    slug: "cindy-maite-lopez-cedano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Milagros Johana",
    lastName: "Lopez Gonzalez",
    title: "Accountant - Capital Assets",
    slug: "milagros-johana-lopez-gonzalez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Avelino S",
    lastName: "Loquere Jr",
    title: "Clin Trials Unit Coordinator",
    slug: "avelino-s-loquere-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sergio Gustavo",
    lastName: "Lora",
    title: "Associate Director, Research & Technology",
    slug: "sergio-gustavo-lora",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lilian",
    lastName: "Lora",
    title: "Wait Staff",
    slug: "lilian-lora",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maristella",
    lastName: "Lorch",
    title: "Dir External Rel-Italian Acad",
    slug: "maristella-lorch",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gary A",
    lastName: "Lord",
    title: "Lieutenant",
    slug: "gary-a-lord",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Destiny A.",
    lastName: "Lord",
    title: "Assistant Director of Administration",
    slug: "destiny-a-lord",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lazina A",
    lastName: "Lorick",
    title: "Department Administrator/COO",
    slug: "lazina-a-lorick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dori J",
    lastName: "Lorsch",
    title: "Department Administrator",
    slug: "dori-j-lorsch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "LoTempio",
    title: "Senior Associate Director, Operations",
    slug: "stephanie-lotempio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher Josef",
    lastName: "Lotis",
    title:
      " Associate Director, Development Communications, Zuckerman Institute",
    slug: "christopher-josef-lotis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ruth Ilarah",
    lastName: "Louis",
    title: "IT Technical Assistant",
    slug: "ruth-ilarah-louis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Natalie Suzanne",
    lastName: "Louis",
    title: "Lead Staff Developer",
    slug: "natalie-suzanne-louis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jochebed Angel",
    lastName: "Louis-Jean",
    title: "Senior Program Manager",
    slug: "jochebed-angel-louis-jean",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karyn M.",
    lastName: "Louis-Smith",
    title: "Associate Dean, Financial Planning and Strategy",
    slug: "karyn-m-louis-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Paulette",
    lastName: "Louissaint",
    title: "Senior Coordinator",
    slug: "paulette-louissaint",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tia",
    lastName: "Love",
    title: "Administrative Coordinator",
    slug: "tia-love",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marlon W",
    lastName: "Lowe",
    title: "Senior Director of Husbandry Operations",
    slug: "marlon-w-lowe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Lowry",
    title: "Director of Operations",
    slug: "emily-lowry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Veronika",
    lastName: "Lozina",
    title: "Executive Assistant",
    slug: "veronika-lozina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ivan",
    lastName: "Lozuk",
    title: "Associate Director, Web and Mobile Services",
    slug: "ivan-lozuk",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ye",
    lastName: "Lu",
    title: "Post-Award Grants Manager",
    slug: "ye-lu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samantha",
    lastName: "Lu",
    title: "Director for International Student Services",
    slug: "samantha-lu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mark",
    lastName: "Lu",
    title: "Lead Database ADministrator",
    slug: "mark-lu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jay",
    lastName: "Lu",
    title: "Technical Support Specialist",
    slug: "jay-lu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "James C.",
    lastName: "Lu",
    title: "Manager of Finance and Operations",
    slug: "james-c-lu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dan",
    lastName: "Lu",
    title: "Specialist-FA Systems & Data",
    slug: "dan-lu",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Savannah",
    lastName: "Lucas",
    title: "Program Manager",
    slug: "savannah-lucas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Agustina",
    lastName: "Lucas",
    title: "Asst Director-Ops,Student Svcs",
    slug: "agustina-lucas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Denise",
    lastName: "Luciano",
    title: "Associate Director, HR Systems Training and Change Management",
    slug: "denise-luciano",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joanna",
    lastName: "Luehmann",
    title: "Staff",
    slug: "joanna-luehmann",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Daniel",
    lastName: "Lugo",
    title: "Building Services Coordinator",
    slug: "daniel-lugo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Timothy W.",
    lastName: "Lumley",
    title: "Senior Associate Director of Business Applications",
    slug: "timothy-w-lumley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Luna",
    title: "Sr Service Desk Specialist",
    slug: "jennifer-luna",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Damaris",
    lastName: "Luna",
    title: "Receptionist",
    slug: "damaris-luna",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deya",
    lastName: "Luna",
    title: "Associate Director of Administrative Operations",
    slug: "deya-luna",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Myra",
    lastName: "Luna Lucero",
    title: "Research Compliance Director",
    slug: "myra-luna-lucero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fernando L.",
    lastName: "Luque",
    title: "Project Coordinator II",
    slug: "fernando-l-luque",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lawino S",
    lastName: "Lurum",
    title: "Director-Acad Finance/Admin",
    slug: "lawino-s-lurum",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily E.",
    lastName: "LuShing",
    title: "Instructional Technology Manager",
    slug: "emily-e-lushing",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lindsay Alyssa",
    lastName: "Lutchmidat",
    title: "Human Resources Coordinator",
    slug: "lindsay-alyssa-lutchmidat",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Phong",
    lastName: "Luu",
    title: "Director, Student Support",
    slug: "phong-luu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Anhphan T",
    lastName: "Ly",
    title: "Sr Director, Data & Analytics",
    slug: "anhphan-t-ly",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gregory D.",
    lastName: "Lyle",
    title: "Director, Systems and Infrastructure",
    slug: "gregory-d-lyle",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicole M",
    lastName: "Lyn",
    title: "Departmental Administrator/COO",
    slug: "nicole-m-lyn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew J.",
    lastName: "Lynagh",
    title: "Senior Director of Technology Services and Support",
    slug: "andrew-j-lynagh",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mary Jo",
    lastName: "Lynch",
    title: "Senior HR Business Partner",
    slug: "mary-jo-lynch",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lydia",
    lastName: "Lynch",
    title: "Accounts Payable Specialist",
    slug: "lydia-lynch",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Harley A",
    lastName: "Lynch",
    title: "Asst Director-Traiining & Educ",
    slug: "harley-a-lynch",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Anna C.",
    lastName: "Lynch-McNamara",
    title: "Director of Business Operations",
    slug: "anna-c-lynch-mcnamara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paige",
    lastName: "Lyne",
    title: "Executive Director of Finance",
    slug: "paige-lyne",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth A.",
    lastName: "Lyons",
    title: "Assistant Director of Industry and Festival Outreach",
    slug: "elizabeth-a-lyons",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kelsey",
    lastName: "Ma",
    title: "Coordinator, Alumni Relations",
    slug: "kelsey-ma",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicholas L.",
    lastName: "Maaske",
    title: "Associate Director, Property Operations",
    slug: "nicholas-l-maaske",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "Maass",
    title: "Grant & Research Dev Associate",
    slug: "karen-maass",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lindsay A.",
    lastName: "Macala",
    title: "Director, Product Marketing",
    slug: "lindsay-a-macala",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Colin",
    lastName: "MacAllister",
    title: "Manager, Application Development",
    slug: "colin-macallister",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kathleen A",
    lastName: "MacArthur",
    title: "Senior Administrative Lab Manager",
    slug: "kathleen-a-macarthur",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hannah M.",
    lastName: "MacAskill",
    title: "Executive Assistant to the Dean",
    slug: "hannah-m-macaskill",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kevin",
    lastName: "Macaulay",
    title: "Marketing/Outreach Coordinator",
    slug: "kevin-macaulay",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Aedan Ian",
    lastName: "Macdonald",
    title: "Executive Director",
    slug: "aedan-ian-macdonald",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madeline",
    lastName: "Macey",
    title: "Program Manager",
    slug: "madeline-macey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristopher T",
    lastName: "Machado-Mirasola",
    title: "Sr Human Resources Generalist",
    slug: "kristopher-t-machado-mirasola",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "VenkataRavi Shanker",
    lastName: "Macherla",
    title: "Manager, PeopleSoft HR Application Development",
    slug: "venkataravi-shanker-macherla",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Destiny D",
    lastName: "Machin",
    title:
      " Associate Director of Multicultural Affairs / Program Director for FLI at Columbia",
    slug: "destiny-d-machin",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Tyrek",
    lastName: "Mack",
    title: "Catering Delivery",
    slug: "tyrek-mack",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jermissia",
    lastName: "Mack",
    title: "Diagnostic Imaging Specialist II",
    slug: "jermissia-mack",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Mackenna",
    title: "Industry Relations Specialist, Career Design Lab",
    slug: "maria-mackenna",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sloane",
    lastName: "Macklin",
    title: "Associate Director of Alumni Relations",
    slug: "sloane-macklin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Betsy",
    lastName: "MacLeod",
    title: "Assistant Director, Precision Medicine Initiative",
    slug: "betsy-macleod",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deniz I",
    lastName: "Macleod",
    title: "Business Manager",
    slug: "deniz-i-macleod",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Donna H.",
    lastName: "MacPhee",
    title: "Vice President for Alumni Relations",
    slug: "donna-h-macphee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Vikram R",
    lastName: "Madan",
    title: "Research Program Manager",
    slug: "vikram-r-madan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacqueline E",
    lastName: "Mader",
    title: "Multimedia Editor and Senior Reporter",
    slug: "jacqueline-e-mader",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ann Keohan",
    lastName: "Madigan",
    title: "Director of Finance & Administration",
    slug: "ann-keohan-madigan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anthony",
    lastName: "Madonna",
    title: "Senior Director, Custom Programs",
    slug: "anthony-madonna",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edmund T.",
    lastName: "Madrid",
    title: "Web Designer / Developer",
    slug: "edmund-t-madrid",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anellia",
    lastName: "Maduro",
    title: "Administrative Manager",
    slug: "anellia-maduro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rashi Noam",
    lastName: "Mager Garfield",
    title: "Assistant Manager - Lerner Hall",
    slug: "rashi-noam-mager-garfield",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christopher",
    lastName: "Maggiulli",
    title: "Director, Product Development",
    slug: "christopher-maggiulli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shila",
    lastName: "Maghji",
    title: "Manager, HR and Finance Service Desks",
    slug: "shila-maghji",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Susan Ann",
    lastName: "Magliato",
    title: "Electron Microscopist Speciali",
    slug: "susan-ann-magliato",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cameron",
    lastName: "Maglio",
    title: "Associate Director, Donor Relations and Stewardship",
    slug: "cameron-maglio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Magno",
    title: "Academic Program Support in Professional Studies",
    slug: "christopher-magno",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samuel J",
    lastName: "Magnus",
    title: "Recess Enrichment Facilitator in The School",
    slug: "samuel-j-magnus",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kelly",
    lastName: "Magnus",
    title: "Research Administrator I",
    slug: "kelly-magnus",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sanjay",
    lastName: "Mahajan",
    title: "Assistant Vice President",
    slug: "sanjay-mahajan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Harpreet",
    lastName: "Mahajan",
    title: "Chief Information Officer",
    slug: "harpreet-mahajan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lucy A",
    lastName: "Mahbub",
    title: "Director - Career Placement",
    slug: "lucy-a-mahbub",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Virginia Marie",
    lastName: "Maher",
    title: "Director, Human Resources",
    slug: "virginia-marie-maher",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Steven Brady",
    lastName: "Maher",
    title: "Sponsored Projects Financial Specialist",
    slug: "steven-brady-maher",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laila",
    lastName: "Maher",
    title: "Dean of Student & Alumni Affairs",
    slug: "laila-maher",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bennett E.",
    lastName: "Mahler",
    title: "Administrative Manager",
    slug: "bennett-e-mahler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abigail E",
    lastName: "Mahon",
    title: "Digital Content Sr Associate",
    slug: "abigail-e-mahon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lakshmie",
    lastName: "Mair",
    title: "Generalist, HR/FA",
    slug: "lakshmie-mair",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jose R.",
    lastName: "Maisonet",
    title: "Office Assistant",
    slug: "jose-r-maisonet",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayla J.",
    lastName: "Maiuri",
    title: "Executive Assistant",
    slug: "kayla-j-maiuri",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diana",
    lastName: "Majano",
    title: "Assistant Director, Corporate & Foundation Relations",
    slug: "diana-majano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yasmin",
    lastName: "Majeed",
    title: "Manager of Communications Operations",
    slug: "yasmin-majeed",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Simon",
    lastName: "Mak",
    title: "Classroom Technology Lead",
    slug: "simon-mak",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bashar",
    lastName: "Makhay",
    title: "Director of Communications",
    slug: "bashar-makhay",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elsa MH",
    lastName: "Maki",
    title: "Assistant Director",
    slug: "elsa-mh-maki",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stefanie",
    lastName: "Makinson",
    title: "Asst Director, Res Development",
    slug: "stefanie-makinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna",
    lastName: "Makkar",
    title: "Director of Operations and Analytics",
    slug: "anna-makkar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Valasia",
    lastName: "Makridis",
    title: "Project Coordinator",
    slug: "valasia-makridis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sakina",
    lastName: "Makwana",
    title: "Data Coordinator II",
    slug: "sakina-makwana",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jacqueline",
    lastName: "Malaguti",
    title: "Acct Recv/Claim Edits Spc III",
    slug: "jacqueline-malaguti",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aurna",
    lastName: "Malakar",
    title: "Sr Manager, Finance/Res Admin",
    slug: "aurna-malakar",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Victoria",
    lastName: "Malaney Brown",
    title: "Director of Academic Integrity",
    slug: "victoria-malaney-brown",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Malasaga",
    title: "Director, Advising",
    slug: "sarah-malasaga",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lucy",
    lastName: "Malave",
    title: "Senior Associate Director, Reporting",
    slug: "lucy-malave",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ramon",
    lastName: "Maldonado",
    title: "Report Developer",
    slug: "ramon-maldonado",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "April",
    lastName: "Maldonado-Brazil",
    title: "Administrative Coordinator",
    slug: "april-maldonado-brazil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Qaiser",
    lastName: "Malik",
    title: "IT Manager",
    slug: "qaiser-malik",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Renata",
    lastName: "Malinowski",
    title: "Wait Staff",
    slug: "renata-malinowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel J.",
    lastName: "Malinowski",
    title: "AVP, Finance and Human Resources",
    slug: "daniel-j-malinowski",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vladimir",
    lastName: "Malinsky",
    title: "Manager, High Performance Computing",
    slug: "vladimir-malinsky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brendan M.",
    lastName: "Mallee",
    title: "Associate Dean for Finance, Strategy and Operations",
    slug: "brendan-m-mallee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Diane P.",
    lastName: "Malloy",
    title: "Administrative Assistant",
    slug: "diane-p-malloy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colleen",
    lastName: "Malloy",
    title: "Senior Salesforce Administrator",
    slug: "colleen-malloy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cecilia",
    lastName: "Malm",
    title: "Staff",
    slug: "cecilia-malm",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Nathaniel H.",
    lastName: "Malone",
    title: "Associate Application Developer",
    slug: "nathaniel-h-malone",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa N.",
    lastName: "Malone",
    title: "Administrative Assistant",
    slug: "lisa-n-malone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer L",
    lastName: "Malone",
    title: "Senior Associate Director, Client Services",
    slug: "jennifer-l-malone",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Casey J",
    lastName: "Malone",
    title: "Manager - Academic Programs",
    slug: "casey-j-malone",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lasha",
    lastName: "Mamardashvili",
    title: "Manager, Marine Recruitment and Staffing",
    slug: "lasha-mamardashvili",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Niharika",
    lastName: "Mamillapalli",
    title: "Compliance Core Coordinator",
    slug: "niharika-mamillapalli",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Randal Torres",
    lastName: "Manago",
    title: "Instructional Designer",
    slug: "randal-torres-manago",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark",
    lastName: "Manansala",
    title: "Senior Admissions Counselor",
    slug: "mark-manansala",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Elizabeth",
    lastName: "Manchester",
    title:
      " Senior Associate Director, The Eric H. Holder Jr. Initiative for Civil and Political Rights",
    slug: "elizabeth-manchester",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nikhil",
    lastName: "Manda",
    title: "Application Systems Developer",
    slug: "nikhil-manda",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eddie",
    lastName: "Mandhry",
    title: "Director, Sports AI Innovation Center",
    slug: "eddie-mandhry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rawan",
    lastName: "Mandwee",
    title: "Donor Relations Coordinator",
    slug: "rawan-mandwee",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Noreen A.",
    lastName: "Mangan",
    title: "Director of Administration",
    slug: "noreen-a-mangan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth R",
    lastName: "Mangan",
    title: "Assistant Director of Student Engagement",
    slug: "elizabeth-r-mangan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rino",
    lastName: "Mangiapili",
    title: "Event Technology Lead",
    slug: "rino-mangiapili",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christine M",
    lastName: "Mangle",
    title: "Sr Director Edu Admin Ops",
    slug: "christine-m-mangle",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexander J",
    lastName: "Mangone",
    title: "Assoc Director, Gnts Mgt Off",
    slug: "alexander-j-mangone",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anthony J.",
    lastName: "Mangone",
    title: "Assistant Director, Broadcast and Multimedia Technology",
    slug: "anthony-j-mangone",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vyjayanthi",
    lastName: "Manian",
    title: "Senior Associate Director, MS Career Management",
    slug: "vyjayanthi-manian",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Agostina",
    lastName: "Mannara",
    title: "Lab Manager",
    slug: "agostina-mannara",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julia M",
    lastName: "Mannes",
    title: "Program Manager, Undergraduate Education Programs",
    slug: "julia-m-mannes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brandon Cornelius",
    lastName: "Manning",
    title: "Senior Associate Director, Advising and Academic Success",
    slug: "brandon-cornelius-manning",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicholas N.",
    lastName: "Mannino",
    title: "Assistant Director, Alumni Engagement",
    slug: "nicholas-n-mannino",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Julia S.",
    lastName: "Manoharan",
    title: "Director of Lab Strategy and Operations",
    slug: "julia-s-manoharan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alice Claude-Dorothy",
    lastName: "Manos",
    title: "Associate Director of Social Media and Content",
    slug: "alice-claude-dorothy-manos",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Menlee",
    lastName: "Mansue",
    title: "Executive Director",
    slug: "menlee-mansue",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vishal B",
    lastName: "Manve",
    title: "Project Coordinator",
    slug: "vishal-b-manve",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Venessa G",
    lastName: "Manzano",
    title: "Senior Director, Development",
    slug: "venessa-g-manzano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren M.",
    lastName: "Manzino",
    title: "Assistant Dean of Advising",
    slug: "lauren-m-manzino",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yvette",
    lastName: "Mapp",
    title: "Billing Compliance Specialist",
    slug: "yvette-mapp",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Khatera",
    lastName: "Maqsudi",
    title: "Senior Program Manager",
    slug: "khatera-maqsudi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gabrielle Charlene",
    lastName: "Maraj",
    title: "Assistant Director of Operations, Gift Systems",
    slug: "gabrielle-charlene-maraj",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maribel",
    lastName: "Marcano-Longi",
    title: "Associate Director, FWS and I-9",
    slug: "maribel-marcano-longi",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer A.",
    lastName: "March",
    title: "Assoc Director",
    slug: "jennifer-a-march",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anne M.",
    lastName: "Marchbanks",
    title: "Administrative Aide",
    slug: "anne-m-marchbanks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel James",
    lastName: "Marcheschi Jr",
    title: "Business Services Officer, Centers and Programs",
    slug: "daniel-james-marcheschi-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna Josephine",
    lastName: "Marchese",
    title: "Senior Project Officer",
    slug: "anna-josephine-marchese",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Marco",
    title: "Assistant Manager - UEM Conference Services",
    slug: "christopher-marco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dianne Doris",
    lastName: "Marcucci-Sadnytzky",
    title: "Director of Academic Administration",
    slug: "dianne-doris-marcucci-sadnytzky",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica",
    lastName: "Marcus",
    title: "Senior Production Manager",
    slug: "jessica-marcus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josephine",
    lastName: "Marescot",
    title: "Leadership Gift Officer II",
    slug: "josephine-marescot",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Mariathas",
    title: "Project Manager",
    slug: "jessica-mariathas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emi",
    lastName: "Marica",
    title: "Senior Administrative Manager",
    slug: "emi-marica",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Raquel",
    lastName: "Marin",
    title: "AVP,Int Cntrls Compl,Dep Cntlr",
    slug: "raquel-marin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Oscar S.",
    lastName: "Marin",
    title: "Piano Tuner",
    slug: "oscar-s-marin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lourdes Teresa",
    lastName: "Marin",
    title: "Payroll Administrator",
    slug: "lourdes-teresa-marin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Claudia",
    lastName: "Marin Andrade",
    title: "Associate Vice President for Student Success and Intervention",
    slug: "claudia-marin-andrade",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica L.",
    lastName: "Marinaccio",
    title: "Dean of Undergraduate Admissions & Financial Aid",
    slug: "jessica-l-marinaccio",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ramon L.",
    lastName: "Marino",
    title: "Financial Associate",
    slug: "ramon-l-marino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michael D",
    lastName: "Marino",
    title: "Director, Class Giving",
    slug: "michael-d-marino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laurena",
    lastName: "Marji",
    title: "Coordinator, Pre-College",
    slug: "laurena-marji",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rose",
    lastName: "Mark",
    title: "Administrative Coordinator",
    slug: "rose-mark",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keshia L.",
    lastName: "Mark",
    title: "Senior Associate Director, Public Relations",
    slug: "keshia-l-mark",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Carrie",
    lastName: "Marlin",
    title: "Senior Associate Provost for Administration and Planning",
    slug: "carrie-marlin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sonnia M.",
    lastName: "Marmol",
    title: "Coding Coordinator",
    slug: "sonnia-m-marmol",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rafaelina",
    lastName: "Marmol",
    title: "Associate Director of Business Services",
    slug: "rafaelina-marmol",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Irene",
    lastName: "Maropakis",
    title: "Assistant Director, Financial Management",
    slug: "irene-maropakis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole A",
    lastName: "Marotta",
    title: "Administrative Coordinator",
    slug: "nicole-a-marotta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Marquez",
    title: "Associate Director of Learning Platforms",
    slug: "emily-marquez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bibiana G.",
    lastName: "Marquez",
    title: "Division Administrator",
    slug: "bibiana-g-marquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erika",
    lastName: "Marrero",
    title: "Program Manager",
    slug: "erika-marrero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chayra N.",
    lastName: "Marrero",
    title: "Program Support Specialist I",
    slug: "chayra-n-marrero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susanne",
    lastName: "Marrone Reda",
    title: "Administrator",
    slug: "susanne-marrone-reda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luz M",
    lastName: "Marroquin Nunez",
    title: "Operations Manager, Online and Digital Programs",
    slug: "luz-m-marroquin-nunez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Roberto",
    lastName: "Marsach Jr",
    title: "Manager of Information Technology",
    slug: "roberto-marsach-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wesley D",
    lastName: "Marsh",
    title: "Recruitment Coordinator",
    slug: "wesley-d-marsh",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rachel",
    lastName: "Marsh",
    title: "Administrator",
    slug: "rachel-marsh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kala M.",
    lastName: "Marsh",
    title: "Director, Parent Fundraising",
    slug: "kala-m-marsh",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Justin Rajid",
    lastName: "Marshall",
    title: "Dir, Information Technology",
    slug: "justin-rajid-marshall",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Catherine Anne",
    lastName: "Marshall",
    title: "Director of Campaign and Major Gifts and Developmental Operations",
    slug: "catherine-anne-marshall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victor",
    lastName: "Marte",
    title: "Transcriptionist",
    slug: "victor-marte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jose",
    lastName: "Marte",
    title: "Associate Registrar for Operations",
    slug: "jose-marte",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ilka",
    lastName: "Marte",
    title: "Executive Asst To Dean",
    slug: "ilka-marte",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Arianny Veronica",
    lastName: "Marte German",
    title: "Wait Staff",
    slug: "arianny-veronica-marte-german",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathy M.",
    lastName: "Marte-Garcia",
    title: "Director of Finance and Administration",
    slug: "kathy-m-marte-garcia",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mayra",
    lastName: "Marte-Miraz",
    title: "Senior Director, HR/FA & Ops",
    slug: "mayra-marte-miraz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gloria",
    lastName: "Martel",
    title: "Ophthalmic Technican",
    slug: "gloria-martel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna R",
    lastName: "Marti",
    title: "Admissions Officer",
    slug: "anna-r-marti",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Miranda E",
    lastName: "Martin",
    title: "Senior Editor",
    slug: "miranda-e-martin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kamesha Kerry-Ann",
    lastName: "Martin",
    title: "Program Manager",
    slug: "kamesha-kerry-ann-martin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric D",
    lastName: "Martin",
    title:
      " Associate Director of Multicultural Affairs / Program Director for LGBTQ@Columbia",
    slug: "eric-d-martin",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "David J.",
    lastName: "Martin",
    title: "General Manager",
    slug: "david-j-martin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alyson R.",
    lastName: "Martin",
    title: "Editor - Columbia News Service",
    slug: "alyson-r-martin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Arthur",
    lastName: "Martin",
    title: "Assistant Director, Third Party Billing and Collections",
    slug: "arthur-martin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Angela Maria",
    lastName: "Martin",
    title: "Administrative Assistant",
    slug: "angela-maria-martin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marty Oliver",
    lastName: "Martineau",
    title: "Assistant Director, Academic Records",
    slug: "marty-oliver-martineau",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yorkis J",
    lastName: "Martinez",
    title: "Desktop Manager",
    slug: "yorkis-j-martinez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yokasta E.",
    lastName: "Martinez",
    title: "Wait Staff",
    slug: "yokasta-e-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Viviana",
    lastName: "Martinez",
    title: "PSR Floater",
    slug: "viviana-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samuel",
    lastName: "Martinez",
    title: "Coding and Charge Edits Specialist II",
    slug: "samuel-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rocio E.",
    lastName: "Martinez",
    title: "Assistant Director",
    slug: "rocio-e-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia",
    lastName: "Martinez",
    title: "Manager-Catering Operations",
    slug: "patricia-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nathalie Amber",
    lastName: "Martinez",
    title: "Assistant Manager - Housing",
    slug: "nathalie-amber-martinez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nastasia",
    lastName: "Martinez",
    title: "Authorization Representative",
    slug: "nastasia-martinez",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Marcia",
    lastName: "Martinez",
    title: "Security Coordinator",
    slug: "marcia-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lydia",
    lastName: "Martinez",
    title: "Administrative Coordinator",
    slug: "lydia-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacqueline",
    lastName: "Martinez",
    title: "Director Academic Affairs",
    slug: "jacqueline-martinez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joan Jose",
    lastName: "Martinez",
    title: "Sr. Technology Licensing Officer",
    slug: "joan-jose-martinez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jose L.",
    lastName: "Martinez",
    title: "Office Assistant",
    slug: "jose-l-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fernanda",
    lastName: "Martinez",
    title: "Associate Director of Inclusive Programs",
    slug: "fernanda-martinez",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Danessa",
    lastName: "Martinez",
    title: "Administrative Aide",
    slug: "danessa-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dianilka D",
    lastName: "Martinez",
    title: "Program Manager",
    slug: "dianilka-d-martinez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carol I.",
    lastName: "Martinez",
    title: "Assoc Director, Budget&Finance",
    slug: "carol-i-martinez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Crystal",
    lastName: "Martinez",
    title: "Development Assistant, Data Management",
    slug: "crystal-martinez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ana",
    lastName: "Martinez",
    title: "Supervisor, ICM",
    slug: "ana-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annie G.",
    lastName: "Martinez",
    title: "Administrative Assistant",
    slug: "annie-g-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ramon Fernando",
    lastName: "Martinez II",
    title: "Assistant Director for Card Services & Technology",
    slug: "ramon-fernando-martinez-ii",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marcio H",
    lastName: "Martinez Jr",
    title: "Audio Visual/IT Assistant",
    slug: "marcio-h-martinez-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alvaro Martin",
    lastName: "Martinez Mattos",
    title: "Internal Communications Specialist",
    slug: "alvaro-martin-martinez-mattos",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Manfry Jose",
    lastName: "Martinez Rodriguez",
    title: "User Services Consultant",
    slug: "manfry-jose-martinez-rodriguez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "maria fernanda",
    lastName: "martinez stolik",
    title: "VSI",
    slug: "maria-fernanda-martinez-stolik",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarita D.",
    lastName: "Martinez-Moran",
    title: "Director, Curricular Affairs",
    slug: "sarita-d-martinez-moran",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maria E.",
    lastName: "Martinez-Torres",
    title: "Senior Projects Officer",
    slug: "maria-e-martinez-torres",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Veronica Ruth",
    lastName: "Martini",
    title: "Assistant Vice President for University Development",
    slug: "veronica-ruth-martini",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicholas J.",
    lastName: "Martucci",
    title: "Systems Coordinator",
    slug: "nicholas-j-martucci",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Magdalena",
    lastName: "Marty",
    title: "Director, HR Processing Center Transactions",
    slug: "magdalena-marty",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Justin B.",
    lastName: "Mascardo",
    title: "Central Registration Coord II",
    slug: "justin-b-mascardo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Philip T.",
    lastName: "Masciantonio",
    title: "Director of Broadcasting and Operations",
    slug: "philip-t-masciantonio",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kara W.",
    lastName: "Maser",
    title: "Donor Relations Coordinator",
    slug: "kara-w-maser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liam",
    lastName: "Maserjian",
    title: "CVN Production Manager",
    slug: "liam-maserjian",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jeanine",
    lastName: "Masih",
    title: "Administrative Manager",
    slug: "jeanine-masih",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gregory S",
    lastName: "Maskel",
    title: "Senior Technology Licensing Officer",
    slug: "gregory-s-maskel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Janine Nadia",
    lastName: "Maslov",
    title: "Assistant Director of Graduate Admissions",
    slug: "janine-nadia-maslov",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jessica",
    lastName: "Mason",
    title: "Senior Project Officer",
    slug: "jessica-mason",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hannah Joy",
    lastName: "Mason",
    title: "Senior Human Resources Coordinator",
    slug: "hannah-joy-mason",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Aubrey",
    lastName: "Mason",
    title: "Painter",
    slug: "aubrey-mason",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dania",
    lastName: "Masood",
    title: "Administrative Coordinator",
    slug: "dania-masood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan Rose",
    lastName: "Massaro",
    title:
      " Executive Director, Enrollment Management, Offices of Financial Aid and Registrar:",
    slug: "megan-rose-massaro",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Abby Pearson",
    lastName: "Massaro",
    title: "Program Associate",
    slug: "abby-pearson-massaro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robyn Elizabeth",
    lastName: "Massey",
    title: "Senior Publicist",
    slug: "robyn-elizabeth-massey",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lisa K.",
    lastName: "Mata",
    title: "Director of Operations",
    slug: "lisa-k-mata",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dylan Kane",
    lastName: "Mataya",
    title: "Administrative Assistant",
    slug: "dylan-kane-mataya",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Franchesca",
    lastName: "Mateo",
    title: "EMG Coordinator",
    slug: "franchesca-mateo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cynthia",
    lastName: "Mateo",
    title: "Administrative Coordinator",
    slug: "cynthia-mateo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony W.",
    lastName: "Matera",
    title: "System Administrator",
    slug: "anthony-w-matera",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chackupuracka",
    lastName: "Mathai",
    title: "Project Director",
    slug: "chackupuracka-mathai",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Farhana",
    lastName: "Mather",
    title: "Principal Gifts Officer, Foundations",
    slug: "farhana-mather",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Susanna T.",
    lastName: "Mathews",
    title: "Associate Director, Deferred Enrollment",
    slug: "susanna-t-mathews",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Thomas Murray",
    lastName: "Mathewson",
    title: "Manager-University Senate",
    slug: "thomas-murray-mathewson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ana Maria",
    lastName: "Matias",
    title: "Associate Director, Investigations",
    slug: "ana-maria-matias",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Daniel Alejandro",
    lastName: "Matos",
    title: "Clinic Administrator",
    slug: "daniel-alejandro-matos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chaney M.",
    lastName: "Matos",
    title: "Senior Associate Director",
    slug: "chaney-m-matos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle E.",
    lastName: "Matsushima",
    title: "Sr Dir, Stratgc Resch Init",
    slug: "danielle-e-matsushima",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jakeim",
    lastName: "Matthew",
    title: "First Cook",
    slug: "jakeim-matthew",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sharon",
    lastName: "Matthews",
    title: "Report Developer",
    slug: "sharon-matthews",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa Andrea",
    lastName: "Matthews",
    title: "Project Manager",
    slug: "lisa-andrea-matthews",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kindra S.",
    lastName: "Matthews",
    title: "Executive Assistant",
    slug: "kindra-s-matthews",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaleigh B.",
    lastName: "Matthews",
    title: "Director Academic Administration and Finance",
    slug: "kaleigh-b-matthews",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alina Danielle",
    lastName: "Matthews",
    title: "Administrative Assistant",
    slug: "alina-danielle-matthews",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Mattlin",
    title: "Senior Contracts Officer",
    slug: "laura-mattlin",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Diane",
    lastName: "Matuzak",
    title: "Associate Director, Employer Relations",
    slug: "diane-matuzak",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Howard I",
    lastName: "Matza",
    title: "Manager of Safety, Security, Communications and Property",
    slug: "howard-i-matza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steve Michael",
    lastName: "Mau",
    title: "Executive Director, Business Operations and Intelligence",
    slug: "steve-michael-mau",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Diana Lynn Ryan",
    lastName: "Maul",
    title: "Executive Director for Academic Affairs Compliance",
    slug: "diana-lynn-ryan-maul",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marlene",
    lastName: "Mauri",
    title: "Executive Director, HR/FA",
    slug: "marlene-mauri",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Emily",
    lastName: "Maury",
    title: "Associate Director of Athletics Development",
    slug: "emily-maury",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Farid",
    lastName: "Mawanda",
    title: "MPA",
    slug: "farid-mawanda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carol",
    lastName: "Maxfield",
    title: "Receptionist",
    slug: "carol-maxfield",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Maxwell",
    title: "Senior Grants Specialist",
    slug: "michael-maxwell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Luke N.",
    lastName: "Maxwell",
    title: "Development and Alumni Administrator",
    slug: "luke-n-maxwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacqueline E",
    lastName: "Maxwell",
    title: "Director, Procurement",
    slug: "jacqueline-e-maxwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda Marie",
    lastName: "Maxwell",
    title: "Social Worker",
    slug: "amanda-marie-maxwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica Woodard",
    lastName: "May",
    title: "Manager of Communications and Special Projects",
    slug: "jessica-woodard-may",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hazel S.",
    lastName: "May",
    title: "Senior Associate Dean for Academic Affairs",
    slug: "hazel-s-may",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melissa",
    lastName: "Mayard",
    title: "Associate Director, Student Life",
    slug: "melissa-mayard",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Susanna Estella",
    lastName: "Mayas",
    title: "Administrative Aide",
    slug: "susanna-estella-mayas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olga L",
    lastName: "Mayens",
    title: "Biller",
    slug: "olga-l-mayens",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alissa A.",
    lastName: "Mayers",
    title: "Director of Public Programs",
    slug: "alissa-a-mayers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seth",
    lastName: "Mayersohn",
    title: "Administrative Director",
    slug: "seth-mayersohn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yana",
    lastName: "Mayevskaya",
    title: "Assoc Dir,CPC Learning Network",
    slug: "yana-mayevskaya",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katie Orlemanski",
    lastName: "Mayfield",
    title: "Sr Director of Development",
    slug: "katie-orlemanski-mayfield",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristen C",
    lastName: "Maynor",
    title:
      " Associate Director, Academic and Student Affairs, Associate Director MA Programs",
    slug: "kristen-c-maynor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Wendy",
    lastName: "Mazo",
    title: "Associate Dean for Development, School of the Arts",
    slug: "wendy-mazo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Beatrice",
    lastName: "Mazzi",
    title: "Coordinator",
    slug: "beatrice-mazzi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Geraldine",
    lastName: "Mc Allister",
    title: "Director",
    slug: "geraldine-mc-allister",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lidia",
    lastName: "Mc Carthy",
    title: "Director (Operations)",
    slug: "lidia-mc-carthy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "McAleer",
    title: "Senior Manager, Financial Operations",
    slug: "christine-mcaleer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David",
    lastName: "McAlinden",
    title: "Associate Director, Instructional Design and Media",
    slug: "david-mcalinden",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniel Michael",
    lastName: "McAlindon",
    title: "Director of Communications",
    slug: "daniel-michael-mcalindon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lisa D.",
    lastName: "McAllister",
    title: "Director, Financial Analysis and Planning",
    slug: "lisa-d-mcallister",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "James",
    lastName: "McArdle",
    title: "Production Coordinator",
    slug: "james-mcardle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jocelyn",
    lastName: "McArthur-Chouloute",
    title: "Associate Director, Academic & Student Success",
    slug: "jocelyn-mcarthur-chouloute",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael",
    lastName: "McAuliffe",
    title: "Sr. Applications Systems Developer",
    slug: "michael-mcauliffe",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Caroline",
    lastName: "McAuliffe",
    title: "Associate Director, Curriculum and Teaching for Pre-College",
    slug: "caroline-mcauliffe",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine Logan",
    lastName: "McBride",
    title: "Oral History Project Manager",
    slug: "katherine-logan-mcbride",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jazmin Elisa",
    lastName: "McBride",
    title: "Assistant Director of Student Engagement & Veteran Initiatives",
    slug: "jazmin-elisa-mcbride",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rebecca S",
    lastName: "McCain",
    title: "Associate Director, Undergraduate Career Development",
    slug: "rebecca-s-mccain",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Zinnia P.",
    lastName: "McCallum",
    title: "Director, HR/FA",
    slug: "zinnia-p-mccallum",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Linda M.",
    lastName: "McCamery",
    title: "Administrative Aide",
    slug: "linda-m-mccamery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kim",
    lastName: "McCann",
    title: "Associate Director for Development",
    slug: "kim-mccann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ann",
    lastName: "McCann Oakley",
    title: "Associate Dean-Computing & Instructional Technology",
    slug: "ann-mccann-oakley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rannie",
    lastName: "McCants",
    title: "Senior Associate Director, Prospect Development",
    slug: "rannie-mccants",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tara",
    lastName: "McCarney",
    title: "Assistant Director of Career Advising",
    slug: "tara-mccarney",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Caitlin A.",
    lastName: "McCarthy",
    title: "Licensed Master Social Worker",
    slug: "caitlin-a-mccarthy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace A",
    lastName: "McCarty",
    title: "Director, Research Strategy & Policy",
    slug: "grace-a-mccarty",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Moira Eileen",
    lastName: "Mccavana",
    title: "Curriculum Developer",
    slug: "moira-eileen-mccavana",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Angela Marie",
    lastName: "McClain",
    title: "Director of Budget and Finance",
    slug: "angela-marie-mcclain",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Madison J",
    lastName: "McClain-Frederick",
    title: "Administrative Coordinator",
    slug: "madison-j-mcclain-frederick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle A",
    lastName: "McClave-Liu",
    title: "Assoc Dir Prog Strat & Comm",
    slug: "michelle-a-mcclave-liu",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rhiannon J",
    lastName: "McClintock",
    title: "Assistant Director of Administrative Planning",
    slug: "rhiannon-j-mcclintock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rachel",
    lastName: "McClure",
    title: "Marketing & Communications Specialist",
    slug: "rachel-mcclure",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Neil M.",
    lastName: "McClure",
    title: "Chief Human Resources Officer, CUIMC",
    slug: "neil-m-mcclure",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joanne S.",
    lastName: "McCormack",
    title: "Administrative Coordinator",
    slug: "joanne-s-mccormack",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily-Anne",
    lastName: "McCormack",
    title: "Director, Career Placement",
    slug: "emily-anne-mccormack",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joan Barry",
    lastName: "McCormick",
    title: "Associate Dean for Advancement, Graduate School of Journalism",
    slug: "joan-barry-mccormick",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Esmeralda",
    lastName: "McCormick",
    title: "Gift Coordinator",
    slug: "esmeralda-mccormick",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Byron M.",
    lastName: "McCray Miller",
    title: "Senior Associate Director, Alumni Relations Marketing",
    slug: "byron-m-mccray-miller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laura L.",
    lastName: "McCreedy",
    title: "Manager of Executive Education and Training",
    slug: "laura-l-mccreedy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hunter",
    lastName: "McCrossin",
    title: "Managing Director",
    slug: "hunter-mccrossin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Paul",
    lastName: "McCullough",
    title: "Director, Academic Programs",
    slug: "paul-mccullough",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Collin",
    lastName: "McDermott",
    title: "Assistant Director, Advising and Academic Success",
    slug: "collin-mcdermott",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anna",
    lastName: "McDermott",
    title: "Non-Student STC",
    slug: "anna-mcdermott",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Trenadia",
    lastName: "McDonald",
    title: "Assoc Director-Admissions",
    slug: "trenadia-mcdonald",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sara",
    lastName: "McDonald",
    title: "Director of Finance and Administration",
    slug: "sara-mcdonald",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matthew",
    lastName: "McDonald",
    title: "Coordinator, Research Edu Ops",
    slug: "matthew-mcdonald",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Imani",
    lastName: "McDonald",
    title: "Business Manager",
    slug: "imani-mcdonald",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacob",
    lastName: "McDougle",
    title: "Financial Manager",
    slug: "jacob-mcdougle",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joan",
    lastName: "McDowell",
    title: "Executive Director of Human Resources",
    slug: "joan-mcdowell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Maria",
    lastName: "McElwee",
    title: "Associate Director, Financial Reporting and Policy",
    slug: "maria-mcelwee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kathleen D.",
    lastName: "McEwan",
    title: "Executive Chef",
    slug: "kathleen-d-mcewan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "McFadden",
    title: "Associate Dean, Academic Services and Innovation",
    slug: "karen-mcfadden",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Diane C",
    lastName: "McFadden",
    title: "Program Manager",
    slug: "diane-c-mcfadden",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael I",
    lastName: "McGann",
    title: "Outreach Coordinator",
    slug: "michael-i-mcgann",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tracy A.",
    lastName: "McGarry",
    title:
      " Senior Associate Director of Alumni Career Development, Undergraduate Career Development",
    slug: "tracy-a-mcgarry",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maryanne",
    lastName: "McGinn",
    title: "Manager-Research Compliance",
    slug: "maryanne-mcginn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert J",
    lastName: "McGinnis",
    title: "Manager-Building Operations",
    slug: "robert-j-mcginnis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tessa J",
    lastName: "McGowan",
    title: "Associate Director of Religious Life",
    slug: "tessa-j-mcgowan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mionellie",
    lastName: "McGue",
    title: "Administrative Assistant",
    slug: "mionellie-mcgue",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meghan Catherine",
    lastName: "McGuffin",
    title: "Assistant Director of Fraternity and Sorority Life",
    slug: "meghan-catherine-mcguffin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sara",
    lastName: "McGuire",
    title: "Director of Special Projects",
    slug: "sara-mcguire",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter T",
    lastName: "McHugh",
    title: "Director, Strategic Communications",
    slug: "peter-t-mchugh",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bernadette",
    lastName: "McHugh",
    title: "Assistant Dean, Student Affairs (Advising and Academic Success)",
    slug: "bernadette-mchugh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dorla C.",
    lastName: "McIntosh",
    title: "Administrative Assistant",
    slug: "dorla-c-mcintosh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maureen A",
    lastName: "McIntyre",
    title: "Executive Assistant",
    slug: "maureen-a-mcintyre",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cheryl T.",
    lastName: "McIntyre",
    title: "Associate Director, Human Resources",
    slug: "cheryl-t-mcintyre",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Susan M.",
    lastName: "McKee",
    title: "Technical Support Specialist",
    slug: "susan-m-mckee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Patricia K",
    lastName: "McKelvin",
    title: "Assistant Director, Human Resources",
    slug: "patricia-k-mckelvin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Pamela R.",
    lastName: "McKelvin",
    title: "Assistant Dean, Strategic Initiatives",
    slug: "pamela-r-mckelvin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Theresa A.",
    lastName: "McKenzie",
    title: "Chief Financial and Administrative Officer",
    slug: "theresa-a-mckenzie",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shana P",
    lastName: "McKenzie",
    title: "Wait Staff",
    slug: "shana-p-mckenzie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shanekqua M.",
    lastName: "Mckune",
    title: "Coding Specialist III",
    slug: "shanekqua-m-mckune",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kerry-Ann",
    lastName: "McLean",
    title: "Director of Human Rights and Public International Law",
    slug: "kerry-ann-mclean",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jody-Ann",
    lastName: "McLeggon",
    title: "Manager, Research Admin",
    slug: "jody-ann-mcleggon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "DELORES",
    lastName: "MCLEOD",
    title: "Self Pay Cust Serv Adj Spc III",
    slug: "delores-mcleod",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meghan",
    lastName: "McLoryd",
    title: "Executive Assistant",
    slug: "meghan-mcloryd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "McMahon",
    title: "Director, Research Strategy and Consulting",
    slug: "kelly-mcmahon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "James T.",
    lastName: "Mcmenamin",
    title:
      " Senior Associate Dean for Columbia College Development / Senior Director of Principal Gifts",
    slug: "james-t-mcmenamin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rosemary",
    lastName: "McNeil",
    title: "Senior Adult Diabetes Educator",
    slug: "rosemary-mcneil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trish R",
    lastName: "McNicholas",
    title: "Executive Director of College Events and Internal Communications",
    slug: "trish-r-mcnicholas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cecily H.",
    lastName: "McNickle",
    title: "Administrative Assistant",
    slug: "cecily-h-mcnickle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael Paul",
    lastName: "McParlane",
    title: "Coordinator",
    slug: "michael-paul-mcparlane",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "John P",
    lastName: "McShane",
    title: "Assistant Director of Academic Administration",
    slug: "john-p-mcshane",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel Robert",
    lastName: "McShane",
    title: "Specialist-Digital Content",
    slug: "daniel-robert-mcshane",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathleen M",
    lastName: "Mcveigh",
    title: "Director, International Affrs",
    slug: "kathleen-m-mcveigh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "D.D.",
    lastName: "Meakin",
    title: "Associate Director, Career Education and Advising",
    slug: "d-d-meakin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tshaye",
    lastName: "Meaza",
    title: "Senior Associate Director of Finance",
    slug: "tshaye-meaza",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Clementina T",
    lastName: "Mecaj",
    title: "Director, HR/FA",
    slug: "clementina-t-mecaj",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Amine",
    lastName: "Mechaal",
    title: "Director of Global Engagement",
    slug: "amine-mechaal",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark Leslie",
    lastName: "Medd",
    title: "Associate Director, Strategic Sourcing",
    slug: "mark-leslie-medd",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Erin",
    lastName: "Medina",
    title: "Asst Gen Manager-Conf Srvs",
    slug: "erin-medina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel A",
    lastName: "Medina",
    title: "Director Annual Giving",
    slug: "daniel-a-medina",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Blanca",
    lastName: "Medina",
    title: "Financial Assistant, Finance",
    slug: "blanca-medina",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amanda",
    lastName: "Medina",
    title: "Financial Aid Officer",
    slug: "amanda-medina",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anna",
    lastName: "Medina",
    title: "Finance Operations Specialist",
    slug: "anna-medina",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Parm",
    lastName: "Meegada",
    title: "Manager, Business Intelligence Architecture & Administration",
    slug: "parm-meegada",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Varvara",
    lastName: "Meehan",
    title: "Grants Manager",
    slug: "varvara-meehan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cynthia A.",
    lastName: "Meekins",
    title: "Associate Director - Academic Administration",
    slug: "cynthia-a-meekins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Whitney D",
    lastName: "Meeks",
    title: "Assoc Director, Contract Neg",
    slug: "whitney-d-meeks",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Owen B.",
    lastName: "Mefford",
    title: "Coordinator",
    slug: "owen-b-mefford",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael Jan",
    lastName: "Mehler",
    title: "Web and Communications Manager",
    slug: "michael-jan-mehler",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Zahid",
    lastName: "Mehmood",
    title: "Associate Director, Information Security and Risk Management",
    slug: "zahid-mehmood",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karen Bridges",
    lastName: "Mehta",
    title: "Assistant Director, Social Enterprise Executive Development",
    slug: "karen-bridges-mehta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lena Ying Yee",
    lastName: "Mei",
    title: "Outreach Program Manager",
    slug: "lena-ying-yee-mei",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicole",
    lastName: "Meily",
    title:
      " Director - Academic Administration & Finance(DAAF) of Arts & Sciences Philosophy",
    slug: "nicole-meily",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jason Lowell",
    lastName: "Meizlish",
    title: "Associate General Counsel",
    slug: "jason-lowell-meizlish",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Marc A",
    lastName: "Mejia",
    title: "International Student Senior",
    slug: "marc-a-mejia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jannelle",
    lastName: "Mejia",
    title: "Administrative Clerk",
    slug: "jannelle-mejia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabriel",
    lastName: "Mejia",
    title: "Director",
    slug: "gabriel-mejia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Diana I.",
    lastName: "Mejia",
    title: "VP, Student & Campus Services",
    slug: "diana-i-mejia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Cindy Melissa",
    lastName: "Mejia",
    title: "Officer-Career Placement",
    slug: "cindy-melissa-mejia",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amanda N",
    lastName: "Mejia",
    title: "Secretary B",
    slug: "amanda-n-mejia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noemi",
    lastName: "Mejia de Gallardo",
    title: "CMA",
    slug: "noemi-mejia-de-gallardo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Massiel",
    lastName: "Mejia-O'Brien",
    title: "Generalist, HR/FA",
    slug: "massiel-mejia-o-brien",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Meesha",
    lastName: "Meksin",
    title: "Senior Project Manager",
    slug: "meesha-meksin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Victor Rafael",
    lastName: "Melendez",
    title: "Associate Director - Media Services",
    slug: "victor-rafael-melendez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melina",
    lastName: "Melendez",
    title: "University Affiliate - STEAM",
    slug: "melina-melendez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josephine T",
    lastName: "Melendez",
    title: "Grants Manager",
    slug: "josephine-t-melendez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John A.",
    lastName: "Melendez",
    title: "Coordinator",
    slug: "john-a-melendez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daisy",
    lastName: "Melendez",
    title: "Administrative Asst",
    slug: "daisy-melendez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "MinwYelet",
    lastName: "Melesse",
    title: "Senior Application Systems Developer (Power BI)",
    slug: "minwyelet-melesse",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pelayo",
    lastName: "Melgarejo Amian",
    title: "Grants Finance Manager",
    slug: "pelayo-melgarejo-amian",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Abigail E",
    lastName: "Melican",
    title: "Project Coordinator",
    slug: "abigail-e-melican",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carolina",
    lastName: "Mellado",
    title: "Sr Human Resources Manager",
    slug: "carolina-mellado",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jean",
    lastName: "Melo",
    title: "Associate Director, Data Operations and Analytics",
    slug: "jean-melo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cristina V.",
    lastName: "Melo-Moya",
    title: "Assistant Director",
    slug: "cristina-v-melo-moya",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel L",
    lastName: "Melvin",
    title: "IRB Specialist, Asst Manager",
    slug: "daniel-l-melvin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "M",
    lastName: "Mena",
    title: "Field Ethnographer",
    slug: "m-mena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Soemanta",
    lastName: "Mendez",
    title: "Director, Budget Operations and Analysis",
    slug: "soemanta-mendez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mickaelar Keeka",
    lastName: "Mendez",
    title: "Senior Generalist, HR/FA",
    slug: "mickaelar-keeka-mendez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Glendaly",
    lastName: "Mendez",
    title: "Administrative Assistant",
    slug: "glendaly-mendez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eileen",
    lastName: "Mendez",
    title: "Communications and Digital Media Associate",
    slug: "eileen-mendez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eimee Ondina",
    lastName: "Mendez",
    title: "HR/Emp Engagement Specialist",
    slug: "eimee-ondina-mendez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Carolyn",
    lastName: "Mendez",
    title: "Office Manager",
    slug: "carolyn-mendez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cecilio",
    lastName: "Mendez",
    title: "Admin Coord, Finance/Ops",
    slug: "cecilio-mendez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katherine",
    lastName: "Mendis",
    title: "Deputy Program Director, Bioethics",
    slug: "katherine-mendis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Wendy",
    lastName: "Mendoza",
    title: "Information Security Auditor",
    slug: "wendy-mendoza",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shawn D.",
    lastName: "Mendoza",
    title: "Director of Academic Administration and Finance",
    slug: "shawn-d-mendoza",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Phil",
    lastName: "Mendoza",
    title: "Executive Director",
    slug: "phil-mendoza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Perla K",
    lastName: "Mendoza",
    title: "Recruitment/Operations Lead",
    slug: "perla-k-mendoza",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jonathan Andrew",
    lastName: "Mendoza",
    title: "Coordinator",
    slug: "jonathan-andrew-mendoza",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Claudia Alejandra",
    lastName: "Mendoza",
    title: "Assoc Director, Procurement",
    slug: "claudia-alejandra-mendoza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aaron",
    lastName: "Mendoza",
    title: "Director of Desktop Engine Sup",
    slug: "aaron-mendoza",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Oliver",
    lastName: "Mendoza Jr",
    title: "Administrative Assistant I",
    slug: "oliver-mendoza-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sonia",
    lastName: "Mendoza-Grey",
    title: "Program Manager",
    slug: "sonia-mendoza-grey",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ran",
    lastName: "Meng",
    title:
      " Director and Radiation Safety Officer, Research Radiation Safety Programs",
    slug: "ran-meng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eileen N.",
    lastName: "Menis",
    title: "Admissions Assistant",
    slug: "eileen-n-menis",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kelunni",
    lastName: "Menon",
    title: "Accounts Payable Specialist",
    slug: "kelunni-menon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amritha",
    lastName: "Menon",
    title: "BRIDGE Technology Manager",
    slug: "amritha-menon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sia J.",
    lastName: "Mensah",
    title: "Project Officer",
    slug: "sia-j-mensah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joelle Renee",
    lastName: "Mentis",
    title: "Project Manager",
    slug: "joelle-renee-mentis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacmel",
    lastName: "Mera",
    title: "Instructional Support Specialist",
    slug: "jacmel-mera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Irina",
    lastName: "Mera",
    title: "Administrative Manager",
    slug: "irina-mera",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Maria",
    lastName: "Mercado",
    title: "Assistant Office Manager",
    slug: "maria-mercado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lalaine N.",
    lastName: "Mercado",
    title: "Senior Associate Director, Undergraduate Career Development",
    slug: "lalaine-n-mercado",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jamila",
    lastName: "Mercado",
    title: "Generalist, HR/FA",
    slug: "jamila-mercado",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jeff",
    lastName: "Mercado",
    title: "Financial Assistant",
    slug: "jeff-mercado",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Edwardo",
    lastName: "Mercado",
    title: "Customer Service",
    slug: "edwardo-mercado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christian",
    lastName: "Mercado",
    title: "Assistant Director of Administration",
    slug: "christian-mercado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Justin",
    lastName: "Merced",
    title: "Assistant Director, Registration and Enrollment Services",
    slug: "justin-merced",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Coral C",
    lastName: "Mercedes",
    title: "Senior Associate Director of Admissions Operations",
    slug: "coral-c-mercedes",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Betty",
    lastName: "Mercedes",
    title: "Call Center Representative",
    slug: "betty-mercedes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Georges P",
    lastName: "Merceron",
    title: "Senior Trainer",
    slug: "georges-p-merceron",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer",
    lastName: "Merchant",
    title: "Columbia Coach",
    slug: "jennifer-merchant",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Clara M.",
    lastName: "Meregildo",
    title: "Manager, HR & FA",
    slug: "clara-m-meregildo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Feven",
    lastName: "Merid",
    title: "Sr. Staff Writer, CJR",
    slug: "feven-merid",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Frantz",
    lastName: "Merine",
    title: "Chief Information Officer, Information technology",
    slug: "frantz-merine",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "David",
    lastName: "Merle",
    title: "Project Manager",
    slug: "david-merle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy",
    lastName: "Merriman",
    title: "Director of Recruiting and Professional Development",
    slug: "nancy-merriman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jenesis Himeka-Beulah",
    lastName: "Merriman",
    title: "Project Coordinator",
    slug: "jenesis-himeka-beulah-merriman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Merry",
    title: "Finance and Compliance Manager",
    slug: "kyle-merry",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maureen",
    lastName: "Mesa",
    title: "Technical Support Specialist",
    slug: "maureen-mesa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gessie",
    lastName: "Mesamours",
    title: "Executive Assistant",
    slug: "gessie-mesamours",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristina",
    lastName: "Mesoznik",
    title: "Consultant",
    slug: "kristina-mesoznik",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather L",
    lastName: "Messina",
    title: "Director, Donr Rel&Strtg Evnts",
    slug: "heather-l-messina",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amy",
    lastName: "Metcalf",
    title: "Director Office of Strategic Donor Relations & Stewardship",
    slug: "amy-metcalf",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jasmina",
    lastName: "Metjaic",
    title:
      " Executive Assistant to the Vice President for University Development",
    slug: "jasmina-metjaic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Mettenburg",
    title: "Brickman Miller UPMC",
    slug: "joseph-mettenburg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Metz",
    title: "Data Mgt and Informatics Lead",
    slug: "melissa-metz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Milca",
    lastName: "Meyer",
    title: "Senior Director",
    slug: "milca-meyer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren Martine",
    lastName: "Meyer",
    title: "National Project Director, Income and the Developing Brain Study",
    slug: "lauren-martine-meyer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jordan",
    lastName: "Meyer",
    title: "Summer Intern",
    slug: "jordan-meyer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric J",
    lastName: "Meyer",
    title: "Business Manager",
    slug: "eric-j-meyer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chelsea Maritsa",
    lastName: "Meyer",
    title: "Associate Director, Development Marketing & Annual Giving",
    slug: "chelsea-maritsa-meyer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alyssa Nicole",
    lastName: "Meyers",
    title: "Senior Associate Director, Development Writing",
    slug: "alyssa-nicole-meyers",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maria",
    lastName: "Meyreles",
    title: "Wait Staff",
    slug: "maria-meyreles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yelena",
    lastName: "Meytes",
    title: "Assoc Dir, Academic Programs",
    slug: "yelena-meytes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Beatrice V.",
    lastName: "Mhando",
    title: "Communications Specialist",
    slug: "beatrice-v-mhando",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Bodiuzzaman",
    lastName: "Mian",
    title: "Business Manager",
    slug: "bodiuzzaman-mian",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Naomi",
    lastName: "Michalowicz",
    title: "Lectures in the Discipline of English and Comparative Literature",
    slug: "naomi-michalowicz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leo",
    lastName: "Michel",
    title: "Chef de Cuisine",
    slug: "leo-michel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Micheles",
    title: "Administrative Assistant",
    slug: "maria-micheles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Manuela ELizabeth",
    lastName: "Middleton",
    title: "Payroll Specialist",
    slug: "manuela-elizabeth-middleton",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cary Lynn",
    lastName: "Midland",
    title: "Director of Operations",
    slug: "cary-lynn-midland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexandra M.",
    lastName: "Miecznikowski",
    title: "Director of Res Impl",
    slug: "alexandra-m-miecznikowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kai M.",
    lastName: "Miedendorp",
    title:
      " Associate Director of Motion Picture Technology - Production Resources and Technical Training",
    slug: "kai-m-miedendorp",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Geoff",
    lastName: "Mielke",
    title: "Associate Director, Strategic Sourcing",
    slug: "geoff-mielke",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lawrie",
    lastName: "Mifflin",
    title: "Senior Editor",
    slug: "lawrie-mifflin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laura",
    lastName: "Migdal",
    title: "Director, Human Resources",
    slug: "laura-migdal",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Amber R",
    lastName: "Migdal",
    title: "Senior Director, Donor Relations",
    slug: "amber-r-migdal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ronald",
    lastName: "Miguel",
    title: "Project Director",
    slug: "ronald-miguel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha Wu",
    lastName: "Mihali",
    title: "Major Gifts Officer",
    slug: "samantha-wu-mihali",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hristo M.",
    lastName: "Mihovski",
    title: "Chief Technology Manager",
    slug: "hristo-m-mihovski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Parivash",
    lastName: "Mikanik",
    title: "Administrative Clerk",
    slug: "parivash-mikanik",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole R.",
    lastName: "Milette",
    title: "Residence Hall Director",
    slug: "nicole-r-milette",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kim",
    lastName: "Milian",
    title: "Director,Events and Special Projects",
    slug: "kim-milian",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Katarina A.",
    lastName: "Milic",
    title: "Administrative Assistant",
    slug: "katarina-a-milic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Milko",
    lastName: "Milkov",
    title: "Executive Director, Finance",
    slug: "milko-milkov",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kaydie Lyn",
    lastName: "Milks",
    title: "Director of Operations",
    slug: "kaydie-lyn-milks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yvette",
    lastName: "Miller",
    title: "Senior Director, Marketing and Communications",
    slug: "yvette-miller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "William M",
    lastName: "Miller",
    title: "Senior Manager, Makerspace",
    slug: "william-m-miller",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sharon",
    lastName: "Miller",
    title: "Payroll Supervisor",
    slug: "sharon-miller",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Olivia M",
    lastName: "Miller",
    title: "Development Assistant",
    slug: "olivia-m-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Miller",
    title: "SR HR Business Partner",
    slug: "mary-miller",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marjorie Jane",
    lastName: "Miller",
    title: "Administrator, The Pulitzer Prizes",
    slug: "marjorie-jane-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melinda M.",
    lastName: "Miller",
    title: "Senior Director, Institute Programs and Outreach",
    slug: "melinda-m-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael J.",
    lastName: "Miller",
    title: "Chief Financial Officer, ICAP",
    slug: "michael-j-miller",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lillian",
    lastName: "Miller",
    title: "MA",
    slug: "lillian-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lauren",
    lastName: "Miller",
    title: "Senior Director, Leadership Gifts",
    slug: "lauren-miller",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Larese M.",
    lastName: "Miller",
    title: "Senior Director for Gift Systems",
    slug: "larese-m-miller",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kaleah T",
    lastName: "Miller",
    title: "Senior Secretary",
    slug: "kaleah-t-miller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Klancy",
    lastName: "Miller",
    title: "Senior Writer",
    slug: "klancy-miller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jashon J",
    lastName: "Miller",
    title: "Financial Coordinator",
    slug: "jashon-j-miller",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brian",
    lastName: "Miller",
    title: "Videographer",
    slug: "brian-miller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anna",
    lastName: "Miller",
    title: "Graduate Program Manager",
    slug: "anna-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrew",
    lastName: "Miller",
    title: "Executive Director of Research",
    slug: "andrew-miller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Syreeta N.",
    lastName: "Miller-Bailey",
    title: "Assoc Director, HR & Fac Affrs",
    slug: "syreeta-n-miller-bailey",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Maxwell",
    lastName: "Milliken",
    title: "Associate Director of Research Strategy and Policy",
    slug: "maxwell-milliken",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shenell",
    lastName: "Mills",
    title: "Human Resources Manager",
    slug: "shenell-mills",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Chaia",
    lastName: "Milstein",
    title: "Digital Content Strategist",
    slug: "chaia-milstein",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Angelica",
    lastName: "Minaya",
    title: "Specialist, Academic Services",
    slug: "angelica-minaya",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Caron Marie",
    lastName: "Mineo",
    title: "Director of Research and Evaluation",
    slug: "caron-marie-mineo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tshakeesha",
    lastName: "Ming",
    title: "Senior Service Specialist",
    slug: "tshakeesha-ming",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shira D.",
    lastName: "Minsk",
    title: "Research and Policy Programs Coordinator",
    slug: "shira-d-minsk",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael J",
    lastName: "Minyetty",
    title: "IRB Specialist",
    slug: "michael-j-minyetty",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Mira",
    title: "Senior Project Officer",
    slug: "sarah-mira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alfonsina",
    lastName: "Mirabal Santos",
    title: "Data Coordinator",
    slug: "alfonsina-mirabal-santos",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ria K.",
    lastName: "Miranda",
    title: "Sr. Project Officer",
    slug: "ria-k-miranda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy",
    lastName: "Miranda",
    title: "Administrative Clerk",
    slug: "nancy-miranda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Mirando",
    title: "Staff",
    slug: "nicole-mirando",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Katrina A.",
    lastName: "Mirasola",
    title: "Senior Director, Academic Affairs MBA/MS",
    slug: "katrina-a-mirasola",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Linda C.",
    lastName: "Mischel Eisner",
    title:
      " Executive Director, Labor and Employee Relations (Academic Personnel)",
    slug: "linda-c-mischel-eisner",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle Deborah",
    lastName: "Mischler",
    title: "Assistant Director of Development Events and Strategic Projects",
    slug: "michelle-deborah-mischler",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dedra",
    lastName: "Mishoe",
    title: "Customer Service Representative",
    slug: "dedra-mishoe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sylwia",
    lastName: "Misiewicz",
    title: "Project Coordinator",
    slug: "sylwia-misiewicz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas C.",
    lastName: "Mistretta",
    title: "Senior Service Specialist",
    slug: "nicholas-c-mistretta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dhvani",
    lastName: "Mistry",
    title: "Application Systems Developer",
    slug: "dhvani-mistry",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elisabeth Joy",
    lastName: "Mistur",
    title: "Project Coordinator for the Fall AA-A Training Program",
    slug: "elisabeth-joy-mistur",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trinit'y",
    lastName: "Mitchell",
    title: "BioBus Personnel",
    slug: "trinit-y-mitchell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Estelle Romaine",
    lastName: "Mitchell",
    title: "Assistant Director of Pro Bono and Summer Preparation",
    slug: "estelle-romaine-mitchell",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Dennis A.",
    lastName: "Mitchell",
    title:
      " Interim Dean of the Faculty of Dental Medicine; Professor of Dental Medicine (Community Health and Periodontics) at the Columbia University Medical Center; Senior Advisor for Inclusion and Belonging",
    slug: "dennis-a-mitchell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hilda Elizabeth",
    lastName: "Mitjans",
    title: "Administrator",
    slug: "hilda-elizabeth-mitjans",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ashwini",
    lastName: "Mitkari",
    title: "Sr. Applications Systems Developer",
    slug: "ashwini-mitkari",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tatiana",
    lastName: "Mitrova",
    title: "Consultant",
    slug: "tatiana-mitrova",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer S",
    lastName: "Mizhquiri Barbecho",
    title: "Project Manager",
    slug: "jennifer-s-mizhquiri-barbecho",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emiko",
    lastName: "Mizumura",
    title: "Assistant Director",
    slug: "emiko-mizumura",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace Nimrod",
    lastName: "Mkemwa",
    title: "Sr Project Portfolio Manager",
    slug: "grace-nimrod-mkemwa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John-Shaw",
    lastName: "Moazami",
    title: "Project Assistant",
    slug: "john-shaw-moazami",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Mock",
    title: "Associate Director of Education and Public Programs",
    slug: "jennifer-mock",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Petal N",
    lastName: "Modeste",
    title:
      " Associate Dean for Professional Development, Graduate Degrees, and Executive Education",
    slug: "petal-n-modeste",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Charles W.",
    lastName: "Modica",
    title: "Director of Business Operations and Service Management",
    slug: "charles-w-modica",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Clay R",
    lastName: "Moffitt",
    title: "Assistant Director of Admissions Systems and Operations",
    slug: "clay-r-moffitt",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kaisha C. V.",
    lastName: "Mofford",
    title: "Research Specialist",
    slug: "kaisha-c-v-mofford",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Liya Berhane",
    lastName: "Mogese",
    title: "Program Officer",
    slug: "liya-berhane-mogese",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Winston",
    lastName: "Moguel",
    title: "Admissions Assistant",
    slug: "winston-moguel",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Siddiq",
    lastName: "Mohamed",
    title: "Info Tech/Systems Manager",
    slug: "siddiq-mohamed",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shafiq",
    lastName: "Mohammed",
    title: "Consultant",
    slug: "shafiq-mohammed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Soresh",
    lastName: "Mohan",
    title: "Manager-Catering Ops",
    slug: "soresh-mohan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aurelian Dragos",
    lastName: "Mohan",
    title: "Contractor",
    slug: "aurelian-dragos-mohan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dhewan",
    lastName: "Mohanlall",
    title: "IT Support Specialist",
    slug: "dhewan-mohanlall",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa Elizabeth",
    lastName: "Mohler",
    title: "Desk Clerk",
    slug: "lisa-elizabeth-mohler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maita",
    lastName: "Mojica",
    title: "Associate Director, Product Marketing",
    slug: "maita-mojica",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Celinette",
    lastName: "Mojica",
    title: "Associate Director, University Financial Aid",
    slug: "celinette-mojica",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Claudia Oana",
    lastName: "Moldoveanu",
    title: "Financial Coordinator in the Department of Computer Science",
    slug: "claudia-oana-moldoveanu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lema Naima",
    lastName: "Moliga",
    title: "Director of Student Support & Advocacy",
    slug: "lema-naima-moliga",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Marilyn",
    lastName: "Molina",
    title: "Associate University Ombuds Officer",
    slug: "marilyn-molina",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Erica",
    lastName: "Molina",
    title: "Administrative Coordinator",
    slug: "erica-molina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christian M",
    lastName: "Molina",
    title: "Executive Director, Columbia College Finance",
    slug: "christian-m-molina",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eugene",
    lastName: "Molina Jr",
    title: "Senior Service Specialist",
    slug: "eugene-molina-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lorraine J.",
    lastName: "Molloy",
    title: "Director, Deployment",
    slug: "lorraine-j-molloy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jonathan Robert",
    lastName: "Molter",
    title: "Director, Pre-College Programs",
    slug: "jonathan-robert-molter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Olympia",
    lastName: "Moment",
    title: "Sr Generalist-Human Res/FA",
    slug: "olympia-moment",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Thomas W.",
    lastName: "Monaco",
    title: "Executive Director, Experienced Professional Career Management",
    slug: "thomas-w-monaco",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Riyad",
    lastName: "Monaf",
    title: "Accounting Coordinator",
    slug: "riyad-monaf",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah Evelyn",
    lastName: "Monks",
    title: "Associate Director",
    slug: "sarah-evelyn-monks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaylin",
    lastName: "Monroe",
    title: "Development Associate",
    slug: "jaylin-monroe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gisele E.",
    lastName: "Monroe",
    title: "Executive Director-Benefits",
    slug: "gisele-e-monroe",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alexandria",
    lastName: "Monroe",
    title: "Associate Director, Student Accounts Collections",
    slug: "alexandria-monroe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kassandre R",
    lastName: "Monsanto-Laster",
    title: "Coordinator, Communications and External Relations",
    slug: "kassandre-r-monsanto-laster",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristal",
    lastName: "Montanez",
    title: "Coding Charge Edits Spc III",
    slug: "kristal-montanez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francisco",
    lastName: "Monterroso",
    title: "Assistant Director of Institutional Research",
    slug: "francisco-monterroso",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Starnaishia",
    lastName: "Montes",
    title: "Call Center Scheduling Representative",
    slug: "starnaishia-montes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kenndy",
    lastName: "Montes",
    title: "Manager, Cash and Accounting Operations",
    slug: "kenndy-montes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anna Maria",
    lastName: "Montes",
    title: "Associate Director, Strategic Initiatives",
    slug: "anna-maria-montes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carolina",
    lastName: "Montes Garcia",
    title: "Project Manager",
    slug: "carolina-montes-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luz Elizabeth",
    lastName: "Montez",
    title: "Program Administrator, Professional Prizes",
    slug: "luz-elizabeth-montez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mitchell Ryan",
    lastName: "Montgomery",
    title: "Assistant Director, Annual Giving",
    slug: "mitchell-ryan-montgomery",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jamie W",
    lastName: "Montgomery",
    title: "Executive Director,Development",
    slug: "jamie-w-montgomery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eamonn F.",
    lastName: "Montgomery",
    title: "Sr Director,Prospect Developmt",
    slug: "eamonn-f-montgomery",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sylvia",
    lastName: "Montijo",
    title: "Associate Director of Undergraduate Programs",
    slug: "sylvia-montijo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julissa",
    lastName: "Montijo",
    title: "Assistant Director, Instructional Support",
    slug: "julissa-montijo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hector M.",
    lastName: "Montijo Jr",
    title: "Office Assistant VI",
    slug: "hector-m-montijo-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Moody-Astwood",
    title:
      " Assistant Director for Multicultural and Social Justice Initiatives",
    slug: "ashley-moody-astwood",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Tiffany A.",
    lastName: "Moore",
    title: "Program Manager",
    slug: "tiffany-a-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Pamela Patterson",
    lastName: "Moore",
    title: "University Affiliate - STEAM",
    slug: "pamela-patterson-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia L",
    lastName: "Moore",
    title: "Managing Director, Center for Smart Streetscapes",
    slug: "olivia-l-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martha",
    lastName: "Moore",
    title: "Senior Writer",
    slug: "martha-moore",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kari",
    lastName: "Moore",
    title: "Associate Director of Administration",
    slug: "kari-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isaac Daniel",
    lastName: "Moore",
    title: "Associate Director of Admissions, Specialized Degree Programs",
    slug: "isaac-daniel-moore",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Glenroy A",
    lastName: "Moore",
    title: "Manager-Housing Operations",
    slug: "glenroy-a-moore",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elisa",
    lastName: "Moore",
    title: "Administrative Assistant",
    slug: "elisa-moore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dawn P.",
    lastName: "Moore",
    title: "Judicial Liaison Coordinator",
    slug: "dawn-p-moore",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Alexis",
    lastName: "Moore",
    title: "Director of Enrollment Services and Operations",
    slug: "alexis-moore",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Argustar",
    lastName: "Moore II",
    title: "System Administrator",
    slug: "argustar-moore-ii",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Donna R",
    lastName: "Moore-Martinez",
    title: "Administrative Assistant",
    slug: "donna-r-moore-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "April",
    lastName: "Moorhouse",
    title: "Major Gift Officer, Regional",
    slug: "april-moorhouse",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Zoraida",
    lastName: "Morales",
    title: "Administrative Coordinator",
    slug: "zoraida-morales",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mikaela",
    lastName: "Morales",
    title: "RN Temp",
    slug: "mikaela-morales",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mimian",
    lastName: "Morales",
    title: "Director of Executive Support and Operations",
    slug: "mimian-morales",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael S.",
    lastName: "Morales",
    title: "Senior System Administrator",
    slug: "michael-s-morales",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jimmy",
    lastName: "Morales",
    title: "Transaction Coordinator",
    slug: "jimmy-morales",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Juan C",
    lastName: "Morales",
    title: "Associate Director, Property, Budget & Fleet Administration",
    slug: "juan-c-morales",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Celia Marie",
    lastName: "Morales",
    title: "Finance Manager",
    slug: "celia-marie-morales",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bessy O.",
    lastName: "Morales",
    title: "Assistant Director, Human Resources",
    slug: "bessy-o-morales",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dayana E.",
    lastName: "Moran",
    title: "Customer Service Representative",
    slug: "dayana-e-moran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher Lee",
    lastName: "Moran",
    title: "Senior Category Manager, Procure To Pay Systems",
    slug: "christopher-lee-moran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ron",
    lastName: "Moraski",
    title: "Vice President, Procurement Services",
    slug: "ron-moraski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Mordan",
    title: "Administrative Coordinator",
    slug: "maria-mordan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Morel",
    title: "SYEP",
    slug: "michael-morel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elias C",
    lastName: "Morel",
    title: "Secretary B",
    slug: "elias-c-morel",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Judith",
    lastName: "Morel-Pointer",
    title: "Asst Dir of Fac Prom & Fac Dev",
    slug: "judith-morel-pointer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Naiomi Y.",
    lastName: "Moreno",
    title: "Associate Director of Academic Appointments and Payroll",
    slug: "naiomi-y-moreno",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Leticia Y.",
    lastName: "Moreno",
    title: "Pantry Worker",
    slug: "leticia-y-moreno",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Moreno",
    title: "Manager, Ed Programs & Ops",
    slug: "elizabeth-moreno",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yeiny Elizabeth",
    lastName: "Moreno Cabral",
    title: "Coordinator, Student Affairs (High School & Non-Degree Program)",
    slug: "yeiny-elizabeth-moreno-cabral",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "David",
    lastName: "Moretti",
    title: "Senior Director, Digital Marketing and Technology",
    slug: "david-moretti",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michelle S.",
    lastName: "Morgan",
    title: "Sr.Administrative Manager",
    slug: "michelle-s-morgan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lee",
    lastName: "Morgan",
    title: "Unified Communications Manager",
    slug: "lee-morgan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Beth E",
    lastName: "Morgan",
    title:
      " Director of Higher Education Transition and Partnership for Columbia's University Veterans' Center",
    slug: "beth-e-morgan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tenisha",
    lastName: "Morgan-Brathwaite",
    title: "Manager, Gift Planning Operations",
    slug: "tenisha-morgan-brathwaite",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Flatra",
    lastName: "Morina",
    title: "Operations Manager",
    slug: "flatra-morina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Flovijana",
    lastName: "Morina",
    title: "Senior Associate Director, Operations",
    slug: "flovijana-morina",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer R.",
    lastName: "Morisco",
    title: "Director, Global Travel & Risk Management",
    slug: "jennifer-r-morisco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward J.",
    lastName: "Moroni",
    title: "Executive Director, Operations and Manhattanville Planning",
    slug: "edward-j-moroni",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Morrison",
    title: "Senior Data Coordinator",
    slug: "megan-morrison",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Aurora",
    lastName: "Morrison",
    title: "Executive Assistant",
    slug: "aurora-morrison",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richlin M",
    lastName: "Morrow",
    title: "Operations Manager",
    slug: "richlin-m-morrow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bridget Audrey",
    lastName: "Morse-Karzen",
    title: "Res Mgr, Ctr for Health Policy",
    slug: "bridget-audrey-morse-karzen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marcus M",
    lastName: "Mortise",
    title: "Technical Support Specialist",
    slug: "marcus-m-mortise",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julia",
    lastName: "Morton",
    title:
      " Director of Development, Columbia College, Arts & Sciences and GSAS",
    slug: "julia-morton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John J",
    lastName: "Morton",
    title: "Intermediate App Developer",
    slug: "john-j-morton",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tumelo",
    lastName: "Mosaka",
    title: "Project Director",
    slug: "tumelo-mosaka",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamila Gerald",
    lastName: "Mosley",
    title:
      " Director, Raising Educational Achievement Coalition of Harlem (REACH)",
    slug: "jamila-gerald-mosley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gwendolyn",
    lastName: "Mosley",
    title: "Administrative Assistant",
    slug: "gwendolyn-mosley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Mosquera",
    title: "Director of Academic Administration",
    slug: "laura-mosquera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Meritza E.",
    lastName: "Moss",
    title: "Financial Assistant",
    slug: "meritza-e-moss",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Demetrius",
    lastName: "Mossaidis",
    title: "Senior Director of Enterprise Systems",
    slug: "demetrius-mossaidis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sean J.",
    lastName: "Mota",
    title: "Systems Manager",
    slug: "sean-j-mota",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amitis",
    lastName: "Motevalli",
    title: "Visiting Researcher",
    slug: "amitis-motevalli",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karyna",
    lastName: "Motta",
    title: "Diagnostic Imaging Specialist II",
    slug: "karyna-motta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tanya N.",
    lastName: "Mottley",
    title: "Senior Director, Budget Planning and Finance",
    slug: "tanya-n-mottley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anjna",
    lastName: "Motwani",
    title: "Senior Associate Director, MBA Careeer Education and Advising",
    slug: "anjna-motwani",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stephon",
    lastName: "Moulterie",
    title: "Officer-Career Placement",
    slug: "stephon-moulterie",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rosine Thomas",
    lastName: "Moussa",
    title: "Center Administrator",
    slug: "rosine-thomas-moussa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bohari",
    lastName: "Moussa",
    title: "Time and Labor Manager, HRPC Data Integrity",
    slug: "bohari-moussa",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Isabelle",
    lastName: "Mouton",
    title: "Assistant Director of Enrollment Management Systems and Slate",
    slug: "isabelle-mouton",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Deborah",
    lastName: "Mowshowitz",
    title: "Dir Undergrad Prog & Lab Oper",
    slug: "deborah-mowshowitz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Janet",
    lastName: "Moy",
    title: "Director of Academic Affairs",
    slug: "janet-moy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alyssa",
    lastName: "Moya-Lopez",
    title: "Student Success and Intervention Case Manager",
    slug: "alyssa-moya-lopez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Olga",
    lastName: "Mozias",
    title: "Application Specialist, Finance Information Systems (FIS)",
    slug: "olga-mozias",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Catherine Louise",
    lastName: "Muccini",
    title: "Associate Director, Institutional Research",
    slug: "catherine-louise-muccini",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Roswell",
    lastName: "Mueller",
    title:
      " Executive Director, Strategic Communications, Marketing, Editorial and Events",
    slug: "roswell-mueller",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Leslie A",
    lastName: "Mueller",
    title: "Training Coordinator",
    slug: "leslie-a-mueller",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Chukwuma Jude",
    lastName: "Mueme",
    title: "Program Associate",
    slug: "chukwuma-jude-mueme",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Molly Jean",
    lastName: "Muench",
    title: "Senior Associate Director",
    slug: "molly-jean-muench",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abdul Malik",
    lastName: "Muftau",
    title: "Program Manager",
    slug: "abdul-malik-muftau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven Revell",
    lastName: "Muhammad",
    title: "Associate Director of Finance and Grants Administration",
    slug: "steven-revell-muhammad",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kawthar A.",
    lastName: "Muhammad",
    title: "Data Manager",
    slug: "kawthar-a-muhammad",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shirley",
    lastName: "Mui",
    title: "Staff",
    slug: "shirley-mui",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dmitriy",
    lastName: "Mullakandov",
    title: "Senior Manager, Applications Systems Administration",
    slug: "dmitriy-mullakandov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lani C.",
    lastName: "Muller",
    title: "Dir, Academic Admin & Finance",
    slug: "lani-c-muller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacqueline",
    lastName: "Muller",
    title: "Administrative Manager",
    slug: "jacqueline-muller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amelia C.",
    lastName: "Mullins",
    title: "Training & Education Coordinator",
    slug: "amelia-c-mullins",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Uyanga",
    lastName: "Mungunchimeg",
    title: "Assistant Director of Employment Partnerships",
    slug: "uyanga-mungunchimeg",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Matthew A.",
    lastName: "Muniz",
    title: "Social Media Manager",
    slug: "matthew-a-muniz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karen T",
    lastName: "Muniz",
    title: "Lab Manager",
    slug: "karen-t-muniz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andy",
    lastName: "Muniz",
    title: "HR Onboarding Assistant",
    slug: "andy-muniz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Raquel",
    lastName: "Munoz",
    title: "Assistant Provost for Academic Appointments",
    slug: "raquel-munoz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Leniza A.",
    lastName: "Munoz",
    title: "Path Asst with Regulatory Comp",
    slug: "leniza-a-munoz",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Ivannia",
    lastName: "Munoz",
    title: "Administrative Coordinator",
    slug: "ivannia-munoz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Freddy R",
    lastName: "Munoz",
    title: "Senior Grants Specialist",
    slug: "freddy-r-munoz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jordan D",
    lastName: "Munro-Rankin",
    title: "Variabl Hour Officer",
    slug: "jordan-d-munro-rankin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristabelle",
    lastName: "Munson",
    title: "Assc Registrar, Dir Client Svc",
    slug: "kristabelle-munson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Hannah E.",
    lastName: "Munson",
    title: "Cooridnator, Lab Res Ops",
    slug: "hannah-e-munson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charlotte M",
    lastName: "Munson",
    title: "Associate Director of Strategic Initiatives and Partnerships",
    slug: "charlotte-m-munson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan R",
    lastName: "Muntean",
    title: "Project Coordinator",
    slug: "jonathan-r-muntean",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dickens",
    lastName: "Murat",
    title: "Administrative Aide",
    slug: "dickens-murat",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara Therese",
    lastName: "Murphy",
    title: "Associate Director of Admissions",
    slug: "sara-therese-murphy",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sean B",
    lastName: "Murphy",
    title: "Senior Manager - Digital Content",
    slug: "sean-b-murphy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Joan M",
    lastName: "Murphy",
    title: "Coding Manager",
    slug: "joan-m-murphy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joni",
    lastName: "Murphy",
    title: "Senior Webinar Specialist",
    slug: "joni-murphy",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erin Maureen",
    lastName: "Murphy",
    title: "Administrative Assistant",
    slug: "erin-maureen-murphy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine",
    lastName: "Murphy",
    title: "Senior Associate Director, Admissions",
    slug: "catherine-murphy",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michael",
    lastName: "Murray",
    title: "Associate Director, Compliance",
    slug: "michael-murray",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Monique",
    lastName: "Murray",
    title: "Assistant Director, Accounting and Business Management",
    slug: "monique-murray",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David",
    lastName: "Murray",
    title: "Director of Development for University Initiatives",
    slug: "david-murray",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Catherine",
    lastName: "Murray Dwyer",
    title: "Assistant Vice President for Principal Gifts",
    slug: "catherine-murray-dwyer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Catherine L.",
    lastName: "Muse Walden",
    title: "Academic Program Support in Professional Studies",
    slug: "catherine-l-muse-walden",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Linda",
    lastName: "Muskat-Rim",
    title: "Sr Assoc Dean, Mktg&Strat Comm",
    slug: "linda-muskat-rim",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "MaryAnn",
    lastName: "Mustac",
    title: "Associate Director for Special Projects",
    slug: "maryann-mustac",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zarina",
    lastName: "Mustapha",
    title: "Senior Web Developer",
    slug: "zarina-mustapha",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dina",
    lastName: "Muthana",
    title: "Human Resources Associate",
    slug: "dina-muthana",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kadzi N",
    lastName: "Mutizwa",
    title: "Senior Associate Director",
    slug: "kadzi-n-mutizwa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kasivisweswara Rao",
    lastName: "Muvvala",
    title: "Sr. Application Systems Developer",
    slug: "kasivisweswara-rao-muvvala",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sky",
    lastName: "Myers",
    title: "Contractor",
    slug: "sky-myers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mindy E.",
    lastName: "Myers",
    title: "Program Manager, Academic Affairs",
    slug: "mindy-e-myers",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kevin",
    lastName: "Myers",
    title: "Ergonomist",
    slug: "kevin-myers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elianne Esperanza",
    lastName: "Myers",
    title: "Technical Support Specialist",
    slug: "elianne-esperanza-myers",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Urania",
    lastName: "Mylonas",
    title: "Deputy Director of Strategic Donor Relations and Stewardship",
    slug: "urania-mylonas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Spyridon",
    lastName: "Mylonas",
    title: "Managing Director, AI Research Center",
    slug: "spyridon-mylonas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Samuel J",
    lastName: "Myung",
    title: "Financial Assistant",
    slug: "samuel-j-myung",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Henry E.",
    lastName: "Nabong",
    title: "Associate Director, Columbia College Finance",
    slug: "henry-e-nabong",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole",
    lastName: "Naclerio",
    title: "Supervisor, Slide Send Out",
    slug: "nicole-naclerio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Whitney",
    lastName: "Nadeau",
    title: "Leadership Gift Officer, University Development",
    slug: "whitney-nadeau",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nadine T.",
    lastName: "Nader",
    title: "Senior Data Manager",
    slug: "nadine-t-nader",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Noor",
    lastName: "Nahar",
    title: "Senior Project Lead, Systems Development, HRIS",
    slug: "noor-nahar",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ashley Simone",
    lastName: "Nail",
    title:
      " Assistant Dean of Academic Programming, Center for the Core Curriculum",
    slug: "ashley-simone-nail",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Binu V.",
    lastName: "Nair",
    title: "Managing Director",
    slug: "binu-v-nair",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anjana",
    lastName: "Nair",
    title: "Communication Manager",
    slug: "anjana-nair",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hussein S.",
    lastName: "Najafee",
    title: "Accounts Payable Manager",
    slug: "hussein-s-najafee",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tyler",
    lastName: "Najara",
    title: "Ass't Service Desk Tech - Temp",
    slug: "tyler-najara",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ayube",
    lastName: "Najeer",
    title: "Accounts Payable Specialist",
    slug: "ayube-najeer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shoko",
    lastName: "Nakamoto-Musumeci",
    title: "Associate Director",
    slug: "shoko-nakamoto-musumeci",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trisha",
    lastName: "Nakhul",
    title: "Accounting Assistant",
    slug: "trisha-nakhul",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amanda",
    lastName: "Nakhul",
    title: "SYEP Clerical Aide",
    slug: "amanda-nakhul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Coretta",
    lastName: "Nalls",
    title: "Community researcher on Movements Against Mass Incarceration",
    slug: "coretta-nalls",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Madhavi",
    lastName: "Nambiar",
    title: "Assc Director, Research Ops",
    slug: "madhavi-nambiar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Noah Jin",
    lastName: "Namgoong",
    title: "High School Program Assistant",
    slug: "noah-jin-namgoong",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alexandra",
    lastName: "Nana",
    title: "Technical Support Specialist",
    slug: "alexandra-nana",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Libby Jauvtis",
    lastName: "Nance",
    title: "Department Administrator/COO",
    slug: "libby-jauvtis-nance",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erika Rose",
    lastName: "Nannery",
    title: "Assoc Director of Operations",
    slug: "erika-rose-nannery",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alyssa Marie",
    lastName: "Napier",
    title: "Associate Editor",
    slug: "alyssa-marie-napier",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Udee L",
    lastName: "Narayan",
    title: "Director of Operations",
    slug: "udee-l-narayan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristen",
    lastName: "Nardullo Mahood",
    title: "Dep Vice President-Development",
    slug: "kristen-nardullo-mahood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Narvaez",
    title: "MPA",
    slug: "matthew-narvaez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Namra",
    lastName: "Naseer",
    title: "Industry Relations Specialist, Career Design Lab",
    slug: "namra-naseer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mona Anis Saleh",
    lastName: "Naser",
    title: "Manager - Financial Operations",
    slug: "mona-anis-saleh-naser",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Angela M.",
    lastName: "Natale",
    title: "Administrative Coordinator",
    slug: "angela-m-natale",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Padmanabhan",
    lastName: "Natarajan",
    title: "Lead Application Systems Developer",
    slug: "padmanabhan-natarajan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jayasree",
    lastName: "Natarajan",
    title: "Director, Desktop Support",
    slug: "jayasree-natarajan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nancy",
    lastName: "Natelli",
    title: "Associate Director, Finance Human Resources",
    slug: "nancy-natelli",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Cassandra",
    lastName: "Nathan",
    title: "Assistant Director-Internal Communications",
    slug: "cassandra-nathan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kerri",
    lastName: "Natkiel",
    title: "Sr. Director-Clncal Revenue/Op",
    slug: "kerri-natkiel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarah K.",
    lastName: "Naumes",
    title: "Director of Strategic Research Development",
    slug: "sarah-k-naumes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Afshan",
    lastName: "Nawaz",
    title: "Associate Manager Guest Services",
    slug: "afshan-nawaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vijayakumar",
    lastName: "Nayudupalli",
    title: "Project Director",
    slug: "vijayakumar-nayudupalli",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Victoria G.",
    lastName: "Nazario",
    title: "Director of Sponsored Projects Finance and Reporting",
    slug: "victoria-g-nazario",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth",
    lastName: "Nazario",
    title: "Claims Mgr Spec",
    slug: "elizabeth-nazario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mariya",
    lastName: "Nazginova",
    title: "Associate General Counsel",
    slug: "mariya-nazginova",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Maria C.",
    lastName: "Neagoe",
    title: "Department Administrator",
    slug: "maria-c-neagoe",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "April St.Theresa",
    lastName: "Neal",
    title: "Manager, Professional Development & Leadership Program",
    slug: "april-st-theresa-neal",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ryan",
    lastName: "Neary",
    title: "Finance Administrator, Academic Affairs",
    slug: "ryan-neary",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ellen Pullekines",
    lastName: "Neff",
    title: "Manager-Science Communication",
    slug: "ellen-pullekines-neff",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lauren Marie",
    lastName: "Negron",
    title: "Admissions Operations Specialist",
    slug: "lauren-marie-negron",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Dianelis",
    lastName: "Negron",
    title: "Talent Acquisition Specialist",
    slug: "dianelis-negron",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "JoAnn E.",
    lastName: "Neil",
    title: "Administrative Coordinator",
    slug: "joann-e-neil",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ushma S.",
    lastName: "Neill",
    title:
      " Chief of Staff to the President and Vice President for Campus Alignment",
    slug: "ushma-s-neill",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heidi",
    lastName: "Neilson",
    title: "Website Designer",
    slug: "heidi-neilson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Geovanna C.",
    lastName: "Neira",
    title: "Administrative Assistant I",
    slug: "geovanna-c-neira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Micah",
    lastName: "Nelson",
    title: "Asst Service Desk Tech-Tier I",
    slug: "micah-nelson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gregory Aruna",
    lastName: "Nelson",
    title: "Program Manager for Advising",
    slug: "gregory-aruna-nelson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Camilla Ravazzi",
    lastName: "Nelson",
    title: "Assistant Director, HR",
    slug: "camilla-ravazzi-nelson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Christina L.",
    lastName: "Nelson",
    title: "Senior Managing Editor",
    slug: "christina-l-nelson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Celina Chatman",
    lastName: "Nelson",
    title:
      " Senior Associate Dean for Academic Diversity and Professional Development",
    slug: "celina-chatman-nelson",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Katherine R.",
    lastName: "Nemetz",
    title: "Assistant Director, Events and Communications",
    slug: "katherine-r-nemetz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gwen",
    lastName: "Nero",
    title: "Director, Industry Relations",
    slug: "gwen-nero",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Barbara",
    lastName: "Nesmith",
    title: "Program Assistant",
    slug: "barbara-nesmith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claire",
    lastName: "Netemeyer",
    title: "Assistant Director, Academic and Student Affairs",
    slug: "claire-netemeyer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristin",
    lastName: "Neuman",
    title: "Sr. Technology Licensing Officer",
    slug: "kristin-neuman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Grace K.",
    lastName: "Neveu",
    title: "Assistant Director - Pre Award",
    slug: "grace-k-neveu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Beth L.",
    lastName: "Neville",
    title: "Director of Finance and Data Management",
    slug: "beth-l-neville",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle",
    lastName: "Nevin",
    title: "Accountant, Capital Asset Accounting",
    slug: "michelle-nevin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cynthia",
    lastName: "Nevins",
    title: "Administrative Aide",
    slug: "cynthia-nevins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Newhall",
    title: "Associate Director, Academic Services and Innovation",
    slug: "amy-newhall",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole Grace",
    lastName: "Newham",
    title: "Associate Director",
    slug: "nicole-grace-newham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia",
    lastName: "Newkirk",
    title: "Biller",
    slug: "patricia-newkirk",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauren Therese",
    lastName: "Newman",
    title: "Assistant Director, Media and Advertising",
    slug: "lauren-therese-newman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alexis M",
    lastName: "Newman",
    title: "Director of Strategic Events & Programming",
    slug: "alexis-m-newman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher J",
    lastName: "Newsome",
    title: "Sr Coordinator, Rsch Edu Ops",
    slug: "christopher-j-newsome",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cullen O'Connor",
    lastName: "Newton",
    title: "Director of Employer Outreach",
    slug: "cullen-o-connor-newton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "David C",
    lastName: "Newtown",
    title: "Administrative Assistant",
    slug: "david-c-newtown",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Larry",
    lastName: "Ng",
    title: "Service Specialist",
    slug: "larry-ng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cynthia",
    lastName: "Ng",
    title: "Regulatory Coordinator II",
    slug: "cynthia-ng",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Carmen",
    lastName: "Ng",
    title: "Director, Academic and Student Affairs",
    slug: "carmen-ng",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Madeleine C.",
    lastName: "Ngo",
    title: "Assoc Dir, Ops,Strat & Fin Ana",
    slug: "madeleine-c-ngo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alen",
    lastName: "Ngomuo",
    title: "Admissions Operations Assistant (Document Management)",
    slug: "alen-ngomuo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Willson Ngoc",
    lastName: "Nguyen",
    title: "Financial Coordinator",
    slug: "willson-ngoc-nguyen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Viet",
    lastName: "Nguyen",
    title: "Lead Service Specialist",
    slug: "viet-nguyen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thanh Thanh Thi",
    lastName: "Nguyen",
    title: "Social Media Manager & Content Strategist",
    slug: "thanh-thanh-thi-nguyen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tan T.",
    lastName: "Nguyen",
    title: "Assistant Dean",
    slug: "tan-t-nguyen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Regina Thanh-Yen Bui",
    lastName: "Nguyen",
    title: "Live Support Specialist",
    slug: "regina-thanh-yen-bui-nguyen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peter",
    lastName: "Nguyen",
    title: "Assistant Director of Donor Relations",
    slug: "peter-nguyen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Minh D",
    lastName: "Nguyen",
    title: "Lead Service Desk Specialist",
    slug: "minh-d-nguyen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Denny T",
    lastName: "Nguyen",
    title: "Administrative Coordinator",
    slug: "denny-t-nguyen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Duong Thi Hong",
    lastName: "Nguyen",
    title: "Senior Accountant, Sponsored Projects Finance Cash Team",
    slug: "duong-thi-hong-nguyen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laura K.",
    lastName: "Nicholas",
    title: "Assoc Director, Executive Comm",
    slug: "laura-k-nicholas",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jonathan David Miller",
    lastName: "Nicholas",
    title: "Shohamy Lab Alum",
    slug: "jonathan-david-miller-nicholas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda",
    lastName: "Nicholas",
    title: "Associate Director, Operations",
    slug: "amanda-nicholas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexis R",
    lastName: "Nicholas",
    title: "Manager, HR/FA",
    slug: "alexis-r-nicholas",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Christine",
    lastName: "Nicholson",
    title: "Events Coordinator",
    slug: "christine-nicholson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Camille",
    lastName: "Nicholson",
    title: "Office Manager, Labor Relations",
    slug: "camille-nicholson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marlon",
    lastName: "Nieto",
    title: "Administrative Director",
    slug: "marlon-nieto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carmen",
    lastName: "Nieves",
    title: "Senior Coordinator, Research Compliance",
    slug: "carmen-nieves",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Destin",
    lastName: "Nieves",
    title: "HR Onboarding Assistant",
    slug: "destin-nieves",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Yoshiko",
    lastName: "Niiya",
    title: "Assistant Director",
    slug: "yoshiko-niiya",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "May",
    lastName: "Niiya",
    title: "Assistant Director - Finance & Admin",
    slug: "may-niiya",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Manmeet K",
    lastName: "Nijjer",
    title: "Assistant Director of Programs",
    slug: "manmeet-k-nijjer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mya",
    lastName: "Nikitas",
    title: "High School Program Assistant",
    slug: "mya-nikitas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Erwin R",
    lastName: "Nin Diaz",
    title: "Porter",
    slug: "erwin-r-nin-diaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leslie",
    lastName: "Nina",
    title: "Senior Associate Director, Constituent Analytics",
    slug: "leslie-nina",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Madeline",
    lastName: "Ninno",
    title: "Project Officer",
    slug: "madeline-ninno",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anely",
    lastName: "Ninonuevo",
    title: "Senior Administrative Manager",
    slug: "anely-ninonuevo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dita",
    lastName: "Niraula",
    title: "Coordinator Care Management",
    slug: "dita-niraula",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane",
    lastName: "Nisselson",
    title: "Director of Multimedia Communications",
    slug: "jane-nisselson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "McKenna",
    lastName: "Nisson",
    title: "Admin Assistant",
    slug: "mckenna-nisson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alicia",
    lastName: "Nixon-Taft",
    title: "Senior Project Officer",
    slug: "alicia-nixon-taft",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Darlyncia",
    lastName: "Nobrun",
    title: "DEI Program Manager",
    slug: "darlyncia-nobrun",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Petra",
    lastName: "Noel",
    title: "Development Assistant",
    slug: "petra-noel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah C",
    lastName: "Noell",
    title: "Sr Publicist",
    slug: "sarah-c-noell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yakira",
    lastName: "Nolasco",
    title: "Research Administrative Coord",
    slug: "yakira-nolasco",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole",
    lastName: "Nolasco",
    title: "Administrative Services Coordinator",
    slug: "nicole-nolasco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maricon",
    lastName: "Nolasco",
    title: "Lab Aide",
    slug: "maricon-nolasco",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Liam J.",
    lastName: "Noonan",
    title: "Director of Finance and Administration",
    slug: "liam-j-noonan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Arif",
    lastName: "Noori",
    title: "Director of Technology Strategy & Innovation",
    slug: "arif-noori",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shavonne N.",
    lastName: "Norris",
    title: "Director of Employee Relations and Development",
    slug: "shavonne-n-norris",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle Boachie-Ansah",
    lastName: "Norton",
    title: "Manager, Financial Aid and Operations",
    slug: "michelle-boachie-ansah-norton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Clare R.",
    lastName: "Norton",
    title: "Senior Associate Dean of Enrollment Management",
    slug: "clare-r-norton",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lisa King",
    lastName: "Nouri",
    title: "Director, Research Strategy and Consulting",
    slug: "lisa-king-nouri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Glenn",
    lastName: "Novarr",
    title: "Senior Assistant Dean for Academic Affairs",
    slug: "glenn-novarr",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rocio",
    lastName: "Novo",
    title: "Assistant Director, Administration - Applied Analytics",
    slug: "rocio-novo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel",
    lastName: "Noyola",
    title: "Grants Administrator",
    slug: "daniel-noyola",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patricia",
    lastName: "Nriaka",
    title: "Admissions Assistant",
    slug: "patricia-nriaka",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Blessing",
    lastName: "Nuga",
    title: "Department Administrator",
    slug: "blessing-nuga",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Nunez",
    title: "Administrative Assistant",
    slug: "stephanie-nunez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosalia",
    lastName: "Nunez",
    title: "Call Center Agent",
    slug: "rosalia-nunez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michele A",
    lastName: "Nunez",
    title: "Director, Onboarding Services",
    slug: "michele-a-nunez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jessica L.",
    lastName: "Nunez",
    title: "Executive Director for Community Standards and Accountability",
    slug: "jessica-l-nunez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Juan Carlos",
    lastName: "Nunez",
    title: "Chef Manager",
    slug: "juan-carlos-nunez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janice",
    lastName: "Nunez",
    title: "Administrative Assistant II",
    slug: "janice-nunez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jose A.",
    lastName: "Nunez",
    title: "Director, Budget and Finance",
    slug: "jose-a-nunez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Edwin A.",
    lastName: "Nunez",
    title: "Manager, Fin and Busi Off Ops",
    slug: "edwin-a-nunez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Analisa",
    lastName: "Nunez",
    title: "Administrative Assistant I",
    slug: "analisa-nunez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amalfi",
    lastName: "Nunez",
    title: "Senior Surgical Scheduler",
    slug: "amalfi-nunez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Manuel",
    lastName: "Nunez Almonte",
    title: "Fullstack Web Developer",
    slug: "manuel-nunez-almonte",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tiara Zekaya",
    lastName: "Nurse",
    title: "Administrative Manager, Training and Education",
    slug: "tiara-zekaya-nurse",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Quy G",
    lastName: "O",
    title: "Associate Director of Technology Services",
    slug: "quy-g-o",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Niamh H.",
    lastName: "O'Brien",
    title:
      " Senior Associate Dean of Alumni and Undergraduate Career Development",
    slug: "niamh-h-o-brien",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jarred Lee Buford",
    lastName: "O'Brien",
    title: "Sr. Applications Systems Developer",
    slug: "jarred-lee-buford-o-brien",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sheila M",
    lastName: "O'Byrne",
    title: "Senior Program Manager",
    slug: "sheila-m-o-byrne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin",
    lastName: "O'Connell",
    title: "Assistant Director, Graduate Programs",
    slug: "erin-o-connell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole",
    lastName: "O'Connor",
    title: "Executive Assistant",
    slug: "nicole-o-connor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kurt",
    lastName: "O'Connor",
    title: "LAN Sys Admin - Senior",
    slug: "kurt-o-connor",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Acacia Marie",
    lastName: "O'Connor",
    title: "Social Media Consultant",
    slug: "acacia-marie-o-connor",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Diana",
    lastName: "O'Donnell",
    title:
      " Senior Associate Director of Admissions, Director of Undergraduate Recruitment",
    slug: "diana-o-donnell",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Caitlin M",
    lastName: "O'Donnell",
    title: "Director",
    slug: "caitlin-m-o-donnell",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Megan",
    lastName: "O'Donovan",
    title: "Associate Director, Continuing Education",
    slug: "megan-o-donovan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vincent J",
    lastName: "O'Grady",
    title: "Accounts Payable Specialist",
    slug: "vincent-j-o-grady",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maeve Teresa",
    lastName: "O'Grady",
    title: "Academic Secretary",
    slug: "maeve-teresa-o-grady",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eric L.",
    lastName: "O'Hanlon",
    title: "Head, Development, Infrastructure and Applications",
    slug: "eric-l-o-hanlon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Merit Elisabeth",
    lastName: "O'Hare",
    title: "English Education Program Associate",
    slug: "merit-elisabeth-o-hare",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alison Ewing",
    lastName: "O'Loughlin",
    title: "Senior Executive Director",
    slug: "alison-ewing-o-loughlin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "O'Malley Jr",
    title: "Manager of Operations and Systems",
    slug: "michael-o-malley-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Georgia Mary",
    lastName: "O'Neil",
    title: "Coordinator-Communication Adm",
    slug: "georgia-mary-o-neil",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anna Marie M.",
    lastName: "O'Neill",
    title: "Senior Director for Budget and Financial Reporting",
    slug: "anna-marie-m-o-neill",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Hollis B.",
    lastName: "O'Rorke",
    title: "Director",
    slug: "hollis-b-o-rorke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melissa",
    lastName: "O'Rourke",
    title: "Communications Coordinator",
    slug: "melissa-o-rourke",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kevin",
    lastName: "O'Rourke",
    title: "Director of Finance",
    slug: "kevin-o-rourke",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth",
    lastName: "Oakley",
    title: "Executive Assistant Strategic Communications and Event",
    slug: "elizabeth-oakley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Risa",
    lastName: "Obara",
    title: "Finance and Compliance Manager, Sponsored Projects Finance",
    slug: "risa-obara",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ngozi",
    lastName: "Obi",
    title: "Non-Student STC",
    slug: "ngozi-obi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aida",
    lastName: "Ocasio",
    title: "Front Desk Specialist/CMA or RMA",
    slug: "aida-ocasio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julande",
    lastName: "Ocean",
    title: "Senior Assistant Bursar",
    slug: "julande-ocean",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrew Justin",
    lastName: "Ochoa",
    title: "Grants Manager, Office of Sponsored Projects",
    slug: "andrew-justin-ochoa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathleen Anne",
    lastName: "Ochs",
    title: "Bus Mgr,Clin Path & Ctr Adv LM",
    slug: "kathleen-anne-ochs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Awuraama",
    lastName: "Ocran",
    title: "Coding and Charge Edit Specialist I",
    slug: "awuraama-ocran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret D",
    lastName: "ODonnell",
    title: "Project Manager",
    slug: "margaret-d-odonnell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle Marie",
    lastName: "Officer",
    title: "Assoc Dean for DEI",
    slug: "danielle-marie-officer",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Xiomara",
    lastName: "Ogando",
    title: "Administrative Manager",
    slug: "xiomara-ogando",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Stephanie Anne",
    lastName: "Ogden",
    title: "Associate Director, Media Production",
    slug: "stephanie-anne-ogden",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicole H.",
    lastName: "Ogden",
    title: "Associate Director, Business Services",
    slug: "nicole-h-ogden",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kevin",
    lastName: "OGilvie",
    title: "Director, IT Infrastructure Controls",
    slug: "kevin-ogilvie",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ryoko",
    lastName: "Ogino",
    title: "Managing Director",
    slug: "ryoko-ogino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lena",
    lastName: "Ogren",
    title: "Info Sec Program Manager",
    slug: "lena-ogren",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stella",
    lastName: "Oh",
    title: "One Time Payment (ARTE)",
    slug: "stella-oh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ingrid Marie",
    lastName: "Ohara",
    title: "Admin Coord, Grants/Payroll",
    slug: "ingrid-marie-ohara",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mara Therese",
    lastName: "Ohorodnik",
    title: "Asst Director - Communications",
    slug: "mara-therese-ohorodnik",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jahmal Joan",
    lastName: "Ojeda Velazquez",
    title: "Program Administrator",
    slug: "jahmal-joan-ojeda-velazquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Midori",
    lastName: "Oka",
    title: "Associate Director",
    slug: "midori-oka",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jasmine",
    lastName: "Okeagu",
    title: "SYEP Clerical Aide",
    slug: "jasmine-okeagu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Quadri",
    lastName: "Olanlege",
    title: "Assistant Director, Student Engagement and Corporate Relations",
    slug: "quadri-olanlege",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lilian A",
    lastName: "Oling",
    title: "Division Admin",
    slug: "lilian-a-oling",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sandra L",
    lastName: "Olivares",
    title: "Front Desk Receptionist",
    slug: "sandra-l-olivares",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tanisha Nicole",
    lastName: "Oliver",
    title: "Associate Dean, Human Resources and Academic Appointments",
    slug: "tanisha-nicole-oliver",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melissa Ann",
    lastName: "Oliver",
    title: "Deaf and Hard of Hearing Education Specialist",
    slug: "melissa-ann-oliver",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christine",
    lastName: "Oliveras",
    title: "Call Center Scheduling Representative",
    slug: "christine-oliveras",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marika",
    lastName: "Olsen",
    title: "Director, Communications",
    slug: "marika-olsen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John Harold",
    lastName: "Olsen",
    title: "Senior Project Manager",
    slug: "john-harold-olsen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eunice",
    lastName: "Olugbile",
    title: "Assistant Director, Communications",
    slug: "eunice-olugbile",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Virgen M.",
    lastName: "Onativia",
    title: "Research Operations Manager",
    slug: "virgen-m-onativia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tiffany",
    lastName: "Onorato Hughes",
    title: "Associate Dean, Graduate Programs",
    slug: "tiffany-onorato-hughes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chisimdi Nkemka",
    lastName: "Onwuteaka",
    title: "Communications Officer",
    slug: "chisimdi-nkemka-onwuteaka",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alexa M",
    lastName: "Oord",
    title: "Associate Director, Administration and Special Projects",
    slug: "alexa-m-oord",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Oppenheimer",
    title: "Senior Grants Manager",
    slug: "emily-oppenheimer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kylie A",
    lastName: "Oquendo",
    title: "Human Resources Associate",
    slug: "kylie-a-oquendo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ariel P",
    lastName: "Oquendo",
    title: "Procedure Scheduling Coordinator",
    slug: "ariel-p-oquendo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yelissa",
    lastName: "Ordonez",
    title: "Data Entry Clerk",
    slug: "yelissa-ordonez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ageliki",
    lastName: "Orfanos",
    title: "Director, Financial Reporting",
    slug: "ageliki-orfanos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sherly",
    lastName: "Orilas",
    title: "Output Systems Coordinator",
    slug: "sherly-orilas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chanel",
    lastName: "Orkopoulos",
    title: "Research Manager",
    slug: "chanel-orkopoulos",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Devon",
    lastName: "Ormsby",
    title: "Director, IT Systems and Infrastructure",
    slug: "devon-ormsby",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nathania",
    lastName: "Ornis",
    title: "Project Coordinator",
    slug: "nathania-ornis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael R.",
    lastName: "Orrange",
    title: "Associate Director Communications",
    slug: "michael-r-orrange",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Janelle",
    lastName: "Ortega",
    title: "Sr IRB Specialist-Manager",
    slug: "janelle-ortega",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Iliana",
    lastName: "Ortega",
    title: "Assistant Director for CLS Summer Funding Programs",
    slug: "iliana-ortega",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edgar F",
    lastName: "Ortega",
    title: "Administrative Coordinator",
    slug: "edgar-f-ortega",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cristina",
    lastName: "Ortega",
    title: "Tech B",
    slug: "cristina-ortega",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yvonne Torruella",
    lastName: "Ortiz",
    title: "Assoc Dean,InclusiveExcellence",
    slug: "yvonne-torruella-ortiz",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Vivian",
    lastName: "Ortiz",
    title: "Coordinator",
    slug: "vivian-ortiz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vynessa",
    lastName: "Ortiz",
    title:
      " Assistant Dean, Student Affairs (High School and Non Degree Programs)",
    slug: "vynessa-ortiz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nadine",
    lastName: "Ortiz",
    title: "Coding Supervisor",
    slug: "nadine-ortiz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Martha I.",
    lastName: "Ortiz",
    title: "Revenue Cycle Manager",
    slug: "martha-i-ortiz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melody",
    lastName: "Ortiz",
    title: "Assoc Dean-Admin Affs/CAO",
    slug: "melody-ortiz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lourdes",
    lastName: "Ortiz",
    title: "Finance and Compliance Manager, Sponsored Projects Finance",
    slug: "lourdes-ortiz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessenia Yolanda",
    lastName: "Ortiz",
    title: "Secretary B",
    slug: "jessenia-yolanda-ortiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jasmine",
    lastName: "Ortiz",
    title: "Media Services Administrator",
    slug: "jasmine-ortiz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Josehanny I.",
    lastName: "Ortiz",
    title: "Business Manager-Division",
    slug: "josehanny-i-ortiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabriella Grace",
    lastName: "Ortiz",
    title: "RFMH Tech",
    slug: "gabriella-grace-ortiz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Edwin",
    lastName: "Ortiz",
    title: "Student Mail Center Employee",
    slug: "edwin-ortiz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Eugenia",
    lastName: "Ortiz",
    title: "Coding Charge Edits Spc II",
    slug: "eugenia-ortiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erika I",
    lastName: "Ortiz",
    title: "Secretary B",
    slug: "erika-i-ortiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David J",
    lastName: "Ortiz",
    title: "Senior Grants Manager",
    slug: "david-j-ortiz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Catalina",
    lastName: "Ortiz",
    title: "Assistant Director, Budget Operations",
    slug: "catalina-ortiz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christopher A",
    lastName: "Ortiz",
    title: "Administrative Assistant",
    slug: "christopher-a-ortiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dennis",
    lastName: "Ortiz Jr",
    title: "Onboarding Specialist III",
    slug: "dennis-ortiz-jr",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael E",
    lastName: "Orzechowski",
    title: "Director of Housing and Campus Services",
    slug: "michael-e-orzechowski",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Naoki",
    lastName: "Osawa",
    title: "Administrative Assistant",
    slug: "naoki-osawa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren Nicole",
    lastName: "Osborn",
    title: "Senior Data Coordinator",
    slug: "lauren-nicole-osborn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chandra E.",
    lastName: "Osborne",
    title: "Assistant Director, University Ceremonies",
    slug: "chandra-e-osborne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Osborne",
    title: "Talent Services Generalist",
    slug: "ashley-osborne",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle",
    lastName: "Osei",
    title: "Associate Director, Internal Audit",
    slug: "michelle-osei",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joyce A",
    lastName: "Osei",
    title: "Administrative Assistant",
    slug: "joyce-a-osei",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martins Oyathelemi",
    lastName: "Oshoke",
    title: "Asst Manager-Housing",
    slug: "martins-oyathelemi-oshoke",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Debra L.",
    lastName: "Osinsky",
    title: "Retired",
    slug: "debra-l-osinsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Osorio",
    title: "Project Coordinator",
    slug: "michael-osorio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph A",
    lastName: "Ostrow",
    title: "Analytics Developer",
    slug: "joseph-a-ostrow",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joannie",
    lastName: "Otanez",
    title: "Generalist-Human Resources",
    slug: "joannie-otanez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sugeiry",
    lastName: "Otano",
    title: "Billing Specialist",
    slug: "sugeiry-otano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Judith",
    lastName: "Otero",
    title: "Assistant Business Manager",
    slug: "judith-otero",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yumi",
    lastName: "Otsu",
    title: "Assistant Director of Operations and Student Outreach",
    slug: "yumi-otsu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bianca",
    lastName: "Ottley",
    title: "CTV Administrative Coordinator",
    slug: "bianca-ottley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wenli",
    lastName: "Ou",
    title: "Bibliographic Assistant VII",
    slug: "wenli-ou",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John M.",
    lastName: "Oursler",
    title:
      " Senior Assc Director of Development for Industry Relations and Philanthropy (Film)",
    slug: "john-m-oursler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marguerite K",
    lastName: "Outlaw",
    title: "Executive Secretary",
    slug: "marguerite-k-outlaw",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Toni",
    lastName: "Ouyang",
    title: "Admissions Assistant",
    slug: "toni-ouyang",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sandra",
    lastName: "Ovalles",
    title: "Office Manager",
    slug: "sandra-ovalles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karinne E.",
    lastName: "Ovalles",
    title: "Manager, Diversity/Cul Aff(s)",
    slug: "karinne-e-ovalles",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Sandra B",
    lastName: "Overo",
    title: "Associate Director, Academic and Budget Operations",
    slug: "sandra-b-overo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Liza",
    lastName: "Ovinova",
    title: "Specialist",
    slug: "liza-ovinova",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mark N.",
    lastName: "Owen",
    title: "Program Manager",
    slug: "mark-n-owen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Owens",
    title: "Chief Financial Officer",
    slug: "michael-owens",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marques",
    lastName: "Owens",
    title: "Business Manager, Accounts Receivable",
    slug: "marques-owens",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Willie",
    lastName: "Owens Jr",
    title: "Service Specialist",
    slug: "willie-owens-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richie",
    lastName: "Owusu",
    title: "Operations Officer",
    slug: "richie-owusu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Efua E",
    lastName: "Owusu",
    title: "Senior Communications Officer",
    slug: "efua-e-owusu",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Seun",
    lastName: "Oyedele",
    title: "Senior Grants Manager",
    slug: "seun-oyedele",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yesenia",
    lastName: "Ozoria Urena",
    title: "Senior Human Resources Generalist",
    slug: "yesenia-ozoria-urena",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nohely I",
    lastName: "Ozoria Vasquez",
    title: "Executive Assistant and Projects Coordinator",
    slug: "nohely-i-ozoria-vasquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nur",
    lastName: "Ozten Kandas",
    title: "Compliance & Training Coord",
    slug: "nur-ozten-kandas",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Neidy Ana",
    lastName: "Ozuna",
    title: "Billing Specialist",
    slug: "neidy-ana-ozuna",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katherine",
    lastName: "Ozuna",
    title: "Call Center Scheduling Representative",
    slug: "katherine-ozuna",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicolette K.",
    lastName: "Pabatao",
    title: "BMT,Cell&Gene Ther Res Nrs II",
    slug: "nicolette-k-pabatao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maribel",
    lastName: "Pachay",
    title: "Purchasing Manager",
    slug: "maribel-pachay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diosilda",
    lastName: "Pacheco",
    title: "Administrative Clerk",
    slug: "diosilda-pacheco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samanta",
    lastName: "Padalino",
    title: "Grants Manager, Office of Sponsored Projects",
    slug: "samanta-padalino",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Roseni",
    lastName: "Padilla",
    title: "Program Manager",
    slug: "roseni-padilla",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erika",
    lastName: "Padilla",
    title: "Accountant, Cash Accounting",
    slug: "erika-padilla",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Edwing A.",
    lastName: "Padilla",
    title: "Associate Director, Technical Support",
    slug: "edwing-a-padilla",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jane H",
    lastName: "Pae",
    title: "Associate Director",
    slug: "jane-h-pae",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jinah Helen",
    lastName: "Paek",
    title: "Associate Director, Academic Appointments",
    slug: "jinah-helen-paek",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole M",
    lastName: "Pagan",
    title: "Administrative Assistant",
    slug: "nicole-m-pagan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miguel A.",
    lastName: "Pagan",
    title: "Assistant Vice President",
    slug: "miguel-a-pagan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Iris J",
    lastName: "Pagan",
    title: "EEG/EMU Coordinator",
    slug: "iris-j-pagan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Antonio",
    lastName: "Pagan",
    title: "Director, Human Resources and Operations",
    slug: "antonio-pagan",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Karen Kirsch",
    lastName: "Page",
    title: "Senior Associate Director of Professional Learning",
    slug: "karen-kirsch-page",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Karen",
    lastName: "Pagliaro-Meyer",
    title: "Chief Privacy Officer",
    slug: "karen-pagliaro-meyer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dagmar",
    lastName: "Paguada",
    title: "University Affiliate - STEAM",
    slug: "dagmar-paguada",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark Q",
    lastName: "Paige",
    title: "Program Manager",
    slug: "mark-q-paige",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Su Yon",
    lastName: "Pak",
    title: "Sr Director, Integrative & Field-Based Education",
    slug: "su-yon-pak",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Timur",
    lastName: "Pakay",
    title: "Dir,SHARP/Online Training Prog",
    slug: "timur-pakay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James E",
    lastName: "Pakiela",
    title: "Director of Human Resources",
    slug: "james-e-pakiela",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Anita",
    lastName: "Palacios",
    title: "Coding and Charge Edits Specialist II",
    slug: "anita-palacios",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sherry",
    lastName: "Palines",
    title: "Administrative Assistant",
    slug: "sherry-palines",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa A.",
    lastName: "Palladino",
    title:
      " Editor, Communications and Marketing; Executive Editor of Columbia College Today",
    slug: "lisa-a-palladino",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tiffaney Anne",
    lastName: "Palmer",
    title: "Senior Admissions Counselor",
    slug: "tiffaney-anne-palmer",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Matica",
    lastName: "Palmer",
    title: "Rounds Person",
    slug: "matica-palmer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren",
    lastName: "Palmer",
    title: "Program Manager",
    slug: "lauren-palmer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Milda",
    lastName: "Palubinskas",
    title: "Associate Director, Development Research",
    slug: "milda-palubinskas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marianna",
    lastName: "Palumbo",
    title: "Executive Assistant",
    slug: "marianna-palumbo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samuel S.",
    lastName: "Pan",
    title: "Manager, CBSR",
    slug: "samuel-s-pan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ryan M",
    lastName: "Pancoast",
    title: "Dir, Dig Strategy & Marketing",
    slug: "ryan-m-pancoast",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sonal",
    lastName: "Pande",
    title: "Associate Dean, Alumni Relations and Development",
    slug: "sonal-pande",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stella",
    lastName: "Pandis",
    title: "Associate Director, Programs and Events",
    slug: "stella-pandis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Renu",
    lastName: "Pandita",
    title: "Service Desk Manager",
    slug: "renu-pandita",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Asha R",
    lastName: "Panduranga",
    title: "Finance Coordinator",
    slug: "asha-r-panduranga",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christopher M",
    lastName: "Pandza",
    title: "Manager-Graphic Design",
    slug: "christopher-m-pandza",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jonathan Edward",
    lastName: "Pang",
    title: "Program Manager",
    slug: "jonathan-edward-pang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ivan",
    lastName: "Pantic",
    title:
      " Senior Staff Associate ll in the Department of Environmental Health Sciences",
    slug: "ivan-pantic",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Genesis",
    lastName: "Pantosin",
    title: "Assistant Director, Student Life, Inclusion and Global Awareness",
    slug: "genesis-pantosin",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Peter",
    lastName: "Panycia",
    title: "Associate Director, Compensation",
    slug: "peter-panycia",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kai Lun",
    lastName: "Pao",
    title: "Assistant Director, Office of Management & Budget",
    slug: "kai-lun-pao",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Irene",
    lastName: "Papajohn",
    title: "Senior Associate Director, MBA Career Education and Advising",
    slug: "irene-papajohn",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Katsiaryna",
    lastName: "Papouskaya",
    title: "Administrative Assistant in the Harriman Institute",
    slug: "katsiaryna-papouskaya",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Louis",
    lastName: "Pappas",
    title: "Business Manager",
    slug: "louis-pappas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meenakshisundaram",
    lastName: "Paramasivam",
    title: "Brickman Miller UI",
    slug: "meenakshisundaram-paramasivam",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha Kearney",
    lastName: "Parang",
    title: "CPRE Researcher",
    slug: "samantha-kearney-parang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sacha S.",
    lastName: "Parchment",
    title: "Admin Mgr to Vice Dean for Ed",
    slug: "sacha-s-parchment",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Luz Magaly",
    lastName: "Paredes",
    title: "Administrative Assistant",
    slug: "luz-magaly-paredes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea M.",
    lastName: "Paredes",
    title: "Assistant Director for Academic and Research Community Development",
    slug: "andrea-m-paredes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amanda E",
    lastName: "Paredes",
    title: "Program Manager",
    slug: "amanda-e-paredes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maritza",
    lastName: "Paredes Martinez",
    title: "Administration and Planning Coordinator",
    slug: "maritza-paredes-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yoel Juan",
    lastName: "Paredes Rodriguez",
    title: "SMB Curriculum Coordinator",
    slug: "yoel-juan-paredes-rodriguez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ravi",
    lastName: "Parekh",
    title: "Consultant",
    slug: "ravi-parekh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Courtney Jane",
    lastName: "Parent",
    title: "Administrative Associate",
    slug: "courtney-jane-parent",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nick",
    lastName: "Paris",
    title: "QA Manager",
    slug: "nick-paris",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melissa A",
    lastName: "Paris",
    title: "Assistant Director, Finance",
    slug: "melissa-a-paris",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yebin",
    lastName: "Park",
    title: "Project Officer, Social Impact Leadership",
    slug: "yebin-park",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tae Young",
    lastName: "Park",
    title: "Director, Grants Management",
    slug: "tae-young-park",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John",
    lastName: "Park",
    title: "Principal Research Technologis",
    slug: "john-park",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Henry",
    lastName: "Park",
    title: "Asst Director, Financial Ops",
    slug: "henry-park",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Henry C",
    lastName: "Park",
    title: "Dir, Ed Res&Data Analysis Sup",
    slug: "henry-c-park",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David Maxwell",
    lastName: "Park",
    title: "Film and Video Projection Manager",
    slug: "david-maxwell-park",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David J.",
    lastName: "Park",
    title: "Executive Director of Emerging Technologies",
    slug: "david-j-park",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Talia S",
    lastName: "Parker",
    title: "Manager, Charge Capture",
    slug: "talia-s-parker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rachel",
    lastName: "Parker",
    title: "Senior Grants Manager",
    slug: "rachel-parker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rodney S.",
    lastName: "Parker",
    title: "Head Catering Delivery Person",
    slug: "rodney-s-parker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julianne",
    lastName: "Parker",
    title: "Assoc Dir of Gen Public Health",
    slug: "julianne-parker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily I",
    lastName: "Parkington",
    title: "Enrollment Coordinator",
    slug: "emily-i-parkington",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Diamond J",
    lastName: "Parks",
    title: "Administrative Clerk",
    slug: "diamond-j-parks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jovana",
    lastName: "Parlic",
    title: "Wellness Coordinator",
    slug: "jovana-parlic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zachary Joseph",
    lastName: "Parolin",
    title: "Contractor",
    slug: "zachary-joseph-parolin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josephine Theresa",
    lastName: "Parr",
    title: "Executive Director of External Affairs and Communication",
    slug: "josephine-theresa-parr",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Clayuri",
    lastName: "Parrilla",
    title: "Associate Director, Resource Planning",
    slug: "clayuri-parrilla",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kayla A.",
    lastName: "Parsons",
    title: "Student Acad Support Worker",
    slug: "kayla-a-parsons",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Adelle Maya",
    lastName: "Parsons",
    title: "Program Manager",
    slug: "adelle-maya-parsons",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ramakrishna",
    lastName: "Paruchuri",
    title: "Audit Manager, IT Audit",
    slug: "ramakrishna-paruchuri",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sneha",
    lastName: "Parundekar",
    title: "Generalist, HR/FA",
    slug: "sneha-parundekar",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Raemel Gilbert",
    lastName: "Pascual",
    title: "Deputy Director, Psychiatric Center 2",
    slug: "raemel-gilbert-pascual",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abhignya",
    lastName: "Pashupati",
    title: "Sr. Application Systems Developer",
    slug: "abhignya-pashupati",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dana",
    lastName: "Pasini",
    title: "Assoc Director-Alumni Relation",
    slug: "dana-pasini",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Oksana",
    lastName: "Paslavska",
    title: "Temp - Finance",
    slug: "oksana-paslavska",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Victoria",
    lastName: "Passarella",
    title: "Associate Director, Career Design Lab",
    slug: "victoria-passarella",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Radhika V.",
    lastName: "Patel",
    title: "Chief Operating Officer in the Data Science Institute",
    slug: "radhika-v-patel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rashmika N",
    lastName: "Patel",
    title: "Senior Grants Manager",
    slug: "rashmika-n-patel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nisha",
    lastName: "Patel",
    title: "Wait Staff",
    slug: "nisha-patel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nirali Arvind",
    lastName: "Patel",
    title: "Associate Director of Grants Management",
    slug: "nirali-arvind-patel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mayur",
    lastName: "Patel",
    title: "Director, IT Audit",
    slug: "mayur-patel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maitreya",
    lastName: "Patel",
    title: "Lead Application Systems Developer",
    slug: "maitreya-patel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Janki",
    lastName: "Patel",
    title: "Manager of Strategic Research Initiatives",
    slug: "janki-patel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Falgun",
    lastName: "Patel",
    title: "Senior Manager, SaaS Procurement Application Support",
    slug: "falgun-patel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dixaben",
    lastName: "Patel",
    title: "IRB Specialist",
    slug: "dixaben-patel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anish",
    lastName: "Patel",
    title: "Payroll Coordinator",
    slug: "anish-patel",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Anita",
    lastName: "Patel",
    title: "Department Administrator/COO",
    slug: "anita-patel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ankur",
    lastName: "Pathania",
    title: "Consultant",
    slug: "ankur-pathania",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diego",
    lastName: "Patino Toro",
    title: "Assistant Director of Information Technology Systems",
    slug: "diego-patino-toro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sala Elise",
    lastName: "Patterson",
    title: "Senior Director for Communications",
    slug: "sala-elise-patterson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessonia",
    lastName: "Patterson",
    title: "CMA",
    slug: "jessonia-patterson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Breanna M.",
    lastName: "Patterson",
    title: "Leadership Gifts Officer",
    slug: "breanna-m-patterson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andre",
    lastName: "Patterson",
    title: "FDR/MA",
    slug: "andre-patterson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea C",
    lastName: "Patterson",
    title: "Director, CUMC Events",
    slug: "andrea-c-patterson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Timothy S.",
    lastName: "Paul",
    title: "Editorial Director",
    slug: "timothy-s-paul",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rowyn W",
    lastName: "Paul",
    title: "Assistant Director of Student Engagement",
    slug: "rowyn-w-paul",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mercedes",
    lastName: "Paulino",
    title: "Administrative Coordinator",
    slug: "mercedes-paulino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arleny",
    lastName: "Paulino",
    title: "Senior Coordinator, Human Resources",
    slug: "arleny-paulino",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lori L",
    lastName: "Paulson",
    title: "Strategic Initiative Manager; Interim Director of Communications",
    slug: "lori-l-paulson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dana Wade",
    lastName: "Pavarini",
    title: "Executive Director of Undergraduate Admissions",
    slug: "dana-wade-pavarini",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Yarenys",
    lastName: "Payamps",
    title: "Lab Assistant",
    slug: "yarenys-payamps",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Josue",
    lastName: "Payero",
    title: "2024 BioBus Personnel",
    slug: "josue-payero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ayoune",
    lastName: "Payne",
    title: "Administrative Aide",
    slug: "ayoune-payne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ricardo",
    lastName: "Paz",
    title: "Asst Supvr",
    slug: "ricardo-paz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nia Divine",
    lastName: "Paz-Diaz",
    title: "Project Coordinator",
    slug: "nia-divine-paz-diaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martha Vienna",
    lastName: "Paz-Garcia",
    title:
      " Executive Assistant in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "martha-vienna-paz-garcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John H",
    lastName: "Peacock",
    title: "Administrative Coordinator",
    slug: "john-h-peacock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christian R.",
    lastName: "Pecache",
    title: "Office Assistant",
    slug: "christian-r-pecache",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elisabeth Maria",
    lastName: "Peck",
    title: "Administrative Assistant",
    slug: "elisabeth-maria-peck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marianna",
    lastName: "Pecoraro",
    title: "Associate Director of Event Management",
    slug: "marianna-pecoraro",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Diana Michelle",
    lastName: "Pedi",
    title: "Assistant Director, Communications",
    slug: "diana-michelle-pedi",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Chelsea",
    lastName: "Peel",
    title: "Grants Coordinator I",
    slug: "chelsea-peel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Renee",
    lastName: "Peele",
    title: "Dir, Research Administration",
    slug: "renee-peele",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shanny",
    lastName: "Peer",
    title: "Director - Maison Francaise",
    slug: "shanny-peer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katharine E",
    lastName: "Peglow",
    title: "Project Coordinator",
    slug: "katharine-e-peglow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth Anne",
    lastName: "Peiffer",
    title: "Assistant Dean of Advising",
    slug: "elizabeth-anne-peiffer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Riwan",
    lastName: "Pelissier",
    title: "Senior Service Specialist",
    slug: "riwan-pelissier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Milagrosa",
    lastName: "Pellan",
    title:
      " Lab Coordinator in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "milagrosa-pellan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Geralyn P.",
    lastName: "Pelle",
    title: "Supervisor",
    slug: "geralyn-p-pelle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam J.",
    lastName: "Pellegrini",
    title: "Director of the Writing Center",
    slug: "adam-j-pellegrini",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "Pellerito",
    title: "Director, Digital Content",
    slug: "jennifer-pellerito",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ren",
    lastName: "Pelosi",
    title: "Institute Learning & Technology Associate (Center Associate)",
    slug: "ren-pelosi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vivianna",
    lastName: "Pena",
    title: "Executive Assistant",
    slug: "vivianna-pena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thalia",
    lastName: "Pena",
    title: "Administrative Clerk",
    slug: "thalia-pena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosamna",
    lastName: "Pena",
    title: "Financial Aid Officer",
    slug: "rosamna-pena",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rocio M",
    lastName: "Pena",
    title: "Director of Finance and Administration",
    slug: "rocio-m-pena",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pamela",
    lastName: "Pena",
    title: "Payroll Manager",
    slug: "pamela-pena",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Magda V.",
    lastName: "Pena",
    title: "Bursar Representative for Loans and Collections",
    slug: "magda-v-pena",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Milagros Mercedes",
    lastName: "Pena",
    title: "Guest Service Representative",
    slug: "milagros-mercedes-pena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayla M",
    lastName: "Pena",
    title: "Financial Coordinator",
    slug: "kayla-m-pena",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jesenia",
    lastName: "Pena",
    title: "Administrative Coordinator",
    slug: "jesenia-pena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juan A",
    lastName: "Pena",
    title: "Porter",
    slug: "juan-a-pena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Esthefany",
    lastName: "Pena",
    title: "Human Resources & Events Operations Manager",
    slug: "esthefany-pena",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kevin Micheal",
    lastName: "Penaloza",
    title: "Operations Coordinator",
    slug: "kevin-micheal-penaloza",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ann",
    lastName: "Pence",
    title: "Assistant Director, University Card Programs",
    slug: "ann-pence",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Danielle",
    lastName: "Pendrick",
    title: "Director of Interdisciplinary Research Initiatives",
    slug: "danielle-pendrick",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Xin",
    lastName: "Peng",
    title: "Deputy Vice President, Finance",
    slug: "xin-peng",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle",
    lastName: "Pennicott",
    title: "Billing Collector",
    slug: "michelle-pennicott",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Susan",
    lastName: "Pensak",
    title: "Senior Manuscript Editor",
    slug: "susan-pensak",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Noelle",
    lastName: "Pensec Rovensky",
    title: "Diagnostic Imaging Supervisor",
    slug: "noelle-pensec-rovensky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marjorie I",
    lastName: "Penzetta",
    title: "Admissions Assistant",
    slug: "marjorie-i-penzetta",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Arianna",
    lastName: "Pepin",
    title: "Lab Coordinator",
    slug: "arianna-pepin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sara",
    lastName: "Pepitone",
    title: "Senior Writer",
    slug: "sara-pepitone",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Fernando",
    lastName: "Peralta Cruz",
    title: "Program Manager",
    slug: "fernando-peralta-cruz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leonel",
    lastName: "Peralta Olivo",
    title: "Associate Director of Information Technology",
    slug: "leonel-peralta-olivo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Danai",
    lastName: "Percheson-Carriere",
    title: "Research Project Manager",
    slug: "danai-percheson-carriere",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Glenny",
    lastName: "Perdomo",
    title: "Sr Program Support Coordinator",
    slug: "glenny-perdomo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angelica",
    lastName: "Perdomo",
    title: "Benefits Representative",
    slug: "angelica-perdomo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Katia G.",
    lastName: "Pereira",
    title: "Financial Assistant",
    slug: "katia-g-pereira",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Javier",
    lastName: "Pereira",
    title: "Porter",
    slug: "javier-pereira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isabella Pirete Furtado",
    lastName: "Pereira",
    title: "Interim Employee (e-class 91)",
    slug: "isabella-pirete-furtado-pereira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Uduwanage Gayani",
    lastName: "Perera",
    title: "Senior Data Manager",
    slug: "uduwanage-gayani-perera",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yadira I",
    lastName: "Perez",
    title: "Project Coordinator",
    slug: "yadira-i-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Valerie Lee",
    lastName: "Perez",
    title: "Executive Assistant",
    slug: "valerie-lee-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiffany Lourdes",
    lastName: "Perez",
    title: "Project Coordinator I",
    slug: "tiffany-lourdes-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Perez",
    title: "Program Administrator",
    slug: "michelle-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maritza",
    lastName: "Perez",
    title: "Mail Room Clerk",
    slug: "maritza-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Freddy A",
    lastName: "Perez",
    title: "Manager, Events and Engagement",
    slug: "freddy-a-perez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erica",
    lastName: "Perez",
    title: "Front Desk Receptionist",
    slug: "erica-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carmen Maria",
    lastName: "Perez",
    title: "Administrative Coordinator",
    slug: "carmen-maria-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander",
    lastName: "Perez",
    title: "Service Specialist",
    slug: "alexander-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexandra",
    lastName: "Perez",
    title: "Program Manager",
    slug: "alexandra-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ana L",
    lastName: "Perez",
    title: "Administrative Assistant I",
    slug: "ana-l-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michelle",
    lastName: "Perez",
    title: "Senior Project Officer",
    slug: "michelle-perez-1",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anthony C",
    lastName: "Perez",
    title: "Associate Service Specialist",
    slug: "anthony-c-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julio Armando",
    lastName: "Perez Jr",
    title: "Senior Program Manager",
    slug: "julio-armando-perez-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Estilita F",
    lastName: "Perez Martinez",
    title: "Senior Secretary",
    slug: "estilita-f-perez-martinez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Xiomara",
    lastName: "Perez-Betances",
    title: "Senior Project Officer",
    slug: "xiomara-perez-betances",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marjorie",
    lastName: "Perez-Richardson",
    title:
      " Assistant Director, Institute Events and Initiatives, Administrative Services",
    slug: "marjorie-perez-richardson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charlene",
    lastName: "Perilla-Iqbal",
    title: "Deputy Program Director, Strategic Communication",
    slug: "charlene-perilla-iqbal",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Henry",
    lastName: "Perkowski",
    title: "Vice President for Finance and Operations",
    slug: "henry-perkowski",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karolina A.",
    lastName: "Perlik",
    title: "Senior Associate Director of Administration and Finance",
    slug: "karolina-a-perlik",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lauren",
    lastName: "Perlmutter",
    title: "Assistant VP, Comm & Donor Rel",
    slug: "lauren-perlmutter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andrew J.",
    lastName: "Permaul",
    title: "Administrative Manager",
    slug: "andrew-j-permaul",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michelle",
    lastName: "Perri",
    title: "Enrollment Coordinator",
    slug: "michelle-perri",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Shawntell",
    lastName: "Perry",
    title: "Front Desk Customer Service Representative",
    slug: "shawntell-perry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Allison",
    lastName: "Perry",
    title: "Consultant",
    slug: "allison-perry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "April",
    lastName: "Perry",
    title: "Assistant Director, Columbia Alumni Center",
    slug: "april-perry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Satyanand",
    lastName: "Persaud",
    title:
      " Senior Director, Systems Support, Database Administration and Infrastructure Services",
    slug: "satyanand-persaud",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Reshma Devi",
    lastName: "Persaud",
    title: "Major Gifts Officer",
    slug: "reshma-devi-persaud",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Devika K.",
    lastName: "Persaud",
    title: "Lead Application Systems Developer",
    slug: "devika-k-persaud",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shanaz",
    lastName: "Pershad",
    title: "Admin/Exec Asst - ADMN",
    slug: "shanaz-pershad",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keshia S",
    lastName: "Pershad",
    title: "Student Services Coordinator",
    slug: "keshia-s-pershad",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "John J",
    lastName: "Pesantez",
    title: "Senior Academic Technology Specialist",
    slug: "john-j-pesantez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jaya",
    lastName: "Peterkin",
    title: "Yes in the HEIGHTS Casual",
    slug: "jaya-peterkin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erin A.",
    lastName: "Peterman",
    title:
      " Internal Communications Director in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "erin-a-peterman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sandra C.",
    lastName: "Peters",
    title: "Sr Assc Director-Financial Aid",
    slug: "sandra-c-peters",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Djenaba",
    lastName: "Peters",
    title: "MPA",
    slug: "djenaba-peters",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gregory David",
    lastName: "Petershack",
    title: "Professional Development Coach",
    slug: "gregory-david-petershack",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Brennon Joseph",
    lastName: "Peterson",
    title: "Instructional Support Assistant",
    slug: "brennon-joseph-peterson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Azaleah Crystal",
    lastName: "Peterson",
    title: "Subaward Specialist",
    slug: "azaleah-crystal-peterson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Adam",
    lastName: "Peterson",
    title: "Contractor",
    slug: "adam-peterson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Petit-Day",
    title: "Undergraduate Program and Curriculum Coordinator",
    slug: "jennifer-petit-day",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rebecca L.",
    lastName: "Petitti",
    title: "Associate Director, Assessment and Strategic initiatives",
    slug: "rebecca-l-petitti",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daniel",
    lastName: "Petre",
    title: "Associate Director, IT Systems and Infrastructure",
    slug: "daniel-petre",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Valentin",
    lastName: "Petrov",
    title: "Asst Director, Cardiology IT",
    slug: "valentin-petrov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shawyonia L.",
    lastName: "Pettigrew",
    title: "Student Services Coordinator",
    slug: "shawyonia-l-pettigrew",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Karl D.",
    lastName: "Pettus",
    title: "Senior Service Specialist",
    slug: "karl-d-pettus",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John M",
    lastName: "Pezzolla",
    title: "Associate Director - Management Operations",
    slug: "john-m-pezzolla",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Friedrich K.",
    lastName: "Pfetsch",
    title: "Director, Pension Financial Reporting",
    slug: "friedrich-k-pfetsch",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maria Khanh",
    lastName: "Pham",
    title: "Student Conduct Specialist",
    slug: "maria-khanh-pham",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hoi V.",
    lastName: "Pham",
    title: "Sr Application Systems Develop",
    slug: "hoi-v-pham",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Denise",
    lastName: "Pham",
    title: "Lab Consultant",
    slug: "denise-pham",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lan Hoang",
    lastName: "Phan",
    title: "Organization Development Coordinator",
    slug: "lan-hoang-phan",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Janet",
    lastName: "Phang",
    title: "Research Support Assistant Level II",
    slug: "janet-phang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa",
    lastName: "Phelan",
    title: "Consultant",
    slug: "lisa-phelan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David J.",
    lastName: "Phelan",
    title: "Business Manager",
    slug: "david-j-phelan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dennis Frances",
    lastName: "Philbert",
    title: "Disbursement Specialist",
    slug: "dennis-frances-philbert",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nisha",
    lastName: "Philip",
    title: "Director, Financial Operations",
    slug: "nisha-philip",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tricia M",
    lastName: "Philip-Rao",
    title: "Director",
    slug: "tricia-m-philip-rao",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anastasia",
    lastName: "Philippis",
    title: "Director of Administration and Finance",
    slug: "anastasia-philippis",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Juliet",
    lastName: "Philips",
    title: "Department Administrator",
    slug: "juliet-philips",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaillee M",
    lastName: "Philleo",
    title: "Assistant Director of Experiential Education",
    slug: "kaillee-m-philleo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marisa",
    lastName: "Phillip",
    title: "Graduate Admissions Operations Officer",
    slug: "marisa-phillip",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Tiffany",
    lastName: "Phillips",
    title: "Authorization and Referrals Specialist II",
    slug: "tiffany-phillips",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa Blake",
    lastName: "Phillips",
    title:
      " Senior Director of Institutional Partnerships, Columbia Climate School",
    slug: "lisa-blake-phillips",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hannah",
    lastName: "Phillips",
    title: "Associate Director, Executive Education",
    slug: "hannah-phillips",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adam David",
    lastName: "Phillips",
    title: "Contractor",
    slug: "adam-david-phillips",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hannah Elizabeth",
    lastName: "Phipps",
    title: "Coordinator",
    slug: "hannah-elizabeth-phipps",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jason",
    lastName: "Phoel",
    title: "Director, Budget and Planning",
    slug: "jason-phoel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sirilak Tina",
    lastName: "Phounsavath",
    title: "Financial Coordinator",
    slug: "sirilak-tina-phounsavath",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Molly Bond",
    lastName: "Picardi",
    title: "Staff Developer",
    slug: "molly-bond-picardi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lianna M",
    lastName: "Piccarillo",
    title: "Dir IT Srvc Mgmt, Design & Gov",
    slug: "lianna-m-piccarillo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John",
    lastName: "Piccolo",
    title: "Administrative Assistant",
    slug: "john-piccolo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arelys",
    lastName: "Pichardo",
    title: "Secretary B",
    slug: "arelys-pichardo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Breandra R.",
    lastName: "Pichon",
    title: "Grants Manager, Office of Sponsored Projects",
    slug: "breandra-r-pichon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth",
    lastName: "Pickard",
    title: "Director of Administration - Technology Management",
    slug: "elizabeth-pickard",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Schanica",
    lastName: "Pickens Rollling",
    title: "Director of Student Affairs",
    slug: "schanica-pickens-rollling",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mary",
    lastName: "Pickett",
    title: "Executive Director, American Language Program",
    slug: "mary-pickett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Clarissa",
    lastName: "Pickett",
    title: "Accounts Payable Payment Operations Liaison",
    slug: "clarissa-pickett",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Koumamo",
    lastName: "Piebo",
    title: "MPA",
    slug: "koumamo-piebo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Pierson",
    title: "Associate Director, Artists' Resource Center and Alumni Affairs",
    slug: "jessica-pierson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alphonso",
    lastName: "Pigatt Jr",
    title: "Financial Clearance andEcommerce Rejectroc Associate",
    slug: "alphonso-pigatt-jr",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Georgia O.",
    lastName: "Pike",
    title: "Assoc Dir, Gift Systems",
    slug: "georgia-o-pike",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lourdes R",
    lastName: "Pilapil",
    title: "Director-Grant/Finance",
    slug: "lourdes-r-pilapil",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kartik P.",
    lastName: "Pilar",
    title: "CDI Program Manager",
    slug: "kartik-p-pilar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isaure",
    lastName: "Pilot",
    title: "Student Acad Support Worker",
    slug: "isaure-pilot",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer",
    lastName: "Pimentel",
    title: "Care and Outreach Coordinator",
    slug: "jennifer-pimentel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Denisse",
    lastName: "Pimentel",
    title: "Receptionist",
    slug: "denisse-pimentel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maya",
    lastName: "Pincus",
    title: "Science Officer-Communications",
    slug: "maya-pincus",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yasser R",
    lastName: "Pineiro Gonzalez",
    title: "Assistant Director, Capital Planning & Housing Assistance Program",
    slug: "yasser-r-pineiro-gonzalez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia R",
    lastName: "Pines",
    title: "Research Support Assistant",
    slug: "julia-r-pines",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Carolina",
    lastName: "Pinheiro Rezende",
    title: "Senior Director",
    slug: "carolina-pinheiro-rezende",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Benjamin",
    lastName: "Pinillos",
    title: "Director, Contracts",
    slug: "benjamin-pinillos",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Zubaida Khanam",
    lastName: "Pinky",
    title: "Financial Assistant",
    slug: "zubaida-khanam-pinky",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tiffany",
    lastName: "Pinnock",
    title: "Administrative Coordinator",
    slug: "tiffany-pinnock",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mariana Y.",
    lastName: "Pinos",
    title: "Academic Program Support in Professional Studies",
    slug: "mariana-y-pinos",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sasha",
    lastName: "Pinto",
    title: "Coordinator-Financial Aid",
    slug: "sasha-pinto",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Daniel",
    lastName: "Pioske",
    title: "Auburn Theol. Seminary",
    slug: "daniel-pioske",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Iman",
    lastName: "Piracha",
    title: "Administrative Coordinator",
    slug: "iman-piracha",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah",
    lastName: "Piscitelli",
    title: "Fidelity Trainer",
    slug: "sarah-piscitelli",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kosmas",
    lastName: "Pissakos",
    title: "Administrative Assistant",
    slug: "kosmas-pissakos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mariam Tolulope",
    lastName: "Pitan",
    title: "Manager of Operations and Administrative Services",
    slug: "mariam-tolulope-pitan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caroline Boggan",
    lastName: "Pitman",
    title: "Special Assistant",
    slug: "caroline-boggan-pitman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher M.",
    lastName: "Pitoscia",
    title: "Director, EH&S",
    slug: "christopher-m-pitoscia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carol C.",
    lastName: "Pitter",
    title: "Generalist, HR/FA",
    slug: "carol-c-pitter",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Maggie",
    lastName: "Pittman",
    title: "Administrative Assistant",
    slug: "maggie-pittman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aldina",
    lastName: "Pjetrovic",
    title: "Administrative Assistant",
    slug: "aldina-pjetrovic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angelic M",
    lastName: "Pla",
    title: "Director, HR/FA",
    slug: "angelic-m-pla",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Andrew T",
    lastName: "Plaa",
    title: "Dean of Advising",
    slug: "andrew-t-plaa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rory",
    lastName: "Placa",
    title: "Assistant Director of Educational Financing",
    slug: "rory-placa",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Isabella",
    lastName: "Plachter",
    title: "Events Coordinator",
    slug: "isabella-plachter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hilda L",
    lastName: "Plasencia",
    title: "Quality Manager",
    slug: "hilda-l-plasencia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joey M.",
    lastName: "Platt",
    title: "Senior Project Officer",
    slug: "joey-m-platt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Platt",
    title:
      " Project Director, Public Rights/Private Conscience Project, Center for Gender and Sexuality Law",
    slug: "elizabeth-platt",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Benjamin",
    lastName: "Platt",
    title: "Senior Editor",
    slug: "benjamin-platt",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alix",
    lastName: "Platt",
    title: "Development Assistant, School of the Arts",
    slug: "alix-platt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Darcy Floyd",
    lastName: "Pleckham",
    title: "Information Tech Specialist",
    slug: "darcy-floyd-pleckham",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jonathan",
    lastName: "Plummer",
    title: "Technical Specialist",
    slug: "jonathan-plummer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Herbert",
    lastName: "Plummer",
    title: "Digital Product Sales Manager",
    slug: "herbert-plummer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gabriela A.",
    lastName: "Plump",
    title: "Director",
    slug: "gabriela-a-plump",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Belkis M.",
    lastName: "Poche",
    title: "Outreach Coordinator",
    slug: "belkis-m-poche",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gennady",
    lastName: "Podrezov",
    title: "Application Systems Developer",
    slug: "gennady-podrezov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vivian",
    lastName: "Polanco",
    title: "Business Manager in the Department of Chemistry",
    slug: "vivian-polanco",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jaime L.",
    lastName: "Polanco",
    title: "Senior Manager, Financial Administration",
    slug: "jaime-l-polanco",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Evelyn",
    lastName: "Polanco",
    title:
      " HHMI Tech in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "evelyn-polanco",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christina",
    lastName: "Polanco",
    title: "Surgical Scheduler",
    slug: "christina-polanco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Benjamin S.",
    lastName: "Poleretzky",
    title: "Production Specialist",
    slug: "benjamin-s-poleretzky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna",
    lastName: "Poliakova",
    title: "Director, Benefits & Pension Accounting & Reporting",
    slug: "anna-poliakova",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meriam A",
    lastName: "Polilen",
    title: "Director - HRIS",
    slug: "meriam-a-polilen",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Trenton",
    lastName: "Pollard",
    title: "Associate Director of Student Affairs",
    slug: "trenton-pollard",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Madeline",
    lastName: "Pollifrone",
    title: "Project Manager",
    slug: "madeline-pollifrone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Pompili",
    title: "Director, Student Wellness",
    slug: "danielle-pompili",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Diana",
    lastName: "Ponce",
    title: "Administrative Coordinator",
    slug: "diana-ponce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mariecia Julie",
    lastName: "Pook",
    title: "Senior Administrative Manager",
    slug: "mariecia-julie-pook",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Pooler",
    title: "Leadership Gift Officer II",
    slug: "daniel-pooler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathryn S.",
    lastName: "Poots",
    title: "Program Director in the Middle East Institute",
    slug: "kathryn-s-poots",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Niessence",
    lastName: "Pope",
    title:
      " Executive Assistant, School of International and Public Affairs (SIPA)",
    slug: "niessence-pope",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robert Stephen Pio",
    lastName: "Popik Jr.",
    title: "REACH Community School Director (Elementary)",
    slug: "robert-stephen-pio-popik-jr",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marelys",
    lastName: "Popoter",
    title: "Admissions Associate - Admissions",
    slug: "marelys-popoter",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kamaara",
    lastName: "Porcenat",
    title: "Senior Associate Director, Digital Marketing",
    slug: "kamaara-porcenat",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mario Antonio",
    lastName: "Porras",
    title: "Student Services Coordinator",
    slug: "mario-antonio-porras",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Autumn L",
    lastName: "Porter",
    title: "Education Assistant",
    slug: "autumn-l-porter",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Omar",
    lastName: "Portieles",
    title: "Doppler Lab Manager",
    slug: "omar-portieles",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christian J.",
    lastName: "Portilla",
    title: "Director-Analytics Development",
    slug: "christian-j-portilla",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dawnmarie",
    lastName: "Portoff",
    title: "KSS Consultant",
    slug: "dawnmarie-portoff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marielle T",
    lastName: "Poss",
    title: "Director of Editing, Design & Production",
    slug: "marielle-t-poss",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Viktoria V.",
    lastName: "Potapova",
    title: "Senior Administrative and Legal Associate",
    slug: "viktoria-v-potapova",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Whitney",
    lastName: "Potter",
    title: "Ex Director, Donor Relations",
    slug: "whitney-potter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Madrid",
    lastName: "Poultney",
    title: "Program Manager",
    slug: "madrid-poultney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "M. Cody",
    lastName: "Poulton",
    title: "Resident Director, KCJS",
    slug: "m-cody-poulton",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Matthew A.",
    lastName: "Pourviseh",
    title: "Assistant Director of Production and Risk",
    slug: "matthew-a-pourviseh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Renee",
    lastName: "Powell",
    title:
      " Senior Associate Director, Development Strategy, Columbia College and Arts & Sciences",
    slug: "renee-powell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juliana",
    lastName: "Powell",
    title: "Senior Director of Research Operations, MS, SPA",
    slug: "juliana-powell",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Devin C",
    lastName: "Powell",
    title: "Senior Creative Manager",
    slug: "devin-c-powell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cynthia",
    lastName: "Powell",
    title: "Director, Finance & Admin",
    slug: "cynthia-powell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nancy Ellen",
    lastName: "Power",
    title: "Marketing Manager",
    slug: "nancy-ellen-power",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicholas Kajder",
    lastName: "Pozek",
    title: "Assistant Director of Asian Law Programs",
    slug: "nicholas-kajder-pozek",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Julie",
    lastName: "Pozo-Cepeda",
    title: "Senior Director, Events",
    slug: "julie-pozo-cepeda",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sonali",
    lastName: "Prabhakar",
    title: "Staff",
    slug: "sonali-prabhakar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Monica",
    lastName: "Prabudoss",
    title: "Department Administrator / COO",
    slug: "monica-prabudoss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sebastian",
    lastName: "Prado",
    title: "CMA",
    slug: "sebastian-prado",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vishwanath H",
    lastName: "Prathikanti",
    title: "Research/Database Coordinator",
    slug: "vishwanath-h-prathikanti",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gail J",
    lastName: "Prescod",
    title: "Administrative Aide",
    slug: "gail-j-prescod",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Prescott",
    title: "Project Director",
    slug: "laura-prescott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Norma V.",
    lastName: "Pressley",
    title: "Administrative Manager",
    slug: "norma-v-pressley",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Stuart",
    lastName: "Pressman",
    title: "Office  Manager",
    slug: "stuart-pressman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Federico J.",
    lastName: "Prete",
    title: "Senior Manager, Classroom and Academic Computing",
    slug: "federico-j-prete",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Leonide",
    lastName: "Previna",
    title: "MA",
    slug: "leonide-previna",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vincent",
    lastName: "Price",
    title: "File Room Clerk",
    slug: "vincent-price",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jaqueline",
    lastName: "Price",
    title: "Administrative Coordinator",
    slug: "jaqueline-price",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Frantz Thomas",
    lastName: "Price",
    title: "Director of International and Alumni Careers",
    slug: "frantz-thomas-price",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lynette",
    lastName: "Prince",
    title: "Business Services Officer",
    slug: "lynette-prince",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph Henry",
    lastName: "Prince",
    title: "Audiovisual Specialist",
    slug: "joseph-henry-prince",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Caroline Keenon",
    lastName: "Prince",
    title:
      " Associate Director of Donor Relations and Development Communications",
    slug: "caroline-keenon-prince",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eugene S.",
    lastName: "Profanato",
    title: "Manager-Procurement",
    slug: "eugene-s-profanato",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emin",
    lastName: "Promnam",
    title: "Executive Assistant",
    slug: "emin-promnam",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Solomon F.",
    lastName: "Prophete",
    title: "Manager, Cyber Security Operations",
    slug: "solomon-f-prophete",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nadia",
    lastName: "Propp",
    title: "Administrative Director",
    slug: "nadia-propp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lorena Cristina",
    lastName: "Prosco",
    title: "Executive Director",
    slug: "lorena-cristina-prosco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chara Ruth",
    lastName: "Proud",
    title: "Health and Safety Specialist",
    slug: "chara-ruth-proud",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy E",
    lastName: "Proulx",
    title: "PCFP Mentor",
    slug: "amy-e-proulx",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dina C",
    lastName: "Pruitt",
    title: "Dir, Fac Advance/Doc Relations",
    slug: "dina-c-pruitt",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Aleksey",
    lastName: "Przhevalskiy",
    title: "Senior Associate Director, Web Services",
    slug: "aleksey-przhevalskiy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Corey",
    lastName: "Ptak",
    title: "Assistant Director - CUIMC",
    slug: "corey-ptak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaitlyn",
    lastName: "Puckart",
    title: "Associate Director",
    slug: "kaitlyn-puckart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ysela Delnoy",
    lastName: "Puello-Guzman",
    title: "Administrative Aide",
    slug: "ysela-delnoy-puello-guzman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karla P",
    lastName: "Puga",
    title: "Senior Associate Director, Employer and Alumni Relations",
    slug: "karla-p-puga",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tanya",
    lastName: "Puig",
    title: "Program Manager",
    slug: "tanya-puig",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wilmarys Maybel",
    lastName: "Pujols",
    title: "Diagnostic CT Program Coord",
    slug: "wilmarys-maybel-pujols",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William",
    lastName: "Puleo",
    title: "Accounts Payable Specialist",
    slug: "william-puleo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jenner",
    lastName: "Pulido",
    title: "Histotech",
    slug: "jenner-pulido",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diana Loretta",
    lastName: "Punales Morejon",
    title: "Doctoral Supervisor",
    slug: "diana-loretta-punales-morejon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth Ann",
    lastName: "Purce",
    title: "Administrative Assistant",
    slug: "elizabeth-ann-purce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary",
    lastName: "Purcell",
    title: "Sr. Manager, Comms & Programs",
    slug: "mary-purcell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shikha",
    lastName: "Puri",
    title: "Data Coordinator",
    slug: "shikha-puri",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Xiaoyan",
    lastName: "Qin",
    title: "Learning Designer I",
    slug: "xiaoyan-qin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mengxue",
    lastName: "Qu",
    title: "Division Administrator",
    slug: "mengxue-qu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dovina",
    lastName: "Qu",
    title: "Sr. Technology Licensing Officer",
    slug: "dovina-qu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christopher Luan",
    lastName: "Quach",
    title: "Senior Associate Director",
    slug: "christopher-luan-quach",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sadiqa K.",
    lastName: "Quadri",
    title: "Sr Research Program Manager",
    slug: "sadiqa-k-quadri",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rocco",
    lastName: "Quagliara",
    title: "Administrative Director",
    slug: "rocco-quagliara",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jinling",
    lastName: "Quan",
    title: "Asst Director - Student Svces",
    slug: "jinling-quan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kaylee Erika",
    lastName: "Quanbeck",
    title: "Senior Associate Director, Columbia College Fund",
    slug: "kaylee-erika-quanbeck",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stacey",
    lastName: "Quartaro",
    title: "Director, Administration - Narrative Medicine",
    slug: "stacey-quartaro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caylin N.",
    lastName: "Quatromoni",
    title: "Senior Development Associate",
    slug: "caylin-n-quatromoni",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evelyn",
    lastName: "Quero",
    title: "Senior Supervisor, ICM",
    slug: "evelyn-quero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Destiny",
    lastName: "Quezada",
    title: "Multimedia Digital Designer",
    slug: "destiny-quezada",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ana",
    lastName: "Quian",
    title: "Academic Coordinator",
    slug: "ana-quian",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Qiana-Denise",
    lastName: "Quiles",
    title: "Sr IRB Specialist (Sr Manager)",
    slug: "qiana-denise-quiles",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joseph",
    lastName: "Quinlan Jr",
    title: "Senior Associate Athletics Director, Internal Operations",
    slug: "joseph-quinlan-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathleen Louise",
    lastName: "Quinn",
    title: "Director of Finance",
    slug: "kathleen-louise-quinn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Francis E",
    lastName: "Quinn",
    title: "Data Network Install Manager",
    slug: "francis-e-quinn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jose M",
    lastName: "Quinones",
    title: "Manager, High Performance Comp",
    slug: "jose-m-quinones",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Evelyn",
    lastName: "Quinones",
    title: "Academic Secretary",
    slug: "evelyn-quinones",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elena J",
    lastName: "Quinonez",
    title: "Administrative Coordinator",
    slug: "elena-j-quinonez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alisa V",
    lastName: "Quintana",
    title: "Generalist, HR/FA",
    slug: "alisa-v-quintana",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jade",
    lastName: "Quintero",
    title: "Assistant Director",
    slug: "jade-quintero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isaac",
    lastName: "Quintero",
    title: "SYEP",
    slug: "isaac-quintero",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Diego",
    lastName: "Quintuna",
    title: "Community Affairs Associate",
    slug: "diego-quintuna",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alana G.",
    lastName: "Quirk",
    title: "Sr Strategic Fund/Prog Writer",
    slug: "alana-g-quirk",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Farith Julian",
    lastName: "Quiroga",
    title: "Audio Visual Systems Manager",
    slug: "farith-julian-quiroga",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ana",
    lastName: "Quiroz",
    title: "Center Coordinator",
    slug: "ana-quiroz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tania P.",
    lastName: "Quispe",
    title: "Asst Dean, Student Affairs",
    slug: "tania-p-quispe",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lucca Ruth",
    lastName: "Raabe",
    title: "Case Manager",
    slug: "lucca-ruth-raabe",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Estelle Ifeoma",
    lastName: "Raad",
    title: "Census Coordinator",
    slug: "estelle-ifeoma-raad",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bari E.",
    lastName: "Rabinovich",
    title: "Director, Investments",
    slug: "bari-e-rabinovich",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ari Michel",
    lastName: "Rabinowitz",
    title: "Senior Systems Administrator",
    slug: "ari-michel-rabinowitz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amy P.",
    lastName: "Rabinowitz",
    title: "Associate Provost and Director of the Office of WorkLife",
    slug: "amy-p-rabinowitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aurelia",
    lastName: "Rabot-Hernandez",
    title: "Administrative  Assistant",
    slug: "aurelia-rabot-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alla",
    lastName: "Rachkov",
    title: "Executive Director",
    slug: "alla-rachkov",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Axinia",
    lastName: "Radeva",
    title: "Research Computing Service Senior Manager",
    slug: "axinia-radeva",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amir",
    lastName: "Radoncic",
    title: "Consultant",
    slug: "amir-radoncic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claire A",
    lastName: "Raether",
    title: "Senior Traning & Ed Specialist",
    slug: "claire-a-raether",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sandy",
    lastName: "Raghoo",
    title: "Grants Manager, Post-Award",
    slug: "sandy-raghoo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Allen",
    lastName: "Raghunath",
    title: "Director, Service Delivery",
    slug: "allen-raghunath",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karl",
    lastName: "Ragnauth",
    title: "Associate Director, Web and Mobile Services",
    slug: "karl-ragnauth",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nina Valerie",
    lastName: "Ragone",
    title: "Assistant Director, Pre-College Admissions",
    slug: "nina-valerie-ragone",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lauren E",
    lastName: "Ragone",
    title: "Associate Director, Benefits and Compensation Operations",
    slug: "lauren-e-ragone",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marika",
    lastName: "Ragovskaia",
    title: "Associate Director, Events Management",
    slug: "marika-ragovskaia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mohammad",
    lastName: "Rahman",
    title: "Sr. Application Systems Developer, Java",
    slug: "mohammad-rahman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Masudur",
    lastName: "Rahman",
    title: "Associate Director",
    slug: "masudur-rahman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Claudia Virginia",
    lastName: "Rahman-DuJarric",
    title: "Administrative",
    slug: "claudia-virginia-rahman-dujarric",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anthony Scott",
    lastName: "Rainey",
    title: "Grants Administrator",
    slug: "anthony-scott-rainey",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Madhavi",
    lastName: "Rajdev",
    title: "Deputy Controller",
    slug: "madhavi-rajdev",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yasmin",
    lastName: "Rajendran",
    title: "Collaborator",
    slug: "yasmin-rajendran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deepak",
    lastName: "Rajwani",
    title: "Sr.Application Systems Developer",
    slug: "deepak-rajwani",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeff",
    lastName: "Rall",
    title: "Sr. Salesforce Developer",
    slug: "jeff-rall",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth",
    lastName: "Rallis",
    title: "Executive Assistant and Office Manager",
    slug: "elizabeth-rallis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annette M",
    lastName: "Ralph",
    title: "Senior Administrative Manager",
    slug: "annette-m-ralph",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paula D",
    lastName: "Ralph-Birkett",
    title: "Program Manager",
    slug: "paula-d-ralph-birkett",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Miriah Naomi",
    lastName: "Ralston",
    title: "Assistant Editor",
    slug: "miriah-naomi-ralston",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anita",
    lastName: "Ramasami Henriquez",
    title: "Director, Budget and Financial Analysis",
    slug: "anita-ramasami-henriquez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rebecca Taige",
    lastName: "Rambarran",
    title: "Assistant Director",
    slug: "rebecca-taige-rambarran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diana D.",
    lastName: "Rambeau",
    title: "Director of Events and Community Engagement and Operation",
    slug: "diana-d-rambeau",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sharon",
    lastName: "Rambhadjan",
    title: "Financial Assistant",
    slug: "sharon-rambhadjan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nadia",
    lastName: "Ramdeen",
    title: "Administrative Coordinator",
    slug: "nadia-ramdeen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven J.",
    lastName: "Ramirez",
    title: "Sub-Awards Manager",
    slug: "steven-j-ramirez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sophy N.",
    lastName: "Ramirez",
    title: "Executive Assistant",
    slug: "sophy-n-ramirez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shawn",
    lastName: "Ramirez",
    title: "Counselor, Financial Loan",
    slug: "shawn-ramirez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rudy",
    lastName: "Ramirez",
    title: "Operations Coordinator",
    slug: "rudy-ramirez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Raquel M",
    lastName: "Ramirez",
    title: "Financial Aid Officer",
    slug: "raquel-m-ramirez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisandra G",
    lastName: "Ramirez",
    title: "Manager, HR & FA",
    slug: "lisandra-g-ramirez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jose",
    lastName: "Ramirez",
    title: "Director IT Site Support",
    slug: "jose-ramirez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Juan D",
    lastName: "Ramirez",
    title: "Regulatory Coordinator",
    slug: "juan-d-ramirez",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "German",
    lastName: "Ramirez",
    title: "Tech A",
    slug: "german-ramirez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elenisse",
    lastName: "Ramirez",
    title: "CMA",
    slug: "elenisse-ramirez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Diana Minerva",
    lastName: "Ramirez",
    title: "Associate Director of Admissions",
    slug: "diana-minerva-ramirez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Charlenny",
    lastName: "Ramirez Beltre",
    title: "MPA",
    slug: "charlenny-ramirez-beltre",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cindy",
    lastName: "Ramjeawan",
    title: "Data Manager",
    slug: "cindy-ramjeawan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer D",
    lastName: "Ramlall",
    title: "Administrative Assistant",
    slug: "jennifer-d-ramlall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nancy Ann",
    lastName: "Ramos",
    title: "Leave Management, Administrative Coordinator",
    slug: "nancy-ann-ramos",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lorraine",
    lastName: "Ramos",
    title: "Associate Director, Sponsored Project Finance",
    slug: "lorraine-ramos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kamrun",
    lastName: "Ramos",
    title: "Asst Director-Human Resources",
    slug: "kamrun-ramos",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Keyauna",
    lastName: "Ramos",
    title: "Assistant Director, Admissions",
    slug: "keyauna-ramos",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jennifer Anne",
    lastName: "Ramos",
    title: "Senior Director, Research Strategy and Consulting",
    slug: "jennifer-anne-ramos",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Idania",
    lastName: "Ramos",
    title: "Call Center Representative",
    slug: "idania-ramos",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emma Eden",
    lastName: "Ramos",
    title: "Development and Marketing Associate",
    slug: "emma-eden-ramos",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alejandra A.",
    lastName: "Ramos",
    title: "OrgDev-People Specialist",
    slug: "alejandra-a-ramos",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lilibeth",
    lastName: "Ramos Flores",
    title: "Student Affairs Manager",
    slug: "lilibeth-ramos-flores",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Raquel M",
    lastName: "Ramos Plasencia",
    title: "Project Coordinator",
    slug: "raquel-m-ramos-plasencia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bernice",
    lastName: "Ramos-Perez",
    title: "Department Administrator",
    slug: "bernice-ramos-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex Elisabeth",
    lastName: "Ramsden",
    title: "Project Coordinator",
    slug: "alex-elisabeth-ramsden",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Akai Sterling",
    lastName: "Ramsey",
    title: "Instructional Support Assistant",
    slug: "akai-sterling-ramsey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Raina M.",
    lastName: "Ranaghan",
    title: "Assistant Director of Career Placement",
    slug: "raina-m-ranaghan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Akash",
    lastName: "Rani",
    title: "Consultant",
    slug: "akash-rani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Asha",
    lastName: "Rani",
    title: "Administrative Coordinator",
    slug: "asha-rani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carla J.",
    lastName: "Ransom",
    title: "Executive Assistant",
    slug: "carla-j-ransom",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Advaita S",
    lastName: "Rao-Sharma",
    title: "Salesforce Administrator",
    slug: "advaita-s-rao-sharma",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Frank A.",
    lastName: "Rapkiewicz",
    title: "Project Lead, Classroom and Lab Technologies",
    slug: "frank-a-rapkiewicz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kimberly C.",
    lastName: "Rapp",
    title: "Associate Director of Sales Operations",
    slug: "kimberly-c-rapp",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Farjia",
    lastName: "Rashid",
    title: "Treasury Assistant",
    slug: "farjia-rashid",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Diana",
    lastName: "Rashidi",
    title: "Asst Director, Career Services",
    slug: "diana-rashidi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Aviva",
    lastName: "Raskin",
    title: "Live Support Specialist",
    slug: "aviva-raskin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tiffany L.",
    lastName: "Rasmussen",
    title: "Director, Office of Professional Excellence",
    slug: "tiffany-l-rasmussen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trena Miriam",
    lastName: "Rauner",
    title: "Coordinator of Reading Services",
    slug: "trena-miriam-rauner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth Hannah",
    lastName: "Rauner",
    title: "Interim Literacy Practicum Supervsiors - Spring 2025",
    slug: "elizabeth-hannah-rauner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Patrick W",
    lastName: "Rausch Jr",
    title: "Student Casual",
    slug: "patrick-w-rausch-jr",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Richard L.",
    lastName: "Ray II",
    title: "Associate Director, Systems and Operational Initiatives",
    slug: "richard-l-ray-ii",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brigid",
    lastName: "Rayder",
    title: "Sr Project Portfolio Manager",
    slug: "brigid-rayder",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Fazle",
    lastName: "Rayhan",
    title: "Senior Accountant",
    slug: "fazle-rayhan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marc A.",
    lastName: "Raymond",
    title: "Senior Web Designer",
    slug: "marc-a-raymond",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rose",
    lastName: "Razaghian",
    title: "Dean of Academic Planning and Governance",
    slug: "rose-razaghian",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kari Adelaide",
    lastName: "Razdow",
    title: "Senior Admissions Manager",
    slug: "kari-adelaide-razdow",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Matthew",
    lastName: "Reals",
    title: "Sr Dir Dev,Principal Mjr Gifts",
    slug: "matthew-reals",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica S.",
    lastName: "Rechtschaffer",
    title: "Dir, Academic Admin & Finance",
    slug: "jessica-s-rechtschaffer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mary Delena",
    lastName: "Redd",
    title: "Community Health Worker",
    slug: "mary-delena-redd",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Colin",
    lastName: "Redhead",
    title: "Deputy Treasurer",
    slug: "colin-redhead",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ricardo M",
    lastName: "Redito",
    title: "Bosun",
    slug: "ricardo-m-redito",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tony",
    lastName: "Reen",
    title: "Director of Infrastructure Services",
    slug: "tony-reen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anne M.",
    lastName: "Reeves",
    title: "Administrative Assistant",
    slug: "anne-m-reeves",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathia",
    lastName: "Regalado",
    title: "Program Administrator",
    slug: "kathia-regalado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa M.",
    lastName: "Rehm",
    title: "Sr Grants Specialist",
    slug: "lisa-m-rehm",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shumaisa",
    lastName: "Rehman-Nabi",
    title: "Assistant Director, Career Development",
    slug: "shumaisa-rehman-nabi",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kristen",
    lastName: "Reichardt",
    title: "Administrative Manager",
    slug: "kristen-reichardt",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Symonne Tiffany",
    lastName: "Reid",
    title: "Student Life Coordinator",
    slug: "symonne-tiffany-reid",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Selah Frances",
    lastName: "Reid",
    title: "Research Support Assistant",
    slug: "selah-frances-reid",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Patricia",
    lastName: "Reid",
    title: "Associate Treasurer, Global Cash Management and Operations",
    slug: "patricia-reid",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jason Donovan",
    lastName: "Reid",
    title: "Coordinator Assistant",
    slug: "jason-donovan-reid",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Genise",
    lastName: "Reid",
    title: "Staff",
    slug: "genise-reid",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sean S.",
    lastName: "Reilly",
    title: "Administrative Aide",
    slug: "sean-s-reilly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan Cynthia",
    lastName: "Reilly",
    title: "Music Hybrid Coordinator with Prof.Fynn",
    slug: "megan-cynthia-reilly",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jack",
    lastName: "Reilly",
    title: "Director of Decanal Affairs",
    slug: "jack-reilly",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eileen",
    lastName: "Reilly",
    title: "Office Manager I",
    slug: "eileen-reilly",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna Silvia",
    lastName: "Reinhard",
    title: "Academic Affairs Coordinator",
    slug: "anna-silvia-reinhard",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eric J.",
    lastName: "Reisenger",
    title: "Art Handler",
    slug: "eric-j-reisenger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lily Glieth",
    lastName: "Reiser",
    title: "Admission Coordinator",
    slug: "lily-glieth-reiser",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Emily M",
    lastName: "Reiser",
    title: "Director, Financial Operations",
    slug: "emily-m-reiser",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Robert",
    lastName: "Reiter",
    title: "Senior  Director, Compensation and HR Administration",
    slug: "robert-reiter",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sara",
    lastName: "Remedios Bloom",
    title: "Assistant Dean of Student Success Programs",
    slug: "sara-remedios-bloom",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Natalia M",
    lastName: "Remis",
    title: "Advising Dean",
    slug: "natalia-m-remis",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Magalita",
    lastName: "Rene",
    title: "Director, Human Resources",
    slug: "magalita-rene",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Francisco",
    lastName: "Renta",
    title: "Coordinator",
    slug: "francisco-renta",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jessica Peyton",
    lastName: "Rentz",
    title: "Coordinator-Concentrations",
    slug: "jessica-peyton-rentz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Azalia",
    lastName: "Resendiz",
    title: "Coordinator",
    slug: "azalia-resendiz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alpa",
    lastName: "Reshamwala",
    title: "Coding and Charge Edits Specialist III",
    slug: "alpa-reshamwala",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth Ann",
    lastName: "Resko",
    title: "Manager-Print Srvs",
    slug: "elizabeth-ann-resko",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sadie A.",
    lastName: "Resnick",
    title: "Project Coordinator IT/Analytics",
    slug: "sadie-a-resnick",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maribel",
    lastName: "Respo",
    title: "Assoc Director - Research Ops",
    slug: "maribel-respo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maggie",
    lastName: "Ress",
    title: "Senior Associate Director of Development, School of the Arts",
    slug: "maggie-ress",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carly",
    lastName: "Rettie",
    title: "Manager of Operations and Administrative Services",
    slug: "carly-rettie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karen",
    lastName: "Rey",
    title: "Administrator, Research Edu Op",
    slug: "karen-rey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yesenia",
    lastName: "Reyes",
    title: "Receptionist",
    slug: "yesenia-reyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Virtudes",
    lastName: "Reyes",
    title: "Onboarding Manager",
    slug: "virtudes-reyes",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Taylor",
    lastName: "Reyes",
    title: "Student and Alumni Engagement Coordinator",
    slug: "taylor-reyes",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Saverio",
    lastName: "Reyes",
    title: "Contractor",
    slug: "saverio-reyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Reyes",
    title: "Event Manager",
    slug: "stephanie-reyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Raquel J.",
    lastName: "Reyes",
    title: "Production Center Manager",
    slug: "raquel-j-reyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nayroby",
    lastName: "Reyes",
    title: "Coordinator",
    slug: "nayroby-reyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melina",
    lastName: "Reyes",
    title: "Associate Director, Human Resources",
    slug: "melina-reyes",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael D",
    lastName: "Reyes",
    title: "Asst Manager, Business Office",
    slug: "michael-d-reyes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Loyda R.",
    lastName: "Reyes",
    title: "Special Projects Manager",
    slug: "loyda-r-reyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristiana",
    lastName: "Reyes",
    title: "Live Support Specialist",
    slug: "kristiana-reyes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jesus Isaias",
    lastName: "Reyes",
    title: "Administrative Coordinator",
    slug: "jesus-isaias-reyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juan Carlos Carlos",
    lastName: "Reyes",
    title:
      " Executive Director for Diversity, Community Affairs & Equity/Deputy Section 504 Compliance Officer",
    slug: "juan-carlos-carlos-reyes",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Hareton",
    lastName: "Reyes",
    title: "Adult Education Program Manager",
    slug: "hareton-reyes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Evelyn",
    lastName: "Reyes",
    title: "Associate Director, Accounting Operations",
    slug: "evelyn-reyes",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Clayre",
    lastName: "Reyes",
    title: "Assistant Director",
    slug: "clayre-reyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Celestina",
    lastName: "Reyes",
    title: "Secretary B",
    slug: "celestina-reyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angielina",
    lastName: "Reyes",
    title: "Program Manager",
    slug: "angielina-reyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andria",
    lastName: "Reyes",
    title: "Sr Health Education Specialist",
    slug: "andria-reyes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Adrieanna Cheyenne",
    lastName: "Reyes",
    title: "Associate Director of Undergraduate Student Affairs",
    slug: "adrieanna-cheyenne-reyes",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Adrian",
    lastName: "Reyes Gloss",
    title: "IRB Specialist / Asst Manager",
    slug: "adrian-reyes-gloss",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maria S",
    lastName: "Reyes Luna",
    title: "Project Coordinator I",
    slug: "maria-s-reyes-luna",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa L",
    lastName: "Reynolds",
    title: "Assistant Provost for Academic Programs",
    slug: "melissa-l-reynolds",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Niurka",
    lastName: "Reynoso",
    title: "Program Manager",
    slug: "niurka-reynoso",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria Y.",
    lastName: "Reynoso",
    title: "Director of Compliance",
    slug: "maria-y-reynoso",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Alenia M.",
    lastName: "Reynoso",
    title: "Assistant Director of Human Resources",
    slug: "alenia-m-reynoso",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Liana",
    lastName: "Rhee",
    title: "Assistant Director of Web & Digital Design",
    slug: "liana-rhee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eileen",
    lastName: "Rhie",
    title: "Admissions Officer",
    slug: "eileen-rhie",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ben",
    lastName: "Rhoades",
    title: "Asst Dir, Shared Res Ops",
    slug: "ben-rhoades",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Rias",
    title: "Senior Admissions Specialist",
    slug: "danielle-rias",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Paulo C.",
    lastName: "Ribeiro",
    title: "Instructional Support Specialist",
    slug: "paulo-c-ribeiro",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily",
    lastName: "Riber",
    title: "Office Coordinator",
    slug: "emily-riber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Taylor",
    lastName: "Riccio",
    title: "Director of Artistic and Production Planning",
    slug: "taylor-riccio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natilia H.",
    lastName: "Rice",
    title: "Assistant Director of Administration & Planning",
    slug: "natilia-h-rice",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Beatrice",
    lastName: "Rice",
    title: "Dir, Student Activities/P&S Cl",
    slug: "beatrice-rice",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nigel Barrington",
    lastName: "Richard",
    title: "Senior Program Director",
    slug: "nigel-barrington-richard",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carmella Alfreda",
    lastName: "Richards",
    title: "Administrative Coordinator",
    slug: "carmella-alfreda-richards",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashlie Briana",
    lastName: "Richards",
    title: "Senior Human Resources Coordinator",
    slug: "ashlie-briana-richards",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Susan R.",
    lastName: "Richards-Baptiste",
    title: "Assoc Director-Finance Admin",
    slug: "susan-r-richards-baptiste",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shenetta A.",
    lastName: "Richardson",
    title: "Director, Voice & Mobile Services",
    slug: "shenetta-a-richardson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephan",
    lastName: "Richardson",
    title: "Assistant Director - HR",
    slug: "stephan-richardson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Obri",
    lastName: "Richardson",
    title: "Staff",
    slug: "obri-richardson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Oral",
    lastName: "Richardson",
    title: "Grant Manager",
    slug: "oral-richardson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matthew",
    lastName: "Richardson",
    title: "Assistant Director, Operations",
    slug: "matthew-richardson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Asasia S",
    lastName: "Richardson",
    title: "Technical Support Specialist",
    slug: "asasia-s-richardson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anais",
    lastName: "Richardson",
    title: "Administrative Assistant I",
    slug: "anais-richardson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jada Valera",
    lastName: "Richiez",
    title: "SYEP",
    slug: "jada-valera-richiez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sonia",
    lastName: "Richmond",
    title: "CRNA",
    slug: "sonia-richmond",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lance D.",
    lastName: "Richmond",
    title: "Manager, Customer Support Services",
    slug: "lance-d-richmond",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Petra",
    lastName: "Richterova",
    title: "Research Affiliate",
    slug: "petra-richterova",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tonya",
    lastName: "Ricketts-De La Rosa",
    title: "Associate Director - Practicum Learning",
    slug: "tonya-ricketts-de-la-rosa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laura",
    lastName: "Rickman",
    title:
      " Business Manager in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "laura-rickman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily Ruth",
    lastName: "Riddles",
    title: "Director of Academic Administration",
    slug: "emily-ruth-riddles",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Deborah E",
    lastName: "Ridgard",
    title: "Benefits Specialists",
    slug: "deborah-e-ridgard",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Susanne M",
    lastName: "Ridley",
    title: "Coordinator",
    slug: "susanne-m-ridley",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Natalie M",
    lastName: "Riera",
    title: "Staff Assoicate II in the Gertrude H. SergievskyCenter",
    slug: "natalie-m-riera",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marie",
    lastName: "Rigaud",
    title: "Catering Sales Manager",
    slug: "marie-rigaud",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William J.",
    lastName: "Riggs",
    title: "Able Bodied Seaperson",
    slug: "william-j-riggs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan M.",
    lastName: "Rigney",
    title: "Associate Dean",
    slug: "megan-m-rigney",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joseph Daniel",
    lastName: "Riina-Ferrie",
    title: "Associate Director of Educational Media",
    slug: "joseph-daniel-riina-ferrie",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Timothy Michael",
    lastName: "Riley",
    title: "Associate Director, Finance",
    slug: "timothy-michael-riley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kylie W.",
    lastName: "Riley",
    title: "Progam Coordinator II",
    slug: "kylie-w-riley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edna D",
    lastName: "Rilveria",
    title: "Assistant Director, Benefits System",
    slug: "edna-d-rilveria",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Maylin E.",
    lastName: "Rincon",
    title: "Administrative Assistant",
    slug: "maylin-e-rincon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Helena",
    lastName: "Rincon",
    title: "Assoc Dir for Finance and Adm",
    slug: "helena-rincon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Claudia P.",
    lastName: "Rincon",
    title: "Associate Director",
    slug: "claudia-p-rincon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yoel",
    lastName: "Rio",
    title: "Financial Assistant",
    slug: "yoel-rio",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samantha J.",
    lastName: "Rippner",
    title: "Associate Director, LeRoy Neiman Center for Print Studies",
    slug: "samantha-j-rippner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Luis F",
    lastName: "Riquelme",
    title: "Adjunct, Communication Sciences and Disorders Program",
    slug: "luis-f-riquelme",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vicki A.",
    lastName: "Risser",
    title: "Administrative Assistant",
    slug: "vicki-a-risser",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dean",
    lastName: "Risteski",
    title: "Sr Dir, Bus Intel, Anls&Rptng",
    slug: "dean-risteski",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ariel S.",
    lastName: "Ritchin",
    title:
      " Senior Producer, Content & Programs, Dart Center for Journalism & Training",
    slug: "ariel-s-ritchin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathleen",
    lastName: "Rithisorn",
    title: "Administrative Director",
    slug: "kathleen-rithisorn",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gregory Anthony",
    lastName: "Rivas",
    title: "Executive Director",
    slug: "gregory-anthony-rivas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine Denise",
    lastName: "Rivas",
    title: "Procurement Coordinator",
    slug: "christine-denise-rivas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Crystal C.",
    lastName: "Rivas",
    title: "Project Manager",
    slug: "crystal-c-rivas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria G",
    lastName: "Rivas Alvarado",
    title: "Sr Lab & Data Coordinator",
    slug: "maria-g-rivas-alvarado",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vanessa",
    lastName: "Riveiro",
    title: "Site Manager",
    slug: "vanessa-riveiro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Terri",
    lastName: "Rivera",
    title: "Administrative Manager",
    slug: "terri-rivera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie A",
    lastName: "Rivera",
    title: "Alumni Operations Associate",
    slug: "stephanie-a-rivera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Selina",
    lastName: "Rivera",
    title: "Finance Coordinator",
    slug: "selina-rivera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Samantha",
    lastName: "Rivera",
    title: "Administrative Assistant",
    slug: "samantha-rivera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosa E.",
    lastName: "Rivera",
    title:
      " Director, MSPH/SPA and Associate Dean for Grants and Contract, MSPH",
    slug: "rosa-e-rivera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Randy",
    lastName: "Rivera",
    title: "Category Manager, Construction Sourcing",
    slug: "randy-rivera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Omiyajaira",
    lastName: "Rivera",
    title: "Procurement Clerk",
    slug: "omiyajaira-rivera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nilca S",
    lastName: "Rivera",
    title: "Manager, Financial Reporting",
    slug: "nilca-s-rivera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nayrobi A",
    lastName: "Rivera",
    title: "Regulatory Assistant",
    slug: "nayrobi-a-rivera",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Nina-Marie",
    lastName: "Rivera",
    title: "Senior Director of Admissions Operations",
    slug: "nina-marie-rivera",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Maria",
    lastName: "Rivera",
    title: "Customer Service Representative",
    slug: "maria-rivera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa",
    lastName: "Rivera",
    title: "Coordinator",
    slug: "melissa-rivera",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Melissa",
    lastName: "Rivera",
    title: "Manager, Finance and Budget",
    slug: "melissa-rivera-1",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jackelyn",
    lastName: "Rivera",
    title: "Director of Special Events and Programs",
    slug: "jackelyn-rivera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juan",
    lastName: "Rivera",
    title: "Building Coordinator",
    slug: "juan-rivera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jerry",
    lastName: "Rivera",
    title: "Manager - Stockroom",
    slug: "jerry-rivera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juan",
    lastName: "Rivera",
    title: "Manager of Systems / Financial Reporting",
    slug: "juan-rivera-1",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jo-Ann",
    lastName: "Rivera",
    title: "Director Admin & Finance",
    slug: "jo-ann-rivera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eric",
    lastName: "Rivera",
    title: "Admissions Specialist",
    slug: "eric-rivera",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Daniel",
    lastName: "Rivera",
    title: "Residence Hall Director",
    slug: "daniel-rivera",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Caroline Y.",
    lastName: "Rivera",
    title: "Assistant Regulatory Manager",
    slug: "caroline-y-rivera",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Carla Maria",
    lastName: "Rivera",
    title: "Asst Director - Tuition Pgms",
    slug: "carla-maria-rivera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Benny",
    lastName: "Rivera",
    title: "Assoc Director of Admissions",
    slug: "benny-rivera",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Daniel",
    lastName: "Rivero",
    title: "Chief of Staff",
    slug: "daniel-rivero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Haniya",
    lastName: "Rizwan",
    title: "Assistant Dean",
    slug: "haniya-rizwan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Heidi",
    lastName: "Rizzo",
    title: "Associate Registrar",
    slug: "heidi-rizzo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nathan W",
    lastName: "Robb",
    title: "Associate Vice President, Government Affairs",
    slug: "nathan-w-robb",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kevin",
    lastName: "Robbins",
    title:
      " Senior Director of Development, Center on Global Energy Policy, SIPA",
    slug: "kevin-robbins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle A",
    lastName: "Robbins",
    title: "Assoc Vice Dean/CAO, HR & FA",
    slug: "danielle-a-robbins",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Stachel Alana",
    lastName: "Roberts",
    title: "Project Officer, Social Impact Leadership",
    slug: "stachel-alana-roberts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Simone",
    lastName: "Roberts",
    title: "Administrator",
    slug: "simone-roberts",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mark",
    lastName: "Roberts",
    title: "Senior Associate Dean, Executive Education",
    slug: "mark-roberts",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Monica",
    lastName: "Roberts",
    title: "Admin Director, Residency Prog",
    slug: "monica-roberts",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael B.",
    lastName: "Roberts",
    title: "Executive Director of Development and Alumni Relations, SIPA",
    slug: "michael-b-roberts",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeanice",
    lastName: "Roberts",
    title: "Administrative Coordinator",
    slug: "jeanice-roberts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ieunice G",
    lastName: "Roberts",
    title:
      " Senior Director for Budget and Financial Reporting for Executive Education",
    slug: "ieunice-g-roberts",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christine M",
    lastName: "Roberts",
    title: "Digital Marketing Coordinator",
    slug: "christine-m-roberts",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Aneka Renee",
    lastName: "Roberts",
    title: "Assistant Director of Operations",
    slug: "aneka-renee-roberts",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Roberts-Campbell",
    title: "Divisional Administrator",
    slug: "jessica-roberts-campbell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aaron",
    lastName: "Robertson",
    title: "Assistant Director, Student Service and ID Center",
    slug: "aaron-robertson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tayla",
    lastName: "Robinson",
    title: "Associate Director, Student Conduct",
    slug: "tayla-robinson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Matthew R",
    lastName: "Robinson",
    title: "Senior Director of Research Publications and Editorial Services",
    slug: "matthew-r-robinson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael G.",
    lastName: "Robinson",
    title: "Assistant Dean, Engagement",
    slug: "michael-g-robinson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa Beth",
    lastName: "Robinson",
    title: "GRG Administrative Officer",
    slug: "lisa-beth-robinson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janice Sheryl",
    lastName: "Robinson",
    title: "Vice President for Diversity and Community Affairs",
    slug: "janice-sheryl-robinson",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Jamir",
    lastName: "Robinson",
    title: "MPA",
    slug: "jamir-robinson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jacob Kyle",
    lastName: "Robinson",
    title: "AV Supervisor",
    slug: "jacob-kyle-robinson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Graham Arthur",
    lastName: "Robinson",
    title: "Post Certificate Teaching Associate",
    slug: "graham-arthur-robinson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "William",
    lastName: "Robison II",
    title: "Bosun",
    slug: "william-robison-ii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Blanca A",
    lastName: "Robles",
    title: "Neurophysiology Coordinator",
    slug: "blanca-a-robles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Iris Minerva",
    lastName: "Robles-Rivera",
    title: "Junior Accountant",
    slug: "iris-minerva-robles-rivera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Deyanira A.",
    lastName: "Roca",
    title: "Administrative Assistant",
    slug: "deyanira-a-roca",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dilenny",
    lastName: "Roca-Dominguez",
    title: "Director, Columbia Center for Injury Science and Prevention",
    slug: "dilenny-roca-dominguez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Antonio",
    lastName: "Rocchio",
    title: "Assistant Director",
    slug: "antonio-rocchio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary F.",
    lastName: "Rocco",
    title: "Director, Engaged Scholarship and Community Engage",
    slug: "mary-f-rocco",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cristina",
    lastName: "Rocha",
    title: "Secretary B",
    slug: "cristina-rocha",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeanne N.",
    lastName: "Roche",
    title: "Director of Academic Administration and Finance",
    slug: "jeanne-n-roche",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chanel J",
    lastName: "Roche",
    title: "Associate Director, Student Life",
    slug: "chanel-j-roche",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Brian D.",
    lastName: "Rocheny",
    title: "Coordinator",
    slug: "brian-d-rocheny",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Katherine S",
    lastName: "Rochmat",
    title: "Dir, Office Sponsored Projects",
    slug: "katherine-s-rochmat",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Thomas Patrick",
    lastName: "Rock",
    title: "Chief Student Affairs Officer and Associate Vice President",
    slug: "thomas-patrick-rock",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amber Dawn",
    lastName: "Rockson",
    title: "Project Manager",
    slug: "amber-dawn-rockson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda Suzanne",
    lastName: "Roden",
    title:
      " Director of Graduate Admissions and the Executive LL.M. in Global Business Law",
    slug: "amanda-suzanne-roden",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jeannine Cason",
    lastName: "Rodgers",
    title: "Sr Manager of Behavioral Mgmt",
    slug: "jeannine-cason-rodgers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Curtis M.",
    lastName: "Rodgers",
    title: "Vice Dean-General Studies",
    slug: "curtis-m-rodgers",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zuleika E.",
    lastName: "Rodriguez",
    title: "Scheduling Coordinator, OR",
    slug: "zuleika-e-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Veronica",
    lastName: "Rodriguez",
    title: "MPA",
    slug: "veronica-rodriguez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Vivianna",
    lastName: "Rodriguez",
    title: "Senior Coordinator - Administration",
    slug: "vivianna-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sophia",
    lastName: "Rodriguez",
    title: "Research Genetic Counselor",
    slug: "sophia-rodriguez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rashel",
    lastName: "Rodriguez",
    title: "Payroll Manager",
    slug: "rashel-rodriguez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nyah",
    lastName: "Rodriguez",
    title: "Joe's Coffee COntractor",
    slug: "nyah-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole F",
    lastName: "Rodriguez",
    title: "Assoc Dir, Career Adv/Res Serv",
    slug: "nicole-f-rodriguez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nicole",
    lastName: "Rodriguez",
    title: "Authorization and Referrals Specialist I",
    slug: "nicole-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nilka",
    lastName: "Rodriguez",
    title: "Associate Manager of Human Resources",
    slug: "nilka-rodriguez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mayrelina",
    lastName: "Rodriguez",
    title: "Manager",
    slug: "mayrelina-rodriguez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Melanie",
    lastName: "Rodriguez",
    title: "Administrative Aide",
    slug: "melanie-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Migdalia",
    lastName: "Rodriguez",
    title: "Secretary",
    slug: "migdalia-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leslie",
    lastName: "Rodriguez",
    title: "Investigations Assistant",
    slug: "leslie-rodriguez",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kayla",
    lastName: "Rodriguez",
    title: "SYEP",
    slug: "kayla-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katty I",
    lastName: "Rodriguez",
    title: "Administrative Coordinator",
    slug: "katty-i-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeanette",
    lastName: "Rodriguez",
    title: "Procurement Manager",
    slug: "jeanette-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob",
    lastName: "Rodriguez",
    title: "Mail Clerk",
    slug: "jacob-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jashira",
    lastName: "Rodriguez",
    title: "Finance Manager",
    slug: "jashira-rodriguez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Rodriguez",
    title: "Director, Strategic Events and Outreach",
    slug: "jessica-rodriguez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jilliene Johnson",
    lastName: "Rodriguez",
    title: "Associate Dean for Diversity and Community Engagement",
    slug: "jilliene-johnson-rodriguez",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Johnny",
    lastName: "Rodriguez",
    title: "Director, IT Projects",
    slug: "johnny-rodriguez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mel",
    lastName: "Rodriguez",
    title: "Director of Finance and Operations",
    slug: "mel-rodriguez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Irene",
    lastName: "Rodriguez",
    title: "Assistant Dean of Advising",
    slug: "irene-rodriguez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gabriel Sussman",
    lastName: "Rodriguez",
    title: "Manager Collections & Special Projects",
    slug: "gabriel-sussman-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fanny Lissette",
    lastName: "Rodriguez",
    title: "Administrative Coordinator",
    slug: "fanny-lissette-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emely",
    lastName: "Rodriguez",
    title: "Financial Coordinator",
    slug: "emely-rodriguez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Edwin",
    lastName: "Rodriguez",
    title: "Program Director",
    slug: "edwin-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Rodriguez",
    title: "Administrative Assistant",
    slug: "nicole-rodriguez-1",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eva M.",
    lastName: "Rodriguez",
    title: "Senior Secretary",
    slug: "eva-m-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elisha Hanna",
    lastName: "Rodriguez",
    title: "Associate Vice President & Controller",
    slug: "elisha-hanna-rodriguez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dulce Karina",
    lastName: "Rodriguez",
    title: "Assistant Dean",
    slug: "dulce-karina-rodriguez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Daianna",
    lastName: "Rodriguez",
    title: "Research Project Administrator",
    slug: "daianna-rodriguez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Danny J.",
    lastName: "Rodriguez",
    title: "Advance Detail Liaison",
    slug: "danny-j-rodriguez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel Joseph",
    lastName: "Rodriguez",
    title: "Director of Educational Financing",
    slug: "daniel-joseph-rodriguez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cindy",
    lastName: "Rodriguez",
    title: "Admissions Assistant",
    slug: "cindy-rodriguez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Brigitte",
    lastName: "Rodriguez",
    title: "Admissions Officer",
    slug: "brigitte-rodriguez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Billy K.",
    lastName: "Rodriguez",
    title: "Finance Manager",
    slug: "billy-k-rodriguez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Barbara M",
    lastName: "Rodriguez",
    title: "Director, Columbia Alumni Center",
    slug: "barbara-m-rodriguez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ary",
    lastName: "Rodriguez",
    title: "PwC",
    slug: "ary-rodriguez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Amanda E",
    lastName: "Rodriguez",
    title:
      " HHMI Tech in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "amanda-e-rodriguez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Asucena",
    lastName: "Rodriguez",
    title: "MPA",
    slug: "asucena-rodriguez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andreina M",
    lastName: "Rodriguez",
    title: "Asst Director, Adm/Recruit",
    slug: "andreina-m-rodriguez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Antonio",
    lastName: "Rodriguez",
    title: "Associate Director, Columbia Scholastic Press Association",
    slug: "antonio-rodriguez",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alex D.",
    lastName: "Rodriguez",
    title: "Senior Application Systems Dev",
    slug: "alex-d-rodriguez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Hector Armando",
    lastName: "Rodriguez Acosta",
    title: "Senior AV/IT Support Specialist",
    slug: "hector-armando-rodriguez-acosta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sylvia",
    lastName: "Rodriguez Bonet",
    title: "Development Assistant",
    slug: "sylvia-rodriguez-bonet",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria Aurora",
    lastName: "Rodriguez Collado",
    title: "Learning Designer II",
    slug: "maria-aurora-rodriguez-collado",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Francisco J",
    lastName: "Rodriguez Rivera",
    title: "Drupal Developer",
    slug: "francisco-j-rodriguez-rivera",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eunice",
    lastName: "Rodriguez-Ferguson",
    title: "Dir, Academic Admin & Finance",
    slug: "eunice-rodriguez-ferguson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Monica A.",
    lastName: "Rodriguez-Mendez",
    title: "Senior Data Coordinator",
    slug: "monica-a-rodriguez-mendez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth",
    lastName: "Rodriguez-Perez",
    title: "Director of Strategic Projects",
    slug: "elizabeth-rodriguez-perez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noah",
    lastName: "Rodus",
    title: "Asst Service Desk Tech-Tier I",
    slug: "noah-rodus",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Marcia",
    lastName: "Roesch",
    title: "Director, School and Child Care Search Service",
    slug: "marcia-roesch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yolande",
    lastName: "Rogers",
    title: "Administrative Coordinator",
    slug: "yolande-rogers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David L.",
    lastName: "Rogers",
    title: "Academic Director in Executive Education",
    slug: "david-l-rogers",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexandra Sarah",
    lastName: "Rogers",
    title: "Executive Assistant",
    slug: "alexandra-sarah-rogers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa J",
    lastName: "Rogerson",
    title: "Executive Assistant & Operations Manager",
    slug: "lisa-j-rogerson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia",
    lastName: "Rogo",
    title:
      " Assistant Director, Instruction and Curriculum (Pre-College Programs)",
    slug: "olivia-rogo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christina",
    lastName: "Rohm",
    title: "External Relations and Events Manager",
    slug: "christina-rohm",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Marlene",
    lastName: "Rojas",
    title: "Regulatory Coordinator",
    slug: "marlene-rojas",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Mary Alexandra",
    lastName: "Rojas",
    title: "Executive Administrator",
    slug: "mary-alexandra-rojas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Rojas",
    title: "Program Support Specialist II",
    slug: "katherine-rojas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jesenia E.",
    lastName: "Rojas",
    title: "Director, Grants Management",
    slug: "jesenia-e-rojas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Johanna",
    lastName: "Rojas",
    title: "Secretary B",
    slug: "johanna-rojas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danilda",
    lastName: "Rojas",
    title: "Supervisor, ICM",
    slug: "danilda-rojas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandon Christopher",
    lastName: "Rojas",
    title: "Analytics Developer",
    slug: "brandon-christopher-rojas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Andres",
    lastName: "Rojas",
    title: "IT User Support Specialist",
    slug: "andres-rojas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nicole",
    lastName: "Roldan",
    title: "Business Officer",
    slug: "nicole-roldan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Garrett D",
    lastName: "Rollins",
    title: "Assistant Director of Production and Operations",
    slug: "garrett-d-rollins",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Casey Dell",
    lastName: "Rollins",
    title: "Director of Research Initiatives",
    slug: "casey-dell-rollins",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kelinda",
    lastName: "Rolon",
    title: "Exec Director, Bdgt/Fin Anlys",
    slug: "kelinda-rolon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nina K.",
    lastName: "Roman",
    title: "Program Manager",
    slug: "nina-k-roman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fidelina",
    lastName: "Roman",
    title: "Medix- Social Worker",
    slug: "fidelina-roman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley Marie",
    lastName: "Roman",
    title: "Specialist-Instructional Tech",
    slug: "ashley-marie-roman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alicia",
    lastName: "Roman",
    title: "Senior Associate Dean for Finance and Administration",
    slug: "alicia-roman",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexander",
    lastName: "Romanov",
    title: "Assoc Director, Veterinary Ops",
    slug: "alexander-romanov",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mel",
    lastName: "Romero",
    title: "Director of Operations",
    slug: "mel-romero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin Lee",
    lastName: "Romero",
    title: "Manager, Gift Systems",
    slug: "kevin-lee-romero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Denise",
    lastName: "Romero",
    title: "Administrative Assistant I",
    slug: "denise-romero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexandra T.",
    lastName: "Romero",
    title: "Production Coordinator",
    slug: "alexandra-t-romero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tamia Selina",
    lastName: "Romo",
    title: "Assistant Director, Center for Institutional Social Change",
    slug: "tamia-selina-romo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Indrakala",
    lastName: "Rompally",
    title: "Lead Applications Systems Developer",
    slug: "indrakala-rompally",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Prima Elvira",
    lastName: "Romulus Ortega",
    title: "Executive Director-Busi Trans",
    slug: "prima-elvira-romulus-ortega",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nekeia",
    lastName: "Rooks-Holder",
    title: "Assistant Director of Finance",
    slug: "nekeia-rooks-holder",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Skye",
    lastName: "Roper-Moses",
    title: "Assoicate II in Professional Studies",
    slug: "skye-roper-moses",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ty",
    lastName: "Rosa",
    title: "Associate Director of Research Initiatives",
    slug: "ty-rosa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Teresa Esteves",
    lastName: "Rosa",
    title: "Senior Project Manager",
    slug: "teresa-esteves-rosa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Megan I",
    lastName: "Rosa",
    title: "Secretary B",
    slug: "megan-i-rosa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katharine R.B.",
    lastName: "Rosa",
    title: "Senior Lab Manager",
    slug: "katharine-r-b-rosa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dinelia",
    lastName: "Rosa",
    title: "Director",
    slug: "dinelia-rosa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie",
    lastName: "Rosa-Negron",
    title: "Admin Clinic Coordinator",
    slug: "julie-rosa-negron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yojahira",
    lastName: "Rosado",
    title: "Financial Coordinator",
    slug: "yojahira-rosado",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Katherine",
    lastName: "Rosado",
    title: "Business Manager",
    slug: "katherine-rosado",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrea",
    lastName: "Rosado",
    title:
      " Senior Administrative Lab Manager in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "andrea-rosado",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ixchel",
    lastName: "Rosal",
    title: "Senior Associate Vice President, Student Life",
    slug: "ixchel-rosal",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Felice B.",
    lastName: "Rosan",
    title: "General Counsel",
    slug: "felice-b-rosan",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Roberto",
    lastName: "Rosario",
    title: "Systems Administrator",
    slug: "roberto-rosario",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nelson Eladio",
    lastName: "Rosario",
    title: "Administrative Clerk",
    slug: "nelson-eladio-rosario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mabel M.",
    lastName: "Rosario",
    title: "LIS Application Manager",
    slug: "mabel-m-rosario",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Liliana",
    lastName: "Rosario",
    title: "Administrative Assistant",
    slug: "liliana-rosario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luz",
    lastName: "Rosario",
    title: "Senior Administrative Manager",
    slug: "luz-rosario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kalena Marie",
    lastName: "Rosario",
    title: "Secretary",
    slug: "kalena-marie-rosario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "Rosario",
    title: "Administrative Coordinator",
    slug: "heather-rosario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gricelda",
    lastName: "Rosario",
    title: "Administrative Clerk",
    slug: "gricelda-rosario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Crisleyda",
    lastName: "Rosario",
    title: "Administrative Assistant",
    slug: "crisleyda-rosario",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Idsel Yasmin",
    lastName: "Rosas",
    title: "Administrative Assistant",
    slug: "idsel-yasmin-rosas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacob Louis",
    lastName: "Rosati",
    title: "Manager, Multimedia Content",
    slug: "jacob-louis-rosati",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alison",
    lastName: "Rose",
    title: "Senior Program Manager",
    slug: "alison-rose",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Penna",
    lastName: "Rose",
    title: "Artist-in-Residence",
    slug: "penna-rose",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane",
    lastName: "Rose",
    title: "Asst Dir, Dev Res",
    slug: "jane-rose",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew Casciola",
    lastName: "Rosen",
    title: "Contractor",
    slug: "matthew-casciola-rosen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erica",
    lastName: "Rosen",
    title: "Academic Secretary",
    slug: "erica-rosen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Seth",
    lastName: "Rosenberg",
    title: "Director, User Support and Training",
    slug: "seth-rosenberg",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily L.",
    lastName: "Rosenberg",
    title: "Sr Development Associate",
    slug: "emily-l-rosenberg",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barbara R",
    lastName: "Rosenberg",
    title: "Sr Director,Financial Services",
    slug: "barbara-r-rosenberg",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ariana S. G.",
    lastName: "Rosenberg",
    title: "Live Support Specialist",
    slug: "ariana-s-g-rosenberg",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mariam",
    lastName: "Rosenboom",
    title: "Human Resources Generalist",
    slug: "mariam-rosenboom",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Traci L.",
    lastName: "Rosenthal",
    title: "Director",
    slug: "traci-l-rosenthal",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Steven",
    lastName: "Rosenthal",
    title: "Lead Database Administrator",
    slug: "steven-rosenthal",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Samuel",
    lastName: "Rosenthal",
    title: "Senior Webinar Specialist",
    slug: "samuel-rosenthal",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rhonda",
    lastName: "Rospide",
    title: "Director of Human Resources",
    slug: "rhonda-rospide",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nicole L",
    lastName: "Ross",
    title: "Social Worker",
    slug: "nicole-l-ross",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josephine Mellone",
    lastName: "Ross",
    title: "Asst Director-Fin Aid Ops",
    slug: "josephine-mellone-ross",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rossana",
    lastName: "Rossi",
    title: "Office Manager",
    slug: "rossana-rossi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna Lori",
    lastName: "Rossi",
    title: "Manager II",
    slug: "donna-lori-rossi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda Noelle",
    lastName: "Rossillo",
    title: "Assistant Editorial Director",
    slug: "amanda-noelle-rossillo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emily A",
    lastName: "Rothenberg",
    title:
      " National Student Data Corps Program Manager - Northeast Big Data Hub",
    slug: "emily-a-rothenberg",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew",
    lastName: "Rotstein",
    title: "Director",
    slug: "matthew-rotstein",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ian",
    lastName: "Rottenberg",
    title:
      " Dean of Religious Life; Director of the Earl Hall and Associate Chaplain",
    slug: "ian-rottenberg",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lani D",
    lastName: "Rountree",
    title: "Assistant Manager",
    slug: "lani-d-rountree",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leah",
    lastName: "Rousmaniere",
    title: "Development Associate",
    slug: "leah-rousmaniere",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hasson",
    lastName: "Roussell",
    title: "Porter",
    slug: "hasson-roussell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica C",
    lastName: "Rowe",
    title: "Associate Director, Instructional Design",
    slug: "jessica-c-rowe",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexander S",
    lastName: "Rowe",
    title: "Senior Project Officer",
    slug: "alexander-s-rowe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Skyler",
    lastName: "Rowland",
    title: "Administrative Assistant",
    slug: "skyler-rowland",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas James",
    lastName: "Rowley",
    title: "Media Production Manager",
    slug: "thomas-james-rowley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andrew",
    lastName: "Rowls",
    title: "Consultant",
    slug: "andrew-rowls",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole A",
    lastName: "Royer",
    title: "Assistant Director",
    slug: "nicole-a-royer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leonid",
    lastName: "Royzman",
    title: "Senior Application Systems Developer",
    slug: "leonid-royzman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Arkady",
    lastName: "Royzman",
    title: "Sr Application Systems Develop",
    slug: "arkady-royzman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Valeriy",
    lastName: "Rozhdestvenskiy",
    title: "Business Manager",
    slug: "valeriy-rozhdestvenskiy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marcela V.",
    lastName: "Ruano",
    title: "Director, Financial Operations",
    slug: "marcela-v-ruano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marcela",
    lastName: "Ruano",
    title: "Associate Director, Financial Planning",
    slug: "marcela-ruano",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kaitlyn Ada",
    lastName: "Rubbo",
    title: "Coordinator",
    slug: "kaitlyn-ada-rubbo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Nancy",
    lastName: "Rubino",
    title: "Associate Dean of Experiential Education",
    slug: "nancy-rubino",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Allison Rose",
    lastName: "Rubinowitz",
    title: "Assistant Director, Undergraduate Global Engagement",
    slug: "allison-rose-rubinowitz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Josefina",
    lastName: "Rueda",
    title: "Acct Recv Follow Up Spc III",
    slug: "josefina-rueda",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julia Meghan",
    lastName: "Ruegg",
    title: "Senior Case Manager",
    slug: "julia-meghan-ruegg",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Christopher K",
    lastName: "Rugen",
    title: "Senior Director, Website and Design",
    slug: "christopher-k-rugen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Annie Louise",
    lastName: "Ruhl",
    title: "Manager, Ops & Shared Services",
    slug: "annie-louise-ruhl",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yvonne",
    lastName: "Ruiz",
    title: "Administrative Coordinator",
    slug: "yvonne-ruiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marcia Yolanda",
    lastName: "Ruiz",
    title: "Secretary",
    slug: "marcia-yolanda-ruiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lenard Michael",
    lastName: "Ruiz",
    title: "Sr Exec Director,CUIMC Payroll",
    slug: "lenard-michael-ruiz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jacqueline",
    lastName: "Ruiz",
    title: "Manager of Operations",
    slug: "jacqueline-ruiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "JUDITH A",
    lastName: "RUIZ",
    title: "Executive Director of Administration and HR",
    slug: "judith-a-ruiz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ernesto",
    lastName: "Ruiz",
    title: "Contractor-P30 Research",
    slug: "ernesto-ruiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lissa",
    lastName: "Ruiz",
    title: "Coordinator, Sports Management",
    slug: "lissa-ruiz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tiesha",
    lastName: "Ruiz Battles",
    title: "Coding Charge Edits Spc II",
    slug: "tiesha-ruiz-battles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deborah Nary",
    lastName: "Ruiz Kim",
    title: "Coordinator - Operations",
    slug: "deborah-nary-ruiz-kim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalia",
    lastName: "Ruiz-Corrales",
    title: "Associate Director, Student Conduct",
    slug: "natalia-ruiz-corrales",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Flora",
    lastName: "Rukaj",
    title: "Financial Operations Coordinator",
    slug: "flora-rukaj",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rosa H.",
    lastName: "Rule",
    title: "Financial Services Officer",
    slug: "rosa-h-rule",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "August",
    lastName: "Runge",
    title: "Executive Director, Administration and Planning",
    slug: "august-runge",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna",
    lastName: "Rungwerth",
    title: "Executive Assistant to the Dean",
    slug: "anna-rungwerth",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brenda L.",
    lastName: "Ruotolo",
    title: "Assc VP, Human Res Protection",
    slug: "brenda-l-ruotolo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jelica",
    lastName: "Rupar",
    title: "Administrative Coordinator",
    slug: "jelica-rupar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Avallon L",
    lastName: "Rupert",
    title: "Career Development Officer",
    slug: "avallon-l-rupert",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hannah C",
    lastName: "Rush",
    title: "Asst Dir, Academic Unit Budget",
    slug: "hannah-c-rush",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth",
    lastName: "Rush-LaRue",
    title: "Physical Therapist",
    slug: "elizabeth-rush-larue",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan K.",
    lastName: "Rushing",
    title:
      " Chief Legal Officer and Secretary of Columbia Investment Management Company and Deputy General Counsel of Columbia",
    slug: "susan-k-rushing",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Krystal",
    lastName: "Russell",
    title: "Receptionist",
    slug: "krystal-russell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tatyana",
    lastName: "Russo",
    title: "Executive Assistant",
    slug: "tatyana-russo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julianna",
    lastName: "Russo",
    title: "Undergraduate Academic Program Manager",
    slug: "julianna-russo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elvis A",
    lastName: "Russo",
    title: "Asst Manager- Business Office",
    slug: "elvis-a-russo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charlie",
    lastName: "Russo",
    title: "Assoc Director, HR/FA",
    slug: "charlie-russo",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Simone Ilana",
    lastName: "Rutkowitz",
    title: "Program Manager",
    slug: "simone-ilana-rutkowitz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Izabela",
    lastName: "Rutkowski",
    title: "Director-Alumni Relations",
    slug: "izabela-rutkowski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria",
    lastName: "Ruyter",
    title: "Education & Outreach Manager",
    slug: "maria-ruyter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Megan Marie",
    lastName: "Ryan",
    title: "Research Project Manager",
    slug: "megan-marie-ryan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Libby",
    lastName: "Ryasyk",
    title: "Senior Accountant, Financial Reporting",
    slug: "libby-ryasyk",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dionida X.",
    lastName: "Ryce",
    title: "Assistant Vice President for Academic Appointments",
    slug: "dionida-x-ryce",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Meredith Klein",
    lastName: "Ryer",
    title: "Associate Dir, Career Services",
    slug: "meredith-klein-ryer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Erik",
    lastName: "Ryerson",
    title: "Senior Web Designer/Developer",
    slug: "erik-ryerson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Magdalena",
    lastName: "Rzeszotko",
    title: "Assoc Dir, Business Analytics",
    slug: "magdalena-rzeszotko",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zahra",
    lastName: "Saad",
    title: "Senior Student Services Rep",
    slug: "zahra-saad",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Andrea C.",
    lastName: "Saavedra",
    title: "Associate Dean of Registration and Student Services",
    slug: "andrea-c-saavedra",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maria Beatriz",
    lastName: "Sabater Nunez",
    title: "Assistant Director, Disappearance Lab",
    slug: "maria-beatriz-sabater-nunez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elias",
    lastName: "Saber-Khiabani",
    title: "Administrative Assistant",
    slug: "elias-saber-khiabani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elana",
    lastName: "Sable",
    title: "Senior Associate Director, Employer Relations",
    slug: "elana-sable",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rick",
    lastName: "Sabo",
    title: "Manager, Email Systems",
    slug: "rick-sabo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ronnie",
    lastName: "Sacco",
    title: "Editorial Director",
    slug: "ronnie-sacco",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jillian D",
    lastName: "Sacheli",
    title: "Business and IT Manager",
    slug: "jillian-d-sacheli",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Deborah G",
    lastName: "Sack",
    title: "Vice President, Operations",
    slug: "deborah-g-sack",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sam",
    lastName: "Sadeh",
    title: "Learning Designer II",
    slug: "sam-sadeh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Laurie",
    lastName: "Sadofsky",
    title: "Training Coordinator",
    slug: "laurie-sadofsky",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rebecca Allyson",
    lastName: "Saez",
    title: "Administrative Lab Manager",
    slug: "rebecca-allyson-saez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christopher Joseph",
    lastName: "Saffos",
    title: "Org Development Specialist",
    slug: "christopher-joseph-saffos",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joshua",
    lastName: "Safier",
    title: "Managing Director Global Programs and Initiatives",
    slug: "joshua-safier",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dagmara",
    lastName: "Safin",
    title: "Senior Grant Coordinator",
    slug: "dagmara-safin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Smaragda",
    lastName: "Safos",
    title: "Administrative Assistant",
    slug: "smaragda-safos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane E.",
    lastName: "Sahner",
    title: "Manager",
    slug: "jane-e-sahner",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Qamar",
    lastName: "Said",
    title: "Senior Admin Coordinator",
    slug: "qamar-said",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leidi",
    lastName: "Saiteros",
    title: "HR Onboarding Assistant",
    slug: "leidi-saiteros",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Akiko",
    lastName: "Saito",
    title: "Executive Assistant",
    slug: "akiko-saito",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jonathan",
    lastName: "Sajous",
    title: "Coordinator, Business Services",
    slug: "jonathan-sajous",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joshua N.",
    lastName: "Sakolsky",
    title: "Executive Director Finance and Budget",
    slug: "joshua-n-sakolsky",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Minahil",
    lastName: "Salam",
    title: "Social Worker, Achievement Initiative",
    slug: "minahil-salam",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ann Louie Lomboy",
    lastName: "Salamante",
    title: "Director for Administration",
    slug: "ann-louie-lomboy-salamante",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas",
    lastName: "Salamun",
    title: "Senior Platform Support Specialist",
    slug: "nicholas-salamun",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maria",
    lastName: "Salas",
    title: "Mail Clerk",
    slug: "maria-salas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicolle",
    lastName: "Salazar",
    title: "Associate Director of Operations",
    slug: "nicolle-salazar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine E.M.",
    lastName: "Salboudis",
    title: "Administrative Manager",
    slug: "christine-e-m-salboudis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kaidalyn",
    lastName: "Salce",
    title: "SYEP",
    slug: "kaidalyn-salce",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Josefa Y.",
    lastName: "Salcedo",
    title: "Grants Manager",
    slug: "josefa-y-salcedo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Amilka",
    lastName: "Salcedo",
    title: "Administrative Aide",
    slug: "amilka-salcedo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole A",
    lastName: "Saldarriaga Coggins",
    title: "Associate Director of Communications",
    slug: "nicole-a-saldarriaga-coggins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Raffie K.",
    lastName: "Saleem",
    title: "Coordinator-Safety/Security",
    slug: "raffie-k-saleem",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scheherazade Julie",
    lastName: "Salimi",
    title: "Deputy Director, Partnerships, and Impact",
    slug: "scheherazade-julie-salimi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Salinas",
    title: "Production Coordinator",
    slug: "daniel-salinas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chaim",
    lastName: "Sallah",
    title:
      " Scientific Machinist in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "chaim-sallah",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lenora",
    lastName: "Sallie",
    title: "Administrator",
    slug: "lenora-sallie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hannah",
    lastName: "Salto",
    title: "Associate Director, Career Design Lab",
    slug: "hannah-salto",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Evelyn C.",
    lastName: "Salvado",
    title: "Lead Senior Client Manager",
    slug: "evelyn-c-salvado",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jeanette M.",
    lastName: "Salvatore",
    title: "Senior Project Leader",
    slug: "jeanette-m-salvatore",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael",
    lastName: "Salzano",
    title: "Lead Application Systems Developer",
    slug: "michael-salzano",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Achebe",
    lastName: "Sam",
    title: "IT Security Risk Manager",
    slug: "achebe-sam",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica",
    lastName: "Sama",
    title: "Department Administrator/CFO",
    slug: "jessica-sama",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Toussaint",
    lastName: "Sambou",
    title: "Manager, Client Services",
    slug: "toussaint-sambou",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yuriy",
    lastName: "Samsonov",
    title: "Director, Data Integration and Analytics Platform",
    slug: "yuriy-samsonov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachael",
    lastName: "Samuel",
    title: "Asst Director, Student Support",
    slug: "rachael-samuel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Carelle",
    lastName: "Samuel",
    title: "Senior Office Manager",
    slug: "carelle-samuel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina A",
    lastName: "Samurkas",
    title: "Project Coordinator II",
    slug: "christina-a-samurkas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luz A",
    lastName: "Sanabria",
    title: "Grants Manager",
    slug: "luz-a-sanabria",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maria M.",
    lastName: "Sanabria-Nicholas",
    title: "Administrative Coordinator",
    slug: "maria-m-sanabria-nicholas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cathy",
    lastName: "Sanacore",
    title: "Enrichment Facilitator in The School",
    slug: "cathy-sanacore",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maritza",
    lastName: "Sanchez",
    title: "Admissions Assistant",
    slug: "maritza-sanchez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nathalia",
    lastName: "Sanchez",
    title: "Secretary B",
    slug: "nathalia-sanchez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason",
    lastName: "Sanchez",
    title: "IRB Specialist - Assistant Manager",
    slug: "jason-sanchez",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jeannette",
    lastName: "Sanchez",
    title:
      " Assistant Director, Student Affairs (High School & Non-Degree Programs)",
    slug: "jeannette-sanchez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Josenny",
    lastName: "Sanchez",
    title: "Exec Assistant / Admin Manager",
    slug: "josenny-sanchez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jose",
    lastName: "Sanchez",
    title: "Duplicating Machine Operator",
    slug: "jose-sanchez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Idalia I.",
    lastName: "Sanchez",
    title: "Project Manager",
    slug: "idalia-i-sanchez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Felix D.",
    lastName: "Sanchez",
    title: "Business Manager in the Department of Chemistry",
    slug: "felix-d-sanchez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elsa",
    lastName: "Sanchez",
    title: "Director of Student Affairs",
    slug: "elsa-sanchez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Derrick",
    lastName: "Sanchez",
    title: "SYEP",
    slug: "derrick-sanchez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deanna",
    lastName: "Sanchez",
    title: "Payroll Coordinator",
    slug: "deanna-sanchez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dana Cyrelda O",
    lastName: "Sanchez",
    title: "Specialist, Organization & Dev",
    slug: "dana-cyrelda-o-sanchez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Beatriz",
    lastName: "Sanchez",
    title: "Development Assistant",
    slug: "beatriz-sanchez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna",
    lastName: "Sanchez",
    title: "Associate Director",
    slug: "anna-sanchez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lucia",
    lastName: "Sanchez Diaz",
    title: "Administrative Coordinator",
    slug: "lucia-sanchez-diaz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Betsabeth",
    lastName: "Sanchez Olivero",
    title: "Financial Assistant",
    slug: "betsabeth-sanchez-olivero",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yuli Andrea",
    lastName: "Sanchez-Diaz",
    title: "Asst Director Applications",
    slug: "yuli-andrea-sanchez-diaz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Fiona F.",
    lastName: "Sanders",
    title: "Clin Res and QA Manager",
    slug: "fiona-f-sanders",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eddie",
    lastName: "Sanders",
    title: "PDS Epic",
    slug: "eddie-sanders",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Brandee",
    lastName: "Sanders",
    title: "Assoc Director-Communications",
    slug: "brandee-sanders",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anita",
    lastName: "Sandeva",
    title: "Manager",
    slug: "anita-sandeva",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Heather",
    lastName: "Sandler",
    title: "Leadership Gift Officer, General Studies",
    slug: "heather-sandler",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brandon Anthony",
    lastName: "Sandoval",
    title: "Coordinator",
    slug: "brandon-anthony-sandoval",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Linette M.",
    lastName: "Sandoval-Rzepka",
    title: "Senior Manager, Pre-Award",
    slug: "linette-m-sandoval-rzepka",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dylan",
    lastName: "Sands",
    title: "Senior Development Writer",
    slug: "dylan-sands",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alexsandra G.",
    lastName: "Sanford",
    title: "Chief Operating Officer",
    slug: "alexsandra-g-sanford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Senaida L",
    lastName: "Santa",
    title: "Input Control Specialist",
    slug: "senaida-l-santa",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sarah",
    lastName: "Santana",
    title: "Assistant Director",
    slug: "sarah-santana",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marlene V.",
    lastName: "Santana",
    title: "Associate Director of Practicum Learning",
    slug: "marlene-v-santana",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julie",
    lastName: "Santana",
    title: "Junior Instructional Designer",
    slug: "julie-santana",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ambar",
    lastName: "Santana",
    title: "Administrative Coordinator",
    slug: "ambar-santana",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eduardo Felipe",
    lastName: "Santander Sr.",
    title: "Interim Employee",
    slug: "eduardo-felipe-santander-sr",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Roberto J.",
    lastName: "Santelises",
    title: "Dermatopathology Lab Manager",
    slug: "roberto-j-santelises",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Guru",
    lastName: "Santhanam",
    title: "Consultant",
    slug: "guru-santhanam",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yesenia",
    lastName: "Santiago",
    title: "Coding and Charge Edits Specialist II",
    slug: "yesenia-santiago",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jose A.",
    lastName: "Santiago",
    title: "AVP, Client Services",
    slug: "jose-a-santiago",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicholas",
    lastName: "Santiago",
    title: "High School Program",
    slug: "nicholas-santiago",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Maria",
    lastName: "Santiago",
    title: "Senior Student Rep",
    slug: "maria-santiago",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Geoffrey",
    lastName: "Santiago",
    title: "Lab Aide",
    slug: "geoffrey-santiago",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David",
    lastName: "Santiago",
    title: "Financial Aid Counselor",
    slug: "david-santiago",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alana R",
    lastName: "Santiago",
    title: "Administrative Assistant",
    slug: "alana-r-santiago",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Louis",
    lastName: "Santiago Jr",
    title: "Director of Building Services and Operations,",
    slug: "louis-santiago-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eulalia",
    lastName: "Santin",
    title: "Associate Director of Finance & Administration",
    slug: "eulalia-santin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Bill W.",
    lastName: "Santin",
    title: "Registrar Services Associate",
    slug: "bill-w-santin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Trudi",
    lastName: "Santobello",
    title: "Manager II",
    slug: "trudi-santobello",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rafael",
    lastName: "Santos",
    title: "Transcriptionist",
    slug: "rafael-santos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosa M",
    lastName: "Santos",
    title: "Associate Director, Budget Planning and Finance",
    slug: "rosa-m-santos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Liam",
    lastName: "Santos",
    title: "Financial Aid Assistant",
    slug: "liam-santos",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Santos",
    title: "Mammography",
    slug: "jessica-santos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jorge",
    lastName: "Santos",
    title: "Print Services Clerk",
    slug: "jorge-santos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Iris",
    lastName: "Santos",
    title: "Recruitment Manager",
    slug: "iris-santos",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Eddy",
    lastName: "Santos",
    title: "Office Assistant",
    slug: "eddy-santos",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jayalakshmi",
    lastName: "Santosh",
    title: "Assistant Director of Grants",
    slug: "jayalakshmi-santosh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vishal",
    lastName: "Sarada",
    title: "Consultant",
    slug: "vishal-sarada",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna K",
    lastName: "Sardar",
    title: "Administrative Coordinator",
    slug: "anna-k-sardar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hasmik",
    lastName: "Sargsyan",
    title: "Associate Director of Admissions",
    slug: "hasmik-sargsyan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sahema",
    lastName: "Sarika",
    title: "SYEP",
    slug: "sahema-sarika",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tumpa",
    lastName: "Sarker",
    title: "Human Resources Generalist",
    slug: "tumpa-sarker",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Gracy",
    lastName: "Sarkissian",
    title: "Associate Dean of the Career Management Center",
    slug: "gracy-sarkissian",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica",
    lastName: "Sarles",
    title: "Senior Associate Dean for Strategic Initiatives and Partnerships",
    slug: "jessica-sarles",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jaime Carlos",
    lastName: "Sarmiento",
    title: "Manager, Catering Operations",
    slug: "jaime-carlos-sarmiento",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniella",
    lastName: "Sarnoff",
    title: "Director, Social Impact Leadership",
    slug: "daniella-sarnoff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jacquelyn Anne",
    lastName: "Sasaki",
    title: "Senior Director, Donor and Prospect Relations",
    slug: "jacquelyn-anne-sasaki",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrew Francisco",
    lastName: "Satchwell",
    title: "Systems Applications Coord",
    slug: "andrew-francisco-satchwell",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "John",
    lastName: "Saul",
    title: "Director of Institutional Research",
    slug: "john-saul",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Justin",
    lastName: "Saunders",
    title: "Assistant Director of Operation Support",
    slug: "justin-saunders",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lylia",
    lastName: "Saurel",
    title: "Program Manager-Undergraduate and Continuing Programs",
    slug: "lylia-saurel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Janice",
    lastName: "Savage",
    title: "Assistant Dean, Research",
    slug: "janice-savage",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Chester J",
    lastName: "Sawicki",
    title: "Director, Org Dev-Bus Process",
    slug: "chester-j-sawicki",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Vanessa",
    lastName: "Sawyer",
    title: "Project Manager",
    slug: "vanessa-sawyer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Starling",
    lastName: "Sawyer",
    title: "Director of Event Strategy and Policy Programming",
    slug: "starling-sawyer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Mary R.",
    lastName: "Sawyer",
    title: "Associate Director of Field Education Systems and Reporting",
    slug: "mary-r-sawyer",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zara",
    lastName: "Sayeed",
    title: "Associate Director",
    slug: "zara-sayeed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth",
    lastName: "Sazo",
    title: "Senior Associate Director, Systems and Slate",
    slug: "elizabeth-sazo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Margaret A.",
    lastName: "Scanlon",
    title: "Academic Secretary",
    slug: "margaret-a-scanlon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ava M",
    lastName: "Scanlon",
    title: "Administrative Coordinator",
    slug: "ava-m-scanlon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cassandra",
    lastName: "Scannella",
    title: "Senior Instructional Designer",
    slug: "cassandra-scannella",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cathy A.",
    lastName: "Scarillo",
    title: "Administrative Assistant",
    slug: "cathy-a-scarillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Casey M.",
    lastName: "Schadie",
    title: "Executive Assistant",
    slug: "casey-m-schadie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward",
    lastName: "Schaefer",
    title: "Director of Development and Strategic Initiatives",
    slug: "edward-schaefer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexis",
    lastName: "Schaefer",
    title: "Project Coordinator",
    slug: "alexis-schaefer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elisabeth A.",
    lastName: "Schapmann",
    title: "Admissions Operations Officer",
    slug: "elisabeth-a-schapmann",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Roberta",
    lastName: "Scheinmann",
    title: "Project Director",
    slug: "roberta-scheinmann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara A",
    lastName: "Scherer",
    title: "Project Coordinator II",
    slug: "sara-a-scherer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan K.",
    lastName: "Scherman",
    title: "Senior Executive Director, Annual Giving & Alumni Relations",
    slug: "susan-k-scherman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly",
    lastName: "Schermerhorn",
    title: "Assistant Dean of Sponsored Projects Finance and Business Services",
    slug: "kimberly-schermerhorn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Laura P.",
    lastName: "Schiff",
    title: "Associate Director, UGE",
    slug: "laura-p-schiff",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Easton T",
    lastName: "Schindler",
    title: "Project Coordinator",
    slug: "easton-t-schindler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madeline",
    lastName: "Schlesinger",
    title: "Associate Director",
    slug: "madeline-schlesinger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cara",
    lastName: "Schlesinger",
    title: "Conservation Specialist",
    slug: "cara-schlesinger",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jolynn",
    lastName: "Schmidt",
    title: "Project Manager - Data Lead",
    slug: "jolynn-schmidt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anthony L",
    lastName: "Schmitt",
    title: "Director of Pre-award Services",
    slug: "anthony-l-schmitt",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kristen",
    lastName: "Schneider",
    title: "Executive Assistant",
    slug: "kristen-schneider",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie",
    lastName: "Schneider",
    title: "Director of Development",
    slug: "katie-schneider",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark",
    lastName: "Schnellbaecher",
    title: "Chief Operating Officer",
    slug: "mark-schnellbaecher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Schoenfeld",
    title: "Assoc Director-People Engagmnt",
    slug: "rebecca-schoenfeld",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Laura",
    lastName: "Schon",
    title: "Director, Risk Management",
    slug: "laura-schon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Naomi Jessica",
    lastName: "Schrag",
    title: "Vice President for Research Compliance, Training and Policy",
    slug: "naomi-jessica-schrag",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lindsey Michelle",
    lastName: "Schram",
    title: "Associate Director",
    slug: "lindsey-michelle-schram",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Schramm",
    title: "Staff",
    slug: "rebecca-schramm",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isabelle Veerle Suzanne",
    lastName: "Schrauwen",
    title: "Collaborator",
    slug: "isabelle-veerle-suzanne-schrauwen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annapurna",
    lastName: "Schreiber",
    title: "Coordinator",
    slug: "annapurna-schreiber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Koos Arno Jacques",
    lastName: "Schrijen",
    title: "Director, Major Gifts and International Development",
    slug: "koos-arno-jacques-schrijen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noris",
    lastName: "Schrils",
    title: "Information Operator",
    slug: "noris-schrils",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Alix",
    lastName: "Schroder",
    title: "Associate Director, Academic Initiatives",
    slug: "alix-schroder",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth C. F.",
    lastName: "Schroeder",
    title: "Director, Educational Programs",
    slug: "elizabeth-c-f-schroeder",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Abby Noelle",
    lastName: "Schroering",
    title: "Assistant Director, Graduate Students and Program Services",
    slug: "abby-noelle-schroering",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Paul J.",
    lastName: "Schuchert",
    title: "Assoc Vice President-Fin & HR",
    slug: "paul-j-schuchert",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julie Gottlieb",
    lastName: "Schulman",
    title: "Associate Director of Career Advising",
    slug: "julie-gottlieb-schulman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ivy",
    lastName: "Schultz",
    title: "Senior Director of Entrepreneurship, Innovation and Design",
    slug: "ivy-schultz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyle",
    lastName: "Schumacher-Picone",
    title: "Senior Graphic Designer",
    slug: "kyle-schumacher-picone",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Evelyn M.",
    lastName: "Schwalb",
    title: "Executive Director, Office of the President Emeritus",
    slug: "evelyn-m-schwalb",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tracy",
    lastName: "Schwartz",
    title: "Senior Program Director, Wealth Management",
    slug: "tracy-schwartz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ellen",
    lastName: "Schwartz",
    title: "Lead Application Systems Developer",
    slug: "ellen-schwartz",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Esther",
    lastName: "Schwartz",
    title: "Executive Assistant to the Dean",
    slug: "esther-schwartz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Eric",
    lastName: "Schwartz",
    title: "Editorial Director",
    slug: "eric-schwartz",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Renee",
    lastName: "Schwarz",
    title: "Director-Admissions Ops",
    slug: "renee-schwarz",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Robert Joaquin",
    lastName: "Schwarz",
    title: "Assistant Director for the Business Services Center",
    slug: "robert-joaquin-schwarz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Schwarz",
    title: "Production Manager",
    slug: "jessica-schwarz",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nathan",
    lastName: "Schweer",
    title: "Dir, Academic Admin & Finance",
    slug: "nathan-schweer",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Danielle Anne",
    lastName: "Schweiloch",
    title: "Assistant Dean of Career Services and Professional Development",
    slug: "danielle-anne-schweiloch",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Natalie P.",
    lastName: "Schweizer",
    title: "Director of Development",
    slug: "natalie-p-schweizer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Margaret",
    lastName: "Sclafani",
    title: "Videographer, Editor",
    slug: "margaret-sclafani",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Angela",
    lastName: "Sclafani",
    title: "Administrative Coordinator",
    slug: "angela-sclafani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dara",
    lastName: "Scolnick",
    title: "Coordinator, Leave Mgt Admin",
    slug: "dara-scolnick",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Joseph",
    lastName: "Scorcia",
    title: "Senior Category Manager, Construction Sourcing",
    slug: "joseph-scorcia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha A",
    lastName: "Scott",
    title: "Assistant Director",
    slug: "samantha-a-scott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shane S",
    lastName: "Scott",
    title: "Assistant Director, CRM Reporting and Marketing",
    slug: "shane-s-scott",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Stephanie",
    lastName: "Scott",
    title: "Director of Policy and Research Development",
    slug: "stephanie-scott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael Washington",
    lastName: "Scott",
    title: "Financial Coordinator",
    slug: "michael-washington-scott",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leidy J.",
    lastName: "Scott",
    title: "Administrative Coordinator",
    slug: "leidy-j-scott",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adam",
    lastName: "Scott",
    title: "Research Manager",
    slug: "adam-scott",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marcia R",
    lastName: "Scott-Gumbs",
    title: "Senior Clerk",
    slug: "marcia-r-scott-gumbs",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mera Lee A.",
    lastName: "Scovern",
    title: "Manager",
    slug: "mera-lee-a-scovern",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tessie",
    lastName: "Scroggins",
    title: "Assistant Director of Educational Financing for Veteran Benefits",
    slug: "tessie-scroggins",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Julie Jones",
    lastName: "Sculli",
    title: "Assistant Dean for Graduate Degree Programs",
    slug: "julie-jones-sculli",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Benjamin Alexander",
    lastName: "Seagren",
    title: "Coordinator - Student Affairs",
    slug: "benjamin-alexander-seagren",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lisa",
    lastName: "Seales",
    title: "Vice President for Administration",
    slug: "lisa-seales",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mark A.",
    lastName: "Sealey",
    title: "Director of Web and Digital Strategy",
    slug: "mark-a-sealey",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Christina",
    lastName: "Sebastian",
    title: "Assistant Vice President, Marketing Strategy and Enablement",
    slug: "christina-sebastian",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Neria",
    lastName: "Sebastien",
    title: "Director, CUIMC Programs and Services",
    slug: "neria-sebastien",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aidan X.",
    lastName: "Sebesta",
    title: "Assistant Director, Class Giving",
    slug: "aidan-x-sebesta",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Koba",
    lastName: "Sebiskveradze",
    title: "Manager, Catering Sales",
    slug: "koba-sebiskveradze",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David B.",
    lastName: "Secrest",
    title: "Systems Administrator",
    slug: "david-b-secrest",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sacha K.",
    lastName: "Seecharran",
    title: "Senior Associate Director, Alumni Relations",
    slug: "sacha-k-seecharran",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kaylee M",
    lastName: "Seekon",
    title: "Pediatric Diabetes Educator",
    slug: "kaylee-m-seekon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John J",
    lastName: "Seeley",
    title: "Senior Director, Core Res Tech",
    slug: "john-j-seeley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Romeo R",
    lastName: "Seenjan",
    title: "Dev Assoc, Ophthalmology",
    slug: "romeo-r-seenjan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aimee B.",
    lastName: "Seeram",
    title: "Academic Secretary",
    slug: "aimee-b-seeram",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Narayanan",
    lastName: "Seetharaman",
    title: "Technical Director, ERP Applications",
    slug: "narayanan-seetharaman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Meenakshi",
    lastName: "Seetharaman",
    title: "IRB Specialist",
    slug: "meenakshi-seetharaman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather",
    lastName: "Seid",
    title: "Program Manager",
    slug: "heather-seid",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hanna E",
    lastName: "Seifu",
    title: "Director of Academic Administration",
    slug: "hanna-e-seifu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah C",
    lastName: "Seigel",
    title: "Purchasing & Logistics Coord",
    slug: "sarah-c-seigel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amanda A.",
    lastName: "Seitz",
    title: "Associate Director-Human Resources",
    slug: "amanda-a-seitz",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Edun",
    lastName: "Sela",
    title: "Specialization Coordinator",
    slug: "edun-sela",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Seliga",
    title: "Senior Director of Recruitment and Professional Development",
    slug: "susan-seliga",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Greyden",
    lastName: "Seliga",
    title: "Administrative Coordinator, Columbia Alumni Center",
    slug: "greyden-seliga",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bahar Hazal",
    lastName: "Selimbeyoglu",
    title: "Research Center Coordinator",
    slug: "bahar-hazal-selimbeyoglu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Barbara Danielle",
    lastName: "Selman",
    title: "Associate Director of Alumni Relations, Reunion and Operations",
    slug: "barbara-danielle-selman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David M",
    lastName: "Seltzer",
    title: "Executive Director, University Financial Aid",
    slug: "david-m-seltzer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ranisha",
    lastName: "Semley Reyes",
    title: "Administrative Assistant",
    slug: "ranisha-semley-reyes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stanislaw",
    lastName: "Sempruch",
    title: "IT Director",
    slug: "stanislaw-sempruch",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emmy",
    lastName: "Semprun",
    title: "Design Associate",
    slug: "emmy-semprun",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Theresa M.",
    lastName: "Sencen",
    title: "Sr Project Coordinator",
    slug: "theresa-m-sencen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Naomi",
    lastName: "Sender",
    title: "Sr Multi-Ctr Clinic Trials Mgr",
    slug: "naomi-sender",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Manidipa",
    lastName: "Sengupta",
    title: "Financial Coordinator",
    slug: "manidipa-sengupta",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rafael",
    lastName: "Senices",
    title: "Instructional Support Specialist",
    slug: "rafael-senices",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Assewe",
    lastName: "Senyedji-Karmon",
    title: "Manager-Heyman Center",
    slug: "assewe-senyedji-karmon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Won",
    lastName: "Seo",
    title: "Live Support Specialist",
    slug: "won-seo",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yuna Patricia",
    lastName: "Seong",
    title: "Language Program Director",
    slug: "yuna-patricia-seong",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jesse",
    lastName: "Sepulveda",
    title: "Administrative Coordinator",
    slug: "jesse-sepulveda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maria A",
    lastName: "Serafini",
    title: "Project Coordinator II",
    slug: "maria-a-serafini",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia L.",
    lastName: "Seraphin",
    title: "Program Manager",
    slug: "patricia-l-seraphin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alina P",
    lastName: "Sergeeva",
    title: "Associate Research in the Department of Systems Biology",
    slug: "alina-p-sergeeva",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stella",
    lastName: "Serpa",
    title: "Manager, Appointments and Promotions",
    slug: "stella-serpa",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tina",
    lastName: "Serrano",
    title: "Administrative Assistant",
    slug: "tina-serrano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sheila B.",
    lastName: "Serrano",
    title: "Associate Registrar",
    slug: "sheila-b-serrano",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Juan Jose",
    lastName: "Serraty",
    title: "Instructional Support Associate",
    slug: "juan-jose-serraty",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hormazd N",
    lastName: "Sethna",
    title: "Sr Project Portfolio Manager",
    slug: "hormazd-n-sethna",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Magdaly",
    lastName: "Sevilla",
    title: "Administrative Assistant",
    slug: "magdaly-sevilla",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laisa Tatiana",
    lastName: "Sevilla",
    title: "Education and Outreach Administrator",
    slug: "laisa-tatiana-sevilla",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Krystal",
    lastName: "Sewell",
    title: "Assistant Director - AP Payment Operations",
    slug: "krystal-sewell",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emma Lynn",
    lastName: "Sexton",
    title: "Project Director",
    slug: "emma-lynn-sexton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sean",
    lastName: "Seymour",
    title: "Generalist, HR/FA",
    slug: "sean-seymour",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marynet",
    lastName: "Shafik",
    title: "Regulatory Coordinator II",
    slug: "marynet-shafik",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Vikas M",
    lastName: "Shah",
    title: "Director of Technology",
    slug: "vikas-m-shah",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Romil M",
    lastName: "Shah",
    title: "Billing & Coding Manager",
    slug: "romil-m-shah",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ruby",
    lastName: "Shah",
    title: "Administrative Coordinator",
    slug: "ruby-shah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nirvi",
    lastName: "Shah",
    title: "Executive Editor",
    slug: "nirvi-shah",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nemi",
    lastName: "Shah",
    title: "Lead SQL Server Database Administrator",
    slug: "nemi-shah",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shay",
    lastName: "Shaked",
    title: "Coordinator- Dept IT Support",
    slug: "shay-shaked",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tayyaba",
    lastName: "Shakeel",
    title: "Administrative Manager for Scientific Platforms",
    slug: "tayyaba-shakeel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Shamailov",
    title: "IT User Support Specialist",
    slug: "daniel-shamailov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Esfir",
    lastName: "Shamilova",
    title:
      " Operations Manager Dean's Office and Executive Assistant to the Vice Dean",
    slug: "esfir-shamilova",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Afsheen",
    lastName: "Shamsi",
    title: "Staff",
    slug: "afsheen-shamsi",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Robert Douglas",
    lastName: "Shand",
    title: "Contractor",
    slug: "robert-douglas-shand",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Shank",
    title: "Program Manager",
    slug: "danielle-shank",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rebecca",
    lastName: "Shapiro",
    title: "Managing Editor, Columbia Magazine",
    slug: "rebecca-shapiro",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rachel",
    lastName: "Shapiro",
    title: "Assistant Dean, Student Affairs",
    slug: "rachel-shapiro",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hilal",
    lastName: "Sharif",
    title: "Financial Assistant",
    slug: "hilal-sharif",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mahnaaz",
    lastName: "Sharifi",
    title: "Regulatory Start-Up Specialist",
    slug: "mahnaaz-sharifi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sahil",
    lastName: "Sharma",
    title: "Application Systems Developer",
    slug: "sahil-sharma",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mitali",
    lastName: "Sharma",
    title:
      " Executive Assistant to Dr. Carol Mason and Manager of Special Projects",
    slug: "mitali-sharma",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kavita",
    lastName: "Sharma",
    title: "Dean, Center for Career Education",
    slug: "kavita-sharma",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Damion O.",
    lastName: "Sharpe",
    title: "First Cook",
    slug: "damion-o-sharpe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ginta",
    lastName: "Shaurina",
    title: "Salesforce Administrator",
    slug: "ginta-shaurina",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lorenzo A.",
    lastName: "Shaw-Graham",
    title: "Assistant Director-Diversity",
    slug: "lorenzo-a-shaw-graham",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Anna",
    lastName: "Shchupak",
    title: "Assc Director-SPF",
    slug: "anna-shchupak",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Peter",
    lastName: "Shea",
    title: "Media Specialist",
    slug: "peter-shea",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Nicole",
    lastName: "Shea",
    title:
      " Events Marketing Coordinator for Office of Alumni and Development (OAD) Strategic Events",
    slug: "nicole-shea",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christopher D",
    lastName: "Shea",
    title: "Director, Science, and Technology Communications",
    slug: "christopher-d-shea",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Katherine",
    lastName: "Sheeran",
    title: "Assistant Vice President, Finance Administration",
    slug: "katherine-sheeran",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Victoria L.",
    lastName: "Sheffer",
    title: "Admissions Assistant",
    slug: "victoria-l-sheffer",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Angelica J.",
    lastName: "Sheffer",
    title: "Senior Associate Director",
    slug: "angelica-j-sheffer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael T.",
    lastName: "Sheffey",
    title: "IRB Specialist",
    slug: "michael-t-sheffey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sabeen J",
    lastName: "Sheikh",
    title: "Director of TC NEXT",
    slug: "sabeen-j-sheikh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Florina",
    lastName: "Shein",
    title: "Supervisor",
    slug: "florina-shein",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma",
    lastName: "Sheinbaum",
    title: "Administrative Assistant",
    slug: "emma-sheinbaum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christina M",
    lastName: "Shelby",
    title: "Executive Director, Institute of Global Politics",
    slug: "christina-m-shelby",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ryan J",
    lastName: "Shelton",
    title: "Asst Director, Clin Res Ops",
    slug: "ryan-j-shelton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Beverly",
    lastName: "Shelton",
    title: "Training Manager",
    slug: "beverly-shelton",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Amanda",
    lastName: "Shelton",
    title: "Technical Specialist, Events Production",
    slug: "amanda-shelton",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lily",
    lastName: "Shen",
    title: "Assistant Director, Development Research",
    slug: "lily-shen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liat",
    lastName: "Shenhav",
    title: "Research Collaborator",
    slug: "liat-shenhav",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alla",
    lastName: "Shenkerman",
    title: "Lead Application Systems Developer (ETL)",
    slug: "alla-shenkerman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Vladislav",
    lastName: "Shepelenko",
    title: "Student Acad Support Worker",
    slug: "vladislav-shepelenko",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kara",
    lastName: "Sheridan",
    title: "Program Manager/Field Coordinator",
    slug: "kara-sheridan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda J.",
    lastName: "Sheridan-Dasilva",
    title: "Manager of Tenure Reviews",
    slug: "linda-j-sheridan-dasilva",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kipa Lhamu",
    lastName: "Sherpa",
    title: "IRB Specialist",
    slug: "kipa-lhamu-sherpa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alison P",
    lastName: "Sherwin",
    title: "Director, Academic Affairs and the J.S.D. Program",
    slug: "alison-p-sherwin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Greysi M.",
    lastName: "Sherwood",
    title: "Program Manager",
    slug: "greysi-m-sherwood",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ragini",
    lastName: "Sheth",
    title: "Assistant Compliance Officer",
    slug: "ragini-sheth",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Shuk-Yee S.",
    lastName: "Sheung",
    title: "Senior Associate Director",
    slug: "shuk-yee-s-sheung",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sabina",
    lastName: "Shevchenko",
    title: "Accountant",
    slug: "sabina-shevchenko",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yakov Dubno",
    lastName: "Shevin",
    title: "Peer Health Navigator",
    slug: "yakov-dubno-shevin",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Wenyu",
    lastName: "Shi",
    title: "Sr. Applications Systems Developer",
    slug: "wenyu-shi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ting",
    lastName: "Shi",
    title: "AVP Deputy Controller",
    slug: "ting-shi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Woojin",
    lastName: "Shim",
    title: "Tech Mgr. Sim Ctr & IT Tech",
    slug: "woojin-shim",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cari Elizabeth",
    lastName: "Shimkus",
    title: "Director of Enrollment ad Data Strategy",
    slug: "cari-elizabeth-shimkus",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Myungjin",
    lastName: "Shin",
    title: "Regulatory Coordinator",
    slug: "myungjin-shin",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Meredith",
    lastName: "Shin",
    title: "Assistant Director of Finance",
    slug: "meredith-shin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Daniel",
    lastName: "Shin",
    title: "Operations Manager",
    slug: "daniel-shin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anne K.",
    lastName: "Shinn",
    title: "Senior Grants Officer",
    slug: "anne-k-shinn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Pamela S",
    lastName: "Shively",
    title: "Associate Manager, Safety Training Programs",
    slug: "pamela-s-shively",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dwayne Anthony",
    lastName: "Shivnarain",
    title: "Associate General Counsel",
    slug: "dwayne-anthony-shivnarain",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jill C.",
    lastName: "Shomer",
    title:
      " Senior Associate Director for Editorial Strategy and Content; Deputy Editor of Columbia College Today",
    slug: "jill-c-shomer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Fusako",
    lastName: "Shore",
    title: "KCJS Assistant Director",
    slug: "fusako-shore",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maxfield Van Alstyne",
    lastName: "Shortte",
    title: "Manager, High-Performance Computing",
    slug: "maxfield-van-alstyne-shortte",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Raquel",
    lastName: "Shrager",
    title: "Director, Research Admin",
    slug: "raquel-shrager",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Valentina",
    lastName: "Shrayman",
    title: "Payroll Manager",
    slug: "valentina-shrayman",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rabindra",
    lastName: "Shreshta",
    title: "Consultant",
    slug: "rabindra-shreshta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anusha",
    lastName: "Shrivastava",
    title: "Associate Dean, Career Services",
    slug: "anusha-shrivastava",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Thomas H.",
    lastName: "Shriver",
    title: "Data Manager",
    slug: "thomas-h-shriver",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Svetlana",
    lastName: "Shtytser",
    title: "Lead App Systems Develop",
    slug: "svetlana-shtytser",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Shue",
    title: "Assistant Director, Stewardship and Donor Impact Reporting",
    slug: "emily-shue",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gwendolyn",
    lastName: "Shufro",
    title: "Senior Director of Tamer Executive Education",
    slug: "gwendolyn-shufro",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "David S.",
    lastName: "Shulman",
    title: "Senior Salesforce Administrator",
    slug: "david-s-shulman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anne V.",
    lastName: "Shutkin",
    title: "Chief of Staff to the Provost",
    slug: "anne-v-shutkin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Brian",
    lastName: "Siaw",
    title: "Project Coordinator-PRMC/DSMC",
    slug: "brian-siaw",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mary E",
    lastName: "Siddens",
    title: "Administrative Assistant",
    slug: "mary-e-siddens",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hanna Hasson",
    lastName: "Siddiqui",
    title: "Assistant Director",
    slug: "hanna-hasson-siddiqui",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madison",
    lastName: "Siebenhoven",
    title: "Office Manager",
    slug: "madison-siebenhoven",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott A.",
    lastName: "Siegel",
    title: "Senior Director, Student Life and Engagement",
    slug: "scott-a-siegel",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rachel",
    lastName: "Siegel",
    title: "Research Manager",
    slug: "rachel-siegel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hugh D",
    lastName: "Siegel",
    title: "Dir, Comm & Content Strategy",
    slug: "hugh-d-siegel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lawrence J.",
    lastName: "Siems",
    title: "Chief of Staff, Knight First Amendment Institute",
    slug: "lawrence-j-siems",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mariela",
    lastName: "Sierra",
    title: "Senior Associate Director, University Programs and Events",
    slug: "mariela-sierra",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessica",
    lastName: "Sievers",
    title: "Termp",
    slug: "jessica-sievers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven",
    lastName: "Siew",
    title: "Manager, IT Ops & Support",
    slug: "steven-siew",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Justin",
    lastName: "Siguachi Sr",
    title: "Instrument Manager (MUSC)",
    slug: "justin-siguachi-sr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Briana Marie",
    lastName: "Silck",
    title: "Service Provider",
    slug: "briana-marie-silck",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aleyna Anil",
    lastName: "Silcott",
    title: "Administrative Lab Manager",
    slug: "aleyna-anil-silcott",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Silliman",
    title: "Associate Director, Project Management",
    slug: "sarah-silliman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephen",
    lastName: "Silva",
    title: "Assistant Director, Registration and Technology Operations",
    slug: "stephen-silva",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mabel",
    lastName: "Silva",
    title: "Student Support Specialist",
    slug: "mabel-silva",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Filipe",
    lastName: "Silva",
    title: "Executive Director, Custom Programs",
    slug: "filipe-silva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie A",
    lastName: "Silver",
    title: "Project Coordinator II",
    slug: "stephanie-a-silver",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David C.",
    lastName: "Silver",
    title:
      " Director of Development, Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "david-c-silver",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marley",
    lastName: "Silverio",
    title: "CMA",
    slug: "marley-silverio",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marbella C",
    lastName: "Silverio",
    title: "Research Project Officer",
    slug: "marbella-c-silverio",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Remi",
    lastName: "Silverman",
    title: "Associate General Counsel",
    slug: "remi-silverman",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jo Ann",
    lastName: "Silverstein",
    title: "IRB Member",
    slug: "jo-ann-silverstein",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ilana",
    lastName: "Silverstein",
    title: "Asst Director, Research Admin",
    slug: "ilana-silverstein",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lea Whidbey",
    lastName: "Silvert",
    title: "Service Provider",
    slug: "lea-whidbey-silvert",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jeanette E.",
    lastName: "Silverthorne",
    title: "Associate Director of Finance and Exhibitions",
    slug: "jeanette-e-silverthorne",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Simone",
    lastName: "Simmons",
    title: "Director-Business Operations",
    slug: "simone-simmons",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jamaica J.",
    lastName: "Simmons",
    title:
      " HHMI Tech in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "jamaica-j-simmons",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julia Brown",
    lastName: "Simmons",
    title: "Subsidiary Rights Assistant",
    slug: "julia-brown-simmons",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evita L.",
    lastName: "Simmons",
    title: "Administrative Aide",
    slug: "evita-l-simmons",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Devon Perry",
    lastName: "Simmons",
    title:
      " Associate Director for the Paralegal Pathways Initiative and Center Programs",
    slug: "devon-perry-simmons",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Angela Mai",
    lastName: "Simmons",
    title: "Assistant Director, Student Support",
    slug: "angela-mai-simmons",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lisa",
    lastName: "Simon",
    title: "Admn Asst for Student Life & Field Ed",
    slug: "lisa-simon",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Emily Elizabeth",
    lastName: "Simon",
    title: "Assistant Editor",
    slug: "emily-elizabeth-simon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lara H",
    lastName: "Simone",
    title: "Senior Associate Director of Administration and Planning",
    slug: "lara-h-simone",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emiliana",
    lastName: "Simoni",
    title: "Senior Administrative Assistant",
    slug: "emiliana-simoni",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kiara",
    lastName: "Simonson",
    title: "Receptionist",
    slug: "kiara-simonson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kedeesha",
    lastName: "Simpson",
    title: "Online Program Administrator",
    slug: "kedeesha-simpson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Frances A.",
    lastName: "Simpson",
    title: "Project Coordinator",
    slug: "frances-a-simpson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Simpson",
    title: "Administrative Assistant",
    slug: "david-simpson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mishael A.",
    lastName: "Sims",
    title: "Technical Support Specialist",
    slug: "mishael-a-sims",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Thomas",
    lastName: "Sinclair",
    title: "High School Program",
    slug: "thomas-sinclair",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Carolyn Sachs",
    lastName: "Singer",
    title: "Associate Director, School and Child Care Search Service",
    slug: "carolyn-sachs-singer",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Calder K.",
    lastName: "Singer",
    title: "Production Manager",
    slug: "calder-k-singer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vidyawattie",
    lastName: "Singh",
    title: "Assistant Director-Finance and Administration",
    slug: "vidyawattie-singh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sulekha",
    lastName: "Singh",
    title: "Assistant Director, Audit and Review",
    slug: "sulekha-singh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sarita",
    lastName: "Singh",
    title: "Peer Navigator",
    slug: "sarita-singh",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Simran",
    lastName: "Singh",
    title: "Senior Assistant Director, Financial Aid",
    slug: "simran-singh",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Satwinder",
    lastName: "Singh",
    title: "Senior Director of Enterprise Architecture",
    slug: "satwinder-singh",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Surujdeen",
    lastName: "Singh",
    title: "Billing Compliance Coordinator",
    slug: "surujdeen-singh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pardeep",
    lastName: "Singh",
    title: "Assistant Director, Financial Aid",
    slug: "pardeep-singh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mandeep K.",
    lastName: "Singh",
    title: "Assistant/Director of Academic Affairs",
    slug: "mandeep-k-singh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lakhbir",
    lastName: "Singh",
    title: "Associate Director of Financial Aid",
    slug: "lakhbir-singh",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Hurneet",
    lastName: "Singh",
    title: "Director of IT Info Systems",
    slug: "hurneet-singh",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shahnaz",
    lastName: "Singh-Kandah",
    title: "Oncology Core NP III",
    slug: "shahnaz-singh-kandah",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "James",
    lastName: "Singletary",
    title: "Director of Practicum Learning",
    slug: "james-singletary",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jason Chadwick",
    lastName: "Singleton",
    title: "Division Director",
    slug: "jason-chadwick-singleton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole Marie",
    lastName: "Siniscalchi",
    title: "Director of Operations, Admissions",
    slug: "nicole-marie-siniscalchi",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Courtney M.",
    lastName: "Sinn",
    title: "Assistant Director, HR/FA",
    slug: "courtney-m-sinn",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Hana",
    lastName: "Sinno",
    title: "Associate Director in Executive Education",
    slug: "hana-sinno",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nancy",
    lastName: "Siporin",
    title: "Executive Coordinator",
    slug: "nancy-siporin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Quintin Ellis",
    lastName: "Sipp",
    title: "Assistant Director of Financial Aid",
    slug: "quintin-ellis-sipp",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Joseph William",
    lastName: "Sista",
    title: "Senior Lab Tech. (R-7)",
    slug: "joseph-william-sista",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zeid",
    lastName: "Sitnica",
    title: "Associate Provost For Academic Appointments",
    slug: "zeid-sitnica",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Charnee",
    lastName: "Skeete-Breen",
    title: "Assistant Director, OCIP Claims and Safety",
    slug: "charnee-skeete-breen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Agnes",
    lastName: "Skiba",
    title: "Assoc Dean, Int Controls&Compl",
    slug: "agnes-skiba",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily Katherine",
    lastName: "Skilton",
    title: "Donor Relations Assistant",
    slug: "emily-katherine-skilton",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anne M.",
    lastName: "Skrobala Fotino",
    title: "Administrator",
    slug: "anne-m-skrobala-fotino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Samantha A.",
    lastName: "Slater",
    title: "Executive Director of Media Relations",
    slug: "samantha-a-slater",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Doug",
    lastName: "Slater",
    title: "Communication Director",
    slug: "doug-slater",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Debi",
    lastName: "Slatkin",
    title: "Interim CPRE Business Director",
    slug: "debi-slatkin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rory K",
    lastName: "Slattery",
    title: "Assistant Director, Parent Fundraising",
    slug: "rory-k-slattery",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ekaterina",
    lastName: "Slavashevich",
    title: "Cluster Administrator",
    slug: "ekaterina-slavashevich",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mike L.",
    lastName: "Slaven",
    title: "Director of Enterprise Applications",
    slug: "mike-l-slaven",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Malgorzata",
    lastName: "Slaweta",
    title: "Wait Staff",
    slug: "malgorzata-slaweta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bernard",
    lastName: "Sledge Jr",
    title: "Porter",
    slug: "bernard-sledge-jr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard D.",
    lastName: "Sloan",
    title: "Administrator",
    slug: "richard-d-sloan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Barbara J.",
    lastName: "Sloane",
    title: "Senior Project Lead",
    slug: "barbara-j-sloane",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Charlotte",
    lastName: "Slota",
    title: "Senior Associate Director, Donor and Prospect Relations",
    slug: "charlotte-slota",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hannah R.",
    lastName: "Slow",
    title: "Director, Communications",
    slug: "hannah-r-slow",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Richard",
    lastName: "Slusarczyk",
    title: "Senior Associate Dean of Academic and Student Affairs",
    slug: "richard-slusarczyk",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steven",
    lastName: "Slywka",
    title: "Director, Investments",
    slug: "steven-slywka",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sabrina",
    lastName: "Small",
    title: "Director of Human Resources",
    slug: "sabrina-small",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Len",
    lastName: "Small",
    title: "Director-Art",
    slug: "len-small",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer J.",
    lastName: "Small",
    title: "Dir of Development, Pediatrics",
    slug: "jennifer-j-small",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Theodore F.",
    lastName: "Smart",
    title: "Sr. Scientific Technical Writer and Editor",
    slug: "theodore-f-smart",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Felicia D.",
    lastName: "Smart-Williams",
    title: "Department Secretary",
    slug: "felicia-d-smart-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John W",
    lastName: "Smerdon",
    title: "Sr Dir Lab Research Ops & Cap",
    slug: "john-w-smerdon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melissa K.",
    lastName: "Smey",
    title: "Associate Dean and Executive Director",
    slug: "melissa-k-smey",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yvette Y.",
    lastName: "Smith",
    title: "Executive Assistant",
    slug: "yvette-y-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thana",
    lastName: "Smith",
    title: "SYEP Clerical Aide",
    slug: "thana-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Troy",
    lastName: "Smith",
    title: "Director of Strategic Planning",
    slug: "troy-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tasha I",
    lastName: "Smith",
    title: "Sr IRB Specialist - Liaison",
    slug: "tasha-i-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Savannah J.",
    lastName: "Smith",
    title: "Administrative Lab Manager",
    slug: "savannah-j-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shannon",
    lastName: "Smith",
    title: "Staff",
    slug: "shannon-smith",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rebecca A",
    lastName: "Smith",
    title: "Health Information Specialist",
    slug: "rebecca-a-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Roberta",
    lastName: "Smith",
    title: "Senior Associate Director, Donor Relations (SIPA)",
    slug: "roberta-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rabiyya Q",
    lastName: "Smith",
    title: "Associate Director, Academic Enrichment",
    slug: "rabiyya-q-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Patrick Brian",
    lastName: "Smith",
    title: "Executive Director of Operations, Student Services",
    slug: "patrick-brian-smith",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Peter",
    lastName: "Smith",
    title: "Dean Emeritus of the School of the Arts",
    slug: "peter-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael A.",
    lastName: "Smith",
    title: "IT Systems Administrator, Civil Eng",
    slug: "michael-a-smith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maura",
    lastName: "Smith",
    title: "Staff",
    slug: "maura-smith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lorraine M.",
    lastName: "Smith",
    title: "Executive Director for Human Resources and Academic Affairs",
    slug: "lorraine-m-smith",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Karyn",
    lastName: "Smith",
    title: "Consultant",
    slug: "karyn-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyra",
    lastName: "Smith",
    title: "Executive Assistant, Alumni Relations",
    slug: "kyra-smith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Karmen",
    lastName: "Smith",
    title: "Staff",
    slug: "karmen-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kevin J.",
    lastName: "Smith",
    title: "Assistant Dean-Admissions and Financial Aid",
    slug: "kevin-j-smith",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Kristin Catherine",
    lastName: "Smith",
    title: "Staff Developer",
    slug: "kristin-catherine-smith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer",
    lastName: "Smith",
    title: "Dir for Strategic Projects",
    slug: "jennifer-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeniya",
    lastName: "Smith",
    title: "CMA",
    slug: "jeniya-smith",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gwyneth Anne",
    lastName: "Smith",
    title: "Sr. Associate Director",
    slug: "gwyneth-anne-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gilbert A.",
    lastName: "Smith",
    title: "Administrative Director",
    slug: "gilbert-a-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Smith",
    title: "Project Deputy Director",
    slug: "emily-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Da Shante",
    lastName: "Smith",
    title: "Assoc Director-Student Srvs",
    slug: "da-shante-smith",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Dwayne David-Daniel",
    lastName: "Smith",
    title: "Systems Coordinator",
    slug: "dwayne-david-daniel-smith",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Crystal",
    lastName: "Smith",
    title: "Senior Student Service Rep",
    slug: "crystal-smith",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Bari Y",
    lastName: "Smith",
    title: "Administrative Coordinator",
    slug: "bari-y-smith",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brandon Michael",
    lastName: "Smith",
    title: "Director of Financial Aid",
    slug: "brandon-michael-smith",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Brian C",
    lastName: "Smith",
    title: "Editor",
    slug: "brian-c-smith",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anderson P",
    lastName: "Smith",
    title: "Assistant Director for Research Compliance Education",
    slug: "anderson-p-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "April N",
    lastName: "Smith",
    title: "Senior Associate Director, Academic and Student Success",
    slug: "april-n-smith",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Allashia Katrina",
    lastName: "Smith-Harris",
    title: "Director of the ACT Institute",
    slug: "allashia-katrina-smith-harris",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Katherine Jane",
    lastName: "Smith-Siegel",
    title: "Associate Director, Development Programs and Communications",
    slug: "katherine-jane-smith-siegel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Erica",
    lastName: "Smock",
    title: "Dean for Public Interest/Public Service Law and Careers",
    slug: "erica-smock",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicole",
    lastName: "Smoot",
    title: "Manager, Tuition Programs",
    slug: "nicole-smoot",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charlene A.",
    lastName: "Smullyan",
    title: "Director of Special Events, Alumni Relations",
    slug: "charlene-a-smullyan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "David Scott",
    lastName: "Smyth Jr",
    title: "Sr. Application Systems Developer",
    slug: "david-scott-smyth-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Casey",
    lastName: "Snepar",
    title: "Assistant Director, Online and Digital Programs",
    slug: "casey-snepar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Clare C",
    lastName: "Sng",
    title: "Associate Director",
    slug: "clare-c-sng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madeleine G",
    lastName: "Snider",
    title: "Data Manager",
    slug: "madeleine-g-snider",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robin",
    lastName: "Snow",
    title: "Project Coordinator",
    slug: "robin-snow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Spencer T",
    lastName: "Snyder",
    title: "Video Content Creator",
    slug: "spencer-t-snyder",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Meghan",
    lastName: "Snyder",
    title: "Director, Research Strategy and Policy",
    slug: "meghan-snyder",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kim",
    lastName: "Snyder",
    title: "Development & Industry Liaison",
    slug: "kim-snyder",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma",
    lastName: "Snyder",
    title: "Associate Director, Reunion Class Giving",
    slug: "emma-snyder",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brooke S.",
    lastName: "Snyder",
    title: "Grants Finance Manager",
    slug: "brooke-s-snyder",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sharon",
    lastName: "Sobel",
    title: "Asst Director,Alumni Relations",
    slug: "sharon-sobel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laura",
    lastName: "Sobel",
    title: "Associate Dean, Development",
    slug: "laura-sobel",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melanie Jane",
    lastName: "Soberal",
    title: "Title IX Investigator",
    slug: "melanie-jane-soberal",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jennifer M",
    lastName: "Sobolewski",
    title: "Development Assistant, Columbia Climate School",
    slug: "jennifer-m-sobolewski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zenalenia A",
    lastName: "Sockwell",
    title: "Senior Associate Director",
    slug: "zenalenia-a-sockwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander",
    lastName: "Soden",
    title: "Catering Delivery",
    slug: "alexander-soden",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shivangi",
    lastName: "Sogani",
    title: "Case Manager",
    slug: "shivangi-sogani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dana Lindsay",
    lastName: "Sokolov",
    title: "Assistant Production Manager - Shapiro",
    slug: "dana-lindsay-sokolov",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julius R.",
    lastName: "Solatorio",
    title: "Research Administrator I",
    slug: "julius-r-solatorio",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jennifer",
    lastName: "Soler",
    title: "Associate Director, International Student Services",
    slug: "jennifer-soler",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rebecca D",
    lastName: "Solinsky",
    title: "Senior Director, Development",
    slug: "rebecca-d-solinsky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janeth",
    lastName: "Solis",
    title: "Senior Generalist, HR/FA",
    slug: "janeth-solis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Danielle A.",
    lastName: "Solomon",
    title: "Senior Data Coordinator",
    slug: "danielle-a-solomon",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Carolann",
    lastName: "Solomon",
    title: "Administrative Assistant",
    slug: "carolann-solomon",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meriam M.",
    lastName: "Soltan",
    title: "Editor, Graduate School of Architecture, Planning and Preservation",
    slug: "meriam-m-soltan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Izabela",
    lastName: "Soltys",
    title: "Contract Negotiations Officer",
    slug: "izabela-soltys",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Targbe",
    lastName: "Somah Jr",
    title: "Finance Manager",
    slug: "targbe-somah-jr",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mayurapriyan",
    lastName: "Somalinga",
    title: "Student Collaborator",
    slug: "mayurapriyan-somalinga",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Leah Shalini",
    lastName: "Soman",
    title: "Director of Financial Aid Administration",
    slug: "leah-shalini-soman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sonya E.",
    lastName: "Somerville",
    title: "Head of School",
    slug: "sonya-e-somerville",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Robert William",
    lastName: "Sommo Jr",
    title: "Assoc Dean, Enrollment Mgmt",
    slug: "robert-william-sommo-jr",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Minwoo",
    lastName: "Son",
    title: "Senior Grants Manager",
    slug: "minwoo-son",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Priyanka",
    lastName: "Soneja",
    title: "Lead Application Systems Developer",
    slug: "priyanka-soneja",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shiyu",
    lastName: "Song",
    title: "Senior Instructional Designer",
    slug: "shiyu-song",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jeehyun",
    lastName: "Song",
    title: "Financial Coordinator",
    slug: "jeehyun-song",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer R.",
    lastName: "Sonntag",
    title: "Administrative Assistant",
    slug: "jennifer-r-sonntag",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeannette",
    lastName: "Soriano",
    title: "Human Resources & Academic Affairs Manager",
    slug: "jeannette-soriano",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sonia",
    lastName: "Sorrentini",
    title: "Financial Coordinator",
    slug: "sonia-sorrentini",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexander",
    lastName: "Sosa",
    title: "Senior Administrative Coord",
    slug: "alexander-sosa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Henry",
    lastName: "Sosa Jr",
    title: "Service Management Office Director",
    slug: "henry-sosa-jr",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jamie",
    lastName: "Sosnow",
    title: "Director",
    slug: "jamie-sosnow",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Raquel Y",
    lastName: "Sotelo",
    title: "Mgr,Grants&Fin&CCCEH Dir,Ops",
    slug: "raquel-y-sotelo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas",
    lastName: "Sotiriadis",
    title: "Senior System Administrator",
    slug: "nicholas-sotiriadis",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Tamar",
    lastName: "Sotnicov",
    title: "Administrative Coordinator",
    slug: "tamar-sotnicov",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Paola Alexandra",
    lastName: "Soto",
    title: "Front of House Supervisor",
    slug: "paola-alexandra-soto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Johanny",
    lastName: "Soto",
    title: "Ins Verf Ref Auth Spc I",
    slug: "johanny-soto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Juan A",
    lastName: "Soto",
    title: "Manager of Building Services & Operations",
    slug: "juan-a-soto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jenilee",
    lastName: "Soto",
    title: "Sr IRB Specialist",
    slug: "jenilee-soto",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Delmy",
    lastName: "Soto",
    title: "Authorization and Referrals Specialist II",
    slug: "delmy-soto",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Avery Jordan",
    lastName: "Souders",
    title: "Coordinator-Admissions/Fin Aid",
    slug: "avery-jordan-souders",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Davey Santiago",
    lastName: "Souffront",
    title: "Manager of Enrollment Services and Operations",
    slug: "davey-santiago-souffront",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jessica C.",
    lastName: "Soursourian",
    title: "Prog Dir,StudRes/Glbl&PopHlth",
    slug: "jessica-c-soursourian",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kimberly Azevedo",
    lastName: "Sousa",
    title: "Executive Assistant",
    slug: "kimberly-azevedo-sousa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Denise",
    lastName: "Southwood",
    title: "Director of Finance and Operations for Columbia Entrepreneurship",
    slug: "denise-southwood",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aliou David",
    lastName: "Sow",
    title: "Audiovisual Specialist",
    slug: "aliou-david-sow",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephanie",
    lastName: "Sozomenu",
    title: "Administrative Director",
    slug: "stephanie-sozomenu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dan G.",
    lastName: "Spacher",
    title: "Associate Director",
    slug: "dan-g-spacher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandy Renee",
    lastName: "Spady",
    title: "Director of Finance and Administration",
    slug: "sandy-renee-spady",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Emily C.",
    lastName: "Spangler",
    title: "Senior Acquisitions Editor",
    slug: "emily-c-spangler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rita M.",
    lastName: "Spann",
    title: "Oiler",
    slug: "rita-m-spann",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emma Dietrich",
    lastName: "Spector",
    title: "Senior Program Manager, Entrepreneurship",
    slug: "emma-dietrich-spector",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ali K",
    lastName: "Speede",
    title: "Senior Admissions Counselor",
    slug: "ali-k-speede",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Marion",
    lastName: "Speights",
    title: "Secretary",
    slug: "marion-speights",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Segovia",
    lastName: "Spelbrink",
    title: "Assistant Dean, Principal Gifts",
    slug: "segovia-spelbrink",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Louise",
    lastName: "Spence",
    title: "Program Manager",
    slug: "louise-spence",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelley-Ann M.",
    lastName: "Spencer",
    title: "Director, Alumni Relations",
    slug: "kelley-ann-m-spencer",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "James H.",
    lastName: "Spencer",
    title: "Logistics Coordinator",
    slug: "james-h-spencer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Corey B.",
    lastName: "Spencer",
    title: "Administrative Assistant",
    slug: "corey-b-spencer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren Elizabeth",
    lastName: "Sperandio Phelps",
    title: "Director, GSAS Writing Studio",
    slug: "lauren-elizabeth-sperandio-phelps",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jonathan",
    lastName: "Sperling",
    title: "Writer/Editor",
    slug: "jonathan-sperling",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jason Adam",
    lastName: "Spiegel",
    title: "Team Lead and Senior Software Developer",
    slug: "jason-adam-spiegel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Frank A.",
    lastName: "Spigner",
    title: "A/V Network & Audio Production Manager",
    slug: "frank-a-spigner",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ellen",
    lastName: "Spilker",
    title: "Executive Director",
    slug: "ellen-spilker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tara",
    lastName: "Spinelli",
    title: "Associate Director, Digital Communications",
    slug: "tara-spinelli",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Anna",
    lastName: "Spinner",
    title: "Executive Director, Communications",
    slug: "anna-spinner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jeffrey",
    lastName: "Spiro",
    title: "Director, Application Services",
    slug: "jeffrey-spiro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Diane M.",
    lastName: "Spizzirro",
    title: "Executive Director, Career Design Lab",
    slug: "diane-m-spizzirro",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Melissa M.",
    lastName: "Spooner",
    title: "Senior Associate Director",
    slug: "melissa-m-spooner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Spraragen",
    title: "Diagnostic Imaging Specialist",
    slug: "lisa-spraragen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica",
    lastName: "Spreen",
    title: "Manager-Audio Visual",
    slug: "jessica-spreen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sierra M",
    lastName: "Spriggs",
    title: "Live Support Specialist",
    slug: "sierra-m-spriggs",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Chanda",
    lastName: "Springer",
    title: "Office Assistant",
    slug: "chanda-springer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dante",
    lastName: "Sprott",
    title: "Associate Manager, Human Resources",
    slug: "dante-sprott",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Albert J.",
    lastName: "Spuler",
    title: "Associate Dean for Planning and Information Systems",
    slug: "albert-j-spuler",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Rebecca M.",
    lastName: "Spurr",
    title: "Sr Admin, Res Education Ops",
    slug: "rebecca-m-spurr",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sharon",
    lastName: "Sputz",
    title: "Associate Vice President, Research Initiatives/Development",
    slug: "sharon-sputz",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tiffany M.",
    lastName: "Squires",
    title: "Procurements Coordinator",
    slug: "tiffany-m-squires",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seetha V",
    lastName: "Srinivasan",
    title: "Research Administrator",
    slug: "seetha-v-srinivasan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Uranise Moanna A.",
    lastName: "St Clair",
    title: "Division Administrator",
    slug: "uranise-moanna-a-st-clair",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shanell L",
    lastName: "St Clair",
    title: "Call Center Manager",
    slug: "shanell-l-st-clair",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joan",
    lastName: "St. John",
    title: "HR Onboarding / Ops Manager",
    slug: "joan-st-john",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jennifer L",
    lastName: "Stancek",
    title: "Assistant Director Academic Appointments",
    slug: "jennifer-l-stancek",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Stephanie",
    lastName: "Stanford",
    title: "IRB Specialist",
    slug: "stephanie-stanford",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael J.",
    lastName: "Stanish",
    title: "Executive Director of Information Technology",
    slug: "michael-j-stanish",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Natasha Z.",
    lastName: "Stanislas",
    title: "Graduate Admissions Recruitment and Communications Officer",
    slug: "natasha-z-stanislas",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Edward",
    lastName: "Stanley",
    title: "Senior Manager, Research Compliance Applications",
    slug: "edward-stanley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Latrisha T.",
    lastName: "Staples",
    title: "Executive Assistant",
    slug: "latrisha-t-staples",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Trudy",
    lastName: "Stapleton-Truglia",
    title: "Manager, Financial Aid Client Services",
    slug: "trudy-stapleton-truglia",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nicole",
    lastName: "Statuti",
    title: "Director, Development & Alumni Relations Marketing",
    slug: "nicole-statuti",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly J.",
    lastName: "Steele",
    title: "Executive Director, Information Technology & Strategic Analytics",
    slug: "kimberly-j-steele",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jack",
    lastName: "Steele",
    title:
      " Sr. Lab-to-Market (L2M ) Program Associate & Interim Assistant Director, Carbontech Development Initiative",
    slug: "jack-steele",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph",
    lastName: "Stegemerten",
    title: "Design Lead",
    slug: "joseph-stegemerten",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric Glenn",
    lastName: "Steinhardt",
    title: "Director, Information Tech",
    slug: "eric-glenn-steinhardt",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Glen M.",
    lastName: "Steinmacher",
    title: "Assistant Director for Digital Media Production",
    slug: "glen-m-steinmacher",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Melik",
    lastName: "Stepanyan",
    title: "Sr. Apps. Sys. Developer",
    slug: "melik-stepanyan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Natalie Lucille",
    lastName: "Stephenson",
    title: "Manager-Ops CFJ",
    slug: "natalie-lucille-stephenson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gina",
    lastName: "Steriti",
    title: "Administrative Assistant",
    slug: "gina-steriti",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chris James",
    lastName: "Stern",
    title: "Hollingworth Preschool Office Support",
    slug: "chris-james-stern",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara Carlson",
    lastName: "Sternglass",
    title: "Departmental Administrator",
    slug: "sara-carlson-sternglass",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniel",
    lastName: "Sternoff",
    title: "Consultant",
    slug: "daniel-sternoff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephen H.",
    lastName: "Sterns",
    title: "Managing Editor for Reference and Electronic Publishing",
    slug: "stephen-h-sterns",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Natalie Christine",
    lastName: "Stevens",
    title: "Regulatory Compliance Specialist",
    slug: "natalie-christine-stevens",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Julie L.",
    lastName: "Stevens",
    title: "Director-Acad Finance/Admin",
    slug: "julie-l-stevens",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle R.",
    lastName: "Stevenson",
    title: "Coordinator",
    slug: "michelle-r-stevenson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "D. Anne",
    lastName: "Stewart",
    title: "Department Administrator / CFO",
    slug: "d-anne-stewart",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Diamond",
    lastName: "Stewart",
    title: "Administrative Assistant",
    slug: "diamond-stewart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jared",
    lastName: "Stickley",
    title: "Director, Academic Administration and Finance",
    slug: "jared-stickley",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ted A.",
    lastName: "Stiffel",
    title:
      " Director of Communications and Special Assistant to the Dean of A&S",
    slug: "ted-a-stiffel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John R.",
    lastName: "Stobo II",
    title: "Administrative Assistant",
    slug: "john-r-stobo-ii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kira",
    lastName: "Stockdale",
    title: "Senior Director, Events Management",
    slug: "kira-stockdale",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brooke Reann",
    lastName: "Stockwell",
    title: "Assistant Director, Student Wellness",
    slug: "brooke-reann-stockwell",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jacqui Eve",
    lastName: "Stolzer",
    title: "Senior Professional Development Coach",
    slug: "jacqui-eve-stolzer",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Dara",
    lastName: "Stoney",
    title: "Dir Strategic Sys & Knwl Mgmt",
    slug: "dara-stoney",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Susan",
    lastName: "Storms",
    title: "Director of Alumni Affairs",
    slug: "susan-storms",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Madelyn",
    lastName: "Storms",
    title: "Director, Strategic Projects",
    slug: "madelyn-storms",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Adrienne",
    lastName: "Stortz",
    title: "Director of Programs and Finance",
    slug: "adrienne-stortz",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sophia Marin",
    lastName: "Stoute",
    title: "PT Interim RA: S-BYE Lab",
    slug: "sophia-marin-stoute",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Megann Kerrri",
    lastName: "Strajcher",
    title: "Director, Award Management",
    slug: "megann-kerrri-strajcher",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Steven",
    lastName: "Strang",
    title: "Data Coordinator",
    slug: "steven-strang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephen J",
    lastName: "Strauss",
    title: "Director for Financial Rptg",
    slug: "stephen-j-strauss",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David M.",
    lastName: "Strauss",
    title: "Creative Director",
    slug: "david-m-strauss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Darlene",
    lastName: "Straussman",
    title: "Administrative Manager",
    slug: "darlene-straussman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Naum",
    lastName: "Streltsov",
    title: "Associate Director, Student Applications Systems Architecture",
    slug: "naum-streltsov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shannon",
    lastName: "Strohmeyer",
    title: "IRB  Specialist",
    slug: "shannon-strohmeyer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Norman L",
    lastName: "Strong",
    title: "Associate Director, Payments and Deposits",
    slug: "norman-l-strong",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth",
    lastName: "Strong",
    title:
      " Project Coordinator at the Interdisciplinary Center for Innovative Theory and Empirics",
    slug: "elizabeth-strong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Najoice",
    lastName: "Strong George",
    title: "Assistant Director of Finance and Operations",
    slug: "najoice-strong-george",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Chyna",
    lastName: "Stroud",
    title: "Junior Salesforce Administrator",
    slug: "chyna-stroud",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Katherine M.S.",
    lastName: "Strzalkowski",
    title: "Assistant Dean of Advising",
    slug: "katherine-m-s-strzalkowski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Silvia",
    lastName: "Stuard",
    title: "Recess Enrichment Facilitator in The School",
    slug: "silvia-stuard",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Vestena M.",
    lastName: "Stuckey-Wilkin",
    title: "Information Processing Assistant",
    slug: "vestena-m-stuckey-wilkin",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cartilia",
    lastName: "Stukes",
    title: "Talent Acq/Engagement Manager",
    slug: "cartilia-stukes",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael",
    lastName: "Stutts",
    title: "Assistant Director, Marketing Optimization and Integration",
    slug: "michael-stutts",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kate Charlotte",
    lastName: "Stutzel",
    title: "Revenue Cycle AR Manager",
    slug: "kate-charlotte-stutzel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tania",
    lastName: "Suarez",
    title: "Human Resources/Training Associate",
    slug: "tania-suarez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rafael",
    lastName: "Suarez",
    title: "Systems Coordinator",
    slug: "rafael-suarez",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jonathan",
    lastName: "Suarez",
    title: "Counselor-Financial Aid",
    slug: "jonathan-suarez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Fernando",
    lastName: "Suarez",
    title: "Porter",
    slug: "fernando-suarez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Faride M",
    lastName: "Suarez",
    title: "Associate Director For Certification Compliance",
    slug: "faride-m-suarez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tania Beatriz",
    lastName: "Suarez Marquez",
    title: "Accommodations Assistant",
    slug: "tania-beatriz-suarez-marquez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Catherine F.",
    lastName: "Subervi",
    title: "Finance Supervisor",
    slug: "catherine-f-subervi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Daniel",
    lastName: "Suchenski",
    title: "Associate Director-CWP",
    slug: "daniel-suchenski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Malika",
    lastName: "Sud",
    title: "Genetic Counselor",
    slug: "malika-sud",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia A.",
    lastName: "Sudol",
    title: "Grants Coordinator I",
    slug: "olivia-a-sudol",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Sudol",
    title: "Associate (Investments)",
    slug: "katherine-sudol",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wanda Milagros",
    lastName: "Suero",
    title: "Customer Service Representative",
    slug: "wanda-milagros-suero",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tatiana",
    lastName: "Suero",
    title: "Manager,Administration/Finance",
    slug: "tatiana-suero",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Niurka M.",
    lastName: "Suero-Tejeda",
    title: "Project Director",
    slug: "niurka-m-suero-tejeda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nandita",
    lastName: "Sugandhi",
    title: "Associate",
    slug: "nandita-sugandhi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Eliana",
    lastName: "Sugarman",
    title: "Assistant Director of Development",
    slug: "eliana-sugarman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Hera HyunSoo",
    lastName: "Suh",
    title: "Associate Director of Academic Affairs",
    slug: "hera-hyunsoo-suh",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jozef",
    lastName: "Sulik",
    title: "Assistant Director, Center for Science and Society",
    slug: "jozef-sulik",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sophia Renee",
    lastName: "Sulimirski",
    title: "CTV Program Manager, Entrepreneurship",
    slug: "sophia-renee-sulimirski",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tiffeny",
    lastName: "Sullivan",
    title: "Senior Associate Director, Finance",
    slug: "tiffeny-sullivan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stephen M",
    lastName: "Sullivan",
    title: "IT Systems Administrator",
    slug: "stephen-m-sullivan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Susan M.",
    lastName: "Sullivan",
    title: "Senior Associate Director",
    slug: "susan-m-sullivan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julia F",
    lastName: "Sullivan",
    title: "Manager, Development and Alumni Relations",
    slug: "julia-f-sullivan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "JOANNE M",
    lastName: "SULLIVAN",
    title: "Office Manager",
    slug: "joanne-m-sullivan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anne R",
    lastName: "Sullivan",
    title: "Executive Vice President for Finance",
    slug: "anne-r-sullivan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Airiayana D",
    lastName: "Sullivan",
    title: "Technical Specialist",
    slug: "airiayana-d-sullivan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily",
    lastName: "Sun",
    title: "Research Support Assistant II",
    slug: "emily-sun",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lifeng",
    lastName: "Sun",
    title: "Associate Director, General Ledger and Accounting Operations",
    slug: "lifeng-sun",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Steve B.",
    lastName: "Sundell",
    title: "Associate Director, Marketing Optimization and Integration",
    slug: "steve-b-sundell",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eun Suh",
    lastName: "Sung",
    title: "Administrative Assistant",
    slug: "eun-suh-sung",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Arlene",
    lastName: "Suriani",
    title: "Administrative Coordinator",
    slug: "arlene-suriani",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linda",
    lastName: "Suriano",
    title:
      " Executive Assistant for the Deputy Vice President for Administration",
    slug: "linda-suriano",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caroline Marie",
    lastName: "Surman",
    title: "Program and Communications Manager",
    slug: "caroline-marie-surman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael V.",
    lastName: "Susi",
    title: "AVP of Academic Affairs",
    slug: "michael-v-susi",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Samantha",
    lastName: "Sutton",
    title: "Associate Director of Policy",
    slug: "samantha-sutton",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kristin J.",
    lastName: "Svenningsen",
    title: "Managing Director",
    slug: "kristin-j-svenningsen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Holly",
    lastName: "Swaminathan",
    title: "Asst Director, Res Fin Report",
    slug: "holly-swaminathan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kathryn",
    lastName: "Swanson",
    title: "Major Gifts Officer",
    slug: "kathryn-swanson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jill B.",
    lastName: "Swanson",
    title: "Staff Accountant",
    slug: "jill-b-swanson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Derrian Annadean",
    lastName: "Swany",
    title: "Contracts Coordinator",
    slug: "derrian-annadean-swany",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Myint",
    lastName: "Swe",
    title: "Coordinator, Business Services",
    slug: "myint-swe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lisa",
    lastName: "Sweat",
    title: "Associate Director",
    slug: "lisa-sweat",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tristan Mary",
    lastName: "Swedin",
    title: "Project Coordinator II",
    slug: "tristan-mary-swedin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniela Eva",
    lastName: "Sweet-Coll",
    title: "Administrative and Communications Officer",
    slug: "daniela-eva-sweet-coll",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brian M",
    lastName: "Sweeting",
    title: "Manager - Platform Engagement",
    slug: "brian-m-sweeting",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zachary A",
    lastName: "Sweetland",
    title: "Recess Enrichment Facilitator in The School",
    slug: "zachary-a-sweetland",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jawindy S",
    lastName: "Swengbe",
    title: "Community Outreach Manager",
    slug: "jawindy-s-swengbe",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Colleen K",
    lastName: "Swift",
    title: "Director of Academic Administration and Finance",
    slug: "colleen-k-swift",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Gabriel Raymond Mason",
    lastName: "Swinth",
    title: "Development & Planning Officer",
    slug: "gabriel-raymond-mason-swinth",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ezra",
    lastName: "Sydnor",
    title: "Administrator RFMH",
    slug: "ezra-sydnor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Areesha",
    lastName: "Syed",
    title: "Manager - Finance",
    slug: "areesha-syed",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kendra",
    lastName: "Sykes",
    title: "Director of Internal Exhibitions and Events",
    slug: "kendra-sykes",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Russell",
    lastName: "Szalasny",
    title: "Administrative Aide",
    slug: "russell-szalasny",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cora",
    lastName: "Szapka",
    title: "Academic Program Support In Professional Studies",
    slug: "cora-szapka",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Barbara A.",
    lastName: "Szolc",
    title: "Compliance Specialist,",
    slug: "barbara-a-szolc",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Tanya",
    lastName: "Tabachnik",
    title:
      " Senior Director, Scientific Platforms, Shared Resources and Advanced Instrumentation",
    slug: "tanya-tabachnik",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Idania",
    lastName: "Tablada",
    title: "Dir Billing Ed Comp Audit",
    slug: "idania-tablada",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marialejandra",
    lastName: "Taddeo",
    title: "Assistant Director, Admissions Operations",
    slug: "marialejandra-taddeo",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michele",
    lastName: "Tadiello",
    title: "Senior Informatics Specialist",
    slug: "michele-tadiello",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Abdullah",
    lastName: "Tafesh",
    title: "Assistant Director of Event Management and Communications",
    slug: "abdullah-tafesh",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tristan",
    lastName: "Tafolla",
    title: "Senior Director, Finance Operations & Strategic Risk Management",
    slug: "tristan-tafolla",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessie Garrett",
    lastName: "Taft",
    title: "Assistant Director of Strategic Partnerships",
    slug: "jessie-garrett-taft",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tanzina",
    lastName: "Taher",
    title: "Senior Administration Manager",
    slug: "tanzina-taher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mika",
    lastName: "Tal",
    title: "Manager - Preservation Technology Lab",
    slug: "mika-tal",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kirsten A",
    lastName: "Talgo",
    title: "Sr Spon Prog Admin & Comp Spec",
    slug: "kirsten-a-talgo",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anna Marie",
    lastName: "Tallman",
    title: "Graduate Admissions Manager",
    slug: "anna-marie-tallman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "June",
    lastName: "Tallon",
    title: "Financial Administrator",
    slug: "june-tallon",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Lucy",
    lastName: "Tam",
    title: "Academic Secretary",
    slug: "lucy-tam",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Esther",
    lastName: "Tam",
    title: "Manager, Finance and Billing",
    slug: "esther-tam",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Pamela C",
    lastName: "Tamay",
    title: "Assistant Director, Alumni and Corporate Relations",
    slug: "pamela-c-tamay",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Maria",
    lastName: "Tamburro",
    title: "Events and Project Coordinator (VHO)",
    slug: "maria-tamburro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ingrid",
    lastName: "Tamm",
    title:
      " Senior Specialist for Prospect Identification and Principal Gifts Research",
    slug: "ingrid-tamm",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michelle",
    lastName: "Tan",
    title: "Associate",
    slug: "michelle-tan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Isabel Victoria",
    lastName: "Tanedo",
    title: "Assistant Director of Operations",
    slug: "isabel-victoria-tanedo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yu Lan",
    lastName: "Tang",
    title: "Associate Director, Finance",
    slug: "yu-lan-tang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Philip",
    lastName: "Tang",
    title: "Diagnostic Imaging Specialist",
    slug: "philip-tang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Linyao",
    lastName: "Tang",
    title: "Manager, Financial Operations",
    slug: "linyao-tang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jackie C.",
    lastName: "Tang",
    title: "Graduate Career Placement Manager",
    slug: "jackie-c-tang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Cheryl",
    lastName: "Tang",
    title: "Assistant Director",
    slug: "cheryl-tang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bingjun",
    lastName: "Tang",
    title: "PT Interim RA: Econ Program",
    slug: "bingjun-tang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melissa N.",
    lastName: "Tanis",
    title: "Manager-Communications",
    slug: "melissa-n-tanis",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kimberly",
    lastName: "Tantillo",
    title: "Administrative Coordinator",
    slug: "kimberly-tantillo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia",
    lastName: "Tapia",
    title: "Academic Secretary",
    slug: "patricia-tapia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Evelyn",
    lastName: "Tapia",
    title: "Coordinator Anes. User Support",
    slug: "evelyn-tapia",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Domingo",
    lastName: "Tapia",
    title: "Production Coordinator",
    slug: "domingo-tapia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alba R.",
    lastName: "Tapia",
    title: "Billing Manager",
    slug: "alba-r-tapia",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Aneudy E.",
    lastName: "Tapia",
    title: "Senior Operations Coordinator",
    slug: "aneudy-e-tapia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Feteri",
    lastName: "Tapia Silvestre",
    title: "Senior Clerk",
    slug: "feteri-tapia-silvestre",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexandra",
    lastName: "Tarasenko",
    title: "Lab Manager",
    slug: "alexandra-tarasenko",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Maja",
    lastName: "Tarateta",
    title: "Editorial Director",
    slug: "maja-tarateta",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John",
    lastName: "Tarbet",
    title: "Assoc Director-Intl Programs",
    slug: "john-tarbet",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jocelyn",
    lastName: "Tarbox",
    title: "Chief of Staff to the Founding Director",
    slug: "jocelyn-tarbox",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thomas",
    lastName: "Tarduogno",
    title: "Director-Financial Aid",
    slug: "thomas-tarduogno",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Arsalan",
    lastName: "Tariq",
    title: "Accessioning Coordinator",
    slug: "arsalan-tariq",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Liana",
    lastName: "Tascau",
    title: "Compliance Specialist, Research Compliance & Training",
    slug: "liana-tascau",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Myrick J",
    lastName: "Tasher",
    title: "Accountant, Benefits Accounting",
    slug: "myrick-j-tasher",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth Sparrow",
    lastName: "Tashiro",
    title: "Assoc Dean, IT and CTO",
    slug: "elizabeth-sparrow-tashiro",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Zarrin A",
    lastName: "Tasnim",
    title: "Project Manager",
    slug: "zarrin-a-tasnim",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lori Ann",
    lastName: "Tate",
    title: "Production Editor",
    slug: "lori-ann-tate",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kristina R",
    lastName: "Tate",
    title: "Senior Director of Communications",
    slug: "kristina-r-tate",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Darlynn V.",
    lastName: "Tate",
    title: "Director, Revenue Cycle",
    slug: "darlynn-v-tate",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Josephine K.",
    lastName: "Tatel",
    title: "Assistant Director, Instructional Technology",
    slug: "josephine-k-tatel",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Charlie",
    lastName: "Tatis",
    title: "Associate Manager",
    slug: "charlie-tatis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Marci",
    lastName: "Taub",
    title: "Senior Associate Director, Undergraduate Career Development",
    slug: "marci-taub",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Islah Nawal",
    lastName: "Tauheed",
    title: "Administrative Manager",
    slug: "islah-nawal-tauheed",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yanira Marilyn",
    lastName: "Tavares",
    title: "Contract Negotiations Officer",
    slug: "yanira-marilyn-tavares",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Thomas",
    lastName: "Tavares",
    title: "Associate Bursar/AR System Administrator",
    slug: "thomas-tavares",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Letisha M",
    lastName: "Tavarez",
    title: "Secretary B",
    slug: "letisha-m-tavarez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luisa",
    lastName: "Taveras",
    title: "Program Manager, CPRC",
    slug: "luisa-taveras",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Emily",
    lastName: "Taveras",
    title: "Program Manager",
    slug: "emily-taveras",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittany",
    lastName: "Taveras",
    title: "Temp",
    slug: "brittany-taveras",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alba E.",
    lastName: "Taveras",
    title: "Coordinator",
    slug: "alba-e-taveras",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexa Idelky",
    lastName: "Taveras",
    title: "Research Administrator II",
    slug: "alexa-idelky-taveras",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Wandee",
    lastName: "Tawinboon",
    title: "Outreach and Social Media Coordinator",
    slug: "wandee-tawinboon",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tosha",
    lastName: "Taybron",
    title: "Senior Finance Specialist",
    slug: "tosha-taybron",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sara E.",
    lastName: "Taylor",
    title: "Vice President for Finance and Administration, Arts and Sciences",
    slug: "sara-e-taylor",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kent",
    lastName: "Taylor",
    title: "Senior Application Systems Developer",
    slug: "kent-taylor",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joseph M.",
    lastName: "Taylor",
    title: "Director of Operations, Administration and Planning",
    slug: "joseph-m-taylor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jazmin",
    lastName: "Taylor",
    title: "Senior Director of EOAA Investigations/Deputy Title IX Coordinator",
    slug: "jazmin-taylor",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jessica Tameeka",
    lastName: "Taylor",
    title: "Administrative Assistant",
    slug: "jessica-tameeka-taylor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chrissandra S.",
    lastName: "Taylor",
    title: "Department Secretary",
    slug: "chrissandra-s-taylor",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alvin",
    lastName: "Taylor",
    title: "Director, Columbia Startup Lab",
    slug: "alvin-taylor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Taylor-Tumilty",
    title: "Assistant Director, Recruitment & Admissions",
    slug: "david-taylor-tumilty",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Garen A",
    lastName: "Tchopourian",
    title: "Web Developer",
    slug: "garen-a-tchopourian",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kam-Meng Mary",
    lastName: "Tchou-Wong",
    title: "Exec Director-Rsch Strategy",
    slug: "kam-meng-mary-tchou-wong",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yousef",
    lastName: "Tehrani",
    title: "Advising Dean",
    slug: "yousef-tehrani",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nidia Mercedes",
    lastName: "Tejada",
    title: "Senior Executive Assistant",
    slug: "nidia-mercedes-tejada",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Deja A.",
    lastName: "Tejada",
    title: "HR & Operations Associate",
    slug: "deja-a-tejada",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mazaher A",
    lastName: "Tejani",
    title: "Associate Director for Compliance",
    slug: "mazaher-a-tejani",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Jeanette",
    lastName: "Tejeda",
    title: "Procurement Coordinator",
    slug: "jeanette-tejeda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Julie A",
    lastName: "Tellez",
    title: "Licensed Master Social Worker",
    slug: "julie-a-tellez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Renee",
    lastName: "Tenenbaum",
    title: "Business Manager",
    slug: "renee-tenenbaum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura R",
    lastName: "Tenenbaum",
    title: "Senior Director of Development",
    slug: "laura-r-tenenbaum",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy J",
    lastName: "Tenney",
    title: "Associate Director, Operations",
    slug: "amy-j-tenney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Layhannara",
    lastName: "Tep",
    title: "Associate Director of Tutoring and Academic Support",
    slug: "layhannara-tep",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anthony S",
    lastName: "Teri",
    title: "Sr. Director, Information Tech",
    slug: "anthony-s-teri",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ana",
    lastName: "Terrero Claret",
    title: "Development Assistant, Information Services",
    slug: "ana-terrero-claret",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachael Marie",
    lastName: "Terry",
    title: "Deputy Director -Cntrs/Prgms",
    slug: "rachael-marie-terry",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evagelia",
    lastName: "Terzopoulos Cunningham",
    title: "Associate Director, Digital Project Management",
    slug: "evagelia-terzopoulos-cunningham",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "ldap replication",
    lastName: "test",
    title: "LDAP Replication Report",
    slug: "ldap-replication-test",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "ldap replication",
    lastName: "test",
    title: "LDAP Replication Report",
    slug: "ldap-replication-test-1",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karissa Kelly",
    lastName: "Thacker",
    title: "Earl Hall Pluralism Associate",
    slug: "karissa-kelly-thacker",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Malcolm W.",
    lastName: "Thaxton",
    title: "Senior Manager of Finance and Operations",
    slug: "malcolm-w-thaxton",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Johanne",
    lastName: "Then",
    title: "Administrative Aide",
    slug: "johanne-then",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bernisabel",
    lastName: "Then",
    title: "Administrative Assistant I",
    slug: "bernisabel-then",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aram",
    lastName: "Then",
    title: "Manager, Clin Svcs Admin&Cred",
    slug: "aram-then",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luciana",
    lastName: "Theodore Neverson",
    title: "Manager - Finance Application Support",
    slug: "luciana-theodore-neverson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Elizabeth",
    lastName: "Theoharis",
    title: "Staff",
    slug: "elizabeth-theoharis",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Michel",
    lastName: "Thiebaut",
    title: "Contractor",
    slug: "michel-thiebaut",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin",
    lastName: "Thiel",
    title: "Coordinator",
    slug: "robin-thiel",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kirsten M.",
    lastName: "Thien",
    title: "Senior Manager, Research Administration",
    slug: "kirsten-m-thien",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael J.",
    lastName: "Thivierge",
    title: "Executive Director, Tuition Programs",
    slug: "michael-j-thivierge",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Aiyuba",
    lastName: "Thomas",
    title: "Project Manager",
    slug: "aiyuba-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sonia",
    lastName: "Thomas",
    title: "Supervisor, ICM",
    slug: "sonia-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacy",
    lastName: "Thomas",
    title: "Secretary",
    slug: "stacy-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven E.",
    lastName: "Thomas",
    title: "Director, Instructional Support",
    slug: "steven-e-thomas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Peter Mark",
    lastName: "Thomas",
    title: "Associate Service Specialist",
    slug: "peter-mark-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex",
    lastName: "Thomas",
    title: "Porter",
    slug: "alex-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lincy M.",
    lastName: "Thomas",
    title: "Radiology Qual Doc Manager",
    slug: "lincy-m-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laneisha C",
    lastName: "Thomas",
    title: "Coding and Charge Edits Specialist III",
    slug: "laneisha-c-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karla Z.",
    lastName: "Thomas",
    title: "Associate Director, Experiential Education",
    slug: "karla-z-thomas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Kharla Gabriela",
    lastName: "Thomas",
    title: "Events Coordinator",
    slug: "kharla-gabriela-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Keil Joseph",
    lastName: "Thomas",
    title: "Administrative Director - Bio",
    slug: "keil-joseph-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Janet",
    lastName: "Thomas",
    title: "Staff",
    slug: "janet-thomas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Hugh W.",
    lastName: "Thomas",
    title: "Assoc Director-ENG Deans Offic",
    slug: "hugh-w-thomas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Darren Joseph",
    lastName: "Thomas",
    title: "Program Manager for Advising",
    slug: "darren-joseph-thomas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Deborah R",
    lastName: "Thomas",
    title: "Billing Compliance Coordinator",
    slug: "deborah-r-thomas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Crystal",
    lastName: "Thomas",
    title: "Financial Assistant",
    slug: "crystal-thomas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Crystal Anne",
    lastName: "Thomas",
    title: "Director, Research Strategy and Policy",
    slug: "crystal-anne-thomas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andron",
    lastName: "Thomas",
    title: "Gift Coordinator",
    slug: "andron-thomas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Abe",
    lastName: "Thomas",
    title: "Sr Director, Budget&Analytics",
    slug: "abe-thomas",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Glenford D",
    lastName: "Thomas Sr.",
    title: "Assistant Manager, Custodial Operations",
    slug: "glenford-d-thomas-sr",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Troy",
    lastName: "Thompson",
    title: "CMA",
    slug: "troy-thompson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Suzette Samaroo",
    lastName: "Thompson",
    title: "Sr Director, Clin Svcs Admin",
    slug: "suzette-samaroo-thompson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sativa Lucille",
    lastName: "Thompson",
    title: "Data Associate",
    slug: "sativa-lucille-thompson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rashan",
    lastName: "Thompson",
    title: "Operations Coordinator",
    slug: "rashan-thompson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Norma Fay",
    lastName: "Thompson",
    title: "Host/Hostess",
    slug: "norma-fay-thompson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kyoko H",
    lastName: "Thompson",
    title: "Associate Director of Research Development",
    slug: "kyoko-h-thompson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth",
    lastName: "Thompson",
    title: "Leadership Gift Officer, GSAS",
    slug: "elizabeth-thompson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrew Wayne",
    lastName: "Thompson",
    title: "Senior Grants Manager",
    slug: "andrew-wayne-thompson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrew",
    lastName: "Thompson",
    title: "Director, DevOps and Cloud Native Solutions",
    slug: "andrew-thompson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Daniel",
    lastName: "Thorn",
    title: "Sr Exec Director, Fin & Ops",
    slug: "daniel-thorn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Karyn",
    lastName: "Thorne",
    title: "Sr Administrative Assistant",
    slug: "karyn-thorne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sophie",
    lastName: "Thuault-Restituito",
    title: "Exec Dir,Strategic Initiatives",
    slug: "sophie-thuault-restituito",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian J",
    lastName: "Thumm",
    title: "IT Mgr EMR & Assoc IT Sys",
    slug: "brian-j-thumm",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Smorapoom",
    lastName: "Thumpituk",
    title: "Rounds Person",
    slug: "smorapoom-thumpituk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Naw Wai Wai L.",
    lastName: "Thway",
    title: "Coordinator",
    slug: "naw-wai-wai-l-thway",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jane",
    lastName: "Tian",
    title: "Senior Director, Finncl Rprtng",
    slug: "jane-tian",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Ponce D.",
    lastName: "Tidwell",
    title: "Administrator",
    slug: "ponce-d-tidwell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lisa",
    lastName: "Tilihoi",
    title: "Major Gifts Officer I",
    slug: "lisa-tilihoi",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Gina",
    lastName: "Tilleli",
    title: "Senior Director, Talent Management and Human Resources",
    slug: "gina-tilleli",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Robert E.",
    lastName: "Tillman",
    title: "Assoc VD / Dir, Mentoring",
    slug: "robert-e-tillman",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jhalisa",
    lastName: "Tillman",
    title: "MA",
    slug: "jhalisa-tillman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alyssa Faith",
    lastName: "Timin",
    title: "Managing Editor",
    slug: "alyssa-faith-timin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emily",
    lastName: "Timson",
    title: "Program Manager, GME",
    slug: "emily-timson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "May Theng",
    lastName: "Ting",
    title: "Research Project Manager",
    slug: "may-theng-ting",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zachary K.",
    lastName: "Tinkelman",
    title: "Director of Production and Operations",
    slug: "zachary-k-tinkelman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Raquel B",
    lastName: "Tipiani",
    title: "Admin Coord, Stud Act/P&S Club",
    slug: "raquel-b-tipiani",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Melanie L.",
    lastName: "Tiplady",
    title: "Academic Affairs Manager",
    slug: "melanie-l-tiplady",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Margery F.",
    lastName: "Tippie",
    title: "Retired",
    slug: "margery-f-tippie",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Daniela",
    lastName: "Tisch",
    title:
      " Managing Director, Richman Center for Business, Law, and Public Policy",
    slug: "daniela-tisch",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandra",
    lastName: "Tiwari",
    title: "Division Administrator",
    slug: "sandra-tiwari",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leonard",
    lastName: "Tjondro",
    title: "Associate Director, Operations",
    slug: "leonard-tjondro",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joyee",
    lastName: "To",
    title: "Assistant Director for Strategic Partnerships",
    slug: "joyee-to",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Henryne G",
    lastName: "Tobias",
    title: "Director, Career Services",
    slug: "henryne-g-tobias",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jean",
    lastName: "Tobin",
    title: "Administrative Assistant I",
    slug: "jean-tobin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chanel A",
    lastName: "Tobon",
    title: "Lab Manager",
    slug: "chanel-a-tobon",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Keiko",
    lastName: "Toda",
    title: "Administrative Assistant",
    slug: "keiko-toda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabriel S",
    lastName: "Toja",
    title: "Senior Admissions Officer",
    slug: "gabriel-s-toja",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Gwendolyn",
    lastName: "Tolen",
    title: "Charge Edits Spc I",
    slug: "gwendolyn-tolen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zhanna",
    lastName: "Tolochko",
    title: "Director - Budget and Finance",
    slug: "zhanna-tolochko",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Moriah J",
    lastName: "Tom",
    title: "Senior Admissions Officer",
    slug: "moriah-j-tom",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Christine",
    lastName: "Tom",
    title: "Associate Director, Custom Programs",
    slug: "christine-tom",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jack",
    lastName: "Tomaselli",
    title: "Director of Finance and Administration",
    slug: "jack-tomaselli",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Diane Renee",
    lastName: "Tomasi",
    title: "Program Associate for Program in Arts Administration (ARAD)",
    slug: "diane-renee-tomasi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kazue",
    lastName: "Tomiyama",
    title: "Assistant Director",
    slug: "kazue-tomiyama",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeffrey Charles",
    lastName: "Tompkins",
    title: "Communications Officer",
    slug: "jeffrey-charles-tompkins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jessica",
    lastName: "Tong",
    title: "Assistant Director, Summer Sessions and Continuing Education",
    slug: "jessica-tong",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessie",
    lastName: "Tong",
    title: "Asst Dir, Academic Affairs",
    slug: "jessie-tong",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andrea Lauren G.",
    lastName: "Tong",
    title: "Event Coordinator",
    slug: "andrea-lauren-g-tong",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tonya K",
    lastName: "Tonge",
    title: "Administrative Assistant",
    slug: "tonya-k-tonge",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicole",
    lastName: "Tonge",
    title: "CMA",
    slug: "nicole-tonge",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Anatoly",
    lastName: "Tonkonogy",
    title: "Enrichment Facilitator in The School",
    slug: "anatoly-tonkonogy",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marta Christina",
    lastName: "Torelli",
    title: "Coordinator",
    slug: "marta-christina-torelli",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dany A.",
    lastName: "Toribio Torres",
    title: "Digital Image Specialist",
    slug: "dany-a-toribio-torres",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Catharina E.",
    lastName: "Torok",
    title: "Senior Associate Director, Web Development and Technology",
    slug: "catharina-e-torok",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yeseny",
    lastName: "Torres",
    title: "Manager, HR/FA",
    slug: "yeseny-torres",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Sally A",
    lastName: "Torres",
    title: "Project Coordinator",
    slug: "sally-a-torres",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ruth E.",
    lastName: "Torres",
    title: "Director of Finance and Administration",
    slug: "ruth-e-torres",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nia",
    lastName: "Torres",
    title: "Customer Service Representative / Front Desk",
    slug: "nia-torres",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nurys J.",
    lastName: "Torres",
    title: "Onboarding Manager",
    slug: "nurys-j-torres",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jessica",
    lastName: "Torres",
    title: "CMA",
    slug: "jessica-torres",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Janelle",
    lastName: "Torres",
    title: "Program Manager",
    slug: "janelle-torres",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jennifer Michelle",
    lastName: "Torres",
    title: "Assistant Director of Recruiting",
    slug: "jennifer-michelle-torres",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "John A.",
    lastName: "Torres",
    title: "Manager, Deployment",
    slug: "john-a-torres",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Felix R.",
    lastName: "Torres",
    title: "Systems Dir, Cardiology IT",
    slug: "felix-r-torres",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Edwin",
    lastName: "Torres",
    title:
      " Deputy Chief of Staff and Director of Strategic Initiatives and Board Relations",
    slug: "edwin-torres",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Daniel A.",
    lastName: "Torres",
    title: "Service Specialist",
    slug: "daniel-a-torres",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cris",
    lastName: "Torres",
    title: "Assistant Director -Human Reso",
    slug: "cris-torres",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Carmen",
    lastName: "Torres",
    title: "Customer Service Rep",
    slug: "carmen-torres",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Cleofe C.",
    lastName: "Torres",
    title: "Deputy Vice President for Administration",
    slug: "cleofe-c-torres",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Elizabeth N.",
    lastName: "Torrez",
    title: "Grants Manager",
    slug: "elizabeth-n-torrez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Beryl Suzan Eva",
    lastName: "Torthe",
    title: "Service Provider",
    slug: "beryl-suzan-eva-torthe",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alexandra K.",
    lastName: "Toubia",
    title: "Event Coordinator",
    slug: "alexandra-k-toubia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ravi Kiran",
    lastName: "Toughti Reddy",
    title: "Sr. Applications Systems Developer",
    slug: "ravi-kiran-toughti-reddy",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jonathan C",
    lastName: "Touson",
    title: "Assoc Vice Dean, Org Strat&Dev",
    slug: "jonathan-c-touson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lindsay M.",
    lastName: "Toussaint",
    title: "Assistant Director of Financial Aid",
    slug: "lindsay-m-toussaint",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lianny",
    lastName: "Toval",
    title: "Licensed Master Social Worker",
    slug: "lianny-toval",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katarzyna",
    lastName: "Townsend",
    title: "Senior Director, Executive Finance and Administration",
    slug: "katarzyna-townsend",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alyssa",
    lastName: "Tracy",
    title: "Clin Coord, Mental Hlth Prvdr",
    slug: "alyssa-tracy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Thao Hieu",
    lastName: "Tran",
    title: "Scheduling Coordinator",
    slug: "thao-hieu-tran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Tran",
    title: "Administrative Coordinator",
    slug: "stephanie-tran",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Richard M.",
    lastName: "Tran",
    title: "Assistant Director, Instructional Design",
    slug: "richard-m-tran",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Olivia B",
    lastName: "Tran",
    title:
      " Associate Director of Multicultural Affairs / Program Director for Diversity Education",
    slug: "olivia-b-tran",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Lucky",
    lastName: "Tran",
    title: "Dir, Sci Comm&Media Relations",
    slug: "lucky-tran",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kevin",
    lastName: "Tran",
    title: "Associate (Operations)-Investment Management Company",
    slug: "kevin-tran",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John",
    lastName: "Tran",
    title: "Associate Registrar, Instructional Support",
    slug: "john-tran",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cleopatra",
    lastName: "Travell-Kromelow",
    title: "Asst Media Producer",
    slug: "cleopatra-travell-kromelow",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Beth C",
    lastName: "Traver",
    title: "Associate Staffing Specialist",
    slug: "beth-c-traver",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Aaron Christopher",
    lastName: "Treat",
    title: "Technical Director",
    slug: "aaron-christopher-treat",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alissa",
    lastName: "Trepman",
    title: "Continuing Education Units Program Manager",
    slug: "alissa-trepman",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lilian",
    lastName: "Trevino",
    title: "Analytics Developer",
    slug: "lilian-trevino",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Georgia",
    lastName: "Trim",
    title: "Assistant Director, Adult Education",
    slug: "georgia-trim",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Timothy K.",
    lastName: "Trimble",
    title: "Night Supervisor",
    slug: "timothy-k-trimble",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aaron",
    lastName: "Trimpin",
    title: "Administrative Aide",
    slug: "aaron-trimpin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren A.",
    lastName: "Trinker",
    title: "Senior Manager of Finance",
    slug: "lauren-a-trinker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Tenzin",
    lastName: "Trinley",
    title: "Project Coordinator",
    slug: "tenzin-trinley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meghray",
    lastName: "Tripathi",
    title: "Cloud Architect",
    slug: "meghray-tripathi",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Meredith Marks",
    lastName: "Trivedi",
    title: "Managing Director",
    slug: "meredith-marks-trivedi",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle",
    lastName: "Trivino",
    title: "Career Catalyst Intern",
    slug: "danielle-trivino",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Mirela N.",
    lastName: "Trofin",
    title: "Director",
    slug: "mirela-n-trofin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica A.",
    lastName: "Troiano",
    title: "Director of Administration, Doctoral Program",
    slug: "jessica-a-troiano",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cathy H.",
    lastName: "Troutman",
    title: "Asst Mgr, Safety & Security",
    slug: "cathy-h-troutman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tanya",
    lastName: "Trueheart",
    title: "Assistant Director, Advising",
    slug: "tanya-trueheart",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Sean R",
    lastName: "Trulby",
    title: "Associate Dean of Student Life",
    slug: "sean-r-trulby",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tan N",
    lastName: "Truong",
    title: "Associate Director of Client Services",
    slug: "tan-n-truong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Azsanee Ann",
    lastName: "Truss Ms",
    title: "Administrative Coordinator",
    slug: "azsanee-ann-truss-ms",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stacey C",
    lastName: "Tsai",
    title: "Director, Financial Reporting",
    slug: "stacey-c-tsai",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Patty",
    lastName: "Tsai",
    title: "Director, Alumni Relations",
    slug: "patty-tsai",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jennifer",
    lastName: "Tsai",
    title: "Administrative Manager",
    slug: "jennifer-tsai",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tony",
    lastName: "Tsang",
    title: "Senior Contracts Officer",
    slug: "tony-tsang",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Kevin",
    lastName: "Tschirhart",
    title: "Senior Project Manager",
    slug: "kevin-tschirhart",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sayaka",
    lastName: "Tsuda",
    title: "Programs Manager",
    slug: "sayaka-tsuda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shante Marie",
    lastName: "Tucker",
    title: "Administrative Assistant",
    slug: "shante-marie-tucker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Satomi",
    lastName: "Tucker",
    title: "Administrative Manager",
    slug: "satomi-tucker",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Rachel",
    lastName: "Tucker",
    title: "Supervisor, Histology",
    slug: "rachel-tucker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rena H.",
    lastName: "Tucker",
    title: "Administrative Coordinator, Achievement Institute",
    slug: "rena-h-tucker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ade",
    lastName: "Tukuru",
    title: "Consultant",
    slug: "ade-tukuru",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sandesh M.",
    lastName: "Tuladhar",
    title: "Associate Provost for Online Education",
    slug: "sandesh-m-tuladhar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sradha",
    lastName: "Tuladhar",
    title: "Associate Director of Grants Administration and Compliance",
    slug: "sradha-tuladhar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Danielle Alexandra",
    lastName: "Tulchinsky",
    title: "Instructional Support Associate-Design Education",
    slug: "danielle-alexandra-tulchinsky",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tomasz",
    lastName: "Tuleja",
    title: "Assistant Director for Compliance & ALP",
    slug: "tomasz-tuleja",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Courtney",
    lastName: "Tulli",
    title: "HR Generalist",
    slug: "courtney-tulli",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Robert",
    lastName: "Tulman",
    title: "Director, Dnr Relations & Comm",
    slug: "robert-tulman",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Kathryn A.",
    lastName: "Tuman",
    title: "Senior Financial Aid Specialist",
    slug: "kathryn-a-tuman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jena",
    lastName: "Tumbleson",
    title: "Assoc Director, Development",
    slug: "jena-tumbleson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zoe",
    lastName: "Tunkelrott",
    title: "Org Dev Specialist, Bus Proc",
    slug: "zoe-tunkelrott",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Esther",
    lastName: "Turay",
    title: "Manager of Development & Alumni Relations",
    slug: "esther-turay",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah Rose",
    lastName: "Turchin",
    title: "Director of Legal Strategy and Policy",
    slug: "sarah-rose-turchin",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Carmela",
    lastName: "Turco",
    title: "Multi-Center Trial CRC II",
    slug: "carmela-turco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew Jeremy",
    lastName: "Turk",
    title: "Senior Grants Accountant",
    slug: "matthew-jeremy-turk",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David",
    lastName: "Turk",
    title: "Consultant",
    slug: "david-turk",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew B",
    lastName: "Turner",
    title: "Director of Academic Administration and Finance",
    slug: "matthew-b-turner",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Emily Caroline",
    lastName: "Turner",
    title: "Assistant Director, Marketing Optimization and Integration",
    slug: "emily-caroline-turner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Christy Reed",
    lastName: "Turner",
    title: "Coordinator-Operations",
    slug: "christy-reed-turner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexandra",
    lastName: "Turner",
    title: "Assistant Director, Admissions",
    slug: "alexandra-turner",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Andra L.",
    lastName: "Turner",
    title: "Assistant Director of Affirmative Action and Recruitment",
    slug: "andra-l-turner",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Andrew J",
    lastName: "Turner",
    title: "Project Coordinator",
    slug: "andrew-j-turner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bryan",
    lastName: "Turner-George",
    title: "Associate Director, Online and Digital Programs",
    slug: "bryan-turner-george",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lesley",
    lastName: "Turton",
    title: "Dissertations and Database Manager",
    slug: "lesley-turton",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Barbara",
    lastName: "Tversky",
    title: "Interim Employee",
    slug: "barbara-tversky",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Twardziak",
    title: "Digital Content Specialist",
    slug: "kelly-twardziak",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Peace",
    lastName: "Twesigye",
    title: "Staff",
    slug: "peace-twesigye",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Peter Andrew",
    lastName: "Twyman",
    title: "Deputy Director for Projects",
    slug: "peter-andrew-twyman",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olger Cornelius",
    lastName: "Twyner III",
    title: "Executive Director, Community Impact",
    slug: "olger-cornelius-twyner-iii",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carol R.",
    lastName: "Tycko",
    title: "Dir of Business System",
    slug: "carol-r-tycko",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Erica L",
    lastName: "Tyler",
    title: "Comm and Mrktng Coord II",
    slug: "erica-l-tyler",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Danielle",
    lastName: "Tyler",
    title: "Administrator",
    slug: "danielle-tyler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neffertia Shaniqua",
    lastName: "Tyner",
    title: "Associate Director of Student Wellness",
    slug: "neffertia-shaniqua-tyner",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Alicia",
    lastName: "Ubiera-Fuller",
    title: "Administrative Assistant",
    slug: "alicia-ubiera-fuller",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chidera Kosi",
    lastName: "Udedibia",
    title: "Fly Kitchen Access - Rockefeller U",
    slug: "chidera-kosi-udedibia",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Masha",
    lastName: "Udensiva-Brenner",
    title: "Manager-Digital & Print",
    slug: "masha-udensiva-brenner",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Tomomi",
    lastName: "Uetani",
    title: "Director",
    slug: "tomomi-uetani",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Arthur",
    lastName: "Uhimov",
    title: "Executive Director, Pre-Award and Strategic Research Development",
    slug: "arthur-uhimov",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "John",
    lastName: "Uhl",
    title: "Senior Writer",
    slug: "john-uhl",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lourdes",
    lastName: "Ulerio-Zaiter",
    title: "Administrative Aide",
    slug: "lourdes-ulerio-zaiter",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Donna",
    lastName: "Ulijn",
    title: "Assistant Controller",
    slug: "donna-ulijn",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Rainah Grace",
    lastName: "Umlauf",
    title: "Associate Director of Global Academic Partnerships",
    slug: "rainah-grace-umlauf",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hannette",
    lastName: "Un",
    title: "Asst Director-Info Tech",
    slug: "hannette-un",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Richard Aricheta",
    lastName: "Unite",
    title: "Live Support Specialist",
    slug: "richard-aricheta-unite",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laudy A",
    lastName: "Urena",
    title: "Wait Staff",
    slug: "laudy-a-urena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura",
    lastName: "Urena",
    title: "Financial Coordinator",
    slug: "laura-urena",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jonelie S",
    lastName: "Urena",
    title: "Administrative Assistant",
    slug: "jonelie-s-urena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven",
    lastName: "Urra",
    title: "Administrative Aide",
    slug: "steven-urra",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna Alejandrina",
    lastName: "Urrea",
    title: "Academic Secretary (Art & Art Education Program)",
    slug: "anna-alejandrina-urrea",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Linda",
    lastName: "Ury Greenberg",
    title: "Director of Marketing Research",
    slug: "linda-ury-greenberg",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Basavaraju",
    lastName: "Us",
    title: "Consultant",
    slug: "basavaraju-us",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Aziz",
    lastName: "Usmani",
    title: "Manager, Systems Administration",
    slug: "aziz-usmani",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Emily C",
    lastName: "Utset",
    title: "Assistant Director, Class Giving",
    slug: "emily-c-utset",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marisol",
    lastName: "Uy",
    title: "Administrative Coordinator",
    slug: "marisol-uy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Helen A.",
    lastName: "Uy",
    title: "Procurement Manager",
    slug: "helen-a-uy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mohini V",
    lastName: "Vaidya",
    title: "Project Manager",
    slug: "mohini-v-vaidya",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kanika A.",
    lastName: "Vaish",
    title: "Manager of Academic Administration",
    slug: "kanika-a-vaish",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michelle H",
    lastName: "Vakman",
    title: "Executive Director, Admissions Operations",
    slug: "michelle-h-vakman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Mireille",
    lastName: "Valbrun",
    title: "Division Administrator - RFMH",
    slug: "mireille-valbrun",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zachary A",
    lastName: "Valdez",
    title: "Administrative Assistant",
    slug: "zachary-a-valdez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rosandi",
    lastName: "Valdez",
    title: "Associate Director of Special Events and Programs",
    slug: "rosandi-valdez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Regina Marie",
    lastName: "Valdez",
    title: "Administrative Manager and Executive Assistant",
    slug: "regina-marie-valdez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ondina M.",
    lastName: "Valdez",
    title: "Senior Generalist, HR/FA",
    slug: "ondina-m-valdez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Lenfis",
    lastName: "Valdez",
    title: "Project Manager",
    slug: "lenfis-valdez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Francisco J.",
    lastName: "Valdez",
    title: "Task Force Leader",
    slug: "francisco-j-valdez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bernardo Garcia",
    lastName: "Valencia",
    title: "Graphic Designer",
    slug: "bernardo-garcia-valencia",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Samantha",
    lastName: "Valente",
    title: "Coordinator",
    slug: "samantha-valente",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Yolanda",
    lastName: "Valentin",
    title: "Customer Service - Front Desk",
    slug: "yolanda-valentin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wilson",
    lastName: "Valentin",
    title: "Associate Vice President for Communications, Columbia News",
    slug: "wilson-valentin",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eva",
    lastName: "Valentin",
    title: "Sr Specialist, Org Dev/People",
    slug: "eva-valentin",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "EVELYN",
    lastName: "VALENTIN",
    title: "Executive Assistant",
    slug: "evelyn-valentin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Evan P.",
    lastName: "Valentine",
    title: "VHO, Columbia Publishing Course",
    slug: "evan-p-valentine",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Amelia M",
    lastName: "Valentino",
    title: "Asst Director, Development",
    slug: "amelia-m-valentino",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sunilda",
    lastName: "Valladares-Silva",
    title: "Manager, Histology",
    slug: "sunilda-valladares-silva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Laura Gabriela",
    lastName: "Valle",
    title: "Administrative Assistant-RFMH",
    slug: "laura-gabriela-valle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Estela L",
    lastName: "Vallejo",
    title: "Administrative Manager",
    slug: "estela-l-vallejo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Enid M",
    lastName: "Vallejo-Juste",
    title: "Assoc Dir, Post Award Finance",
    slug: "enid-m-vallejo-juste",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Matthew",
    lastName: "Van Hellen",
    title: "Senior Associate Director, Media Production",
    slug: "matthew-van-hellen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eleanor Corlett",
    lastName: "van Hest",
    title: "Programming and Columbia Public Interest Community Coordinator",
    slug: "eleanor-corlett-van-hest",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexandra",
    lastName: "Van Petten",
    title: "Echo Tech",
    slug: "alexandra-van-petten",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charles",
    lastName: "Van Scyoc",
    title: "Director of Global Development",
    slug: "charles-van-scyoc",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kara",
    lastName: "Van Woerden",
    title: "Creative Director, Communications",
    slug: "kara-van-woerden",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Dirk",
    lastName: "Vanderlaan",
    title: "Admissions Manager",
    slug: "dirk-vanderlaan",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Demian P.",
    lastName: "Vanderputten",
    title: "Manager,Data Loss Prevention",
    slug: "demian-p-vanderputten",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Greg P",
    lastName: "Vann",
    title: "Data Coordinator",
    slug: "greg-p-vann",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Alexander",
    lastName: "Vapnyar",
    title: "Senior Application Systems Developer",
    slug: "alexander-vapnyar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Helena V.",
    lastName: "Vaquera Pena",
    title: "Graduate Student Life Officer",
    slug: "helena-v-vaquera-pena",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Tianna",
    lastName: "Vargas",
    title: "MPA",
    slug: "tianna-vargas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Noel",
    lastName: "Vargas",
    title: "Executive Director of Information Technology",
    slug: "noel-vargas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Melissa Maria",
    lastName: "Vargas",
    title: "Project Officer",
    slug: "melissa-maria-vargas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lillian",
    lastName: "Vargas",
    title: "Administrative Assistant",
    slug: "lillian-vargas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Vargas",
    title: "Research Administrator",
    slug: "katherine-vargas",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Justin D.",
    lastName: "Vargas",
    title: "Quality and Data Specialist",
    slug: "justin-d-vargas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Greivy R",
    lastName: "Vargas",
    title: "Administrative Coordinator",
    slug: "greivy-r-vargas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Genevieth",
    lastName: "Vargas",
    title: "Live Support Specialist",
    slug: "genevieth-vargas",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Connie A.",
    lastName: "Vargas",
    title: "Administrative Assistant",
    slug: "connie-a-vargas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brigitte Katherine",
    lastName: "Vargas",
    title: "Manager, Student Services",
    slug: "brigitte-katherine-vargas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ronald A.",
    lastName: "Vargas Benavides",
    title: "Associate Director, Admissions Operations",
    slug: "ronald-a-vargas-benavides",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Nancy Aguedita",
    lastName: "Vargas-Pena",
    title: "Rounds Person",
    slug: "nancy-aguedita-vargas-pena",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lindsey A.",
    lastName: "Varghese",
    title: "Director, Content Strategy, Online and Digital Programs",
    slug: "lindsey-a-varghese",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Saichaarvi",
    lastName: "Varimadugu",
    title: "Administrative Assistant",
    slug: "saichaarvi-varimadugu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna",
    lastName: "Varjian",
    title: "Financial Services Coordinator",
    slug: "anna-varjian",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Harold E.",
    lastName: "Varmus",
    title: "Lecture in Biological Sciences",
    slug: "harold-e-varmus",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Suzi J.",
    lastName: "Varnhagen",
    title: "Project Director",
    slug: "suzi-j-varnhagen",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gardenia",
    lastName: "Varona",
    title: "Accounts Payable Specialist",
    slug: "gardenia-varona",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cindy Y.",
    lastName: "Varona",
    title: "Grants Administrator",
    slug: "cindy-y-varona",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole Elise",
    lastName: "Vartanian",
    title: "Chief of Staff",
    slug: "nicole-elise-vartanian",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren A",
    lastName: "Vasek",
    title: "Administrative Director, Climate Business Initiatives",
    slug: "lauren-a-vasek",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bojana",
    lastName: "Vasikj Bjelogrlic",
    title: "Project Coordinator",
    slug: "bojana-vasikj-bjelogrlic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Natalya",
    lastName: "Vasilyeva",
    title: "Manager-Lab & Med Sourciing",
    slug: "natalya-vasilyeva",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sylvia",
    lastName: "Vasquez",
    title: "Assistant Director, Operations and Student Services",
    slug: "sylvia-vasquez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Stephanie",
    lastName: "Vasquez",
    title: "Admissions Assistant",
    slug: "stephanie-vasquez",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Minnelly",
    lastName: "Vasquez",
    title: "Social Worker II",
    slug: "minnelly-vasquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lillian",
    lastName: "Vasquez",
    title: "Assc Dir, Financial Ops, SPA",
    slug: "lillian-vasquez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jeffry N",
    lastName: "Vasquez",
    title: "Financial  Coordinator",
    slug: "jeffry-n-vasquez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Dario",
    lastName: "Vasquez",
    title: "Assistant Director of Entrepreneurship, Innovation and Design",
    slug: "dario-vasquez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cecilia L.",
    lastName: "Vasquez",
    title: "Human Resources Manager",
    slug: "cecilia-l-vasquez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ana E",
    lastName: "Vasquez",
    title: "Rev Cycle Reporting Manager",
    slug: "ana-e-vasquez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stacey L.",
    lastName: "Vassallo",
    title: "Senior Director of Development and Leadership Giving",
    slug: "stacey-l-vassallo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Quixote Radio",
    lastName: "Vassilakis",
    title: "Manager, Recruiting Operations and Services, Employer Relations",
    slug: "quixote-radio-vassilakis",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Peter J.",
    lastName: "Vaughan",
    title:
      " Director, Instructional and Information Technology/Dir. Motion Picture and Information Technology",
    slug: "peter-j-vaughan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Matthew",
    lastName: "Vaughan",
    title: "Associate Director, Instructional Design and Operations",
    slug: "matthew-vaughan",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Bethany",
    lastName: "Vaughan",
    title: "Staff",
    slug: "bethany-vaughan",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Bryon",
    lastName: "Vaughn",
    title: "Executive Director, Data and Analytics",
    slug: "bryon-vaughn",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sophia L",
    lastName: "Vazquez",
    title: "Assistant Project Manager",
    slug: "sophia-l-vazquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karla",
    lastName: "Vazquez",
    title: "Call Center Agent",
    slug: "karla-vazquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Geisha M",
    lastName: "Vazquez",
    title: "Manager, HRPC Transactions",
    slug: "geisha-m-vazquez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Alejandro",
    lastName: "Vazquez",
    title: "Administrative Manager",
    slug: "alejandro-vazquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Andrea",
    lastName: "Vazquez de Arthur",
    title: "Associate",
    slug: "andrea-vazquez-de-arthur",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Saul Rafael",
    lastName: "Vazquez-Pichardo",
    title: "Talent Inclusion Manager",
    slug: "saul-rafael-vazquez-pichardo",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Rebekah Abigail",
    lastName: "Vega",
    title: "Generalist, HR/FA",
    slug: "rebekah-abigail-vega",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marilisa",
    lastName: "Vega",
    title: "Research Project Coordinator",
    slug: "marilisa-vega",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Angela",
    lastName: "Vega",
    title: "Generalist, HR/FA",
    slug: "angela-vega",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Ashley M",
    lastName: "Vega",
    title: "Residence Hall Director",
    slug: "ashley-m-vega",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Krystal",
    lastName: "Vega Guilbe",
    title: "Project Manager",
    slug: "krystal-vega-guilbe",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anibal",
    lastName: "Vega-Montijo",
    title: "AV Systems Manager",
    slug: "anibal-vega-montijo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bridget",
    lastName: "Vegazo",
    title: "Front Desk Coordinator",
    slug: "bridget-vegazo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexis",
    lastName: "Velasco",
    title: "SYEP",
    slug: "alexis-velasco",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Luz",
    lastName: "Velasco Vela",
    title: "2024-2025 BioBus Personnel",
    slug: "luz-velasco-vela",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Stephanie",
    lastName: "Velasquez",
    title: "Chief of Staff",
    slug: "stephanie-velasquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander",
    lastName: "Velasquez",
    title: "Coordinator",
    slug: "alexander-velasquez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ashley",
    lastName: "Velasquez",
    title: "Grants Administrator",
    slug: "ashley-velasquez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Naomi",
    lastName: "Velazquez",
    title: "HR Representative",
    slug: "naomi-velazquez",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kimberly Alliya",
    lastName: "Velazquez",
    title: "Prog Coord,Stud Res&Schol Proj",
    slug: "kimberly-alliya-velazquez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Ashley",
    lastName: "Velez",
    title: "Associate Director of College Events",
    slug: "ashley-velez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Allyson Mckay",
    lastName: "Velez",
    title: "Asst Dean, Inst Giving & Ops",
    slug: "allyson-mckay-velez",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tania",
    lastName: "Velimirovici",
    title: "Academic Programs and Special Projects Officer",
    slug: "tania-velimirovici",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christina",
    lastName: "Vellios",
    title: "Executive Director, Development",
    slug: "christina-vellios",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian F.",
    lastName: "Velsor",
    title: "Equipment Prep and Inventory Assistant",
    slug: "brian-f-velsor",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christine",
    lastName: "Venezia",
    title: "Associate Director - Academic Programs",
    slug: "christine-venezia",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Krishna",
    lastName: "Venigalla",
    title: "Consultant",
    slug: "krishna-venigalla",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Srikanth",
    lastName: "Venkatesham",
    title: "Senior Consultant",
    slug: "srikanth-venkatesham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Milagros",
    lastName: "Ventura",
    title: "Data Manager",
    slug: "milagros-ventura",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Martir",
    lastName: "Ventura",
    title: "Fin Cnslr/Foll-Up Reg Coord",
    slug: "martir-ventura",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "EUGENIA",
    lastName: "VENTURA-Gonzalez",
    title: "FD Manager",
    slug: "eugenia-ventura-gonzalez",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Johanna Marleny",
    lastName: "Vera",
    title: "Self-Pay and Financial Counseling Specialist III",
    slug: "johanna-marleny-vera",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Antonio",
    lastName: "Vera",
    title: "Customer Service Rep",
    slug: "antonio-vera",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gisela",
    lastName: "Veras",
    title: "Call Center Representative",
    slug: "gisela-veras",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Evelyn",
    lastName: "Veras",
    title: "MPA",
    slug: "evelyn-veras",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Maria Eugenia",
    lastName: "Vergara",
    title: "Contract Negotiations Officer",
    slug: "maria-eugenia-vergara",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Charly A",
    lastName: "Vergara Benjumea",
    title: "Business Manager",
    slug: "charly-a-vergara-benjumea",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Elizabeth",
    lastName: "Vergez",
    title: "Senior Secretary",
    slug: "elizabeth-vergez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kelly",
    lastName: "Verkem",
    title: "Assistant Director,  Finance and Compliance SPF",
    slug: "kelly-verkem",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Srishti",
    lastName: "Verman",
    title: "Asst Director-Enrollment Ops",
    slug: "srishti-verman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Lauren Alexis",
    lastName: "Vermilion",
    title: "Assoc Dir, Student Services",
    slug: "lauren-alexis-vermilion",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Guido",
    lastName: "Verona",
    title: "Administrative Assistant",
    slug: "guido-verona",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alex J.",
    lastName: "Vervoort",
    title: "Senior Associate Director of Alumni Relations",
    slug: "alex-j-vervoort",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Chloe",
    lastName: "Vidal",
    title: "Administrative Assistant",
    slug: "chloe-vidal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angie",
    lastName: "Vidal Hernandez",
    title: "SYEP",
    slug: "angie-vidal-hernandez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Travis W",
    lastName: "Vidic",
    title: "Director, Events and Operations",
    slug: "travis-w-vidic",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Eric M.",
    lastName: "Vieira",
    title: "Director of Strategic Collaborations",
    slug: "eric-m-vieira",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yvelisse M.",
    lastName: "Viera",
    title: "Student Affairs Coordinator",
    slug: "yvelisse-m-viera",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Angay",
    lastName: "Vijayakumar",
    title: "Associate Director of IT Operations",
    slug: "angay-vijayakumar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Eric",
    lastName: "Villa",
    title: "Head Bartender",
    slug: "eric-villa",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alejandra",
    lastName: "Villadiego",
    title: "Grants Manager, Social Intervention Group",
    slug: "alejandra-villadiego",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Melanie",
    lastName: "Villalona",
    title: "Lab Consultant",
    slug: "melanie-villalona",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joshua",
    lastName: "Villalona",
    title: "Lab Consultant",
    slug: "joshua-villalona",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Mauricio",
    lastName: "Villanueva Dominguez",
    title: "Student Acad Support Worker",
    slug: "mauricio-villanueva-dominguez",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Radhimir",
    lastName: "Villar",
    title: "Technical Support Assistant III",
    slug: "radhimir-villar",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Areli Alejandra",
    lastName: "Villavicencio",
    title: "Events and Office Coordinator",
    slug: "areli-alejandra-villavicencio",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Delfina",
    lastName: "Villegas",
    title: "Generalist, HR/FA",
    slug: "delfina-villegas",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Andres",
    lastName: "Villegas",
    title: "Siegelbaum Lab Alum",
    slug: "andres-villegas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Flavia",
    lastName: "Villegas Landivar",
    title: "Associate Manager, Hazardous Materials Programs",
    slug: "flavia-villegas-landivar",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anyelina",
    lastName: "Vinas",
    title: "Wait Staff",
    slug: "anyelina-vinas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Nicholas C.",
    lastName: "Vincent",
    title: "Executive Director of Administration & Planning",
    slug: "nicholas-c-vincent",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jillian M",
    lastName: "Vincent",
    title: "Assoc Dir, Bdgt/Fin Anlys",
    slug: "jillian-m-vincent",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Howard",
    lastName: "Vines",
    title: "Coordinator, Business Services",
    slug: "howard-vines",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathryn L.",
    lastName: "Viola",
    title: "Assistant Director, HR Operations",
    slug: "kathryn-l-viola",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Marion",
    lastName: "Viray",
    title: "Director of Employer Relations",
    slug: "marion-viray",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lucas",
    lastName: "Vireday",
    title: "Sr Mgr, Strategic Initiatives",
    slug: "lucas-vireday",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Araceli",
    lastName: "Viruet",
    title: "Manager of Financial Operation",
    slug: "araceli-viruet",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "August",
    lastName: "Visco",
    title: "Senior Application Systems Developer",
    slug: "august-visco",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Charlene",
    lastName: "Visconti",
    title: "Staff",
    slug: "charlene-visconti",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Cecelia",
    lastName: "Visscher",
    title: "Associate Director of Strategic Initiatives",
    slug: "cecelia-visscher",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mirriah A",
    lastName: "Vitale",
    title: "Sr Dir,Strategies&Partnerships",
    slug: "mirriah-a-vitale",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Diana",
    lastName: "Vition",
    title: "Assistant Director, International Financial Operations",
    slug: "diana-vition",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jessica",
    lastName: "Vitkus",
    title: "Writer/Editor",
    slug: "jessica-vitkus",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Emma",
    lastName: "Vittori",
    title: "Admissions Counselor",
    slug: "emma-vittori",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ana Beatriz",
    lastName: "Vizcaino Gutierrez",
    title: "Baby's First Years Site Coordinator",
    slug: "ana-beatriz-vizcaino-gutierrez",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matei Eckley",
    lastName: "Vohr",
    title: "Research Project Manager",
    slug: "matei-eckley-vohr",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marie",
    lastName: "Volpe",
    title: "Staff",
    slug: "marie-volpe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John Michael",
    lastName: "Von Braunsberg III",
    title: "Associate Director of Event Technology",
    slug: "john-michael-von-braunsberg-iii",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Senia Eurica",
    lastName: "Vong",
    title: "Senior Finance and Compliance Manager",
    slug: "senia-eurica-vong",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mykhaylo",
    lastName: "Voronych",
    title: "Diagnostic Imaging Specialist II",
    slug: "mykhaylo-voronych",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michael",
    lastName: "Votta",
    title: "Writer/Researcher",
    slug: "michael-votta",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "John R.",
    lastName: "Votta",
    title: "Analytics Developer",
    slug: "john-r-votta",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pamela J.",
    lastName: "Vreeland",
    title: "Assoc Dir of Education & Resea",
    slug: "pamela-j-vreeland",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Thao Phuong",
    lastName: "Vu",
    title: "Instructional Designer",
    slug: "thao-phuong-vu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jaclyn B",
    lastName: "Vu",
    title: "Specialist-Student Affairs",
    slug: "jaclyn-b-vu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Nathalie",
    lastName: "Vukosavljevic",
    title: "Admissions Specialist",
    slug: "nathalie-vukosavljevic",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Daniel B.",
    lastName: "Vulis",
    title: "Recess Enrichment Facilitator in The School",
    slug: "daniel-b-vulis",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Roberta",
    lastName: "W. Albert",
    title: "Vice President for Institutional Advancement",
    slug: "roberta-w-albert",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hong",
    lastName: "Wacker",
    title: "Senior Application Systems Developer",
    slug: "hong-wacker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lisa",
    lastName: "Wade-Stewart",
    title: "Director, CUIMC Registration Services",
    slug: "lisa-wade-stewart",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Holly",
    lastName: "Wady",
    title: "Sr. Finance & Compliance Manager, Sponsored Projects Finance",
    slug: "holly-wady",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Braulio",
    lastName: "Wagan",
    title: "Manager, Finance&Grants Admin",
    slug: "braulio-wagan",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Simrankaur",
    lastName: "Wahan",
    title: "Program Support Specialist II",
    slug: "simrankaur-wahan",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Harpreet Singh",
    lastName: "Wahan",
    title: "Lead Application Systems Developer",
    slug: "harpreet-singh-wahan",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Evrette",
    lastName: "Walcott",
    title: "Payroll Manager",
    slug: "evrette-walcott",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kevin",
    lastName: "Waldron",
    title: "Director of Buildings, Grounds, and Office Adminstration",
    slug: "kevin-waldron",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tamerneka",
    lastName: "Walker",
    title: "Production Coordinator",
    slug: "tamerneka-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara E.",
    lastName: "Walker",
    title: "Project Manager",
    slug: "sara-e-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Reuben L",
    lastName: "Walker",
    title: "Director of Prospect Research and Strategy",
    slug: "reuben-l-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Patricia Ann",
    lastName: "Walker",
    title: "Director, Business Services",
    slug: "patricia-ann-walker",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jhinelle J.",
    lastName: "Walker",
    title: "Systems Coordinator",
    slug: "jhinelle-j-walker",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dilara",
    lastName: "Walker",
    title: "Associate Director, Dev Resrch",
    slug: "dilara-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carrie A.",
    lastName: "Walker",
    title: "Vice President for University Ceremonies and Board Operations",
    slug: "carrie-a-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anette",
    lastName: "Walker",
    title: "MA",
    slug: "anette-walker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mishka Yeneke",
    lastName: "Walker-Anderson",
    title: "Residency Supervisor",
    slug: "mishka-yeneke-walker-anderson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Donna J.",
    lastName: "Wall",
    title: "Asst Dir, Found & Corp Rel",
    slug: "donna-j-wall",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Matthew",
    lastName: "Wallace",
    title: "Administrative Director",
    slug: "matthew-wallace",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jeff",
    lastName: "Wallace",
    title: "Assoc. Director of Finance Budgeting",
    slug: "jeff-wallace",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Angelique",
    lastName: "Wallace",
    title: "Service Specialist",
    slug: "angelique-wallace",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Max",
    lastName: "Wallach",
    title: "Flow Cytometry Facility Manager",
    slug: "max-wallach",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brian",
    lastName: "Wallen",
    title: "Audiovisual Specialist",
    slug: "brian-wallen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anna",
    lastName: "Waller",
    title: "Assistant Director, Graduate Writing Studio",
    slug: "anna-waller",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Lisa S",
    lastName: "Walley",
    title: "Sr Director-Mktg Tech & Ops",
    slug: "lisa-s-walley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "LaKeesha NeShae",
    lastName: "Walrond",
    title: "Staff",
    slug: "lakeesha-neshae-walrond",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Katelin Susan",
    lastName: "Walsch",
    title: "Coordinator",
    slug: "katelin-susan-walsch",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexandra",
    lastName: "Walser",
    title: "Finance and Compliance Manager, Sponsored Projects Finance",
    slug: "alexandra-walser",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nicole",
    lastName: "Walsh",
    title: "Administrative Coordinator",
    slug: "nicole-walsh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward E.",
    lastName: "Walsh",
    title: "Director",
    slug: "edward-e-walsh",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Colleen S",
    lastName: "Walsh",
    title: "Senior Director of Title IX Investigations",
    slug: "colleen-s-walsh",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Rita",
    lastName: "Walters",
    title: "Staff",
    slug: "rita-walters",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Cindy",
    lastName: "Walters",
    title: "Assistant Director - Grants",
    slug: "cindy-walters",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Alexis",
    lastName: "Walters",
    title: "Director-Government Affairs",
    slug: "alexis-walters",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sarah",
    lastName: "Walton Kinney",
    title: "Associate Director",
    slug: "sarah-walton-kinney",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sonia",
    lastName: "Walton-Kemp",
    title: "Talent Relationship Manager",
    slug: "sonia-walton-kemp",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jacob",
    lastName: "Waltuck",
    title: "Comparative Medicine Asst",
    slug: "jacob-waltuck",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Wanja",
    lastName: "Wambu",
    title: "Project Manager",
    slug: "wanja-wambu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jenny",
    lastName: "Wang",
    title: "Learning Designer I",
    slug: "jenny-wang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Yujia",
    lastName: "Wang",
    title: "Data Coordinator",
    slug: "yujia-wang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Xiaoying",
    lastName: "Wang",
    title: "Supervisor, Histology",
    slug: "xiaoying-wang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Xiangnong",
    lastName: "Wang",
    title: "Staff Attorney",
    slug: "xiangnong-wang",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Xintian",
    lastName: "Wang",
    title: "Manager of Events/External Relations",
    slug: "xintian-wang",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Xin",
    lastName: "Wang",
    title: "Manager, Financial Administration",
    slug: "xin-wang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wei Jia",
    lastName: "Wang",
    title: "Director of Grants Management",
    slug: "wei-jia-wang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Vanessa",
    lastName: "Wang",
    title: "Student Acad Support Worker",
    slug: "vanessa-wang",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tianyou",
    lastName: "Wang",
    title: "Statistical Anlst/Data Manager",
    slug: "tianyou-wang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shuqi",
    lastName: "Wang",
    title: "Paninski Lab Alum Courtesy Access Extension",
    slug: "shuqi-wang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Robin",
    lastName: "Wang",
    title: "Coordinator, Career Design Lab",
    slug: "robin-wang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Liyuan",
    lastName: "Wang",
    title: "Tech B",
    slug: "liyuan-wang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kevin",
    lastName: "Wang",
    title: "Program Assistant",
    slug: "kevin-wang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jean",
    lastName: "Wang",
    title: "Leadership Gift Officer II",
    slug: "jean-wang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Huanzhou",
    lastName: "Wang",
    title: "Web Accessibility Specialist",
    slug: "huanzhou-wang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Bonnie S.",
    lastName: "Wang",
    title: "Departmental Administrator/CFO",
    slug: "bonnie-s-wang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Kristin E.",
    lastName: "Warbasse",
    title: "Executive Asst to the Dean",
    slug: "kristin-e-warbasse",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Reginald",
    lastName: "Ward",
    title: "Coding/Charge Review Specialist II",
    slug: "reginald-ward",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Gabriela",
    lastName: "Ward",
    title: "Secretary B",
    slug: "gabriela-ward",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Douglas",
    lastName: "Ward",
    title: "Manager, Service Specialist",
    slug: "douglas-ward",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Britton Edward",
    lastName: "Ward",
    title: "Exec Director, CUIMC Analytics",
    slug: "britton-edward-ward",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Audrey K.",
    lastName: "Ward",
    title: "Associate Director of Operations, Social Intervention Group",
    slug: "audrey-k-ward",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Catherine M.",
    lastName: "Warden",
    title: "Graduate Programs Manager",
    slug: "catherine-m-warden",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joan",
    lastName: "Wargo",
    title: "Deputy Director, Korean Legal Studies",
    slug: "joan-wargo",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Emilia K.",
    lastName: "Warlinski-Tokiwa",
    title: "Dir Budget Oper",
    slug: "emilia-k-warlinski-tokiwa",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Brian",
    lastName: "Warm",
    title: "Human Resources Officer",
    slug: "brian-warm",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Michael",
    lastName: "Warren",
    title: "Administrative Assistant",
    slug: "michael-warren",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kimberly Stacy",
    lastName: "Warren",
    title: "Admnistrative Manager",
    slug: "kimberly-stacy-warren",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Caitlin M",
    lastName: "Warthin",
    title: "Assistant Director",
    slug: "caitlin-m-warthin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Molly",
    lastName: "Washburn",
    title: "Director of Academic Administration",
    slug: "molly-washburn",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Christine",
    lastName: "Washington",
    title: "Recess & After School Coordinator in The School",
    slug: "christine-washington",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Benjamin",
    lastName: "Wasserburg",
    title: "Paralegal",
    slug: "benjamin-wasserburg",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "David L.",
    lastName: "Waterbury",
    title: "Technical Specialist, Network",
    slug: "david-l-waterbury",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joan C.",
    lastName: "Waters",
    title: "Ombuds Officer",
    slug: "joan-c-waters",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kristen Patricia",
    lastName: "Watson",
    title: "Website Content Officer",
    slug: "kristen-patricia-watson",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Jarvis Marcel",
    lastName: "Watson",
    title: "Chief Diversity Officer",
    slug: "jarvis-marcel-watson",
    dei: true,
    category: "Human Resources",
  },
  {
    firstName: "Jodi-Kaye A.",
    lastName: "Watson",
    title: "Program Manager",
    slug: "jodi-kaye-a-watson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Christopher",
    lastName: "Watson",
    title: "Senior Client Manager",
    slug: "christopher-watson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Charmain R.",
    lastName: "Watson",
    title: "Executive Assistant",
    slug: "charmain-r-watson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Brittany Z.",
    lastName: "Watson",
    title: "Financial Coordinator",
    slug: "brittany-z-watson",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer",
    lastName: "Wayne",
    title: "Sr Dir, Donor Rel&Strat Events",
    slug: "jennifer-wayne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alleyne A",
    lastName: "Waysome",
    title: "Senior Assistant Dean",
    slug: "alleyne-a-waysome",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jessica",
    lastName: "Weaver",
    title: "Title IX Investigator",
    slug: "jessica-weaver",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Amanda Nicole",
    lastName: "Webb",
    title: "Program Cordinator",
    slug: "amanda-nicole-webb",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kathy Fischer",
    lastName: "Weber",
    title: "Project Manager, Events",
    slug: "kathy-fischer-weber",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Amy",
    lastName: "Wee",
    title: "Senior Project Director",
    slug: "amy-wee",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Karin E",
    lastName: "Weidner-Mubanda",
    title: "Senior Project Manager",
    slug: "karin-e-weidner-mubanda",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Lauren W",
    lastName: "Weigel",
    title: "Director",
    slug: "lauren-w-weigel",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Daniel",
    lastName: "Weik",
    title: "Senior Salesforce Administrator",
    slug: "daniel-weik",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amy",
    lastName: "Weil",
    title: "Senior Director of Communications",
    slug: "amy-weil",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Ofra",
    lastName: "Weinberger",
    title:
      " Senior Director of Commercialization & Associate VP for IP and Tech Transfer",
    slug: "ofra-weinberger",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ella Coralie",
    lastName: "Weiner",
    title: "Manager, Administrative Operations",
    slug: "ella-coralie-weiner",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Kayla",
    lastName: "Weir",
    title: "Student Affairs Assistant",
    slug: "kayla-weir",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elisabeth H",
    lastName: "Weir",
    title: "Executive Director",
    slug: "elisabeth-h-weir",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jessica Lyn",
    lastName: "Weis",
    title: "Program Director, Women in Energy Program",
    slug: "jessica-lyn-weis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katie Lynn",
    lastName: "Weiser",
    title: "Director, Alumni Relations",
    slug: "katie-lynn-weiser",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yelena",
    lastName: "Weiss",
    title: "Senior Accountant",
    slug: "yelena-weiss",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Janie",
    lastName: "Weiss",
    title: "Manager",
    slug: "janie-weiss",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anita Rambabu",
    lastName: "Weiss",
    title: "Assistant Director, Recruitment (Pre-College Programs)",
    slug: "anita-rambabu-weiss",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Michelle",
    lastName: "Welch",
    title: "Assistant Director of Digital Content and Communications",
    slug: "michelle-welch",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sasha Marie",
    lastName: "Wells",
    title: "Executive Director, DDC",
    slug: "sasha-marie-wells",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Katherine",
    lastName: "Wells",
    title: "Senior Associate Director of Human Resources",
    slug: "katherine-wells",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tracy",
    lastName: "Wen",
    title: "Senior Finance Manager/Department Administrator",
    slug: "tracy-wen",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Haiying",
    lastName: "Weng",
    title: "Program Manager at the Tang Center",
    slug: "haiying-weng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David Dawes",
    lastName: "Wentsler",
    title: "Information Systems Admin",
    slug: "david-dawes-wentsler",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Olivia",
    lastName: "Wenzel",
    title: "Assistant Director of Annual Giving",
    slug: "olivia-wenzel",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Joseph",
    lastName: "Werst",
    title: "Exec Director-Acad Appts/Payrl",
    slug: "joseph-werst",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jon Eric",
    lastName: "Werst",
    title: "Administrative Assistant",
    slug: "jon-eric-werst",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Mildred Grace",
    lastName: "Wert",
    title: "Assistant Director, Media Relations",
    slug: "mildred-grace-wert",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Stephen",
    lastName: "Wesley",
    title: "Senior Editor",
    slug: "stephen-wesley",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Susan M",
    lastName: "West",
    title:
      " Senior Director, Academic and Student Affairs in Executive MBA Programs",
    slug: "susan-m-west",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Josiah Neil",
    lastName: "West",
    title: "Executive Asst/Admin Coord",
    slug: "josiah-neil-west",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Talya",
    lastName: "Westbrook",
    title: "Associate Dean, Development",
    slug: "talya-westbrook",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marnie P.",
    lastName: "Whalen-Turini",
    title:
      " Director of Student Engagement, Orientation, and Community Programs",
    slug: "marnie-p-whalen-turini",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Lyudmila",
    lastName: "Whatley",
    title: "Audit Manager",
    slug: "lyudmila-whatley",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Raevon",
    lastName: "Wheatley",
    title: "Grant Coordinator",
    slug: "raevon-wheatley",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sacha",
    lastName: "Whedon",
    title: "Service Provider",
    slug: "sacha-whedon",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Yenthl D",
    lastName: "Wheeler-Monestime",
    title: "Senior Program Manager",
    slug: "yenthl-d-wheeler-monestime",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Rick A.",
    lastName: "Whitaker",
    title: "Manager-Events",
    slug: "rick-a-whitaker",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Caitlin",
    lastName: "White",
    title: "Director, Development",
    slug: "caitlin-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tamara L.",
    lastName: "White",
    title: "Purchasing Manager",
    slug: "tamara-l-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Monifa",
    lastName: "White",
    title: "Health Education Manager",
    slug: "monifa-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melinda",
    lastName: "White",
    title: "Customer Service - Scheduler",
    slug: "melinda-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Melissa Lynn",
    lastName: "White",
    title: "Project Coordinator II",
    slug: "melissa-lynn-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dewayne",
    lastName: "White",
    title: "Executive Director of Campus Services",
    slug: "dewayne-white",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Joselyn",
    lastName: "White",
    title: "Second Mate",
    slug: "joselyn-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edith",
    lastName: "White",
    title: "Project Coordinator",
    slug: "edith-white",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Candace",
    lastName: "White",
    title: "Deputy Director of Communication & Digital Strategy",
    slug: "candace-white",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Sheri M.",
    lastName: "Whitley",
    title: "Associate Vice President for Digital Strategy",
    slug: "sheri-m-whitley",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Michael Justin",
    lastName: "Whitmore",
    title: "Technical Director, Event Production",
    slug: "michael-justin-whitmore",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Gavin",
    lastName: "Whitt",
    title: "Associate Manager-Housing Services",
    slug: "gavin-whitt",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Annette E.",
    lastName: "Whyte",
    title: "Administrative Assistant-Procurement",
    slug: "annette-e-whyte",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sarah E",
    lastName: "Wiant",
    title: "Program Manager",
    slug: "sarah-e-wiant",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Judith",
    lastName: "Wicks",
    title: "Project Coordinator",
    slug: "judith-wicks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Efraim",
    lastName: "Wielgus",
    title: "Technical Director, Disaster Recovery",
    slug: "efraim-wielgus",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Maggie",
    lastName: "Wiggin",
    title: "Director of Strategic Analysis",
    slug: "maggie-wiggin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "David X",
    lastName: "Wiggin",
    title: "Admissions Coordinator",
    slug: "david-x-wiggin",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sean D.",
    lastName: "Wiggins",
    title: "Executive Director of CVN",
    slug: "sean-d-wiggins",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Rebecca",
    lastName: "Wiggins",
    title: "Instructional Media Developer",
    slug: "rebecca-wiggins",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jonathan B.",
    lastName: "Wiggins",
    title: "Associate Director of Residence Life and Housing",
    slug: "jonathan-b-wiggins",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Milli",
    lastName: "Wijenaike-Bogle",
    title: "Project Manager",
    slug: "milli-wijenaike-bogle",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "LaToya D.",
    lastName: "Wiles",
    title: "Senior Administrative Coordinator",
    slug: "latoya-d-wiles",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tucker",
    lastName: "Wilke",
    title: "Program Associate",
    slug: "tucker-wilke",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Scott",
    lastName: "Wilkens",
    title: "Senior Counsel",
    slug: "scott-wilkens",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Marissa Hailey",
    lastName: "Wilkes",
    title: "Social Media Specialist",
    slug: "marissa-hailey-wilkes",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Noelle D",
    lastName: "Willecke",
    title: "Associate Director for International Student Services",
    slug: "noelle-d-willecke",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Elizabeth",
    lastName: "Willen",
    title: "Director, Hechinger Institute",
    slug: "elizabeth-willen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Willie Leondias",
    lastName: "Williams",
    title: "Assistant Dean, Inclusive Excellence",
    slug: "willie-leondias-williams",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Terrell",
    lastName: "Williams",
    title: "Porter",
    slug: "terrell-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tenneill Mia",
    lastName: "Williams",
    title: "Project Director",
    slug: "tenneill-mia-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tamika K",
    lastName: "Williams",
    title: "Director of Finance and Administration",
    slug: "tamika-k-williams",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Treena",
    lastName: "Williams",
    title: "Senior Regulatory Manager",
    slug: "treena-williams",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "ShaQuanna A",
    lastName: "Williams",
    title: "Talent Acq & Sourcing Manager",
    slug: "shaquanna-a-williams",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Shikema",
    lastName: "Williams",
    title: "Referral and Authorization Specialist II",
    slug: "shikema-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Shatiqua Janet",
    lastName: "Williams",
    title: "Lab Admin & Ops Manager",
    slug: "shatiqua-janet-williams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sam",
    lastName: "Williams",
    title: "Senior Staff Technical Support Specialist",
    slug: "sam-williams",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Portia G.",
    lastName: "Williams",
    title: "Vice Provost for Academic Planning and Global Affairs",
    slug: "portia-g-williams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Ovita F.",
    lastName: "Williams",
    title:
      " Senior Lecturer in Discipline of Social Work; Executive Director, Action Lab for Social Justice",
    slug: "ovita-f-williams",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Nida W.",
    lastName: "Williams",
    title: "Executive Director, Accounting and Business Management",
    slug: "nida-w-williams",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Maxine",
    lastName: "Williams",
    title: "Assistant Director, Engagement",
    slug: "maxine-williams",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michael P.",
    lastName: "Williams",
    title: "Associate Director of Operations and Finance",
    slug: "michael-p-williams",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Melanie L",
    lastName: "Williams",
    title: "Live Support Specialist",
    slug: "melanie-l-williams",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Lee Anthony",
    lastName: "Williams",
    title: "Lab Husbandry Senior Specialist",
    slug: "lee-anthony-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leo Anthony",
    lastName: "Williams",
    title: "Group Program Specialist",
    slug: "leo-anthony-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Joseph C.",
    lastName: "Williams",
    title: "Senior Grants Manager",
    slug: "joseph-c-williams",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "John E.",
    lastName: "Williams",
    title: "Director, Student Affairs & DEI; Lecturer in Professional Studies",
    slug: "john-e-williams",
    dei: true,
    category: "Student Life",
  },
  {
    firstName: "Erik James",
    lastName: "Williams",
    title: "Associate Director, Investigations",
    slug: "erik-james-williams",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Emma",
    lastName: "Williams",
    title: "Associate Director of Alumni Relations",
    slug: "emma-williams",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth A",
    lastName: "Williams",
    title: "Sr Director, Alumni Relations",
    slug: "elizabeth-a-williams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elizabeth",
    lastName: "Williams",
    title: "Director of Strategic Initiatives and Operations",
    slug: "elizabeth-williams",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Demi",
    lastName: "Williams",
    title: "Executive Director, Human Resources and Talent Management",
    slug: "demi-williams",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Amina",
    lastName: "Williams",
    title: "Sr Mgr,Acad Ops/Strat Planning",
    slug: "amina-williams",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Simon Bishop",
    lastName: "Williamson",
    title: "Senior Technical Specialist",
    slug: "simon-bishop-williamson",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jennifer L.",
    lastName: "Williamson",
    title: "Assc VD,ResPlcy&Sci Strtgy/COS",
    slug: "jennifer-l-williamson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Deborah A",
    lastName: "Williamson",
    title: "Director of Academic Administration",
    slug: "deborah-a-williamson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Michael James",
    lastName: "Willis",
    title: "Program Manager",
    slug: "michael-james-willis",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Vance Anthony",
    lastName: "Wilson",
    title: "Coordinator",
    slug: "vance-anthony-wilson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tyari T",
    lastName: "Wilson",
    title: "Recess Enrichment Facilitator in The School",
    slug: "tyari-t-wilson",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Mitchell Frederick",
    lastName: "Wilson",
    title: "Senior Executive Assistant to the Dean",
    slug: "mitchell-frederick-wilson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Malika Abdukader",
    lastName: "Wilson",
    title: "Assistant Director of Human Resources & Academic Appointments",
    slug: "malika-abdukader-wilson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kannya J.",
    lastName: "Wilson",
    title: "HR/Talent Acquisition Specialist",
    slug: "kannya-j-wilson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Hadija",
    lastName: "Wilson",
    title: "Assistant Director",
    slug: "hadija-wilson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Crystal Mailan",
    lastName: "Wilson",
    title: "Administrative Director",
    slug: "crystal-mailan-wilson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Afiya",
    lastName: "Wilson",
    title: "Assistant Dean of Academic Diversity and Inclusion",
    slug: "afiya-wilson",
    dei: true,
    category: "Academic",
  },
  {
    firstName: "Anthony",
    lastName: "Wilson",
    title: "Director, Security Force Monitor, Human Rights Institute",
    slug: "anthony-wilson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Armani",
    lastName: "Wilson",
    title: "Systems Mgr, Admissions Ops",
    slug: "armani-wilson",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Barbara Ann",
    lastName: "Wilson Brooks",
    title: "Secretary",
    slug: "barbara-ann-wilson-brooks",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Heather Dawn",
    lastName: "Wiltshire Clement",
    title: "Associate Director, Casualty Claims & Risk Control",
    slug: "heather-dawn-wiltshire-clement",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Megan",
    lastName: "Winborne",
    title: "Associate Director",
    slug: "megan-winborne",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Dina",
    lastName: "Winchell",
    title: "Senior Program Officer",
    slug: "dina-winchell",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Neil E",
    lastName: "Windsor",
    title: "Associate Director, Administration - Technology, Management",
    slug: "neil-e-windsor",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Keith",
    lastName: "Windsor Jr",
    title: "Assistant Dean of Advising",
    slug: "keith-windsor-jr",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Alexander B",
    lastName: "Wingerson",
    title: "Executive Assistant, University Development",
    slug: "alexander-b-wingerson",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jane",
    lastName: "Winsett",
    title: "Student Success and Intervention Case Manager",
    slug: "jane-winsett",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Franklin M.",
    lastName: "Winslow",
    title: "Director of Academic Administration",
    slug: "franklin-m-winslow",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Marie Marlene",
    lastName: "Wint",
    title: "Enrollment Support Representative",
    slug: "marie-marlene-wint",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Meaghan Kathleen",
    lastName: "Winter",
    title: "Assistant Director, communications",
    slug: "meaghan-kathleen-winter",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Gil E",
    lastName: "Winters",
    title: "Director FInance and Operation",
    slug: "gil-e-winters",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jack",
    lastName: "Wisniewski",
    title: "Digital Content Strategist",
    slug: "jack-wisniewski",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elise Shao",
    lastName: "Withers",
    title: "Genetic Counseling Assistant",
    slug: "elise-shao-withers",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Olivia Rose",
    lastName: "Witting",
    title: "Senior Assistant Director",
    slug: "olivia-rose-witting",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Andrea A",
    lastName: "Witting",
    title: "Finance Manager",
    slug: "andrea-a-witting",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Christina",
    lastName: "Witwer",
    title: "Associate Director, Gift Planning and Lifecycle Content",
    slug: "christina-witwer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Noel",
    lastName: "Wo",
    title: "Director of Networks",
    slug: "noel-wo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Stephanie C",
    lastName: "Wobby",
    title: "LTAC Coordinator",
    slug: "stephanie-c-wobby",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "John L",
    lastName: "Wofford",
    title: "Consultant",
    slug: "john-l-wofford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Theodore",
    lastName: "Wohlsen",
    title: "Senior Multimedia Technical Specialist",
    slug: "theodore-wohlsen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Anna",
    lastName: "Wojnarowska Lenczewski",
    title: "Senior Executive Director",
    slug: "anna-wojnarowska-lenczewski",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Jason M",
    lastName: "Wojtylko",
    title: "Residence Hall Director",
    slug: "jason-m-wojtylko",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Amy",
    lastName: "Wolf",
    title: "Academic Secretary",
    slug: "amy-wolf",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jason",
    lastName: "Wolfe",
    title: "Senior Grants Manager",
    slug: "jason-wolfe",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Judy",
    lastName: "Wolfe",
    title: "Sr Assoc Dean, Student Affairs",
    slug: "judy-wolfe",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Jessica R",
    lastName: "Wolff",
    title: "Policy Director",
    slug: "jessica-r-wolff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "David",
    lastName: "Wolford",
    title: "Chief Mate",
    slug: "david-wolford",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Taylor Lynne",
    lastName: "Wolfson",
    title: "HR Business Partner",
    slug: "taylor-lynne-wolfson",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Jonathan A",
    lastName: "Wolpert",
    title: "Administrative Assistant",
    slug: "jonathan-a-wolpert",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Seaneen",
    lastName: "Womack",
    title: "Coder",
    slug: "seaneen-womack",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Pui Yi L",
    lastName: "Wong",
    title: "Senior Manager, Systems Development",
    slug: "pui-yi-l-wong",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Nang Tung",
    lastName: "Wong",
    title: "Senior IT Service Specialist",
    slug: "nang-tung-wong",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kenny",
    lastName: "Wong",
    title: "Director of Admissions & Financial Aid",
    slug: "kenny-wong",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jan",
    lastName: "Wong",
    title: "Assistant Director of Student Engagement",
    slug: "jan-wong",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Gloria",
    lastName: "Wong",
    title: "Asst Director-Career Dvlpmt",
    slug: "gloria-wong",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Danielle N.",
    lastName: "Wong",
    title: "Senior Advising Dean",
    slug: "danielle-n-wong",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Diana",
    lastName: "Wong",
    title: "Associate Director of Donor Relations",
    slug: "diana-wong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Crystal",
    lastName: "Wong",
    title: "Deputy Division Administrator",
    slug: "crystal-wong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Agnes",
    lastName: "Wong",
    title: "Research Nutritionist",
    slug: "agnes-wong",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cynthia",
    lastName: "Wood",
    title: "Assistant Director, CAA and University Relations",
    slug: "cynthia-wood",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Andre",
    lastName: "Wood",
    title: "Assistant Director, Information Technology",
    slug: "andre-wood",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lorna A",
    lastName: "Woodham",
    title: "Senior Social Worker",
    slug: "lorna-a-woodham",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Charles",
    lastName: "Woods",
    title: "Manager, Support Services",
    slug: "charles-woods",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Omar",
    lastName: "Woods",
    title: "Associate Director, Client Services",
    slug: "omar-woods",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Kiamisha D",
    lastName: "Woods",
    title: "Director, Student Service Center",
    slug: "kiamisha-d-woods",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Casey",
    lastName: "Woods",
    title: "Asst Director, Professionalism",
    slug: "casey-woods",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "William I.",
    lastName: "Woodson",
    title: "Academic Program Support in Professional Studies",
    slug: "william-i-woodson",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Keithley",
    lastName: "Woolward",
    title: "HiLi Associate Director",
    slug: "keithley-woolward",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Carlyn J.",
    lastName: "Worthy",
    title: "Administrative Manager",
    slug: "carlyn-j-worthy",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "William D.",
    lastName: "Wozniak",
    title: "Network Design Manager",
    slug: "william-d-wozniak",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Karen",
    lastName: "Wray",
    title: "Senior Financial Aid Clerk",
    slug: "karen-wray",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Devyn",
    lastName: "Wray-Scriven",
    title: "Administrative Coordinator",
    slug: "devyn-wray-scriven",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Martin J.",
    lastName: "Wren",
    title: "Lead Security Systems Developer",
    slug: "martin-j-wren",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sandra M.",
    lastName: "Wright",
    title: "Director",
    slug: "sandra-m-wright",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jason A",
    lastName: "Wright",
    title: "Vice Dean of Finance and Administration",
    slug: "jason-a-wright",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jana Hart",
    lastName: "Wright",
    title: "Dean, Academic Administration and Planning",
    slug: "jana-hart-wright",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Mia Elyse",
    lastName: "Wright",
    title: "Director, Alumni Engagement",
    slug: "mia-elyse-wright",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Eliza Whitney",
    lastName: "Wright",
    title: "Internal Events Associate",
    slug: "eliza-whitney-wright",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Brittani D",
    lastName: "Wright",
    title: "Communication Specialist",
    slug: "brittani-d-wright",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Abi E.",
    lastName: "Wright",
    title: "Executive Director, Professional Prizes",
    slug: "abi-e-wright",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Zaiqi",
    lastName: "Wu",
    title:
      " HHMI Tech in the Mortimer B. Zuckerman Mind Brain Behavior Institute",
    slug: "zaiqi-wu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ying",
    lastName: "Wu",
    title: "Neurovascular Doppler Coord",
    slug: "ying-wu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Xinyi",
    lastName: "Wu",
    title: "Instructional Designer",
    slug: "xinyi-wu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Sarah",
    lastName: "Wu",
    title: "Officer-Fin Aid",
    slug: "sarah-wu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "James J.",
    lastName: "Wu",
    title: "Director, Experienced Professionals Career Management",
    slug: "james-j-wu",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "John",
    lastName: "Wu",
    title: "Senior Service Desk Specialist",
    slug: "john-wu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Julie",
    lastName: "Wu",
    title: "Childcare Provider",
    slug: "julie-wu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chaoqi",
    lastName: "Wu",
    title: "Statistical Anlst/Data Manager",
    slug: "chaoqi-wu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Charlie",
    lastName: "Wu",
    title: "Active Directory Manager",
    slug: "charlie-wu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren E",
    lastName: "Wycoff",
    title: "Development Assistant",
    slug: "lauren-e-wycoff",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Grace Madison",
    lastName: "Wygal",
    title: "Administrative Assistant",
    slug: "grace-madison-wygal",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander L",
    lastName: "Wyles",
    title: "Associate Director, Instructional and Information Technology",
    slug: "alexander-l-wyles",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Amber M.",
    lastName: "Wylie",
    title: "Sr. Project Manager",
    slug: "amber-m-wylie",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Roland",
    lastName: "Wyn Jones",
    title: "Senior Director of Communications Content",
    slug: "roland-wyn-jones",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Shuang",
    lastName: "Xia Ryan",
    title: "Senior Associate Director of Marketing, Degree Programs",
    slug: "shuang-xia-ryan",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Fengdi",
    lastName: "Xiao",
    title: "Senior Data Manager",
    slug: "fengdi-xiao",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jean",
    lastName: "Xiong",
    title: "Director, Administration - Applied Analytics",
    slug: "jean-xiong",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Ying",
    lastName: "Xu",
    title:
      " Assistant Director, Graduate Admissions Recruitment and Communications",
    slug: "ying-xu",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Sharon",
    lastName: "Xu",
    title: "Lab Coordinator",
    slug: "sharon-xu",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Joanna",
    lastName: "Xu",
    title: "Sr Financial Service Officer",
    slug: "joanna-xu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Yixuan",
    lastName: "Xu",
    title: "Senior Project Coordinator",
    slug: "yixuan-xu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yasmin-Marie S.",
    lastName: "Yabyabin",
    title: "Business Officer",
    slug: "yasmin-marie-s-yabyabin",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sofia",
    lastName: "Yagaeva",
    title: "Assistant Director, CVN",
    slug: "sofia-yagaeva",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica A.",
    lastName: "Yakata",
    title: "Recess Enrichment Facilitator in The School",
    slug: "jessica-a-yakata",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Larisa",
    lastName: "Yakimenko",
    title: "Anltcs BI Anltcs Developer-SON",
    slug: "larisa-yakimenko",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Rachel A.",
    lastName: "Yalof",
    title: "Coordinator, Communications and Research",
    slug: "rachel-a-yalof",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Yuran",
    lastName: "Yan",
    title: "Student Acad Support Worker",
    slug: "yuran-yan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Laura",
    lastName: "Yan",
    title: "Coordinator",
    slug: "laura-yan",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "William Anthony",
    lastName: "Yandolino",
    title: "Executive Director of Operations Finance",
    slug: "william-anthony-yandolino",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Winsor",
    lastName: "Yang",
    title: "Asst Director-Student Affairs",
    slug: "winsor-yang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Susanna",
    lastName: "Yang",
    title: "Admissions Officer, High School",
    slug: "susanna-yang",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Ho-Ching",
    lastName: "Yang",
    title: "Brickman Miller UI",
    slug: "ho-ching-yang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Huiyu",
    lastName: "Yang",
    title: "Project Administrator Level II",
    slug: "huiyu-yang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bill",
    lastName: "Yang",
    title: "Lead Service Specialist",
    slug: "bill-yang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Angela",
    lastName: "Yang",
    title: "Grants Coordinator",
    slug: "angela-yang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Edward L.",
    lastName: "Yanisch",
    title: "Associate Director of Administration, Strategic Communications",
    slug: "edward-l-yanisch",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hannah Y",
    lastName: "Yankowitz",
    title: "Student Acad Support Worker",
    slug: "hannah-y-yankowitz",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Qikui",
    lastName: "Yao",
    title: "Network Manager",
    slug: "qikui-yao",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Edward S.",
    lastName: "Yao",
    title: "Managing Director",
    slug: "edward-s-yao",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Sumeyye",
    lastName: "Yar",
    title: "Associate Director of Academic Administration",
    slug: "sumeyye-yar",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Julien Jean-Pierre",
    lastName: "Yarker",
    title: "Associate Dean, Executive Education",
    slug: "julien-jean-pierre-yarker",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Anthony",
    lastName: "Yau",
    title: "Manager, Financial Reporting",
    slug: "anthony-yau",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Angel",
    lastName: "Yau",
    title: "Director of Academic Technologies",
    slug: "angel-yau",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Krista Alexia",
    lastName: "Yearwood",
    title: "Generalist, HR/FA",
    slug: "krista-alexia-yearwood",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Tsuya Hohri",
    lastName: "Yee",
    title: "Associate Dean of Student Affairs",
    slug: "tsuya-hohri-yee",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Christopher",
    lastName: "Yee",
    title: "Associate Director, User Experience",
    slug: "christopher-yee",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Kenneth Ross",
    lastName: "Yelsey",
    title: "Associate Director, Admissions and Marketing",
    slug: "kenneth-ross-yelsey",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Jessica",
    lastName: "Yen",
    title:
      " Assistant Dean, Summer Sessions Programs and Visiting Student Programs",
    slug: "jessica-yen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Hua-Chu",
    lastName: "Yen",
    title: "Senior Multimedia Producer",
    slug: "hua-chu-yen",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Hyunjin",
    lastName: "Yeo",
    title: "Assistant Director",
    slug: "hyunjin-yeo",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Erlina",
    lastName: "Yeo",
    title: "Managing Director (Investments)",
    slug: "erlina-yeo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marvin Y.",
    lastName: "Yeung",
    title: "IT Manager",
    slug: "marvin-y-yeung",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yoora",
    lastName: "Yi Tenen",
    title: "Application Systems Developer",
    slug: "yoora-yi-tenen",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jessica Lee",
    lastName: "Yim",
    title: "Executive Director, Tax",
    slug: "jessica-lee-yim",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Wai",
    lastName: "Yin",
    title: "Business Services Coordinator",
    slug: "wai-yin",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Sara M",
    lastName: "Yllescas",
    title: "Career Placement Officer",
    slug: "sara-m-yllescas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Rebecca",
    lastName: "Yohannes",
    title: "Exec Dir, Rsch Comp Resources",
    slug: "rebecca-yohannes",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Joon J",
    lastName: "Yoo",
    title: "Assoc Dir, Grants Fin/Training",
    slug: "joon-j-yoo",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jeong",
    lastName: "Yoo",
    title: "Associate Technical Director",
    slug: "jeong-yoo",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Sandra I",
    lastName: "Yoshida",
    title: "Grants Finance Manager",
    slug: "sandra-i-yoshida",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Min",
    lastName: "You",
    title: "Senior Application Systems Developer",
    slug: "min-you",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Haseeb",
    lastName: "Younas",
    title: "Department Administrator/COO",
    slug: "haseeb-younas",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Susan",
    lastName: "Young",
    title: "Executive Assistant to the Executive Vice President",
    slug: "susan-young",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Steven John",
    lastName: "Young",
    title: "Supervisor-ICM",
    slug: "steven-john-young",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Shana",
    lastName: "Young",
    title: "Accountant",
    slug: "shana-young",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Nivita S",
    lastName: "Young",
    title: "Benefits Programs Liaison",
    slug: "nivita-s-young",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "McKenzie R",
    lastName: "Young",
    title: "Senior Associate Director of Survey Research and Data Analytics",
    slug: "mckenzie-r-young",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jake S",
    lastName: "Young",
    title: "Technical Director, User Interface Development",
    slug: "jake-s-young",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Jason P.",
    lastName: "Young",
    title: "Associate Director of Admissions Communications",
    slug: "jason-p-young",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Erin Elizabeth",
    lastName: "Young",
    title: "MA Program Assistant",
    slug: "erin-elizabeth-young",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Dominique",
    lastName: "Young",
    title: "Senior Associate Director, Academic Affairs",
    slug: "dominique-young",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Colette Cecile",
    lastName: "Young",
    title: "Assistant Director, SPA NYC",
    slug: "colette-cecile-young",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Chan F.",
    lastName: "Young",
    title: "Senior Duplicating Machine Officer",
    slug: "chan-f-young",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bernadette O.",
    lastName: "Young",
    title: "Coordinator-Publicity",
    slug: "bernadette-o-young",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Michelle",
    lastName: "Yu",
    title: "Senior Director, Custom Programs",
    slug: "michelle-yu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yueping",
    lastName: "Yu",
    title: "Sr Application Systems Develop",
    slug: "yueping-yu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Taewook",
    lastName: "Yu",
    title: "Interim Employee Motor Learning",
    slug: "taewook-yu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tara",
    lastName: "Yu",
    title: "Manager, Financial Reporting",
    slug: "tara-yu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Stanley",
    lastName: "Yu",
    title: "Classroom Tech Specialist Asst",
    slug: "stanley-yu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Xuelei",
    lastName: "Yu",
    title: "Director,Budgeting & Reporting",
    slug: "xuelei-yu",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Di",
    lastName: "Yu",
    title: "Director, Operations",
    slug: "di-yu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Fatima",
    lastName: "Yudeh",
    title: "Assistant Director",
    slug: "fatima-yudeh",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Priscilla H",
    lastName: "Yuen",
    title: "Assistant Dean, Specialized Degree Programs",
    slug: "priscilla-h-yuen",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Elina",
    lastName: "Yuffa",
    title: "Director for Curricular Planning and Administration",
    slug: "elina-yuffa",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Evita",
    lastName: "Yumul",
    title: "Assistant Director",
    slug: "evita-yumul",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Tyla",
    lastName: "Yurgel",
    title: "Director of Research",
    slug: "tyla-yurgel",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jonathan Luis",
    lastName: "Zaccarini",
    title: "Digital Learning Support Spec",
    slug: "jonathan-luis-zaccarini",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Lauren",
    lastName: "Zagelbaum",
    title: "Associate Director, Investigations",
    slug: "lauren-zagelbaum",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sofia R",
    lastName: "Zaidman",
    title: "Associate Director, Data Analytics",
    slug: "sofia-r-zaidman",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Laurel Noelani-Reiko",
    lastName: "Zaima",
    title: "Assistant Director, K12 and Continuing Education",
    slug: "laurel-noelani-reiko-zaima",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Tanzina",
    lastName: "Zakir",
    title: "Asst Director-Stud Wellbeing",
    slug: "tanzina-zakir",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Kayla",
    lastName: "Zalcgendler",
    title: "Senior Program Manager",
    slug: "kayla-zalcgendler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Simonne Lisa Britto",
    lastName: "Zalenski",
    title: "Asst Dir,Card Rgnl Billing Ops",
    slug: "simonne-lisa-britto-zalenski",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Marissa Litwin",
    lastName: "Zalk",
    title: "Director of Graduate Student Affairs",
    slug: "marissa-litwin-zalk",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Marina",
    lastName: "Zamalin",
    title: "Director of Online Education",
    slug: "marina-zamalin",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Nicholas D.",
    lastName: "Zambrotta",
    title: "Program Manager",
    slug: "nicholas-d-zambrotta",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Leah B",
    lastName: "Zamechek",
    title: "Lab Manager",
    slug: "leah-b-zamechek",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Cosmin",
    lastName: "Zamfirescu",
    title: "Lead Applications Systems Developer",
    slug: "cosmin-zamfirescu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Yvette",
    lastName: "Zapata",
    title: "Finance Coordinator",
    slug: "yvette-zapata",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Camilo",
    lastName: "Zapata",
    title: "Staff",
    slug: "camilo-zapata",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Angelica",
    lastName: "Zapata-Frias",
    title: "Onboarding Specialist II",
    slug: "angelica-zapata-frias",
    dei: false,
    category: "Human Resources",
  },
  {
    firstName: "Eric V.",
    lastName: "Zaretsky",
    title: "Director, Finance Training",
    slug: "eric-v-zaretsky",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Leonid",
    lastName: "Zaurov",
    title: "Sonographer",
    slug: "leonid-zaurov",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Anna Maria",
    lastName: "Zavodszky",
    title: "Research Program Manager",
    slug: "anna-maria-zavodszky",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jenny Giselle",
    lastName: "Zawisza",
    title: "Business Services Officer, Business and Finance",
    slug: "jenny-giselle-zawisza",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Mia DeLuis",
    lastName: "Zayas",
    title: "Manager Housing Services",
    slug: "mia-deluis-zayas",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Svetlana",
    lastName: "Zaykova",
    title: "Manager, Financial Operations Compliance (Endowments)",
    slug: "svetlana-zaykova",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jennifer M",
    lastName: "Zech",
    title: "Senior Project Manager",
    slug: "jennifer-m-zech",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Robert",
    lastName: "Zeibig",
    title: "Contractor - CUIMC IT",
    slug: "robert-zeibig",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Seida",
    lastName: "Zekiroska",
    title: "Gift Coordinator, Gift Systems",
    slug: "seida-zekiroska",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Yana",
    lastName: "Zeltser",
    title: "Program Manager, Academic Affairs",
    slug: "yana-zeltser",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Andy",
    lastName: "Zeng",
    title: "Accounting Supervisor",
    slug: "andy-zeng",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Michelle M.",
    lastName: "Zern",
    title: "Director of Academic Administration",
    slug: "michelle-m-zern",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Zhi Qiang",
    lastName: "Zhang",
    title: "Senior Systems Administrator",
    slug: "zhi-qiang-zhang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Wen Na",
    lastName: "Zhang",
    title: "Asst Dir, Student Services",
    slug: "wen-na-zhang",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Claudia",
    lastName: "Zhang",
    title: "Senior Database Administrator",
    slug: "claudia-zhang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Shandao",
    lastName: "Zhang",
    title: "Service Specialist",
    slug: "shandao-zhang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ming Jian",
    lastName: "Zhang",
    title: "Technical B",
    slug: "ming-jian-zhang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Xinhan-Jane",
    lastName: "Zhang",
    title: "Coordinator",
    slug: "xinhan-jane-zhang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Guhong",
    lastName: "Zhang",
    title: "Finance & Compliance Manager, Sponsored Projects Finance",
    slug: "guhong-zhang",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Jonathan Dasheng",
    lastName: "Zhang",
    title: "Application Developer",
    slug: "jonathan-dasheng-zhang",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Annie",
    lastName: "Zhang",
    title: "Ultrasound Tech",
    slug: "annie-zhang",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Ran",
    lastName: "Zhao",
    title: "Director, Budget Operations",
    slug: "ran-zhao",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Janet",
    lastName: "Zheng",
    title: "Associate Director, Program Manager - APAC",
    slug: "janet-zheng",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Judy",
    lastName: "Zhong",
    title: "Administrative Coordinator",
    slug: "judy-zhong",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Helen",
    lastName: "Zhong",
    title: "Litigation Program Manager in the Knight Institute",
    slug: "helen-zhong",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Sophie",
    lastName: "Zhou",
    title: "Assistant Director of Academic Appointments and Payroll",
    slug: "sophie-zhou",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shizhen",
    lastName: "Zhu",
    title: "Senior Application Systems Developer",
    slug: "shizhen-zhu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Margaret Lin",
    lastName: "Zhu",
    title: "Department Administrator",
    slug: "margaret-lin-zhu",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Calvin",
    lastName: "Zhu",
    title: "Lead Application Systems Developer",
    slug: "calvin-zhu",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Viktoriya",
    lastName: "Zhuravleva",
    title: "Associate Director, Strategic Research Development",
    slug: "viktoriya-zhuravleva",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Jackie",
    lastName: "Zibrosky",
    title: "ERP - Project Manager",
    slug: "jackie-zibrosky",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Cassandra L.",
    lastName: "Ziegler",
    title:
      " Associate Director of Strategic Development Outreach & Programs, ZMBBI",
    slug: "cassandra-l-ziegler",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Annmarie",
    lastName: "Zigabarra",
    title: "Director-Revenue Cycle",
    slug: "annmarie-zigabarra",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Meurcie Katherine",
    lastName: "Zignoli",
    title: "Director of Student Support",
    slug: "meurcie-katherine-zignoli",
    dei: false,
    category: "Student Life",
  },
  {
    firstName: "Valerie",
    lastName: "Zimmer",
    title: "Managing Director",
    slug: "valerie-zimmer",
    dei: false,
    category: "Finance",
  },
  {
    firstName: "Andrew",
    lastName: "Zimnik",
    title: "Co-Author, Virtual Access Only",
    slug: "andrew-zimnik",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Shannon",
    lastName: "Zinn",
    title: "Sr Dir, Comm & Spec Projects",
    slug: "shannon-zinn",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Elizabeth T.",
    lastName: "Zito",
    title:
      " Assistant Director, Visual Arts Instructional Technology and Exhibitions",
    slug: "elizabeth-t-zito",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Dusan",
    lastName: "Zivanovic",
    title: "Senior Contracts Officer",
    slug: "dusan-zivanovic",
    dei: false,
    category: "Legal",
  },
  {
    firstName: "Cassandra M.",
    lastName: "Zoetjes",
    title: "Education Assistant",
    slug: "cassandra-m-zoetjes",
    dei: false,
    category: "Academic",
  },
  {
    firstName: "Josh",
    lastName: "Zoffer",
    title: "Consultant",
    slug: "josh-zoffer",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Alexander",
    lastName: "Zolotnikov",
    title: "Senior Systems Administrator",
    slug: "alexander-zolotnikov",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Otoniel A.",
    lastName: "Zorrilla",
    title: "Director of Student IT Services",
    slug: "otoniel-a-zorrilla",
    dei: false,
    category: "Technology",
  },
  {
    firstName: "Chen",
    lastName: "Zou",
    title: "Project Coordinator",
    slug: "chen-zou",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Bryan",
    lastName: "Zudick",
    title: "Associate Director, Slate Communications",
    slug: "bryan-zudick",
    dei: false,
    category: "Communications",
  },
  {
    firstName: "Laura",
    lastName: "Zuiderveld",
    title: "Project Manager",
    slug: "laura-zuiderveld",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Michal",
    lastName: "Zussman",
    title: "Senior Admissions Officer",
    slug: "michal-zussman",
    dei: false,
    category: "Admissions",
  },
  {
    firstName: "Benjamin R.",
    lastName: "Zweig",
    title: "Project Manager",
    slug: "benjamin-r-zweig",
    dei: false,
    category: "Miscellaneous",
  },
  {
    firstName: "Meredith",
    lastName: "Zylberberg",
    title: "Chief of Staff",
    slug: "meredith-zylberberg",
    dei: false,
    category: "Miscellaneous",
  },
];
export default people;
